const postcodes = {
  '01400': [
    'L ABERGEMENT CLEMENCIAT',
    'CHANOZ CHATENAY',
    'CHATILLON SUR CHALARONNE',
    'CONDEISSIAT',
    'DOMPIERRE SUR CHALARONNE',
    'NEUVILLE LES DAMES',
    'ROMANS',
    'ST GEORGES SUR RENON',
    'SANDRANS',
    'SULIGNAT',
  ],
  '01640': ['L ABERGEMENT DE VAREY', 'BOYEUX ST JEROME', 'JUJURIEUX', 'ST JEAN LE VIEUX'],
  '01500': [
    'AMBERIEU EN BUGEY',
    'AMBRONAY',
    'AMBUTRIX',
    'BETTANT',
    'CHATEAU GAILLARD',
    'DOUVRES',
    'ST DENIS EN BUGEY',
    'ST MAURICE DE REMENS',
  ],
  '01330': [
    'AMBERIEUX EN DOMBES',
    'BIRIEUX',
    'BOULIGNEUX',
    'LAPEYROUSE',
    'LE PLANTAY',
    'STE OLIVE',
    'VERSAILLEUX',
    'VILLARS LES DOMBES',
  ],
  '01300': [
    'AMBLEON',
    'ANDERT ET CONDON',
    'ARBOYS EN BUGEY',
    'BELLEY',
    'BREGNIER CORDON',
    'BRENS',
    'CHAZEY BONS',
    'COLOMIEU',
    'CONTREVOZ',
    'CONZIEU',
    'CUZIEU',
    'IZIEU',
    'MAGNIEU',
    'MARIGNIEU',
    'MASSIGNIEU DE RIVES',
    'MURS ET GELIGNIEUX',
    'PARVES ET NATTAGES',
    'PEYRIEU',
    'PREMEYZEL',
    'GROSLEE ST BENOIT',
    'ST GERMAIN LES PAROISSES',
    'VIRIGNIN',
  ],
  '01350': [
    'ANGLEFORT',
    'CEYZERIEU',
    'CRESSIN ROCHEFORT',
    'CULOZ BEON',
    'FLAXIEU',
    'LAVOURS',
    'POLLIEU',
    'VONGNES',
  ],
  '01100': ['APREMONT', 'ARBENT', 'BELLIGNAT', 'GEOVREISSET', 'GROISSIAT', 'MARTIGNAT', 'OYONNAX'],
  '01110': [
    'ARANC',
    'BRENOD',
    'CHAMPDOR CORCELLES',
    'CORLIER',
    'PLATEAU D HAUTEVILLE',
    'PREMILLIEU',
  ],
  '01230': [
    'ARANDAS',
    'ARGIS',
    'CHALEY',
    'CLEYZIEU',
    'CONAND',
    'EVOSGES',
    'NIVOLLET MONTGRIFFON',
    'ONCIEU',
    'ST RAMBERT EN BUGEY',
    'TENAY',
    'TORCIEU',
  ],
  '01190': [
    'ARBIGNY',
    'BOISSEY',
    'BOZ',
    'CHAVANNES SUR REYSSOUZE',
    'CHEVROUX',
    'GORREVOD',
    'OZAN',
    'PONT DE VAUX',
    'REYSSOUZE',
    'ST BENIGNE',
    'ST ETIENNE SUR REYSSOUZE',
    'SERMOYER',
  ],
  '01510': [
    'ARMIX',
    'ARTEMARE',
    'LA BURBANCHE',
    'CHAZEY BONS',
    'CHEIGNIEU LA BALME',
    'ORDONNAZ',
    'ROSSILLON',
    'ST MARTIN DE BAVEL',
    'TALISSIEU',
    'VIRIEU LE GRAND',
  ],
  '01480': [
    'ARS SUR FORMANS',
    'BEAUREGARD',
    'CHALEINS',
    'FAREINS',
    'FRANS',
    'JASSANS RIOTTIER',
    'MESSIMY SUR SAONE',
    'SAVIGNEUX',
    'VILLENEUVE',
  ],
  '01570': ['ASNIERES SUR SAONE', 'FEILLENS', 'MANZIAT', 'VESINES'],
  '01340': [
    'ATTIGNAT',
    'BEREZIAT',
    'BRESSE VALLONS',
    'FOISSIAT',
    'JAYAT',
    'MALAFRETAZ',
    'MARSONNAS',
    'MONTREVEL EN BRESSE',
    'ST DIDIER D AUSSIAT',
    'ST SULPICE',
  ],
  '01380': [
    'BAGE DOMMARTIN',
    'BAGE LE CHATEL',
    'BOISSEY',
    'ST ANDRE DE BAGE',
    'ST CYR SUR MENTHON',
    'ST GENIS SUR MENTHON',
  ],
  '01360': ['BALAN', 'BELIGNEUX', 'BRESSOLLES', 'LOYETTES'],
  '01990': ['BANEINS', 'CHANEINS', 'RELEVANT', 'ST TRIVIER SUR MOIGNANS'],
  '01270': ['BEAUPONT', 'COLIGNY', 'DOMSURE', 'PIRAJOUX', 'SALAVRE', 'VERJON', 'VILLEMOTIER'],
  '01200': [
    'VALSERHONE',
    'BILLIAT',
    'CHEZERY FORENS',
    'CONFORT',
    'INJOUX GENISSIAT',
    'LEAZ',
    'MONTANGES',
    'VILLES',
    'ELOISE',
  ],
  '01130': [
    'BELLEYDOUX',
    'CHARIX',
    'ECHALLON',
    'GIRON',
    'LE POIZAT LALLEYRIAT',
    'NANTUA',
    'LES NEYROLLES',
    'PLAGNE',
    'ST GERMAIN DE JOUX',
  ],
  '01260': [
    'VALROMEY SUR SERAN',
    'CHAMPAGNE EN VALROMEY',
    'HAUT VALROMEY',
    'RUFFIEU',
    'ARVIERE EN VALROMEY',
  ],
  '01470': ['BENONCES', 'BRIORD', 'MONTAGNIEU', 'SEILLONNAZ', 'SERRIERES DE BRIORD'],
  '01370': ['BENY', 'COURMANGOUX', 'MEILLONNAS', 'ST ETIENNE DU BOIS', 'VAL REVERMONT'],
  '01290': [
    'BEY',
    'BIZIAT',
    'CORMORANCHE SUR SAONE',
    'CROTTET',
    'CRUZILLES LES MEPILLAT',
    'GRIEGES',
    'LAIZ',
    'PONT DE VEYLE',
    'ST ANDRE D HUIRIAT',
    'ST JEAN SUR VEYLE',
  ],
  '01700': ['BEYNOST', 'MIRIBEL', 'NEYRON', 'ST MAURICE DE BEYNOST'],
  '01150': [
    'BLYES',
    'CHAZEY SUR AIN',
    'LAGNIEU',
    'LEYMENT',
    'STE JULIE',
    'ST SORLIN EN BUGEY',
    'ST VULBAS',
    'SAULT BRENAZ',
    'SOUCLIN',
    'VAUX EN BUGEY',
    'VILLEBOIS',
  ],
  '01120': ['LA BOISSE', 'DAGNEUX', 'MONTLUEL', 'NIEVROZ', 'PIZAY', 'STE CROIX', 'THIL'],
  '01450': [
    'BOLOZON',
    'CERDON',
    'CHALLES LA MONTAGNE',
    'LABALME',
    'LEYSSARD',
    'MERIGNAT',
    'PONCIN',
    'ST ALBAN',
    'SERRIERES SUR AIN',
  ],
  '01000': ['BOURG EN BRESSE', 'ST DENIS LES BOURG'],
  '01800': [
    'BOURG ST CHRISTOPHE',
    'CHARNOZ SUR AIN',
    'FARAMANS',
    'JOYEUX',
    'MEXIMIEUX',
    'LE MONTELLIER',
    'PEROUGES',
    'RIGNIEUX LE FRANC',
    'ST ELOI',
    'ST JEAN DE NIOST',
    'ST MAURICE DE GOURDANS',
    'VILLIEU LOYES MOLLON',
  ],
  '01460': [
    'BRION',
    'BEARD GEOVREISSIAT',
    'MONTREAL LA CLUSE',
    'NURIEUX VOLOGNAT',
    'NANTUA',
    'PORT',
  ],
  '01310': [
    'BUELLAS',
    'CONFRANCON',
    'CURTAFOND',
    'MONTCET',
    'MONTRACOL',
    'POLLIAT',
    'ST MARTIN LE CHATEL',
    'ST REMY',
  ],
  '01430': [
    'CEIGNES',
    'CHEVILLARD',
    'CONDAMINE',
    'IZENAVE',
    'LANTENAY',
    'MAILLAT',
    'OUTRIAZ',
    'PEYRIAT',
    'ST MARTIN DU FRENE',
    'VIEU D IZENAVE',
  ],
  '01240': [
    'CERTINES',
    'LA CHAPELLE DU CHATELARD',
    'DOMPIERRE SUR VEYLE',
    'LENT',
    'MARLIEUX',
    'ST ANDRE LE BOUCHOUX',
    'ST GERMAIN SUR RENON',
    'ST PAUL DE VARAX',
  ],
  '01170': ['CESSY', 'CHEVRY', 'CROZET', 'ECHENEVEX', 'GEX', 'MIJOUX', 'SEGNY', 'VESANCY'],
  '01250': [
    'CEYZERIAT',
    'NIVIGNE ET SURAN',
    'CIZE',
    'CORVEISSIAT',
    'DROM',
    'GRAND CORENT',
    'HAUTECOURT ROMANECHE',
    'JASSERON',
    'JOURNANS',
    'BOHAS MEYRIAT RIGNAT',
    'MONTAGNAT',
    'POUILLAT',
    'RAMASSE',
    'REVONNAS',
    'ST JUST',
    'SIMANDRE SUR SURAN',
    'TOSSIAT',
    'VILLEREVERSURE',
  ],
  '01320': [
    'CHALAMONT',
    'CHATENAY',
    'CHATILLON LA PALUD',
    'CRANS',
    'ST NIZIER LE DESERT',
    'VILLETTE SUR AIN',
  ],
  '01630': ['CHALLEX', 'PERON', 'ST GENIS POUILLY', 'ST JEAN DE GONVILLE', 'SERGY'],
  '01410': ['CHAMPFROMIER', 'CHEZERY FORENS', 'LELEX', 'MIJOUX', 'LAJOUX'],
  '01420': ['CHANAY', 'CORBONOD', 'SURJOUX LHOPITAL', 'SEYSSEL'],
  '01660': ['CHAVEYRIAT', 'MEZERIAT', 'VANDEINS'],
  '01390': [
    'CIVRIEUX',
    'MIONNAY',
    'MONTHIEUX',
    'RANCE',
    'ST ANDRE DE CORCY',
    'ST JEAN DE THURIGNEUX',
    'ST MARCEL',
    'TRAMOYES',
  ],
  '01550': ['COLLONGES', 'FARGES', 'POUGNY'],
  '01560': [
    'CORMOZ',
    'COURTES',
    'CURCIAT DONGALON',
    'LESCHEROUX',
    'MANTENAY MONTLIN',
    'ST JEAN SUR REYSSOUZE',
    'ST JULIEN SUR REYSSOUZE',
    'ST NIZIER LE BOUCHOUX',
    'ST TRIVIER DE COURTES',
    'SERVIGNAT',
    'VERNOUX',
    'VESCOURS',
  ],
  '01750': ['CROTTET', 'REPLONGES', 'ST LAURENT SUR SAONE'],
  '01220': ['DIVONNE LES BAINS', 'GRILLY', 'SAUVERNY'],
  '01590': ['DORTAN', 'CHANCIA', 'LAVANCIA EPERCY'],
  '01160': [
    'DRUILLAT',
    'NEUVILLE SUR AIN',
    'PONT D AIN',
    'PRIAY',
    'ST MARTIN DU MONT',
    'LA TRANCLIERE',
    'VARAMBON',
  ],
  '01210': ['FERNEY VOLTAIRE', 'ORNEX', 'VERSONNEX'],
  '01090': ['FRANCHELEINS', 'GENOUILLEUX', 'GUEREINS', 'LURCY', 'MONTCEAUX', 'MONTMERLE SUR SAONE'],
  '01140': [
    'GARNERANS',
    'ILLIAT',
    'MOGNENEINS',
    'PEYZIEUX SUR SAONE',
    'ST DIDIER SUR CHALARONNE',
    'ST ETIENNE SUR CHALARONNE',
    'THOISSEY',
    'VALEINS',
  ],
  '01680': ['INNIMOND', 'LHUIS', 'LOMPNAS', 'MARCHAMP'],
  '01580': ['IZERNORE', 'MATAFELON GRANGES', 'SAMOGNAT', 'SONTHONNAX LA MONTAGNE'],
  '01851': ['MARBOZ'],
  '01600': [
    'MASSIEUX',
    'MISERIEUX',
    'PARCIEUX',
    'REYRIEUX',
    'ST BERNARD',
    'ST DIDIER DE FORMANS',
    'STE EUPHEMIE',
    'TOUSSIEUX',
    'TREVOUX',
  ],
  '01960': ['PERONNAS', 'ST ANDRE SUR VIEUX JONC', 'SERVAS'],
  '01540': ['PERREX', 'ST JULIEN SUR VEYLE', 'VONNAS'],
  '01280': ['PREVESSIN MOENS'],
  '01710': ['THOIRY'],
  '01440': ['VIRIAT'],
  '02300': [
    'ABBECOURT',
    'AUDIGNICOURT',
    'AUTREVILLE',
    'BEAUMONT EN BEINE',
    'BESME',
    'BETHANCOURT EN VAUX',
    'BICHANCOURT',
    'BLERANCOURT',
    'BOURGUIGNON SOUS COUCY',
    'CAILLOUEL CREPIGNY',
    'CAMELIN',
    'CAUMONT',
    'CHAUNY',
    'COMMENCHON',
    'GUIVRY',
    'GUNY',
    'MANICAMP',
    'MAREST DAMPCOURT',
    'NEUFLIEUX',
    'LA NEUVILLE EN BEINE',
    'OGNES',
    'PIERREMANDE',
    'QUIERZY',
    'ST AUBIN',
    'ST PAUL AUX BOIS',
    'SELENS',
    'SINCENY',
    'TROSLY LOIRE',
    'UGNY LE GAY',
    'VILLEQUIER AUMONT',
    'VIRY NOUREUIL',
  ],
  '02800': [
    'ACHERY',
    'ANDELAIN',
    'ANGUILCOURT LE SART',
    'BEAUTOR',
    'BERTAUCOURT EPOURDON',
    'CHARMES',
    'COURBES',
    'DANIZY',
    'LA FERE',
    'FRESSANCOURT',
    'MAYOT',
    'NOUVION LE COMTE',
    'ROGECOURT',
    'TRAVECY',
    'VENDEUIL',
    'VERSIGNY',
  ],
  '02200': [
    'ACY',
    'AMBRIEF',
    'BELLEU',
    'BILLY SUR AISNE',
    'BUZANCY',
    'CHACRISE',
    'CHAUDUN',
    'COURMELLES',
    'CUISY EN ALMONT',
    'MERCIN ET VAUX',
    'MISSY AUX BOIS',
    'NAMPTEUIL SOUS MURET',
    'BERNOY LE CHATEAU',
    'PASLY',
    'PERNANT',
    'PLOISY',
    'POMMIERS',
    'ROZIERES SUR CRISE',
    'SACONIN ET BREUIL',
    'SEPTMONTS',
    'SOISSONS',
    'VAUXREZIS',
    'VAUXBUIN',
    'VENIZEL',
    'VILLENEUVE ST GERMAIN',
  ],
  '02340': [
    'AGNICOURT ET SECHELLES',
    'BERLISE',
    'CHAOURSE',
    'CLERMONT LES FERMES',
    'DIZY LE GROS',
    'LISLET',
    'MONTCORNET',
    'MONTLOUE',
    'NOIRCOURT',
    'RENNEVAL',
    'STE GENEVIEVE',
    'SOIZE',
    'LE THUEL',
    'VIGNEUX HOCQUET',
    'LA VILLE AUX BOIS LES DIZY',
    'VINCY REUIL ET MAGNY',
  ],
  '02190': [
    'AGUILCOURT',
    'AMIFONTAINE',
    'BERRY AU BAC',
    'BERTRICOURT',
    'CONDE SUR SUIPPE',
    'EVERGNICOURT',
    'VILLENEUVE SUR AISNE',
    'JUVINCOURT ET DAMARY',
    'LOR',
    'LA MALMAISON',
    'NEUFCHATEL SUR AISNE',
    'ORAINVILLE',
    'PIGNICOURT',
    'PROUVAIS',
    'PROVISEUX ET PLESNOY',
    'VARISCOURT',
  ],
  '02110': [
    'AISONVILLE ET BERNOVILLE',
    'BEAUREVOIR',
    'BECQUIGNY',
    'BOHAIN EN VERMANDOIS',
    'BRANCOURT LE GRAND',
    'CROIX FONSOMME',
    'ETAVES ET BOCQUIAUX',
    'FIEULAINE',
    'FONSOMME',
    'FONTAINE NOTRE DAME',
    'FONTAINE UTERTE',
    'GROUGIS',
    'MOLAIN',
    'MONTBREHAIN',
    'MONTIGNY EN ARROUAISE',
    'PREMONT',
    'RAMICOURT',
    'RIBEAUVILLE',
    'ST MARTIN RIVIERE',
    'SEBONCOURT',
    'SERAIN',
    'LA VALLEE MULATRE',
    'VAUX ANDIGNY',
  ],
  '02820': [
    'AIZELLES',
    'AUBIGNY EN LAONNOIS',
    'BERRIEUX',
    'CORBENY',
    'COURTRIZY ET FUSSIGNY',
    'GOUDELANCOURT LES BERRIEUX',
    'MAUREGNY EN HAYE',
    'MONTAIGU',
    'STE CROIX',
    'ST ERME OUTRE ET RAMECOURT',
    'ST THOMAS',
  ],
  '02370': [
    'AIZY JOUY',
    'CELLES SUR AISNE',
    'CHASSEMY',
    'CHAVONNE',
    'CONDE SUR AISNE',
    'OSTEL',
    'PRESLES ET BOVES',
    'VAILLY SUR AISNE',
  ],
  '02240': [
    'ALAINCOURT',
    'BERTHENICOURT',
    'BRISSAY CHOIGNY',
    'BRISSY HAMEGICOURT',
    'CERIZY',
    'CHATILLON SUR OISE',
    'ITANCOURT',
    'MEZIERES SUR OISE',
    'PARPEVILLE',
    'PLEINE SELVE',
    'REGNY',
    'RENANSART',
    'RIBEMONT',
    'SERY LES MEZIERES',
    'SISSY',
    'SURFONTAINE',
    'VILLERS LE SEC',
  ],
  '02320': [
    'ALLEMANT',
    'ANIZY LE GRAND',
    'BRANCOURT EN LAONNOIS',
    'CESSIERES SUZY',
    'PINON',
    'PREMONTRE',
    'VAUDESSON',
    'VAUXAILLON',
    'WISSIGNICOURT',
  ],
  '02290': [
    'AMBLENY',
    'BAGNEUX',
    'BERNY RIVIERE',
    'BIEUXY',
    'EPAGNY',
    'FONTENOY',
    'MONTIGNY LENGRAIN',
    'MORSAIN',
    'NOUVRON VINGRE',
    'OSLY COURTIL',
    'RESSONS LE LONG',
    'ST BANDRY',
    'ST CHRISTOPHE A BERRY',
    'TARTIERS',
    'VASSENS',
    'VEZAPONIN',
    'VIC SUR AISNE',
  ],
  '02700': [
    'AMIGNY ROUY',
    'BARISIS AUX BOIS',
    'CONDREN',
    'DEUILLET',
    'FRIERES FAILLOUEL',
    'LIEZ',
    'MENNESSIS',
    'SERVAIS',
    'TERGNIER',
  ],
  '02600': [
    'ANCIENVILLE',
    'COEUVRES ET VALSERY',
    'CORCY',
    'COYOLLES',
    'CUTRY',
    'DAMPLEUX',
    'DOMMIERS',
    'FAVEROLLES',
    'FLEURY',
    'HARAMONT',
    'LARGNY SUR AUTOMNE',
    'LAVERSINE',
    'LONGPONT',
    'LOUATRE',
    'MONTGOBERT',
    'MORTEFONTAINE',
    'NOROY SUR OURCQ',
    'OIGNY EN VALOIS',
    'PUISEUX EN RETZ',
    'RETHEUIL',
    'ST PIERRE AIGLE',
    'SOUCY',
    'TAILLEFONTAINE',
    'VILLERS COTTERETS',
    'VILLERS HELON',
    'VIVIERES',
  ],
  '02480': [
    'ANNOIS',
    'ARTEMPS',
    'BRAY ST CHRISTOPHE',
    'CUGNY',
    'DURY',
    'HAPPENCOURT',
    'JUSSY',
    'OLLEZY',
    'PITHON',
    'SOMMETTE EAUCOURT',
  ],
  '02500': [
    'ANY MARTIN RIEUX',
    'AUBENTON',
    'BEAUME',
    'BESMONT',
    'BUCILLY',
    'BUIRE',
    'EFFRY',
    'EPARCY',
    'LA HERIE',
    'HIRSON',
    'LEUZE',
    'LOGNY LES AUBENTON',
    'LUZOIR',
    'MARTIGNY',
    'MONDREPUIS',
    'NEUVE MAISON',
    'OHIS',
    'WIMY',
  ],
  '02360': [
    'ARCHON',
    'LES AUTELS',
    'BRUNEHAMEL',
    'CHERY LES ROZOY',
    'COINGT',
    'CUIRY LES IVIERS',
    'DOHIS',
    'DOLIGNON',
    'GRANDRIEUX',
    'IVIERS',
    'MONT ST JEAN',
    'MORGNY EN THIERACHE',
    'PARFONDEVAL',
    'RAILLIMONT',
    'RESIGNY',
    'ROUVROY SUR SERRE',
    'ROZOY SUR SERRE',
    'ST CLEMENT',
  ],
  '02130': [
    'ARCY STE RESTITUE',
    'BEUVARDES',
    'BRUYERES SUR FERE',
    'CIERGES',
    'COULONGES COHAN',
    'COURMONT',
    'CRAMAILLE',
    'DRAVEGNY',
    'FERE EN TARDENOIS',
    'FRESNES EN TARDENOIS',
    'GOUSSANCOURT',
    'LOUPEIGNE',
    'MAREUIL EN DOLE',
    'RONCHERES',
    'SAPONAY',
    'SERGY',
    'SERINGES ET NESLES',
    'VEZILLY',
    'VILLENEUVE SUR FERE',
    'VILLERS AGRON AIGUIZY',
    'VILLERS SUR FERE',
  ],
  '02210': [
    'ARMENTIERES SUR OURCQ',
    'BEUGNEUX',
    'BILLY SUR OURCQ',
    'BRECY',
    'BRENY',
    'CHOUY',
    'COINCY',
    'LA CROIX SUR OURCQ',
    'DROIZY',
    'GRISOLLES',
    'HARTENNES ET TAUX',
    'LATILLY',
    'LAUNOY',
    'MONTGRU ST HILAIRE',
    'MURET ET CROUTTES',
    'NANTEUIL NOTRE DAME',
    'OULCHY LA VILLE',
    'OULCHY LE CHATEAU',
    'PARCY ET TIGNY',
    'LE PLESSIER HULEU',
    'ROCOURT ST MARTIN',
    'ROZET ST ALBIN',
    'GRAND ROZOY',
    'ST REMY BLANZY',
    'VICHEL NANTEUIL',
    'VIERZY',
    'VILLEMONTOIRE',
  ],
  '02860': [
    'ARRANCY',
    'BIEVRES',
    'BOUCONVILLE VAUCLAIR',
    'BRUYERES ET MONTBERAULT',
    'CERNY EN LAONNOIS',
    'CHAMOUILLE',
    'CHERET',
    'CHERMIZY AILLES',
    'COLLIGIS CRANDELAIN',
    'LAVAL EN LAONNOIS',
    'LIERVAL',
    'MARTIGNY COURPIERRE',
    'MONTCHALONS',
    'MONTHENAULT',
    'NEUVILLE SUR AILETTE',
    'NOUVION LE VINEUX',
    'ORGEVAL',
    'PANCY COURTECON',
    'PLOYART ET VAURSEINE',
    'PRESLES ET THIERNY',
    'TRUCY',
    'VORGES',
  ],
  '02270': [
    'ASSIS SUR SERRE',
    'BARENTON SUR SERRE',
    'BOIS LES PARGNY',
    'CHALANDRY',
    'CHATILLON LES SONS',
    'CHEVRESIS MONCEAU',
    'COUVRON ET AUMENCOURT',
    'CRECY SUR SERRE',
    'DERCY',
    'LA FERTE CHEVRESIS',
    'FROIDMONT COHARTILLE',
    'MESBRECOURT RICHECOURT',
    'MONCEAU LE NEUF ET FAUCOUZY',
    'MONCEAU LES LEUPS',
    'MONTIGNY SUR CRECY',
    'MORTIERS',
    'NOUVION ET CATILLON',
    'PARGNY LES BOIS',
    'POUILLY SUR SERRE',
    'REMIES',
    'SONS ET RONCHERES',
  ],
  '02840': [
    'ATHIES SOUS LAON',
    'COUCY LES EPPES',
    'EPPES',
    'FESTIEUX',
    'MONCEAU LE WAAST',
    'PARFONDRU',
    'SAMOUSSY',
    'VESLUD',
  ],
  '02490': [
    'ATTILLY',
    'CAULAINCOURT',
    'JEANCOURT',
    'MAISSEMY',
    'PONTRU',
    'PONTRUET',
    'TREFCON',
    'VENDELLES',
    'LE VERGUIER',
    'VERMAND',
  ],
  '02420': [
    'AUBENCHEUL AUX BOIS',
    'BELLENGLISE',
    'BELLICOURT',
    'BONY',
    'LE CATELET',
    'ESTREES',
    'GOUY',
    'HARGICOURT',
    'LEHAUCOURT',
    'JONCOURT',
    'LEMPIRE',
    'LEVERGIES',
    'MAGNY LA FOSSE',
    'NAUROY',
    'SEQUEHART',
    'VENDHUILE',
    'VILLERET',
  ],
  '02590': [
    'AUBIGNY AUX KAISNES',
    'BEAUVOIS EN VERMANDOIS',
    'DOUCHY',
    'ETREILLERS',
    'FLUQUIERES',
    'FORESTE',
    'GERMAINE',
    'LANCHY',
    'ROUPY',
    'SAVY',
    'VAUX EN VERMANDOIS',
    'VILLERS ST CHRISTOPHE',
  ],
  '02120': [
    'AUDIGNY',
    'BERNOT',
    'CHIGNY',
    'COLONFAY',
    'CRUPILLY',
    'FLAVIGNY LE GRAND ET BEAURAIN',
    'GUISE',
    'HAUTEVILLE',
    'LE HERIE LA VIEVILLE',
    'LANDIFAY ET BERTAIGNEMONT',
    'LESQUIELLES ST GERMAIN',
    'MACQUIGNY',
    'MALZY',
    'MARLY GOMONT',
    'MONCEAU SUR OISE',
    'NOYALES',
    'PROISY',
    'PROIX',
    'PUISIEUX ET CLANLIEU',
    'ROMERY',
    'SAINS RICHAUMONT',
    'TUPIGNY',
    'VADENCOURT',
    'GRAND VERLY',
    'VILLERS LES GUISE',
    'WIEGE FATY',
  ],
  '02220': [
    'AUGY',
    'BAZOCHES ET ST THIBAUT',
    'BRAINE',
    'BRENELLE',
    'BRUYS',
    'CERSEUIL',
    'CHERY CHARTREUVE',
    'CIRY SALSOGNE',
    'COURCELLES SUR VESLE',
    'COUVRELLES',
    'CUIRY HOUSSE',
    'CYS LA COMMUNE',
    'DHUIZEL',
    'JOUAIGNES',
    'LESGES',
    'LHUYS',
    'LIME',
    'MAAST ET VIOLAINE',
    'MONT NOTRE DAME',
    'MONT ST MARTIN',
    'PAARS',
    'QUINCY SOUS LE MONT',
    'ST MARD',
    'SERCHES',
    'SERMOISE',
    'TANNIERES',
    'VASSENY',
    'VAUXTIN',
    'VILLE SAVOYE',
  ],
  '02000': [
    'AULNOIS SOUS LAON',
    'BARENTON BUGNY',
    'BARENTON CEL',
    'BOURGUIGNON SOUS MONTBAVIN',
    'BRAYE EN LAONNOIS',
    'CHAILLEVOIS',
    'CHAMBRY',
    'CHAVIGNON',
    'CHERY LES POUILLY',
    'CHEVREGNY',
    'CHIVY LES ETOUVELLES',
    'CLACY ET THIERRET',
    'ETOUVELLES',
    'FILAIN',
    'LANISCOURT',
    'LAON',
    'MERLIEUX ET FOUQUEROLLES',
    'MOLINCHART',
    'MONAMPTEUIL',
    'MONS EN LAONNOIS',
    'MONTBAVIN',
    'PARGNY FILAIN',
    'ROYAUCOURT ET CHAILVET',
    'URCEL',
    'VAUCELLES ET BEFFECOURT',
    'VERNEUIL SUR SERRE',
  ],
  '02250': [
    'AUTREMENCOURT',
    'BERLANCOURT',
    'BOSMONT SUR SERRE',
    'CHEVENNES',
    'CILLY',
    'ERLON',
    'HOUSSET',
    'MARCY SOUS MARLE',
    'MARLE',
    'MONTIGNY LE FRANC',
    'MONTIGNY SOUS MARLE',
    'LA NEUVILLE BOSMONT',
    'LA NEUVILLE HOUSSET',
    'ST PIERREMONT',
    'TAVAUX ET PONTSERICOURT',
    'THIERNU',
    'TOULIS ET ATTENCOURT',
    'VOYENNE',
  ],
  '02580': ['AUTREPPES', 'ETREAUPONT', 'SORBAIS'],
  '02400': [
    'AZY SUR MARNE',
    'BELLEAU',
    'BEZU ST GERMAIN',
    'BLESMES',
    'BONNEIL',
    'BONNESVALYN',
    'BOURESCHES',
    'BRASLES',
    'CHARTEVES',
    'CHATEAU THIERRY',
    'CHIERRY',
    'EPAUX BEZU',
    'EPIEDS',
    'ESSOMES SUR MARNE',
    'ETAMPES SUR MARNE',
    'ETREPILLY',
    'GLAND',
    'LUCY LE BOCAGE',
    'MONTHIERS',
    'MONT ST PERE',
    'NESLES LA MONTAGNE',
    'NOGENTEL',
    'VERDILLY',
  ],
  '02140': [
    'BANCIGNY',
    'LA BOUTEILLE',
    'BRAYE EN THIERACHE',
    'BURELLES',
    'DAGNY LAMBERCY',
    'FONTAINE LES VERVINS',
    'FRANQUEVILLE',
    'GERCY',
    'GRONARD',
    'HARCIGNY',
    'HARY',
    'HAUTION',
    'HOURY',
    'JEANTES',
    'LAIGNY',
    'LANDOUZY LA COUR',
    'LANDOUZY LA VILLE',
    'LEME',
    'LUGNY',
    'MARFONTAINE',
    'NAMPCELLES LA COUR',
    'PLOMION',
    'PRISCES',
    'ROGNY',
    'ROUGERIES',
    'ST GOBERT',
    'ST PIERRE LES FRANQUEVILLE',
    'LE SOURD',
    'THENAILLES',
    'LA VALLEE AU BLE',
    'VERVINS',
    'VOHARIES',
    'VOULPAIX',
  ],
  '02170': [
    'BARZY EN THIERACHE',
    'ESQUEHERIES',
    'FONTENELLE',
    'LESCHELLE',
    'LE NOUVION EN THIERACHE',
  ],
  '02850': [
    'BARZY SUR MARNE',
    'LE CHARMEL',
    'COURTEMONT VARENNES',
    'JAULGONNE',
    'PASSY SUR MARNE',
    'REUILLY SAUVIGNY',
    'TRELOU SUR MARNE',
  ],
  '02380': [
    'BASSOLES AULERS',
    'COUCY LE CHATEAU AUFFRIQUE',
    'COUCY LA VILLE',
    'CRECY AU MONT',
    'FRESNES SOUS COUCY',
    'JUMENCOURT',
    'LANDRICOURT',
    'LEUILLY SOUS COUCY',
    'PONT ST MARD',
    'QUINCY BASSE',
    'VERNEUIL SOUS COUCY',
  ],
  '02330': [
    'VALLEES EN CHAMPAGNE',
    'CELLES LES CONDE',
    'CONDE EN BRIE',
    'CONNIGIS',
    'COURBOIN',
    'DHUYS ET MORIN EN BRIE',
    'MONTHUREL',
    'MONTIGNY LES CONDE',
    'MONTLEVON',
    'PARGNY LA DHUYS',
    'ST EUGENE',
  ],
  '02160': [
    'BEAURIEUX',
    'BLANZY LES FISMES',
    'BOUFFIGNEREUX',
    'BOURG ET COMIN',
    'CHAUDARDES',
    'CONCEVREUX',
    'CRAONNE',
    'CRAONNELLE',
    'CUIRY LES CHAUDARDES',
    'CUISSY ET GENY',
    'GUYENCOURT',
    'JUMIGNY',
    'LES SEPTVALLONS',
    'MAIZY',
    'MEURIVAL',
    'MOULINS',
    'MOUSSY VERNEUIL',
    'MUSCOURT',
    'OEUILLY',
    'OULCHES LA VALLEE FOULON',
    'PAISSY',
    'PARGNAN',
    'PONT ARCY',
    'PONTAVERT',
    'ROUCY',
    'SERVAL',
    'SOUPIR',
    'VASSOGNE',
    'VENDRESSE BEAULNE',
    'VIEL ARCY',
    'LA VILLE AUX BOIS LES PONTAVERT',
  ],
  '02440': [
    'BENAY',
    'CLASTRES',
    'GIBERCOURT',
    'HINACOURT',
    'LY FONTAINE',
    'MONTESCOURT LIZEROLLES',
    'REMIGNY',
  ],
  '02450': [
    'BERGUES SUR SAMBRE',
    'BOUE',
    'DORENGT',
    'FESMY LE SART',
    'LAVAQUERESSE',
    'LA NEUVILLE LES DORENGT',
    'OISY',
  ],
  '02870': [
    'BESNY ET LOIZY',
    'BRIE',
    'BUCY LES CERNY',
    'CERNY LES BUCY',
    'CREPY',
    'FOURDRAIN',
    'VIVAISE',
  ],
  '02310': [
    'BEZU LE GUERY',
    'CHARLY SUR MARNE',
    'COUPRU',
    'CROUTTES SUR MARNE',
    'DOMPTIN',
    'MONTREUIL AUX LIONS',
    'NOGENT L ARTAUD',
    'PAVANT',
    'ROMENY SUR MARNE',
    'SAULCHERY',
    'VILLIERS ST DENIS',
  ],
  '02350': [
    'BONCOURT',
    'BUCY LES PIERREPONT',
    'CHIVRES EN LAONNOIS',
    'CUIRIEUX',
    'EBOULEAU',
    'GIZY',
    'GOUDELANCOURT LES PIERREPONT',
    'GRANDLUP ET FAY',
    'LIESSE NOTRE DAME',
    'MACHECOURT',
    'MARCHAIS',
    'MISSY LES PIERREPONT',
    'PIERREPONT',
    'STE PREUVE',
    'VESLES ET CAUMONT',
  ],
  '02880': [
    'BRAYE',
    'BUCY LE LONG',
    'CHAVIGNY',
    'CHIVRES VAL',
    'CLAMECY',
    'CROUY',
    'CUFFIES',
    'JUVIGNY',
    'LAFFAUX',
    'LEURY',
    'MARGIVAL',
    'MISSY SUR AISNE',
    'NANTEUIL LA FOSSE',
    'NEUVILLE SUR MARGIVAL',
    'SANCY LES CHEMINOTS',
    'TERNY SORNY',
    'VREGNY',
    'VUILLERY',
  ],
  '02810': [
    'BRUMETZ',
    'BUSSIARES',
    'CHEZY EN ORXOIS',
    'COURCHAMPS',
    'GANDELU',
    'HAUTEVESNES',
    'LICY CLIGNON',
    'MARIGNY EN ORXOIS',
    'MONTIGNY L ALLIER',
    'ST GENGOULPH',
    'TORCY EN VALOIS',
    'VEUILLY LA POTERIE',
  ],
  '02620': ['BUIRONFOSSE'],
  '02260': [
    'LA CAPELLE',
    'CLAIRFONTAINE',
    'ENGLANCOURT',
    'ERLOY',
    'LA FLAMENGRIE',
    'FROIDESTREES',
    'GERGNY',
    'LERZY',
    'PAPLEUX',
    'ROCQUIGNY',
    'ST ALGIS',
    'SOMMERON',
  ],
  '02680': ['CASTRES', 'CONTESCOURT', 'DALLON', 'FONTAINE LES CLERCS', 'GRUGIES'],
  '02670': ['CHAMPS', 'FOLEMBRAY'],
  '02570': ['LA CHAPELLE SUR CHEZY', 'CHEZY SUR MARNE', 'ESSISES'],
  '02650': ['CREZANCY', 'FOSSOY', 'MEZY MOULINS'],
  '02470': [
    'DAMMARD',
    'MACOGNY',
    'MARIZY STE GENEVIEVE',
    'MARIZY ST MARD',
    'MONNES',
    'NEUILLY ST FRONT',
    'PASSY EN VALOIS',
    'PRIEZ',
    'SOMMELANS',
  ],
  '02540': [
    'L EPINE AUX BOIS',
    'DHUYS ET MORIN EN BRIE',
    'MONTFAUCON',
    'ROZOY BELLEVALLE',
    'VENDIERES',
    'VIELS MAISONS',
    'VIFFORT',
  ],
  '02690': ['ESSIGNY LE GRAND', 'URVILLERS'],
  '02100': [
    'ESSIGNY LE PETIT',
    'FAYET',
    'GRICOURT',
    'HARLY',
    'LESDINS',
    'MORCOURT',
    'NEUVILLE ST AMAND',
    'OMISSY',
    'REMAUCOURT',
    'ROUVROY',
    'ST QUENTIN',
  ],
  '02510': ['ETREUX', 'HANNAPES', 'IRON', 'VENEROLLES'],
  '02460': ['LA FERTE MILON', 'SILLY LA POTERIE', 'TROESNES'],
  '02520': ['FLAVY LE MARTEL'],
  '02760': ['FRANCILLY SELENCY', 'HOLNON'],
  '02230': ['FRESNOY LE GRAND'],
  '02430': ['GAUCHY'],
  '02720': ['HOMBLIERES', 'MARCY', 'MESNIL ST LAURENT'],
  '02150': ['LAPPION', 'NIZY LE COMTE', 'LA SELVE', 'SISSONNE'],
  '02630': ['MENNEVRET', 'PETIT VERLY', 'WASSIGNY'],
  '02390': ['MONT D ORIGNY', 'NEUVILLETTE', 'ORIGNY STE BENOITE', 'THENELLES'],
  '02610': ['MOY DE L AISNE'],
  '02550': ['ORIGNY EN THIERACHE'],
  '02410': ['ST GOBAIN', 'ST NICOLAS AUX BOIS', 'SEPTVAUX'],
  '02830': ['ST MICHEL', 'WATIGNY'],
  '02640': ['ST SIMON', 'TUGNY ET PONT'],
  '02790': ['SERAUCOURT LE GRAND'],
  '03200': ['ABREST', 'LE VERNET', 'VICHY'],
  '03210': [
    'AGONGES',
    'AUTRY ISSARDS',
    'BESSON',
    'BRESNAY',
    'CHATILLON',
    'CHEMILLY',
    'GIPCY',
    'MARIGNY',
    'MEILLERS',
    'NOYANT D ALLIER',
    'ST MENOUX',
    'SOUVIGNY',
  ],
  '03360': [
    'AINAY LE CHATEAU',
    'BRAIZE',
    'ISLE ET BARDAIS',
    'LETELON',
    'MEAULNE VITRAY',
    'ST BONNET TRONCAIS',
    'URCAY',
    'VALIGNY',
  ],
  '03120': [
    'ANDELAROCHE',
    'ARFEUILLES',
    'BARRAIS BUSSOLLES',
    'BILLEZOIS',
    'LE BREUIL',
    'CHATELUS',
    'DROITURIER',
    'ISSERPENT',
    'LAPALISSE',
    'PERIGNY',
    'ST CHRISTOPHE EN BOURBONNAIS',
    'ST PRIX',
    'SERVILLY',
  ],
  '03380': [
    'ARCHIGNAT',
    'LA CHAPELAUDE',
    'HURIEL',
    'LAMAIDS',
    'QUINSSAINES',
    'ST MARTINIEN',
    'TREIGNAT',
  ],
  '03420': [
    'ARPHEUILLES ST PRIEST',
    'MARCILLAT EN COMBRAILLE',
    'MAZIRAT',
    'LA PETITE MARCHE',
    'RONNET',
    'ST FARGEOL',
    'ST MARCEL EN MARCILLAT',
    'STE THERENCE',
    'TERJAT',
  ],
  '03250': [
    'ARRONNES',
    'LA CHABANNE',
    'CHATEL MONTAGNE',
    'FERRIERES SUR SICHON',
    'LA GUILLERMIE',
    'LAPRUGNE',
    'LAVOINE',
    'LE MAYET DE MONTAGNE',
    'NIZEROLLES',
    'ST CLEMENT',
    'ST NICOLAS DES BIEFS',
  ],
  '03460': ['AUBIGNY', 'AUROUER', 'BAGNEUX', 'TREVOL', 'VILLENEUVE SUR ALLIER'],
  '03190': [
    'AUDES',
    'ESTIVAREILLES',
    'HERISSON',
    'HAUT BOCAGE',
    'NASSIGNY',
    'REUGNY',
    'ST CAPRAIS',
    'VALLON EN SULLY',
    'VAUX',
    'VENAS',
    'VERNEIX',
  ],
  '03000': ['AVERMES', 'BRESSOLLES', 'COULANDON', 'MONTILLY', 'MOULINS', 'NEUVY'],
  '03130': [
    'AVRILLY',
    'BERT',
    'LE BOUCHAUD',
    'LE DONJON',
    'LENAX',
    'LIERNOLLES',
    'LODDES',
    'LUNEAU',
    'MONTAIGUET EN FOREZ',
    'MONTCOMBROUX LES MINES',
    'NEUILLY EN DONJON',
    'LE PIN',
    'ST DIDIER EN DONJON',
    'ST LEGER SUR VOUZANCE',
  ],
  '03140': [
    'BARBERIER',
    'CHANTELLE',
    'CHAREIL CINTRAT',
    'CHARROUX',
    'CHEZELLE',
    'DENEUILLE LES CHANTELLE',
    'ETROUSSAT',
    'FLEURIEL',
    'FOURILLES',
    'MONESTIER',
    'ST GERMAIN DE SALLES',
    'TARGET',
    'TAXAT SENAT',
    'USSEL D ALLIER',
    'VOUSSAC',
  ],
  '03500': [
    'BAYET',
    'BRANSAT',
    'CESSET',
    'CHATEL DE NEUVRE',
    'CONTIGNY',
    'LAFELINE',
    'LORIGES',
    'LOUCHY MONTFAND',
    'MEILLARD',
    'MONETAY SUR ALLIER',
    'MONTORD',
    'PARAY SOUS BRIAILLES',
    'ST POURCAIN SUR SIOULE',
    'SAULCET',
    'VERNEUIL EN BOURBONNAIS',
  ],
  '03230': [
    'BEAULON',
    'LA CHAPELLE AUX CHASSES',
    'CHEVAGNES',
    'CHEZY',
    'GANNAY SUR LOIRE',
    'GARNAT SUR ENGIEVRE',
    'LUSIGNY',
    'PARAY LE FRESIL',
    'ST MARTIN DES LAIS',
    'THIEL SUR ACOLIN',
  ],
  '03390': [
    'BEAUNE D ALLIER',
    'BLOMARD',
    'CHAPPES',
    'MONTMARAULT',
    'MURAT',
    'ST BONNET DE FOUR',
    'ST MARCEL EN MURAT',
    'ST PRIEST EN MURAT',
    'SAZERET',
    'VERNUSSE',
  ],
  '03800': [
    'BEGUES',
    'BIOZAT',
    'CHARMES',
    'GANNAT',
    'JENZAT',
    'LE MAYET D ECOLE',
    'MAZERIER',
    'MONTEIGNET SUR L ANDELOT',
    'POEZAT',
    'ST BONNET DE ROCHEFORT',
    'ST PRIEST D ANDELOT',
    'SAULZET',
  ],
  '03330': [
    'BELLENAVES',
    'CHIRAT L EGLISE',
    'COUTANSOUZE',
    'ECHASSIERES',
    'LOUROUX DE BOUBLE',
    'NAVES',
    'VALIGNAT',
  ],
  '03700': ['BELLERIVE SUR ALLIER', 'BRUGHEAS', 'SERBANNES'],
  '03340': [
    'BESSAY SUR ALLIER',
    'CHAPEAU',
    'LA FERTE HAUTERIVE',
    'GOUISE',
    'MERCY',
    'MONTBEUGNY',
    'NEUILLY LE REAL',
    'ST GERAND DE VAUX',
  ],
  '03170': [
    'BEZENET',
    'BIZENEUILLE',
    'CHAMBLET',
    'DENEUILLE LES MINES',
    'DOYET',
    'MONTVICQ',
    'ST ANGEL',
  ],
  '03260': ['BILLY', 'MAGNET', 'MARCENAT', 'ST FELIX', 'ST GERMAIN DES FOSSES', 'SEUILLET'],
  '03300': [
    'BOST',
    'LA CHAPELLE',
    'CREUZIER LE NEUF',
    'CREUZIER LE VIEUX',
    'CUSSET',
    'MOLLES',
    'ST ETIENNE DE VICQ',
  ],
  '03150': [
    'BOUCE',
    'CRECHY',
    'LANGY',
    'MONTAIGU LE BLIN',
    'MONTOLDRE',
    'RONGERES',
    'ST GERAND LE PUY',
    'ST LOUP',
    'SANSSAT',
    'VARENNES SUR ALLIER',
  ],
  '03160': [
    'BOURBON L ARCHAMBAULT',
    'COUZON',
    'FRANCHESSE',
    'ST AUBIN LE MONIAL',
    'ST LEOPARDIN D AUGY',
    'ST PLAISIR',
    'YGRANDE',
  ],
  '03350': ['LE BRETHON', 'CERILLY', 'LOUROUX BOURBONNAIS', 'THENEUILLE', 'LE VILHAIN'],
  '03110': [
    'BROUT VERNET',
    'CHARMEIL',
    'COGNAT LYONNE',
    'ESCUROLLES',
    'ESPINASSE VOZELLE',
    'ST DIDIER LA FORET',
    'ST PONT',
    'ST REMY EN ROLLAT',
    'VENDAT',
  ],
  '03270': ['BUSSET', 'HAUTERIVE', 'MARIOL', 'ST YORRE'],
  '03440': ['BUXIERES LES MINES', 'CHAVENON', 'ST HILAIRE'],
  '03600': ['LA CELLE', 'COLOMBIER', 'COMMENTRY', 'HYDS', 'LOUROUX DE BEAUNE', 'MALICORNE'],
  '03370': [
    'CHAMBERAT',
    'CHAZEMAIS',
    'COURCAIS',
    'MESPLES',
    'ST DESIRE',
    'ST ELOY D ALLIER',
    'ST PALAIS',
    'ST SAUVIER',
    'VIPLAIX',
  ],
  '03510': ['CHASSENARD', 'MOLINET'],
  '03320': [
    'CHATEAU SUR ALLIER',
    'COULEUVRE',
    'LIMOISE',
    'LURCY LEVIS',
    'NEURE',
    'POUZY MESANGY',
    'LE VEURDRE',
  ],
  '03220': [
    'CHATELPERRON',
    'CHAVROCHES',
    'CINDRE',
    'JALIGNY SUR BESBRE',
    'ST LEON',
    'ST VOIR',
    'SORBIER',
    'THIONNE',
    'TRETEAU',
    'TREZELLES',
    'VARENNES SUR TECHE',
    'VAUMAS',
  ],
  '03450': ['CHOUVIGNY', 'EBREUIL', 'LALIZOLLE', 'NADES', 'SUSSAT', 'VEAUCE', 'VICQ'],
  '03430': ['COSNE D ALLIER', 'SAUVAGNY', 'TORTEZAIS', 'VIEURE', 'VILLEFRANCHE D ALLIER'],
  '03470': ['COULANGES', 'MONETAY SUR LOIRE', 'PIERREFITTE SUR LOIRE', 'SALIGNY SUR ROUDON'],
  '03240': [
    'CRESSANGES',
    'DEUX CHAISES',
    'LE MONTET',
    'ROCLES',
    'ST SORNIN',
    'LE THEIL',
    'TREBAN',
    'TRONGET',
  ],
  '03630': ['DESERTINES'],
  '03290': ['DIOU', 'DOMPIERRE SUR BESBRE', 'ST POURCAIN SUR BESBRE'],
  '03410': ['DOMERAT', 'LIGNEROLLES', 'PREMILHAT', 'ST VICTOR', 'TEILLET ARGENTY'],
  '03310': ['DURDAT LAREQUILLE', 'NERIS LES BAINS', 'ST GENEST', 'VILLEBRET'],
  '03400': ['GENNETINES', 'ST ENNEMOND', 'TOULON SUR ALLIER', 'YZEURE'],
  '03100': ['LAVAULT STE ANNE', 'MONTLUCON'],
  42620: ['ST PIERRE LAVAL', 'ST MARTIN D ESTREAUX'],
  '04510': ['AIGLUN', 'LE CHAFFAUT ST JURSON', 'MALIJAI', 'MALLEMOISSON', 'MIRABEAU'],
  '04500': [
    'ALLEMAGNE EN PROVENCE',
    'MONTAGNAC MONTPEZAT',
    'QUINSON',
    'RIEZ',
    'ROUMOULES',
    'STE CROIX DU VERDON',
    'ST LAURENT DU VERDON',
  ],
  '04170': [
    'ALLONS',
    'ANGLES',
    'LAMBRUISSE',
    'MORIEZ',
    'LA MURE ARGENS',
    'ST ANDRE LES ALPES',
    'ST JULIEN DU VERDON',
    'THORAME BASSE',
    'THORAME HAUTE',
    'VERGONS',
  ],
  '04260': ['ALLOS'],
  '04240': ['ANNOT', 'BRAUX', 'LE FUGERET', 'MEAILLES', 'ST BENOIT', 'UBRAYE'],
  '04420': [
    'ARCHAIL',
    'BEAUJEU',
    'LE BRUSQUET',
    'DRAIX',
    'LA JAVIE',
    'MARCOUX',
    'PRADS HAUTE BLEONE',
  ],
  '04110': [
    'AUBENAS LES ALPES',
    'MONTFURON',
    'MONTJUSTIN',
    'OPPEDETTE',
    'REILLANNE',
    'STE CROIX A LAUZE',
    'VACHERES',
    'VILLEMUS',
  ],
  '04200': [
    'AUBIGNOSC',
    'AUTHON',
    'BEVONS',
    'CHATEAUNEUF MIRAVAIL',
    'CHATEAUNEUF VAL ST DONAT',
    'CUREL',
    'ENTREPIERRES',
    'MISON',
    'NOYERS SUR JABRON',
    'LES OMERGUES',
    'PEIPIN',
    'ST GENIEZ',
    'ST VINCENT SUR JABRON',
    'SIGOYER',
    'SISTERON',
    'THEZE',
    'VALBELLE',
    'VALERNES',
    'VAUMEILH',
  ],
  '04140': [
    'AUZET',
    'BARLES',
    'MONTCLAR',
    'ST MARTIN LES SEYNE',
    'SELONNET',
    'SEYNE',
    'VERDACHES',
    'LE VERNET',
  ],
  '04150': [
    'BANON',
    'L HOSPITALET',
    'MONTSALIER',
    'REDORTIERS',
    'REVEST DES BROUSSES',
    'REVEST DU BION',
    'LA ROCHEGIRON',
    'SAUMANE',
    'SIMIANE LA ROTONDE',
  ],
  '04400': [
    'BARCELONNETTE',
    'ENCHASTRAYES',
    'FAUCON DE BARCELONNETTE',
    'ST PONS',
    'LES THUILES',
    'UVERNET FOURS',
  ],
  '04380': ['BARRAS', 'LE CASTELLARD MELAN', 'HAUTES DUYES', 'THOARD'],
  '04330': [
    'BARREME',
    'BLIEUX',
    'CHAUDON NORANTE',
    'CLUMANC',
    'ST JACQUES',
    'ST LIONS',
    'SENEZ',
    'TARTONNE',
  ],
  '04250': [
    'BAYONS',
    'BELLAFFAIRE',
    'LE CAIRE',
    'CHATEAUFORT',
    'CLAMENSANE',
    'FAUCON DU CAIRE',
    'GIGORS',
    'MELVE',
    'LA MOTTE DU CAIRE',
    'NIBLES',
    'TURRIERS',
    'VALAVOIRE',
  ],
  '04370': ['BEAUVEZER', 'COLMARS', 'VILLARS COLMARS'],
  '04270': [
    'BEYNES',
    'BRAS D ASSE',
    'CHATEAUREDON',
    'ENTRAGES',
    'ESTOUBLON',
    'MAJASTRES',
    'MEZEL',
    'ST JEANNET',
    'ST JULIEN D ASSE',
    'SENEZ',
  ],
  '04340': ['UBAYE SERRE PONCON', 'LE LAUZET UBAYE', 'MEOLANS REVEL'],
  '04700': ['LA BRILLANNE', 'LE CASTELLET', 'ENTREVENNES', 'LURS', 'ORAISON', 'PUIMICHEL'],
  '04210': ['BRUNET', 'VALENSOLE'],
  '04120': [
    'CASTELLANE',
    'DEMANDOLX',
    'LA GARDE',
    'LA PALUD SUR VERDON',
    'PEYROULES',
    'ROUGON',
    'SOLEILHAS',
  ],
  '04320': ['CASTELLET LES SAUSSES', 'VAL DE CHALVAGNE', 'ENTREVAUX', 'SAUSSES'],
  '04280': ['CERESTE EN LUBERON'],
  '04660': ['CHAMPTERCIER'],
  '04160': ['CHATEAU ARNOUX ST AUBAN', 'L ESCALE'],
  '04600': ['CHATEAU ARNOUX ST AUBAN', 'MONTFORT'],
  '05110': [
    'CLARET',
    'CURBANS',
    'BARCILLONNETTE',
    'ESPARRON',
    'LARDIER ET VALENCA',
    'MONETIER ALLEMONT',
    'LA SAULCE',
    'VITROLLES',
  ],
  '04530': ['LA CONDAMINE CHATELARD', 'VAL D ORONAYE', 'ST PAUL SUR UBAYE'],
  '04220': ['CORBIERES EN PROVENCE', 'STE TULLE'],
  '04230': [
    'CRUIS',
    'FONTIENNE',
    'LARDIERS',
    'MALLEFOUGASSE AUGES',
    'MONTLAUX',
    'ONGLES',
    'REVEST ST MARTIN',
    'ST ETIENNE LES ORGUES',
  ],
  '04300': [
    'DAUPHIN',
    'FORCALQUIER',
    'LIMANS',
    'MANE',
    'NIOZELLES',
    'PIERRERUE',
    'ST MAIME',
    'ST MARTIN LES EAUX',
    'SIGONCE',
  ],
  '04000': ['DIGNE LES BAINS', 'ENTRAGES', 'LA JAVIE', 'LA ROBINE SUR GALABRE'],
  '04800': ['ESPARRON DE VERDON', 'GREOUX LES BAINS', 'ST MARTIN DE BROMES'],
  '04310': ['GANAGOBIE', 'PEYRUIS'],
  '04850': ['JAUSIERS'],
  '04350': ['MALIJAI'],
  '04100': ['MANOSQUE'],
  '04190': ['LES MEES'],
  '04360': ['MOUSTIERS STE MARIE'],
  '05130': [
    'PIEGUT',
    'VENTEROL',
    'FOUILLOUSE',
    'JARJAYES',
    'LETTRET',
    'ST ETIENNE LE LAUS',
    'SIGOYER',
    'TALLARD',
    'VALSERRES',
  ],
  '04860': ['PIERREVERT'],
  '05160': ['PONTIS', 'REALLON', 'ST APOLLINAIRE', 'LE SAUZE DU LAC', 'SAVINES LE LAC'],
  '04410': ['PUIMOISSON', 'ST JURS'],
  '06260': [
    'LA ROCHETTE',
    'ST PIERRE',
    'ASCROS',
    'AUVARE',
    'LA CROIX SUR ROUDOULE',
    'LIEUCHE',
    'LA PENNE',
    'PIERLAS',
    'PUGET ROSTANG',
    'PUGET THENIERS',
    'RIGAUD',
    'ST ANTONIN',
    'ST LEGER',
  ],
  '04870': ['ST MICHEL L OBSERVATOIRE'],
  '04290': ['SALIGNAC', 'SOURRIBES', 'VOLONNE'],
  '04180': ['VILLENEUVE'],
  '04130': ['VOLX'],
  '05460': ['ABRIES RISTOLAS'],
  '05470': ['AIGUILLES'],
  '05260': [
    'ANCELLE',
    'CHABOTTES',
    'CHAMPOLEON',
    'FOREST ST JULIEN',
    'ST JEAN ST NICOLAS',
    'ST LEGER LES MELEZES',
    'ST MICHEL DE CHAILLOL',
  ],
  '05120': ['L ARGENTIERE LA BESSEE', 'ST MARTIN DE QUEYRIERES', 'LES VIGNEAUX'],
  '05350': ['ARVIEUX', 'CHATEAU VILLE VIEILLE', 'MOLINES EN QUEYRAS', 'ST VERAN'],
  '05140': [
    'ASPREMONT',
    'ASPRES SUR BUECH',
    'LA BEAUME',
    'LA FAURIE',
    'LA HAUTE BEAUME',
    'MONTBRAND',
    'ST JULIEN EN BEAUCHENE',
    'ST PIERRE D ARGENCON',
  ],
  '05800': [
    'ASPRES LES CORPS',
    'AUBESSAGNE',
    'LE GLAIZIL',
    'LA CHAPELLE EN VALGAUDEMAR',
    'ST FIRMIN',
    'ST JACQUES EN VALGODEMARD',
    'ST MAURICE EN VALGODEMARD',
    'VILLAR LOUBIERE',
  ],
  '05230': ['AVANCON', 'LA BATIE NEUVE', 'CHORGES', 'MONTGARDIN', 'PRUNIERES'],
  '05200': [
    'BARATIER',
    'CREVOUX',
    'CROTS',
    'EMBRUN',
    'LES ORRES',
    'PUY ST EUSEBE',
    'PUY SANIERES',
    'ST ANDRE D EMBRUN',
    'ST SAUVEUR',
  ],
  '05300': [
    'BARRET SUR MEOUGE',
    'EOURRES',
    'GARDE COLOMBE',
    'LARAGNE MONTEGLIN',
    'LAZER',
    'LE POET',
    'VAL BUECH MEOUGE',
    'ST PIERRE AVEZ',
    'SALEON',
    'SALERANS',
    'UPAIX',
    'VENTAVON',
  ],
  '05700': [
    'LA BATIE MONTSALEON',
    'LE BERSAC',
    'CHANOUSSE',
    'L EPINE',
    'ETOILE ST CYRICE',
    'MEREUIL',
    'MONTCLUS',
    'MONTROND',
    'NOSSAGE ET BENEVENT',
    'ORPIERRE',
    'LA PIARRE',
    'STE COLOMBE',
    'SAVOURNON',
    'SERRES',
    'SIGOTTIER',
    'TRESCLEOUX',
    'VILLEBOIS LES PINS',
  ],
  '05000': [
    'LA BATIE VIEILLE',
    'CHATEAUVIEUX',
    'LA FREISSINOUSE',
    'GAP',
    'NEFFES',
    'PELLEAUTIER',
    'RAMBAUD',
    'LA ROCHETTE',
  ],
  '05190': ['BREZIERS', 'ESPINASSES', 'REMOLLON', 'ROCHEBRUNE', 'ROUSSET', 'THEUS'],
  '05100': [
    'BRIANCON',
    'CERVIERES',
    'MONTGENEVRE',
    'NEVACHE',
    'PUY ST ANDRE',
    'PUY ST PIERRE',
    'VAL DES PRES',
    'VILLAR ST PANCRACE',
  ],
  '05150': [
    'VALDOULE',
    'MONTJAY',
    'MOYDANS',
    'RIBEYRET',
    'ROSANS',
    'ST ANDRE DE ROSANS',
    'SORBIERS',
  ],
  '05500': [
    'BUISSARD',
    'AUBESSAGNE',
    'LA FARE EN CHAMPSAUR',
    'LAYE',
    'LA MOTTE EN CHAMPSAUR',
    'LE NOYER',
    'POLIGNY',
    'ST BONNET EN CHAMPSAUR',
    'ST JULIEN EN CHAMPSAUR',
    'ST LAURENT DU CROS',
  ],
  '05600': [
    'CEILLAC',
    'EYGLIERS',
    'GUILLESTRE',
    'MONT DAUPHIN',
    'REOTIER',
    'RISOUL',
    'ST CLEMENT SUR DURANCE',
    'ST CREPIN',
  ],
  '05400': [
    'CHABESTAN',
    'CHATEAUNEUF D OZE',
    'FURMEYER',
    'MANTEYER',
    'MONTMAUR',
    'OZE',
    'RABOU',
    'LA ROCHE DES ARNAUDS',
    'ST AUBAN D OZE',
    'LE SAIX',
    'VEYNES',
  ],
  '05310': ['CHAMPCELLA', 'FREISSINIERES', 'LA ROCHE DE RAME'],
  '05380': ['CHATEAUROUX LES ALPES'],
  '05320': ['LA GRAVE'],
  '05220': ['LE MONETIER LES BAINS'],
  '05170': ['ORCIERES'],
  '05290': ['VALLOUISE PELVOUX', 'PUY ST VINCENT'],
  '05340': ['VALLOUISE PELVOUX'],
  '05330': ['ST CHAFFREY'],
  '05250': ['LE DEVOLUY'],
  '05240': ['LA SALLE LES ALPES'],
  '05560': ['VARS'],
  '05480': ['VILLAR D ARENE'],
  '06910': [
    'AIGLUN',
    'AMIRAT',
    'COLLONGUES',
    'CUEBRIS',
    'LE MAS',
    'LES MUJOULS',
    'PIERREFEU',
    'ROQUESTERON',
    'LA ROQUE EN PROVENCE',
    'SALLAGRIFFON',
    'SIGALE',
  ],
  '06750': ['ANDON', 'CAILLE', 'SERANON', 'VALDEROURE'],
  '06160': ['ANTIBES'],
  '06600': ['ANTIBES'],
  '06790': ['ASPREMONT'],
  '06810': ['AURIBEAU SUR SIAGNE'],
  '06420': [
    'BAIROLS',
    'CLANS',
    'ILONSE',
    'ISOLA',
    'MARIE',
    'RIMPLAS',
    'ROUBION',
    'ROURE',
    'ST SAUVEUR SUR TINEE',
    'LA TOUR',
    'TOURNEFORT',
    'VALDEBLORE',
  ],
  '06620': ['LE BAR SUR LOUP', 'CIPIERES', 'COURMES', 'GOURDON', 'GREOLIERES'],
  '06310': ['BEAULIEU SUR MER'],
  '06240': ['BEAUSOLEIL'],
  '06450': [
    'BELVEDERE',
    'LA BOLLENE VESUBIE',
    'LANTOSQUE',
    'ROQUEBILLIERE',
    'ST MARTIN VESUBIE',
    'UTELLE',
    'VENANSON',
  ],
  '06390': ['BENDEJUN', 'BERRE LES ALPES', 'CHATEAUNEUF VILLEVIEILLE', 'COARAZE', 'CONTES'],
  '06470': [
    'BEUIL',
    'CHATEAUNEUF D ENTRAUNES',
    'DALUIS',
    'ENTRAUNES',
    'GUILLAUMES',
    'PEONE',
    'ST MARTIN D ENTRAUNES',
    'SAUZE',
    'VILLENEUVE D ENTRAUNES',
  ],
  '06510': [
    'BEZAUDUN LES ALPES',
    'BOUYON',
    'LE BROC',
    'CARROS',
    'CONSEGUDES',
    'LES FERRES',
    'GATTIERES',
  ],
  '06410': ['BIOT'],
  '06440': ['BLAUSASC', 'L ESCARENE', 'LUCERAM', 'PEILLE', 'PEILLON', 'TOUET DE L ESCARENE'],
  '06830': ['BONSON', 'GILETTE', 'REVEST LES ROCHES', 'TOUDON', 'TOURETTE DU CHATEAU'],
  '06540': ['BREIL SUR ROYA', 'FONTAN', 'SAORGE'],
  '06850': ['BRIANCONNET', 'GARS', 'ST AUBAN'],
  '06530': ['CABRIS', 'PEYMEINADE', 'ST CEZAIRE SUR SIAGNE', 'SPERACEDES', 'LE TIGNET'],
  '06800': ['CAGNES SUR MER'],
  '06150': ['CANNES'],
  '06400': ['CANNES'],
  '06110': ['LE CANNET'],
  '06340': ['CANTARON', 'DRAP', 'LA TRINITE'],
  '06320': ['CAP D AIL', 'LA TURBIE'],
  '06670': [
    'CASTAGNIERS',
    'COLOMARS',
    'DURANUS',
    'LEVENS',
    'LA ROQUETTE SUR VAR',
    'ST BLAISE',
    'ST MARTIN DU VAR',
  ],
  '06500': ['CASTELLAR', 'CASTILLON', 'GORBIO', 'MENTON', 'STE AGNES'],
  '06460': ['CAUSSOLS', 'ESCRAGNOLLES', 'ST VALLIER DE THIEY'],
  '06740': ['CHATEAUNEUF GRASSE'],
  '06480': ['LA COLLE SUR LOUP'],
  '06140': ['COURSEGOULES', 'TOURRETTES SUR LOUP', 'VENCE'],
  '06360': ['EZE'],
  '06950': ['FALICON'],
  '06610': ['LA GAUDE'],
  '06130': ['GRASSE'],
  '06520': ['GRASSE'],
  '06710': ['MALAUSSENE', 'MASSOINS', 'THIERY', 'TOUET SUR VAR', 'VILLARS SUR VAR'],
  '06210': ['MANDELIEU LA NAPOULE'],
  '06370': ['MOUANS SARTOUX'],
  '06250': ['MOUGINS'],
  '06380': ['MOULINET', 'SOSPEL'],
  '06000': ['NICE'],
  '06100': ['NICE'],
  '06200': ['NICE'],
  '06300': ['NICE'],
  '06650': ['OPIO', 'LE ROURET'],
  '06580': ['PEGOMAS'],
  '06190': ['ROQUEBRUNE CAP MARTIN'],
  '06330': ['ROQUEFORT LES PINS'],
  '06550': ['LA ROQUETTE SUR SIAGNE'],
  '06730': ['ST ANDRE DE LA ROCHE'],
  '06660': ['ST DALMAS LE SELVAGE', 'ST ETIENNE DE TINEE'],
  '06230': ['ST JEAN CAP FERRAT', 'VILLEFRANCHE SUR MER'],
  '06640': ['ST JEANNET'],
  '06700': ['ST LAURENT DU VAR'],
  '06570': ['ST PAUL DE VENCE'],
  '06590': ['THEOULE SUR MER'],
  '06690': ['TOURRETTE LEVENS'],
  '06560': ['VALBONNE'],
  '06220': ['VALLAURIS'],
  '06270': ['VILLENEUVE LOUBET'],
  '06430': ['LA BRIGUE', 'TENDE'],
  '07160': [
    'ACCONS',
    'LE CHAMBON',
    'LE CHEYLARD',
    'DORNAS',
    'JAUNAC',
    'MARIAC',
    'BELSENTES',
    'ST ANDEOL DE FOURCHADES',
    'ST BARTHELEMY LE MEIL',
    'ST CHRISTOL',
    'ST CIERGE SOUS LE CHEYLARD',
    'ST GENEST LACHAMP',
    'ST JEAN ROURE',
    'ST MICHEL D AURANCE',
  ],
  '07200': [
    'AILHON',
    'AUBENAS',
    'FONS',
    'LABEGUDE',
    'LACHAPELLE SOUS AUBENAS',
    'LANAS',
    'LENTILLERES',
    'MERCUER',
    'ROCHECOLOMBE',
    'ST DIDIER SOUS AUBENAS',
    'ST ETIENNE DE BOULOGNE',
    'ST ETIENNE DE FONTBELLON',
    'ST JULIEN DU SERRE',
    'ST MAURICE D ARDECHE',
    'ST MICHEL DE BOULOGNE',
    'ST PRIVAT',
    'ST SERNIN',
    'UCEL',
    'VESSEAUX',
    'VOGUE',
  ],
  '07530': [
    'AIZAC',
    'VALLEES D ANTRAIGUES ASPERJOC',
    'GENESTELLE',
    'LACHAMP RAPHAEL',
    'LAVIOLLE',
    'MEZILHAC',
    'ST JOSEPH DES BANCS',
  ],
  '07000': [
    'AJOUX',
    'COUX',
    'CREYSSEILLES',
    'FLAVIAC',
    'FREYSSENET',
    'GOURDON',
    'LYAS',
    'POURCHERES',
    'PRANLES',
    'PRIVAS',
    'ST JULIEN EN ST ALBAN',
    'ST PRIEST',
    'VEYRAS',
  ],
  '07400': [
    'ALBA LA ROMAINE',
    'AUBIGNAS',
    'MEYSSE',
    'ROCHEMAURE',
    'ST MARTIN SUR LAVEZON',
    'ST PIERRE LA ROCHE',
    'SCEAUTRES',
    'LE TEIL',
    'VALVIGNERES',
  ],
  '07190': [
    'ALBON D ARDECHE',
    'BEAUVENE',
    'GLUIRAS',
    'ISSAMOULENC',
    'MARCOLS LES EAUX',
    'ST ETIENNE DE SERRE',
    'ST GENEST LACHAMP',
    'ST JULIEN DU GUA',
    'ST MAURICE EN CHALENCON',
    'ST PIERREVILLE',
    'ST SAUVEUR DE MONTAGUT',
  ],
  '07440': ['ALBOUSSIERE', 'BOFFRES', 'CHAMPIS', 'ST SYLVESTRE'],
  '07210': [
    'ALISSAS',
    'BAIX',
    'CHOMERAC',
    'ROCHESSAUVE',
    'ST BAUZILE',
    'ST LAGER BRESSAC',
    'ST SYMPHORIEN SOUS CHOMERAC',
    'ST VINCENT DE BARRES',
  ],
  '07340': [
    'ANDANCE',
    'BOGY',
    'BROSSAINC',
    'CHAMPAGNE',
    'CHARNAS',
    'FELINES',
    'LIMONY',
    'PEAUGRES',
    'PEYRAUD',
    'ST DESIRAT',
    'ST ETIENNE DE VALOUX',
    'ST JACQUES D ATTICIEUX',
    'SERRIERES',
    'TALENCIEUX',
    'THORRENC',
    'VINZIEUX',
  ],
  '07100': ['ANNONAY', 'BOULIEU LES ANNONAY', 'ROIFFIEUX', 'ST MARCEL LES ANNONAY'],
  '07600': [
    'VALLEES D ANTRAIGUES ASPERJOC',
    'JUVINAS',
    'LABASTIDE SUR BESORGUES',
    'ST ANDEOL DE VALS',
    'VALS LES BAINS',
  ],
  '07310': [
    'ARCENS',
    'BOREE',
    'CHANEAC',
    'ST JULIEN D INTRES',
    'LACHAPELLE SOUS CHANEAC',
    'LA ROCHETTE',
    'ST CLEMENT',
    'ST MARTIAL',
    'ST MARTIN DE VALAMAS',
  ],
  '07290': [
    'ARDOIX',
    'PREAUX',
    'QUINTENAS',
    'ST JEURE D AY',
    'ST ROMAIN D AY',
    'ST SYMPHORIEN DE MAHUN',
    'SATILLIEU',
  ],
  '07410': [
    'ARLEBOSC',
    'BOZAS',
    'COLOMBIER LE VIEUX',
    'PAILHARES',
    'ST FELICIEN',
    'ST VICTOR',
    'VAUDEVANT',
  ],
  '07370': ['ARRAS SUR RHONE', 'ECLASSAN', 'OZON', 'SARRAS'],
  '07140': [
    'LES ASSIONS',
    'CHAMBONAS',
    'GRAVIERES',
    'MALARCE SUR LA THINES',
    'MALBOSC',
    'MONTSELGUES',
    'STE MARGUERITE LAFIGERE',
    'ST PIERRE ST JEAN',
    'LES SALELLES',
    'LES VANS',
  ],
  '07330': ['ASTET', 'BARNAS', 'MAYRES', 'THUEYTS'],
  '07120': [
    'BALAZUC',
    'CHAUZON',
    'GROSPIERRES',
    'LABEAUME',
    'PRADONS',
    'RUOMS',
    'ST ALBAN AURIOLLES',
    'SAMPZON',
  ],
  '07460': [
    'BANNE',
    'BEAULIEU',
    'BERRIAS ET CASTELJAU',
    'ST ANDRE DE CRUZIERES',
    'ST PAUL LE JEUNE',
    'ST SAUVEUR DE CRUZIERES',
  ],
  '07630': ['LE BEAGE', 'CROS DE GEORAND'],
  '07800': [
    'BEAUCHASTEL',
    'CHARMES SUR RHONE',
    'GILHAC ET BRUZAC',
    'ROMPON',
    'ST CIERGE LA SERRE',
    'ST GEORGES LES BAINS',
    'ST LAURENT DU PAPE',
    'LA VOULTE SUR RHONE',
  ],
  '07110': [
    'BEAUMONT',
    'CHASSIERS',
    'CHAZEAUX',
    'JOANNAS',
    'LABOULE',
    'LARGENTIERE',
    'LAURAC EN VIVARAIS',
    'LOUBARESSE',
    'MONTREAL',
    'PRUNET',
    'ROCHER',
    'ROCLES',
    'SANILHAC',
    'TAURIERS',
    'UZER',
    'VALGORGE',
    'VINEZAC',
  ],
  '07580': ['BERZEME', 'ST GINEYS EN COIRON', 'ST JEAN LE CENTENIER', 'ST PONS'],
  '07150': [
    'BESSAS',
    'LABASTIDE DE VIRAC',
    'LAGORCE',
    'ORGNAC L AVEN',
    'SALAVAS',
    'VAGNAS',
    'VALLON PONT D ARC',
  ],
  '07700': [
    'BIDON',
    'BOURG ST ANDEOL',
    'GRAS',
    'ST JUST D ARDECHE',
    'ST MARCEL D ARDECHE',
    'ST MARTIN D ARDECHE',
    'ST REMEZE',
  ],
  '07590': [
    'BORNE',
    'CELLIER DU LUC',
    'LE PLAGNAL',
    'ST ALBAN EN MONTAGNE',
    'ST ETIENNE DE LUGDARES',
    'ST LAURENT BAINS LAVAL D AURELLE',
  ],
  '07270': [
    'BOUCIEU LE ROI',
    'COLOMBIER LE JEUNE',
    'LE CRESTET',
    'EMPURANY',
    'GILHOC SUR ORMEZE',
    'LAMASTRE',
    'NOZIERES',
    'ST BARTHELEMY GROZON',
    'ST BASILE',
    'ST PRIX',
  ],
  '07450': ['BURZET', 'PEREYRES', 'SAGNES ET GOUDOULET', 'ST PIERRE DE COLOMBIER'],
  '07240': [
    'CHALENCON',
    'CHATEAUNEUF DE VERNOUX',
    'ST APOLLINAIRE DE RIAS',
    'ST JEAN CHAMBRE',
    'ST JULIEN LE ROUX',
    'SILHAC',
    'VERNOUX EN VIVARAIS',
  ],
  '07230': [
    'CHANDOLAS',
    'FAUGERES',
    'LABLACHERE',
    'PAYZAC',
    'PLANZOLLES',
    'ST ANDRE LACHAMP',
    'ST GENEST DE BEAUZON',
  ],
  '07130': ['CHATEAUBOURG', 'CORNAS', 'ST PERAY', 'ST ROMAIN DE LERPS', 'SOYONS', 'TOULAUD'],
  '07300': [
    'CHEMINAS',
    'ETABLES',
    'GLUN',
    'MAUVES',
    'PLATS',
    'ST BARTHELEMY LE PLAIN',
    'ST JEAN DE MUZOLS',
    'TOURNON SUR RHONE',
  ],
  '07380': [
    'CHIROLS',
    'FABRAS',
    'JAUJAC',
    'LALEVADE D ARDECHE',
    'MEYRAS',
    'PONT DE LABEAUME',
    'PRADES',
    'ST CIRGUES DE PRADES',
    'LA SOUCHE',
  ],
  '07430': [
    'COLOMBIER LE CARDINAL',
    'DAVEZIEUX',
    'ST CLAIR',
    'ST CYR',
    'SAVAS',
    'VERNOSC LES ANNONAY',
  ],
  '07470': ['COUCOURON', 'ISSARLES', 'LE LAC D ISSARLES', 'LACHAPELLE GRAILLOUSE'],
  '07510': [
    'CROS DE GEORAND',
    'ISSANLAS',
    'MAZAN L ABBAYE',
    'ST CIRGUES EN MONTAGNE',
    'STE EULALIE',
    'USCLADES ET RIEUTORD',
  ],
  '07350': ['CRUAS'],
  '07170': [
    'DARBRES',
    'LAVILLEDIEU',
    'LUSSAS',
    'MIRABEL',
    'ST ANDEOL DE BERG',
    'ST GERMAIN',
    'ST LAURENT SOUS COIRON',
    'ST MAURICE D IBIE',
    'VILLENEUVE DE BERG',
  ],
  '07570': ['DESAIGNES', 'LABATIE D ANDAURE'],
  '07320': [
    'DEVESSET',
    'ST JULIEN D INTRES',
    'MARS',
    'ROCHEPAULE',
    'ST AGREVE',
    'ST JEURE D ANDAURE',
  ],
  '07260': ['DOMPNAC', 'JOYEUSE', 'RIBES', 'ROSIERES', 'SABLIERES', 'ST MELANY', 'VERNON'],
  '07360': [
    'DUNIERE SUR EYRIEUX',
    'LES OLLIERES SUR EYRIEUX',
    'ST FORTUNAT SUR EYRIEUX',
    'ST MICHEL DE CHABRILLANOUX',
    'ST VINCENT DE DURFORT',
  ],
  '07500': ['GUILHERAND GRANGES'],
  '07660': ['ISSANLAS', 'LANARCE', 'LAVILLATTE', 'LESPERON'],
  '07520': ['LAFARRE', 'LALOUVESC', 'ST PIERRE SUR DOUX'],
  '07220': ['LARNAS', 'ST MONTAN', 'ST THOME', 'VIVIERS'],
  48250: ['LAVEYRUNE', 'LA BASTIDE PUYLAURENT', 'MONT LOZERE ET GOULET', 'LUC'],
  '07610': ['LEMPS', 'SECHERAS', 'VION'],
  '07690': [
    'MONESTIER',
    'ST ANDRE EN VIVARAIS',
    'ST JULIEN VOCANCE',
    'VANOSC',
    'VILLEVOCANCE',
    'VOCANCE',
  ],
  '07560': ['MONTPEZAT SOUS BAUZON', 'LE ROUX'],
  '07250': ['LE POUZIN', 'ROMPON'],
  '07790': ['ST ALBAN D AY'],
  '08300': [
    'ACY ROMANCE',
    'AMAGNE',
    'ARNICOURT',
    'AVANCON',
    'BARBY',
    'BERGNICOURT',
    'BERTONCOURT',
    'BIERMES',
    'LE CHATELET SUR RETOURNE',
    'COUCY',
    'DOUX',
    'L ECAILLE',
    'ECLY',
    'HAUTEVILLE',
    'INAUMONT',
    'LUCQUY',
    'NANTEUIL SUR AISNE',
    'NEUFLIZE',
    'NOVY CHEVRIERES',
    'PERTHES',
    'RETHEL',
    'ST LOUP EN CHAMPAGNE',
    'ST REMY LE PETIT',
    'SAULT LES RETHEL',
    'SEUIL',
    'SON',
    'SORBON',
    'TAGNON',
    'THUGNY TRUGNY',
  ],
  '08090': [
    'AIGLEMONT',
    'ARREUX',
    'BELVAL',
    'CLIRON',
    'DAMOUZY',
    'EVIGNY',
    'FAGNON',
    'HAM LES MOINES',
    'HAUDRECY',
    'HOULDIZY',
    'MONTCORNET',
    'MONTCY NOTRE DAME',
    'NEUVILLE LES THIS',
    'ST LAURENT',
    'SURY',
    'THIS',
    'TOURNES',
    'WARNECOURT',
  ],
  '08190': [
    'AIRE',
    'ASFELD',
    'AVAUX',
    'BALHAM',
    'BLANZY LA SALONNAISE',
    'BRIENNE SUR AISNE',
    'GOMONT',
    'HOUDILCOURT',
    'POILCOURT SYDNEY',
    'ROIZY',
    'ST GERMAINMONT',
    'SAULT ST REMY',
    'LE THOUR',
    'VIEUX LES ASFELD',
    'VILLERS DEVANT LE THOUR',
  ],
  '08310': [
    'ALINCOURT',
    'ANNELLES',
    'AUSSONCE',
    'BIGNICOURT',
    'CAUROY',
    'DRICOURT',
    'HAUVINE',
    'JUNIVILLE',
    'LEFFINCOURT',
    'MACHAULT',
    'MENIL ANNELLES',
    'MENIL LEPINOIS',
    'MONT ST REMY',
    'LA NEUVILLE EN TOURNE A FUY',
    'PAUVRES',
    'ST CLEMENT A ARNES',
    'ST ETIENNE A ARNES',
    'ST PIERRE A ARNES',
    'VILLE SUR RETOURNE',
  ],
  '08130': [
    'ALLAND HUY ET SAUSSEUIL',
    'AMBLY FLEURY',
    'ATTIGNY',
    'CHARBOGNE',
    'CHUFFILLY ROCHE',
    'COULOMMES ET MARQUENY',
    'ECORDAL',
    'GIVRY',
    'GUINCOURT',
    'JONVAL',
    'LAMETZ',
    'MONT LAURENT',
    'NEUVILLE DAY',
    'RILLY SUR AISNE',
    'LA SABOTTERIE',
    'ST LAMBERT ET MONT DE JEUX',
    'ST LOUP TERRIER',
    'STE VAUBOURG',
    'SAULCES CHAMPENOISES',
    'SEMUY',
    'SUZANNE',
    'TOURTERON',
    'VAUX CHAMPAGNE',
  ],
  '08500': ['ANCHAMPS', 'LES MAZURES', 'REVIN'],
  '08450': [
    'ANGECOURT',
    'LA BESACE',
    'BULSON',
    'CHEMERY CHEHERY',
    'HARAUCOURT',
    'MAISONCELLE ET VILLERS',
    'LA NEUVILLE A MAIRE',
    'OMICOURT',
    'RAUCOURT ET FLABA',
    'REMILLY AILLICOURT',
  ],
  '08260': [
    'ANTHENY',
    'AUVILLERS LES FORGES',
    'BLOMBAY',
    'CERNION',
    'CHAMPLIN',
    'CHILLY',
    'ESTREBAY',
    'ETALLE',
    'ETEIGNIERES',
    'FLAIGNES HAVYS',
    'GIRONDELLE',
    'MARBY',
    'MAUBERT FONTAINE',
  ],
  '08290': [
    'AOUSTE',
    'BLANCHEFOSSE ET BAY',
    'BOSSUS LES RUMIGNY',
    'LA FEREE',
    'LE FRETY',
    'HANNAPPES',
    'LIART',
    'MARLEMONT',
    'PREZ',
    'RUMIGNY',
  ],
  '08250': [
    'APREMONT',
    'AUTRY',
    'BEFFU ET LE MORTHOMME',
    'BOUCONVILLE',
    'CHAMPIGNEULLE',
    'CHATEL CHEHERY',
    'CHEVIERES',
    'CONDE LES AUTRY',
    'CORNAY',
    'EXERMONT',
    'FLEVILLE',
    'GRANDHAM',
    'GRANDPRE',
    'LANCON',
    'MARCQ',
    'MONTCHEUTIN',
    'MOURON',
    'OLIZY PRIMAT',
    'ST JUVIN',
    'SECHAULT',
    'SENUC',
    'SOMMERANCE',
    'VAUX LES MOURON',
  ],
  '08400': [
    'ARDEUIL ET MONTFAUXELLES',
    'AURE',
    'BALLAY',
    'BOURCQ',
    'BRECY BRIERES',
    'CHALLERANGE',
    'CHARDENY',
    'BAIRON ET SES ENVIRONS',
    'CONTREUVE',
    'LA CROIX AUX BOIS',
    'FALAISE',
    'GRIVY LOISY',
    'LIRY',
    'LONGWE',
    'MANRE',
    'MARS SOUS BOURCQ',
    'MARVAUX VIEUX',
    'MONTHOIS',
    'MONT ST MARTIN',
    'NOIRVAL',
    'QUATRE CHAMPS',
    'QUILLY',
    'STE MARIE',
    'ST MOREL',
    'SAVIGNY SUR AISNE',
    'SEMIDE',
    'SUGNY',
    'TOGES',
    'TOURCELLES CHAUMONT',
    'VANDY',
    'VONCQ',
    'VOUZIERS',
  ],
  '08390': [
    'LES GRANDES ARMOISES',
    'LES PETITES ARMOISES',
    'ARTAISE LE VIVIER',
    'BAIRON ET SES ENVIRONS',
    'MARQUIGNY',
    'LE MONT DIEU',
    'MONTGON',
    'SAUVILLE',
    'STONNE',
    'SY',
    'TANNAY',
    'VERRIERES',
  ],
  '08150': [
    'AUBIGNY LES POTHEES',
    'LE CHATELET SUR SORMONNE',
    'L ECHELLE',
    'HARCY',
    'LAVAL MORENCY',
    'LEPRON LES VALLEES',
    'LOGNY BOGNY',
    'LONNY',
    'MURTIN ET BOGNY',
    'REMILLY LES POTHEES',
    'RENWEZ',
    'RIMOGNE',
    'ROUVROY SUR AUDRY',
    'SECHEVAL',
    'SORMONNE',
    'TREMBLOIS LES ROCROI',
    'VAUX VILLAINE',
  ],
  '08270': [
    'AUBONCOURT VAUZELLES',
    'CHESNOIS AUBONCOURT',
    'CORNY MACHEROMENIL',
    'FAISSAULT',
    'FAUX',
    'GRANDCHAMP',
    'JUSTINE HERBIGNY',
    'MESMONT',
    'LA NEUVILLE LES WASIGNY',
    'NOVION PORCIEN',
    'PUISEUX',
    'SAULCES MONCLIN',
    'SERY',
    'SORCY BAUTHEMONT',
    'VAUX MONTREUIL',
    'VIEL ST REMY',
    'WAGNON',
    'WASIGNY',
    'WIGNICOURT',
  ],
  '08320': ['AUBRIVES', 'HIERGES', 'VIREUX MOLHAIN', 'VIREUX WALLERAND'],
  '08370': [
    'AUFLANCE',
    'BIEVRES',
    'LA FERTE SUR CHIERS',
    'FROMY',
    'HERBEUVAL',
    'MALANDRY',
    'MARGNY',
    'MARGUT',
    'MOIRY',
    'PUILLY ET CHARBEAUX',
    'SAPOGNE SUR MARCHE',
    'SIGNY MONTLIBERT',
    'VILLY',
  ],
  '08380': [
    'AUGE',
    'BROGNON',
    'FLIGNY',
    'LA NEUVILLE AUX JOUTES',
    'NEUVILLE LEZ BEAULIEU',
    'SIGNY LE PETIT',
    'TARZY',
  ],
  '08240': [
    'AUTHE',
    'AUTRUCHE',
    'BAR LES BUZANCY',
    'BAYONVILLE',
    'BELLEVILLE ET CHATILLON SUR BAR',
    'BELVAL BOIS DES DAMES',
    'LA BERLIERE',
    'BOULT AUX BOIS',
    'BRIEULLES SUR BAR',
    'BRIQUENAY',
    'BUZANCY',
    'FOSSE',
    'GERMONT',
    'HARRICOURT',
    'IMECOURT',
    'LANDRES ET ST GEORGES',
    'NOUART',
    'OCHES',
    'ST PIERREMONT',
    'SOMMAUTHE',
    'TAILLY',
    'THENORGUES',
    'VAUX EN DIEULET',
    'VERPEL',
  ],
  '08210': [
    'AUTRECOURT ET POURRON',
    'BEAUMONT EN ARGONNE',
    'EUILLY ET LOMBUT',
    'LETANNE',
    'MOUZON',
    'VAUX LES MOUZON',
    'VILLERS DEVANT MOUZON',
    'YONCQ',
  ],
  '08000': [
    'LES AYVELLES',
    'CHARLEVILLE MEZIERES',
    'LA FRANCHEVILLE',
    'PRIX LES MEZIERES',
    'VILLERS SEMEUSE',
    'WARCQ',
  ],
  '08430': [
    'BAALONS',
    'BARBAISE',
    'BOUVELLEMONT',
    'CHAGNY',
    'CHAMPIGNEUL SUR VENCE',
    'GRUYERES',
    'GUIGNICOURT SUR VENCE',
    'HAGNICOURT',
    'LA HORGNE',
    'JANDUN',
    'LAUNOIS SUR VENCE',
    'MAZERNY',
    'MONDIGNY',
    'MONTIGNY SUR VENCE',
    'NEUVIZY',
    'OMONT',
    'POIX TERRON',
    'RAILLICOURT',
    'ST PIERRE SUR VENCE',
    'SINGLY',
    'TOULIGNY',
    'VILLERS LE TILLEUL',
    'VILLERS LE TOURNEUR',
    'VILLERS SUR LE MONT',
    'YVERNAUMONT',
  ],
  '08200': [
    'BALAN',
    'LA CHAPELLE',
    'FLEIGNEUX',
    'FLOING',
    'GIVONNE',
    'GLAIRE',
    'ILLY',
    'ST MENGES',
    'SEDAN',
    'WADELINCOURT',
  ],
  '08220': [
    'BANOGNE RECOUVRANCE',
    'CHAPPES',
    'CHAUMONT PORCIEN',
    'DOUMELY BEGNY',
    'DRAIZE',
    'FRAILLICOURT',
    'GIVRON',
    'HANNOGNE ST REMY',
    'MONTMEILLANT',
    'REMAUCOURT',
    'RENNEVILLE',
    'ROCQUIGNY',
    'LA ROMAGNE',
    'RUBIGNY',
    'ST JEAN AUX BOIS',
    'ST QUENTIN LE PETIT',
    'SERAINCOURT',
    'SEVIGNY WALEPPE',
    'VAUX LES RUBIGNY',
  ],
  '08140': [
    'BAZEILLES',
    'BREVILLY',
    'DAIGNY',
    'DOUZY',
    'FRANCHEVAL',
    'POURU AUX BOIS',
    'POURU ST REMY',
  ],
  '08110': [
    'BLAGNY',
    'CARIGNAN',
    'LES DEUX VILLES',
    'ESCOMBRES ET LE CHESNOIS',
    'LINAY',
    'MATTON ET CLEMENCY',
    'MESSINCOURT',
    'MOGUES',
    'OSNES',
    'PURE',
    'SACHY',
    'SAILLY',
    'TETAIGNE',
    'TREMBLOIS LES CARIGNAN',
    'WILLIERS',
  ],
  '08410': ['BOULZICOURT'],
  '08230': ['BOURG FIDELE', 'GUE D HOSSUS', 'REGNIOWEZ', 'ROCROI', 'SEVIGNY LA FORET', 'TAILLETTE'],
  '08120': ['BOGNY SUR MEUSE'],
  '08160': [
    'CHALANDRY ELAIRE',
    'DOM LE MESNIL',
    'ETREPIGNY',
    'FLIZE',
    'HANNOGNE ST MARTIN',
    'NOUVION SUR MEUSE',
    'ST MARCEAU',
    'SAPOGNE ET FEUCHERES',
    'VENDRESSE',
  ],
  '08600': [
    'CHARNOIS',
    'CHOOZ',
    'FOISCHES',
    'FROMELENNES',
    'GIVET',
    'HAM SUR MEUSE',
    'LANDRICHAMPS',
    'RANCENNES',
  ],
  '08360': ['CHATEAU PORCIEN', 'CONDE LES HERPY', 'HERPY L ARLESIENNE', 'ST FERGEUX', 'TAIZY'],
  '08350': [
    'CHEMERY CHEHERY',
    'CHEVEUGES',
    'DONCHERY',
    'NOYERS PONT MAUGIS',
    'ST AIGNAN',
    'THELONNE',
    'VILLERS SUR BAR',
    'VRIGNE AUX BOIS',
    'VRIGNE MEUSE',
  ],
  '08460': [
    'CLAVY WARBY',
    'DOMMERY',
    'LALOBBE',
    'MARANWEZ',
    'NEUFMAISON',
    'ST MARCEL',
    'SIGNY L ABBAYE',
    'THIN LE MOUTIER',
  ],
  '08800': [
    'DEVILLE',
    'HAULME',
    'LES HAUTES RIVIERES',
    'LAIFOUR',
    'MONTHERME',
    'THILAY',
    'TOURNAVAUX',
  ],
  '08170': ['FEPIN', 'FUMAY', 'HARGNIES', 'HAYBES', 'MONTIGNY SUR MEUSE'],
  '08440': ['GERNELLE', 'ISSANCOURT ET RUMEL', 'LUMES', 'VILLE SUR LUMES', 'VIVIER AU COURT'],
  '08700': ['GESPUNSART', 'LA GRANDVILLE', 'JOIGNY SUR MEUSE', 'NEUFMANIL', 'NOUZONVILLE'],
  '08330': ['VRIGNE AUX BOIS'],
  '09240': [
    'AIGUES JUNTES',
    'ALLIERES',
    'ALZEN',
    'LA BASTIDE DE SEROU',
    'CADARCET',
    'DURBAN SUR ARIZE',
    'LARBONT',
    'MONTAGAGNE',
    'MONTELS',
    'MONTSERON',
    'NESCUS',
    'SENTENAC DE SEROU',
    'SUZAN',
  ],
  '09600': [
    'AIGUES VIVES',
    'LA BASTIDE SUR L HERS',
    'BELLOC',
    'DUN',
    'ESCLAGNE',
    'LAROQUE D OLMES',
    'LERAN',
    'LIMBRASSAC',
    'MONTBEL',
    'LE PEYRAT',
    'PRADETTES',
    'REGAT',
    'TABRE',
  ],
  '09300': [
    'L AIGUILLON',
    'BELESTA',
    'BENAIX',
    'CARLA DE ROQUEFORT',
    'DREUILHE',
    'FOUGAX ET BARRINEUF',
    'FREYCHENET',
    'ILHAT',
    'LAVELANET',
    'LESPARROU',
    'LEYCHERT',
    'LIEURAC',
    'MONTFERRIER',
    'MONTSEGUR',
    'NALZEN',
    'PEREILLE',
    'RAISSAC',
    'ROQUEFIXADE',
    'ROQUEFORT LES CASCADES',
    'ST JEAN D AIGUES VIVES',
    'SAUTEL',
    'VILLENEUVE D OLMES',
  ],
  '09310': [
    'ALBIES',
    'ASTON',
    'BOUAN',
    'LES CABANNES',
    'CHATEAU VERDUN',
    'LARCAT',
    'LARNAT',
    'LASSUR',
    'PECH',
    'AULOS SINSAT',
    'URS',
    'VEBRE',
    'VERDUN',
  ],
  '09320': ['ALEU', 'BIERT', 'BOUSSENAC', 'MASSAT', 'LE PORT', 'SOULAN'],
  '09400': [
    'ALLIAT',
    'ARIGNAC',
    'ARNAVE',
    'BEDEILHAC ET AYNAT',
    'BOMPAS',
    'CAPOULET ET JUNAC',
    'CAZENAVE SERRES ET ALLENS',
    'GENAT',
    'GOURBIT',
    'LAPEGE',
    'MERCUS GARRABET',
    'MIGLOS',
    'NIAUX',
    'ORNOLAC USSAT LES BAINS',
    'QUIE',
    'RABAT LES TROIS SEIGNEURS',
    'SAURAT',
    'SURBA',
    'TARASCON SUR ARIEGE',
    'USSAT',
  ],
  '09200': [
    'ALOS',
    'ENCOURTIECH',
    'ERP',
    'EYCHEIL',
    'LACOURT',
    'MONTEGUT EN COUSERANS',
    'MONTESQUIEU AVANTES',
    'MONTJOIE EN COUSERANS',
    'MOULIS',
    'RIVERENERT',
    'ST GIRONS',
  ],
  '09800': [
    'ANTRAS',
    'ARGEIN',
    'ARRIEN EN BETHMALE',
    'ARROUT',
    'AUCAZEIN',
    'AUDRESSEIN',
    'AUGIREIN',
    'BALACET',
    'BALAGUERES',
    'BETHMALE',
    'BONAC IRAZEIN',
    'BORDES UCHENTEIN',
    'BUZAN',
    'CASTILLON EN COUSERANS',
    'CESCAU',
    'ENGOMER',
    'GALEY',
    'ILLARTEIN',
    'ORGIBET',
    'ST JEAN DU CASTILLONNAIS',
    'ST LARY',
    'SALSEIN',
    'SENTEIN',
    'SOR',
    'VILLENEUVE',
  ],
  '09250': [
    'APPY',
    'AXIAT',
    'BESTIAC',
    'CAUSSOU',
    'CAYCHAX',
    'GARANOU',
    'LORDAT',
    'LUZENAC',
    'SENCONAC',
    'UNAC',
    'VERNAUX',
  ],
  '09000': [
    'ARABAUX',
    'BAULOU',
    'BENAC',
    'LE BOSC',
    'BRASSAC',
    'BURRET',
    'CELLES',
    'COS',
    'FERRIERES SUR ARIEGE',
    'FOIX',
    'GANAC',
    'L HERM',
    'LOUBIERES',
    'MONTOULIEU',
    'PRADIERES',
    'PRAYOLS',
    'ST JEAN DE VERGES',
    'ST MARTIN DE CARALP',
    'ST PAUL DE JARRAT',
    'ST PIERRE DE RIVIERE',
    'SERRES SUR ARGET',
    'SOULA',
    'VERNAJOUL',
  ],
  '09130': [
    'ARTIGAT',
    'CARLA BAYLE',
    'CASTERAS',
    'DURFORT',
    'LE FOSSAT',
    'LANOUX',
    'MONESPLE',
    'PAILHES',
    'SIEURAS',
    'VILLENEUVE DU LATOU',
    'STE SUZANNE',
  ],
  '09460': ['ARTIGUES', 'CARCANIERES', 'MIJANES', 'LE PLA', 'LE PUCH', 'QUERIGUT', 'ROUZE'],
  '09120': [
    'ARTIX',
    'CALZAN',
    'CAZAUX',
    'COUSSA',
    'CRAMPAGNA',
    'DALOU',
    'GUDAS',
    'LOUBENS',
    'MALLEON',
    'MONTEGUT PLANTAUREL',
    'RIEUX DE PELLEPORT',
    'ST BAUZEIL',
    'ST FELIX DE RIEUTORD',
    'SEGURA',
    'VARILHES',
    'VENTENAC',
    'VIRA',
  ],
  '09100': [
    'ARVIGNA',
    'BENAGUES',
    'BEZAC',
    'BONNAC',
    'LE CARLARET',
    'ESCOSSE',
    'LES ISSARDS',
    'LESCOUSSE',
    'LUDIES',
    'MADIERE',
    'PAMIERS',
    'LES PUJOLS',
    'ST AMADOU',
    'ST JEAN DU FALGA',
    'ST MARTIN D OYDES',
    'ST MICHEL',
    'ST VICTOR ROUZAUD',
    'LA TOUR DU CRIEU',
    'UNZENT',
    'VILLENEUVE DU PAREAGE',
  ],
  '09110': [
    'ASCOU',
    'AX LES THERMES',
    'IGNAUX',
    'MERENS LES VALS',
    'MONTAILLOU',
    'ORGEIX',
    'ORLU',
    'PERLES ET CASTELET',
    'PRADES',
    'SAVIGNAC LES ORMEAUX',
    'SORGEAT',
    'TIGNAC',
    'VAYCHIS',
  ],
  '09140': [
    'AULUS LES BAINS',
    'COUFLENS',
    'ERCE',
    'OUST',
    'SEIX',
    'SENTENAC D OUST',
    'SOUEIX ROGALLE',
    'USTOU',
  ],
  '09220': ['AUZAT', 'GESTIES', 'ILLIER ET LARAMADE', 'LERCOUL', 'ORUS', 'SIGUER', 'VAL DE SOS'],
  '09230': [
    'BAGERT',
    'BARJAC',
    'BEDEILLE',
    'CERIZOLS',
    'CONTRAZY',
    'FABAS',
    'LASSERRE',
    'MAUVEZIN DE STE CROIX',
    'MERIGON',
    'MONTARDIT',
    'STE CROIX VOLVESTRE',
    'TOURTOUSE',
  ],
  '09350': [
    'LA BASTIDE DE BESPLAS',
    'LES BORDES SUR ARIZE',
    'CAMPAGNE SUR ARIZE',
    'CASTEX',
    'DAUMAZAN SUR ARIZE',
    'FORNEX',
    'LOUBAUT',
    'MERAS',
    'MONTFA',
    'SABARAT',
    'THOUARS SUR ARIZE',
  ],
  '09500': [
    'LA BASTIDE DE BOUSIGNAC',
    'BESSET',
    'CAMON',
    'CAZALS DES BAYLES',
    'COUTENS',
    'LAGARDE',
    'LAPENNE',
    'MALEGOUDE',
    'MANSES',
    'MIREPOIX',
    'MOULIN NEUF',
    'RIEUCROS',
    'ROUMENGOUX',
    'ST FELIX DE TOURNEGAT',
    'STE FOI',
    'ST JULIEN DE GRAS CAPOU',
    'ST QUENTIN LA TOUR',
    'TEILHET',
    'TOURTROL',
    'TROYE D ARIEGE',
    'VALS',
    'VIVIES',
  ],
  '09700': [
    'LA BASTIDE DE LORDAT',
    'BRIE',
    'CANTE',
    'ESPLAS',
    'GAUDIES',
    'JUSTINIAC',
    'LABATUT',
    'LISSAC',
    'MONTAUT',
    'ST QUIRC',
    'SAVERDUN',
    'TREMOULET',
    'LE VERNET',
  ],
  '09160': [
    'LA BASTIDE DU SALAT',
    'BETCHAT',
    'CAUMONT',
    'CAZAVET',
    'LACAVE',
    'MAUVEZIN DE PRAT',
    'MERCENAC',
    'MONTGAUCH',
    'PRAT BONREPAUX',
    'TAURIGNAN CASTET',
  ],
  '09290': ['CAMARADE', 'GABRE', 'LE MAS D AZIL'],
  '09420': ['CASTELNAU DURBAN', 'CLERMONT', 'ESPLAS DE SEROU', 'LESCURE', 'RIMONT'],
  '09190': ['GAJAN', 'ST LIZIER', 'LORP SENTARAILLE', 'TAURIGNAN VIEUX'],
  '09390': ['L HOSPITALET PRES L ANDORRE'],
  '09210': ['LEZAT SUR LEZE', 'ST YBARS'],
  '09270': ['MAZERES'],
  '09330': ['MONTGAILHARD'],
  '09340': ['VERNIOLLE'],
  10200: [
    'AILLEVILLE',
    'ARCONVILLE',
    'ARRENTIERES',
    'ARSONVAL',
    'BAROVILLE',
    'BAR SUR AUBE',
    'BERGERES',
    'BLIGNY',
    'CHAMPIGNOL LEZ MONDEVILLE',
    'COLOMBE LA FOSSE',
    'COLOMBE LE SEC',
    'COUVIGNON',
    'DOLANCOURT',
    'ECLANCE',
    'ENGENTE',
    'FONTAINE',
    'FRAVAUX',
    'FRESNAY',
    'FULIGNY',
    'JAUCOURT',
    'LEVIGNY',
    'LIGNOL LE CHATEAU',
    'MAISONS LES SOULAINES',
    'MEURVILLE',
    'MONTIER EN L ISLE',
    'PROVERVILLE',
    'ROUVRES LES VIGNES',
    'SAULCY',
    'SOULAINES DHUYS',
    'SPOY',
    'THIL',
    'THORS',
    'URVILLE',
    'VERNONVILLIERS',
    'VILLE SUR TERRE',
    'VOIGNY',
  ],
  10160: [
    'AIX VILLEMAUR PALIS',
    'BERULLE',
    'MARAYE EN OTHE',
    'NOGENT EN OTHE',
    'PAISY COSDON',
    'PLANTY',
    'RIGNY LE FERRON',
    'ST BENOIST SUR VANNE',
    'ST MARDS EN OTHE',
    'VILLEMOIRON EN OTHE',
    'VULAINES',
  ],
  10190: [
    'AIX VILLEMAUR PALIS',
    'BERCENAY EN OTHE',
    'BUCEY EN OTHE',
    'CHENNEGY',
    'DIERREY ST JULIEN',
    'DIERREY ST PIERRE',
    'ESTISSAC',
    'FONTVANNES',
    'MESNIL ST LOUP',
    'MESSON',
    'NEUVILLE SUR VANNE',
    'PRUGNY',
    'VAUCHASSIS',
  ],
  10700: [
    'ALLIBAUDIERES',
    'ARCIS SUR AUBE',
    'CHAMPFLEURY',
    'CHAMPIGNY SUR AUBE',
    'CHAPELLE VALLON',
    'LE CHENE',
    'DOSNON',
    'GRANDVILLE',
    'HERBISSE',
    'LHUITRE',
    'MESNIL LA COMTESSE',
    'NOZAY',
    'ORMES',
    'ORTILLON',
    'POIVRES',
    'POUAN LES VALLEES',
    'ST ETIENNE SOUS BARBUISE',
    'ST NABORD SUR AUBE',
    'ST REMY SOUS BARBUISE',
    'SALON',
    'SEMOINE',
    'TORCY LE GRAND',
    'TORCY LE PETIT',
    'TROUANS',
    'VAUPOISSON',
    'VILLETTE SUR AUBE',
    'VILLIERS HERBISSE',
    'VINETS',
  ],
  10140: [
    'AMANCE',
    'ARGANCON',
    'BEUREY',
    'BOSSANCOURT',
    'BRIEL SUR BARSE',
    'CHAMP SUR BARSE',
    'JESSAINS',
    'JUVANZE',
    'LA LOGE AUX CHEVRES',
    'LONGPRE LE SEC',
    'MAGNY FOUCHARD',
    'MAISON DES CHAMPS',
    'MESNIL ST PERE',
    'MONTMARTIN LE HAUT',
    'PUITS ET NUISEMENT',
    'THIEFFRAIN',
    'TRANNES',
    'UNIENVILLE',
    'VAUCHONVILLIERS',
    'VENDEUVRE SUR BARSE',
    'LA VILLENEUVE AU CHENE',
    'VILLY EN TRODES',
  ],
  10340: [
    'ARRELLES',
    'AVIREY LINGEY',
    'BAGNEUX LA FOSSE',
    'BRAGELOGNE BEAUVOIR',
    'CHANNES',
    'LES RICEYS',
  ],
  10330: [
    'ARREMBECOURT',
    'BAILLY LE FRANC',
    'BALIGNICOURT',
    'CHAVANGES',
    'DONNEMENT',
    'JASSEINES',
    'JONCREUIL',
    'LENTILLES',
    'MONTMORENCY BEAUFORT',
    'PARS LES CHAVANGES',
    'ST LEGER SOUS MARGERIE',
    'VILLERET',
  ],
  10320: [
    'ASSENAY',
    'BOUILLY',
    'CRESANTIGNES',
    'FAYS LA CHAPELLE',
    'JAVERNANT',
    'JEUGNY',
    'LIREY',
    'LONGEVILLE SUR MOGNE',
    'MACHY',
    'MAUPAS',
    'RONCENAY',
    'ST JEAN DE BONNEVAL',
    'SOMMEVAL',
    'SOULIGNY',
    'VILLERY',
  ],
  10220: [
    'ASSENCIERES',
    'VAL D AUZON',
    'BOUY LUXEMBOURG',
    'BREVONNES',
    'DOSCHES',
    'GERAUDOT',
    'MESNIL SELLIERES',
    'ONJON',
    'PINEY',
    'ROUILLY SACEY',
  ],
  10150: [
    'AUBETERRE',
    'CHARMONT SOUS BARBUISE',
    'CRENEY PRES TROYES',
    'FEUGES',
    'LAVAU',
    'LUYERES',
    'MONTSUZAIN',
    'PONT STE MARIE',
    'STE MAURE',
    'VAILLY',
    'VOUE',
  ],
  10240: [
    'AULNAY',
    'AVANT LES RAMERUPT',
    'BRILLECOURT',
    'CHAUDREY',
    'COCLOIS',
    'DAMPIERRE',
    'DOMMARTIN LE COQ',
    'ISLE AUBIGNY',
    'LONGSOLS',
    'MAGNICOURT',
    'MESNIL LETTRE',
    'MOREMBERT',
    'NOGENT SUR AUBE',
    'POUGY',
    'RAMERUPT',
    'VAUCOGNE',
    'VERRICOURT',
  ],
  10130: [
    'AUXON',
    'AVREUIL',
    'BERNON',
    'CHAMOY',
    'CHESSY LES PRES',
    'COURSAN EN OTHE',
    'COURTAOULT',
    'LES CROUTES',
    'DAVREY',
    'EAUX PUISEAUX',
    'ERVY LE CHATEL',
    'LIGNIERES',
    'MAROLLES SOUS LIGNIERES',
    'MONTFEY',
    'MONTIGNY LES MONTS',
    'RACINES',
    'ST PHAL',
    'VILLENEUVE AU CHEMIN',
    'VOSNON',
  ],
  10400: [
    'AVANT LES MARCILLY',
    'BARBUISE',
    'BOUY SUR ORVIN',
    'COURCEROY',
    'FERREUX QUINCEY',
    'FONTAINE MACON',
    'FONTENAY DE BOSSERY',
    'GUMERY',
    'LA LOUPTIERE THENARD',
    'MARNAY SUR SEINE',
    'LE MERIOT',
    'MONTPOTHIER',
    'LA MOTTE TILLY',
    'NOGENT SUR SEINE',
    'PERIGNY LA ROSE',
    'PLESSIS BARBUISE',
    'PONT SUR SEINE',
    'ST AUBIN',
    'ST NICOLAS LA CHAPELLE',
    'LA SAULSOTTE',
    'SOLIGNY LES ETANGS',
    'TRAINEL',
    'LA VILLENEUVE AU CHATELOT',
  ],
  10290: [
    'AVON LA PEZE',
    'BERCENAY LE HAYER',
    'BOURDENAY',
    'CHARMOY',
    'FAUX VILLECERF',
    'FAY LES MARCILLY',
    'MARCILLY LE HAYER',
    'POUY SUR VANNES',
    'RIGNY LA NONNEUSE',
    'TRANCAULT',
    'VILLADIN',
  ],
  10210: [
    'BALNOT LA GRANGE',
    'CHAOURCE',
    'CHASEREY',
    'CHESLEY',
    'COUSSEGREY',
    'CUSSANGY',
    'ETOURVY',
    'LES GRANGES',
    'LAGESSE',
    'LANTAGES',
    'LA LOGE POMBLIN',
    'LES LOGES MARGUERON',
    'MAISONS LES CHAOURCE',
    'METZ ROBERT',
    'PARGUES',
    'PRASLIN',
    'PRUSY',
    'TURGY',
    'VALLIERES',
    'VANLAY',
    'VILLIERS LE BOIS',
    'VILLIERS SOUS PRASLIN',
    'VOUGREY',
  ],
  10110: [
    'BALNOT SUR LAIGNES',
    'BAR SUR SEINE',
    'BERTIGNOLLES',
    'BOURGUIGNONS',
    'BUXEUIL',
    'BUXIERES SUR ARCE',
    'CELLES SUR OURCE',
    'CHACENAY',
    'CHAUFFOUR LES BAILLY',
    'CHERVEY',
    'EGUILLY SOUS BOIS',
    'FRALIGNES',
    'LANDREVILLE',
    'LOCHES SUR OURCE',
    'MAGNANT',
    'MAROLLES LES BAILLY',
    'MERREY SUR ARCE',
    'POLIGNY',
    'POLISOT',
    'POLISY',
    'VILLEMORIEN',
    'VILLE SUR ARCE',
    'VITRY LE CROISE',
    'VIVIERS SUR ARTAUT',
  ],
  10600: ['BARBEREY ST SULPICE', 'LA CHAPELLE ST LUC', 'MERGEY', 'PAYNS', 'SAVIERES', 'VILLACERF'],
  10310: ['BAYEL', 'JUVANCOURT', 'LONGCHAMP SUR AUJON', 'VILLE SOUS LA FERTE'],
  10170: [
    'BESSY',
    'CHAUCHIGNY',
    'DROUPT ST BASLE',
    'DROUPT STE MARIE',
    'ETRELLES SUR AUBE',
    'LES GRANDES CHAPELLES',
    'LONGUEVILLE SUR AUBE',
    'MERY SUR SEINE',
    'MESGRIGNY',
    'ORVILLIERS ST JULIEN',
    'PREMIERFAIT',
    'RHEGES',
    'ST OULPH',
    'VALLANT ST GEORGES',
  ],
  10500: [
    'BETIGNICOURT',
    'BLAINCOURT SUR AUBE',
    'BLIGNICOURT',
    'BRAUX',
    'BRIENNE LA VIEILLE',
    'BRIENNE LE CHATEAU',
    'LA CHAISE',
    'CHALETTE SUR VOIRE',
    'CHAUMESNIL',
    'COURCELLES SUR VOIRE',
    'CRESPY LE NEUF',
    'DIENVILLE',
    'EPAGNE',
    'EPOTHEMONT',
    'HAMPIGNY',
    'JUZANVIGNY',
    'LASSICOURT',
    'LESMONT',
    'MAIZIERES LES BRIENNE',
    'MATHAUX',
    'MOLINS SUR AUBE',
    'MORVILLIERS',
    'PEL ET DER',
    'PERTHES LES BRIENNE',
    'PETIT MESNIL',
    'PRECY NOTRE DAME',
    'PRECY ST MARTIN',
    'RADONVILLIERS',
    'RANCES',
    'ROSNAY L HOPITAL',
    'LA ROTHIERE',
    'ST CHRISTOPHE DODINICOURT',
    'ST LEGER SOUS BRIENNE',
    'VALLENTIGNY',
    'LA VILLE AUX BOIS',
    'YEVRES LE PETIT',
  ],
  10800: [
    'LES BORDES AUMONT',
    'BUCHERES',
    'CORMOST',
    'ISLE AUMONT',
    'MOUSSEY',
    'ROUILLY ST LOUP',
    'ST JULIEN LES VILLAS',
    'ST LEGER PRES TROYES',
    'ST THIBAULT',
    'LA VENDUE MIGNOT',
    'VILLEMEREUIL',
    'VILLY LE BOIS',
    'VILLY LE MARECHAL',
  ],
  10380: ['BOULAGES', 'CHARNY LE BACHOT', 'PLANCY L ABBAYE', 'VIAPRES LE PETIT'],
  10270: [
    'BOURANTON',
    'COURTERANGES',
    'FRESNOY LE CHATEAU',
    'LAUBRESSEL',
    'LUSIGNY SUR BARSE',
    'MONTAULIN',
    'MONTIERAMEY',
    'MONTREUIL SUR BARSE',
  ],
  10450: ['BREVIANDES'],
  10260: [
    'CHAPPES',
    'COURTENOT',
    'FOUCHERES',
    'JULLY SUR SARCE',
    'MONTCEAUX LES VAUDES',
    'RUMILLY LES VAUDES',
    'ST PARRES LES VAUDES',
    'VAUDES',
    'VILLEMOYENNE',
    'VIREY SOUS BAR',
  ],
  10510: ['CHATRES', 'MAIZIERES LA GRANDE PAROISSE', 'ORIGNY LE SEC'],
  10390: ['CLEREY', 'VERRIERES'],
  10250: [
    'COURTERON',
    'GYE SUR SEINE',
    'MUSSY SUR SEINE',
    'NEUVILLE SUR SEINE',
    'PLAINES ST LANGE',
  ],
  10100: [
    'CRANCEY',
    'LA FOSSE CORDUAN',
    'GELANNES',
    'OSSEY LES TROIS MAISONS',
    'PARS LES ROMILLY',
    'ROMILLY SUR SEINE',
    'ST HILAIRE SOUS ROMILLY',
    'ST LOUP DE BUFFIGNY',
    'ST MARTIN DE BOSSENAY',
  ],
  10360: ['CUNFIN', 'ESSOYES', 'FONTETTE', 'NOE LES MALLETS', 'ST USAGE', 'VERPILLIERES SUR OURCE'],
  10350: [
    'ECHEMINES',
    'MARIGNY LE CHATEL',
    'LE PAVILLON STE JULIE',
    'PRUNAY BELLEVILLE',
    'ST FLAVY',
    'ST LUPIEN',
    'VILLELOUP',
  ],
  10280: ['FONTAINE LES GRES', 'RILLY STE SYRE', 'ST MESMIN'],
  10120: ['LAINES AUX BOIS', 'ST ANDRE LES VERGERS', 'ST GERMAIN', 'ST POUANGE'],
  10300: ['MACEY', 'MONTGUEUX', 'STE SAVINE'],
  10230: ['MAILLY LE CAMP'],
  10420: ['LES NOES PRES TROYES'],
  10440: ['LA RIVIERE DE CORPS', 'TORVILLIERS'],
  10430: ['ROSIERES PRES TROYES'],
  10410: ['RUVIGNY', 'ST PARRES AUX TERTRES', 'THENNELIERES', 'VILLECHETIF'],
  10180: ['ST BENOIT SUR SEINE', 'ST LYE'],
  10000: ['TROYES'],
  10370: ['VILLENAUXE LA GRANDE'],
  11800: [
    'AIGUES VIVES',
    'BADENS',
    'BARBAIRA',
    'BOUILHONNAC',
    'FLOURE',
    'FONTIES D AUDE',
    'LAURE MINERVOIS',
    'MARSEILLETTE',
    'MONTIRAT',
    'MONZE',
    'RUSTIQUES',
    'ST FRICHOUX',
    'TREBES',
    'VILLEDUBERT',
  ],
  11320: [
    'AIROUX',
    'LES CASSES',
    'LABASTIDE D ANJOU',
    'MONTFERRAND',
    'MONTMAUR',
    'ST PAULET',
    'SOUPEX',
  ],
  11300: [
    'AJAC',
    'LA BEZOLE',
    'BOURIEGE',
    'BOURIGEOLE',
    'BRUGAIROLLES',
    'CASTELRENG',
    'CEPIE',
    'COURNANEL',
    'LA DIGNE D AMONT',
    'LA DIGNE D AVAL',
    'FESTES ET ST ANDRE',
    'GAJA ET VILLEDIEU',
    'LAURAGUEL',
    'LIMOUX',
    'LOUPIA',
    'MAGRIE',
    'MALRAS',
    'MALVIES',
    'PAULIGNE',
    'PIEUSSE',
    'POMY',
    'ROQUETAILLADE ET CONILHAC',
    'ST COUAT DU RAZES',
    'ST MARTIN DE VILLEREGLAN',
    'ST POLYCARPE',
    'TOURREILLES',
    'VILLARZEL DU RAZES',
    'VILLELONGUE D AUDE',
  ],
  11240: [
    'ALAIGNE',
    'BELLEGARDE DU RAZES',
    'BELVEZE DU RAZES',
    'CAILHAU',
    'CAILHAVEL',
    'CAMBIEURE',
    'LA COURTETE',
    'DONAZAC',
    'ESCUEILLENS ET ST JUST DE BELENGARD',
    'FENOUILLET DU RAZES',
    'FERRAN',
    'GRAMAZIE',
    'HOUNOUX',
    'LIGNAIROLLES',
    'MAZEROLLES DU RAZES',
    'MONTGRADAIL',
    'MONTHAUT',
    'ROUTIER',
    'SEIGNALENS',
  ],
  11290: ['ALAIRAC', 'ARZENS', 'LAVALETTE', 'MONTREAL', 'ROULLENS', 'VILLENEUVE LES MONTREAL'],
  11360: [
    'ALBAS',
    'CASCASTEL DES CORBIERES',
    'DURBAN CORBIERES',
    'EMBRES ET CASTELMAURE',
    'FONTJONCOUSE',
    'FRAISSE DES CORBIERES',
    'QUINTILLAN',
    'ST JEAN DE BARROU',
    'VILLENEUVE LES CORBIERES',
    'VILLESEQUE DES CORBIERES',
  ],
  11330: [
    'ALBIERES',
    'AURIAC',
    'BOUISSE',
    'DAVEJEAN',
    'DERNACUEILLETTE',
    'FELINES TERMENES',
    'LAIRIERE',
    'LANET',
    'LAROQUE DE FA',
    'MAISONS',
    'MASSAC',
    'MONTGAILLARD',
    'MONTJOI',
    'MOUTHOUMET',
    'PALAIRAC',
    'SALZA',
    'SOULATGE',
    'TERMES',
    'VIGNEVIEILLE',
    'VILLEROUGE TERMENES',
  ],
  11580: [
    'ALET LES BAINS',
    'BELCASTEL ET BUC',
    'MISSEGRE',
    'TERROLES',
    'VALMIGERE',
    'VERAZA',
    'VILLARDEBELLE',
  ],
  11170: [
    'ALZONNE',
    'CARLIPA',
    'CAUX ET SAUZENS',
    'CENNE MONESTIES',
    'MONTOLIEU',
    'MOUSSOULENS',
    'PEZENS',
    'RAISSAC SUR LAMPY',
    'STE EULALIE',
    'ST MARTIN LE VIEIL',
    'VILLESEQUELANDE',
    'VILLESPY',
  ],
  11190: [
    'ANTUGNAC',
    'ARQUES',
    'BUGARACH',
    'CAMPS SUR L AGLY',
    'CASSAIGNES',
    'COUIZA',
    'COUSTAUSSA',
    'CUBIERES SUR CINOBLE',
    'FOURTOU',
    'LUC SUR AUDE',
    'MONTAZELS',
    'PEYROLLES',
    'RENNES LE CHATEAU',
    'RENNES LES BAINS',
    'ROQUETAILLADE ET CONILHAC',
    'LA SERPENT',
    'SERRES',
    'SOUGRAIGNE',
  ],
  11600: [
    'ARAGON',
    'BAGNOLES',
    'CONQUES SUR ORBIEL',
    'FOURNES CABARDES',
    'FRAISSE CABARDES',
    'LASTOURS',
    'LIMOUSIS',
    'MALVES EN MINERVOIS',
    'SALLELES CABARDES',
    'SALSIGNE',
    'VILLALIER',
    'VILLANIERE',
    'VILLARDONNEL',
    'VILLARZEL CABARDES',
    'VILLEGAILHENC',
    'VILLEGLY',
  ],
  11120: [
    'ARGELIERS',
    'BIZE MINERVOIS',
    'GINESTAS',
    'MAILHAC',
    'MARCORIGNAN',
    'MIREPEISSET',
    'MOUSSAN',
    'POUZOLS MINERVOIS',
    'ST MARCEL SUR AUDE',
    'ST NAZAIRE D AUDE',
    'STE VALIERE',
    'VENTENAC EN MINERVOIS',
  ],
  11200: [
    'ARGENS MINERVOIS',
    'BIZANET',
    'BOUTENAC',
    'CAMPLONG D AUDE',
    'CANET',
    'CONILHAC CORBIERES',
    'CRUSCADES',
    'ESCALES',
    'FABREZAN',
    'FERRALS LES CORBIERES',
    'HOMPS',
    'LEZIGNAN CORBIERES',
    'LUC SUR ORBIEU',
    'MONTSERET',
    'NEVIAN',
    'ORNAISONS',
    'PARAZA',
    'RAISSAC D AUDE',
    'ROUBIA',
    'ST ANDRE DE ROQUELONGUE',
    'THEZAN DES CORBIERES',
    'TOUROUZELLE',
    'VILLEDAIGNE',
  ],
  11110: ['ARMISSAN', 'COURSAN', 'SALLES D AUDE', 'VINASSAN'],
  11220: [
    'ARQUETTES EN VAL',
    'CAUNETTES EN VAL',
    'COUSTOUGE',
    'FAJAC EN VAL',
    'JONQUIERES',
    'LABASTIDE EN VAL',
    'LAGRASSE',
    'MAYRONNES',
    'VAL DE DAGNE',
    'RIBAUTE',
    'RIEUX EN VAL',
    'ST LAURENT DE LA CABRERISSE',
    'ST MARTIN DES PUITS',
    'ST PIERRE DES CHAMPS',
    'SERVIES EN VAL',
    'TALAIRAN',
    'TAURIZE',
    'TOURNISSAN',
    'VILLAR EN VAL',
    'VILLETRITOULS',
  ],
  11140: [
    'ARTIGUES',
    'AUNAT',
    'AXAT',
    'BELFORT SUR REBENTY',
    'BESSEDE DE SAULT',
    'LE BOUSQUET',
    'CAILLA',
    'CAMPAGNA DE SAULT',
    'LE CLAT',
    'COUNOZOULS',
    'ESCOULOUBRE',
    'LA FAJOLLE',
    'FONTANES DE SAULT',
    'GALINAGUES',
    'GINCLA',
    'JOUCOU',
    'MARSA',
    'MAZUBY',
    'MERIAL',
    'MONTFORT SUR BOULZANE',
    'NIORT DE SAULT',
    'PUILAURENS',
    'RODOME',
    'ROQUEFORT DE SAULT',
    'STE COLOMBE SUR GUETTE',
    'SALVEZINES',
  ],
  11700: [
    'AZILLE',
    'BLOMAC',
    'CAPENDU',
    'CASTELNAU D AUDE',
    'COMIGNE',
    'DOUZENS',
    'FONTCOUVERTE',
    'LA REDORTE',
    'MONTBRUN DES CORBIERES',
    'MOUX',
    'PEPIEUX',
    'PUICHERIC',
    'ROQUECOURBE MINERVOIS',
    'ST COUAT D AUDE',
  ],
  11100: ['BAGES', 'MONTREDON DES CORBIERES', 'NARBONNE'],
  11410: [
    'BARAIGNE',
    'BELFLOU',
    'CUMIES',
    'FAJAC LA RELENQUE',
    'GOURVIEILLE',
    'LA LOUVIERE LAURAGAIS',
    'MARQUEIN',
    'MEZERVILLE',
    'MOLLEVILLE',
    'MONTAURIOL',
    'PAYRA SUR L HERS',
    'STE CAMELLE',
    'ST MICHEL DE LANES',
    'SALLES SUR L HERS',
  ],
  11340: ['BELCAIRE', 'BELVIS', 'CAMURAC', 'COMUS', 'ESPEZEL', 'ROQUEFEUIL'],
  11420: [
    'BELPECH',
    'CAHUZAC',
    'LAFAGE',
    'MAYREVILLE',
    'MOLANDIER',
    'PECHARIC ET LE PY',
    'PECH LUNA',
    'PEYREFITTE SUR L HERS',
    'PLAIGNE',
    'ST SERNIN',
    'VILLAUTOU',
  ],
  11500: [
    'BELVIANES ET CAVIRAC',
    'COUDONS',
    'GINOLES',
    'GRANES',
    'NEBIAS',
    'QUILLAN',
    'QUIRBAJOU',
    'ST FERRIOL',
    'ST JULIA DE BEC',
    'ST JUST ET LE BEZU',
    'ST LOUIS ET PARAHOU',
    'ST MARTIN LYS',
  ],
  11000: ['BERRIAC', 'CARCASSONNE'],
  11150: ['BRAM', 'PEXIORA', 'VILLASAVARY', 'VILLEPINTE', 'VILLESISCLE'],
  11270: [
    'BREZILHAC',
    'LA CASSAIGNE',
    'CAZALRENOUX',
    'FANJEAUX',
    'LA FORCE',
    'GAJA LA SELVE',
    'GENERVILLE',
    'LASSERRE DE PROUILLE',
    'LAURAC',
    'ORSANS',
    'PLAVILLA',
    'RIBOUISSE',
    'ST AMANS',
    'ST GAUDERIC',
    'ST JULIEN DE BRIOLA',
  ],
  11390: [
    'BROUSSES ET VILLARET',
    'CAUDEBRONDE',
    'CUXAC CABARDES',
    'FONTIERS CABARDES',
    'LAPRADE',
    'LES MARTYS',
  ],
  11400: [
    'LES BRUNELS',
    'CASTELNAUDARY',
    'FENDEILLE',
    'FONTERS DU RAZES',
    'ISSEL',
    'LABECEDE LAURAGAIS',
    'LASBORDES',
    'LAURABUC',
    'MAS SAINTES PUELLES',
    'MIREVAL LAURAGAIS',
    'PEYRENS',
    'LA POMAREDE',
    'PUGINIER',
    'RICAUD',
    'ST MARTIN LALANDE',
    'ST PAPOUL',
    'SOUILHANELS',
    'SOUILHE',
    'TREVILLE',
    'VERDUN EN LAURAGAIS',
    'VILLENEUVE LA COMPTAL',
  ],
  11160: [
    'CABRESPINE',
    'CASTANS',
    'CAUNES MINERVOIS',
    'CITOU',
    'LESPINASSIERE',
    'PEYRIAC MINERVOIS',
    'RIEUX MINERVOIS',
    'TRASSANEL',
    'TRAUSSE',
    'VILLENEUVE MINERVOIS',
  ],
  11260: ['CAMPAGNE SUR AUDE', 'ESPERAZA', 'VAL DU FABY', 'ST JEAN DE PARACOL'],
  11230: [
    'VAL DE LAMBRONNE',
    'CHALABRE',
    'CORBIERES',
    'COURTAULY',
    'MONTJARDIN',
    'PEYREFITTE DU RAZES',
    'PUIVERT',
    'RIVEL',
    'ST BENOIT',
    'STE COLOMBE SUR L HERS',
    'SONNAC SUR L HERS',
    'TREZIERS',
    'VILLEFORT',
  ],
  11250: [
    'CAUNETTE SUR LAUQUET',
    'CLERMONT SUR LAUQUET',
    'COUFFOULENS',
    'GARDIE',
    'GREFFEIL',
    'LADERN SUR LAUQUET',
    'LEUC',
    'MONTCLAR',
    'POMAS',
    'PREIXAN',
    'ROUFFIAC D AUDE',
    'ST HILAIRE',
    'VERZEILLE',
    'VILLAR ST ANSELME',
    'VILLEBAZY',
  ],
  11570: ['CAVANAC', 'CAZILHAC', 'MAS DES COURS', 'PALAJA', 'VILLEFLOURE'],
  11510: ['CAVES', 'FEUILLA', 'FITOU', 'TREILLES'],
  11350: [
    'CUCUGNAN',
    'DUILHAC SOUS PEYREPERTUSE',
    'PADERN',
    'PAZIOLS',
    'ROUFFIAC DES CORBIERES',
    'TUCHAN',
  ],
  11590: ['CUXAC D AUDE', 'OUVEILLAN', 'SALLELES D AUDE'],
  11560: ['FLEURY'],
  11430: ['GRUISSAN'],
  11380: [
    'LES ILHES',
    'LABASTIDE ESPARBAIRENQUE',
    'MAS CABARDES',
    'MIRAVAL CABARDES',
    'PRADELLES CABARDES',
    'ROQUEFERE',
    'LA TOURETTE CABARDES',
  ],
  11310: ['LACOMBE', 'ST DENIS', 'SAISSAC', 'VILLEMAGNE'],
  11480: ['LA PALME'],
  11370: ['LEUCATE'],
  11210: ['PORT LA NOUVELLE'],
  11610: ['PENNAUTIER', 'VENTENAC CABARDES'],
  11440: ['PEYRIAC DE MER'],
  11490: ['PORTEL DES CORBIERES'],
  11540: ['ROQUEFORT DES CORBIERES'],
  11130: ['SIGEAN'],
  11620: ['VILLEMOUSTAUSSOU'],
  12630: ['AGEN D AVEYRON', 'MONTROZIER'],
  12520: ['AGUESSAC', 'COMPEYRE', 'PAULHE', 'VERRIERES'],
  12220: [
    'LES ALBRES',
    'GALGAN',
    'LUGAN',
    'MONTBAZENS',
    'PEYRUSSE LE ROC',
    'ROUSSENNAC',
    'VALZERGUES',
    'VAUREILLES',
  ],
  12300: [
    'ALMONT LES JUNIES',
    'BOISSE PENCHOT',
    'BOUILLAC',
    'DECAZEVILLE',
    'FIRMI',
    'FLAGNAC',
    'LIVINHAC LE HAUT',
    'ST PARTHEM',
    'ST SANTIN',
  ],
  12430: ['ALRANCE', 'AYSSENES', 'LESTRADE ET THOUELS', 'LE TRUEL', 'VILLEFRANCHE DE PANAT'],
  12260: [
    'AMBEYRAC',
    'BALAGUIER D OLT',
    'LA CAPELLE BALAGUIER',
    'FOISSAC',
    'MONTSALES',
    'OLS ET RINHODES',
    'STE CROIX',
    'ST IGEST',
    'SALLES COURBATIES',
    'SALVAGNAC CAJARC',
    'SAUJAC',
    'VILLENEUVE',
  ],
  12390: [
    'ANGLARS ST FELIX',
    'AUZITS',
    'BELCASTEL',
    'BOURNAZEL',
    'ESCANDOLIERES',
    'GOUTRENS',
    'MAYRAN',
    'RIGNAC',
  ],
  12360: [
    'ARNAC SUR DOURDOU',
    'BRUSQUE',
    'CAMARES',
    'FAYET',
    'GISSAC',
    'MELAGUES',
    'MONTAGNOL',
    'PEUX ET COUFFOULEUX',
    'SYLVANES',
    'TAURIAC DE CAMARES',
  ],
  12290: [
    'ARQUES',
    'CANET DE SALARS',
    'PONT DE SALARS',
    'PRADES SALARS',
    'SEGUR',
    'TREMOUILLES',
    'LE VIBAL',
  ],
  12120: [
    'ARVIEU',
    'AURIAC LAGAST',
    'CASSAGNES BEGONHES',
    'CENTRES',
    'COMPS LA GRAND VILLE',
    'MELJAC',
    'RULLAC ST CIRQ',
    'STE JULIETTE SUR VIAUR',
    'SALMIECH',
  ],
  12700: ['ASPRIERES', 'CAPDENAC GARE', 'NAUSSAC', 'CAUSSE ET DIEGE', 'SONNAC'],
  12110: ['AUBIN', 'CRANSAC', 'VIVIEZ'],
  12380: [
    'BALAGUIER SUR RANCE',
    'LAVAL ROQUECEZIERE',
    'MONTFRANC',
    'POUSTHOMY',
    'ST SERNIN SUR RANCE',
    'LA SERRE',
  ],
  12200: [
    'LE BAS SEGALA',
    'MARTIEL',
    'MONTEILS',
    'MORLHON LE HAUT',
    'LA ROUQUETTE',
    'ST REMY',
    'SANVENSA',
    'SAVIGNAC',
    'TOULONJAC',
    'VAILHOURLES',
    'VILLEFRANCHE DE ROUERGUE',
  ],
  12240: ['LE BAS SEGALA', 'LA CAPELLE BLEYS', 'CASTANET', 'COLOMBIES', 'PRADINAS', 'RIEUPEYROUX'],
  12490: [
    'LA BASTIDE PRADINES',
    'MONTJAUX',
    'ST ROME DE CERNON',
    'ST ROME DE TARN',
    'VIALA DU TARN',
  ],
  12550: ['LA BASTIDE SOLAGES', 'BRASC', 'COUPIAC', 'MARTRIN', 'MONTCLAR', 'PLAISANCE', 'ST JUERY'],
  12370: ['BELMONT SUR RANCE', 'COMBRET', 'MURASSON', 'MOUNES PROHENCOUX', 'ST SEVER DU MOUSTIER'],
  12310: [
    'BERTHOLENE',
    'GAILLAC D AVEYRON',
    'LAISSAC SEVERAC L EGLISE',
    'PALMAS D AVEYRON',
    'VIMENET',
  ],
  12500: [
    'BESSUEJOULS',
    'CASTELNAU DE MANDAILLES',
    'LE CAYROL',
    'ESPALION',
    'LASSOUTS',
    'ST COME D OLT',
  ],
  12270: ['BOR ET BAR', 'LA FOUILLADE', 'LUNAC', 'NAJAC', 'ST ANDRE DE NAJAC'],
  12160: ['BOUSSAC', 'CAMBOULAZET', 'BARAQUEVILLE', 'GRAMOND', 'MANHAC', 'MOYRAZES'],
  12340: ['BOZOULS', 'GABRIAC', 'PALMAS D AVEYRON', 'RODELLE'],
  12350: [
    'BRANDONNET',
    'COMPOLIBAT',
    'DRULHE',
    'LANUEJOULS',
    'MALEVILLE',
    'PREVINQUIERES',
    'PRIVEZAC',
  ],
  12600: ['BROMMAT', 'LACROIX BARREZ', 'MUR DE BARREZ', 'MUROLS', 'TAUSSAC', 'THERONDELS'],
  12480: ['BROQUIES', 'BROUSSE LE CHATEAU', 'ST IZAIRE'],
  12800: [
    'CABANES',
    'CAMJAC',
    'CASTELMARY',
    'CRESPIN',
    'NAUCELLE',
    'QUINS',
    'ST JUST SUR VIAUR',
    'SAUVETERRE DE ROUERGUE',
    'TAURIAC DE NAUCELLE',
  ],
  12400: [
    'CALMELS ET LE VIALA',
    'LES COSTES GOZON',
    'MONTLAUR',
    'REBOURGUIL',
    'ST AFFRIQUE',
    'ST FELIX DE SORGUES',
    'ST VICTOR ET MELVIEU',
    'VABRES L ABBAYE',
    'VERSOLS ET LAPEYRE',
  ],
  12450: ['CALMONT', 'FLAVIN', 'LUC LA PRIMAUBE'],
  12560: ['CAMPAGNAC', 'ST LAURENT D OLT', 'ST SATURNIN DE LENNE'],
  12140: [
    'CAMPOURIEZ',
    'LE FEL',
    'ENTRAYGUES SUR TRUYERE',
    'ESPEYRAC',
    'FLORENTIN LA CAPELLE',
    'GOLINHAC',
    'ST HIPPOLYTE',
  ],
  12460: ['CAMPOURIEZ', 'HUPARLAC', 'MONTEZIC', 'ST AMANS DES COTS', 'ST SYMPHORIEN DE THENIERES'],
  12580: ['CAMPUAC', 'VILLECOMTAL'],
  12420: ['CANTOIN', 'ARGENCES EN AUBRAC'],
  12130: [
    'LA CAPELLE BONANCE',
    'PIERREFICHE',
    'POMAYROLS',
    'STE EULALIE D OLT',
    'ST GENIEZ D OLT ET D AUBRAC',
    'ST MARTIN DE LENNE',
  ],
  12210: [
    'CASSUEJOULS',
    'CURIERES',
    'LAGUIOLE',
    'MONTPEYROUX',
    'ARGENCES EN AUBRAC',
    'SOULAGES BONNEVAL',
  ],
  12620: ['CASTELNAU PEGAYROLS', 'ST BEAUZELY', 'ST LAURENT DE LEVEZOU'],
  12230: [
    'LA CAVALERIE',
    'LA COUVERTOIRADE',
    'L HOSPITALET DU LARZAC',
    'LAPANOUSE DE CERNON',
    'NANT',
    'STE EULALIE DE CERNON',
    'ST JEAN DU BRUEL',
    'SAUCLIERES',
  ],
  12330: [
    'CLAIRVAUX D AVEYRON',
    'MARCILLAC VALLON',
    'MOURET',
    'MURET LE CHATEAU',
    'NAUVIALE',
    'ST CHRISTOPHE VALLON',
    'SALLES LA SOURCE',
    'VALADY',
  ],
  12540: ['LE CLAPIER', 'CORNUS', 'MARNHAGUES ET LATOUR', 'FONDAMENTE', 'ST BEAULIZE'],
  12100: ['COMPREGNAC', 'CREISSELS', 'MILLAU', 'LA ROQUE STE MARGUERITE', 'ST GEORGES DE LUZENCON'],
  12470: ['CONDOM D AUBRAC', 'PRADES D AUBRAC', 'ST CHELY D AUBRAC'],
  12170: [
    'CONNAC',
    'DURENQUE',
    'LEDERGUES',
    'REQUISTA',
    'ST JEAN DELNOUS',
    'ST JUST SUR VIAUR',
    'LA SELVE',
  ],
  12320: ['CONQUES EN ROUERGUE', 'PRUINES', 'ST FELIX DE LUNEL', 'SENERGUES'],
  12190: ['COUBISOU', 'ESTAING', 'LE NAYRAC', 'SEBRAZAC'],
  12640: ['LA CRESSE', 'RIVIERE SUR TARN'],
  12000: ['DRUELLE BALSAC', 'LE MONASTERE', 'ONET LE CHATEAU', 'RODEZ'],
  12510: ['DRUELLE BALSAC', 'OLEMPS'],
  12440: ['LESCURE JAOUL', 'LA SALVETAT PEYRALES', 'TAYRAC'],
  12740: ['LA LOUBIERE', 'SEBAZAC CONCOURES'],
  12720: ['MOSTUEJOULS', 'PEYRELEAU', 'ST ANDRE DE VEZINES', 'VEYREAU'],
  12850: ['ONET LE CHATEAU', 'STE RADEGONDE'],
  12250: [
    'ROQUEFORT SUR SOULZON',
    'ST JEAN D ALCAPIES',
    'ST JEAN ET ST PAUL',
    'TOURNEMIRE',
    'VIALA DU PAS DE JAUX',
  ],
  12780: ['ST LEONS', 'VEZINS DE LEVEZOU'],
  12410: ['SALLES CURAN', 'CURAN'],
  12150: ['SEVERAC D AVEYRON'],
  13080: ['AIX EN PROVENCE'],
  13090: ['AIX EN PROVENCE'],
  13100: [
    'AIX EN PROVENCE',
    'BEAURECUEIL',
    'ST ANTONIN SUR BAYON',
    'ST MARC JAUMEGARDE',
    'LE THOLONET',
  ],
  13290: ['AIX EN PROVENCE'],
  13540: ['AIX EN PROVENCE'],
  13190: ['ALLAUCH'],
  13980: ['ALLEINS'],
  13104: ['ARLES'],
  13123: ['ARLES'],
  13129: ['ARLES'],
  13200: ['ARLES'],
  13280: ['ARLES'],
  13400: ['AUBAGNE'],
  13930: ['AUREILLE'],
  13390: ['AURIOL'],
  13121: ['AURONS'],
  13330: ['LA BARBEN', 'PELISSANNE'],
  13570: ['BARBENTANE'],
  13520: ['LES BAUX DE PROVENCE', 'MAUSSANE LES ALPILLES', 'PARADOU'],
  13720: ['BELCODENE', 'LA BOUILLADISSE'],
  13130: ['BERRE L ETANG'],
  13320: ['BOUC BEL AIR'],
  13150: ['BOULBON', 'ST PIERRE DE MEZOARGUES', 'TARASCON'],
  13440: ['CABANNES'],
  13480: ['CABRIES'],
  13950: ['CADOLIVE'],
  13620: ['CARRY LE ROUET'],
  13260: ['CASSIS'],
  13600: ['CEYRESTE', 'LA CIOTAT'],
  13350: ['CHARLEVAL'],
  13790: ['CHATEAUNEUF LE ROUGE', 'PEYNIER', 'ROUSSET'],
  13220: ['CHATEAUNEUF LES MARTIGUES'],
  13160: ['CHATEAURENARD'],
  13250: ['CORNILLON CONFOUX', 'ST CHAMAS'],
  13780: ['CUGES LES PINS', 'RIBOUX'],
  13112: ['LA DESTROUSSE'],
  13510: ['EGUILLES'],
  13820: ['ENSUES LA REDONNE'],
  13810: ['EYGALIERES'],
  13430: ['EYGUIERES'],
  13630: ['EYRAGUES'],
  13580: ['LA FARE LES OLIVIERS'],
  13990: ['FONTVIEILLE'],
  13270: ['FOS SUR MER'],
  13710: ['FUVEAU'],
  13120: ['GARDANNE'],
  13420: ['GEMENOS'],
  13180: ['GIGNAC LA NERTHE'],
  13450: ['GRANS'],
  13690: ['GRAVESON'],
  13850: ['GREASQUE'],
  13118: ['ISTRES'],
  13800: ['ISTRES'],
  13490: ['JOUQUES'],
  13113: ['LAMANON'],
  13410: ['LAMBESC'],
  13680: ['LANCON PROVENCE'],
  13910: ['MAILLANE'],
  13370: ['MALLEMORT'],
  13700: ['MARIGNANE'],
  13117: ['MARTIGUES'],
  13500: ['MARTIGUES'],
  13103: ['MAS BLANC DES ALPILLES', 'ST ETIENNE DU GRES'],
  13650: ['MEYRARGUES'],
  13590: ['MEYREUIL'],
  13105: ['MIMET'],
  13140: ['MIRAMAS'],
  13940: ['MOLLEGES'],
  13890: ['MOURIES'],
  13550: ['NOVES'],
  13660: ['ORGON'],
  13821: ['LA PENNE SUR HUVEAUNE'],
  13170: ['LES PENNES MIRABEAU'],
  13124: ['PEYPIN'],
  13860: ['PEYROLLES EN PROVENCE'],
  13380: ['PLAN DE CUQUES'],
  13750: ['PLAN D ORGON'],
  13110: ['PORT DE BOUC'],
  13230: ['PORT ST LOUIS DU RHONE'],
  13114: ['PUYLOUBIER'],
  13610: ['LE PUY STE REPARADE', 'ST ESTEVE JANSON'],
  13340: ['ROGNAC'],
  13840: ['ROGNES'],
  13870: ['ROGNONAS'],
  13640: ['LA ROQUE D ANTHERON'],
  13830: ['ROQUEFORT LA BEDOULE'],
  13360: ['ROQUEVAIRE'],
  13740: ['LE ROVE'],
  13670: ['ST ANDIOL', 'VERQUIERES'],
  13760: ['ST CANNAT'],
  13460: ['SAINTES MARIES DE LA MER'],
  13310: ['ST MARTIN DE CRAU'],
  13920: ['ST MITRE LES REMPARTS'],
  13115: ['ST PAUL LES DURANCE'],
  13210: ['ST REMY DE PROVENCE'],
  13119: ['ST SAVOURNIN'],
  13730: ['ST VICTORET'],
  13300: ['SALON DE PROVENCE'],
  13960: ['SAUSSET LES PINS'],
  13560: ['SENAS'],
  13240: ['SEPTEMES LES VALLONS'],
  13109: ['SIMIANE COLLONGUE'],
  13530: ['TRETS'],
  13126: ['VAUVENARGUES'],
  13880: ['VELAUX'],
  13770: ['VENELLES'],
  13122: ['VENTABREN'],
  13116: ['VERNEGUES'],
  13127: ['VITROLLES'],
  13111: ['COUDOUX'],
  13470: ['CARNOUX EN PROVENCE'],
  13001: ['MARSEILLE 01'],
  13002: ['MARSEILLE 02'],
  13003: ['MARSEILLE 03'],
  13004: ['MARSEILLE 04'],
  13005: ['MARSEILLE 05'],
  13006: ['MARSEILLE 06'],
  13007: ['MARSEILLE 07'],
  13008: ['MARSEILLE 08'],
  13009: ['MARSEILLE 09'],
  13010: ['MARSEILLE 10'],
  13011: ['MARSEILLE 11'],
  13012: ['MARSEILLE 12'],
  13013: ['MARSEILLE 13'],
  13014: ['MARSEILLE 14'],
  13015: ['MARSEILLE 15'],
  13016: ['MARSEILLE 16'],
  14600: [
    'ABLON',
    'BARNEVILLE LA BERTRAN',
    'EQUEMAUVILLE',
    'FOURNEVILLE',
    'GENNEVILLE',
    'GONNEVILLE SUR HONFLEUR',
    'HONFLEUR',
    'PENNEDEPIE',
    'LA RIVIERE ST SAUVEUR',
  ],
  14400: [
    'AGY',
    'ARGANCHY',
    'BARBEVILLE',
    'BAYEUX',
    'BLAY',
    'CONDE SUR SEULLES',
    'COTTUN',
    'CROUAY',
    'CUSSY',
    'ESQUAY SUR SEULLES',
    'ETREHAM',
    'GUERON',
    'LONGUES SUR MER',
    'MAGNY EN BESSIN',
    'MAISONS',
    'LE MANOIR',
    'MONCEAUX EN BESSIN',
    'MOSLES',
    'NONANT',
    'RANCHY',
    'RYES',
    'ST LOUP HORS',
    'ST MARTIN DES ENTREES',
    'ST VIGOR LE GRAND',
    'SOMMERVIEU',
    'SUBLES',
    'SULLY',
    'TOUR EN BESSIN',
    'VAUCELLES',
    'VAUX SUR AURE',
    'VAUX SUR SEULLES',
    'VIENNE EN BESSIN',
  ],
  14190: [
    'VALAMBRAY',
    'BRETTEVILLE LE RABET',
    'LE BU SUR ROUVRES',
    'CAUVICOURT',
    'ESTREES LA CAMPAGNE',
    'FONTAINE LE PIN',
    'GRAINVILLE LANGANNERIE',
    'MAIZIERES',
    'OUILLY LE TESSON',
    'ROUVRES',
    'ST GERMAIN LE VASSON',
    'ST SYLVAIN',
    'SOIGNOLLES',
    'URVILLE',
  ],
  14370: [
    'VALAMBRAY',
    'ARGENCES',
    'BELLENGREVILLE',
    'CANTELOUP',
    'CLEVILLE',
    'MERY BISSIERES EN AUGE',
    'MEZIDON VALLEE D AUGE',
    'MOULT CHICHEBOVILLE',
    'VIMONT',
  ],
  14540: ['VALAMBRAY', 'BOURGUEBUS', 'GRENTHEVILLE', 'CASTINE EN PLAINE', 'LE CASTELET', 'SOLIERS'],
  14210: [
    'AMAYE SUR ORNE',
    'AVENAY',
    'BARON SUR ODON',
    'BOUGY',
    'THUE ET MUE',
    'LA CAINE',
    'ESQUAY NOTRE DAME',
    'EVRECY',
    'GAVRUS',
    'GRAINVILLE SUR ODON',
    'MAISONCELLES SUR AJON',
    'MAIZET',
    'MONDRAINVILLE',
    'MONTIGNY',
    'VAL D ARRY',
    'PREAUX BOCAGE',
    'STE HONORINE DU FAY',
    'TOURVILLE SUR ODON',
    'MONTILLIERES SUR ORNE',
    'VACOGNES NEUILLY',
  ],
  14310: [
    'AMAYE SUR SEULLES',
    'EPINAY SUR ODON',
    'LANDES SUR AJON',
    'LONGVILLERS',
    'MAISONCELLES PELVEY',
    'MONTS EN BESSIN',
    'VAL D ARRY',
    'PARFOURU SUR ODON',
    'SEULLINE',
    'ST LOUET SUR SEULLES',
    'TRACY BOCAGE',
    'VILLERS BOCAGE',
    'VILLY BOCAGE',
  ],
  14860: ['AMFREVILLE', 'BAVENT', 'BREVILLE LES MONTS', 'RANVILLE'],
  14240: [
    'AURSEULLES',
    'CAHAGNES',
    'CAUMONT SUR AURE',
    'CORMOLAIN',
    'FOULOGNES',
    'LES LOGES',
    'STE HONORINE DE DUCY',
    'SALLEN',
    'VAL DE DROME',
  ],
  14250: [
    'AURSEULLES',
    'AUDRIEU',
    'THUE ET MUE',
    'BUCEELS',
    'CHOUAIN',
    'CRISTOT',
    'DUCY STE MARGUERITE',
    'ELLON',
    'FONTENAY LE PESNEL',
    'HOTTOT LES BAGUES',
    'JUAYE MONDAYE',
    'JUVIGNY SUR SEULLES',
    'LINGEVRES',
    'LOUCELLES',
    'ST VAAST SUR SEULLES',
    'TESSEL',
    'TILLY SUR SEULLES',
    'VENDES',
  ],
  14430: [
    'ANGERVILLE',
    'ANNEBAULT',
    'BEUVRON EN AUGE',
    'BOURGEAUVILLE',
    'BRANVILLE',
    'CRESSEVEUILLE',
    'CRICQUEVILLE EN AUGE',
    'DANESTAL',
    'DOUVILLE EN AUGE',
    'DOZULE',
    'GERROTS',
    'GOUSTRANVILLE',
    'HEULAND',
    'HOTOT EN AUGE',
    'PUTOT EN AUGE',
    'ST JOUIN',
    'ST LEGER DUBOSQ',
    'VICTOT PONTFOL',
  ],
  14610: [
    'COLOMBY ANGUERNY',
    'ANISY',
    'BASLY',
    'CAIRON',
    'CAMBES EN PLAINE',
    'EPRON',
    'FONTAINE HENRY',
    'THAON',
    'VILLONS LES BUISSONS',
  ],
  14117: ['ARROMANCHES LES BAINS', 'MANVIEUX', 'TRACY SUR MER'],
  14960: ['ASNELLES', 'MEUVAINES', 'ST COME DE FRESNE'],
  14710: [
    'ASNIERES EN BESSIN',
    'BERNESQ',
    'BRICQUEVILLE',
    'COLLEVILLE SUR MER',
    'COLOMBIERES',
    'ENGLESQUEVILLE LA PERCEE',
    'LA FOLIE',
    'FORMIGNY LA BATAILLE',
    'MANDEVILLE EN BESSIN',
    'RUBERCY',
    'AURE SUR MER',
    'ST LAURENT SUR MER',
    'ST MARTIN DE BLAGNY',
    'SURRAIN',
    'TREVIERES',
    'VIERVILLE SUR MER',
  ],
  14640: ['AUBERVILLE', 'ST VAAST EN AUGE', 'VILLERS SUR MER'],
  14700: [
    'AUBIGNY',
    'BONNOEIL',
    'CORDEY',
    'ERAINES',
    'FALAISE',
    'FOURNEAUX LE VAL',
    'FRESNE LA MERE',
    'LA HOGUETTE',
    'LEFFARD',
    'LES LOGES SAULCES',
    'MARTIGNY SUR L ANTE',
    'NORON L ABBAYE',
    'PERTHEVILLE NERS',
    'ST GERMAIN LANGOT',
    'ST MARTIN DE MIEUX',
    'ST PIERRE CANIVET',
    'ST PIERRE DU BU',
    'SOULANGY',
    'VERSAINVILLE',
    'VIGNATS',
    'VILLY LEZ FALAISE',
  ],
  14260: [
    'LES MONTS D AUNAY',
    'MALHERBE SUR AJON',
    'SOULEUVRE EN BOCAGE',
    'BONNEMAISON',
    'BREMOY',
    'COURVAUDON',
    'DIALAN SUR CHAINE',
    'LE MESNIL AU GRAIN',
    'SEULLINE',
    'ST PIERRE DU FRESNE',
  ],
  14770: ['LES MONTS D AUNAY', 'CAUVILLE', 'CONDE EN NORMANDIE', 'TERRES DE DRUANCE', 'PERIGNY'],
  14280: ['AUTHIE', 'ST CONTEST', 'ST GERMAIN LA BLANCHE HERBE'],
  14130: [
    'LES AUTHIEUX SUR CALONNE',
    'BLANGY LE CHATEAU',
    'BONNEVILLE LA LOUVET',
    'LE BREUIL EN AUGE',
    'LE BREVEDENT',
    'CLARBEC',
    'COQUAINVILLIERS',
    'DRUBEC',
    'LE FAULQ',
    'FIERVILLE LES PARCS',
    'MANNEVILLE LA PIPARD',
    'LE MESNIL SUR BLANGY',
    'PIERREFITTE EN AUGE',
    'PONT L EVEQUE',
    'QUETTEVILLE',
    'REUX',
    'ST ANDRE D HEBERTOT',
    'ST BENOIT D HEBERTOT',
    'ST GATIEN DES BOIS',
    'ST HYMER',
    'ST JULIEN SUR CALONNE',
    'ST MARTIN AUX CHARTRAINS',
    'ST PHILBERT DES CHAMPS',
    'SURVILLE',
    'LE THEIL EN AUGE',
    'LE TORQUESNE',
    'TOURVILLE EN AUGE',
    'VIEUX BOURG',
  ],
  14340: [
    'AUVILLARS',
    'LA BOISSIERE',
    'BONNEBOSQ',
    'CAMBREMER',
    'BEAUFOUR DRUVAL',
    'FORMENTIN',
    'LE FOURNET',
    'LA HOUBLONNIERE',
    'LEAUPARTIE',
    'MANERBE',
    'MEZIDON VALLEE D AUGE',
    'MONTREUIL EN AUGE',
    'NOTRE DAME DE LIVAYE',
    'NOTRE DAME D ESTREES CORBON',
    'LE PRE D AUGE',
    'BELLE VIE EN AUGE',
    'REPENTIGNY',
    'LA ROQUE BAIGNARD',
    'RUMESNIL',
    'ST OUEN LE PIN',
    'VALSEME',
  ],
  14490: [
    'BALLEROY SUR DROME',
    'LA BAZOQUE',
    'CAHAGNOLLES',
    'CAMPIGNY',
    'CASTILLON',
    'LITTEAU',
    'MONTFIQUET',
    'NORON LA POTERIE',
    'PLANQUERY',
    'ST PAUL DU VERNAY',
    'LE TRONQUAY',
    'TRUNGY',
  ],
  14940: ['BANNEVILLE LA CAMPAGNE', 'SANNERVILLE', 'TOUFFREVILLE'],
  14480: [
    'BANVILLE',
    'BAZENVILLE',
    'COLOMBIERS SUR SEULLES',
    'CREPON',
    'CREULLY SUR SEULLES',
    'LE FRESNE CAMILLY',
    'PONTS SUR SEULLES',
    'MOULINS EN BESSIN',
    'STE CROIX SUR MER',
  ],
  14220: [
    'BARBERY',
    'BOULON',
    'CESNY LES SOURCES',
    'COMBRAY',
    'CROISILLES',
    'CULEY LE PATRY',
    'DONNAY',
    'ESPINS',
    'ESSON',
    'FRESNEY LE VIEUX',
    'GRIMBOSQ',
    'MARTAINVILLE',
    'MESLAY',
    'MOULINES',
    'LES MOUTIERS EN CINGLAIS',
    'MUTRECY',
    'OUFFIERES',
    'ST LAURENT DE CONDEL',
    'ST OMER',
    'THURY HARCOURT LE HOM',
  ],
  14620: [
    'BAROU EN AUGE',
    'BEAUMAIS',
    'CROCY',
    'DAMBLAINVILLE',
    'FOURCHES',
    'LE MARAIS LA CHAPELLE',
    'MORTEAUX COULIBOEUF',
    'LES MOUTIERS EN AUGE',
    'NORREY EN AUGE',
  ],
  14670: [
    'BASSENEVILLE',
    'JANVILLE',
    'ST OUEN DU MESNIL OGER',
    'ST PAIR',
    'ST PIERRE DU JONQUET',
    'ST SAMSON',
    'TROARN',
  ],
  14380: [
    'BEAUMESNIL',
    'LANDELLES ET COUPIGNY',
    'LE MESNIL ROBERT',
    'PONT BELLANGER',
    'ST AUBIN DES BOIS',
    'STE MARIE OUTRE L EAU',
    'NOUES DE SIENNE',
  ],
  14950: ['BEAUMONT EN AUGE', 'GLANVILLE', 'ST ETIENNE LA THILLAYE', 'ST PIERRE AZIF'],
  14910: ['BENERVILLE SUR MER', 'BLONVILLE SUR MER'],
  14970: ['BENOUVILLE', 'ST AUBIN D ARQUENAY'],
  14350: ['SOULEUVRE EN BOCAGE', 'VAL DE DROME', 'VALDALLIERE'],
  14440: ['BENY SUR MER', 'CRESSERONS', 'DOUVRES LA DELIVRANDE', 'PLUMETOT'],
  14170: [
    'BERNIERES D AILLY',
    'COURCY',
    'EPANEY',
    'JORT',
    'LOUVAGNY',
    'OLENDON',
    'PERRIERES',
    'ST PIERRE EN AUGE',
    'SASSY',
    'VENDEUVRE',
    'VICQUES',
  ],
  14990: ['BERNIERES SUR MER'],
  14112: ['BIEVILLE BEUVILLE', 'PERIERS SUR LE DAN'],
  14100: [
    'BEUVILLERS',
    'CORDEBUGLE',
    'COURTONNE LA MEURDRAC',
    'FAUGUERNON',
    'FIRFOL',
    'GLOS',
    'HERMIVAL LES VAUX',
    'L HOTELLERIE',
    'LISIEUX',
    'MAROLLES',
    'LE MESNIL EUDES',
    'LE MESNIL GUILLAUME',
    'LES MONCEAUX',
    'NOROLLES',
    'OUILLY LE VICOMTE',
    'ROCQUES',
    'ST DENIS DE MAILLOC',
    'ST DESIR',
    'ST GERMAIN DE LIVET',
    'ST JEAN DE LIVET',
    'ST MARTIN DE LA LIEUE',
    'ST MARTIN DE MAILLOC',
    'ST PIERRE DES IFS',
  ],
  14550: ['BLAINVILLE SUR ORNE'],
  14690: [
    'LE BO',
    'COSSESSEVILLE',
    'LE DETROIT',
    'LES ISLES BARDEL',
    'LE MESNIL VILLEMENT',
    'PIERREFITTE EN CINGLAIS',
    'PIERREPONT',
    'LA POMMERAYE',
    'RAPILLY',
    'TREPREL',
    'PONT D OUILLY',
  ],
  14800: [
    'BONNEVILLE SUR TOUQUES',
    'CANAPVILLE',
    'DEAUVILLE',
    'ENGLESQUEVILLE EN AUGE',
    'ST ARNOULT',
    'TOUQUES',
    'TOURGEVILLE',
    'VAUVILLE',
  ],
  14420: ['BONS TASSILLY', 'POTIGNY', 'SOUMONT ST QUENTIN', 'USSY', 'VILLERS CANIVET'],
  14740: ['THUE ET MUE', 'CARCAGNY', 'MOULINS EN BESSIN', 'ROSEL', 'ROTS', 'ST MANVIEU NORREY'],
  14680: ['BRETTEVILLE SUR LAIZE', 'CINTHEAUX', 'FRESNEY LE PUCEUX', 'GOUVIX'],
  14760: ['BRETTEVILLE SUR ODON'],
  14330: [
    'LE BREUIL EN BESSIN',
    'CARTIGNY L EPINAY',
    'ISIGNY SUR MER',
    'LISON',
    'LE MOLAY LITTRY',
    'ST MARCOUF',
    'STE MARGUERITE D ELLE',
    'SAON',
    'SAONNET',
    'TOURNIERES',
  ],
  14160: ['BRUCOURT', 'DIVES SUR MER', 'GRANGUES', 'PERIERS EN AUGE'],
  14390: ['CABOURG', 'PETIVILLE', 'VARAVILLE'],
  14000: ['CAEN'],
  14630: ['CAGNY', 'EMIEVILLE', 'FRENOUVILLE'],
  14230: [
    'LA CAMBE',
    'CANCHY',
    'CARDONVILLE',
    'DEUX JUMEAUX',
    'GEFOSSE FONTENAY',
    'ISIGNY SUR MER',
    'LONGUEVILLE',
    'MONFREVILLE',
    'OSMANVILLE',
    'ST GERMAIN DU PERT',
  ],
  14500: ['CAMPAGNOLLES', 'VIRE NORMANDIE'],
  14650: ['CARPIQUET'],
  14140: [
    'CASTILLON EN AUGE',
    'LESSARD ET LE CHENE',
    'LISORES',
    'LIVAROT PAYS D AUGE',
    'LE MESNIL SIMON',
    'MEZIDON VALLEE D AUGE',
    'PRETREVILLE',
    'VAL DE VIE',
    'ST PIERRE EN AUGE',
  ],
  14290: [
    'CERNAY',
    'COURTONNE LES DEUX EGLISES',
    'LA FOLLETIERE ABENON',
    'LIVAROT PAYS D AUGE',
    'ORBEC',
    'VALORBIQUET',
    'ST MARTIN DE BIENFAITE LA CRESSONNIERE',
    'LA VESPIERE FRIARDEL',
  ],
  14270: [
    'CESNY AUX VIGNES',
    'CONDE SUR IFS',
    'ERNES',
    'MEZIDON VALLEE D AUGE',
    'OUEZY',
    'BELLE VIE EN AUGE',
  ],
  14570: ['CLECY', 'ST LAMBERT', 'ST REMY', 'LE VEY', 'LA VILLETTE'],
  14880: ['COLLEVILLE MONTGOMERY', 'HERMANVILLE SUR MER'],
  14460: ['COLOMBELLES'],
  14520: ['COMMES', 'PORT EN BESSIN HUPPAIN', 'AURE SUR MER'],
  14110: ['CONDE EN NORMANDIE', 'PONTECOULANT', 'ST DENIS DE MERE'],
  14123: ['CORMELLES LE ROYAL', 'FLEURY SUR ORNE', 'IFS'],
  14470: ['COURSEULLES SUR MER', 'GRAYE SUR MER', 'REVIERS'],
  14113: ['CRICQUEBOEUF', 'VILLERVILLE'],
  14450: ['CRICQUEVILLE EN BESSIN', 'GRANDCAMP MAISY', 'ST PIERRE DU MONT'],
  14840: ['CUVERVILLE', 'DEMOUVILLE'],
  14850: ['ESCOVILLE', 'HEROUVILLETTE'],
  14930: ['ETERVILLE', 'MALTOT', 'VIEUX'],
  14320: [
    'FEUGUEROLLES BULLY',
    'FONTENAY LE MARMION',
    'LAIZE CLINCHAMPS',
    'MAY SUR ORNE',
    'ST ANDRE SUR ORNE',
    'ST MARTIN DE FONTENAY',
  ],
  14790: ['FONTAINE ETOUPEFOUR', 'MOUEN', 'VERSON'],
  14590: ['FUMICHON', 'MOYAUX', 'OUILLY DU HOULEY', 'LE PIN'],
  14730: ['GIBERVILLE'],
  14510: ['GONNEVILLE SUR MER', 'HOULGATE'],
  14810: ['GONNEVILLE EN AUGE', 'MERVILLE FRANCEVILLE PLAGE'],
  14200: ['HEROUVILLE ST CLAIR'],
  14830: ['LANGRUNE SUR MER'],
  14780: ['LION SUR MER'],
  14111: ['LOUVIGNY'],
  14530: ['LUC SUR MER'],
  14920: ['MATHIEU'],
  14120: ['MONDEVILLE'],
  14150: ['OUISTREHAM'],
  14980: ['ROTS'],
  14750: ['ST AUBIN SUR MER'],
  14121: ['SALLENELLES'],
  14360: ['TROUVILLE SUR MER'],
  14410: ['VALDALLIERE'],
  14114: ['VER SUR MER'],
  15160: ['ALLANCHE', 'LANDEYRAT', 'PRADIERS', 'VERNOLS', 'VEZE'],
  15100: [
    'ALLEUZE',
    'ANDELAT',
    'ANGLARDS DE ST FLOUR',
    'COREN',
    'MENTIERES',
    'MONTCHAMP',
    'NEUVEGLISE SUR TRUYERE',
    'ROFFIAC',
    'ST FLOUR',
    'ST GEORGES',
    'SOULAGES',
    'TANAVELLE',
    'LES TERNES',
    'TIVIERS',
    'VABRES',
    'VEDRINES ST LOUP',
    'VILLEDIEU',
  ],
  15700: ['ALLY', 'BARRIAC LES BOSQUETS', 'BRAGEAC', 'CHAUSSENAC', 'ESCORAILLES', 'PLEAUX'],
  15380: ['ANGLARDS DE SALERS', 'LE FALGOUX', 'MOUSSAGES', 'ST VINCENT DE SALERS', 'LE VAULMIER'],
  15110: [
    'ANTERRIEUX',
    'CHAUDES AIGUES',
    'DEUX VERGES',
    'ESPINASSE',
    'FRIDEFONT',
    'JABRUN',
    'LIEUTADES',
    'MAURINES',
    'ST MARTIAL',
    'ST REMY DE CHAUDES AIGUES',
    'ST URCIZE',
    'LA TRINITAT',
  ],
  15240: [
    'ANTIGNAC',
    'AUZERS',
    'BASSIGNAC',
    'LA MONSELIE',
    'LE MONTEIL',
    'SAIGNES',
    'SAUVAT',
    'VEBRET',
  ],
  15400: [
    'APCHON',
    'CHEYLADE',
    'LE CLAUX',
    'COLLANDRES',
    'MARCHASTEL',
    'MENET',
    'RIOM ES MONTAGNES',
    'ST ETIENNE DE CHOMEIL',
    'ST HIPPOLYTE',
    'TRIZAC',
    'VALETTE',
  ],
  15200: [
    'ARCHES',
    'CHALVIGNAC',
    'JALEYRAC',
    'MAURIAC',
    'MEALLET',
    'SALINS',
    'SOURNIAC',
    'LE VIGEAN',
  ],
  15150: [
    'ARNAC',
    'CROS DE MONTVERT',
    'GLENAT',
    'LACAPELLE VIESCAMP',
    'LAROQUEBROU',
    'MONTVERT',
    'NIEUDAN',
    'ROUFFIAC',
    'ST ETIENNE CANTALES',
    'ST GERONS',
    'ST SANTIN CANTALES',
    'ST VICTOR',
    'SIRAN',
  ],
  15130: [
    'ARPAJON SUR CERE',
    'CARLAT',
    'CROS DE RONESQUE',
    'GIOU DE MAMOU',
    'LABROUSSE',
    'LAFEUILLADE EN VEZIE',
    'PRUNET',
    'ST ETIENNE DE CARLAT',
    'ST SIMON',
    'SANSAC DE MARMIESSE',
    'TEISSIERES LES BOULIES',
    'VEZAC',
    'VEZELS ROUSSY',
    'YOLET',
    'YTRAC',
  ],
  15500: [
    'AURIAC L EGLISE',
    'BONNAC',
    'CELOUX',
    'LA CHAPELLE LAURENT',
    'CHARMENSAC',
    'CHAZELLES',
    'LASTIC',
    'LAURIE',
    'MASSIAC',
    'MOLEDES',
    'MOLOMPIZE',
    'RAGEADE',
    'ST MARY LE PLAIN',
    'ST PONCY',
    'VIEILLESPESSE',
  ],
  15000: ['AURILLAC', 'YTRAC'],
  15250: [
    'AYRENS',
    'CRANDELLES',
    'JUSSAC',
    'LAROQUEVIEILLE',
    'MARMANHAC',
    'NAUCELLES',
    'REILHAC',
    'ST PAUL DES LANDES',
    'TEISSIERES DE CORNET',
  ],
  15800: [
    'BADAILHAC',
    'JOU SOUS MONJOU',
    'PAILHEROLS',
    'POLMINHAC',
    'RAULHAC',
    'ST CLEMENT',
    'ST JACQUES DES BLATS',
    'THIEZAC',
    'VIC SUR CERE',
  ],
  15270: ['BEAULIEU', 'CHAMPS SUR TARENTAINE MARCHAL', 'LANOBRE', 'TREMOUILLE'],
  15600: [
    'BOISSET',
    'LEYNHAC',
    'MAURS',
    'MONTMURAT',
    'QUEZAC',
    'ROUZIERS',
    'ST CONSTANT FOURNOULES',
    'ST ETIENNE DE MAURS',
    'ST JULIEN DE TOURSAC',
    'ST SANTIN DE MAURS',
    'LE TRIOULOU',
  ],
  15300: [
    'ALBEPIERRE BREDONS',
    'LA CHAPELLE D ALAGNON',
    'DIENNE',
    'LAVEISSENET',
    'LAVEISSIERE',
    'LAVIGERIE',
    'MURAT',
    'NEUSSARGUES EN PINATELLE',
    'SEGUR LES VILLAS',
    'USSEL',
    'VALUEJOLS',
    'VIRARGUES',
  ],
  15230: [
    'BREZONS',
    'CEZENS',
    'GOURDIEGES',
    'LACAPELLE BARRES',
    'MALBO',
    'NARNHAC',
    'PAULHENC',
    'PIERREFORT',
    'STE MARIE',
    'ST MARTIN SOUS VIGOUROUX',
  ],
  15340: ['PUYCAPEL', 'CASSANIOUZE', 'SENEZERGUES'],
  15290: [
    'CAYROLS',
    'OMPS',
    'PARLAN',
    'ROUMEGOUX',
    'ST SAURY',
    'LA SEGALASSIERE',
    'LE ROUGET PERS',
  ],
  15320: ['CHALIERS', 'CLAVIERES', 'LORCIERES', 'VAL D ARCOMIE', 'RUYNES EN MARGERIDE'],
  15350: ['CHAMPAGNAC', 'ST PIERRE', 'VEYRIERES'],
  15190: [
    'CHANTERELLE',
    'CONDAT',
    'LUGARDE',
    'MARCENAT',
    'MONTBOUDIF',
    'MONTGRELEIX',
    'ST AMANDIN',
    'ST BONNET DE CONDAT',
    'ST SATURNIN',
  ],
  15170: [
    'COLTINES',
    'FERRIERES ST MARY',
    'JOURSAC',
    'NEUSSARGUES EN PINATELLE',
    'PEYRUSSE',
    'REZENTIERES',
    'TALIZAT',
    'VALJOUZE',
  ],
  15430: ['CUSSAC', 'PAULHAC'],
  15140: [
    'DRUGEAC',
    'LE FAU',
    'FONTANGES',
    'ST BONNET DE SALERS',
    'ST CHAMANT',
    'ST CIRGUES DE MALBERT',
    'STE EULALIE',
    'ST MARTIN CANTALES',
    'ST MARTIN VALMEROUX',
    'ST PAUL DE SALERS',
    'ST PROJET DE SALERS',
    'SALERS',
    'BESSE',
  ],
  15310: ['FREIX ANGLARDS', 'GIRGOLS', 'ST CERNIN', 'ST ILLIDE', 'TOURNEMIRE'],
  15120: [
    'JUNHAC',
    'LABESSERETTE',
    'LACAPELLE DEL FRAISSE',
    'LADINHAC',
    'LAPEYRUGUE',
    'LEUCAMP',
    'MONTSALVY',
    'SANSAC VEINAZES',
    'VIEILLEVIE',
  ],
  15590: ['LASCELLE', 'MANDAILLES ST JULIEN', 'ST CIRGUES DE JORDANNE', 'VELZIC'],
  43450: [
    'LEYVAUX',
    'AUTRAC',
    'BLESLE',
    'ESPALEM',
    'GRENIER MONTGON',
    'ST ETIENNE SUR BLESLE',
    'TORSIAC',
  ],
  15210: ['MADIC', 'YDES'],
  15220: ['MARCOLES', 'ROANNES ST MARY', 'ST ANTOINE', 'ST MAMET LA SALVETAT', 'VITRAC'],
  15260: ['NEUVEGLISE SUR TRUYERE'],
  16500: [
    'ABZAC',
    'ANSAC SUR VIENNE',
    'BRILLAC',
    'CONFOLENS',
    'ESSE',
    'LESSAC',
    'MANOT',
    'ORADOUR FANAIS',
    'ST MAURICE DES LIONS',
  ],
  16700: [
    'LES ADJOTS',
    'BARRO',
    'BERNAC',
    'BIOUSSAC',
    'CONDAC',
    'COURCOME',
    'LA FAYE',
    'LONDIGNY',
    'NANTEUIL EN VALLEE',
    'POURSAC',
    'RUFFEC',
    'ST GEORGES',
    'ST GOURSON',
    'ST MARTIN DU CLOCHER',
    'SALLES DE VILLEFAGNAN',
    'TAIZE AIZIE',
  ],
  16110: [
    'AGRIS',
    'BUNZAC',
    'MARILLAC LE FRANC',
    'PRANZAC',
    'RIVIERES',
    'LA ROCHEFOUCAULD EN ANGOUMOIS',
    'LA ROCHETTE',
    'TAPONNAT FLEURIGNAC',
    'MOULINS SUR TARDOIRE',
    'YVRAC ET MALLEYRAND',
  ],
  16140: [
    'AIGRE',
    'AMBERAC',
    'BARBEZIERES',
    'BESSE',
    'LA CHAPELLE',
    'CHARME',
    'EBREON',
    'FOUQUEURE',
    'LES GOURS',
    'LIGNE',
    'LUPSAULT',
    'MARCILLAC LANVILLE',
    'MONS',
    'ORADOUR',
    'RANVILLE BREUILLAUD',
    'ST FRAIGNE',
    'TUSSON',
    'VERDILLE',
  ],
  16490: ['ALLOUE', 'AMBERNAC', 'EPENEDE', 'HIESSE', 'PLEUVILLE'],
  16560: ['ANAIS', 'AUSSAC VADALLE', 'COULGENS', 'JAULDES', 'TOURRIERS', 'VILLEJOUBERT'],
  16130: [
    'ANGEAC CHAMPAGNE',
    'ARS',
    'GENSAC LA PALLUE',
    'GENTE',
    'GIMEUX',
    'JUILLAC LE COQ',
    'LIGNIERES AMBLEVILLE',
    'ST FORT SUR LE NE',
    'ST PREUIL',
    'SALLES D ANGLES',
    'SEGONZAC',
    'VERRIERES',
  ],
  16120: [
    'ANGEAC CHARENTE',
    'BASSAC',
    'BIRAC',
    'BONNEUIL',
    'BOUTEVILLE',
    'CHATEAUNEUF SUR CHARENTE',
    'LADIVILLE',
    'BELLEVIGNE',
    'MOSNAC ST SIMEUX',
    'GRAVES ST AMANT',
    'ST SIMON',
    'VIBRAC',
  ],
  16300: [
    'ANGEDUC',
    'BARBEZIEUX ST HILAIRE',
    'BARRET',
    'BRIE SOUS BARBEZIEUX',
    'CHALLIGNAC',
    'CRITEUIL LA MAGDELEINE',
    'GUIMPS',
    'LACHAISE',
    'LAGARDE SUR LE NE',
    'LIGNIERES AMBLEVILLE',
    'MONTMERAC',
    'ST AULAIS LA CHAPELLE',
    'ST BONNET',
    'ST MEDARD',
    'ST PALAIS DU NE',
    'SALLES DE BARBEZIEUX',
    'VIGNOLLES',
  ],
  16000: ['ANGOULEME'],
  16290: ['ASNIERES SUR NOUERE', 'CHAMPMILLON', 'DOUZAT', 'HIERSAC', 'MOULIDARS', 'ST SATURNIN'],
  16390: [
    'AUBETERRE SUR DRONNE',
    'BONNES',
    'LAPRADE',
    'MONTIGNAC LE COQ',
    'NABINAUD',
    'PALLUAUD',
    'PILLAC',
    'ST SEVERIN',
  ],
  16460: [
    'AUNAC SUR CHARENTE',
    'CHENON',
    'COUTURE',
    'LICHERES',
    'MOUTON',
    'MOUTONNEAU',
    'ST FRONT',
    'ST SULPICE DE RUFFEC',
    'VALENCE',
    'VENTOUSE',
  ],
  16360: [
    'BAIGNES STE RADEGONDE',
    'BORS DE BAIGNES',
    'CHANTILLAC',
    'CONDEON',
    'REIGNAC',
    'LE TATRE',
    'TOUVERAC',
  ],
  16430: ['BALZAC', 'CHAMPNIERS', 'VINDELLE'],
  16210: [
    'BARDENAC',
    'BAZAC',
    'BELLON',
    'BRIE SOUS CHALAIS',
    'CHALAIS',
    'COURLAC',
    'CURAC',
    'LES ESSARDS',
    'MEDILLAC',
    'ORIVAL',
    'RIOUX MARTIN',
    'ROUFFIAC',
    'ST AVIT',
    'ST QUENTIN DE CHALAIS',
    'ST ROMAIN',
    'YVIERS',
  ],
  16450: [
    'BEAULIEU SUR SONNETTE',
    'LE GRAND MADIEU',
    'LUSSAC',
    'PARZAC',
    'ST CLAUD',
    'ST LAURENT DE CERIS',
  ],
  16250: [
    'BECHERESSE',
    'BESSAC',
    'COTEAUX DU BLANZACAIS',
    'CHADURIE',
    'CHAMPAGNE VIGNY',
    'ETRIAC',
    'VAL DES VIGNES',
    'PERIGNAC',
    'PLASSAC ROUFFIAC',
    'VOULGEZAC',
  ],
  16350: [
    'BENEST',
    'LE BOUCHAGE',
    'CHAMPAGNE MOUTON',
    'CHASSIECQ',
    'ST COUTANT',
    'TURGON',
    'LE VIEUX CERIER',
    'VIEUX RUFFEC',
  ],
  16480: [
    'BERNEUIL',
    'BOISBRETEAU',
    'BROSSAC',
    'CHATIGNAC',
    'CHILLAC',
    'GUIZENGEARD',
    'ORIOLLES',
    'PASSIRAC',
    'ST FELIX',
    'ST LAURENT DES COMBES',
    'STE SOULINE',
    'ST VALLIER',
    'SAUVIGNAC',
  ],
  16320: [
    'BLANZAGUET ST CYBARD',
    'BOISNE LA TUDE',
    'COMBIERS',
    'EDON',
    'GARDES LE PONTAROUX',
    'GURAT',
    'MAGNAC LAVALETTE VILLARS',
    'RONSENAC',
    'ROUGNAC',
    'VAUX LAVALETTE',
    'VILLEBOIS LAVALETTE',
  ],
  16190: [
    'BORS DE MONTMOREAU',
    'COURGEAC',
    'DEVIAT',
    'JUIGNAC',
    'MONTMOREAU',
    'NONAC',
    'POULLIGNAC',
    'ST MARTIAL',
    'SALLES LAVALETTE',
  ],
  16410: ['BOUEX', 'DIGNAC', 'DIRAC', 'FOUQUEBRUNE', 'GARAT', 'SERS', 'TORSAC', 'VOUZAN'],
  16200: [
    'BOURG CHARENTE',
    'CHASSORS',
    'COURBILLAC',
    'FLEURAC',
    'FOUSSIGNAC',
    'MAINXE GONDEVILLE',
    'HOULETTE',
    'JARNAC',
    'JULIENNE',
    'MERIGNAC',
    'LES METAIRIES',
    'NERCILLAC',
    'REPARSAC',
    'STE SEVERE',
    'SIGOGNE',
    'TRIAC LAUTRAIT',
  ],
  16100: [
    'BOUTIERS ST TROJAN',
    'CHATEAUBERNARD',
    'COGNAC',
    'JAVREZAC',
    'LOUZAC ST ANDRE',
    'MERPINS',
    'ST BRICE',
    'ST LAURENT DE COGNAC',
  ],
  16240: [
    'BRETTES',
    'LA CHEVRERIE',
    'COURCOME',
    'EMPURE',
    'LA FORET DE TESSE',
    'LONGRE',
    'LA MAGDELEINE',
    'MONTJEAN',
    'PAIZAY NAUDOUIN EMBOURIE',
    'RAIX',
    'SOUVIGNE',
    'THEIL RABIER',
    'VILLEFAGNAN',
    'VILLIERS LE ROUX',
  ],
  16370: ['BREVILLE', 'VAL DE COGNAC', 'MESNAC'],
  16590: ['BRIE'],
  16420: ['BRIGUEUIL', 'LESTERPS', 'MONTROLLET', 'ST CHRISTOPHE', 'SAULGOND'],
  16260: ['CELLEFROUIN', 'CHASSENEUIL SUR BONNIEURE', 'LES PINS', 'ST MARY', 'SUAUX', 'LA TACHE'],
  16230: [
    'CELLETTES',
    'FONTENILLE',
    'JUILLE',
    'LONNES',
    'LUXE',
    'MAINE DE BOIXE',
    'MANSLE LES FONTAINES',
    'NANCLARS',
    'PUYREAUX',
    'VAL DE BONNIEURE',
    'ST CIERS SUR BONNIEURE',
    'ST GROUX',
    'VILLOGNON',
  ],
  16150: [
    'CHABANAIS',
    'CHABRAC',
    'CHASSENON',
    'CHIRAC',
    'ETAGNAC',
    'EXIDEUIL SUR VIENNE',
    'PRESSIGNAC',
    'ST QUENTIN SUR CHARENTE',
  ],
  16380: [
    'CHARRAS',
    'CHAZELLES',
    'FEUILLADE',
    'GRASSAC',
    'MAINZAC',
    'MARTHON',
    'ST GERMAIN DE MONTBRON',
    'SOUFFRIGNAC',
  ],
  16310: [
    'CHERVES CHATELARS',
    'LESIGNAC DURAND',
    'LE LINDOIS',
    'MASSIGNAC',
    'MAZEROLLES',
    'MONTEMBOEUF',
    'MOUZON',
    'ROUSSINES',
    'ST ADJUTORY',
    'SAUVAGNAC',
    'VERNEUIL',
    'VITRAC ST VINCENT',
  ],
  16440: ['CLAIX', 'MOUTHIERS SUR BOEME', 'NERSAC', 'ROULLET ST ESTEPHE', 'SIREUIL'],
  16330: [
    'COULONGES',
    'MONTIGNAC CHARENTE',
    'ST AMANT DE BOIXE',
    'VARS',
    'VERVANT',
    'VOUHARTE',
    'XAMBES',
  ],
  16400: ['LA COURONNE', 'PUYMOYEN', 'VOEUIL ET GIGET'],
  16170: [
    'ECHALLAT',
    'GENAC BIGNAC',
    'MAREUIL',
    'ROUILLAC',
    'ST AMANT DE NOUERE',
    'ST CYBARDEAUX',
    'VAL D AUGE',
    'VAUX ROUILLAC',
  ],
  16220: [
    'ECURAS',
    'EYMOUTHIERS',
    'MONTBRON',
    'ORGEDEUIL',
    'ROUZEDE',
    'ST SORNIN',
    'MOULINS SUR TARDOIRE',
    'VOUTHON',
  ],
  16730: ['FLEAC', 'LINARS', 'TROIS PALIS'],
  16160: ['GOND PONTOUVRE'],
  16340: ['L ISLE D ESPAGNAC'],
  16270: ['TERRES DE HAUTE CHARENTE', 'NIEUIL'],
  16600: ['MAGNAC SUR TOUVRE', 'MORNAC', 'RUELLE SUR TOUVRE', 'TOUVRE'],
  16570: ['MARSAC', 'ST GENIS D HIERSAC'],
  16620: ['MONTBOYER'],
  16720: ['ST MEME LES CARRIERES'],
  16470: ['ST MICHEL'],
  16710: ['ST YRIEIX SUR CHARENTE'],
  16800: ['SOYAUX'],
  16510: ['VERTEUIL SUR CHARENTE'],
  17500: [
    'AGUDELLE',
    'ALLAS CHAMPAGNE',
    'CHAMPAGNAC',
    'CLAM',
    'FONTAINES D OZILLAC',
    'GUITINIERES',
    'JONZAC',
    'LEOVILLE',
    'LUSSAC',
    'MEUX',
    'MORTIERS',
    'NEULLES',
    'OZILLAC',
    'REAUX SUR TREFLE',
    'ST GERMAIN DE LUSIGNAN',
    'ST GERMAIN DE VIBRAC',
    'ST HILAIRE DU BOIS',
    'ST MARTIAL DE VITATERNE',
    'ST MEDARD',
    'ST SIMON DE BORDES',
    'VANZAC',
    'VILLEXAVIER',
  ],
  17290: [
    'AIGREFEUILLE D AUNIS',
    'ARDILLIERES',
    'BALLON',
    'CHAMBON',
    'CIRE D AUNIS',
    'FORGES',
    'LANDRAIS',
    'THAIRE',
    'LE THOU',
    'VIRSON',
  ],
  17123: ['ILE D AIX'],
  17150: [
    'ALLAS BOCAGE',
    'BOISREDON',
    'CONSAC',
    'MIRAMBEAU',
    'NIEUL LE VIROUIL',
    'ST BONNET SUR GIRONDE',
    'ST DIZANT DU BOIS',
    'ST GEORGES DES AGOUTS',
    'ST MARTIAL DE MIRAMBEAU',
    'ST SORLIN DE CONAC',
    'ST THOMAS DE CONAC',
    'SEMILLAC',
    'SEMOUSSAC',
    'SOUBRAN',
  ],
  17540: [
    'ANAIS',
    'ANGLIERS',
    'BOUHET',
    'LE GUE D ALLERE',
    'NUAILLE D AUNIS',
    'ST SAUVEUR D AUNIS',
    'VERINES',
  ],
  17230: ['ANDILLY', 'CHARRON', 'LONGEVES', 'MARANS', 'ST OUEN D AUNIS', 'VILLEDOUX'],
  17690: ['ANGOULINS'],
  17350: [
    'ANNEPONT',
    'CRAZANNES',
    'FENIOUX',
    'GRANDJEAN',
    'LE MUNG',
    'PORT D ENVAUX',
    'ST SAVINIEN',
    'TAILLANT',
    'TAILLEBOURG',
  ],
  17380: [
    'ANNEZAY',
    'ARCHINGEAY',
    'CHANTEMERLE SUR LA SOIE',
    'LANDES',
    'NACHAMPS',
    'LES NOUILLERS',
    'PUY DU LAC',
    'PUYROLLAND',
    'ST CREPIN',
    'ST LOUP',
    'TONNAY BOUTONNE',
    'TORXE',
    'LA DEVISE',
  ],
  17400: [
    'ANTEZANT LA CHAPELLE',
    'ASNIERES LA GIRAUD',
    'BIGNAY',
    'COURCELLES',
    'LES EGLISES D ARGENTEUIL',
    'FONTENET',
    'MAZERAY',
    'ESSOUVERT',
    'POURSAY GARNAUD',
    'ST JEAN D ANGELY',
    'ST JULIEN DE L ESCAP',
    'ST MARTIN DE JUILLERS',
    'ST PARDOULT',
    'ST PIERRE DE JUILLERS',
    'TERNANT',
    'VARAIZE',
    'LA VERGNE',
    'VERVANT',
    'VOISSAY',
  ],
  17120: [
    'ARCES',
    'BARZAN',
    'BOUTENAC TOUVENT',
    'BRIE SOUS MORTAGNE',
    'CHENAC ST SEURIN D UZET',
    'COZES',
    'EPARGNES',
    'FLOIRAC',
    'GREZAC',
    'MEURSAC',
    'MORTAGNE SUR GIRONDE',
    'SEMUSSAC',
    'TALMONT SUR GIRONDE',
    'THAIMS',
  ],
  17520: [
    'ARCHIAC',
    'ARTHENAC',
    'BRIE SOUS ARCHIAC',
    'CELLES',
    'CIERZAC',
    'GERMIGNAC',
    'JARNAC CHAMPAGNE',
    'LONZAC',
    'NEUILLAC',
    'ST CIERS CHAMPAGNE',
    'ST EUGENE',
    'STE LHEURINE',
    'ST MAIGRIN',
    'ST MARTIAL SUR NE',
  ],
  17590: ['ARS EN RE', 'ST CLEMENT DES BALEINES'],
  17530: ['ARVERT'],
  17770: [
    'AUJAC',
    'AUMAGNE',
    'AUTHON EBEON',
    'BERCLOUX',
    'BRIZAMBOURG',
    'BURIE',
    'ECOYEUX',
    'JUICQ',
    'MIGRON',
    'NANTILLE',
    'ST BRIS DES BOIS',
    'ST CESAIRE',
    'ST HILAIRE DE VILLEFRANCHE',
    'STE MEME',
    'LE SEURE',
    'VILLARS LES BOIS',
  ],
  17470: [
    'AULNAY',
    'BLANZAY SUR BOUTONNE',
    'CHERBONNIERES',
    'CONTRE',
    'DAMPIERRE SUR BOUTONNE',
    'LOIRE SUR NIE',
    'NUAILLE SUR BOUTONNE',
    'PAILLE',
    'ST GEORGES DE LONGUEPIERRE',
    'ST MANDE SUR BREDOIRE',
    'LA VILLEDIEU',
    'VILLEMORIN',
  ],
  17800: [
    'AVY',
    'BELLUIRE',
    'BIRON',
    'BOUGNEAU',
    'BRIVES SUR CHARENTE',
    'CHADENAC',
    'COULONGES',
    'ECHEBRUNE',
    'FLEAC SUR SEUGNE',
    'MARIGNAC',
    'MAZEROLLES',
    'MONTILS',
    'PERIGNAC',
    'PONS',
    'ROUFFIAC',
    'ST LEGER',
    'ST PALAIS DE PHIOLIN',
    'ST QUANTIN DE RANCANNE',
    'ST SEURIN DE PALENNE',
    'ST SEVER DE SAINTONGE',
    'SALIGNAC SUR CHARENTE',
  ],
  17440: ['AYTRE'],
  17160: [
    'BAGNIZEAU',
    'BALLANS',
    'BLANZAC LES MATHA',
    'BRIE SOUS MATHA',
    'LA BROUSSE',
    'COURCERAC',
    'CRESSE',
    'GIBOURNE',
    'LE GICQ',
    'HAIMPS',
    'LOUZIGNAC',
    'MATHA',
    'MONS',
    'PRIGNAC',
    'SONNAC',
    'THORS',
    'LES TOUCHES DE PERIGNY',
  ],
  17600: [
    'BALANZAC',
    'LE CHAY',
    'LA CLISSE',
    'CORME ECLUSE',
    'CORME ROYAL',
    'L EGUILLE',
    'LE GUA',
    'LUCHAT',
    'MEDIS',
    'NANCRAS',
    'NIEULLE SUR SEUDRE',
    'PISANY',
    'SABLONCEAUX',
    'ST ROMAIN DE BENET',
    'ST SORNIN',
    'SAUJON',
    'THEZAC',
  ],
  17360: ['LA BARDE', 'BOSCAMNANT', 'LA CLOTTE', 'LA GENETOUZE', 'ST AIGULIN', 'ST MARTIN DE COUX'],
  17490: [
    'BAZAUGES',
    'BEAUVAIS SUR MATHA',
    'BRESDON',
    'GOURVILLETTE',
    'MACQUEVILLE',
    'MASSAC',
    'NEUVICQ LE CHATEAU',
    'ST OUEN LA THENE',
    'SIECQ',
  ],
  17620: [
    'BEAUGEAY',
    'CHAMPAGNE',
    'ECHILLAIS',
    'LA GRIPPERIE ST SYMPHORIEN',
    'ST AGNANT',
    'ST JEAN D ANGLE',
  ],
  17210: [
    'BEDENAC',
    'BRAN',
    'BUSSAC FORET',
    'CHATENET',
    'CHEPNIERS',
    'CHEVANCEAUX',
    'MERIGNAC',
    'MONTLIEU LA GARDE',
    'ORIGNOLLES',
    'LE PIN',
    'POLIGNAC',
    'POUILLAC',
    'STE COLOMBE',
    'ST PALAIS DE NEGRIGNAC',
  ],
  17170: [
    'BENON',
    'COURCON',
    'CRAM CHABAN',
    'FERRIERES',
    'LA GREVE SUR MIGNON',
    'LA LAIGNE',
    'LA RONDE',
    'ST CYR DU DORET',
    'ST JEAN DE LIVERSAY',
    'TAUGON',
  ],
  17330: [
    'BERNAY ST MARTIN',
    'COIVERT',
    'COURANT',
    'LA CROIX COMTESSE',
    'DOEUIL SUR LE MIGNON',
    'LA JARRIE AUDOUIN',
    'LOULAY',
    'LOZAY',
    'MIGRE',
    'ST FELIX',
    'ST MARTIAL',
    'ST PIERRE DE L ISLE',
    'ST SEVERIN SUR BOUTONNE',
    'VERGNE',
    'VILLENEUVE LA COMTESSE',
  ],
  17460: [
    'BERNEUIL',
    'CHERMIGNAC',
    'COLOMBIERS',
    'LA JARD',
    'PREGUILLAC',
    'RETAUD',
    'RIOUX',
    'TESSON',
    'THENAC',
    'VARZAY',
  ],
  17250: [
    'BEURLAY',
    'LES ESSARDS',
    'GEAY',
    'PLASSAY',
    'PONT L ABBE D ARNOULT',
    'ROMEGOUX',
    'STE GEMME',
    'ST PORCHAIRE',
    'STE RADEGONDE',
    'ST SULPICE D ARNOULT',
    'SOULIGNONNE',
    'TRIZAY',
    'LA VALLEE',
  ],
  17240: [
    'BOIS',
    'CHAMPAGNOLLES',
    'CLION',
    'FLOIRAC',
    'LORIGNAC',
    'MOSNAC',
    'PLASSAC',
    'ST CIERS DU TAILLON',
    'ST DIZANT DU GUA',
    'ST FORT SUR GIRONDE',
    'ST GENIS DE SAINTONGE',
    'ST GEORGES ANTIGNAC',
    'ST GERMAIN DU SEUDRE',
    'ST GREGOIRE D ARDENNES',
    'STE RAMEE',
    'ST SIGISMOND DE CLERMONT',
  ],
  17580: ['LE BOIS PLAGE EN RE'],
  17430: [
    'BORDS',
    'CABARIOT',
    'CHAMPDOLENT',
    'GENOUILLE',
    'LUSSANT',
    'MORAGNE',
    'MURON',
    'ST COUTANT LE GRAND',
    'ST HIPPOLYTE',
    'TONNAY CHARENTE',
  ],
  17270: [
    'BORESSE ET MARTRON',
    'CERCOUX',
    'CLERAC',
    'LE FOUILLOUX',
    'MONTGUYON',
    'NEUVICQ',
    'ST MARTIN D ARY',
    'ST PIERRE DU PALAIS',
  ],
  17560: ['BOURCEFRANC LE CHAPUS'],
  17220: [
    'BOURGNEUF',
    'CLAVETTE',
    'CROIX CHAPEAU',
    'LA JARNE',
    'LA JARRIE',
    'MONTROY',
    'ST CHRISTOPHE',
    'ST MEDARD D AUNIS',
    'ST ROGATIEN',
    'STE SOULLE',
    'ST VIVIEN',
    'SALLES SUR MER',
  ],
  17700: [
    'BREUIL LA REORTE',
    'MARSAIS',
    'PUYRAVAULT',
    'ST GEORGES DU BOIS',
    'ST PIERRE LA NOUE',
    'ST MARD',
    'ST PIERRE D AMILLY',
    'ST SATURNIN DU BOIS',
    'SURGERES',
    'LA DEVISE',
    'VOUHE',
  ],
  17920: ['BREUILLET'],
  17870: ['BREUIL MAGNE', 'LOIRE LES MARAIS'],
  17100: [
    'BUSSAC SUR CHARENTE',
    'LA CHAPELLE DES POTS',
    'COURCOURY',
    'LE DOUHET',
    'FONTCOUVERTE',
    'LES GONDS',
    'ST VAIZE',
    'SAINTES',
    'VENERAND',
  ],
  17890: ['CHAILLEVETTE'],
  17130: [
    'CHAMOUILLAC',
    'CHARTUZAC',
    'CHAUNAC',
    'CORIGNAC',
    'COURPIGNAC',
    'COUX',
    'EXPIREMONT',
    'JUSSAS',
    'MESSAC',
    'MONTENDRE',
    'POMMIERS MOULONS',
    'ROUFFIGNAC',
    'SALIGNAC DE MIRAMBEAU',
    'SOUMERAS',
    'SOUSMOULINS',
    'TUGERAS ST MAURICE',
    'VIBRAC',
  ],
  17610: ['CHANIERS', 'CHERAC', 'DOMPIERRE SUR CHARENTE', 'ST SAUVANT'],
  17480: ['LE CHATEAU D OLERON'],
  17340: ['CHATELAILLON PLAGE', 'YVES'],
  17510: [
    'CHIVES',
    'LES EDUTS',
    'FONTAINE CHALENDRAY',
    'NERE',
    'ROMAZIERES',
    'SALEIGNES',
    'SEIGNE',
    'VILLIERS COUTURE',
    'VINAX',
  ],
  17670: ['LA COUARDE SUR MER'],
  17260: [
    'CRAVANS',
    'GEMOZAC',
    'GIVREZAC',
    'JAZENNES',
    'MONTPELLIER DE MEDILLAN',
    'ST ANDRE DE LIDON',
    'ST SIMON DE PELLOUAILLE',
    'TANZAC',
    'VILLARS EN PONS',
    'VIROLLET',
  ],
  17550: ['DOLUS D OLERON'],
  17139: ['DOMPIERRE SUR MER'],
  17810: ['ECURAT', 'NIEUL LES SAINTES', 'PESSINES', 'ST GEORGES DES COTEAUX'],
  17137: ['ESNANDES', 'L HOUMEAU', 'MARSILLY', 'NIEUL SUR MER'],
  17750: ['ETAULES'],
  17630: ['LA FLOTTE'],
  17450: ['FOURAS', 'ST LAURENT DE LA PREE'],
  17140: ['LAGORD'],
  17111: ['LOIX'],
  17320: ['MARENNES HIERS BROUAGE', 'ST JUST LUZAC'],
  17570: ['LES MATHES', 'ST AUGUSTIN'],
  17132: ['MESCHERS SUR GIRONDE'],
  17780: ['MOEZE', 'ST FROULT', 'ST NAZAIRE SUR CHARENTE', 'SOUBISE'],
  17113: ['MORNAC SUR SEUDRE'],
  17180: ['PERIGNY'],
  17880: ['LES PORTES EN RE'],
  17138: ['PUILBOREAU', 'ST XANDRE'],
  17940: ['RIVEDOUX PLAGE'],
  17300: ['ROCHEFORT', 'VERGEROUX'],
  17000: ['LA ROCHELLE'],
  17200: ['ROYAN', 'ST SULPICE DE ROYAN'],
  17650: ['ST DENIS D OLERON'],
  17110: ['ST GEORGES DE DIDONNE'],
  17190: ['ST GEORGES D OLERON'],
  17740: ['STE MARIE DE RE'],
  17410: ['ST MARTIN DE RE'],
  17420: ['ST PALAIS SUR MER'],
  17310: ['ST PIERRE D OLERON'],
  17370: ['ST TROJAN LES BAINS', 'LE GRAND VILLAGE PLAGE'],
  17390: ['LA TREMBLADE'],
  17640: ['VAUX SUR MER'],
  17730: ['PORT DES BARQUES'],
  17840: ['LA BREE LES BAINS'],
  18250: [
    'ACHERES',
    'LA CHAPELOTTE',
    'HENRICHEMONT',
    'HUMBLIGNY',
    'MONTIGNY',
    'NEUILLY EN SANCERRE',
    'NEUVY DEUX CLOCHERS',
  ],
  18200: [
    'AINAY LE VIEIL',
    'ARCOMPS',
    'ARPHEUILLES',
    'BOUZAIS',
    'BRUERE ALLICHAMPS',
    'LA CELLE',
    'COLOMBIERS',
    'DREVANT',
    'FARGES ALLICHAMPS',
    'LA GROUTTE',
    'MEILLANT',
    'NOZIERES',
    'ORCENAIS',
    'ORVAL',
    'LA PERCHE',
    'ST AMAND MONTROND',
    'ST GEORGES DE POISIEUX',
  ],
  18220: [
    'LES AIX D ANGILLON',
    'AUBINGES',
    'AZY',
    'BRECY',
    'MOROGUES',
    'PARASSY',
    'RIANS',
    'ST CEOLS',
    'STE SOLANGE',
    'SOULANGIS',
  ],
  18110: [
    'ALLOGNY',
    'FUSSY',
    'PIGNY',
    'QUANTILLY',
    'ST ELOY DE GY',
    'ST GEORGES SUR MOULON',
    'ST MARTIN D AUXIGNY',
    'ST PALAIS',
    'VASSELAY',
    'VIGNOUX SOUS LES AIX',
  ],
  18500: [
    'ALLOUIS',
    'BERRY BOUY',
    'FOECY',
    'MARMAGNE',
    'MEHUN SUR YEVRE',
    'STE THORETTE',
    'VIGNOUX SUR BARANGEON',
  ],
  18340: [
    'ANNOIX',
    'ARCAY',
    'CORQUOY',
    'CROSSES',
    'LAPAN',
    'LEVET',
    'LISSAY LOCHY',
    'PLAIMPIED GIVAUDINS',
    'ST GERMAIN DES BOIS',
    'ST JUST',
    'SENNECAY',
    'SOYE EN SEPTAINE',
    'VORLY',
  ],
  18150: [
    'APREMONT SUR ALLIER',
    'LA CHAPELLE HUGON',
    'LE CHAUTAY',
    'CUFFY',
    'GERMIGNY L EXEMPT',
    'LA GUERCHE SUR L AUBOIS',
  ],
  18170: [
    'ARDENAIS',
    'LE CHATELET',
    'IDS ST ROCH',
    'LOYE SUR ARNON',
    'MAISONNAIS',
    'MARCAIS',
    'MORLAC',
    'REZAY',
    'ST PIERRE LES BOIS',
  ],
  18410: ['ARGENT SUR SAULDRE', 'BLANCAFORT', 'BRINON SUR SAULDRE', 'CLEMONT'],
  18140: [
    'ARGENVIERES',
    'LA CHAPELLE MONTLINARD',
    'CHARENTONNAY',
    'CHAUMOUX MARCILLY',
    'COUY',
    'GARIGNY',
    'GROISES',
    'HERRY',
    'JUSSY LE CHAUDRIER',
    'LUGNY CHAMPAGNE',
    'PRECY',
    'ST LEGER LE PETIT',
    'ST MARTIN DES CHAMPS',
    'SANCERGUES',
    'SEVRY',
  ],
  18260: [
    'ASSIGNY',
    'BARLIEU',
    'CONCRESSAULT',
    'DAMPIERRE EN CROT',
    'JARS',
    'LE NOYER',
    'SUBLIGNY',
    'SURY ES BOIS',
    'THOU',
    'VAILLY SUR SAULDRE',
    'VILLEGENON',
  ],
  18700: ['AUBIGNY SUR NERE', 'MENETREOL SUR SAULDRE', 'OIZON', 'STE MONTAINE'],
  18600: [
    'AUGY SUR AUBOIS',
    'GIVARDON',
    'GROSSOUVRE',
    'MORNAY SUR ALLIER',
    'NEUILLY EN DUN',
    'NEUVY LE BARROIS',
    'SAGONNE',
    'ST AIGNAN DES NOYERS',
    'SANCOINS',
    'VEREAUX',
  ],
  18520: ['AVORD', 'BENGY SUR CRAON'],
  18300: [
    'BANNAY',
    'BUE',
    'COUARGUES',
    'CREZANCY EN SANCERRE',
    'FEUX',
    'GARDEFORT',
    'JALOGNES',
    'MENETOU RATEL',
    'MENETREOL SOUS SANCERRE',
    'ST BOUIZE',
    'ST SATUR',
    'SANCERRE',
    'SENS BEAUJEU',
    'SURY EN VAUX',
    'THAUVENAY',
    'VEAUGUES',
    'VERDIGNY',
    'VINON',
  ],
  18210: [
    'BANNEGON',
    'BESSAIS LE FROMENTAL',
    'CHARENTON DU CHER',
    'COUST',
    'LE PONDY',
    'ST PIERRE LES ETIEUX',
    'THAUMIERS',
    'VERNAIS',
    'VERNEUIL',
  ],
  18800: ['BAUGY', 'CHASSY', 'ETRECHY', 'FARGES EN SEPTAINE', 'GRON', 'VILLABON', 'VILLEQUIERS'],
  18370: [
    'BEDDES',
    'CHATEAUMEILLANT',
    'PREVERANGES',
    'ST JEANVRIN',
    'ST PRIEST LA MARCHE',
    'ST SATURNIN',
  ],
  18320: [
    'BEFFES',
    'COURS LES BARRES',
    'JOUET SUR L AUBOIS',
    'MARSEILLES LES AUBIGNY',
    'MENETOU COUTURE',
    'ST HILAIRE DE GONDILLY',
    'TORTERON',
  ],
  18240: [
    'BELLEVILLE SUR LOIRE',
    'BOULLERET',
    'LERE',
    'STE GEMME EN SANCERROIS',
    'SANTRANGES',
    'SAVIGNY EN SANCERRE',
    'SURY PRES LERE',
  ],
  18350: [
    'BLET',
    'CHARLY',
    'CHAUMONT',
    'CORNUSSE',
    'CROISY',
    'FLAVIGNY',
    'IGNOL',
    'MORNAY BERRY',
    'NERONDES',
    'OSMERY',
    'OUROUER LES BOURDELINS',
    'ST HILAIRE DE GONDILLY',
    'TENDRON',
  ],
  18000: ['BOURGES'],
  18120: [
    'BRINAY',
    'CERBOIS',
    'CHERY',
    'LAZENAY',
    'LIMEUX',
    'LURY SUR ARNON',
    'MASSAY',
    'MEREAU',
    'PREUILLY',
    'QUINCY',
  ],
  18130: [
    'BUSSY',
    'CHALIVOY MILON',
    'COGNY',
    'CONTRES',
    'DUN SUR AURON',
    'JUSSY CHAMPAGNE',
    'LANTAN',
    'OSMERY',
    'PARNAY',
    'RAYMOND',
    'ST DENIS DE PALIN',
    'VORNAY',
  ],
  18360: [
    'LA CELETTE',
    'EPINEUIL LE FLEURIEL',
    'FAVERDINES',
    'ST VITTE',
    'SAULZAIS LE POTIER',
    'VESDUN',
  ],
  18160: [
    'LA CELLE CONDE',
    'CHEZAL BENOIT',
    'INEUIL',
    'LIGNIERES',
    'MONTLOUIS',
    'ST BAUDEL',
    'ST HILAIRE EN LIGNIERES',
    'TOUCHAY',
    'VILLECELIN',
  ],
  18190: [
    'CHAMBON',
    'CHATEAUNEUF SUR CHER',
    'CHAVANNES',
    'CORQUOY',
    'CREZANCAY SUR CHER',
    'ST LOUP DES CHAUMES',
    'ST SYMPHORIEN',
    'SERRUELLES',
    'UZAY LE VENON',
    'VALLENAY',
    'VENESMES',
  ],
  18380: ['LA CHAPELLE D ANGILLON', 'ENNORDRES', 'IVOY LE PRE', 'MERY ES BOIS', 'PRESLY'],
  18570: ['LA CHAPELLE ST URSIN', 'MORTHOMIERS', 'LE SUBDRAY', 'TROUY'],
  18290: ['CHAROST', 'CIVRAY', 'MAREUIL SUR ARNON', 'PLOU', 'POISIEUX', 'ST AMBROIX', 'SAUGY'],
  18270: ['CULAN', 'REIGNY', 'ST CHRISTOPHE LE CHAUDRY', 'ST MAUR', 'SIDIAILLES'],
  18310: ['DAMPIERRE EN GRACAY', 'GENOUILLY', 'GRACAY', 'NOHANT EN GRACAY', 'ST OUTRILLE'],
  18400: ['LUNERY', 'PRIMELLES', 'ST CAPRAIS', 'ST FLORENT SUR CHER', 'VILLENEUVE SUR CHER'],
  18510: ['MENETOU SALON'],
  18100: ['MERY SUR CHER', 'ST GEORGES SUR LA PREE', 'ST HILAIRE DE COURT', 'THENIOUX', 'VIERZON'],
  18390: [
    'MOULINS SUR YEVRE',
    'NOHANT EN GOUT',
    'OSMOY',
    'ST GERMAIN DU PUY',
    'ST MICHEL DE VOLANGIS',
    'SAVIGNY EN SEPTAINE',
  ],
  18330: ['NANCAY', 'NEUVY SUR BARANGEON', 'ST LAURENT', 'VOUZERON'],
  18230: ['ST DOULCHARD'],
  19260: ['AFFIEUX', 'PEYRISSAC', 'RILHAC TREIGNAC', 'TREIGNAC', 'VEIX'],
  19200: [
    'AIX',
    'ALLEYRAT',
    'CHAVEROCHE',
    'LIGNAREIX',
    'MARGERIDES',
    'MESTES',
    'CONFOLENT PORT DIEU',
    'ST ANGEL',
    'ST BONNET PRES BORT',
    'ST ETIENNE AUX CLOS',
    'ST EXUPERY LES ROCHES',
    'ST FREJOUX',
    'ST PARDOUX LE NEUF',
    'ST PARDOUX LE VIEUX',
    'ST VICTOUR',
    'THALAMY',
    'USSEL',
    'VALIERGUES',
    'VEYRIERES',
  ],
  19190: [
    'ALBIGNAC',
    'AUBAZINES',
    'BEYNAT',
    'LE CHASTANG',
    'LANTEUIL',
    'MENOIRE',
    'PALAZINGES',
    'LE PESCHER',
    'SERILHAC',
  ],
  19380: ['ALBUSSAC', 'FORGES', 'NEUVILLE', 'ST BONNET ELVERT', 'ST CHAMANT', 'ST SYLVAIN'],
  19240: ['ALLASSAC', 'ST VIANCE', 'VARETZ'],
  19120: [
    'ALTILLAC',
    'ASTAILLAC',
    'BEAULIEU SUR DORDOGNE',
    'BILHAC',
    'LA CHAPELLE AUX SAINTS',
    'CHENAILLER MASCHEIX',
    'LIOURDRES',
    'NONARDS',
    'PUY D ARNAC',
    'QUEYSSAC LES VIGNES',
    'SIONIAC',
    'TUDEILS',
    'VEGENNES',
  ],
  19250: ['AMBRUGEAT', 'COMBRESSOL', 'DAVIGNAC', 'MAUSSAC', 'MEYMAC', 'ST SULPICE LES BOIS'],
  19000: ['LES ANGLES SUR CORREZE', 'TULLE'],
  19320: [
    'ARGENTAT SUR DORDOGNE',
    'CHAMPAGNAC LA NOAILLE',
    'CHAMPAGNAC LA PRUNE',
    'CLERGOUX',
    'GROS CHASTANG',
    'GUMOND',
    'LAFAGE SUR SOMBRE',
    'MARCILLAC LA CROISILLE',
    'LA ROCHE CANILLAC',
    'ST MARTIN LA MEANNE',
    'ST MERD DE LAPLEAU',
    'ST PARDOUX LA CROISILLE',
  ],
  19400: [
    'ARGENTAT SUR DORDOGNE',
    'HAUTEFAGE',
    'MONCEAUX SUR DORDOGNE',
    'ST HILAIRE TAURIEUX',
    'ST MARTIAL ENTRAYGUES',
  ],
  19230: [
    'ARNAC POMPADOUR',
    'BEYSSAC',
    'BEYSSENAC',
    'ST SORNIN LAVOLPS',
    'SEGUR LE CHATEAU',
    'TROCHE',
  ],
  19220: [
    'AURIAC',
    'BASSIGNAC LE HAUT',
    'DARAZAC',
    'RILHAC XAINTRIE',
    'ST CIRGUES LA LOUTRE',
    'ST GENIEZ O MERLE',
    'ST JULIEN AUX BOIS',
    'ST PRIVAT',
    'SERVIERES LE CHATEAU',
  ],
  19310: [
    'AYEN',
    'BRIGNAC LA PLAINE',
    'LOUIGNAC',
    'PERPEZAC LE BLANC',
    'ST ROBERT',
    'SEGONZAC',
    'YSSANDON',
  ],
  19800: [
    'BAR',
    'CORREZE',
    'EYREIN',
    'GIMEL LES CASCADES',
    'MEYRIGNAC L EGLISE',
    'ST PRIEST DE GIMEL',
    'SARRAN',
    'VITRAC SUR MONTANE',
  ],
  19430: [
    'BASSIGNAC LE BAS',
    'CAMPS ST MATHURIN LEOBAZEL',
    'LA CHAPELLE ST GERAUD',
    'GOULLES',
    'MERCOEUR',
    'REYGADE',
    'ST BONNET LES TOURS DE MERLE',
    'ST JULIEN LE PELERIN',
    'SEXCLES',
  ],
  19390: ['BEAUMONT', 'CHAUMEIL', 'ORLIAC DE BAR', 'ST AUGUSTIN'],
  19290: [
    'BELLECHASSAGNE',
    'CHAVANAC',
    'MILLEVACHES',
    'PEYRELEVADE',
    'ST GERMAIN LAVOLPS',
    'ST REMY',
    'ST SETIERS',
    'SORNAC',
  ],
  19510: ['BENAYES', 'LAMONGERIE', 'MASSERET', 'MEILHARDS', 'SALON LA TOUR'],
  19170: [
    'BONNEFOND',
    'BUGEAT',
    'L EGLISE AUX BOIS',
    'GOURDON MURAT',
    'LACELLE',
    'LESTARDS',
    'PEROLS SUR VEZERE',
    'PRADINES',
    'ST HILAIRE LES COURBES',
    'ST MERD LES OUSSINES',
    'TARNAC',
    'TOY VIAM',
    'VIAM',
  ],
  19110: ['BORT LES ORGUES', 'MONESTIER PORT DIEU', 'SARROUX ST JULIEN'],
  19500: [
    'BRANCEILLES',
    'CHAUFFOUR SUR VELL',
    'COLLONGES LA ROUGE',
    'CUREMONTE',
    'JUGEALS NAZARETH',
    'LAGLEYGEOLLE',
    'LIGNEYRAC',
    'LOSTANGES',
    'MARCILLAC LA CROZE',
    'MEYSSAC',
    'NOAILHAC',
    'SAILLAC',
    'ST BAZILE DE MEYSSAC',
    'ST JULIEN MAUMONT',
    'TURENNE',
  ],
  19100: ['BRIVE LA GAILLARDE'],
  19350: ['CHABRIGNAC', 'CONCEZE', 'JUILLAC', 'ROSIERS DE JUILLAC'],
  19370: ['CHAMBERET', 'SOUDAINE LAVINADIERE'],
  19450: ['CHAMBOULIVE', 'PIERREFITTE'],
  19330: ['CHAMEYRAT', 'CHANTEIX', 'FAVARS', 'ST GERMAIN LES VERGNES', 'ST MEXANT'],
  19150: [
    'CHANAC LES MINES',
    'CORNIL',
    'ESPAGNAC',
    'LADIGNAC SUR RONDELLES',
    'LAGARDE MARC LA TOUR',
    'LAGUENNE SUR AVALOUZE',
    'PANDRIGNES',
    'ST MARTIAL DE GIMEL',
    'ST PAUL',
  ],
  19360: ['LA CHAPELLE AUX BROCS', 'COSNAC', 'DAMPNIAT', 'MALEMORT'],
  19300: [
    'CHAPELLE SPINASSE',
    'DARNETS',
    'EGLETONS',
    'GRANDSAIGNE',
    'MONTAIGNAC SUR DOUSTRE',
    'MOUSTIER VENTADOUR',
    'PERET BEL AIR',
    'ROSIERS D EGLETONS',
    'ST YRIEIX LE DEJALAT',
    'SOUDEILLES',
  ],
  19600: [
    'CHARTRIER FERRIERE',
    'CHASTEAUX',
    'ESTIVALS',
    'LARCHE',
    'LISSAC SUR COUZE',
    'NESPOULS',
    'NOAILLES',
    'ST CERNIN DE LARCHE',
    'ST PANTALEON DE LARCHE',
  ],
  19160: [
    'CHIRAC BELLEVUE',
    'LAMAZIERE BASSE',
    'LATRONCHE',
    'LIGINIAC',
    'NEUVIC',
    'PALISSE',
    'ROCHE LE PEYROUX',
    'ST ETIENNE LA GENESTE',
    'ST HILAIRE LUC',
    'STE MARIE LAPANOUZE',
    'ST PANTALEON DE LAPLEAU',
    'SERANDON',
  ],
  19140: ['CONDAT SUR GANAVEIX', 'ESPARTIGNAC', 'EYBURIE', 'ST YBARD', 'UZERCHE'],
  19340: [
    'COUFFY SUR SARSONNE',
    'COURTEIX',
    'EYGURANDE',
    'FEYT',
    'LAMAZIERE HAUTE',
    'LAROCHE PRES FEYT',
    'MERLINES',
    'MONESTIER MERLINES',
  ],
  19520: ['CUBLAC', 'MANSAC'],
  19270: ['DONZENAC', 'SADROC', 'STE FEREOLE', 'ST PARDOUX L ORTIGIER', 'USSAC'],
  19410: ['ESTIVAUX', 'ORGNAC SUR VEZERE', 'PERPEZAC LE NOIR', 'ST BONNET L ENFANTIER', 'VIGEOIS'],
  19700: ['LAGRAULIERE', 'ST CLEMENT', 'ST JAL', 'ST SALVADOUR', 'SEILHAC'],
  19550: ['LAPLEAU', 'LAVAL SUR LUZEGE', 'ST HILAIRE FOISSAC', 'SOURSAC'],
  19130: [
    'LASCAUX',
    'OBJAT',
    'ST AULAIRE',
    'ST BONNET LA RIVIERE',
    'ST CYPRIEN',
    'ST CYR LA ROCHE',
    'ST SOLVE',
    'VARS SUR ROSEIX',
    'VIGNOLS',
    'VOUTEZAC',
  ],
  19470: ['LE LONZAC', 'MADRANGES'],
  19210: [
    'LUBERSAC',
    'MONTGIBAUD',
    'ST ELOY LES TUILERIES',
    'ST JULIEN LE VENDOMOIS',
    'ST MARTIN SEPERT',
    'ST PARDOUX CORBIER',
  ],
  19460: ['NAVES'],
  19490: ['STE FORTUNADE'],
  19560: ['ST HILAIRE PEYROUX'],
  21700: [
    'AGENCOURT',
    'ARCENANT',
    'ARGILLY',
    'BAGNOT',
    'BONCOURT LE BOIS',
    'CHAUX',
    'COMBLANCHIEN',
    'CORGOLOIN',
    'FUSSEY',
    'GERLAND',
    'MAGNY LES VILLERS',
    'MAREY LES FUSSEY',
    'MEUILLEY',
    'NUITS ST GEORGES',
    'PREMEAUX PRISSEY',
    'QUINCEY',
    'ST BERNARD',
    'ST NICOLAS LES CITEAUX',
    'VILLARS FONTAINE',
    'VILLEBICHOT',
    'VILLERS LA FAYE',
    'VOSNE ROMANEE',
  ],
  21410: [
    'AGEY',
    'ANCEY',
    'ARCEY',
    'BARBIREY SUR OUCHE',
    'BAULME LA ROCHE',
    'FLEUREY SUR OUCHE',
    'GERGUEIL',
    'GISSEY SUR OUCHE',
    'MALAIN',
    'PRALON',
    'ST JEAN DE BOEUF',
    'STE MARIE SUR OUCHE',
    'ST VICTOR SUR OUCHE',
  ],
  21121: [
    'AHUY',
    'DAIX',
    'DAROIS',
    'ETAULES',
    'FONTAINE LES DIJON',
    'HAUTEVILLE LES DIJON',
    'VAL SUZON',
  ],
  21510: [
    'AIGNAY LE DUC',
    'BEAULIEU',
    'BEAUNOTTE',
    'BELLENOD SUR SEINE',
    'BUSSEAUT',
    'DUESME',
    'ECHALOT',
    'ETALANTE',
    'MAUVILLY',
    'MEULSON',
    'MINOT',
    'MOITRON',
    'ORIGNY',
    'QUEMIGNY SUR SEINE',
    'ROCHEFORT SUR BREVON',
    'ST GERMAIN LE ROCHEUX',
  ],
  21110: [
    'AISEREY',
    'BEIRE LE FORT',
    'BESSEY LES CITEAUX',
    'BRETENIERE',
    'CESSEY SUR TILLE',
    'CHAMBEIRE',
    'COLLONGES ET PREMIERES',
    'ECHIGEY',
    'FAUVERNEY',
    'GENLIS',
    'IZEURE',
    'IZIER',
    'LABERGEMENT FOIGNEY',
    'LONGCHAMP',
    'LONGEAULT PLUVAULT',
    'LONGECOURT EN PLAINE',
    'MAGNY SUR TILLE',
    'MARLIENS',
    'PLUVET',
    'ROUVRES EN PLAINE',
    'SOIRANS',
    'TART LE BAS',
    'TART',
    'THOREY EN PLAINE',
    'VARANGES',
  ],
  21400: [
    'AISEY SUR SEINE',
    'AMPILLY LE SEC',
    'BREMUR ET VAUROIS',
    'BUNCEY',
    'CHAMESSON',
    'CHARREY SUR SEINE',
    'CHATILLON SUR SEINE',
    'CHAUMONT LE BOIS',
    'CHEMIN D AISEY',
    'COULMIER LE SEC',
    'ETROCHEY',
    'GOMMEVILLE',
    'MAISEY LE DUC',
    'MASSINGY',
    'MONTLIOT ET COURCELLES',
    'MOSSON',
    'NOD SUR SEINE',
    'NOIRON SUR SEINE',
    'OBTREE',
    'POTHIERES',
    'PRUSLY SUR OURCE',
    'PUITS',
    'STE COLOMBE SUR SEINE',
    'VANNAIRE',
    'VANVEY',
    'VILLERS PATRAS',
    'VILLIERS LE DUC',
    'VILLOTTE SUR OURCE',
    'VIX',
  ],
  21390: [
    'AISY SOUS THIL',
    'BRAUX',
    'BRIANNY',
    'CLAMEREY',
    'DOMPIERRE EN MORVAN',
    'LE VAL LARREY',
    'FONTANGY',
    'MARCIGNY SOUS THIL',
    'MONTIGNY ST BARTHELEMY',
    'NAN SOUS THIL',
    'NOIDAN',
    'NORMIER',
    'PRECY SOUS THIL',
    'ROILLY',
    'VIC SOUS THIL',
  ],
  21150: [
    'ALISE STE REINE',
    'BUSSY LE GRAND',
    'CHASSEY',
    'CORPOYER LA CHAPELLE',
    'DARCEY',
    'FLAVIGNY SUR OZERAIN',
    'FROLOIS',
    'GISSEY SOUS FLAVIGNY',
    'GRESIGNY STE REINE',
    'GRIGNON',
    'HAUTEROCHE',
    'JAILLY LES MOULINS',
    'LUCENAY LE DUC',
    'MARIGNY LE CAHOUET',
    'MENETREUX LE PITOIS',
    'MUSSY LA FOSSE',
    'POUILLENAY',
    'LA ROCHE VANNEAU',
    'SEIGNY',
    'THENISSEY',
    'VENAREY LES LAUMES',
  ],
  21230: [
    'ALLEREY',
    'ANTIGNY LA VILLE',
    'ARNAY LE DUC',
    'CHAMPIGNOLLES',
    'CLOMOT',
    'CULETRE',
    'CUSSY LE CHATEL',
    'LE FETE',
    'FOISSY',
    'JOUEY',
    'LACANCHE',
    'LONGECOURT LES CULETRE',
    'MAGNIEN',
    'MALIGNY',
    'MIMEURE',
    'MUSIGNY',
    'ST PIERRE EN VAUX',
    'ST PRIX LES ARNAY',
    'VIEVY',
    'VOUDENAY',
  ],
  21420: ['ALOXE CORTON', 'BOUILLAND', 'ECHEVRONNE', 'PERNAND VERGELESSES', 'SAVIGNY LES BEAUNE'],
  21450: [
    'AMPILLY LES BORDES',
    'BAIGNEUX LES JUIFS',
    'BILLY LES CHANCEAUX',
    'CHAUME LES BAIGNEUX',
    'ETORMAY',
    'FONTAINES EN DUESMOIS',
    'JOURS LES BAIGNEUX',
    'MAGNY LAMBERT',
    'OIGNY',
    'ORRET',
    'POISEUL LA VILLE ET LAPERRIERE',
    'ST MARC SUR SEINE',
    'SEMOND',
    'VILLAINES EN DUESMOIS',
    'LA VILLENEUVE LES CONVERS',
  ],
  21360: [
    'ANTHEUIL',
    'AUBAINE',
    'AUXANT',
    'BESSEY EN CHAUME',
    'BESSEY LA COUR',
    'BLIGNY SUR OUCHE',
    'BOUHEY',
    'LA BUSSIERE SUR OUCHE',
    'CHAUDENAY LA VILLE',
    'CHAUDENAY LE CHATEAU',
    'COLOMBIER',
    'CRUGEY',
    'CUSSY LA COLONNE',
    'ECUTIGNY',
    'LUSIGNY SUR OUCHE',
    'MONTCEAU ET ECHARNANT',
    'PAINBLANC',
    'SAUSSEY',
    'THOMIREY',
    'THOREY SUR OUCHE',
    'VEILLY',
    'VEUVEY SUR OUCHE',
    'VIC DES PRES',
  ],
  21310: [
    'ARCEAU',
    'BEAUMONT SUR VINGEANNE',
    'BEIRE LE CHATEL',
    'BELLENEUVE',
    'BEZE',
    'BEZOUOTTE',
    'BLAGNY SUR VINGEANNE',
    'CHAMPAGNE SUR VINGEANNE',
    'CHARMES',
    'CHEUGE',
    'CUISEREY',
    'DAMPIERRE ET FLEE',
    'JANCIGNY',
    'MAGNY ST MEDARD',
    'MIREBEAU SUR BEZE',
    'NOIRON SUR BEZE',
    'OISILLY',
    'RENEVE',
    'SAVOLLES',
    'TANAY',
    'TROCHERES',
    'VIEVIGNE',
  ],
  21320: [
    'ARCONCEY',
    'BELLENOT SOUS POUILLY',
    'BEUREY BAUGUAY',
    'BLANCEY',
    'CHAILLY SUR ARMANCON',
    'CHATEAUNEUF',
    'CHATELLENOT',
    'CHAZILLY',
    'CIVRY EN MONTAGNE',
    'COMMARIN',
    'CREANCEY',
    'EGUILLY',
    'ESSEY',
    'MACONGE',
    'MARCILLY OGNY',
    'MARTROIS',
    'MEILLY SUR ROUVRES',
    'MONT ST JEAN',
    'POUILLY EN AUXOIS',
    'ROUVRES SOUS MEILLY',
    'STE SABINE',
    'SEMAREY',
    'THOISY LE DESERT',
    'VANDENESSE EN AUXOIS',
  ],
  21560: ['ARC SUR TILLE', 'BRESSEY SUR TILLE', 'COUTERNON', 'REMILLY SUR TILLE'],
  21350: [
    'ARNAY SOUS VITTEAUX',
    'AVOSNES',
    'BEURIZOT',
    'BOUSSEY',
    'BRAIN',
    'CHARNY',
    'DAMPIERRE EN MONTAGNE',
    'GISSEY LE VIEIL',
    'MARCELLOIS',
    'MARCILLY ET DRACY',
    'MASSINGY LES VITTEAUX',
    'POSANGES',
    'SAFFRES',
    'STE COLOMBE EN AUXOIS',
    'ST THIBAULT',
    'SOUSSEY SUR BRIONNE',
    'THOREY SOUS CHARNY',
    'UNCEY LE FRANC',
    'VELOGNY',
    'VESVRES',
    'VILLEBERNY',
    'VILLEFERRY',
    'VILLY EN AUXOIS',
    'VITTEAUX',
  ],
  21500: [
    'ARRANS',
    'ASNIERES EN MONTAGNE',
    'ATHIE',
    'BENOISEY',
    'BUFFON',
    'CHAMP D OISEAU',
    'COURCELLES LES MONTBARD',
    'CREPAND',
    'ERINGES',
    'ETAIS',
    'FAIN LES MONTBARD',
    'FAIN LES MOUTIERS',
    'FRESNES',
    'MARMAGNE',
    'MONTBARD',
    'MONTIGNY MONTFORT',
    'MOUTIERS ST JEAN',
    'NOGENT LES MONTBARD',
    'PLANAY',
    'QUINCEROT',
    'QUINCY LE VICOMTE',
    'ROUGEMONT',
    'ST GERMAIN LES SENAILLY',
    'ST REMY',
    'SAVOISY',
    'SENAILLY',
    'TOUILLON',
    'VILLAINES LES PREVOTES',
    'VISERNY',
  ],
  21380: [
    'ASNIERES LES DIJON',
    'CURTIL ST SEINE',
    'EPAGNY',
    'MARSANNAY LE BOIS',
    'MESSIGNY ET VANTOUX',
    'SAUSSY',
    'SAVIGNY LE SEC',
  ],
  21130: [
    'ATHEE',
    'AUXONNE',
    'BILLEY',
    'CHAMPDOTRE',
    'FLAGEY LES AUXONNE',
    'FLAMMERANS',
    'LABERGEMENT LES AUXONNE',
    'MAGNY MONTARLOT',
    'LES MAILLYS',
    'PONCEY LES ATHEE',
    'PONT',
    'ST SEINE EN BACHE',
    'TILLENAY',
    'TRECLUN',
    'VILLERS LES POTS',
    'VILLERS ROTIN',
  ],
  21170: [
    'AUBIGNY EN PLAINE',
    'CHARREY SUR SAONE',
    'ECHENON',
    'ESBARRES',
    'FRANXAULT',
    'LAPERRIERE SUR SAONE',
    'LOSNE',
    'MAGNY LES AUBIGNY',
    'MONTOT',
    'ST JEAN DE LOSNE',
    'ST SYMPHORIEN SUR SAONE',
    'ST USAGE',
    'SAMEREY',
    'TROUHANS',
  ],
  21340: [
    'AUBIGNY LA RONCE',
    'BAUBIGNY',
    'CORMOT VAUCHIGNON',
    'VAL MONT',
    'MOLINOT',
    'NOLAY',
    'LA ROCHEPOT',
    'SANTOSSE',
    'THURY',
    'CHANGE',
  ],
  21540: [
    'AUBIGNY LES SOMBERNON',
    'BLAISY BAS',
    'BLAISY HAUT',
    'BUSSY LA PESLE',
    'CHEVANNAY',
    'DREE',
    'ECHANNAY',
    'GRENANT LES SOMBERNON',
    'GROSBOIS EN MONTAGNE',
    'MESMONT',
    'MONTOILLOT',
    'PANGES',
    'REMILLY EN MONTAGNE',
    'ST ANTHOT',
    'ST MESMIN',
    'SAVIGNY SOUS MALAIN',
    'SOMBERNON',
    'TURCEY',
    'VERREY SOUS DREE',
    'VIEILMOULIN',
  ],
  21570: [
    'AUTRICOURT',
    'BELAN SUR OURCE',
    'BRION SUR OURCE',
    'GRANCEY SUR OURCE',
    'RIEL LES EAUX',
    'THOIRES',
  ],
  21250: [
    'AUVILLARS SUR SAONE',
    'BONNENCONTRE',
    'BOUSSELANGE',
    'BROIN',
    'CHAMBLANC',
    'CORBERON',
    'CORGENGOUX',
    'GLANON',
    'GROSBOIS LES TICHEY',
    'JALLANGES',
    'LABRUYERE',
    'LANTHES',
    'LECHATELET',
    'MONTAGNY LES SEURRE',
    'MONTMAIN',
    'PAGNY LA VILLE',
    'PAGNY LE CHATEAU',
    'POUILLY SUR SAONE',
    'SEURRE',
    'TICHEY',
    'TRUGNY',
    'VILLY LE MOUTIER',
  ],
  21190: [
    'AUXEY DURESSES',
    'CHASSAGNE MONTRACHET',
    'CORCELLES LES ARTS',
    'CORPEAU',
    'EBATY',
    'MAVILLY MANDELOT',
    'MELOISEY',
    'MERCEUIL',
    'MEURSAULT',
    'MONTHELIE',
    'NANTOUX',
    'PULIGNY MONTRACHET',
    'ST AUBIN',
    'ST ROMAIN',
    'TAILLY',
    'VOLNAY',
  ],
  21120: [
    'AVELANGES',
    'CHAIGNAY',
    'COURTIVRON',
    'CRECEY SUR TILLE',
    'DIENAY',
    'ECHEVANNES',
    'FRENOIS',
    'GEMEAUX',
    'IS SUR TILLE',
    'LUX',
    'MARCILLY SUR TILLE',
    'MAREY SUR TILLE',
    'MOLOY',
    'PICHANGES',
    'POISEUL LES SAULX',
    'SAULX LE DUC',
    'SPOY',
    'TARSUL',
    'TIL CHATEL',
    'VERNOT',
    'VILLECOMTE',
    'VILLEY SUR TILLE',
  ],
  21580: [
    'AVOT',
    'BARJON',
    'BUSSEROTTE ET MONTENAILLE',
    'BUSSIERES',
    'COURLON',
    'CUSSEY LES FORGES',
    'FRAIGNOT ET VESVROTTE',
    'GRANCEY LE CHATEAU NEUVELLE',
    'LE MEIX',
    'SALIVES',
  ],
  21330: [
    'BALOT',
    'BISSEY LA PIERRE',
    'BOUIX',
    'CERILLY',
    'CHANNAY',
    'FONTAINES LES SECHES',
    'GRISELLES',
    'LAIGNES',
    'LARREY',
    'MARCENAY',
    'MOLESME',
    'NESLE ET MASSOULT',
    'NICEY',
    'POINCON LES LARREY',
    'VERDONNET',
    'VERTAULT',
    'VILLEDIEU',
  ],
  21430: [
    'BARD LE REGULIER',
    'BLANOT',
    'BRAZEY EN MORVAN',
    'CENSEREY',
    'DIANCEY',
    'LIERNAIS',
    'MANLAY',
    'MARCHESEUIL',
    'MENESSAIRE',
    'SAVILLY',
    'SUSSEY',
    'VIANGES',
    'VILLIERS EN MORVAN',
  ],
  21460: [
    'BARD LES EPOISSES',
    'CORROMBLES',
    'CORSAINT',
    'COURCELLES FREMOY',
    'EPOISSES',
    'FORLEANS',
    'JEUX LES BARD',
    'MONTBERTHAULT',
    'THOSTE',
    'TORCY ET POULIGNY',
    'TOUTRY',
    'VIEUX CHATEAU',
  ],
  21910: [
    'BARGES',
    'CORCELLES LES CITEAUX',
    'NOIRON SOUS GEVREY',
    'SAULON LA CHAPELLE',
    'SAULON LA RUE',
    'SAVOUGES',
  ],
  21200: [
    'BEAUNE',
    'BLIGNY LES BEAUNE',
    'BOUZE LES BEAUNE',
    'CHEVIGNY EN VALIERE',
    'CHOREY LES BEAUNE',
    'COMBERTAULT',
    'LEVERNOIS',
    'MARIGNY LES REULLEE',
    'MEURSANGES',
    'MONTAGNY LES BEAUNE',
    'RUFFEY LES BEAUNE',
    'STE MARIE LA BLANCHE',
    'VIGNOLES',
  ],
  21490: [
    'BELLEFOND',
    'BRETIGNY',
    'BROGNON',
    'CLENAY',
    'FLACEY',
    'NORGES LA VILLE',
    'ORGEUX',
    'RUFFEY LES ECHIREY',
    'ST JULIEN',
    'VAROIS ET CHAIGNOT',
  ],
  21290: [
    'BENEUVRE',
    'BURE LES TEMPLIERS',
    'BUXEROLLES',
    'CHAMBAIN',
    'CHAUGEY',
    'ESSAROIS',
    'FAVEROLLES LES LUCEY',
    'GURGY LA VILLE',
    'GURGY LE CHATEAU',
    'LEUGLAY',
    'LUCEY',
    'MENESBLE',
    'MONTMOYEN',
    'RECEY SUR OURCE',
    'ST BROING LES MOINES',
    'TERREFONDREE',
    'VOULAINES LES TEMPLIERS',
  ],
  21220: [
    'BEVY',
    'BROCHON',
    'BROINDON',
    'CHAMBOEUF',
    'CHAMBOLLE MUSIGNY',
    'CHEVANNES',
    'VALFORET',
    'COLLONGES LES BEVY',
    'CURLEY',
    'CURTIL VERGY',
    'DETAIN ET BRUANT',
    'EPERNAY SOUS GEVREY',
    'L ETANG VERGY',
    'FIXIN',
    'GEVREY CHAMBERTIN',
    'MESSANGES',
    'MOREY ST DENIS',
    'REULLE VERGY',
    'ST PHILIBERT',
    'SEGROIS',
    'SEMEZANGES',
    'TERNANT',
    'URCY',
  ],
  21270: [
    'BINGES',
    'CIREY LES PONTAILLER',
    'CLERY',
    'DRAMBON',
    'ETEVAUX',
    'HEUILLEY SUR SAONE',
    'MARANDEUIL',
    'MAXILLY SUR SAONE',
    'MONTMANCON',
    'PERRIGNY SUR L OGNON',
    'PONTAILLER SUR SAONE',
    'ST LEGER TRIEY',
    'ST SAUVEUR',
    'SOISSONS SUR NACEY',
    'TALMAY',
    'TELLECEY',
    'VIELVERGE',
    'VONGES',
  ],
  21520: [
    'BISSEY LA COTE',
    'BOUDREVILLE',
    'LA CHAUME',
    'COURBAN',
    'GEVROLLES',
    'LES GOULLES',
    'LIGNEROLLES',
    'LOUESME',
    'MONTIGNY SUR AUBE',
    'VEUXHAULLES SUR AUBE',
  ],
  21690: [
    'SOURCE SEINE',
    'BOUX SOUS SALMAISE',
    'CHAMPRENAULT',
    'CHARENCEY',
    'ST HELIER',
    'SALMAISE',
    'VERREY SOUS SALMAISE',
    'VILLOTTE ST SEINE',
  ],
  21440: [
    'BLIGNY LE SEC',
    'CHAMPAGNY',
    'CHANCEAUX',
    'FRANCHEVILLE',
    'LAMARGELLE',
    'LERY',
    'PELLEREY',
    'POISEUL LA GRANGE',
    'PONCEY SUR L IGNON',
    'ST MARTIN DU MONT',
    'ST SEINE L ABBAYE',
    'TROUHAUT',
    'VAUX SAULES',
  ],
  21610: [
    'BOURBERAIN',
    'CHAUME ET COURCHAMP',
    'FONTAINE FRANCAISE',
    'FONTENELLE',
    'LICEY SUR VINGEANNE',
    'MONTIGNY MORNAY VILLENEUVE VINGEANNE',
    'ORAIN',
    'POUILLY SUR VINGEANNE',
    'ST MAURICE SUR VINGEANNE',
    'ST SEINE SUR VINGEANNE',
  ],
  21260: [
    'BOUSSENOIS',
    'CHAZEUIL',
    'FONCEGRIVE',
    'ORVILLE',
    'SACQUENAY',
    'SELONGEY',
    'VERNOIS LES VESVRES',
    'VERONNES',
  ],
  21470: ['BRAZEY EN PLAINE'],
  21210: [
    'CHAMPEAU EN MORVAN',
    'JUILLENAY',
    'LACOUR D ARCENAY',
    'MISSERY',
    'MOLPHEY',
    'MONTLAY EN AUXOIS',
    'LA MOTTE TERNANT',
    'ST DIDIER',
    'ST MARTIN DE LA MER',
    'SAULIEU',
    'THOISY LA BERCHERE',
    'VILLARGOIX',
  ],
  21140: [
    'CHARIGNY',
    'COURCELLES LES SEMUR',
    'LE VAL LARREY',
    'GENAY',
    'JUILLY',
    'LANTILLY',
    'MAGNY LA VILLE',
    'MASSINGY LES SEMUR',
    'MILLERY',
    'MONTIGNY SUR ARMANCON',
    'PONT ET MASSENE',
    'ST EUPHRONE',
    'SEMUR EN AUXOIS',
    'SOUHEY',
    'VIC DE CHASSENAY',
    'VILLARS ET VILLENOTTE',
    'VILLENEUVE SOUS CHARIGNY',
  ],
  21300: ['CHENOVE'],
  21800: ['CHEVIGNY ST SAUVEUR', 'NEUILLY CRIMOLOIS', 'QUETIGNY', 'SENNECEY LES DIJON'],
  21820: ['CHIVRES', 'LABERGEMENT LES SEURRE'],
  21160: [
    'CORCELLES LES MONTS',
    'COUCHEY',
    'FLAVIGNEROT',
    'MARSANNAY LA COTE',
    'PERRIGNY LES DIJON',
  ],
  21000: ['DIJON'],
  21600: ['FENAY', 'LONGVIC', 'OUGES'],
  21640: ['FLAGEY ECHEZEAUX', 'GILLY LES CITEAUX', 'VOUGEOT'],
  21760: ['LAMARCHE SUR SAONE'],
  21370: ['LANTENAY', 'PASQUES', 'PLOMBIERES LES DIJON', 'PRENOIS', 'VELARS SUR OUCHE'],
  21630: ['POMMARD'],
  21530: [
    'LA ROCHE EN BRENIL',
    'ROUVRAY',
    'ST ANDEUX',
    'ST GERMAIN DE MODEON',
    'SINCEY LES ROUVRAY',
  ],
  21850: ['ST APOLLINAIRE'],
  21590: ['SANTENAY'],
  21550: ['LADOIX SERRIGNY'],
  21240: ['TALANT'],
  22460: ['ALLINEUC', 'GRACE UZEL', 'MERLEAC', 'LE QUILLIO', 'ST HERVE', 'ST THELO', 'UZEL'],
  22400: [
    'ANDEL',
    'COETMIEUX',
    'HENANSAL',
    'LAMBALLE ARMOR',
    'LANDEHEN',
    'NOYAL',
    'QUINTENIC',
    'ST ALBAN',
    'ST DENOUAL',
  ],
  22100: [
    'AUCALEUC',
    'BOBITAL',
    'BRUSVILY',
    'CALORGUEN',
    'DINAN',
    'LE HINGLE',
    'LANVALLAY',
    'QUEVERT',
    'ST CARNE',
    'ST HELEN',
    'ST SAMSON SUR RANCE',
    'TADEN',
    'TRELIVAN',
    'TREVRON',
  ],
  22140: [
    'BEGARD',
    'BERHET',
    'BRELIDY',
    'CAVAN',
    'COATASCORN',
    'KERMOROC H',
    'LANDEBAERON',
    'PLUZUNET',
    'PRAT',
    'ST LAURENT',
    'TONQUEDEC',
  ],
  22810: ['BELLE ISLE EN TERRE', 'LOC ENVEL', 'PLOUGONVER', 'PLOUNEVEZ MOEDEC'],
  22320: [
    'LE BODEO',
    'CORLAY',
    'LA HARMOYE',
    'LE HAUT CORLAY',
    'PLUSSULIEN',
    'ST MARTIN DES PRES',
    'ST MAYEUX',
  ],
  22170: [
    'BOQUEHO',
    'BRINGOLO',
    'LANRODEC',
    'PLELO',
    'PLERNEUF',
    'CHATELAUDREN PLOUAGAT',
    'PLOUVARA',
    'ST JEAN KERDANIEL',
  ],
  22240: ['LA BOUILLIE', 'FREHEL', 'PLEVENON', 'PLURIEN'],
  22390: ['BOURBRIAC', 'GURUNHUEL', 'PONT MELVEZ', 'ST ADRIEN'],
  22130: [
    'BOURSEUL',
    'CORSEUL',
    'CREHEN',
    'LANDEBIA',
    'LANGUENAN',
    'PLANCOET',
    'PLEVEN',
    'PLOREC SUR ARGUENON',
    'PLUDUNO',
    'ST LORMEL',
  ],
  22510: ['BREHAND', 'MONCONTOUR', 'PENGUILY', 'ST GLEN', 'ST TRIMOEL', 'TREBRY', 'TREDANIEL'],
  22870: ['ILE DE BREHAT'],
  22250: ['BROONS', 'EREAC', 'LANRELAS', 'PLUMAUGAT', 'ROUILLAC', 'SEVIGNAC', 'TREDIAS', 'TREMEUR'],
  22160: [
    'BULAT PESTIVIEN',
    'CALANHEL',
    'CALLAC',
    'CARNOET',
    'LA CHAPELLE NEUVE',
    'DUAULT',
    'LOHUEC',
    'MAEL PESTIVIEN',
    'PLOURAC H',
    'PLUSQUELLEC',
    'ST NICODEME',
    'ST SERVAIS',
  ],
  22210: [
    'LE CAMBOUT',
    'LA CHEZE',
    'COETLOGON',
    'PLEMET',
    'PLUMIEUX',
    'LA PRENESSAYE',
    'ST ETIENNE DU GUE DE L ISLE',
  ],
  22450: [
    'CAMLEZ',
    'COATREVEN',
    'KERMARIA SULARD',
    'LANGOAT',
    'MANTALLOT',
    'QUEMPERVEN',
    'LA ROCHE JAUDY',
    'TREZENY',
    'TROGUERY',
  ],
  22480: [
    'CANIHUEL',
    'KERIEN',
    'KERPERT',
    'LANRIVAIN',
    'MAGOAR',
    'PEUMERIT QUINTIN',
    'ST CONNAN',
    'ST GILLES PLIGEAUX',
    'ST NICOLAS DU PELEM',
    'STE TREPHINE',
  ],
  22300: [
    'CAOUENNEC LANVEZEAC',
    'LANMERIN',
    'LANNION',
    'PLOUBEZRE',
    'PLOULEC H',
    'PLOUMILLIAU',
    'ROSPEZ',
    'ST MICHEL EN GREVE',
    'TREDREZ LOCQUEMEAU',
  ],
  22350: [
    'CAULNES',
    'LA CHAPELLE BLANCHE',
    'GUENROC',
    'GUITTE',
    'PLUMAUDAN',
    'ST JOUAN DE L ISLE',
    'ST MADEN',
    'YVIGNAC LA TOUR',
  ],
  22530: ['CAUREL', 'GUERLEDAN', 'ST CONNEC', 'ST GILLES VIEUX MARCHE'],
  22630: [
    'LES CHAMPS GERAUX',
    'EVRAN',
    'LE QUIOU',
    'ST ANDRE DES EAUX',
    'ST JUDOCE',
    'ST JUVAT',
    'TREFUMEL',
  ],
  22970: ['COADOUT', 'PLOUMAGOAR'],
  22800: [
    'COHINIAC',
    'LE FOEIL',
    'LANFAINS',
    'LE LESLAY',
    'PLAINE HAUTE',
    'QUINTIN',
    'ST BIHY',
    'ST BRANDAN',
    'ST DONAN',
    'ST GILDAS',
    'LE VIEUX BOURG',
  ],
  22330: ['LE MENE'],
  22430: ['ERQUY'],
  22520: ['BINIC ETABLES SUR MER'],
  22680: ['BINIC ETABLES SUR MER'],
  22290: [
    'LE FAOUET',
    'GOMMENEC H',
    'GOUDELIN',
    'LANLEFF',
    'LANNEBERT',
    'LANVOLLON',
    'PLEGUIEN',
    'PLEHEDEL',
    'PLUDUAL',
    'ST GILLES LES BOIS',
    'TREGUIDEL',
    'TREMEVEN',
    'TRESSIGNAUX',
    'TREVEREC',
  ],
  22150: ['GAUSSON', 'HENON', 'PLEMY', 'PLOEUC L HERMITAGE', 'PLOUGUENAST LANGAST', 'ST CARREUC'],
  22110: [
    'GLOMEL',
    'KERGRIST MOELOU',
    'MELLIONNEC',
    'PLOUGUERNEVEL',
    'PLOUNEVEZ QUINTIN',
    'ROSTRENEN',
    'TREMARGAT',
  ],
  22230: [
    'GOMENE',
    'ILLIFAUT',
    'LAURENAN',
    'LOSCOUET SUR MEU',
    'MERDRIGNAC',
    'MERILLAC',
    'ST LAUNEUC',
    'ST VRAN',
    'TREMOREL',
  ],
  22570: ['GOUAREC', 'BON REPOS SUR BLAVET', 'LESCOUET GOUAREC', 'PLELAUFF', 'ST IGEAUX'],
  22200: [
    'GRACES',
    'GUINGAMP',
    'LE MERZER',
    'MOUSTERU',
    'PABU',
    'PLOUISY',
    'POMMERIT LE VICOMTE',
    'ST AGATHON',
    'SQUIFFIEC',
    'TREGONNEAU',
  ],
  22600: ['HEMONSTOIR', 'LOUDEAC', 'LA MOTTE', 'ST BARNABE', 'ST CARADEC', 'ST MAUDAN', 'TREVE'],
  22550: ['HENANBIHEN', 'MATIGNON', 'PLEBOULLE', 'RUCA', 'ST POTAN'],
  22120: ['HILLION', 'POMMERET', 'QUESSOY', 'YFFINIAC'],
  22270: ['JUGON LES LACS', 'MEGRIT', 'PLEDELIAC', 'ST RIEUL'],
  22610: ['KERBORS', 'LANMODEZ', 'PLEUBIAN'],
  22500: ['KERFOT', 'PAIMPOL'],
  22770: ['LANCIEUX'],
  22980: [
    'LA LANDEC',
    'LANGUEDIAS',
    'PLELAN LE PETIT',
    'ST MAUDEZ',
    'ST MELOIR DES BOIS',
    'ST MICHEL DE PLELAN',
    'TREBEDAN',
    'VILDE GUINGALAN',
  ],
  22490: ['LANGROLAY SUR RANCE', 'PLESLIN TRIGAVOU', 'PLOUER SUR RANCE', 'TREMEREUC'],
  22360: ['LANGUEUX'],
  22580: ['LANLOUP', 'PLOUHA'],
  22410: ['LANTIC', 'PLOURHAN', 'ST QUAY PORTRIEUX', 'TREVENEUC'],
  22420: ['LANVELLEC', 'PLOUARET', 'PLOUZELAMBRE', 'TREGROM', 'LE VIEUX MARCHE'],
  22740: ['LEZARDRIEUX', 'PLEUDANIEL', 'PLEUMEUR GAUTIER'],
  22340: [
    'LOCARN',
    'MAEL CARHAIX',
    'LE MOUSTOIR',
    'PAULE',
    'PLEVIN',
    'TREBRIVAN',
    'TREFFRIN',
    'TREOGAN',
  ],
  22780: ['LOGUIVY PLOUGRAS', 'PLOUGRAS', 'PLOUNERIN'],
  22700: ['LOUANNEC', 'PERROS GUIREC', 'ST QUAY PERROS'],
  22540: ['LOUARGAT', 'PEDERNEC', 'TREGLAMUS'],
  22640: ['LA MALHOURE', 'PLENEE JUGON', 'PLESTAN', 'TRAMAIN'],
  22440: ['LA MEAUGON', 'PLOUFRAGAN', 'TREMUSON'],
  22220: ['MINIHY TREGUIER', 'PLOUGUIEL', 'TREDARZEC', 'TREGUIER'],
  22710: ['PENVENAN'],
  22940: ['PLAINTEL', 'ST JULIEN'],
  22960: ['PLEDRAN'],
  22370: ['PLENEUF VAL ANDRE'],
  22190: ['PLERIN'],
  22720: ['PLESIDY', 'ST FIACRE', 'ST PEVER', 'SENVEN LEHART'],
  22310: ['PLESTIN LES GREVES', 'PLUFUR', 'TREDUDER', 'TREMEL'],
  22690: ['PLEUDIHEN SUR RANCE', 'LA VICOMTE SUR RANCE'],
  22560: ['PLEUMEUR BODOU', 'TREBEURDEN'],
  22260: ['PLOEZAL', 'PLOUEC DU TRIEUX', 'PONTRIEUX', 'QUEMPER GUEZENNEC', 'RUNAN', 'ST CLET'],
  22830: ['PLOUASNE'],
  22650: ['BEAUSSAIS SUR MER'],
  22620: ['PLOUBAZLANEC'],
  22470: ['PLOUEZEC'],
  22820: ['PLOUGRESCANT'],
  22860: ['PLOURIVO'],
  22590: ['PORDIC', 'TREGOMEUR'],
  22000: ['ST BRIEUC'],
  22380: ['ST CAST LE GUILDO'],
  22750: ['ST JACUT DE LA MER'],
  22730: ['TREGASTEL'],
  22950: ['TREGUEUX'],
  22660: ['TRELEVERN', 'TREVOU TREGUIGNEC'],
  22930: ['YVIAS'],
  23150: [
    'AHUN',
    'LAVAVEIX LES MINES',
    'LEPINAS',
    'MAISONNISSES',
    'MAZEIRAT',
    'MOUTIER D AHUN',
    'SOUS PARSAT',
    'ST HILAIRE LA PLAINE',
    'ST MARTIAL LE MONT',
    'ST PARDOUX LES CARDS',
    'ST YRIEIX LES BOIS',
  ],
  23380: ['AJAIN', 'GLENIC'],
  23200: [
    'ALLEYRAT',
    'AUBUSSON',
    'BLESSAC',
    'BOSROGER',
    'LA CHAUSSADE',
    'MOUTIER ROZEILLE',
    'NEOUX',
    'ST ALPINIEN',
    'ST AMAND',
    'ST AVIT DE TARDES',
    'ST MAIXANT',
    'ST MARC A FRONGIER',
    'ST MEDARD LA ROCHETTE',
    'ST PARDOUX LE NEUF',
  ],
  23000: [
    'ANZEME',
    'LA BRIONNE',
    'LA CHAPELLE TAILLEFERT',
    'GUERET',
    'PEYRABOUT',
    'LA SAUNIERE',
    'SAVENNES',
    'ST CHRISTOPHE',
    'ST ELOI',
    'STE FEYRE',
    'ST FIEL',
    'ST LAURENT',
    'ST LEGER LE GUERETOIS',
    'ST SULPICE LE GUERETOIS',
    'ST VICTOR EN MARCHE',
  ],
  23700: [
    'ARFEUILLE CHATAIN',
    'AUZANCES',
    'BROUSSE',
    'BUSSIERE NOUVELLE',
    'CHARD',
    'CHARRON',
    'CHATELARD',
    'LE COMPAS',
    'DONTREIX',
    'LIOUX LES MONGES',
    'MAINSAT',
    'LES MARS',
    'ROUGNAT',
    'SERMUR',
  ],
  23210: [
    'ARRENES',
    'AUGERES',
    'AULON',
    'AZAT CHATENET',
    'BENEVENT L ABBAYE',
    'CEYROUX',
    'MARSAC',
    'MOURIOUX VIEILLEVILLE',
  ],
  23480: [
    'ARS',
    'CHAMBERAUD',
    'LE DONZEIL',
    'FRANSECHES',
    'ST AVIT LE PAUVRE',
    'ST MICHEL DE VEISSE',
    'ST SULPICE LES CHAMPS',
  ],
  23170: [
    'AUGE',
    'BUDELIERE',
    'CHAMBON SUR VOUEIZE',
    'LEPAUD',
    'LUSSAT',
    'NOUHANT',
    'TARDES',
    'VERNEIGES',
    'VIERSAT',
  ],
  23400: [
    'AURIAT',
    'BOSMOREAU LES MINES',
    'BOURGANEUF',
    'FAUX MAZURAS',
    'MANSAT LA COURRIERE',
    'MONTBOUCHER',
    'ST AMAND JARTOUDEIX',
    'ST DIZIER MASBARAUD',
    'ST JUNIEN LA BREGERE',
    'ST MOREIL',
    'ST PARDOUX MORTEROLLES',
    'ST PRIEST PALUS',
  ],
  23160: [
    'AZERABLES',
    'BAZELAT',
    'LA CHAPELLE BALOUE',
    'CROZANT',
    'ST GERMAIN BEAUPRE',
    'ST SEBASTIEN',
  ],
  23120: ['BANIZE', 'VALLIERE'],
  23260: [
    'BASVILLE',
    'BEISSAT',
    'CROCQ',
    'FLAYAT',
    'MAGNAT L ETRANGE',
    'MALLERET',
    'LA MAZIERE AUX BONS HOMMES',
    'PONTCHARRAUD',
    'ST AGNANT PRES CROCQ',
    'ST BARD',
    'ST MAURICE PRES CROCQ',
    'ST ORADOUX PRES CROCQ',
    'ST PARDOUX D ARNET',
    'LA VILLENEUVE',
    'LA VILLETELLE',
  ],
  23190: [
    'BELLEGARDE EN MARCHE',
    'CHAMPAGNAT',
    'LUPERSAT',
    'MAUTES',
    'LA SERRE BUSSIERE VIEILLE',
    'ST DOMET',
    'ST SILVAIN BELLEGARDE',
  ],
  23270: [
    'BETETE',
    'CHATELUS MALVALEIX',
    'CLUGNAT',
    'JALESCHES',
    'LADAPEYRE',
    'ROCHES',
    'ST DIZIER LES DOMAINES',
  ],
  23140: [
    'BLAUDEIX',
    'CRESSAT',
    'DOMEYROT',
    'JARNAGES',
    'PARSAC RIMONDEIX',
    'PIONNAT',
    'ST SILVAIN SOUS TOULX',
    'VIGEVILLE',
  ],
  23220: [
    'BONNAT',
    'LE BOURG D HEM',
    'CHAMBON STE CROIX',
    'CHAMPSANGLARD',
    'CHENIERS',
    'JOUILLAT',
    'LINARD MALVAL',
    'MORTROUX',
    'MOUTIER MALCARD',
  ],
  23230: ['BORD ST GEORGES', 'LA CELLE SOUS GOUZON', 'GOUZON', 'TROIS FONDS'],
  23600: [
    'BOUSSAC',
    'BOUSSAC BOURG',
    'BUSSIERE ST GEORGES',
    'LAVAUFRANCHE',
    'LEYRAT',
    'MALLERET BOUSSAC',
    'NOUZERINES',
    'SOUMANS',
    'ST MARIEN',
    'ST PIERRE LE BOST',
    'ST SILVAIN BAS LE ROC',
    'TOULX STE CROIX',
  ],
  23320: [
    'BUSSIERE DUNOISE',
    'FLEURAT',
    'GARTEMPE',
    'MONTAIGUT LE BLANC',
    'ST SILVAIN MONTAIGUT',
    'ST VAURY',
  ],
  23800: [
    'LA CELLE DUNOISE',
    'COLONDANNES',
    'DUN LE PALESTEL',
    'LAFAT',
    'MAISON FEYNE',
    'NAILLAT',
    'SAGNAT',
    'ST SULPICE LE DUNOIS',
    'VILLARD',
  ],
  23350: ['LA CELLETTE', 'GENOUILLAC', 'NOUZIERS', 'TERCILLAT'],
  23110: [
    'CHAMBONCHARD',
    'EVAUX LES BAINS',
    'FONTANIERES',
    'RETERRE',
    'SANNAT',
    'ST JULIEN LA GENETE',
    'ST PRIEST',
  ],
  23240: ['CHAMBORAND', 'LE GRAND BOURG', 'LIZIERES', 'ST PRIEST LA PLAINE'],
  23250: [
    'LA CHAPELLE ST MARTIAL',
    'CHAVANAT',
    'JANAILLAT',
    'PONTARION',
    'LA POUGE',
    'SARDENT',
    'SOUBREBOST',
    'ST GEORGES LA POUGE',
    'ST HILAIRE LE CHATEAU',
    'THAURON',
    'VIDAILLAT',
  ],
  23430: ['CHATELUS LE MARCHEIX', 'ST GOUSSAUD', 'ST MARTIN STE CATHERINE', 'ST PIERRE CHERIGNAT'],
  23130: [
    'LE CHAUCHET',
    'CHENERAILLES',
    'ISSOUDUN LETRIEIX',
    'PEYRAT LA NONIERE',
    'PIERREFITTE',
    'PUY MALSIGNAT',
    'ST CHABRAIS',
    'ST DIZIER LA TOUR',
    'ST JULIEN LE CHATEL',
    'ST LOUP',
  ],
  23500: [
    'CLAIRAVAUX',
    'CROZE',
    'FELLETIN',
    'GIOUX',
    'LA NOUAILLE',
    'POUSSANGES',
    'STE FEYRE LA MONTAGNE',
    'ST FRION',
    'ST GEORGES NIGREMONT',
    'ST QUENTIN LA CHABANNE',
  ],
  23100: [
    'LA COURTINE',
    'FENIERS',
    'LE MAS D ARTIGE',
    'ST MARTIAL LE VIEUX',
    'ST MERD LA BREUILLE',
    'ST ORADOUX DE CHIROUZE',
  ],
  23340: ['FAUX LA MONTAGNE', 'GENTIOUX PIGEROLLES', 'LA VILLEDIEU'],
  23360: ['LA FORET DU TEMPLE', 'LOURDOUEIX ST PIERRE', 'MEASNES', 'NOUZEROLLES'],
  23450: ['FRESSELINES'],
  23420: ['MERINCHAL'],
  23460: [
    'LE MONTEIL AU VICOMTE',
    'ROYERE DE VASSIVIERE',
    'ST MARC A LOUBAUD',
    'ST MARTIN CHATEAU',
    'ST PIERRE BELLEVUE',
    'ST YRIEIX LA MONTAGNE',
  ],
  23300: [
    'NOTH',
    'LA SOUTERRAINE',
    'ST AGNANT DE VERSILLAT',
    'ST LEGER BRIDEREIX',
    'ST MAURICE LA SOUTERRAINE',
    'ST PRIEST LA FEUILLE',
    'VAREILLES',
  ],
  23290: ['FURSAC'],
  24300: [
    'ABJAT SUR BANDIAT',
    'AUGIGNAC',
    'LE BOURDEIX',
    'LA CHAPELLE MONTMOREAU',
    'CONNEZAC',
    'HAUTEFAYE',
    'JAVERLHAC ET LA CHAPELLE ST ROBERT',
    'LUSSAS ET NONTRONNEAU',
    'NONTRON',
    'ST FRONT LA RIVIERE',
    'ST FRONT SUR NIZONNE',
    'ST MARTIAL DE VALETTE',
    'ST MARTIN LE PIN',
    'SAVIGNAC DE NONTRON',
    'SCEAU ST ANGEL',
    'TEYJAT',
  ],
  24460: [
    'AGONAC',
    'BRANTOME EN PERIGORD',
    'CHATEAU L EVEQUE',
    'NEGRONDES',
    'ST FRONT D ALEMPS',
    'SORGES ET LIGUEUX EN PERIGORD',
  ],
  24210: [
    'AJAT',
    'AZERAT',
    'LA BACHELLERIE',
    'BARS',
    'BROUCHAUD',
    'FOSSEMAGNE',
    'GABILLOU',
    'LIMEYRAT',
    'MONTAGNAC D AUBEROCHE',
    'PEYRIGNAC',
    'STE ORSE',
    'ST RABIER',
    'THENON',
  ],
  24480: ['ALLES SUR DORDOGNE', 'BOUILLAC', 'LE BUISSON DE CADOUIN', 'MOLIERES', 'URVAL'],
  24220: [
    'ALLAS LES MINES',
    'BERBIGUIERES',
    'BEYNAC ET CAZENAC',
    'CASTELS ET BEZENAC',
    'COUX ET BIGAROQUE MOUZENS',
    'MARNAC',
    'MEYRALS',
    'ST CYPRIEN',
    'ST VINCENT DE COSSE',
    'VEZAC',
  ],
  24600: [
    'ALLEMANS',
    'BOURG DU BOST',
    'CELLES',
    'CHASSAIGNES',
    'COMBERANCHE ET EPELUCHE',
    'PETIT BERSAC',
    'RIBERAC',
    'ST MARTIN DE RIBERAC',
    'ST MEARD DE DRONE',
    'ST PARDOUX DE DRONE',
    'ST SULPICE DE ROUMAGNAC',
    'SEGONZAC',
    'SIORAC DE RIBERAC',
    'VANXAINS',
    'VILLETOUREIX',
  ],
  24270: [
    'ANGOISSE',
    'DUSSAC',
    'LANOUAILLE',
    'PAYZAC',
    'ST CYR LES CHAMPAGNES',
    'ST MESMIN',
    'SARLANDE',
    'SAVIGNAC LEDRIER',
  ],
  24160: [
    'ANLHIAC',
    'CLERMONT D EXCIDEUIL',
    'EXCIDEUIL',
    'GENIS',
    'PREYSSAC D EXCIDEUIL',
    'ST GERMAIN DES PRES',
    'ST JORY LAS BLOUX',
    'ST MARTIAL D ALBAREDE',
    'ST MEDARD D EXCIDEUIL',
    'ST PANTALY D EXCIDEUIL',
    'ST RAPHAEL',
    'STE TRIE',
    'SALAGNAC',
  ],
  24430: ['ANNESSE ET BEAULIEU', 'COURSAC', 'MARSAC SUR L ISLE', 'RAZAC SUR L ISLE'],
  24420: [
    'ANTONNE ET TRIGONANT',
    'COULAURES',
    'ESCOIRE',
    'MAYAC',
    'ST VINCENT SUR L ISLE',
    'SARLIAC SUR L ISLE',
    'SAVIGNAC LES EGLISES',
    'SORGES ET LIGUEUX EN PERIGORD',
  ],
  24590: [
    'ARCHIGNAC',
    'BORREZE',
    'JAYAC',
    'NADAILLAC',
    'PAULIN',
    'ST CREPIN ET CARLUCET',
    'ST GENIES',
    'SALIGNAC EYVIGUES',
  ],
  24290: [
    'AUBAS',
    'AURIAC DU PERIGORD',
    'LA CHAPELLE AUBAREIL',
    'FANLAC',
    'LES FARGES',
    'MONTIGNAC LASCAUX',
    'COLY ST AMAND',
    'ST LEON SUR VEZERE',
    'SERGEAC',
    'THONAC',
    'VALOJOULX',
  ],
  24260: [
    'AUDRIX',
    'LE BUGUE',
    'CAMPAGNE',
    'LES EYZIES',
    'JOURNIAC',
    'MAUZENS ET MIREMONT',
    'ST AVIT DE VIALARD',
    'ST CHAMASSY',
    'ST FELIX DE REILLAC ET MORTEMART',
    'SAVIGNAC DE MIREMONT',
  ],
  24390: [
    'BADEFOLS D ANS',
    'BOISSEUILH',
    'LA CHAPELLE ST JEAN',
    'CHERVEIX CUBAS',
    'COUBJOURS',
    'GRANGES D ANS',
    'HAUTEFORT',
    'NAILHAC',
    'TEILLOTS',
    'TEMPLE LAGUYON',
    'TOURTOIRAC',
  ],
  24150: [
    'BADEFOLS SUR DORDOGNE',
    'BANEUIL',
    'BAYAC',
    'BOURNIQUEL',
    'CALES',
    'CAUSE DE CLERANS',
    'COUZE ET ST FRONT',
    'LALINDE',
    'LANQUAIS',
    'MAUZAC ET GRAND CASTANG',
    'PONTOURS',
    'PRESSIGNAC VICQ',
    'ST CAPRAISE DE LALINDE',
    'VARENNES',
  ],
  24560: [
    'BARDOU',
    'BOISSE',
    'BOUNIAGUES',
    'COLOMBIER',
    'CONNE DE LABARDE',
    'PLAISANCE',
    'FAURILLES',
    'FAUX',
    'ISSIGEAC',
    'MONMADALES',
    'MONMARVES',
    'MONSAGUEL',
    'MONTAUT',
    'ST AUBIN DE LANQUAIS',
    'ST CERNIN DE LABARDE',
    'ST LEON D ISSIGEAC',
    'ST PERDOUX',
    'STE RADEGONDE',
  ],
  24330: [
    'BASSILLAC ET AUBEROCHE',
    'BOULAZAC ISLE MANOIRE',
    'LA DOUZE',
    'ST CREPIN D AUBEROCHE',
    'ST GEYRAC',
    'ST PIERRE DE CHIGNAC',
  ],
  24640: ['BASSILLAC ET AUBEROCHE', 'CHOURGNAC', 'CUBJAC AUVEZERE VAL D ANS', 'STE EULALIE D ANS'],
  24440: [
    'BEAUMONTOIS EN PERIGORD',
    'MONSAC',
    'MONTFERRAND DU PERIGORD',
    'NAUSSANNES',
    'RAMPIEUX',
    'ST AVIT SENIEUR',
    'STE CROIX',
  ],
  24400: [
    'BEAUPOUYET',
    'BEAURONNE',
    'BOURGNAC',
    'EGLISE NEUVE D ISSAC',
    'ISSAC',
    'LES LECHES',
    'MUSSIDAN',
    'ST ETIENNE DE PUYCORBIER',
    'ST FRONT DE PRADOUX',
    'ST GERY',
    'ST LAURENT DES HOMMES',
    'ST LOUIS EN L ISLE',
    'ST MARTIN L ASTIER',
    'ST MEDARD DE MUSSIDAN',
    'ST MICHEL DE DOUBLE',
    'SOURZAC',
  ],
  24120: [
    'BEAUREGARD DE TERRASSON',
    'LA CASSAGNE',
    'CHATRES',
    'LES COTEAUX PERIGOURDINS',
    'LA DORNAC',
    'LA FEUILLADE',
    'PAZAYAC',
    'COLY ST AMAND',
    'TERRASSON LAVILLEDIEU',
    'VILLAC',
  ],
  24140: [
    'BEAUREGARD ET BASSAC',
    'BELEYMAS',
    'CAMPSEGRET',
    'CLERMONT DE BEAUREGARD',
    'DOUVILLE',
    'JAURE',
    'EYRAUD CREMPSE MAURENS',
    'MONTAGNAC LA CREMPSE',
    'QUEYSSAC',
    'ST GEORGES DE MONTCLARD',
    'ST HILAIRE D ESTISSAC',
    'ST JEAN D ESTISSAC',
    'ST MARTIN DES COMBES',
    'VILLAMBLARD',
  ],
  24170: [
    'PAYS DE BELVES',
    'CARVES',
    'CLADECH',
    'DOISSAT',
    'GRIVES',
    'LARZAC',
    'MONPLAISANT',
    'ORLIAC',
    'SAGELAT',
    'STE FOY DE BELVES',
    'ST GERMAIN DE BELVES',
    'ST LAURENT LA VALLEE',
    'ST PARDOUX ET VIELVIC',
    'ST POMPON',
    'SALLES DE BELVES',
    'SIORAC EN PERIGORD',
  ],
  24100: ['BERGERAC', 'CREYSSE', 'LEMBRAS', 'ST LAURENT DES VIGNES'],
  24320: [
    'BERTRIC BUREE',
    'BOURG DES MAISONS',
    'BOUTEILLES ST SEBASTIEN',
    'CHAMPAGNE ET FONTAINE',
    'CHAPDEUIL',
    'LA CHAPELLE GRESIGNAC',
    'LA CHAPELLE MONTABOURLET',
    'CHERVAL',
    'COUTURES',
    'GOUT ROSSIGNOL',
    'LUSIGNAC',
    'NANTEUIL AURIAC DE BOURZAC',
    'ST JUST',
    'ST MARTIAL VIVEYROL',
    'ST PAUL LIZONNE',
    'LA TOUR BLANCHE CERCLES',
    'VENDOIRE',
    'VERTEILLAC',
  ],
  24550: [
    'BESSE',
    'CAMPAGNAC LES QUERCY',
    'LAVAUR',
    'LOUBEJAC',
    'MAZEYROLLES',
    'PRATS DU PERIGORD',
    'ST CERNIN DE L HERM',
    'VILLEFRANCHE DU PERIGORD',
  ],
  24310: ['BIRAS', 'BOURDEILLES', 'BRANTOME EN PERIGORD', 'PAUSSAC ET ST VIVIEN'],
  24540: [
    'BIRON',
    'CAPDROT',
    'GAUGEAC',
    'LAVALADE',
    'LOLME',
    'MARSALES',
    'MONPAZIER',
    'ST AVIT RIVIERE',
    'ST CASSIEN',
    'ST MARCORY',
    'ST ROMAIN DE MONPAZIER',
    'SOULAURES',
    'VERGT DE BIRON',
  ],
  24230: [
    'BONNEVILLE ET ST AVIT DE FUMADIERES',
    'LAMOTHE MONTRAVEL',
    'MONTAZEAU',
    'MONTCARET',
    'NASTRINGUES',
    'ST ANTOINE DE BREUILH',
    'ST MICHEL DE MONTAIGNE',
    'ST SEURIN DE PRATS',
    'ST VIVIEN',
    'VELINES',
  ],
  24130: [
    'BOSSET',
    'LE FLEIX',
    'FRAISSE',
    'GINESTET',
    'LA FORCE',
    'LUNAS',
    'EYRAUD CREMPSE MAURENS',
    'MONFAUCON',
    'PRIGONRIEUX',
    'ST GEORGES BLANCANEIX',
    'ST PIERRE D EYRAUD',
  ],
  24750: ['BOULAZAC ISLE MANOIRE', 'CHAMPCEVINEL', 'CORNILLE', 'SANILHAC', 'TRELISSAC'],
  24110: [
    'BOURROU',
    'GRIGNOLS',
    'LEGUILLAC DE L AUCHE',
    'MANZAC SUR VERN',
    'MONTREM',
    'ST AQUILIN',
    'ST ASTIER',
    'ST LEON SUR L ISLE',
  ],
  24250: [
    'BOUZIC',
    'CASTELNAUD LA CHAPELLE',
    'CENAC ET ST JULIEN',
    'DAGLAN',
    'DOMME',
    'FLORIMONT GAUMIER',
    'GROLEJAC',
    'NABIRAT',
    'LA ROQUE GAGEAC',
    'ST AUBIN DE NABIRAT',
    'ST CYBRANET',
    'ST MARTIAL DE NABIRAT',
    'VEYRINES DE DOMME',
  ],
  24530: [
    'BRANTOME EN PERIGORD',
    'CHAMPAGNAC DE BELAIR',
    'LA CHAPELLE FAUCHER',
    'CONDAT SUR TRINCOU',
    'QUINSAC',
    'ST PANCRACE',
    'VILLARS',
  ],
  24350: [
    'BUSSAC',
    'LA CHAPELLE GONAGUET',
    'CREYSSAC',
    'DOUCHAPT',
    'GRAND BRASSAC',
    'LISLE',
    'MENSIGNAC',
    'MONTAGRIER',
    'ST VICTOR',
    'TOCANE ST APRE',
  ],
  24360: [
    'BUSSEROLLES',
    'BUSSIERE BADIL',
    'CHAMPNIERS ET REILHAC',
    'ETOUARS',
    'PIEGUT PLUVIERS',
    'ST BARTHELEMY DE BUSSIERE',
    'ST ESTEPHE',
    'SOUDAT',
    'VARAIGNES',
  ],
  24370: [
    'CALVIAC EN PERIGORD',
    'CARLUX',
    'PECHS DE L ESPERANCE',
    'PRATS DE CARLUX',
    'ST JULIEN DE LAMPON',
    'STE MONDANE',
    'SIMEYROLS',
    'VEYRIGNAC',
  ],
  24200: [
    'CARSAC AILLAC',
    'MARCILLAC ST QUENTIN',
    'PROISSANS',
    'ST ANDRE D ALLAS',
    'STE NATHALENE',
    'ST VINCENT LE PALUEL',
    'SARLAT LA CANEDA',
    'VITRAC',
  ],
  24610: [
    'CARSAC DE GURSON',
    'MINZAC',
    'MONTPEYROUX',
    'ST MARTIN DE GURSON',
    'ST MEARD DE GURCON',
    'VILLEFRANCHE DE LONCHAT',
  ],
  24380: [
    'CHALAGNAC',
    'CREYSSENSAC ET PISSOT',
    'EGLISE NEUVE DE VERGT',
    'FOULEIX',
    'GRUN BORDAS',
    'LACROPTE',
    'SANILHAC',
    'VAL DE LOUYRE ET CAUDEAU',
    'ST AMAND DE VERGT',
    'ST MAYME DE PEREYROL',
    'ST MICHEL DE VILLADEIX',
    'ST PAUL DE SERRE',
    'SALON',
    'VERGT',
    'VEYRINES DE VERGT',
  ],
  24800: [
    'CHALAIS',
    'CORGNAC SUR L ISLE',
    'EYZERAC',
    'LEMPZOURS',
    'NANTHEUIL',
    'NANTHIAT',
    'ST JEAN DE COLE',
    'ST JORY DE CHALAIS',
    'ST MARTIN DE FRESSENGEAS',
    'ST PAUL LA ROCHE',
    'ST PIERRE DE COLE',
    'ST ROMAIN ET ST CLEMENT',
    'ST SULPICE D EXCIDEUIL',
    'SARRAZAC',
    'THIVIERS',
    'VAUNAC',
  ],
  24470: ['CHAMPS ROMAIN', 'MILHAC DE NONTRON', 'ST PARDOUX LA RIVIERE', 'ST SAUD LACOUSSIERE'],
  24650: ['CHANCELADE'],
  24190: [
    'CHANTERAC',
    'DOUZILLAC',
    'NEUVIC',
    'ST ANDRE DE DOUBLE',
    'ST GERMAIN DU SALEMBRE',
    'ST JEAN D ATAUX',
    'ST SEVERIN D ESTISSAC',
    'ST VINCENT DE CONNEZAC',
    'VALLEREUIL',
  ],
  24570: ['CONDAT SUR VEZERE', 'LE LARDIN ST LAZARE'],
  24450: ['LA COQUILLE', 'FIRBEIX', 'MIALET', 'ST PIERRE DE FRUGIE', 'ST PRIEST LES FOUGERES'],
  24660: ['COULOUNIEIX CHAMIERS', 'SANILHAC'],
  24520: [
    'COURS DE PILE',
    'LAMONZIE MONTASTRUC',
    'LIORAC SUR LOUYRE',
    'MOULEYDIER',
    'ST AGNE',
    'ST GERMAIN ET MONS',
    'ST NEXANS',
    'ST SAUVEUR',
    'VERDON',
  ],
  24240: [
    'CUNEGES',
    'GAGEAC ET ROUILLAC',
    'MESCOULES',
    'MONBAZILLAC',
    'MONESTIER',
    'POMPORT',
    'RAZAC DE SAUSSIGNAC',
    'RIBAGNAC',
    'ROUFFIGNAC DE SIGOULES',
    'SAUSSIGNAC',
    'SIGOULES ET FLAUGEAC',
    'THENAC',
  ],
  24410: [
    'ECHOURGNAC',
    'LA JEMAYE PONTEYRAUD',
    'PARCOUL CHENAUD',
    'ST AULAYE PUYMANGOU',
    'ST PRIVAT EN PERIGORD',
    'ST VINCENT JALMOUTIERS',
    'SERVANCHES',
  ],
  24700: [
    'EYGURANDE ET GARDEDEUIL',
    'MENESPLET',
    'MONTPON MENESTEROL',
    'MOULIN NEUF',
    'LE PIZOU',
    'ST BARTHELEMY DE BELLEGARDE',
    'ST GERAUD DE CORPS',
    'ST MARTIAL D ARTENSET',
    'ST REMY',
    'ST SAUVEUR LALANDE',
  ],
  24500: [
    'EYMET',
    'FONROQUE',
    'RAZAC D EYMET',
    'SADILLAC',
    'ST AUBIN DE CADELECH',
    'ST CAPRAISE D EYMET',
    'ST JULIEN INNOCENCE EULALIE',
    'SERRES ET MONTGUYARD',
    'SINGLEYRAC',
  ],
  24620: ['LES EYZIES', 'MARQUAY', 'PEYZAC LE MOUSTIER', 'TAMNIES', 'TURSAC'],
  24580: ['FLEURAC', 'PLAZAC', 'ROUFFIGNAC ST CERNIN DE REILHAC'],
  33220: [
    'FOUGUEYROLLES',
    'PORT STE FOY ET PONCHAPT',
    'CAPLONG',
    'EYNESSE',
    'LES LEVES ET THOUMEYRAGUES',
    'LIGUEUX',
    'MARGUERON',
    'PINEUILH',
    'RIOCAUD',
    'LA ROQUILLE',
    'ST ANDRE ET APPELLES',
    'ST AVIT DE SOULEGE',
    'ST AVIT ST NAZAIRE',
    'STE FOY LA GRANDE',
    'ST PHILIPPE DU SEIGNAL',
    'ST QUENTIN DE CAPLONG',
  ],
  24680: ['GARDONNE', 'LAMONZIE ST MARTIN'],
  24630: ['JUMILHAC LE GRAND'],
  24340: [
    'RUDEAU LADOSSE',
    'MAREUIL EN PERIGORD',
    'LA ROCHEBEAUCOURT ET ARGENTINE',
    'STE CROIX DE MAREUIL',
    'ST FELIX DE BOURDEILLES',
  ],
  24510: [
    'LIMEUIL',
    'PAUNAT',
    'PEZULS',
    'VAL DE LOUYRE ET CAUDEAU',
    'ST FELIX DE VILLADEIX',
    'STE FOY DE LONGAS',
    'ST MARCEL DU PERIGORD',
    'TREMOLAT',
  ],
  24000: ['PERIGUEUX'],
  24490: ['LA ROCHE CHALAIS'],
  25320: [
    'ABBANS DESSOUS',
    'BOUSSIERES',
    'BUSY',
    'BYANS SUR DOUBS',
    'CHEMAUDIN ET VAUX',
    'GRANDFONTAINE',
    'MONTFERRAND LE CHATEAU',
    'OSSELLE ROUTELLE',
    'RANCENAY',
    'THORAISE',
    'TORPES',
    'VORGES LES PINS',
  ],
  25440: [
    'ABBANS DESSUS',
    'BARTHERANS',
    'BRERES',
    'BUFFARD',
    'BY',
    'CESSEY',
    'CHARNAY',
    'CHAY',
    'CHENECEY BUILLON',
    'CHOUZELOT',
    'COURCELLES',
    'CUSSEY SUR LISON',
    'ECHAY',
    'FOURG',
    'GOUX SOUS LANDET',
    'LAVANS QUINGEY',
    'LIESLE',
    'LOMBARD',
    'MESMAY',
    'MYON',
    'PALANTINE',
    'PAROY',
    'PESSANS',
    'LE VAL',
    'QUINGEY',
    'RENNES SUR LOUE',
    'RONCHAUX',
    'ROUHE',
    'SAMSON',
  ],
  25340: [
    'ABBENANS',
    'ANTEUIL',
    'BRANNE',
    'PAYS DE CLERVAL',
    'CROSEY LE GRAND',
    'CROSEY LE PETIT',
    'FONTAINE LES CLERVAL',
    'FONTENELLE MONTBY',
    'GONDENANS MONTBY',
    'L HOPITAL ST LIEFFROY',
    'POMPIERRE SUR DOUBS',
    'ROCHE LES CLERVAL',
    'ST GEORGES ARMONT',
    'UZELLE',
    'VIETHOREY',
  ],
  25310: [
    'ABBEVILLERS',
    'BLAMONT',
    'DANNEMARIE',
    'GLAY',
    'HERIMONCOURT',
    'MESLIERES',
    'PIERREFONTAINE LES BLAMONT',
    'ROCHES LES BLAMONT',
    'THULAY',
    'VILLARS LES BLAMONT',
  ],
  25250: [
    'ACCOLANS',
    'APPENANS',
    'BEUTAL',
    'BLUSSANGEAUX',
    'BLUSSANS',
    'BOURNOIS',
    'BRETIGNEY',
    'ETRAPPE',
    'FAIMBE',
    'GEMONVAL',
    'GENEY',
    'HYEMONDANS',
    'L ISLE SUR LE DOUBS',
    'LANTHENANS',
    'MANCENANS',
    'MARVELISE',
    'MEDIERE',
    'ONANS',
    'LA PRETIERE',
    'RANG',
    'SOURANS',
    'SOYE',
  ],
  25360: [
    'ADAM LES PASSAVANT',
    'AISSEY',
    'BOUCLANS',
    'CHAMPLIVE',
    'COTEBRUNE',
    'GLAMONDANS',
    'GONSANS',
    'LANANS',
    'MAGNY CHATELARD',
    'NAISEY LES GRANGES',
    'NANCRAY',
    'OSSE',
    'PASSAVANT',
    'ST JUAN',
    'VAUDRIVILLERS',
  ],
  25530: [
    'ADAM LES VERCEL',
    'BELMONT',
    'BREMONDANS',
    'CHAUX LES PASSAVANT',
    'CHEVIGNEY LES VERCEL',
    'COURTETAIN ET SALANS',
    'EPENOUSE',
    'EYSSON',
    'LANDRESSE',
    'ORSANS',
    'OUVANS',
    'VELLEROT LES VERCEL',
    'VERCEL VILLEDIEU LE CAMP',
    'VILLERS CHIEF',
  ],
  25750: ['AIBRE', 'ARCEY', 'DESANDANS', 'SEMONDANS', 'LE VERNOY'],
  25490: ['ALLENJOIE', 'BADEVEL', 'DAMPIERRE LES BOIS', 'FESCHES LE CHATEL'],
  25300: [
    'LES ALLIES',
    'ARCON',
    'CHAFFOIS',
    'LA CLUSE ET MIJOUX',
    'DOMMARTIN',
    'DOUBS',
    'LES FOURGS',
    'GRANGES NARBOZ',
    'HOUTAUD',
    'PONTARLIER',
    'STE COLOMBE',
    'VERRIERES DE JOUX',
    'VUILLECIN',
  ],
  25550: [
    'ALLONDANS',
    'BAVANS',
    'DUNG',
    'ECHENANS',
    'ISSANS',
    'LAIRE',
    'PRESENTEVILLERS',
    'RAYNANS',
    'ST JULIEN LES MONTBELIARD',
  ],
  25220: ['AMAGNEY', 'CHALEZE', 'CHALEZEULE', 'NOVILLARS', 'ROCHE LEZ BEAUPRE', 'THISE', 'VAIRE'],
  25330: [
    'AMANCEY',
    'AMATHAY VESIGNEUX',
    'AMONDANS',
    'BOLANDOZ',
    'CHANTRANS',
    'CLERON',
    'DESERVILLERS',
    'ETERNOZ',
    'FERTANS',
    'FLAGEY',
    'LIZINE',
    'LONGEVILLE',
    'MALANS',
    'NANS SOUS STE ANNE',
    'REUGNEY',
    'SARAZ',
    'SILLEY AMANCEY',
  ],
  25400: ['ARBOUANS', 'AUDINCOURT', 'EXINCOURT', 'TAILLECOURT'],
  25610: ['ARC ET SENANS'],
  25520: [
    'ARC SOUS CICON',
    'AUBONNE',
    'VAL D USIERS',
    'BUGNY',
    'EVILLERS',
    'OUHANS',
    'RENEDALE',
    'ST GORGON MAIN',
  ],
  25270: [
    'ARC SOUS MONTENOT',
    'CHAPELLE D HUIN',
    'CROUZET MIGETTE',
    'GEVRESIN',
    'LEVIER',
    'MONTMAHOUX',
    'STE ANNE',
    'SEPTFONTAINES',
    'VILLENEUVE D AMONT',
    'VILLERS SOUS CHALAMONT',
  ],
  25170: [
    'AUDEUX',
    'BURGILLE',
    'CHAMPAGNEY',
    'CHAMPVANS LES MOULINS',
    'CHAUCENNE',
    'CHEVIGNEY SUR L OGNON',
    'COURCHAPON',
    'EMAGNY',
    'ETRABONNE',
    'FRANEY',
    'JALLERANGE',
    'LANTENNE VERTIERE',
    'LAVERNAY',
    'MAZEROLLES LE SALIN',
    'MONCLEY',
    'LE MOUTHEROT',
    'NOIRONTE',
    'PELOUSEY',
    'PLACEY',
    'RECOLOGNE',
    'RUFFEY LE CHATEAU',
    'SAUVAGNEY',
    'VILLERS BUZON',
  ],
  25110: [
    'AUTECHAUX',
    'BAUME LES DAMES',
    'BRETIGNEY NOTRE DAME',
    'CUSANCE',
    'DAMMARTIN LES TEMPLIERS',
    'ESNANS',
    'FONTENOTTE',
    'FOURBANNE',
    'GROSBOIS',
    'GUILLON LES BAINS',
    'HYEVRE MAGNY',
    'HYEVRE PAROISSE',
    'LOMONT SUR CRETE',
    'LUXIOL',
    'MONTIVERNAGE',
    'PONT LES MOULINS',
    'RILLANS',
    'SECHIN',
    'SILLEY BLEFOND',
    'VERGRANNE',
    'VERNE',
    'VILLERS ST MARTIN',
    'VOILLANS',
  ],
  25150: [
    'AUTECHAUX ROIDE',
    'BOURGUIGNON',
    'DAMBELIN',
    'ECOT',
    'ECURCEY',
    'GOUX LES DAMBELIN',
    'NEUCHATEL URTIERE',
    'PONT DE ROIDE VERMONDANS',
    'REMONDANS VAIVRE',
    'VILLARS SOUS ECOT',
  ],
  25870: [
    'LES AUXONS',
    'BONNAY',
    'CHATILLON LE DUC',
    'CHEVROZ',
    'CUSSEY SUR L OGNON',
    'DEVECEY',
    'GENEUILLE',
    'MEREY VIEILLEY',
    'MONCEY',
    'PALISE',
    'TALLENAY',
    'THUREY LE MONT',
    'VALLEROY',
    'VENISE',
    'VIEILLEY',
  ],
  25720: ['AVANNE AVENEY', 'BEURE', 'FONTAIN', 'LARNOD', 'PUGEY'],
  25680: [
    'AVILLEY',
    'BONNAL',
    'CUBRIAL',
    'CUBRY',
    'CUSE ET ADRISANS',
    'GONDENANS LES MOULINS',
    'GOUHELANS',
    'HUANNE MONTMARTIN',
    'MESANDANS',
    'MONDON',
    'MONTAGNEY SERVIGNEY',
    'MONTUSSAINT',
    'NANS',
    'PUESSANS',
    'ROGNON',
    'ROMAIN',
    'ROUGEMONT',
    'TALLANS',
    'TOURNANS',
    'TRESSANDANS',
    'TROUVANS',
  ],
  25690: ['AVOUDREY', 'LONGECHAUX', 'LONGEMAISON', 'PASSONFONTAINE'],
  25560: [
    'BANNANS',
    'BONNEVAUX',
    'BOUJAILLES',
    'BOUVERANS',
    'BULLE',
    'COURVIERES',
    'DOMPIERRE LES TILLEULS',
    'FRASNE',
    'LA RIVIERE DRUGEON',
  ],
  25210: [
    'LE BARBOUX',
    'LE BIZOT',
    'BONNETAGE',
    'LA BOSSE',
    'LES FONTENELLES',
    'GRAND COMBE DES BOIS',
    'LAVAL LE PRIEURE',
    'LE LUHIER',
    'LE MEMONT',
    'MONTBELIARDOT',
    'MONT DE LAVAL',
    'NARBIEF',
    'PLAIMBOIS DU MIROIR',
    'LE RUSSEY',
    'ST JULIEN LES RUSSEY',
  ],
  25420: ['BART', 'BERCHE', 'COURCELLES LES MONTBELIARD', 'DAMPIERRE SUR LE DOUBS', 'VOUJEAUCOURT'],
  25640: [
    'BATTENANS LES MINES',
    'BLARIANS',
    'BRAILLANS',
    'BRECONCHAUX',
    'LA BRETENIERE',
    'CENDREY',
    'CHAMPOUX',
    'CHATILLON GUYOTTE',
    'CORCELLE MIESLOT',
    'L ECOUVOTTE',
    'FLAGEY RIGNEY',
    'GERMONDANS',
    'MARCHAUX CHAUDEFONTAINE',
    'OLLANS',
    'OUGNEY DOUVOT',
    'POULIGNEY LUSANS',
    'LE PUY',
    'RIGNEY',
    'RIGNOSOT',
    'ROUGEMONTOT',
    'ROULANS',
    'ST HILAIRE',
    'LA TOUR DE SCAY',
    'VAL DE ROULANS',
    'VENNANS',
    'VILLERS GRELOT',
  ],
  25380: [
    'BATTENANS VARIN',
    'BELLEHERBE',
    'BRETONVILLERS',
    'CHAMESEY',
    'CHARMOILLE',
    'COUR ST MAURICE',
    'LA GRANGE',
    'LONGEVELLE LES RUSSEY',
    'PROVENCHERE',
    'ROSUREUX',
    'SURMONT',
    'VAUCLUSE',
    'VAUCLUSOTTE',
  ],
  25470: [
    'BELFAYS',
    'BURNEVILLERS',
    'CHARMAUVILLERS',
    'COURTEFONTAINE',
    'FERRIERES LE LAC',
    'FESSEVILLERS',
    'GOUMOIS',
    'INDEVILLERS',
    'LES PLAINS ET GRANDS ESSARTS',
    'THIEBOUHANS',
    'TREVILLERS',
    'URTIERE',
  ],
  25500: [
    'LE BELIEU',
    'LA CHENALOTTE',
    'LES COMBES',
    'LES FINS',
    'MONTLEBON',
    'MORTEAU',
    'NOEL CERNEUX',
  ],
  25430: [
    'BELVOIR',
    'CHAZOT',
    'ORVE',
    'RAHON',
    'RANDEVILLERS',
    'SANCEY',
    'SERVIN',
    'VELLEROT LES BELVOIR',
    'VELLEVANS',
    'VERNOIS LES BELVOIR',
    'VYT LES BELVOIR',
  ],
  25410: [
    'BERTHELANGE',
    'CORCELLES FERRIERES',
    'CORCONDRAY',
    'DANNEMARIE SUR CRETE',
    'FERRIERES LES BOIS',
    'MERCEY LE GRAND',
    'OSSELLE ROUTELLE',
    'POUILLEY FRANCAIS',
    'ROSET FLUANS',
    'ST VIT',
    'VELESMES ESSARTS',
    'VILLARS ST GEORGES',
  ],
  25000: ['BESANCON'],
  25200: ['BETHONCOURT', 'GRAND CHARMONT', 'MONTBELIARD'],
  25190: [
    'BIEF',
    'CHAMESOL',
    'LES TERRES DE CHAUX',
    'DAMPJOUX',
    'FEULE',
    'FLEUREY',
    'FROIDEVAUX',
    'GLERE',
    'LIEBVILLERS',
    'MONTANCY',
    'MONTANDON',
    'MONTECHEROUX',
    'MONTJOIE LE CHATEAU',
    'NOIREFONTAINE',
    'PESEUX',
    'ROSIERES SUR BARBECHE',
    'ST HIPPOLYTE',
    'SOLEMONT',
    'SOULCE CERNAY',
    'VALONNE',
    'VALOREILLE',
    'VAUFREY',
    'VILLARS SOUS DAMPJOUX',
  ],
  25230: ['BONDEVAL', 'DASLE', 'SELONCOURT', 'VANDONCOURT'],
  25120: [
    'LES BRESEUX',
    'CERNAY L EGLISE',
    'MAICHE',
    'MANCENANS LIZERNE',
    'MONT DE VOUGNEY',
    'ORGEANS BLANCHEFONTAINE',
  ],
  25240: [
    'BREY ET MAISON DU BOIS',
    'CHAPELLE DES BOIS',
    'CHATELBLANC',
    'CHAUX NEUVE',
    'LE CROUZET',
    'GELLIN',
    'MOUTHE',
    'PETITE CHAUX',
    'LES PONTETS',
    'RECULFOZ',
    'RONDEFONTAINE',
    'SARRAGEOIS',
    'LES VILLEDIEU',
  ],
  25600: ['BROGNARD', 'DAMBENOIS', 'NOMMAY', 'SOCHAUX', 'VIEUX CHARMONT'],
  25290: ['CADEMENE', 'CHASSAGNE ST DENIS', 'EPEUGNEY', 'ORNANS', 'RUREY', 'SCEY MAISIERES'],
  25140: ['CHARQUEMONT', 'LES ECORCES', 'FOURNET BLANCHEROCHE', 'FRAMBOUHANS'],
  25840: ['CHATEAUVIEUX LES FOSSES', 'VUILLAFANS'],
  25650: [
    'LA CHAUX',
    'GILLEY',
    'HAUTERIVE LA FRESSE',
    'LA LONGEVILLE',
    'MAISONS DU BOIS LIEVREMONT',
    'MONTBENOIT',
    'MONTFLOVIN',
    'VILLE DU PONT',
  ],
  25770: ['CHEMAUDIN ET VAUX', 'FRANOIS', 'SERRE LES SAPINS'],
  25620: [
    'LA CHEVILLOTTE',
    'ETALANS',
    'LE GRATTERIS',
    'L HOPITAL DU GROSBOIS',
    'MALBRANS',
    'MAMIROLLE',
    'LES MONTS RONDS',
    'ORNANS',
    'TARCENAY FOUCHERANS',
    'TREPOT',
  ],
  25260: [
    'COLOMBIER FONTAINE',
    'ETOUVANS',
    'LONGEVELLE SUR DOUBS',
    'LOUGRES',
    'MONTENOIS',
    'ST MAURICE COLOMBIER',
  ],
  25390: [
    'CONSOLATION MAISONNETTES',
    'FLANGEBOUCHE',
    'FUANS',
    'FOURNETS LUISANS',
    'GUYANS VENNES',
    'LORAY',
    'ORCHAMPS VENNES',
    'PLAIMBOIS VENNES',
    'VENNES',
  ],
  25450: ['DAMPRICHARD'],
  25960: ['DELUZ'],
  25510: [
    'DOMPREL',
    'GERMEFONTAINE',
    'GRANDFONTAINE SUR CREUSE',
    'LAVIRON',
    'PIERREFONTAINE LES VARANS',
    'LA SOMMETTE',
    'VILLERS LA COMBE',
  ],
  25580: [
    'DURNES',
    'ECHEVANNES',
    'ETALANS',
    'FALLERANS',
    'GUYANS DURNES',
    'LAVANS VUILLAFANS',
    'LES PREMIERS SAPINS',
    'SAULES',
    'VERNIERFONTAINE',
    'VOIRES',
  ],
  25480: ['ECOLE VALENTIN', 'MISEREY SALINES', 'PIREY'],
  25800: ['EPENOY', 'ETRAY', 'VALDAHON'],
  25460: ['ETUPES'],
  25660: [
    'FONTAIN',
    'GENNES',
    'LES MONTS RONDS',
    'MONTFAUCON',
    'MONTROND LE CHATEAU',
    'MORRE',
    'SAONE',
    'LA VEZE',
  ],
  25370: [
    'FOURCATIER ET MAISON NEUVE',
    'LES HOPITAUX NEUFS',
    'LES HOPITAUX VIEUX',
    'JOUGNE',
    'LONGEVILLES MONT D OR',
    'METABIEF',
    'ROCHEJEAN',
    'ST ANTOINE',
    'TOUILLON ET LOUTELET',
  ],
  25570: ['GRAND COMBE CHATELEU'],
  25160: [
    'LES GRANGETTES',
    'LABERGEMENT STE MARIE',
    'MALBUISSON',
    'MALPAS',
    'MONTPERREUX',
    'OYE ET PALLET',
    'LA PLANEE',
    'REMORAY BOUJEONS',
    'ST POINT LAC',
    'VAUX ET CHANTEGRUE',
  ],
  25790: ['LES GRAS'],
  25130: ['VILLERS LE LAC'],
  25820: ['LAISSEY'],
  25930: ['LODS'],
  25350: ['MANDEURE'],
  25700: ['MATHAY', 'VALENTIGNEY'],
  25111: ['MONTGESOYE'],
  25920: ['MOUTHIER HAUTE PIERRE'],
  25115: ['POUILLEY LES VIGNES'],
  25113: ['STE MARIE'],
  25630: ['STE SUZANNE'],
  26150: [
    'SOLAURE EN DIOIS',
    'BARSAC',
    'CHAMALOC',
    'DIE',
    'LAVAL D AIX',
    'MARIGNAC EN DIOIS',
    'MONTMAUR EN DIOIS',
    'PONET ET ST AUBAN',
    'PONTAIX',
    'ROMEYER',
    'ST ANDEOL',
    'STE CROIX',
    'ST JULIEN EN QUINT',
    'VACHERES EN QUINT',
  ],
  26140: ['ALBON', 'ANDANCETTE', 'ANNEYRON', 'ST RAMBERT D ALBON'],
  26770: [
    'ALEYRAC',
    'MONTBRISON SUR LEZ',
    'LE PEGUE',
    'ROCHE ST SECRET BECONNE',
    'ROUSSET LES VIGNES',
    'ST PANTALEON LES VIGNES',
    'SALLES SOUS BOIS',
    'TAULIGNAN',
  ],
  26300: [
    'ALIXAN',
    'BARBIERES',
    'BEAUREGARD BARET',
    'BESAYES',
    'BOURG DE PEAGE',
    'CHARPEY',
    'CHATEAUNEUF SUR ISERE',
    'CHATUZANGE LE GOUBET',
    'MARCHES',
    'ROCHEFORT SAMSON',
    'JAILLANS',
    'ST VINCENT LA COMMANDERIE',
  ],
  26780: ['ALLAN', 'CHATEAUNEUF DU RHONE', 'ESPELUCHE', 'MALATAVERNE'],
  26400: [
    'ALLEX',
    'AOUSTE SUR SYE',
    'LA REPARA AURIPLES',
    'AUTICHAMP',
    'BEAUFORT SUR GERVANNE',
    'CHABRILLAN',
    'COBONNE',
    'CREST',
    'DIVAJEU',
    'EURRE',
    'EYGLUY ESCOULIN',
    'FRANCILLON SUR ROUBION',
    'GIGORS ET LOZERON',
    'GRANE',
    'MIRABEL ET BLACONS',
    'MONTCLAR SUR GERVANNE',
    'OMBLEZE',
    'PIEGROS LA CLASTRE',
    'PLAN DE BAIX',
    'LA ROCHE SUR GRANE',
    'SAOU',
    'SOYANS',
    'SUZE',
    'VAUNAVEYS LA ROCHETTE',
  ],
  26800: ['AMBONIL', 'BEAUVALLON', 'ETOILE SUR RHONE', 'MONTOISON', 'PORTES LES VALENCE'],
  26200: ['ANCONE', 'MONTELIMAR'],
  26470: [
    'ARNAYON',
    'BELLEGARDE EN DIOIS',
    'CHALANCON',
    'LA CHARCE',
    'ESTABLET',
    'GUMIANE',
    'LA MOTTE CHALANCON',
    'POMMEROL',
    'ROTTIER',
    'VOLVENT',
  ],
  26110: [
    'ARPAVON',
    'AUBRES',
    'BELLECOMBE TARENDOL',
    'BESIGNAN',
    'CHATEAUNEUF DE BORDETTE',
    'CHAUDEBONNE',
    'CONDORCET',
    'CURNIER',
    'EYROLES',
    'MIRABEL AUX BARONNIES',
    'MONTAULIEU',
    'NYONS',
    'PIEGON',
    'LES PILLES',
    'LE POET SIGILLAT',
    'ROCHEBRUNE',
    'ST FERREOL TRENTE PAS',
    'STE JALLE',
    'ST MAURICE SUR EYGUES',
    'ST SAUVEUR GOUVERNET',
    'VALOUSE',
    'VENTEROL',
    'VINSOBRES',
  ],
  26260: [
    'ARTHEMONAY',
    'BATHERNAY',
    'BREN',
    'CHARMES SUR L HERBASSE',
    'CHAVANNES',
    'CLERIEUX',
    'MARGES',
    'MARSAZ',
    'ST BARDOUX',
    'ST DONAT SUR L HERBASSE',
  ],
  26340: [
    'AUBENASSON',
    'AUCELON',
    'AUREL',
    'BRETTE',
    'CHASTEL ARNAUD',
    'LA CHAUDIERE',
    'ESPENEL',
    'PENNES LE SEC',
    'PRADELLE',
    'RIMON ET SAVEL',
    'ROCHEFOURCHAT',
    'SAILLANS',
    'ST BENOIT EN DIOIS',
    'ST NAZAIRE LE DESERT',
    'ST SAUVEUR EN DIOIS',
    'VERCHENY',
    'VERONNE',
  ],
  26570: ['AULAN', 'BARRET DE LIOURE', 'FERRASSIERES', 'MONTBRUN LES BAINS', 'REILHANETTE'],
  26560: [
    'BALLONS',
    'EYGALAYES',
    'IZON LA BRUISSE',
    'LABOREL',
    'LACHAU',
    'MEVOUILLON',
    'MONTFROC',
    'SEDERON',
    'VERS SUR MEOUGE',
    'VILLEFRANCHE LE CHATEAU',
  ],
  26120: [
    'BARCELONNE',
    'LA BAUME CORNILLANE',
    'CHABEUIL',
    'CHATEAUDOUBLE',
    'COMBOVIN',
    'MALISSARD',
    'MONTELIER',
    'MONTMEYRAN',
    'MONTVENDRE',
    'OURCHES',
    'PEYRUS',
    'UPIE',
  ],
  26310: [
    'BARNAVE',
    'LA BATIE DES FONDS',
    'BEAUMONT EN DIOIS',
    'BEAURIERES',
    'CHARENS',
    'VAL MARAVEL',
    'JONCHERES',
    'LESCHES EN DIOIS',
    'LUC EN DIOIS',
    'MISCON',
    'MONTLAUR EN DIOIS',
    'POYOLS',
    'LES PRES',
    'RECOUBEAU JANSAC',
    'ST DIZIER EN DIOIS',
    'VALDROME',
  ],
  26160: [
    'LA BATIE ROLLAND',
    'LA BEGUDE DE MAZENC',
    'BONLIEU SUR ROUBION',
    'EYZAHUT',
    'FELINES SUR RIMANDOULE',
    'MANAS',
    'LE POET LAVAL',
    'PONT DE BARRET',
    'PORTES EN VALDAINE',
    'PUYGIRON',
    'ROCHEBAUDIN',
    'ROCHEFORT EN VALDAINE',
    'ST GERVAIS SUR ROUBION',
    'SALETTES',
    'SOUSPIERRE',
    'LA TOUCHE',
  ],
  26790: ['LA BAUME DE TRANSIT', 'BOUCHET', 'ROCHEGUDE', 'SUZE LA ROUSSE', 'TULETTE'],
  26730: ['LA BAUME D HOSTUN', 'EYMEUX', 'HOSTUN'],
  26760: ['BEAUMONT LES VALENCE', 'MONTELEGER'],
  26600: [
    'BEAUMONT MONTEUX',
    'CHANOS CURSON',
    'CHANTEMERLE LES BLES',
    'CROZES HERMITAGE',
    'EROME',
    'LARNAGE',
    'MERCUROL VEAUNES',
    'PONT DE L ISERE',
    'LA ROCHE DE GLUN',
    'SERVES SUR RHONE',
    'TAIN L HERMITAGE',
    'GRANGES LES BEAUMONT',
    'GERVANS',
  ],
  26240: [
    'BEAUSEMBLANT',
    'CLAVEYSON',
    'FAY LE CLOS',
    'LAVEYRON',
    'ST JEAN DE GALAURE',
    'PONSAS',
    'ST BARTHELEMY DE VALS',
    'ST UZE',
    'ST VALLIER',
  ],
  26170: [
    'BEAUVOISIN',
    'BENIVAY OLLON',
    'BUIS LES BARONNIES',
    'EYGALIERS',
    'MERINDOL LES OLIVIERS',
    'MOLLANS SUR OUVEZE',
    'MONTAUBAN SUR L OUVEZE',
    'MONTGUERS',
    'LA PENNE SUR L OUVEZE',
    'PIERRELONGUE',
    'PLAISIANS',
    'LE POET EN PERCIP',
    'PROPIAC',
    'RIOMS',
    'LA ROCHE SUR LE BUIS',
    'LA ROCHETTE DU BUIS',
    'ST AUBAN SUR L OUVEZE',
    'STE EUPHEMIE SUR OUVEZE',
    'VERCOIRAN',
  ],
  26460: [
    'BEZAUDUN SUR BINE',
    'BOURDEAUX',
    'BOUVIERES',
    'CRUPIES',
    'MORNANS',
    'LE POET CELARD',
    'LES TONILS',
    'TRUINAS',
  ],
  26410: ['BOULC', 'CHATILLON EN DIOIS', 'GLANDAGE', 'MENGLON', 'ST ROMAN'],
  26500: ['BOURG LES VALENCE'],
  26190: [
    'BOUVANTE',
    'LE CHAFFAL',
    'ECHEVIS',
    'LEONCEL',
    'LA MOTTE FANJAS',
    'ORIOL EN ROYANS',
    'ROCHECHINARD',
    'STE EULALIE EN ROYANS',
    'ST JEAN EN ROYANS',
    'ST LAURENT EN ROYANS',
    'ST MARTIN LE COLONEL',
    'ST NAZAIRE EN ROYANS',
    'ST THOMAS EN ROYANS',
  ],
  26350: [
    'LE CHALON',
    'CREPOL',
    'MONTCHENU',
    'VALHERBASSE',
    'ST CHRISTOPHE ET LE LARIS',
    'ST LAURENT D ONAY',
  ],
  26230: [
    'CHAMARET',
    'CHANTEMERLE LES GRIGNAN',
    'COLONZELLE',
    'GRIGNAN',
    'MONTJOYER',
    'REAUVILLE',
    'ROUSSAS',
    'VALAURIE',
  ],
  26420: [
    'LA CHAPELLE EN VERCORS',
    'ST AGNAN EN VERCORS',
    'ST JULIEN EN VERCORS',
    'ST MARTIN EN VERCORS',
    'VASSIEUX EN VERCORS',
  ],
  26450: ['CHAROLS', 'CLEON D ANDRAN', 'PUY ST MARTIN', 'ROYNAC'],
  26330: ['CHATEAUNEUF DE GALAURE', 'RATIERES', 'ST AVIT', 'ST MARTIN D AOUT'],
  26750: [
    'CHATILLON ST JEAN',
    'GENISSIEUX',
    'GEYSSANS',
    'MONTMIRAL',
    'PARNANS',
    'ST MICHEL SUR SAVASSE',
    'ST PAUL LES ROMANS',
    'TRIORS',
  ],
  26510: [
    'CHAUVAC LAUX MONTAUX',
    'CORNILLAC',
    'CORNILLON SUR L OULE',
    'LEMPS',
    'MONTFERRAND LA FARE',
    'MONTREAL LES SOURCES',
    'PELONNE',
    'REMUZAT',
    'ROUSSIEUX',
    'SAHUNE',
    'ST MAY',
    'VERCLAUSE',
    'VILLEPERDRIX',
  ],
  26130: [
    'CLANSAYES',
    'MONTSEGUR SUR LAUZON',
    'ST PAUL TROIS CHATEAUX',
    'ST RESTITUT',
    'SOLERIEUX',
  ],
  26270: ['CLIOUSCLAT', 'LORIOL SUR DROME', 'MIRMANDE', 'SAULCE SUR RHONE'],
  26220: ['COMPS', 'DIEULEFIT', 'MONTJOUX', 'ORCINAS', 'TEYSSIERES', 'VESC'],
  26740: [
    'CONDILLAC',
    'LA COUCOURDE',
    'LA LAUPIE',
    'MARSANNE',
    'MONTBOUCHER SUR JABRON',
    'ST MARCEL LES SAUZET',
    'SAUZET',
    'SAVASSE',
    'LES TOURRETTES',
  ],
  26290: ['DONZERE', 'LES GRANGES GONTARDES'],
  26210: [
    'EPINOUZE',
    'LAPEYROUSE MORNAY',
    'LENS LESTANG',
    'MANTHES',
    'MORAS EN VALLOIRE',
    'ST SORLIN EN VALLOIRE',
  ],
  26700: ['LA GARDE ADHEMAR', 'PIERRELATTE'],
  26530: ['LE GRAND SERRE'],
  26390: ['HAUTERIVES', 'TERSANNE'],
  26250: ['LIVRON SUR DROME'],
  26620: ['LUS LA CROIX HAUTE'],
  26540: ['MOURS ST EUSEBE'],
  26380: ['PEYRINS'],
  26100: ['ROMANS SUR ISERE'],
  26320: ['ST MARCEL LES VALENCE'],
  26000: ['VALENCE'],
  27800: [
    'ACLOU',
    'LE BEC HELLOUIN',
    'BERTHOUVILLE',
    'BOISNEY',
    'BOSROBERT',
    'BRETIGNY',
    'BRIONNE',
    'CALLEVILLE',
    'FRANQUEVILLE',
    'HARCOURT',
    'LA HAYE DE CALLEVILLE',
    'HECMANVILLE',
    'LIVET SUR AUTHOU',
    'MALLEVILLE SUR LE BEC',
    'MORSAN',
    'NEUVILLE SUR AUTHOU',
    'NOTRE DAME D EPINE',
    'ST CYR DE SALERNE',
    'ST ELOI DE FOURQUES',
    'ST PAUL DE FOURQUES',
    'ST PIERRE DE SALERNE',
    'ST VICTOR D EPINE',
    'THIBOUVILLE',
  ],
  27570: ['ACON', 'BREUX SUR AVRE', 'L HOSMES', 'TILLIERES SUR AVRE'],
  27400: [
    'ACQUIGNY',
    'AMFREVILLE SUR ITON',
    'CANAPPEVILLE',
    'CRASVILLE',
    'LA HAYE LE COMTE',
    'LA HAYE MALHERBE',
    'HEUDEBOUVILLE',
    'HEUDREVILLE SUR EURE',
    'HONDOUVILLE',
    'HOUETTEVILLE',
    'INCARVILLE',
    'LOUVIERS',
    'LE MESNIL JOURDAIN',
    'TERRES DE BORD',
    'PINTERVILLE',
    'QUATREMARE',
    'SURTAUVILLE',
    'SURVILLE',
    'LA VACHERIE',
    'VIRONVAY',
  ],
  27120: [
    'AIGLEVILLE',
    'BOISSET LES PREVANCHES',
    'BONCOURT',
    'CAILLOUET ORGEVILLE',
    'CHAIGNES',
    'CHAMBRAY',
    'LE CORMIER',
    'CROISY SUR EURE',
    'DOUAINS',
    'FAINS',
    'FONTAINE SOUS JOUY',
    'GADENCOURT',
    'HARDENCOURT COCHEREL',
    'HECOURT',
    'HOULBEC COCHEREL',
    'JOUY SUR EURE',
    'MENILLES',
    'PACY SUR EURE',
    'LE PLESSIS HEBERT',
    'ROUVRAY',
    'LE VAL DAVID',
    'VAUX SUR EURE',
    'VILLEGATS',
  ],
  27600: [
    'AILLY',
    'LE VAL D HAZEY',
    'CHAMPENARD',
    'FONTAINE BELLENGER',
    'GAILLON',
    'HEUDEBOUVILLE',
    'ST AUBIN SUR GAILLON',
    'ST JULIEN DE LA LIEGUE',
    'ST PIERRE LA GARENNE',
  ],
  27500: [
    'AIZIER',
    'BOUQUELON',
    'BOURNEVILLE STE CROIX',
    'CAMPIGNY',
    'COLLETOT',
    'CORNEVILLE SUR RISLE',
    'LE PERREY',
    'MANNEVILLE SUR RISLE',
    'PONT AUDEMER',
    'LES PREAUX',
    'ST MARDS DE BLACARVILLE',
    'ST SYMPHORIEN',
    'SELLES',
    'TOCQUEVILLE',
    'TOURVILLE SUR PONT AUDEMER',
    'TOUTAINVILLE',
    'TRIQUEVILLE',
  ],
  27460: ['ALIZAY', 'IGOVILLE', 'LE MANOIR'],
  27250: [
    'AMBENAY',
    'BOIS ARNAULT',
    'LES BOTTEREAUX',
    'CHAMBORD',
    'CHERONVILLIERS',
    'JUIGNETTES',
    'NEAUFLES AUVERGNY',
    'RUGLES',
    'ST ANTONIN DE SOMMAIRE',
  ],
  27140: ['AMECOURT', 'BAZINCOURT SUR EPTE', 'GISORS', 'ST DENIS LE FERMENT'],
  27370: [
    'AMFREVILLE ST AMAND',
    'LE BEC THOMAS',
    'LES MONTS DU ROUMOIS',
    'FOUQUEVILLE',
    'LE BOSC DU THEIL',
    'LA HARENGERE',
    'LA HAYE DU THEIL',
    'MANDEVILLE',
    'LA PYLE',
    'ST CYR LA CAMPAGNE',
    'ST DIDIER DES BOIS',
    'ST GERMAIN DE PASQUIER',
    'ST MESLIN DU BOSC',
    'ST OUEN DE PONTCHEUIL',
    'ST PIERRE DES FLEURS',
    'ST PIERRE DU BOSGUERARD',
    'LA SAUSSAYE',
    'LE THUIT DE L OISON',
    'TOURVILLE LA CAMPAGNE',
    'VRAIVILLE',
  ],
  27380: [
    'AMFREVILLE LES CHAMPS',
    'AMFREVILLE SOUS LES MONTS',
    'BOURG BEAUDOUIN',
    'CHARLEVAL',
    'DOUVILLE SUR ANDELLE',
    'FLEURY SUR ANDELLE',
    'FLIPOU',
    'VAL D ORGER',
    'RADEPONT',
    'VANDRIMARE',
  ],
  27430: [
    'ANDE',
    'CONNELLES',
    'DAUBEUF PRES VATTEVILLE',
    'HERQUEVILLE',
    'MUIDS',
    'PORTE DE SEINE',
    'ST ETIENNE DU VAUVRAY',
    'ST PIERRE DU VAUVRAY',
    'VATTEVILLE',
  ],
  27700: [
    'LES ANDELYS',
    'FRENELLES EN VEXIN',
    'BOUAFLES',
    'CUVERVILLE',
    'GUISENIERS',
    'HARQUENCY',
    'HENNEZIS',
    'HEUQUEVILLE',
    'LA ROQUETTE',
    'LE THUIT',
    'LES TROIS LACS',
    'VEZILLON',
  ],
  27930: [
    'ANGERVILLE LA CAMPAGNE',
    'AVIRON',
    'BACQUEPUIS',
    'LE BOULAY MORIN',
    'BROSVILLE',
    'LA CHAPELLE DU BOIS DES FAULX',
    'CIERREY',
    'DARDEZ',
    'EMALLEVILLE',
    'FAUVILLE',
    'GAUCIEL',
    'GAUVILLE LA CAMPAGNE',
    'GRAVIGNY',
    'GUICHAINVILLE',
    'HUEST',
    'IRREVILLE',
    'LE MESNIL FUGUET',
    'MISEREY',
    'NORMANVILLE',
    'REUILLY',
    'SACQUENVILLE',
    'ST GERMAIN DES ANGLES',
    'ST LUC',
    'ST MARTIN LA CAMPAGNE',
    'ST VIGOR',
    'SASSEY',
    'TOURNEVILLE',
    'LA TRINITE',
    'LE VIEIL EVREUX',
  ],
  27290: [
    'APPEVILLE ANNEBAULT',
    'AUTHOU',
    'BONNEVILLE APTOT',
    'THENOUVILLE',
    'CONDE SUR RISLE',
    'ECAQUELON',
    'FRENEUSE SUR RISLE',
    'GLOS SUR RISLE',
    'ILLEVILLE SUR MONTFORT',
    'MONTFORT SUR RISLE',
    'PONT AUTHOU',
    'ST PHILBERT SUR RISLE',
    'THIERVILLE',
  ],
  27820: ['ARMENTIERES SUR AVRE', 'CHENNEBRUN', 'ST CHRISTOPHE SUR AVRE'],
  27180: [
    'ARNIERES SUR ITON',
    'AULNAY SUR ITON',
    'LES BAUX STE CROIX',
    'BERNIENVILLE',
    'CAUGE',
    'CLAVILLE',
    'PARVILLE',
    'LE PLESSIS GROHAN',
    'ST SEBASTIEN DE MORSENT',
    'TOURNEDOS BOIS HUBERT',
    'LES VENTES',
  ],
  27260: [
    'ASNIERES',
    'BAILLEUL LA VALLEE',
    'LE BOIS HELLAIN',
    'LA CHAPELLE BAYVEL',
    'CORMEILLES',
    'EPAIGNES',
    'FRESNE CAUVERVILLE',
    'MORAINVILLE JOUVEAUX',
    'ST PIERRE DE CORMEILLES',
    'ST SYLVESTRE DE CORMEILLES',
  ],
  27940: [
    'LE VAL D HAZEY',
    'COURCELLES SUR SEINE',
    'NOTRE DAME DE L ISLE',
    'PORT MORT',
    'LES TROIS LACS',
    'VILLERS SUR LE ROULE',
  ],
  27490: ['AUTHEUIL AUTHOUILLET', 'CAILLY SUR EURE', 'CLEF VALLEE D EURE'],
  27420: [
    'AUTHEVERNES',
    'CHATEAU SUR EPTE',
    'VEXIN SUR EPTE',
    'MOUFLAINES',
    'RICHEVILLE',
    'SUZAY',
    'LES THILLIERS EN VEXIN',
    'VILLERS EN VEXIN',
  ],
  27220: [
    'LES AUTHIEUX',
    'BOIS LE ROI',
    'LA BOISSIERE',
    'BRETAGNOLLES',
    'CHAMPIGNY LA FUTELAYE',
    'CHAVIGNY BAILLEUL',
    'COUDRES',
    'LA FORET DU PARC',
    'FOUCRAINVILLE',
    'FRESNEY',
    'LA BARONNIE',
    'GROSSOEUVRE',
    'L HABIT',
    'JUMELLES',
    'LIGNEROLLES',
    'MOUETTES',
    'MOUSSEAUX NEUVILLE',
    'PREY',
    'ST ANDRE DE L EURE',
    'ST GERMAIN DE FRESNEY',
    'ST LAURENT DES BOIS',
    'SEREZ',
  ],
  27240: ['CHAMBOIS', 'MARBOIS', 'MESNILS SUR ITON', 'SYLVAINS LES MOULINS'],
  27440: [
    'BACQUEVILLE',
    'ECOUIS',
    'VAL D ORGER',
    'HOUVILLE EN VEXIN',
    'LISORS',
    'MESNIL VERCLIVES',
    'TOUFFREVILLE',
  ],
  27130: [
    'BALINES',
    'LES BARILS',
    'COURTEILLES',
    'MANDRES',
    'PISEUX',
    'PULLAY',
    'ST VICTOR SUR AVRE',
    'VERNEUIL D AVRE ET D ITON',
  ],
  27170: [
    'BARC',
    'BARQUET',
    'BEAUMONTEL',
    'BEAUMONT LE ROGER',
    'BERVILLE LA CAMPAGNE',
    'BRAY',
    'COMBON',
    'ECARDENVILLE LA CAMPAGNE',
    'GOUPIL OTHON',
    'GROSLEY SUR RISLE',
    'NASSANDRES SUR RISLE',
    'LE PLESSIS STE OPPORTUNE',
    'ROMILLY LA PUTHENAYE',
    'TILLEUL DAME AGNES',
  ],
  27310: [
    'BARNEVILLE SUR SEINE',
    'FLANCOURT CRESCY EN ROUMOIS',
    'BOSGOUET',
    'BOUQUETOT',
    'BOURG ACHARD',
    'CAUMONT',
    'HONGUEMARE GUENOUVILLE',
    'ST OUEN DE THOUBERVILLE',
    'LA TRINITE DE THOUBERVILLE',
  ],
  27230: [
    'BARVILLE',
    'BAZOQUES',
    'BOURNAINVILLE FAVEROLLES',
    'LA CHAPELLE HARENG',
    'DRUCOURT',
    'DURANVILLE',
    'LE FAVRIL',
    'FOLLEVILLE',
    'FONTAINE LA LOUVET',
    'HEUDREVILLE EN LIEUVIN',
    'PIENCOURT',
    'LES PLACES',
    'LE PLANQUAY',
    'ST AUBIN DE SCELLON',
    'ST GERMAIN LA CAMPAGNE',
    'ST MARDS DE FRESNE',
    'ST VINCENT DU BOULAY',
    'LE THEIL NOLENT',
    'THIBERVILLE',
  ],
  27160: [
    'LES BAUX DE BRETEUIL',
    'BEMECOURT',
    'BRETEUIL',
    'MARBOIS',
    'MESNILS SUR ITON',
    'LE LESME',
    'STE MARIE D ATTEZ',
    'VERNEUIL D AVRE ET D ITON',
  ],
  27190: [
    'BEAUBRAY',
    'LA BONNEVILLE SUR ITON',
    'BUREY',
    'CHAMP DOLENT',
    'COLLANDRES QUINCARNON',
    'CONCHES EN OUCHE',
    'LA CROISILLE',
    'EMANVILLE',
    'FAVEROLLES LA CAMPAGNE',
    'FERRIERES HAUT CLOCHER',
    'LE FIDELAIRE',
    'GAUDREVILLE LA RIVIERE',
    'GLISOLLES',
    'LOUVERSEY',
    'NAGEL SEEZ MESNIL',
    'NOGENT LE SEC',
    'ORMES',
    'LE VAL DORE',
    'PORTES',
    'ST ELIER',
    'STE MARTHE',
    'SEBECOURT',
  ],
  27480: [
    'BEAUFICEL EN LYONS',
    'BEZU LA FORET',
    'BOSQUENTIN',
    'FLEURY LA FORET',
    'LILLY',
    'LORLEAU',
    'LYONS LA FORET',
    'LE TRONQUAY',
  ],
  27270: [
    'MESNIL EN OUCHE',
    'BROGLIE',
    'CAPELLE LES GRANDS',
    'CHAMBLAC',
    'LA CHAPELLE GAUTHIER',
    'FERRIERES ST HILAIRE',
    'GRAND CAMP',
    'ST AUBIN DU THENNEY',
    'TREIS SANTS EN OUCHE',
    'ST JEAN DU THENNEY',
    'LA TRINITE DE REVILLE',
  ],
  27330: [
    'MESNIL EN OUCHE',
    'BOIS ANZERAY',
    'BOIS NORMAND PRES LYRE',
    'LA HAYE ST SYLVESTRE',
    'LA NEUVE LYRE',
    'LA VIEILLE LYRE',
  ],
  27410: ['MESNIL EN OUCHE', 'LA HOUSSAYE', 'LE NOYER EN OUCHE'],
  27110: [
    'BERENGEVILLE LA CAMPAGNE',
    'CESSEVILLE',
    'CRESTOT',
    'CRIQUEBEUF LA CAMPAGNE',
    'CROSVILLE LA VIEILLE',
    'DAUBEUF LA CAMPAGNE',
    'ECAUVILLE',
    'ECQUETOT',
    'EPEGARD',
    'EPREVILLE PRES LE NEUBOURG',
    'FEUGUEROLLES',
    'GRAVERON SEMERVILLE',
    'HECTOMARE',
    'IVILLE',
    'MARBEUF',
    'LE NEUBOURG',
    'QUITTEBEUF',
    'ROUGE PERRIERS',
    'ST AUBIN D ECROSVILLE',
    'STE COLOMBE LA COMMANDERIE',
    'STE OPPORTUNE DU BOSC',
    'LE TILLEUL LAMBERT',
    'LE TREMBLAY OMONVILLE',
    'LE TRONCQ',
    'VENON',
    'VILLETTES',
    'VILLEZ SUR LE NEUBOURG',
    'VITOT',
  ],
  27300: [
    'BERNAY',
    'BOISSY LAMBERVILLE',
    'CAORCHES ST NICOLAS',
    'CORNEVILLE LA FOUQUETIERE',
    'COURBEPINE',
    'MALOUY',
    'MENNEVAL',
    'NASSANDRES SUR RISLE',
    'PLAINVILLE',
    'PLASNES',
    'TREIS SANTS EN OUCHE',
    'ST LEGER DE ROTES',
    'ST MARTIN DU TILLEUL',
    'ST VICTOR DE CHRETIENVILLE',
    'VALAILLES',
  ],
  27660: ['BERNOUVILLE', 'BEZU ST ELOI'],
  27520: [
    'LES MONTS DU ROUMOIS',
    'BOISSEY LE CHATEL',
    'THENOUVILLE',
    'GRAND BOURGTHEROULDE',
    'ST DENIS DES MONTS',
    'ST LEGER DU GENNETEY',
    'ST PHILBERT SUR BOISSEY',
    'VOISCREVILLE',
  ],
  27210: [
    'BERVILLE SUR MER',
    'BEUZEVILLE',
    'BOULLEVILLE',
    'CONTEVILLE',
    'FATOUVILLE GRESTAIN',
    'FIQUEFLEUR EQUAINVILLE',
    'FORT MOVILLE',
    'FOULBEC',
    'LA LANDE ST LEGER',
    'MANNEVILLE LA RAOULT',
    'MARTAINVILLE',
    'ST MACLOU',
    'ST PIERRE DU VAL',
    'ST SULPICE DE GRIMBOUVILLE',
    'LE TORPT',
    'VANNECROCQ',
  ],
  27150: [
    'FRENELLES EN VEXIN',
    'BOUCHEVILLIERS',
    'CHAUVINCOURT PROVEMONT',
    'COUDRAY',
    'DOUDEAUVILLE EN VEXIN',
    'ETREPAGNY',
    'FARCEAUX',
    'GAMACHES EN VEXIN',
    'HACQUEVILLE',
    'HEBECOURT',
    'LONGCHAMPS',
    'MAINNEVILLE',
    'MARTAGNY',
    'MESNIL SOUS VIENNE',
    'MORGNY',
    'LA NEUVE GRANGE',
    'NOJEON EN VEXIN',
    'PUCHAY',
    'STE MARIE DE VATIMESNIL',
    'SANCOURT',
    'SAUSSAY LA CAMPAGNE',
    'LE THIL',
  ],
  27620: ['BOIS JEROME ST OUEN', 'GASNY', 'GIVERNY', 'STE GENEVIEVE LES GASNY'],
  27670: ['BOSROUMOIS', 'ST OUEN DU TILLEUL'],
  27580: ['BOURTH', 'CHAISE DIEU DU THEIL', 'GOURNAY LE GUERIN'],
  27350: [
    'BRESTOT',
    'CAUVERVILLE EN ROUMOIS',
    'ETREVILLE',
    'ETURQUERAYE',
    'HAUVILLE',
    'LA HAYE AUBREE',
    'LA HAYE DE ROUTOT',
    'LE LANDIN',
    'ROUGEMONTIERS',
    'ROUTOT',
    'VALLETOT',
  ],
  27640: ['BREUILPONT', 'MEREY', 'VILLIERS EN DESOEUVRE'],
  27730: ['BUEIL', 'EPIEDS', 'NEUILLY'],
  27320: [
    'COURDEMANCHE',
    'DROISY',
    'LA MADELEINE DE NONANCOURT',
    'MARCILLY LA CAMPAGNE',
    'MOISVILLE',
    'NONANCOURT',
    'ST GERMAIN SUR AVRE',
  ],
  27750: ['LA COUTURE BOUSSEY'],
  27340: ['CRIQUEBEUF SUR SEINE', 'LES DAMPS', 'MARTOT', 'TERRES DE BORD', 'PONT DE L ARCHE'],
  27530: ['CROTH', 'EZY SUR EURE'],
  27720: ['DANGU', 'GUERNY', 'NOYERS'],
  27510: ['VEXIN SUR EPTE', 'MEZIERES EN VEXIN', 'PRESSAGNY L ORGUEILLEUX', 'TILLY'],
  27630: ['VEXIN SUR EPTE', 'HEUBECOURT HARICOURT'],
  27560: [
    'EPREVILLE EN LIEUVIN',
    'GIVERVILLE',
    'LIEUREY',
    'NOARDS',
    'LA NOE POULAIN',
    'LA POTERIE MATHIEU',
    'LE MESNIL ST JEAN',
    'ST SIMEON',
  ],
  27000: ['EVREUX'],
  27760: ['LA FERRIERE SUR RISLE'],
  27470: ['FONTAINE L ABBE', 'LAUNAY', 'SERQUIGNY'],
  27680: [
    'LE PERREY',
    'MARAIS VERNIER',
    'QUILLEBEUF SUR SEINE',
    'ST AUBIN SUR QUILLEBEUF',
    'STE OPPORTUNE LA MARE',
    'ST SAMSON DE LA ROQUE',
    'TROUVILLE LA HAULE',
    'VIEUX PORT',
  ],
  27780: ['GARENNES SUR EURE'],
  27390: [
    'LA GOULAFRIERE',
    'MELICOURT',
    'MESNIL ROUSSET',
    'MONTREUIL L ARGILLE',
    'NOTRE DAME DU HAMEL',
    'ST AGNAN DE CERNIERES',
    'ST DENIS D AUGERONS',
    'ST LAURENT DU TENCEMENT',
    'ST PIERRE DE CERNIERES',
    'VERNEUSSES',
  ],
  27860: ['HEUDICOURT'],
  27950: [
    'LA HEUNIERE',
    'MERCEY',
    'STE COLOMBE PRES VERNON',
    'LA CHAPELLE LONGUEVILLE',
    'ST MARCEL',
    'ST VINCENT DES BOIS',
    'VILLEZ SOUS BAILLEUL',
  ],
  27910: [
    'LES HOGUES',
    'LETTEGUIVES',
    'PERRIERS SUR ANDELLE',
    'PERRUEL',
    'RENNEVILLE',
    'VASCOEUIL',
  ],
  27770: ['ILLIERS L EVEQUE'],
  27540: ['IVRY LA BATAILLE'],
  27690: ['LERY'],
  27650: ['LOUYE', 'MESNIL SUR L ESTREE', 'MUZY'],
  27810: ['MARCILLY SUR EURE'],
  27850: ['MENESQUEVILLE'],
  27550: ['NASSANDRES SUR RISLE'],
  27830: ['NEAUFLES ST MARTIN'],
  27890: ['LA NEUVILLE DU BOSC'],
  27590: ['PITRES'],
  27360: ['PONT ST PIERRE'],
  27100: ['PORTE DE SEINE', 'LE VAUDREUIL', 'VAL DE REUIL'],
  27740: ['POSES'],
  27610: ['ROMILLY SUR ANDELLE'],
  27790: ['ROSAY SUR LIEURE'],
  27450: [
    'ST BENOIT DES OMBRES',
    'ST CHRISTOPHE SUR CONDE',
    'ST ETIENNE L ALLIER',
    'ST GEORGES DU VIEVRE',
    'ST GREGOIRE DU VIEVRE',
    'ST MARTIN ST FIRMIN',
    'ST PIERRE DES IFS',
  ],
  27920: ['ST ETIENNE SOUS BAILLEUL', 'ST PIERRE DE BAILLEUL'],
  27710: ['ST GEORGES MOTEL'],
  27200: ['VERNON'],
  27870: ['VESLY'],
  28410: [
    'ABONDANT',
    'BOUTIGNY PROUAIS',
    'BROUE',
    'BU',
    'GOUSSAINVILLE',
    'HAVELU',
    'MARCHEZAIS',
    'ST LUBIN DE LA HAYE',
    'SERVILLE',
  ],
  28500: [
    'ALLAINVILLE',
    'AUNAY SOUS CRECY',
    'BOISSY EN DROUAIS',
    'LA CHAPELLE FORAINVILLIERS',
    'CHARPONT',
    'CHERISY',
    'CRECY COUVE',
    'ECLUZELLES',
    'GARANCIERES EN DROUAIS',
    'GARNAY',
    'GERMAINVILLE',
    'LOUVILLIERS EN DROUAIS',
    'LURAY',
    'MARVILLE MOUTIERS BRULE',
    'MEZIERES EN DROUAIS',
    'MONTREUIL',
    'OUERRE',
    'STE GEMME MORONVAL',
    'SAULNIERES',
    'TREON',
    'VERNOUILLET',
    'VERT EN DROUAIS',
  ],
  28150: [
    'ALLONNES',
    'BEAUVILLIERS',
    'BOISVILLE LA ST PERE',
    'BONCE',
    'LOUVILLE LA CHENARD',
    'MOUTIERS',
    'OUARVILLE',
    'PRASVILLE',
    'RECLAINVILLE',
    'THEUVILLE',
    'EOLE EN BEAUCE',
    'VILLARS',
    'LES VILLAGES VOVEENS',
    'YMONVILLE',
  ],
  28800: [
    'ALLUYES',
    'BONNEVAL',
    'BOUVILLE',
    'BULLAINVILLE',
    'DANCY',
    'FLACEY',
    'LE GAULT ST DENIS',
    'MONTBOISSIER',
    'MONTHARVILLE',
    'MORIERS',
    'NEUVY EN DUNOIS',
    'PRE ST EVROULT',
    'PRE ST MARTIN',
    'ST MAUR SUR LE LOIR',
    'SANCHEVILLE',
    'SAUMERAY',
    'TRIZAY LES BONNEVAL',
    'VILLIERS ST ORIEN',
  ],
  28300: [
    'AMILLY',
    'BAILLEAU L EVEQUE',
    'BERCHERES ST GERMAIN',
    'BRICONVILLE',
    'CHALLET',
    'CHAMPHOL',
    'CINTRAY',
    'CLEVILLIERS',
    'COLTAINVILLE',
    'FRESNAY LE GILMERT',
    'GASVILLE OISEME',
    'JOUY',
    'LEVES',
    'MAINVILLIERS',
    'POISVILLIERS',
    'ST AUBIN DES BOIS',
    'ST PREST',
  ],
  28260: [
    'ANET',
    'BERCHERES SUR VESGRE',
    'BONCOURT',
    'LA CHAUSSEE D IVRY',
    'GILLES',
    'GUAINVILLE',
    'LE MESNIL SIMON',
    'OULINS',
    'ROUVRES',
    'ST OUEN MARCHEFROY',
    'SAUSSAY',
    'SOREL MOUSSEL',
  ],
  28170: [
    'ARDELLES',
    'LE BOULLAY LES DEUX EGLISES',
    'CHATEAUNEUF EN THYMERAIS',
    'FAVIERES',
    'FONTAINE LES RIBOUTS',
    'MAILLEBOIS',
    'PUISEUX',
    'ST ANGE ET TORCAY',
    'ST JEAN DE REBERVILLIERS',
    'ST MAIXME HAUTERIVE',
    'ST SAUVEUR MARVILLE',
    'SERAZEREUX',
    'THIMERT GATELLES',
    'TREMBLAY LES VILLAGES',
  ],
  28700: [
    'ARDELU',
    'AUNAY SOUS AUNEAU',
    'AUNEAU BLEURY ST SYMPHORIEN',
    'BEVILLE LE COMTE',
    'CHAMPSERU',
    'LA CHAPELLE D AUNAINVILLE',
    'CHATENAY',
    'DENONVILLE',
    'FRANCOURVILLE',
    'GARANCIERES EN BEAUCE',
    'GOMMERVILLE',
    'LE GUE DE LONGROI',
    'HOUVILLE LA BRANCHE',
    'LETHUIN',
    'LEVAINVILLE',
    'MAISONS',
    'MOINVILLE LA JEULIN',
    'MONDONVILLE ST JEAN',
    'MORAINVILLE',
    'OINVILLE SOUS AUNEAU',
    'OYSONVILLE',
    'ROINVILLE',
    'ST LEGER DES AUBEES',
    'SAINVILLE',
    'SANTEUIL',
    'UMPEAU',
    'VIERVILLE',
    'VOISE',
  ],
  28480: [
    'ARGENVILLIERS',
    'BEAUMONT LES AUTELS',
    'CHASSANT',
    'COMBRES',
    'LA CROIX DU PERCHE',
    'HAPPONVILLIERS',
    'LUIGNY',
    'MIERMAIGNE',
    'SAINTIGNY',
    'THIRON GARDAIS',
    'VICHERES',
  ],
  28290: ['VALD YERRE', 'CHAPELLE ROYALE'],
  28330: [
    'LES AUTELS VILLEVILLON',
    'AUTHON DU PERCHE',
    'LA BAZOCHE GOUET',
    'BETHONVILLIERS',
    'CHAPELLE GUILLAUME',
    'CHARBONNIERES',
    'COUDRAY AU PERCHE',
    'LES ETILLEUX',
    'ST BOMER',
  ],
  28140: [
    'BAIGNEAUX',
    'BAZOCHES EN DUNOIS',
    'BAZOCHES LES HAUTES',
    'CORMAINVILLE',
    'COURBEHAYE',
    'DAMBRON',
    'FONTENAY SUR CONIE',
    'GUILLONVILLE',
    'LOIGNY LA BATAILLE',
    'LUMEAU',
    'NOTTONVILLE',
    'ORGERES EN BEAUCE',
    'PERONVILLE',
    'POUPRY',
    'TERMINIERS',
    'TILLAY LE PENEUX',
    'VARIZE',
  ],
  28120: [
    'BAILLEAU LE PIN',
    'BLANDAINVILLE',
    'CERNAY',
    'CHARONVILLE',
    'LES CHATELLIERS NOTRE DAME',
    'CHAUFFOURS',
    'EPEAUTROLLES',
    'ERMENONVILLE LA GRANDE',
    'ERMENONVILLE LA PETITE',
    'ILLIERS COMBRAY',
    'MAGNY',
    'MARCHEVILLE',
    'MEREGLISE',
    'MESLAY LE GRENET',
    'MONTIGNY LE CHARTIF',
    'NOGENT SUR EURE',
    'NONVILLIERS GRANDHOUX',
    'OLLE',
    'ST AVIT LES GUESPIERES',
    'ST EMAN',
    'SANDARVILLE',
    'VIEUVICQ',
  ],
  28320: ['BAILLEAU ARMENONVILLE', 'ECROSNES', 'GALLARDON', 'GAS', 'YMERAY'],
  28630: [
    'BARJOUVILLE',
    'BERCHERES LES PIERRES',
    'CORANCEZ',
    'LE COUDRAY',
    'FONTENAY SUR EURE',
    'GELLAINVILLE',
    'MIGNIERES',
    'MORANCEZ',
    'NOGENT LE PHAYE',
    'SOURS',
    'THIVARS',
    'VER LES CHARTRES',
  ],
  28310: [
    'BARMAINVILLE',
    'BAUDREVILLE',
    'FRESNAY L EVEQUE',
    'GOMMERVILLE',
    'GOUILLONS',
    'GUILLEVILLE',
    'INTREVILLE',
    'JANVILLE EN BEAUCE',
    'LEVESVILLE LA CHENARD',
    'MEROUVILLE',
    'NEUVY EN BEAUCE',
    'OINVILLE ST LIPHARD',
    'POINVILLE',
    'ROUVRAY ST DENIS',
    'SANTILLY',
    'TOURY',
    'TRANCRAINVILLE',
  ],
  28270: [
    'BEAUCHE',
    'BEROU LA MULOTIERE',
    'BREZOLLES',
    'CHATAINCOURT',
    'LES CHATELETS',
    'CRUCEY VILLAGES',
    'ESCORPAIN',
    'FESSANVILLIERS MATTANVILLIERS',
    'LAONS',
    'LA MANCELIERE',
    'MONTIGNY SUR AVRE',
    'PRUDEMANCHE',
    'REVERCOURT',
    'RUEIL LA GADELIERE',
    'ST LUBIN DE CRAVANT',
  ],
  28240: [
    'BELHOMERT GUEHOUVILLE',
    'CHAMPROND EN GATINE',
    'LES CORVEES LES YYS',
    'FONTAINE SIMON',
    'FRIAIZE',
    'LA LOUPE',
    'MANOU',
    'MEAUCE',
    'MONTIREAU',
    'MONTLANDON',
    'ST DENIS DES PUITS',
    'ST ELIPH',
    'ST MAURICE ST GERMAIN',
    'ST VICTOR DE BUTHON',
    'LE THIEULIN',
    'VAUPILLON',
  ],
  28190: [
    'BILLANCELLES',
    'CHUISNES',
    'COURVILLE SUR EURE',
    'DANGERS',
    'LE FAVRIL',
    'FONTAINE LA GUYON',
    'FRUNCE',
    'LANDELLES',
    'MITTAINVILLIERS VERIGNY',
    'ORROUER',
    'PONTGOUIN',
    'ST ARNOULT DES BOIS',
    'ST GEORGES SUR EURE',
    'ST GERMAIN LE GAILLARD',
    'ST LUPERCE',
    'VILLEBON',
  ],
  28340: [
    'BOISSY LES PERCHE',
    'LA CHAPELLE FORTIN',
    'LA FERTE VIDAME',
    'LAMBLORE',
    'MORVILLIERS',
    'LES RESSUINTES',
    'ROHAIRE',
  ],
  28360: [
    'LA BOURDINIERE ST LOUP',
    'DAMMARIE',
    'FRESNAY LE COMTE',
    'LUPLANTE',
    'MESLAY LE VIDAME',
    'PRUNAY LE GILLON',
    'THEUVILLE',
    'VITRAY EN BEAUCE',
  ],
  28130: [
    'BOUGLAINVAL',
    'CHARTAINVILLIERS',
    'HANCHES',
    'HOUX',
    'MAINTENON',
    'MEVOISINS',
    'PIERRES',
    'ST MARTIN DE NIGELLES',
    'ST PIAT',
    'SOULAIRES',
    'VILLIERS LE MORHIER',
    'YERMENONVILLE',
  ],
  28210: [
    'LE BOULLAY MIVOYE',
    'LE BOULLAY THIERRY',
    'BRECHAMPS',
    'CHAUDON',
    'COULOMBS',
    'CROISILLES',
    'FAVEROLLES',
    'LORMAYE',
    'NERON',
    'NOGENT LE ROI',
    'ORMOY',
    'LES PINTHIERES',
    'ST LAURENT LA GATINE',
    'ST LUCIEN',
    'SENANTES',
    'VILLEMEUX SUR EURE',
  ],
  28160: [
    'BROU',
    'DAMPIERRE SOUS BROU',
    'DANGEAU',
    'FRAZE',
    'GOHORY',
    'MOTTEREAU',
    'MOULHARD',
    'UNVERRE',
    'YEVRES',
  ],
  28400: [
    'CHAMPROND EN PERCHET',
    'LA GAUDAINE',
    'ARCISSES',
    'MAROLLES LES BUIS',
    'NOGENT LE ROTROU',
    'ST JEAN PIERRE FIXTE',
    'SOUANCE AU PERCHE',
    'TRIZAY COUTRETOT ST SERGE',
  ],
  28200: [
    'LA CHAPELLE DU NOYER',
    'CHATEAUDUN',
    'CONIE MOLITARD',
    'DONNEMAIN ST MAMES',
    'JALLANS',
    'LOGRON',
    'MARBOUE',
    'MOLEANS',
    'ST CHRISTOPHE',
    'VILLEMAURY',
    'ST DENIS LANNERAY',
    'THIVILLE',
    'VILLAMPUY',
  ],
  28000: ['CHARTRES'],
  28220: ['CLOYES LES TROIS RIVIERES'],
  28350: ['DAMPIERRE SUR AVRE', 'ST LUBIN DES JONCHERETS'],
  28250: [
    'DIGNY',
    'LA FRAMBOISIERE',
    'JAUDRAIS',
    'LOUVILLIERS LES PERCHE',
    'LE MESNIL THOMAS',
    'LA PUISAYE',
    'LA SAUCELLE',
    'SENONCHES',
  ],
  28100: ['DREUX'],
  28230: ['DROUE SUR DROUETTE', 'EPERNON'],
  28110: ['LUCE'],
  28600: ['LUISANT'],
  28380: ['ST REMY SUR AVRE'],
  29560: ['ARGOL', 'LANDEVENNEC', 'TELGRUC SUR MER', 'TREGARVAN'],
  29300: ['ARZANO', 'BAYE', 'GUILLIGOMARC H', 'MELLAC', 'QUIMPERLE', 'REDENE', 'TREMEVEN'],
  29770: ['AUDIERNE', 'CLEDEN CAP SIZUN', 'GOULIEN', 'PLOGOFF', 'PRIMELIN'],
  29380: ['BANNALEC', 'ST THURIEN', 'LE TREVOUX'],
  29950: ['BENODET', 'CLOHARS FOUESNANT', 'GOUESNACH'],
  29690: ['BERRIEN', 'BOTMEUR', 'BRENNILIS', 'LA FEUILLEE', 'HUELGOAT', 'PLOUYE', 'POULLAOUEN'],
  29790: ['BEUZEC CAP SIZUN', 'MAHALON', 'CONFORT MEILARS', 'PONT CROIX'],
  29400: [
    'BODILIS',
    'GUIMILIAU',
    'LAMPAUL GUIMILIAU',
    'LANDIVISIAU',
    'LANNEUFFRET',
    'LOC EGUINER',
    'LOCMELAR',
    'PLOUGOURVEST',
    'PLOUNEVENTER',
    'ST SAUVEUR',
    'ST SERVAIS',
  ],
  29820: ['BOHARS', 'GUILERS'],
  29640: ['BOLAZEC', 'LANNEANOU', 'PLOUGONVEN', 'SCRIGNAC'],
  29650: ['BOTSORHEL', 'GUERLESQUIN', 'PLOUEGAT MOYSAN', 'PLOUIGNEAU'],
  29860: ['BOURG BLANC', 'LE DRENNEC', 'KERSAINT PLABENNEC', 'PLABENNEC', 'PLOUVIEN'],
  29190: [
    'BRASPARTS',
    'LE CLOITRE PLEYBEN',
    'GOUEZEC',
    'LANNEDERN',
    'LENNON',
    'LOTHEY',
    'PLEYBEN',
    'ST RIVOAL',
  ],
  29810: ['BRELES', 'LAMPAUL PLOUARZEL', 'PLOUARZEL', 'PLOUMOGUER'],
  29200: ['BREST'],
  29510: ['BRIEC', 'EDERN', 'LANDREVARZEC', 'LANDUDAL', 'LANGOLEN'],
  29890: ['PLOUNEOUR BRIGNOGAN PLAGES', 'GOULVEN', 'KERLOUAN'],
  29570: ['CAMARET SUR MER', 'ROSCANVEL'],
  29660: ['CARANTEC'],
  29270: ['CARHAIX PLOUGUER', 'CLEDEN POHER', 'KERGLOFF', 'MOTREFF', 'PLOUNEVEZEL', 'ST HERNIN'],
  29150: ['CAST', 'CHATEAULIN', 'DINEAULT', 'PORT LAUNAY', 'ST COULITZ'],
  29520: ['CHATEAUNEUF DU FAOU', 'LAZ', 'ST GOAZEC', 'ST THOIS'],
  29233: ['CLEDER'],
  29360: ['CLOHARS CARNOET'],
  29410: [
    'LE CLOITRE ST THEGONNEC',
    'GUICLAN',
    'PLEYBER CHRIST',
    'PLOUNEOUR MENEZ',
    'ST THEGONNEC LOC EGUINER',
  ],
  29870: ['COAT MEAL', 'LANDEDA', 'LANNILIS', 'TREGLONOU'],
  29530: ['COLLOREC', 'LANDELEAU', 'LOQUEFFRET', 'PLONEVEZ DU FAOU'],
  29120: ['COMBRIT', 'PLOMEUR', 'PONT L ABBE', 'ST JEAN TROLIMON', 'TREMEOC'],
  29450: ['COMMANA', 'SIZUN', 'LE TREHOU'],
  29900: ['CONCARNEAU'],
  29217: ['LE CONQUET', 'PLOUGONVELIN', 'TREBABU'],
  29370: ['CORAY', 'ELLIANT'],
  29160: ['CROZON', 'LANVEOC'],
  29460: [
    'DAOULAS',
    'DIRINON',
    'HANVEC',
    'HOPITAL CAMFROUT',
    'IRVILLAC',
    'LOGONNA DAOULAS',
    'ST ELOY',
  ],
  29100: ['DOUARNENEZ', 'LE JUCH', 'KERLAZ', 'POULDERGAT', 'POULLAN SUR MER'],
  29500: ['ERGUE GABERIC'],
  29590: ['LE FAOU', 'LOPEREC', 'ROSNOEN', 'ST SEGAL', 'PONT DE BUIS LES QUIMERCH'],
  29260: [
    'LE FOLGOET',
    'KERNILIS',
    'KERNOUES',
    'LANARVILY',
    'LESNEVEN',
    'LOC BREVALAIRE',
    'PLOUDANIEL',
    'PLOUIDER',
    'ST FREGANT',
    'ST MEEN',
    'TREGARANTEC',
  ],
  29800: [
    'LA FOREST LANDERNEAU',
    'LANDERNEAU',
    'LA MARTYRE',
    'PENCRAN',
    'PLOUDIRY',
    'PLOUEDERN',
    'LA ROCHE MAURICE',
    'ST DIVY',
    'ST THONAN',
    'ST URBAIN',
    'TREFLEVENEZ',
    'TREMAOUEZAN',
  ],
  29940: ['LA FORET FOUESNANT'],
  29170: ['FOUESNANT', 'PLEUVEN', 'ST EVARZEC'],
  29610: ['GARLAN', 'PLOUIGNEAU'],
  29850: ['GOUESNOU'],
  29710: [
    'GOURLIZON',
    'GUILER SUR GOYEN',
    'LANDUDEC',
    'PEUMERIT',
    'PLOGASTEL ST GERMAIN',
    'PLONEIS',
    'PLOZEVET',
    'POULDREUZIC',
  ],
  29180: ['GUENGAT', 'LOCRONAN', 'PLOGONNEC', 'QUEMENEVEN'],
  29730: ['GUILVINEC', 'TREFFIAGAT'],
  29620: ['GUIMAEC', 'LANMEUR', 'PLOUEGAT GUERAND'],
  29490: ['GUIPAVAS'],
  29290: ['MILIZAC GUIPRONVEL', 'LANRIVOARE', 'ST RENAN', 'TREOUERGAT'],
  29880: ['GUISSENY', 'PLOUGUERNEAU'],
  29670: ['HENVIC', 'LOCQUENOLE', 'TAULE'],
  29253: ['ILE DE BATZ'],
  29990: ['ILE DE SEIN'],
  29259: ['ILE MOLENE'],
  29980: ['ILE TUDY'],
  29830: ['LAMPAUL PLOUDALMEZEAU', 'PLOUDALMEZEAU', 'PLOUGUIN', 'PLOURIN', 'ST PABU'],
  29840: ['LANDUNVEZ', 'LANILDUT', 'PORSPODER'],
  29430: ['LANHOUARNEAU', 'PLOUESCAT', 'PLOUNEVEZ LOCHRIST', 'TREFLEZ'],
  29390: ['LEUHAN', 'SCAER'],
  29280: ['LOCMARIA PLOUZANE', 'PLOUZANE'],
  29241: ['LOCQUIREC'],
  29750: ['LOCTUDY'],
  29310: ['LOCUNOLE', 'QUERRIEN'],
  29470: ['LOPERHET', 'PLOUGASTEL DAOULAS'],
  29140: ['MELGVEN', 'ROSPORDEN', 'ST YVI', 'TOURCH'],
  29420: ['MESPAUL', 'PLOUENAN', 'PLOUVORN'],
  29350: ['MOELAN SUR MER'],
  29600: ['MORLAIX', 'PLOURIN LES MORLAIX', 'ST MARTIN DES CHAMPS', 'STE SEVE'],
  29920: ['NEVEZ'],
  29242: ['OUESSANT'],
  29760: ['PENMARCH'],
  29740: ['PLOBANNALEC LESCONIL'],
  29550: ['PLOEVEN', 'PLOMODIERN', 'PLONEVEZ PORZAY', 'ST NIC'],
  29700: ['PLOMELIN', 'PLUGUFFAN'],
  29720: ['PLONEOUR LANVERN', 'PLOVAN', 'TREGUENNEC', 'TREOGAT'],
  29252: ['PLOUEZOC H'],
  29440: ['PLOUGAR', 'PLOUZEVEDE', 'ST DERRIEN', 'ST VOUGAY', 'TREFLAOUENAN', 'TREZILIDE'],
  29630: ['PLOUGASNOU', 'ST JEAN DU DOIGT'],
  29250: ['PLOUGOULM', 'ST POL DE LEON', 'SANTEC', 'SIBIRIL'],
  29780: ['PLOUHINEC'],
  29930: ['PONT AVEN'],
  29246: ['POULLAOUEN'],
  29000: ['QUIMPER'],
  29480: ['LE RELECQ KERHUON'],
  29340: ['RIEC SUR BELON'],
  29680: ['ROSCOFF'],
  29540: ['SPEZET'],
  29970: ['TREGOUREZ'],
  29910: ['TREGUNC'],
  20167: [
    'AFA',
    'AJACCIO',
    'ALATA',
    'APPIETTO',
    'CUTTOLI CORTICCHIATO',
    'PERI',
    'SARROLA CARCOPINO',
    'TAVACO',
    'VALLE DI MEZZANA',
    'VILLANOVA',
  ],
  20000: ['AJACCIO'],
  20090: ['AJACCIO'],
  20128: ['ALBITRECCIA', 'GROSSETO PRUGNA', 'GUARGUALE', 'URBALACONE'],
  20166: ['ALBITRECCIA', 'COGNOCOLI MONTICCHI', 'GROSSETO PRUGNA', 'PIETROSELLA'],
  20112: ['ALTAGENE', 'MELA', 'OLMICCIA', 'STE LUCIE DE TALLANO', 'ZOZA'],
  20151: ['AMBIEGNA', 'ARRO', 'CANNELLE', 'SARI D ORCINO', 'SANT ANDREA D ORCINO'],
  20110: ['ARBELLARA', 'BELVEDERE CAMPOMORO', 'PROPRIANO', 'VIGGIANELLO'],
  20160: ['ARBORI', 'BALOGNA', 'COGGIA', 'GUAGNO', 'LETIA', 'MURZO', 'POGGIOLO', 'RENNO', 'VICO'],
  20140: [
    'ARGIUSTA MORICCIO',
    'CASALABRIVA',
    'MOCA CROCE',
    'OLIVESE',
    'PETRETO BICCHISANO',
    'SERRA DI FERRO',
    'SOLLACARO',
  ],
  20116: ['AULLENE', 'ZERUBIA'],
  20190: ['AZILONE AMPAZA', 'CARDO TORGIA', 'FORCIOLO', 'SANTA MARIA SICHE', 'ZIGLIARA'],
  20121: ['AZZANA', 'PASTRICCIOLA', 'REZZA', 'ROSAZIA', 'SALICE'],
  20119: ['BASTELICA'],
  20129: ['BASTELICACCIA'],
  20100: ['BILIA', 'FOCE', 'GIUNCHETO', 'GRANACE', 'GROSSA', 'SARTENE'],
  20136: ['BOCOGNANO'],
  20169: ['BONIFACIO'],
  20111: ['CALCATOGGIO', 'CASAGLIONE'],
  20142: ['CAMPO', 'QUASQUARA'],
  20170: ['CARBINI', 'LEVIE', 'SAN GAVINO DI CARBINI'],
  20133: ['CARBUCCIA', 'UCCIANI'],
  20130: ['CARGESE'],
  20164: ['CARGIACA'],
  20117: ['CAURO', 'ECCICA SUARELLA', 'OCANA', 'TOLLA'],
  20134: ['CIAMANNACCE', 'PALNECA', 'SAMPOLO', 'TASSO'],
  20118: ['COGGIA', 'VICO'],
  20123: ['COGNOCOLI MONTICCHI', 'PILA CANALE'],
  20135: ['CONCA'],
  20168: ['CORRANO'],
  20138: ['COTI CHIAVARI'],
  20148: ['COZZANO'],
  20126: ['CRISTINACCE', 'EVISA'],
  20114: ['FIGARI'],
  20143: ['FOZZANO', 'SANTA MARIA FIGANIELLA'],
  20157: ['FRASSETO'],
  20153: ['GUITERA LES BAINS'],
  20137: ['LECCI', 'PORTO VECCHIO', 'SAN GAVINO DI CARBINI'],
  20139: ['LOPIGNA'],
  20165: ['LORETO DI TALLANO'],
  20141: ['MARIGNANA'],
  20171: ['MONACIA D AULLENE'],
  20113: ['OLMETO'],
  20125: ['ORTO', 'POGGIOLO', 'SOCCIA'],
  20147: ['OSANI', 'PARTINELLO', 'SERRIERA'],
  20150: ['OTA'],
  20115: ['PIANA'],
  20131: ['PIANOTTOLI CALDARELLO'],
  20122: ['QUENZA'],
  20145: ['SARI SOLENZARA'],
  20127: ['SERRA DI SCOPAMENE'],
  20152: ['SORBOLLANO'],
  20146: ['SOTTA'],
  20163: ['TAVERA'],
  20172: ['VERO'],
  20173: ['ZEVACO'],
  20132: ['ZICAVO'],
  20124: ['ZONZA'],
  20144: ['ZONZA'],
  20270: [
    'AGHIONE',
    'ALERIA',
    'ANTISANTI',
    'CAMPI',
    'CASEVECCHIE',
    'MATRA',
    'MOITA',
    'PANCHERACCIA',
    'TALLONE',
    'TOX',
  ],
  20244: ['AITI', 'CAMBIA', 'CARTICASI', 'ERONE', 'LANO', 'RUSIO', 'SAN LORENZO'],
  20212: [
    'ALANDO',
    'ALZI',
    'BUSTANICO',
    'CASTELLARE DI MERCURIO',
    'ERBAJOLO',
    'FAVALELLO',
    'FOCICCHIA',
    'MAZZOLA',
    'SERMANO',
    'SANT ANDREA DI BOZIO',
  ],
  20224: ['ALBERTACCE', 'CALACUCCIA', 'CASAMACCIOLI', 'CORSCIA', 'LOZZI'],
  20220: [
    'ALGAJOLA',
    'AREGNO',
    'CORBARA',
    'L ILE ROUSSE',
    'MONTICELLO',
    'PIGNA',
    'SANT ANTONINO',
    'SANTA REPARATA DI BALAGNA',
  ],
  20251: ['ALTIANI', 'GIUNCAGGIO', 'PANCHERACCIA', 'PIEDICORTE DI GAGGIO', 'PIETRASERENA'],
  20272: ['AMPRIANI', 'PIANELLO', 'ZALANA', 'ZUANI'],
  20276: ['ASCO'],
  20225: ['AVAPESSA', 'CATERI', 'FELICETO', 'LAVATOGGIO', 'MURO', 'NESSA'],
  20253: ['BARBAGGIO', 'FARINOLE', 'PATRIMONIO'],
  20228: ['BARRETTALI', 'CAGNANO', 'LURI', 'PINO'],
  20200: ['BASTIA', 'SAN MARTINO DI LOTA', 'SANTA MARIA DI LOTA', 'VILLE DI PIETRABUGNO'],
  20600: ['BASTIA', 'FURIANI'],
  20226: ['BELGODERE', 'COSTA', 'NOVELLA', 'OCCHIATANA', 'PALASCA', 'SPELONCATO'],
  20252: ['BIGORNO', 'CAMPITELLO', 'LENTO'],
  20620: ['BIGUGLIA'],
  20235: ['BISINCHI', 'CANAVAGGIA', 'CASTELLO DI ROSTINO', 'VALLE DI ROSTINO'],
  20290: [
    'BORGO',
    'CAMPILE',
    'CROCICCHIA',
    'LUCCIANA',
    'MONTE',
    'OLMO',
    'ORTIPORIO',
    'PENTA ACQUATELLA',
    'PRUNELLI DI CASACCONI',
    'SCOLCA',
    'VIGNALE',
    'VOLPAJOLA',
  ],
  20222: ['BRANDO'],
  20214: ['CALENZANA', 'MONCALE', 'MONTEGROSSO', 'ZILIA'],
  20260: ['CALENZANA', 'CALVI', 'LUMIO'],
  20229: [
    'CAMPANA',
    'CARCHETO BRUSTICO',
    'CARPINETO',
    'MONACIA D OREZZA',
    'NOCARIO',
    'PARATA',
    'PIAZZOLE',
    'PIEDICROCE',
    'PIEDIPARTINO',
    'PIE D OREZZA',
    'POLVEROSO',
    'RAPAGGIO',
    'STAZZONA',
    'VALLE D OREZZA',
    'VERDESE',
  ],
  20230: [
    'CANALE DI VERDE',
    'CHIATRA',
    'LINGUIZZETTA',
    'PERO CASEVECCHIE',
    'PIETRA DI VERDE',
    'POGGIO MEZZANA',
    'SAN GIOVANNI DI MORIANI',
    'SAN GIULIANO',
    'SANTA LUCIA DI MORIANI',
    'SAN NICOLAO',
    'SANTA REPARATA DI MORIANI',
    'TAGLIO ISOLACCIO',
    'TALASANI',
    'VELONE ORNETO',
  ],
  20217: [
    'CANARI',
    'NONZA',
    'OGLIASTRO',
    'OLCANI',
    'OLMETA DI CAPOCORSO',
    'ST FLORENT',
    'SANTO PIETRO DI TENDA',
  ],
  20237: [
    'CASABIANCA',
    'CROCE',
    'FICAJA',
    'GIOCATOJO',
    'POGGIO MARINACCIO',
    'LA PORTA',
    'QUERCITELLO',
  ],
  20215: [
    'CASALTA',
    'LORETO DI CASINCA',
    'PIANO',
    'PORRI',
    'SILVARECCIO',
    'VENZOLASCA',
    'VESCOVATO',
  ],
  20250: [
    'CASANOVA',
    'CORTE',
    'POGGIO DI VENACO',
    'RIVENTOSA',
    'SOVERIA',
    'SANTA LUCIA DI MERCURIO',
    'SANTO PIETRO DI VENACO',
    'TRALONCA',
  ],
  20213: [
    'CASTELLARE DI CASINCA',
    'PENTA DI CASINCA',
    'PRUNO',
    'SCATA',
    'SORBO OCAGNANO',
    'SAN DAMIANO',
    'SAN GAVINO D AMPUGNANI',
  ],
  20218: [
    'CASTIFAO',
    'CASTIGLIONE',
    'CASTINETA',
    'GAVIGNANO',
    'LAMA',
    'MOLTIFAO',
    'MOROSAGLIA',
    'PIEDIGRIGGIO',
    'PIETRALBA',
    'POPOLASCA',
    'PRATO DI GIOVELLINA',
    'SALICETO',
    'URTACA',
  ],
  20236: ['CASTIRLA', 'OMESSA'],
  20238: ['CENTURI', 'MORSIGLIA'],
  20221: ['CERVIONE', 'SANT ANDREA DI COTONE', 'SANTA MARIA POGGIO', 'VALLE DI CAMPOLORO'],
  20256: ['CORBARA'],
  20275: ['ERSA'],
  20234: [
    'FELCE',
    'NOVALE',
    'ORTALE',
    'PERELLI',
    'PIAZZALI',
    'PIETRICAGGIO',
    'PIOBETTA',
    'TARRANO',
    'VALLE D ALESANI',
  ],
  20245: ['GALERIA', 'MANSO'],
  20240: ['GHISONACCIA', 'LUGO DI NAZZA', 'POGGIO DI NAZZA', 'SOLARO', 'VENTISERI', 'CHISA'],
  20227: ['GHISONI'],
  20243: [
    'ISOLACCIO DI FIUMORBO',
    'PRUNELLI DI FIUMORBO',
    'SERRA DI FIUMORBO',
    'SAN GAVINO DI FIUMORBO',
  ],
  20259: ['MAUSOLEO', 'OLMI CAPPELLA', 'PIOGGIOLA', 'VALLICA'],
  20287: ['MERIA'],
  20219: ['MURACCIOLE', 'VIVARIO'],
  20239: ['MURATO', 'RUTALI'],
  20242: ['NOCETA', 'PIETROSO', 'ROSPIGLIANI', 'VEZZANI'],
  20232: ['OLETTA', 'OLMETA DI TUDA', 'POGGIO D OLETTA', 'VALLECALLE'],
  20233: ['PIETRACORBARA', 'SISCO'],
  20246: ['PIEVE', 'RAPALE', 'SORIO', 'SAN GAVINO DI TENDA', 'SANTO PIETRO DI TENDA'],
  20247: ['ROGLIANO'],
  20248: ['ROGLIANO', 'TOMINO'],
  20231: ['VENACO'],
  20279: ['VILLE DI PARASO'],
  30700: [
    'AIGALIERS',
    'ARPAILLARGUES ET AUREILLAC',
    'BARON',
    'BLAUZAC',
    'LA CAPELLE ET MASMOLENE',
    'FLAUX',
    'FOISSAC',
    'MONTAREN ET ST MEDIERS',
    'ST HIPPOLYTE DE MONTAIGU',
    'ST MAXIMIN',
    'ST QUENTIN LA POTERIE',
    'ST SIFFRET',
    'ST VICTOR DES OULES',
    'SANILHAC SAGRIES',
    'SERVIERS ET LABAUME',
    'UZES',
    'VALLABRIX',
  ],
  30350: [
    'AIGREMONT',
    'CANAULES ET ARGENTIERES',
    'CARDET',
    'CASSAGNOLES',
    'DOMESSARGUES',
    'LEDIGNAN',
    'LEZAN',
    'MARUEJOLS LES GARDON',
    'MASSANES',
    'MAURESSARGUES',
    'MOULEZAN',
    'ST BENEZET',
    'ST JEAN DE SERRES',
    'SAVIGNARGUES',
    'MONTAGNAC',
  ],
  30220: ['AIGUES MORTES', 'ST LAURENT D AIGOUZE'],
  30670: ['AIGUES VIVES'],
  30760: [
    'AIGUEZE',
    'LE GARN',
    'ISSIRAC',
    'LAVAL ST ROMAN',
    'ST CHRISTOL DE RODIERES',
    'ST JULIEN DE PEYROLAS',
    'SALAZAC',
  ],
  30470: ['AIMARGUES'],
  30100: ['ALES'],
  30500: [
    'ALLEGRE LES FUMADES',
    'COURRY',
    'POTELIERES',
    'ST AMBROIX',
    'ST BRES',
    'ST DENIS',
    'ST JULIEN DE CASSAGNAS',
    'ST VICTOR DE MALCAP',
  ],
  30770: ['ALZON', 'ARRIGAS', 'AUMESSAS', 'BLANDAS', 'CAMPESTRE ET LUC', 'VISSEC'],
  30140: [
    'ANDUZE',
    'BAGARD',
    'BOISSET ET GAUJAC',
    'CORBES',
    'GENERARGUES',
    'MASSILLARGUES ATTUECH',
    'MIALET',
    'ST FELIX DE PALLIERES',
    'ST JEAN DU PIN',
    'ST SEBASTIEN D AIGREFEUILLE',
    'THOIRAS',
    'TORNAC',
  ],
  30133: ['LES ANGLES'],
  30390: ['ARAMON', 'DOMAZAN', 'ESTEZARGUES', 'THEZIERS'],
  30210: [
    'ARGILLIERS',
    'CABRIERES',
    'CASTILLON DU GARD',
    'COLLIAS',
    'FOURNES',
    'LEDENON',
    'POUZILHAC',
    'REMOULINS',
    'ST BONNET DU GARD',
    'ST HILAIRE D OZILHAN',
    'SERNHAC',
    'VALLIGUIERES',
    'VERS PONT DU GARD',
  ],
  30120: [
    'ARPHY',
    'ARRE',
    'AULAS',
    'AVEZE',
    'BEZ ET ESPARON',
    'BREAU MARS',
    'MANDAGOUT',
    'MOLIERES CAVAILLAC',
    'MONTDARDIER',
    'POMMIERS',
    'ROGUES',
    'LE VIGAN',
  ],
  30250: [
    'ASPERES',
    'AUBAIS',
    'AUJARGUES',
    'COMBAS',
    'FONTANES',
    'JUNAS',
    'LECQUES',
    'SALINELLES',
    'SOMMIERES',
    'SOUVIGNARGUES',
    'VILLEVIEILLE',
  ],
  30620: ['AUBORD', 'BERNIS', 'UCHAUD'],
  30190: [
    'AUBUSSARGUES',
    'BOUCOIRAN ET NOZIERES',
    'BOURDIC',
    'BRIGNON',
    'LA CALMETTE',
    'CASTELNAU VALENCE',
    'COLLORGUES',
    'DIONS',
    'GARRIGUES STE EULALIE',
    'MONTIGNARGUES',
    'MOUSSAC',
    'LA ROUVIERE',
    'STE ANASTASIE',
    'ST CHAPTES',
    'ST DEZERY',
    'ST GENIES DE MALGOIRES',
    'SAUZET',
  ],
  30450: [
    'AUJAC',
    'BONNEVAUX',
    'CHAMBON',
    'CONCOULES',
    'GENOLHAC',
    'MALONS ET ELZE',
    'PONTEILS ET BRESIS',
    'SENECHAS',
  ],
  30200: [
    'BAGNOLS SUR CEZE',
    'CHUSCLAN',
    'CODOLET',
    'ORSAN',
    'LA ROQUE SUR CEZE',
    'SABRAN',
    'ST ETIENNE DES SORTS',
    'ST GERVAIS',
    'ST LAURENT DE CARNOLS',
    'ST MICHEL D EUZET',
    'ST NAZAIRE',
    'VENEJAN',
  ],
  30430: [
    'BARJAC',
    'MEJANNES LE CLAP',
    'RIVIERES',
    'ROCHEGUDE',
    'ST JEAN DE MARUEJOLS ET AVEJAN',
    'ST PRIVAT DE CHAMPCLOS',
    'THARAUX',
  ],
  30330: [
    'LA BASTIDE D ENGRAS',
    'CAVILLARGUES',
    'CONNAUX',
    'GAUJAC',
    'LE PIN',
    'POUGNADORESSE',
    'ST ANDRE D OLERARGUES',
    'ST LAURENT LA VERNEDE',
    'ST MARCEL DE CAREIRET',
    'ST PONS LA CALM',
    'TRESQUES',
    'ST PAUL LES FONTS',
  ],
  30300: ['BEAUCAIRE', 'COMPS', 'FOURQUES', 'JONQUIERES ST VINCENT', 'VALLABREGUES'],
  30640: ['BEAUVOISIN'],
  30127: ['BELLEGARDE'],
  30580: [
    'BELVEZET',
    'BOUQUET',
    'BROUZET LES ALES',
    'LA BRUGUIERE',
    'FONS SUR LUSSAN',
    'FONTARECHES',
    'LUSSAN',
    'NAVACELLES',
    'ST JUST ET VACQUIERES',
    'SEYNES',
    'VALLERARGUES',
  ],
  30160: ['BESSEGES', 'BORDEZAC', 'GAGNIERES', 'PEYREMALE', 'ROBIAC ROCHESSADOULE'],
  30320: ['BEZOUCE', 'MARGUERITTES', 'POULX', 'ST GERVASY'],
  30114: ['BOISSIERES', 'NAGES ET SOLORGUES'],
  30230: ['BOUILLARGUES', 'RODILHAN'],
  30260: [
    'BRAGASSARGUES',
    'BROUZET LES QUISSAC',
    'CANNES ET CLAIRAN',
    'CARNAS',
    'CORCONNE',
    'CRESPIAN',
    'GAILHAN',
    'LIOUC',
    'MONTMIRAT',
    'ORTHOUX SERIGNAC QUILHAN',
    'QUISSAC',
    'ST CLEMENT',
    'ST THEODORIT',
    'SARDAN',
    'VIC LE FESQ',
  ],
  30110: [
    'BRANOUX LES TAILLADES',
    'LA GRAND COMBE',
    'LAMELOUZE',
    'LAVAL PRADEL',
    'STE CECILE D ANDORGE',
    'LES SALLES DU GARDON',
    'SOUSTELLE',
  ],
  30170: [
    'LA CADIERE ET CAMBO',
    'CONQUEYRAC',
    'CROS',
    'DURFORT ET ST MARTIN DE SOSSENAC',
    'FRESSAC',
    'MONOBLET',
    'POMPIGNAN',
    'ST HIPPOLYTE DU FORT',
  ],
  30740: ['LE CAILAR'],
  30132: ['CAISSARGUES'],
  30420: ['CALVISSON'],
  30130: ['CARSAN', 'PONT ST ESPRIT', 'ST ALEXANDRE', 'ST PAULET DE CAISSON'],
  30750: ['CAUSSE BEGON', 'DOURBIES', 'LANUEJOLS', 'REVENS', 'ST SAUVEUR CAMPRIEU', 'TREVES'],
  30820: ['CAVEIRAC'],
  30480: ['CENDRAS', 'ST PAUL LA COSTE'],
  30530: ['CHAMBORIGAUD', 'PORTES', 'LA VERNAREDE'],
  30870: ['CLARENSAC', 'ST COME ET MARUEJOLS'],
  30920: ['CODOGNAN'],
  30460: [
    'COLOGNAC',
    'LASALLE',
    'ST BONNET DE SALENDRINQUE',
    'STE CROIX DE CADERLE',
    'SOUDORGUES',
    'VABRES',
  ],
  30111: ['CONGENIES'],
  30630: ['CORNILLON', 'GOUDARGUES', 'MONTCLUS', 'ST ANDRE DE ROQUEPERTUIS', 'VERFEUIL'],
  30360: [
    'CRUVIERS LASCOURS',
    'DEAUX',
    'EUZET',
    'MARTIGNARGUES',
    'MONTEILS',
    'NERS',
    'ST CESAIRE DE GAUZIGNAN',
    'ST ETIENNE DE L OLM',
    'ST HIPPOLYTE DE CATON',
    'ST JEAN DE CEYRARGUES',
    'ST MAURICE DE CAZEVIEILLE',
    'VEZENOBRES',
  ],
  30124: ['L ESTRECHURE', 'PEYROLLES'],
  30730: ['FONS', 'GAJAN', 'MONTPEZAT', 'PARIGNARGUES', 'ST BAUZELY', 'ST MAMERT DU GARD'],
  30660: ['GALLARGUES LE MONTUEUX'],
  30128: ['GARONS'],
  30510: ['GENERAC'],
  30240: ['LE GRAU DU ROI'],
  30980: ['LANGLADE', 'ST DIONISY'],
  30290: ['LAUDUN L ARDOISE', 'ST VICTOR LA COSTE'],
  30126: ['LIRAC', 'ST LAURENT DES ARBRES', 'TAVEL'],
  30610: [
    'LOGRIAN FLORIAN',
    'PUECHREDON',
    'ST JEAN DE CRIEULON',
    'ST NAZAIRE DES GARDIES',
    'SAUVE',
  ],
  30960: ['LES MAGES', 'LE MARTINET', 'ST FLORENT SUR AUZONNET', 'ST JEAN DE VALERISCLE'],
  30129: ['MANDUEL', 'REDESSAN'],
  30340: [
    'MEJANNES LES ALES',
    'MONS',
    'LES PLANS',
    'ROUSSON',
    'ST JULIEN LES ROSIERS',
    'ST PRIVAT DES VIEUX',
    'SALINDRES',
    'SERVAS',
  ],
  30840: ['MEYNES'],
  30410: ['MEYRANNES', 'MOLIERES SUR CEZE'],
  30540: ['MILHAUD'],
  30150: ['MONTFAUCON', 'ROQUEMAURE', 'ST GENIES DE COMOLAS', 'SAUVETERRE'],
  30490: ['MONTFRIN'],
  30121: ['MUS'],
  30000: ['NIMES'],
  30900: ['NIMES'],
  30122: ['LES PLANTIERS'],
  30131: ['PUJAUT'],
  30720: ['RIBAUTE LES TAVERNES'],
  30650: ['ROCHEFORT DU GARD', 'SAZE'],
  30440: [
    'ROQUEDUR',
    'ST BRESSON',
    'ST JULIEN DE LA NEF',
    'ST LAURENT LE MINIER',
    'ST MARTIAL',
    'ST ROMAN DE CODIERES',
    'SUMENE',
  ],
  30570: ['ST ANDRE DE MAJENCOULES', 'VAL D AIGOUAL'],
  30940: ['ST ANDRE DE VALBORGNE'],
  30380: ['ST CHRISTOL LEZ ALES'],
  30800: ['ST GILLES'],
  30560: ['ST HILAIRE DE BRETHMAS'],
  30270: ['ST JEAN DU GARD'],
  30520: ['ST MARTIN DE VALGALGUES'],
  30125: ['SAUMANE'],
  30600: ['VAUVERT', 'VESTRIC ET CANDIAC'],
  30310: ['VERGEZE'],
  30400: ['VILLENEUVE LES AVIGNON'],
  31230: [
    'AGASSAC',
    'AMBAX',
    'ANAN',
    'BOISSEDE',
    'CASTELGAILLARD',
    'COUEILLES',
    'FABAS',
    'FRONTIGNAN SAVES',
    'GOUDEX',
    'L ISLE EN DODON',
    'LABASTIDE PAUMES',
    'LILHAC',
    'MARTISSERRE',
    'MAUVEZIN',
    'MIRAMBEAU',
    'MOLAS',
    'MONTBERNARD',
    'MONTESQUIEU GUITTAUT',
    'PUYMAURIN',
    'RIOLAS',
    'ST FRAJOU',
    'ST LAURENT',
    'SALERM',
    'CAZAC',
  ],
  31550: ['AIGNES', 'CINTEGABELLE', 'GAILLAC TOULZA', 'MARLIAC'],
  31280: ['AIGREFEUILLE', 'DREMIL LAFAGE', 'MONS'],
  31450: [
    'AYGUESVIVES',
    'BAZIEGE',
    'BELBERAUD',
    'BELBEZE DE LAURAGAIS',
    'CORRONSAC',
    'DEYME',
    'DONNEVILLE',
    'ESPANES',
    'FOURQUEVAUX',
    'ISSUS',
    'LABASTIDE BEAUVOIR',
    'MONTBRUN LAURAGAIS',
    'MONTESQUIEU LAURAGAIS',
    'MONTGISCARD',
    'MONTLAUR',
    'NOUEILLES',
    'ODARS',
    'POMPERTUZAT',
    'POUZE',
    'VARENNES',
  ],
  31420: [
    'ALAN',
    'AULON',
    'AURIGNAC',
    'BACHAS',
    'BENQUE',
    'BOUSSAN',
    'BOUZIN',
    'CASSAGNABERE TOURNAS',
    'CAZENEUVE MONTAUT',
    'EOUX',
    'ESPARRON',
    'FRANCON',
    'MONTOULIEU ST BERNARD',
    'PEYRISSAS',
    'PEYROUZET',
    'ST ANDRE',
    'ST ELIX SEGLAN',
    'SAMOUILLAN',
    'TERREBASSE',
  ],
  31460: [
    'ALBIAC',
    'AURIAC SUR VENDINELLE',
    'BEAUVILLE',
    'LE CABANIAL',
    'CAMBIAC',
    'CARAGOUDES',
    'CARAMAN',
    'LE FAGET',
    'FRANCARVILLE',
    'LOUBENS LAURAGAIS',
    'MASCARVILLE',
    'MAUREVILLE',
    'MOURVILLES BASSES',
    'PRUNET',
    'LA SALVETAT LAURAGAIS',
    'SAUSSENS',
    'SEGREVILLE',
    'TOUTENS',
    'VENDINE',
  ],
  31510: [
    'ANTICHAN DE FRONTIGNES',
    'BAGIRY',
    'BARBAZAN',
    'CIER DE RIVIERE',
    'FRONTIGNAN DE COMMINGES',
    'GALIE',
    'GENOS',
    'LABROQUERE',
    'LOURDE',
    'LUSCAN',
    'MALVEZIE',
    'MONT DE GALIE',
    'ORE',
    'PAYSSOUS',
    'ST BERTRAND DE COMMINGES',
    'ST PE D ARDET',
    'SAUVETERRE DE COMMINGES',
    'SEILHAN',
    'VALCABRERE',
  ],
  31110: [
    'ANTIGNAC',
    'ARTIGUE',
    'BAGNERES DE LUCHON',
    'BENQUE DESSOUS ET DESSUS',
    'BILLIERE',
    'BOURG D OUEIL',
    'CASTILLON DE LARBOUST',
    'CATHERVIELLE',
    'CAUBOUS',
    'CAZARILH LASPENES',
    'CAZEAUX DE LARBOUST',
    'CIER DE LUCHON',
    'CIRES',
    'GARIN',
    'GOUAUX DE LARBOUST',
    'GOUAUX DE LUCHON',
    'JURVIELLE',
    'JUZET DE LUCHON',
    'MAYREGNE',
    'MONTAUBAN DE LUCHON',
    'MOUSTAJON',
    'OO',
    'PORTET DE LUCHON',
    'POUBEAU',
    'SACCOURVIELLE',
    'ST AVENTIN',
    'ST MAMET',
    'ST PAUL D OUEIL',
    'SALLES ET PRATVIEL',
    'SODE',
    'TREBONS DE LUCHON',
  ],
  31160: [
    'ARBAS',
    'ARBON',
    'ARGUENOS',
    'ASPET',
    'BOUTX',
    'CABANAC CAZAUX',
    'CASTELBIAGUE',
    'CAZAUNOUS',
    'CHEIN DESSUS',
    'COURET',
    'ENCAUSSE LES THERMES',
    'ESTADENS',
    'FOUGARON',
    'GANTIES',
    'HERRAN',
    'IZAUT DE L HOTEL',
    'JUZET D IZAUT',
    'LESPITEAU',
    'MILHAS',
    'MONCAUP',
    'MONTASTRUC DE SALIES',
    'PORTET D ASPET',
    'RAZECUEILLE',
    'ROUEDE',
    'SENGOUAGNET',
    'SOUEICH',
  ],
  31210: [
    'ARDIEGE',
    'AUSSON',
    'BORDES DE RIVIERE',
    'CLARAC',
    'CUGURON',
    'LE CUING',
    'FRANQUEVIELLE',
    'GOURDAN POLIGNAN',
    'HUOS',
    'MARTRES DE RIVIERE',
    'MONTREJEAU',
    'POINTIS DE RIVIERE',
    'PONLAT TAILLEBOURG',
    'LES TOURREILLES',
  ],
  31440: [
    'ARGUT DESSOUS',
    'ARLOS',
    'BACHOS',
    'BAREN',
    'BEZINS GARRAUX',
    'BOUTX',
    'BURGALAYS',
    'CAZAUX LAYRISSE',
    'CHAUM',
    'CIERP GAUD',
    'ESTENOS',
    'EUP',
    'FOS',
    'FRONSAC',
    'GURAN',
    'LEGE',
    'MARIGNAC',
    'MELLES',
    'ST BEAT LEZ',
    'SIGNAC',
    'BINOS',
  ],
  31360: [
    'ARNAUD GUILHEM',
    'AUZAS',
    'BEAUCHALOT',
    'BOUSSENS',
    'CASTILLON DE ST MARTORY',
    'LE FRECHET',
    'LAFFITE TOUPIERE',
    'LESTELLE DE ST MARTORY',
    'MANCIOUX',
    'PROUPIARY',
    'ROQUEFORT SUR GARONNE',
    'ST MARTORY',
    'ST MEDARD',
    'SEPX',
  ],
  31800: [
    'ASPRET SARRAT',
    'ESTANCARBON',
    'LABARTHE INARD',
    'LABARTHE RIVIERE',
    'LALOURET LAFFITEAU',
    'LANDORTHE',
    'LARCAN',
    'LATOUE',
    'LIEOUX',
    'LODES',
    'MIRAMONT DE COMMINGES',
    'POINTIS INARD',
    'REGADES',
    'RIEUCAZE',
    'ST GAUDENS',
    'ST IGNAN',
    'ST MARCET',
    'SAUX ET POMAREDE',
    'SAVARTHES',
    'VALENTINE',
    'VILLENEUVE DE RIVIERE',
  ],
  31140: [
    'AUCAMVILLE',
    'FONBEAUZARD',
    'LAUNAGUET',
    'MONTBERON',
    'PECHBONNIEU',
    'ST ALBAN',
    'ST LOUP CAMMAS',
  ],
  31190: [
    'AURAGNE',
    'AURIBAIL',
    'AUTERIVE',
    'CAUJAC',
    'ESPERCE',
    'GRAZAC',
    'GREPIAC',
    'LABRUYERE DORSA',
    'LAGRACE DIEU',
    'MAURESSAC',
    'MAUVAISIN',
    'MIREMONT',
    'PUYDANIEL',
  ],
  31320: [
    'AUREVILLE',
    'AUZEVILLE TOLOSANE',
    'CASTANET TOLOSAN',
    'MERVILLA',
    'PECHABOU',
    'PECHBUSQUE',
    'REBIGUE',
    'VIEILLE TOULOUSE',
    'VIGOULET AUZIL',
  ],
  31570: [
    'AURIN',
    'BOURG ST BERNARD',
    'LANTA',
    'PRESERVILLE',
    'STE FOY D AIGREFEUILLE',
    'ST PIERRE DE LAGES',
    'TARABEL',
    'VALLESVILLES',
  ],
  31260: [
    'AUSSEING',
    'BELBEZE EN COMMINGES',
    'CASSAGNE',
    'CASTAGNEDE',
    'FIGAROL',
    'FRANCAZAL',
    'HIS',
    'MANE',
    'MARSOULAS',
    'MAZERES SUR SALAT',
    'MONTESPAN',
    'MONTGAILLARD DE SALIES',
    'MONTSAUNES',
    'SALEICH',
    'SALIES DU SALAT',
    'TOUILLE',
    'URAU',
    'ESCOULIS',
  ],
  31840: ['AUSSONNE', 'SEILH'],
  31650: ['AUZIELLE', 'LAUZERVILLE', 'ST ORENS DE GAMEVILLE'],
  31290: [
    'AVIGNONET LAURAGAIS',
    'BEAUTEVILLE',
    'CESSALES',
    'FOLCARDE',
    'GARDOUCH',
    'LAGARDE',
    'LUX',
    'MAUREMONT',
    'MONTCLAR LAURAGAIS',
    'MONTGAILLARD LAURAGAIS',
    'RENNEVILLE',
    'RIEUMAJOU',
    'ST GERMIER',
    'ST ROME',
    'ST VINCENT',
    'TREBONS SUR LA GRASSE',
    'VALLEGUE',
    'VIEILLEVIGNE',
    'VILLEFRANCHE DE LAURAGAIS',
    'VILLENOUVELLE',
  ],
  31380: [
    'AZAS',
    'BAZUS',
    'GARIDECH',
    'GEMIL',
    'GRAGNAGUE',
    'MONTASTRUC LA CONSEILLERE',
    'MONTJOIRE',
    'MONTPITOL',
    'PAULHAC',
    'ROQUESERIERE',
    'ST JEAN LHERM',
    'VILLARIES',
  ],
  31580: [
    'BALESTA',
    'BOUDRAC',
    'CAZARIL TAMBOURES',
    'LARROQUE',
    'LECUSSAN',
    'LOUDET',
    'ST PLANCARD',
    'SEDEILHAC',
    'VILLENEUVE LECUSSAN',
  ],
  31130: ['BALMA', 'FLOURENS', 'PIN BALMA', 'QUINT FONSEGRIVES'],
  31310: [
    'BAX',
    'CANENS',
    'CASTAGNAC',
    'GENSAC SUR GARONNE',
    'GOUTEVERNISSE',
    'GOUZENS',
    'LAHITERE',
    'LAPEYRERE',
    'LATOUR',
    'LATRAPE',
    'MAILHOLAS',
    'MASSABRAC',
    'MONTBRUN BOCAGE',
    'MONTESQUIEU VOLVESTRE',
    'RIEUX VOLVESTRE',
    'ST CHRISTAUD',
  ],
  31370: [
    'BEAUFORT',
    'BERAT',
    'FORGUES',
    'LABASTIDE CLERMONT',
    'LAHAGE',
    'LAUTIGNAC',
    'MONES',
    'MONTASTRUC SAVES',
    'MONTGRAS',
    'LE PIN MURELET',
    'PLAGNOLE',
    'POUCHARRAMET',
    'RIEUMES',
    'SABONNERES',
    'SAJAS',
    'SAVERES',
  ],
  31870: ['BEAUMONT SUR LEZE', 'LAGARDELLE SUR LEZE'],
  31850: ['BEAUPUY', 'MONDOUZIL', 'MONTRABE'],
  31700: ['BEAUZELLE', 'BLAGNAC', 'CORNEBARRIEU', 'DAUX', 'MONDONVILLE'],
  31540: [
    'BELESTA EN LAURAGAIS',
    'FALGA',
    'JUZES',
    'MAURENS',
    'MONTEGUT LAURAGAIS',
    'MOURVILLES HAUTES',
    'NOGARET',
    'ROUMENS',
    'ST FELIX LAURAGAIS',
    'ST JULIA',
    'VAUX',
  ],
  31530: [
    'BELLEGARDE STE MARIE',
    'BRETX',
    'LE CASTERA',
    'LASSERRE PRADERE',
    'LEVIGNAC',
    'MENVILLE',
    'MERENVIELLE',
    'MONTAIGUT SUR SAVE',
    'STE LIVRADE',
    'ST PAUL SUR SAVE',
    'THIL',
  ],
  31480: [
    'BELLESSERRE',
    'BRIGNEMONT',
    'CABANAC SEGUENVILLE',
    'CADOURS',
    'CAUBIAC',
    'COX',
    'DRUDAS',
    'GARAC',
    'LE GRES',
    'LAGRAULET ST NICOLAS',
    'LAREOLE',
    'PELLEPORT',
    'PUYSSEGUR',
    'VIGNAUX',
  ],
  31660: ['BESSIERES', 'BUZET SUR TARN'],
  31350: [
    'BLAJAN',
    'BOULOGNE SUR GESSE',
    'CARDEILHAC',
    'CASTERA VIGNOLES',
    'CHARLAS',
    'CIADOUX',
    'ESCANECRABE',
    'GENSAC DE BOULOGNE',
    'LESPUGUE',
    'MONDILHAN',
    'MONTGAILLARD SUR SAVE',
    'MONTMAURIN',
    'NENIGAN',
    'NIZAN GESSE',
    'PEGUILHAN',
    'ST FERREOL DE COMMINGES',
    'ST LARY BOUJEAN',
    'ST LOUP EN COMMINGES',
    'ST PE DELBOSC',
    'SAMAN',
    'SARRECAVE',
    'SARREMEZAN',
  ],
  31390: [
    'BOIS DE LA PIERRE',
    'CARBONNE',
    'LACAUGNE',
    'LAFITTE VIGORDANE',
    'MARQUEFAVE',
    'PEYSSIES',
    'SALLES SUR GARONNE',
  ],
  31340: [
    'BONDIGOUX',
    'LE BORN',
    'LAYRAC SUR TARN',
    'LA MAGDELAINE SUR TARN',
    'MIREPOIX SUR TARN',
    'VACQUIERS',
    'VILLEMATIER',
    'VILLEMUR SUR TARN',
  ],
  31590: ['BONREPOS RIQUET', 'GAURE', 'LAVALETTE', 'ST MARCEL PAULEL', 'ST PIERRE', 'VERFEIL'],
  31470: [
    'BONREPOS SUR AUSSONNELLE',
    'BRAGAYRAC',
    'CAMBERNARD',
    'EMPEAUX',
    'FONSORBES',
    'FONTENILLES',
    'SAIGUEDE',
    'STE FOY DE PEYROLIERES',
    'ST LYS',
    'ST THOMAS',
  ],
  31620: [
    'BOULOC',
    'CASTELNAU D ESTRETEFONDS',
    'CEPET',
    'FRONTON',
    'GARGAS',
    'LABASTIDE ST SERNIN',
    'ST RUSTICE',
    'VILLAUDRIC',
    'VILLENEUVE LES BOULOC',
  ],
  31490: ['BRAX', 'LEGUEVIN'],
  31150: ['BRUGUIERES', 'FENOUILLET', 'GAGNAC SUR GARONNE', 'GRATENTOUR', 'LESPINASSE'],
  31330: ['LE BURGAUD', 'GRENADE', 'LAUNAC', 'MERVILLE', 'ONDES', 'ST CEZERT', 'LARRA'],
  31560: ['CAIGNAC', 'CALMONT', 'GIBEL', 'MONESTROL', 'MONTGEARD', 'NAILLOUX', 'ST LEON', 'SEYRE'],
  31410: [
    'CAPENS',
    'LE FAUGA',
    'LAVERNOSE LACASSE',
    'LONGAGES',
    'MAUZAC',
    'MONTAUT',
    'MONTGAZIN',
    'NOE',
    'ST HILAIRE',
    'ST SULPICE SUR LEZE',
  ],
  31780: ['CASTELGINEST'],
  31180: ['CASTELMAUROU', 'LAPEYROUSE FOSSAT', 'ROUFFIAC TOLOSAN', 'ST GENIES BELLEVUE'],
  31430: [
    'CASTELNAU PICAMPEAU',
    'CASTIES LABRANDE',
    'LE FOUSSERET',
    'FUSTIGNAC',
    'GRATENS',
    'LUSSAN ADEILHAC',
    'MARIGNAC LASCLARES',
    'MONTEGUT BOURJAC',
    'MONTOUSSIN',
    'POLASTRON',
    'POUY DE TOUGES',
    'ST ARAILLE',
    'ST ELIX LE CHATEAU',
    'SENARENS',
  ],
  31220: [
    'CAZERES',
    'COULADERE',
    'LAVELANET DE COMMINGES',
    'LESCUNS',
    'MARIGNAC LASPEYRES',
    'MARTRES TOLOSANE',
    'MAURAN',
    'MONDAVEZAN',
    'MONTBERAUD',
    'MONTCLAR DE COMMINGES',
    'PALAMINY',
    'PLAGNE',
    'LE PLAN',
    'ST JULIEN SUR GARONNE',
    'ST MICHEL',
    'SANA',
  ],
  31810: ['CLERMONT LE FORT', 'VENERQUE', 'VERNET'],
  31770: ['COLOMIERS'],
  31270: ['CUGNAUX', 'FROUZINS', 'VILLENEUVE TOLOSANE'],
  31600: [
    'EAUNES',
    'LABASTIDETTE',
    'LAMASQUERE',
    'LHERM',
    'MURET',
    'ST CLAR DE RIVIERE',
    'SAUBENS',
    'SEYSSES',
  ],
  31750: ['ESCALQUENS'],
  31120: ['GOYRANS', 'LACROIX FALGARDE', 'PINSAGUEL', 'PORTET SUR GARONNE', 'ROQUES', 'ROQUETTES'],
  31860: ['LABARTHE SUR LEZE', 'PINS JUSTARET', 'VILLATE'],
  31670: ['LABEGE'],
  31820: ['PIBRAC'],
  31830: ['PLAISANCE DU TOUCH'],
  31520: ['RAMONVILLE ST AGNE'],
  31250: ['REVEL', 'VAUDREUILLE'],
  31240: ['ST JEAN', 'L UNION'],
  31790: ['ST JORY', 'ST SAUVEUR'],
  31880: ['LA SALVETAT ST GILLES'],
  31000: ['TOULOUSE'],
  31100: ['TOULOUSE'],
  31200: ['TOULOUSE'],
  31300: ['TOULOUSE'],
  31400: ['TOULOUSE'],
  31500: ['TOULOUSE'],
  31170: ['TOURNEFEUILLE'],
  32290: [
    'AIGNAN',
    'AVERON BERGELLE',
    'BOUZON GELLENAVE',
    'CASTELNAVET',
    'LOUSSOUS DEBAT',
    'LUPIAC',
    'MARGOUET MEYMES',
    'POUYDRAGUIN',
    'SABAZAN',
    'ST PIERRE D AUBEZIES',
  ],
  32270: [
    'ANSAN',
    'AUBIET',
    'BLANQUEFORT',
    'CRASTES',
    'L ISLE ARNE',
    'LUSSAN',
    'MARSAN',
    'NOUGAROULET',
    'ST SAUVY',
  ],
  32360: [
    'ANTRAS',
    'CASTILLON MASSAS',
    'JEGUN',
    'LAVARDENS',
    'MERENS',
    'PEYRUSSE MASSAS',
    'ST LARY',
  ],
  32720: ['ARBLADE LE BAS', 'BARCELONNE DU GERS', 'GEE RIVIERE', 'VERGOIGNAN'],
  32110: [
    'ARBLADE LE HAUT',
    'BETOUS',
    'CAUPENNE D ARMAGNAC',
    'CRAVENCERES',
    'LANNE SOUBIRAN',
    'LAUJUZAN',
    'LOUBEDAT',
    'LUPPE VIOLLES',
    'MAGNAN',
    'NOGARO',
    'PANJAS',
    'ST GRIEDE',
    'ST MARTIN D ARMAGNAC',
    'SION',
    'SORBETS',
    'URGOSSE',
  ],
  32430: [
    'ARDIZAS',
    'COLOGNE',
    'ENCAUSSE',
    'ROQUELAURE ST AUBIN',
    'STE ANNE',
    'ST CRICQ',
    'ST GEORGES',
    'SIRAC',
    'THOUX',
    'TOUGET',
  ],
  32230: [
    'ARMENTIEUX',
    'ARMOUS ET CAU',
    'BLOUSSON SERIAN',
    'CAZAUX VILLECOMTAL',
    'COURTIES',
    'GAZAX ET BACCARISSE',
    'JUILLAC',
    'LADEVEZE RIVIERE',
    'LADEVEZE VILLE',
    'LAVERAET',
    'LOUSLITGES',
    'MARCIAC',
    'MASCARAS',
    'MONLEZUN',
    'PALLANNE',
    'PEYRUSSE VIEILLE',
    'RICOURT',
    'ST JUSTIN',
    'SCIEURAC ET FLOURES',
    'SEMBOUES',
    'TOURDUN',
    'TRONCENS',
  ],
  32140: [
    'ARROUEDE',
    'BELLEGARDE',
    'BEZUES BAJON',
    'CABAS LOUMASSES',
    'CHELAN',
    'ESCLASSAN LABASTIDE',
    'LALANNE ARQUE',
    'LOURTIES MONBRUN',
    'MANENT MONTANE',
    'MASSEUBE',
    'MONLAUR BERNET',
    'MONT D ASTARAC',
    'PANASSAC',
    'ST BLANCARD',
    'SAMARAN',
    'SERE',
    'AUSSOS',
  ],
  32000: ['AUCH'],
  32120: [
    'AUGNAX',
    'AVENSAC',
    'BAJONNETTE',
    'HOMPS',
    'LABRIHE',
    'MANSEMPUY',
    'MARAVAT',
    'MAUVEZIN',
    'MONFORT',
    'PUYCASQUIER',
    'ST ANTONIN',
    'ST BRES',
    'STE GEMME',
    'ST ORENS',
    'SARRANT',
    'SEREMPUY',
    'SOLOMIAC',
    'TAYBOSC',
  ],
  32300: [
    'AUJAN MOURNEDE',
    'BARS',
    'BELLOC ST CLAMENS',
    'BERDOUES',
    'CLERMONT POUYGUILLES',
    'CUELAS',
    'ESTIPOUY',
    'IDRAC RESPAILLES',
    'L ISLE DE NOE',
    'LABEJAN',
    'LAGARDE HACHAN',
    'LAMAZERE',
    'LOUBERSAN',
    'MIRAMONT D ASTARAC',
    'MIRANDE',
    'MONCASSIN',
    'MONCLAR SUR LOSSE',
    'MONTAUT',
    'MOUCHES',
    'PONSAMPERE',
    'PONSAN SOUBIRAN',
    'ST ARROMAN',
    'STE AURENCE CAZAUX',
    'ST ELIX THEUX',
    'ST MARTIN',
    'ST MAUR',
    'ST MEDARD',
    'ST MICHEL',
    'ST OST',
    'SAUVIAC',
    'VIOZAN',
  ],
  32600: [
    'AURADE',
    'BEAUPUY',
    'CLERMONT SAVES',
    'ENDOUFIELLE',
    'L ISLE JOURDAIN',
    'LIAS',
    'MONBRUN',
    'PUJAUDRAN',
    'RAZENGUES',
    'SEGOUFIELLE',
  ],
  32400: [
    'AURENSAN',
    'BERNEDE',
    'CAHUZAC SUR ADOUR',
    'CAUMONT',
    'CORNEILLAN',
    'FUSTEROUAU',
    'GOUX',
    'IZOTGES',
    'LABARTHETE',
    'LANNUX',
    'LELIN LAPUJOLLE',
    'MAULICHERES',
    'MAUMUSSON LAGUIAN',
    'PROJAN',
    'RISCLE',
    'ST GERME',
    'ST MONT',
    'SARRAGACHIES',
    'SEGOS',
    'TARSAC',
    'TERMES D ARMAGNAC',
    'VERLUS',
    'VIELLA',
  ],
  32450: [
    'AURIMONT',
    'BEDECHAN',
    'BOULAUR',
    'CASTELNAU BARBARENS',
    'FAGET ABBATIAL',
    'LARTIGUE',
    'ST ELIX D ASTARAC',
    'ST MARTIN GIMOIS',
    'SARAMON',
    'SEMEZIES CACHAN',
    'TIRENT PONTEJAC',
    'TRAVERSERES',
  ],
  32550: [
    'AUTERIVE',
    'BOUCAGNERES',
    'HAULIES',
    'LASSERAN',
    'LASSEUBE PROPRE',
    'MONTEGUT',
    'PAVIE',
    'PESSAN',
    'ST JEAN LE COMTAL',
  ],
  32170: [
    'AUX AUSSAT',
    'BARCUGNAN',
    'BAZUGUES',
    'CASTEX',
    'DUFFORT',
    'ESTAMPES',
    'LAAS',
    'LAGUIAN MAZOUS',
    'MANAS BASTANOUS',
    'MARSEILLAN',
    'MIELAN',
    'MONPARDIAC',
    'MONT DE MARRAST',
    'SADEILLAN',
    'STE DODE',
    'SARRAGUZAN',
    'TILLAC',
  ],
  32380: [
    'AVEZAN',
    'BIVES',
    'CADEILHAN',
    'CASTERON',
    'ESTRAMIAC',
    'GAUDONVILLE',
    'L ISLE BOUZON',
    'MAGNAS',
    'MAUROUX',
    'PESSOULENS',
    'ST CLAR',
    'ST CREAC',
    'ST LEONARD',
    'TOURNECOUPE',
  ],
  32410: ['AYGUETINTE', 'BEAUCAIRE', 'BONAS', 'CASTERA VERDUZAN', 'CEZAN', 'LARROQUE ST SERNIN'],
  32800: [
    'AYZIEU',
    'BRETAGNE D ARMAGNAC',
    'CAMPAGNE D ARMAGNAC',
    'CAZENEUVE',
    'EAUZE',
    'NOULENS',
    'RAMOUZENS',
    'REANS',
  ],
  32350: ['BARRAN', 'BIRAN', 'LE BROUILH MONBERT', 'MIRANNES', 'ORDAN LARROQUE', 'ST ARAILLES'],
  32190: [
    'BASCOUS',
    'BELMONT',
    'CAILLAVET',
    'CALLIAN',
    'CASTILLON DEBATS',
    'CAZAUX D ANGLES',
    'DEMU',
    'JUSTIAN',
    'LANNEPAX',
    'MARAMBAT',
    'MOUREDE',
    'PRENERON',
    'ROQUEBRUNE',
    'ROZES',
    'ST JEAN POUTGE',
    'ST PAUL DE BAISE',
    'SEAILLES',
    'TUDELLE',
    'VIC FEZENSAC',
  ],
  32320: [
    'BASSOUES',
    'BAZIAN',
    'CASTELNAU D ANGLES',
    'MONTESQUIOU',
    'PEYRUSSE GRANDE',
    'POUYLEBON',
    'RIGUEPEU',
    'ST CHRISTAUD',
  ],
  32160: [
    'BEAUMARCHES',
    'COULOUME MONDEBAT',
    'GALIAX',
    'JU BELLOC',
    'LASSERRADE',
    'PLAISANCE',
    'PRECHAC SUR ADOUR',
    'ST AUNIX LENGROS',
    'TASQUE',
    'TIESTE URAGNOUX',
  ],
  32100: [
    'BEAUMONT',
    'BERAUT',
    'BLAZIERT',
    'CASSAIGNE',
    'CASTELNAU SUR L AUVIGNON',
    'CAUSSENS',
    'CONDOM',
    'LARRESSINGLE',
    'LARROQUE SUR L OSSE',
    'ROQUEPINE',
    'ST ORENS POUY PETIT',
  ],
  32730: ['BECCAS', 'BETPLAN', 'HAGET', 'MALABAT', 'MONTEGUT ARROS', 'VILLECOMTAL SUR ARROS'],
  32480: [
    'BERRAC',
    'GAZAUPOUY',
    'LARROQUE ENGALIN',
    'LIGARDES',
    'POUY ROQUELAURE',
    'LA ROMIEU',
    'ST MARTIN DE GOYNE',
  ],
  32420: [
    'BETCAVE AGUIN',
    'GAUJAN',
    'MEILHAN',
    'MONBARDON',
    'MONTIES',
    'PELLEFIGUE',
    'SABAILLAN',
    'SARCOS',
    'SIMORRE',
    'TOURNAN',
    'VILLEFRANCHE D ASTARAC',
  ],
  32130: [
    'BEZERIL',
    'CAZAUX SAVES',
    'LABASTIDE SAVES',
    'LAHAS',
    'MONBLANC',
    'NIZAS',
    'NOILHAN',
    'PEBEES',
    'POLASTRON',
    'POMPIAC',
    'SAMATAN',
    'SAVIGNAC MONA',
    'SEYSSES SAVES',
  ],
  32310: [
    'BEZOLLES',
    'LAGARDERE',
    'MAIGNAUT TAUZIA',
    'MANSENCOME',
    'ROQUES',
    'ST PUY',
    'VALENCE SUR BAISE',
  ],
  32370: ['BOURROUILLAN', 'ESPAS', 'MANCIET', 'STE CHRISTIE D ARMAGNAC', 'SALLES D ARMAGNAC'],
  32500: [
    'BRUGNENS',
    'CASTELNAU D ARBIEU',
    'CERAN',
    'FLEURANCE',
    'GOUTZ',
    'LALANNE',
    'LAMOTHE GOAS',
    'PAUILHAC',
    'PIS',
    'STE RADEGONDE',
    'LA SAUVETAT',
    'URDENS',
  ],
  32220: [
    'CADEILLAN',
    'ESPAON',
    'GARRAVET',
    'GAUJAC',
    'LAYMONT',
    'LOMBEZ',
    'MONGAUSY',
    'MONTADET',
    'MONTAMAT',
    'MONTEGUT SAVES',
    'MONTPEZAT',
    'PUYLAUSIC',
    'ST LIZIER DU PLANTE',
    'ST LOUBE',
    'ST SOULAN',
    'SAUVETERRE',
    'SAUVIMONT',
  ],
  32250: ['CASTELNAU D AUZAN LABARRERE', 'FOURCES', 'MONTREAL'],
  32440: ['CASTELNAU D AUZAN LABARRERE'],
  32700: [
    'CASTERA LECTOUROIS',
    'LAGARDE',
    'LECTOURE',
    'MARSOLAN',
    'MAS D AUVIGNON',
    'PERGAIN TAILLAC',
    'ST AVIT FRANDAT',
    'STE MERE',
    'ST MEZARD',
    'SEMPESSERRE',
    'TERRAUBE',
  ],
  32340: [
    'CASTET ARROUY',
    'FLAMARENS',
    'GIMBREDE',
    'MIRADOUX',
    'PEYRECAVE',
    'PLIEUX',
    'ST ANTOINE',
  ],
  32240: [
    'CASTEX D ARMAGNAC',
    'ESTANG',
    'LANNEMAIGNAN',
    'LIAS D ARMAGNAC',
    'MAULEON D ARMAGNAC',
    'MAUPAS',
    'MONGUILHEM',
    'MONLEZUN D ARMAGNAC',
    'MORMES',
    'TOUJOUSE',
  ],
  32490: ['CASTILLON SAVES', 'FREGOUVILLE', 'MARESTAING', 'MONFERRAN SAVES'],
  32810: [
    'CASTIN',
    'DURAN',
    'LAHITTE',
    'LEBOULIN',
    'MONTAUT LES CRENEAUX',
    'PREIGNAN',
    'ROQUELAURE',
  ],
  32200: [
    'CATONVIELLE',
    'ESCORNEBOEUF',
    'GIMONT',
    'GISCARO',
    'JUILLES',
    'MAURENS',
    'MONTIRON',
    'ST ANDRE',
    'ST GERMIER',
    'STE MARIE',
    'ST CAPRAIS',
  ],
  32150: ['CAZAUBON', 'LAREE', 'MARGUESTAU', 'MONCLAR'],
  32330: ['COURRENSAN', 'GONDRIN', 'LAGRAULET DU GERS', 'LAURAET', 'MOUCHAN'],
  32260: [
    'DURBAN',
    'LABARTHE',
    'LAMAGUERE',
    'MONCORNEIL GRAZAN',
    'MONFERRAN PLAVES',
    'ORBESSAN',
    'ORNEZAN',
    'POUY LOUBRIN',
    'SANSAN',
    'SEISSAN',
    'TACHOIRES',
  ],
  32390: [
    'GAVARRET SUR AULOUSTE',
    'MIRAMONT LATOUR',
    'MIREPOIX',
    'MONTESTRUC SUR GERS',
    'PRECHAC',
    'PUYSEGUR',
    'REJAUMONT',
    'ROQUEFORT',
    'STE CHRISTIE',
    'TOURRENQUETS',
  ],
  32460: ['LE HOUGA', 'PERCHEDE'],
  33230: [
    'ABZAC',
    'BAYAS',
    'CHAMADELLE',
    'COUTRAS',
    'LES EGLISOTTES ET CHALAURES',
    'LE FIEU',
    'GUITRES',
    'LAGORCE',
    'MARANSIN',
    'LES PEINTURES',
    'ST CHRISTOPHE DE DOUBLE',
    'ST MEDARD DE GUIZIERES',
  ],
  33124: ['AILLAS', 'AUROS', 'BERTHEZ', 'BRANNENS', 'BROUQUEYRAN', 'LADOS', 'SAVIGNAC'],
  33440: ['AMBARES ET LAGRAVE', 'ST LOUIS DE MONTFERRAND', 'ST VINCENT DE PAUL'],
  33810: ['AMBES'],
  33510: ['ANDERNOS LES BAINS'],
  33390: [
    'ANGLADE',
    'BERSON',
    'BLAYE',
    'CAMPUGNAN',
    'CARS',
    'CARTELEGUE',
    'EYRANS',
    'FOURS',
    'MAZION',
    'PLASSAC',
    'ST ANDRONY',
    'ST GENES DE BLAYE',
    'ST MARTIN LACAUSSADE',
    'ST PAUL',
    'ST SEURIN DE CURSAC',
  ],
  33640: [
    'ARBANATS',
    'AYGUEMORTE LES GRAVES',
    'BEAUTIRAN',
    'CASTRES GIRONDE',
    'ISLE ST GEORGES',
    'PORTETS',
  ],
  33760: [
    'PORTE DE BENAUGE',
    'BAIGNEAUX',
    'BELLEBAT',
    'BELLEFOND',
    'CESSAC',
    'COURPIAC',
    'ESCOUSSANS',
    'FALEYRAS',
    'FRONTENAC',
    'LADAUX',
    'LUGASSON',
    'MARTRES',
    'MONTIGNAC',
    'ROMAGNE',
    'ST GENIS DU BOIS',
    'ST PIERRE DE BAT',
    'SOULIGNAC',
    'TARGON',
  ],
  33120: ['ARCACHON'],
  33460: [
    'ARCINS',
    'ARSAC',
    'CUSSAC FORT MEDOC',
    'LABARDE',
    'LAMARQUE',
    'MACAU',
    'MARGAUX CANTENAC',
    'SOUSSANS',
  ],
  33740: ['ARES'],
  33370: [
    'ARTIGUES PRES BORDEAUX',
    'BONNETAN',
    'FARGUES ST HILAIRE',
    'LOUPES',
    'POMPIGNAC',
    'SALLEBOEUF',
    'TRESSES',
    'YVRAC',
  ],
  33570: [
    'LES ARTIGUES DE LUSSAC',
    'FRANCS',
    'LUSSAC',
    'MONTAGNE',
    'PETIT PALAIS ET CORNEMPS',
    'PUISSEGUIN',
    'ST CIBARD',
    'TAYAC',
  ],
  33500: ['ARVEYRES', 'LES BILLAUX', 'LALANDE DE POMEROL', 'LIBOURNE', 'NEAC', 'POMEROL'],
  33240: [
    'ASQUES',
    'VAL DE VIRVEE',
    'CADILLAC EN FRONSADAIS',
    'CUBZAC LES PONTS',
    'GAURIAGUET',
    'LA LANDE DE FRONSAC',
    'LUGON ET L ILE DU CARNAY',
    'MOUILLAC',
    'PERISSAC',
    'PEUJARD',
    'ST ANDRE DE CUBZAC',
    'ST GENES DE FRONSAC',
    'ST GERMAIN DE LA RIVIERE',
    'ST GERVAIS',
    'ST LAURENT D ARCE',
    'ST ROMAIN LA VIRVEE',
    'TARNES',
    'VERAC',
    'VIRSAC',
  ],
  33430: [
    'AUBIAC',
    'BAZAS',
    'BERNOS BEAULAC',
    'BIRAC',
    'CAZATS',
    'CUDOS',
    'GAJAC',
    'GANS',
    'LIGNAN DE BAZAS',
    'MARIMBAULT',
    'LE NIZAN',
    'ST COME',
    'SAUVIAC',
  ],
  33980: ['AUDENGE'],
  33790: [
    'AURIOLLES',
    'CAZAUGITAT',
    'LANDERROUAT',
    'LISTRAC DE DUREZE',
    'MASSUGAS',
    'PELLEGRUE',
    'ST ANTOINE DU QUEYRET',
    'SOUSSAC',
  ],
  33480: [
    'AVENSAN',
    'BRACH',
    'CASTELNAU DE MEDOC',
    'LISTRAC MEDOC',
    'MOULIS EN MEDOC',
    'STE HELENE',
  ],
  33190: [
    'BAGAS',
    'BARIE',
    'BASSANNE',
    'BLAIGNAC',
    'BOURDELLES',
    'CAMIRAN',
    'CASSEUIL',
    'LES ESSEINTES',
    'FLOUDES',
    'FONTET',
    'FOSSES ET BALEYSSAC',
    'GIRONDE SUR DROPT',
    'HURE',
    'LAMOTHE LANDERRON',
    'LOUBENS',
    'LOUPIAC DE LA REOLE',
    'MONGAUZY',
    'MONTAGOUDIN',
    'MORIZES',
    'NOAILLAC',
    'PONDAURAT',
    'PUYBARBAN',
    'LA REOLE',
    'ST EXUPERY',
    'ST HILAIRE DE LA NOAILLE',
    'ST LAURENT DU PLAN',
    'ST MICHEL DE LAPUJADE',
    'ST SEVE',
  ],
  33730: ['BALIZAC', 'NOAILLAN', 'POMPEJAC', 'PRECHAC', 'UZESTE', 'VILLANDRAUT'],
  33750: [
    'BARON',
    'BEYCHAC ET CAILLAU',
    'CADARSAC',
    'CAMARSAC',
    'CROIGNON',
    'NERIGEAN',
    'ST GERMAIN DU PUCH',
    'ST QUENTIN DE BARON',
  ],
  33114: ['LE BARP'],
  33720: [
    'BARSAC',
    'BUDOS',
    'CERONS',
    'GUILLOS',
    'ILLATS',
    'LANDIRAS',
    'PODENSAC',
    'ST MICHEL DE RIEUFRET',
    'VIRELADE',
  ],
  33530: ['BASSENS'],
  33880: ['BAURECH', 'CAMBES', 'ST CAPRAIS DE BORDEAUX'],
  33710: [
    'BAYON SUR GIRONDE',
    'BOURG',
    'COMPS',
    'GAURIAC',
    'LANSAC',
    'MOMBRIER',
    'PRIGNAC ET MARCAMPS',
    'PUGNAC',
    'ST CIERS DE CANESSE',
    'ST SEURIN DE BOURG',
    'ST TROJAN',
    'SAMONAC',
    'TAURIAC',
    'TEUILLAC',
    'VILLENEUVE',
  ],
  33340: [
    'BEGADAN',
    'BLAIGNAN PRIGNAC',
    'CIVRAC EN MEDOC',
    'COUQUEQUES',
    'GAILLAN EN MEDOC',
    'LESPARRE MEDOC',
    'ORDONNAC',
    'QUEYRAC',
    'ST CHRISTOLY MEDOC',
    'ST GERMAIN D ESTEUIL',
    'ST YZANS DE MEDOC',
    'VALEYRAC',
  ],
  33130: ['BEGLES'],
  33410: [
    'BEGUEY',
    'CADILLAC SUR GARONNE',
    'CARDAN',
    'DONZAC',
    'GABARNAC',
    'LAROQUE',
    'LOUPIAC',
    'MONPRIMBLANC',
    'MOURENS',
    'OMET',
    'RIONS',
    'STE CROIX DU MONT',
  ],
  33830: ['BELIN BELIET', 'LUGOS'],
  33350: [
    'BELVES DE CASTILLON',
    'BOSSUGAN',
    'CASTILLON LA BATAILLE',
    'CIVRAC SUR DORDOGNE',
    'DOULEZON',
    'FLAUJAGUES',
    'GARDEGAN ET TOURTIRAC',
    'MERIGNAS',
    'MOULIETS ET VILLEMARTIN',
    'PUJOLS',
    'RUCH',
    'STE COLOMBE',
    'STE FLORENCE',
    'ST GENES DE CASTILLON',
    'ST MAGNE DE CASTILLON',
    'ST PEY DE CASTETS',
    'ST PHILIPPE D AIGUILLE',
    'STE RADEGONDE',
    'STE TERRE',
    'LES SALLES DE CASTILLON',
  ],
  33210: [
    'BIEUJAC',
    'BOMMES',
    'CASTETS ET CASTILLON',
    'COIMERES',
    'FARGUES',
    'LANGON',
    'LEOGEATS',
    'MAZERES',
    'PREIGNAC',
    'PUJOLS SUR CIRON',
    'ROAILLAN',
    'ST LOUBERT',
    'ST PARDON DE CONQUES',
    'ST PIERRE DE MONS',
    'SAUTERNES',
    'TOULENNE',
  ],
  33380: ['BIGANOS', 'MIOS', 'MARCHEPRIME'],
  33290: ['BLANQUEFORT', 'LUDON MEDOC', 'PAREMPUYRE', 'LE PIAN MEDOC'],
  33540: [
    'BLASIMON',
    'CASTELMORON D ALBRET',
    'CASTELVIEL',
    'CAUMONT',
    'CLEYRAC',
    'COIRAC',
    'DAUBEZE',
    'GORNAC',
    'LANDERROUET SUR SEGUR',
    'MAURIAC',
    'MESTERRIEUX',
    'ST BRICE',
    'ST FELIX DE FONCAUDE',
    'ST HILAIRE DU BOIS',
    'ST LAURENT DU BOIS',
    'ST MARTIN DE LERM',
    'ST MARTIN DU PUY',
    'ST SULPICE DE POMMIERS',
    'SAUVETERRE DE GUYENNE',
  ],
  33670: [
    'BLESIGNAC',
    'CREON',
    'CURSAN',
    'MADIRAC',
    'LE POUT',
    'SADIRAC',
    'ST GENES DE LOMBAUD',
    'ST LEON',
    'LA SAUVE',
  ],
  33910: [
    'BONZAC',
    'SABLONS',
    'ST CIERS D ABZAC',
    'ST DENIS DE PILE',
    'ST MARTIN DE LAYE',
    'ST MARTIN DU BOIS',
    'SAVIGNAC DE L ISLE',
  ],
  33000: ['BORDEAUX'],
  33100: ['BORDEAUX'],
  33200: ['BORDEAUX'],
  33300: ['BORDEAUX'],
  33800: ['BORDEAUX'],
  33270: ['BOULIAC', 'FLOIRAC'],
  33113: ['BOURIDEYS', 'CAZALIS', 'ORIGNE', 'ST LEGER DE BALSON', 'ST SYMPHORIEN'],
  33110: ['LE BOUSCAT'],
  33420: [
    'BRANNE',
    'CABARA',
    'CAMIAC ET ST DENIS',
    'DAIGNAC',
    'DARDENAC',
    'ESPIET',
    'GENISSAC',
    'GREZILLAC',
    'GUILLAC',
    'JUGAZAN',
    'LUGAIGNAC',
    'MOULON',
    'NAUJAN ET POSTIAC',
    'RAUZAN',
    'ST AUBIN DE BRANNE',
    'ST JEAN DE BLAIGNAC',
    'ST VINCENT DE PERTIGNAS',
    'TIZAC DE CURTON',
  ],
  33820: [
    'BRAUD ET ST LOUIS',
    'ETAULIERS',
    'PLEINE SELVE',
    'ST AUBIN DE BLAYE',
    'VAL DE LIVENNE',
    'ST CIERS SUR GIRONDE',
    'ST PALAIS',
  ],
  33520: ['BRUGES'],
  33650: [
    'CABANAC ET VILLAGRAINS',
    'LA BREDE',
    'MARTILLAC',
    'ST MEDARD D EYRANS',
    'ST MORILLON',
    'ST SELVE',
    'SAUCATS',
  ],
  33140: ['CADAUJAC', 'VILLENAVE D ORNON'],
  33360: [
    'CAMBLANES ET MEYNAC',
    'CARIGNAN DE BORDEAUX',
    'CENAC',
    'LATRESNE',
    'LIGNAN DE BORDEAUX',
    'QUINSAC',
  ],
  33660: [
    'CAMPS SUR L ISLE',
    'GOURS',
    'PORCHERES',
    'PUYNORMAND',
    'ST ANTOINE SUR L ISLE',
    'ST SAUVEUR DE PUYNORMAND',
    'ST SEURIN SUR L ISLE',
  ],
  33610: ['CANEJAN', 'CESTAS'],
  33550: [
    'CAPIAN',
    'HAUX',
    'LANGOIRAN',
    'LESTIAC SUR GARONNE',
    'PAILLET',
    'TABANAC',
    'LE TOURNE',
    'VILLENAVE DE RIONS',
  ],
  33840: [
    'CAPTIEUX',
    'ESCAUDES',
    'GISCOS',
    'GOUALADE',
    'LARTIGUE',
    'LERM ET MUSSET',
    'LUCMAU',
    'ST MICHEL DE CASTELNAU',
  ],
  33560: ['CARBON BLANC', 'STE EULALIE'],
  33121: ['CARCANS'],
  33490: [
    'CAUDROT',
    'LE PIAN SUR GARONNE',
    'ST ANDRE DU BOIS',
    'STE FOY LA LONGUE',
    'ST GERMAIN DE GRAVE',
    'ST MACAIRE',
    'ST MAIXANT',
    'ST MARTIAL',
    'ST MARTIN DE SESCAS',
    'ST PIERRE D AURILLAC',
    'SEMENS',
    'VERDELAIS',
  ],
  33690: [
    'CAUVIGNAC',
    'COURS LES BAINS',
    'GRIGNOLS',
    'LABESCAU',
    'LAVAZAN',
    'MARIONS',
    'MASSEILLES',
    'SENDETS',
    'SIGALENS',
    'SILLAS',
  ],
  33620: [
    'CAVIGNAC',
    'CEZAC',
    'CUBNEZAIS',
    'LAPOUYADE',
    'LARUSCADE',
    'MARCENAIS',
    'MARSAS',
    'ST MARIENS',
    'TIZAC DE LAPOUYADE',
  ],
  33150: ['CENON'],
  33250: ['CISSAC MEDOC', 'PAUILLAC', 'ST JULIEN BEYCHEVELLE', 'ST SAUVEUR'],
  33920: [
    'CIVRAC DE BLAYE',
    'GENERAC',
    'ST CHRISTOLY DE BLAYE',
    'ST GIRONS D AIGUEVIVES',
    'ST SAVIN',
    'ST VIVIEN DE BLAYE',
    'ST YZAN DE SOUDIAC',
    'SAUGON',
  ],
  33890: ['COUBEYRAC', 'GENSAC', 'JUILLAC', 'PESSAC SUR DORDOGNE'],
  33580: [
    'COURS DE MONSEGUR',
    'COUTURES',
    'DIEULIVOL',
    'MONSEGUR',
    'NEUFFONS',
    'LE PUY',
    'RIMONS',
    'ROQUEBRUNE',
    'ST FERME',
    'STE GEMME',
    'ST SULPICE DE GUILLERAGUES',
    'ST VIVIEN DE MONSEGUR',
    'TAILLECAVAT',
  ],
  33860: ['DONNEZAC', 'REIGNAC', 'VAL DE LIVENNE'],
  33320: ['EYSINES', 'LE TAILLAN MEDOC'],
  33126: ['FRONSAC', 'LA RIVIERE', 'ST AIGNAN', 'ST MICHEL DE FRONSAC'],
  33133: ['GALGON'],
  33170: ['GRADIGNAN'],
  33590: ['GRAYAN ET L HOPITAL', 'JAU DIGNAC ET LOIRAC', 'ST VIVIEN DE MEDOC', 'TALAIS', 'VENSAC'],
  33470: ['GUJAN MESTRAS', 'LE TEICH'],
  33185: ['LE HAILLAN'],
  33125: ['HOSTENS', 'LOUCHATS', 'ST MAGNE', 'LE TUZAN'],
  33990: ['HOURTIN', 'NAUJAC SUR MER'],
  33450: ['IZON', 'MONTUSSAN', 'ST LOUBES', 'ST SULPICE ET CAMEYRAC'],
  33680: ['LACANAU', 'LE PORGE', 'SAUMOS', 'LE TEMPLE'],
  33138: ['LANTON'],
  33950: ['LEGE CAP FERRET'],
  33970: ['LEGE CAP FERRET'],
  33850: ['LEOGNAN'],
  33310: ['LORMONT'],
  33127: ['MARTIGNAS SUR JALLE', 'ST JEAN D ILLAC'],
  33700: ['MERIGNAC'],
  33600: ['PESSAC'],
  33141: ['SAILLANS', 'VILLEGOUGE'],
  33160: ['ST AUBIN DE MEDOC', 'ST MEDARD EN JALLES', 'SALAUNES'],
  33330: [
    'ST CHRISTOPHE DES BARDES',
    'ST EMILION',
    'ST ETIENNE DE LISSE',
    'ST HIPPOLYTE',
    'ST LAURENT DES COMBES',
    'ST PEY D ARMENS',
    'ST SULPICE DE FALEYRENS',
    'VIGNONET',
  ],
  33180: ['ST ESTEPHE', 'ST SEURIN DE CADOURNE', 'VERTHEUIL'],
  33112: ['ST LAURENT MEDOC'],
  33770: ['SALLES'],
  33780: ['SOULAC SUR MER'],
  33400: ['TALENCE'],
  33115: ['LA TESTE DE BUCH'],
  33260: ['LA TESTE DE BUCH'],
  33870: ['VAYRES'],
  33930: ['VENDAYS MONTALIVET'],
  33123: ['LE VERDON SUR MER'],
  34290: [
    'ABEILHAN',
    'ALIGNAN DU VENT',
    'BASSAN',
    'COULOBRES',
    'ESPONDEILHAN',
    'LIEURAN LES BEZIERS',
    'MONTBLANC',
    'SERVIAN',
    'VALROS',
  ],
  34230: [
    'ADISSAN',
    'AUMELAS',
    'BELARGA',
    'CAMPAGNAN',
    'PAULHAN',
    'PLAISSAN',
    'POPIAN',
    'LE POUGET',
    'POUZOLS',
    'PUILACHER',
    'ST BAUZILLE DE LA SYLVE',
    'ST PARGOIRE',
    'ST PONS DE MAUCHIENS',
    'TRESSAN',
    'USCLAS D HERAULT',
    'VENDEMIAN',
  ],
  34300: ['AGDE'],
  34210: [
    'AGEL',
    'AIGNE',
    'AIGUES VIVES',
    'AZILLANET',
    'BEAUFORT',
    'CASSAGNOLES',
    'LA CAUNETTE',
    'CESSERAS',
    'FELINES MINERVOIS',
    'FERRALS LES MONTAGNES',
    'LA LIVINIERE',
    'MINERVE',
    'OLONZAC',
    'OUPIA',
    'SIRAN',
  ],
  34190: [
    'AGONES',
    'BRISSAC',
    'CAZILHAC',
    'FERRIERES LES VERRERIES',
    'GANGES',
    'GORNIES',
    'LAROQUE',
    'MONTOULIEU',
    'MOULES ET BAUCELS',
    'ST ANDRE DE BUEGES',
    'ST BAUZILLE DE PUTOIS',
    'ST MAURICE NAVACELLES',
  ],
  34600: [
    'LES AIRES',
    'BEDARIEUX',
    'CARLENCAS ET LEVAS',
    'CAUSSINIOJOULS',
    'FAUGERES',
    'HEREPIAN',
    'PEZENES LES MINES',
    'LE POUJOL SUR ORB',
    'LE PRADAL',
    'TAUSSAC LA BILLIERE',
    'VILLEMAGNE L ARGENTIERE',
  ],
  34150: [
    'ANIANE',
    'ARBORAS',
    'LA BOISSIERE',
    'GIGNAC',
    'LAGAMAS',
    'MONTPEYROUX',
    'PUECHABON',
    'ST GUILHEM LE DESERT',
    'ST JEAN DE FOS',
  ],
  34380: [
    'ARGELLIERS',
    'CAUSSE DE LA SELLE',
    'MAS DE LONDRES',
    'NOTRE DAME DE LONDRES',
    'PEGAIROLLES DE BUEGES',
    'ROUET',
    'ST JEAN DE BUEGES',
    'ST MARTIN DE LONDRES',
    'VIOLS EN LAVAL',
    'VIOLS LE FORT',
  ],
  34800: [
    'ASPIRAN',
    'BRIGNAC',
    'CABRIERES',
    'CANET',
    'CEYRAS',
    'CLERMONT L HERAULT',
    'LACOSTE',
    'LIAUSSON',
    'LIEURAN CABRIERES',
    'MERIFONS',
    'MOUREZE',
    'NEBIAN',
    'OCTON',
    'PERET',
    'SALASC',
    'VALMASCLE',
    'VILLENEUVETTE',
  ],
  34820: ['ASSAS', 'GUZARGUES', 'TEYRAN'],
  34360: [
    'ASSIGNAN',
    'BABEAU BOULDOUX',
    'BERLOU',
    'CEBAZAN',
    'FERRIERES POUSSAROU',
    'PARDAILHAN',
    'PIERRERUE',
    'PRADES SUR VERNAZOBRE',
    'ST CHINIAN',
    'ST JEAN DE MINERVOIS',
    'VILLESPASSANS',
  ],
  34530: ['AUMES', 'MONTAGNAC'],
  34480: [
    'AUTIGNAC',
    'CABREROLLES',
    'FOUZILHON',
    'LAURENS',
    'MAGALAS',
    'POUZOLLES',
    'PUIMISSON',
    'PUISSALICON',
    'ST GENIES DE FONTEDIT',
  ],
  34260: [
    'AVENE',
    'LE BOUSQUET D ORB',
    'CAMPLONG',
    'CEILHES ET ROCOZELS',
    'GRAISSESSAC',
    'ST ETIENNE ESTRECHOUX',
    'LA TOUR SUR ORB',
  ],
  34670: ['BAILLARGUES', 'ST BRES'],
  34540: ['BALARUC LES BAINS', 'BALARUC LE VIEUX'],
  34160: [
    'BEAULIEU',
    'BOISSERON',
    'BUZIGNARGUES',
    'CAMPAGNE',
    'CASTRIES',
    'GALARGUES',
    'GARRIGUES',
    'MONTAUD',
    'RESTINCLIERES',
    'ST BAUZILLE DE MONTMEL',
    'ST DREZERY',
    'ST GENIES DES MOURGUES',
    'ST HILAIRE DE BEAUVOIR',
    'ST JEAN DE CORNIES',
    'SAUSSINES',
    'SUSSARGUES',
  ],
  34550: ['BESSAN'],
  34500: ['BEZIERS', 'VILLENEUVE LES BEZIERS'],
  34220: [
    'BOISSET',
    'COURNIOU',
    'RIEUSSEC',
    'RIOLS',
    'ST PONS DE THOMIERES',
    'VELIEUX',
    'VERRERIES DE MOUSSANS',
  ],
  34700: [
    'LE BOSC',
    'CELLES',
    'FOZIERES',
    'LAUROUX',
    'LAVALETTE',
    'LODEVE',
    'OLMET ET VILLECUN',
    'PEGAIROLLES DE L ESCALETTE',
    'LES PLANS',
    'POUJOLS',
    'LE PUECH',
    'ST ETIENNE DE GOURGAS',
    'ST JEAN DE LA BLAQUIERE',
    'ST PRIVAT',
    'SOUBES',
    'SOUMONT',
    'USCLAS DU BOSC',
  ],
  34760: ['BOUJAN SUR LIBRON'],
  34140: ['BOUZIGUES', 'LOUPIAN', 'MEZE'],
  34650: ['BRENAS', 'DIO ET VALQUIERES', 'JONCELS', 'LUNAS', 'ROMIGUIERES', 'ROQUEREDONDE'],
  34330: ['CAMBON ET SALVERGUES', 'FRAISSE SUR AGOUT', 'LA SALVETAT SUR AGOUT', 'LE SOULIE'],
  34130: ['CANDILLARGUES', 'LANSARGUES', 'MAUGUIO', 'MUDAISON', 'ST AUNES', 'VALERGUES'],
  34310: ['CAPESTANG', 'CRUZY', 'MONTADY', 'MONTELS', 'MONTOULIERS', 'POILHES', 'QUARANTE'],
  34610: ['CASTANET LE HAUT', 'ROSIS', 'ST GENIES DE VARENSAL', 'ST GERVAIS SUR MARE'],
  34120: [
    'CASTELNAU DE GUERS',
    'CAZOULS D HERAULT',
    'LEZIGNAN LA CEBE',
    'NEZIGNAN L EVEQUE',
    'PEZENAS',
    'TOURBES',
  ],
  34170: ['CASTELNAU LE LEZ'],
  34490: [
    'CAUSSES ET VEYRAN',
    'CORNEILHAN',
    'LIGNAN SUR ORB',
    'MURVIEL LES BEZIERS',
    'PAILHES',
    'ST NAZAIRE DE LADAREZ',
    'THEZAN LES BEZIERS',
  ],
  34720: ['CAUX'],
  34520: [
    'LE CAYLAR',
    'LE CROS',
    'LES RIVES',
    'ST FELIX DE L HERAS',
    'ST MAURICE NAVACELLES',
    'ST MICHEL',
    'ST PIERRE DE LA FAGE',
    'SORBS',
    'LA VACQUERIE ET ST MARTIN DE CASTRIES',
  ],
  34460: ['CAZEDARNES', 'CESSENON SUR ORB', 'ROQUEBRUN'],
  34270: [
    'CAZEVIEILLE',
    'CLARET',
    'FONTANES',
    'LAURET',
    'LES MATELLES',
    'STE CROIX DE QUINTILLARGUES',
    'ST JEAN DE CUCULLES',
    'ST MATHIEU DE TREVIERS',
    'SAUTEYRARGUES',
    'LE TRIADOU',
    'VACQUIERES',
    'VALFLAUNES',
  ],
  34370: ['CAZOULS LES BEZIERS', 'CREISSAN', 'MARAUSSAN', 'MAUREILHAN'],
  34420: ['CERS', 'PORTIRAGNES', 'VILLENEUVE LES BEZIERS'],
  34830: ['CLAPIERS', 'JACOU'],
  34390: [
    'COLOMBIERES SUR ORB',
    'MONS',
    'OLARGUES',
    'PREMIAN',
    'ST ETIENNE D ALBAGNAN',
    'ST JULIEN',
    'ST MARTIN DE L ARCON',
    'ST VINCENT D OLARGUES',
    'VIEUSSAN',
  ],
  34440: ['COLOMBIERS', 'NISSAN LEZ ENSERUNE'],
  34980: [
    'COMBAILLAUX',
    'MONTFERRIER SUR LEZ',
    'MURLES',
    'ST CLEMENT DE RIVIERE',
    'ST GELY DU FESC',
  ],
  34240: ['COMBES', 'LAMALOU LES BAINS'],
  34660: ['COURNONSEC', 'COURNONTERRAL'],
  34920: ['LE CRES'],
  34690: ['FABREGUES'],
  34510: ['FLORENSAC'],
  34320: [
    'FONTES',
    'FOS',
    'GABIAN',
    'MARGON',
    'MONTESQUIEU',
    'NEFFIES',
    'NIZAS',
    'ROQUESSELS',
    'ROUJAN',
    'VAILHAN',
  ],
  34110: ['FRONTIGNAN', 'MIREVAL', 'VIC LA GARDIOLE'],
  34770: ['GIGEAN'],
  34790: ['GRABELS'],
  34725: [
    'JONQUIERES',
    'ST ANDRE DE SANGONIS',
    'ST FELIX DE LODEZ',
    'ST GUIRAUD',
    'ST SATURNIN DE LUCIAN',
  ],
  34990: ['JUVIGNAC'],
  34970: ['LATTES'],
  34880: ['LAVERUNE'],
  34710: ['LESPIGNAN'],
  34400: [
    'LUNEL',
    'LUNEL VIEL',
    'ENTRE VIGNES',
    'ST JUST',
    'ST NAZAIRE DE PEZAN',
    'ST SERIES',
    'SATURARGUES',
    'VILLETELLE',
  ],
  34340: ['MARSEILLAN'],
  34590: ['MARSILLARGUES'],
  34570: [
    'MONTARNAUD',
    'MURVIEL LES MONTPELLIER',
    'PIGNAN',
    'ST PAUL ET VALMALLE',
    'SAUSSAN',
    'VAILHAUQUES',
  ],
  34560: ['MONTBAZIN', 'POUSSAN', 'VILLEVEYRAC'],
  34000: ['MONTPELLIER'],
  34070: ['MONTPELLIER'],
  34080: ['MONTPELLIER'],
  34090: ['MONTPELLIER'],
  34250: ['PALAVAS LES FLOTS'],
  34470: ['PEROLS'],
  34850: ['PINET'],
  34810: ['POMEROLS'],
  34730: ['PRADES LE LEZ', 'ST VINCENT DE BARBEYRARGUES'],
  34620: ['PUISSERGUIER'],
  34680: ['ST GEORGES D ORQUES'],
  34430: ['ST JEAN DE VEDAS'],
  34630: ['ST THIBERY'],
  34410: ['SAUVIAN', 'SERIGNAN'],
  34200: ['SETE'],
  34350: ['VALRAS PLAGE', 'VENDRES'],
  34740: ['VENDARGUES'],
  34450: ['VIAS'],
  34750: ['VILLENEUVE LES MAGUELONE'],
  34280: ['LA GRANDE MOTTE'],
  35690: ['ACIGNE'],
  35150: [
    'AMANLIS',
    'BOISTRUDAN',
    'BRIE',
    'CHANTELOUP',
    'CORPS NUDS',
    'ESSE',
    'JANZE',
    'PIRE CHANCE',
  ],
  35250: [
    'ANDOUILLE NEUVILLE',
    'AUBIGNE',
    'CHASNE SUR ILLET',
    'CHEVAIGNE',
    'MOUAZE',
    'ST AUBIN D AUBIGNE',
    'ST GERMAIN SUR ILLE',
    'ST MEDARD SUR ILLE',
    'ST SULPICE LA FORET',
  ],
  35460: ['VAL COUESNON', 'LES PORTES DU COGLAIS', 'MAEN ROCH', 'ST MARC LE BLANC', 'LE TIERCENT'],
  35560: [
    'VAL COUESNON',
    'BAZOUGES LA PEROUSE',
    'MARCILLE RAOUL',
    'NOYAL SOUS BAZOUGES',
    'RIMOU',
    'ST REMY DU PLAIN',
  ],
  35130: [
    'ARBRISSEL',
    'AVAILLES SUR SEICHE',
    'DROUGES',
    'LA GUERCHE DE BRETAGNE',
    'MOUSSE',
    'MOUTIERS',
    'RANNEE',
    'LA SELLE GUERCHAISE',
    'VISSEICHE',
  ],
  35370: [
    'ARGENTRE DU PLESSIS',
    'BREAL SOUS VITRE',
    'BRIELLES',
    'ETRELLES',
    'GENNES SUR SEICHE',
    'MONDEVERT',
    'LE PERTRE',
    'ST GERMAIN DU PINEL',
    'TORCE',
  ],
  35120: [
    'BAGUER MORVAN',
    'BAGUER PICAN',
    'LA BOUSSAC',
    'BROUALAN',
    'CHERRUEIX',
    'DOL DE BRETAGNE',
    'EPINIAC',
    'HIREL',
    'MONT DOL',
    'ROZ LANDRIEUX',
    'ST BROLADRE',
    'ST MARCAN',
  ],
  35470: ['BAIN DE BRETAGNE', 'LA NOE BLANCHE', 'PLECHATEL'],
  35600: ['BAINS SUR OUST', 'REDON', 'STE MARIE'],
  35680: ['BAIS', 'DOMALAIN', 'LOUVIGNE DE BAIS', 'MOULINS', 'PIRE CHANCE', 'VERGEAL'],
  35500: [
    'BALAZE',
    'CHAMPEAUX',
    'LA CHAPELLE ERBREE',
    'CORNILLE',
    'ERBREE',
    'MONTREUIL SOUS PEROUSE',
    'POCE LES BOIS',
    'ST AUBIN DES LANDES',
    'ST M HERVE',
    'TAILLIS',
    'VITRE',
  ],
  35580: ['BAULON', 'GOVEN', 'GUICHEN', 'GUIGNEN', 'LASSY', 'ST SENOUX'],
  35190: [
    'LA BAUSSAINE',
    'BECHEREL',
    'CARDROC',
    'LA CHAPELLE AUX FILTZMEENS',
    'LONGAULNAY',
    'MINIAC SOUS BECHEREL',
    'QUEBRIAC',
    'ST DOMINEUC',
    'ST PERN',
    'ST THUAL',
    'TINTENIAC',
    'TREVERIEN',
    'TRIMER',
  ],
  35420: [
    'LA BAZOUGE DU DESERT',
    'LE FERRE',
    'LOUVIGNE DU DESERT',
    'MELLE',
    'MONTHAULT',
    'POILLEY',
    'ST GEORGES DE REINTEMBAULT',
    'VILLAMEE',
  ],
  35133: [
    'BEAUCE',
    'BILLE',
    'LA CHAPELLE FLEURIGNE',
    'LE CHATELLIER',
    'JAVENE',
    'LAIGNELET',
    'LANDEAN',
    'LECOUSSE',
    'LE LOROUX',
    'LUITRE DOMPIERRE',
    'PARIGNE',
    'ROMAGNE',
    'ST GERMAIN EN COGLES',
    'ST SAUVEUR DES LANDES',
    'LA SELLE EN LUITRE',
  ],
  35137: ['BEDEE', 'LA NOUAYE', 'PLEUMELEUC'],
  35830: ['BETTON'],
  35750: ['BLERUAIS', 'IFFENDIC', 'ST GONLAY', 'ST MALON SUR MEL', 'ST MAUGAN'],
  35360: [
    'BOISGERVILLY',
    'LA CHAPELLE DU LOU DU LAC',
    'LANDUJAN',
    'MEDREAC',
    'MONTAUBAN DE BRETAGNE',
    'ST UNIAC',
  ],
  35270: [
    'BONNEMAIN',
    'COMBOURG',
    'CUGUEN',
    'LANRIGAN',
    'LOURMAIS',
    'MEILLAC',
    'ST LEGER DES PRES',
    'TREMEHEUC',
  ],
  35320: [
    'LA BOSSE DE BRETAGNE',
    'LA COUYERE',
    'CREVIN',
    'LALLEU',
    'PANCE',
    'LE PETIT FOUGERAY',
    'POLIGNE',
    'SAULNIERES',
    'LE SEL DE BRETAGNE',
    'TRESBOEUF',
  ],
  35340: ['LA BOUEXIERE', 'ERCE PRES LIFFRE', 'LIFFRE'],
  35230: ['BOURGBARRE', 'NOYAL CHATILLON SUR SEICHE', 'ORGERES', 'ST ARMEL', 'ST ERBLON'],
  35890: ['BOURG DES COMPTES', 'LAILLE'],
  35330: [
    'BOVEL',
    'LES BRULAIS',
    'LA CHAPELLE BOUEXIC',
    'COMBLESSAC',
    'LOUTEHEL',
    'VAL D ANAST',
    'MERNEL',
    'ST SEGLIN',
  ],
  35310: ['BREAL SOUS MONTFORT', 'CHAVAGNE', 'CINTRE', 'MORDELLES', 'ST THURIAL'],
  35530: ['BRECE', 'NOYAL SUR VILAINE', 'SERVON SUR VILAINE'],
  35160: ['BRETEIL', 'MONTERFIL', 'MONTFORT SUR MEU', 'TALENSAC', 'LE VERGER'],
  35550: ['BRUC SUR AFF', 'LIEURON', 'LOHEAC', 'PIPRIAC', 'ST GANTON', 'ST JUST', 'SIXT SUR AFF'],
  35170: ['BRUZ'],
  35260: ['CANCALE'],
  35510: ['CESSON SEVIGNE'],
  35135: ['CHANTEPIE'],
  35630: [
    'LA CHAPELLE CHAUSSEE',
    'HEDE BAZOUGES',
    'LES IFFS',
    'LANGOUET',
    'ST BRIEUC DES IFFS',
    'ST GONDRAN',
    'ST SYMPHORIEN',
    'VIGNOC',
  ],
  35520: ['LA CHAPELLE DES FOUGERETZ', 'MELESSE', 'LA MEZIERE', 'MONTREUIL LE GAST'],
  35140: [
    'LA CHAPELLE ST AUBERT',
    'GOSNE',
    'MEZIERES SUR COUESNON',
    'ST AUBIN DU CORMIER',
    'ST CHRISTOPHE DE VALAINS',
    'ST HILAIRE DES LANDES',
    'RIVES DU COUESNON',
    'ST OUEN DES ALLEUX',
  ],
  35660: ['LA CHAPELLE DE BRAIN', 'LANGON', 'RENAC'],
  35590: ['LA CHAPELLE THOUARAULT', 'CLAYES', 'L HERMITAGE', 'ST GILLES'],
  35131: ['CHARTRES DE BRETAGNE', 'PONT PEAN'],
  35220: ['CHATEAUBOURG', 'MARPIRE', 'ST DIDIER', 'ST JEAN SUR VILAINE'],
  35410: ['CHATEAUGIRON', 'DOMLOUP', 'NOUVOITOU'],
  35430: [
    'CHATEAUNEUF D ILLE ET VILAINE',
    'ST GUINOUX',
    'ST JOUAN DES GUERETS',
    'ST PERE MARC EN POULET',
    'ST SULIAC',
    'LA VILLE ES NONAIS',
  ],
  35210: [
    'CHATILLON EN VENDELAIS',
    'COMBOURTILLE',
    'LUITRE DOMPIERRE',
    'MONTAUTOUR',
    'MONTREUIL DES LANDES',
    'PARCE',
    'PRINCE',
    'ST CHRISTOPHE DES BOIS',
  ],
  35490: ['CHAUVIGNE', 'GAHARD', 'ROMAZY', 'SENS DE BRETAGNE', 'VIEUX VY SUR COUESNON'],
  35640: ['CHELUN', 'EANCE', 'FORGES LA FORET', 'MARTIGNE FERCHAUD'],
  35134: ['COESMES', 'STE COLOMBE', 'THOURIE'],
  35290: ['LE CROUAIS', 'GAEL', 'MUEL', 'QUEDILLAC', 'ST MEEN LE GRAND', 'ST ONEN LA CHAPELLE'],
  35800: ['DINARD', 'ST BRIAC SUR MER', 'ST LUNAIRE'],
  35440: ['DINGE', 'FEINS', 'GUIPEL', 'MONTREUIL SUR ILLE'],
  35113: ['DOMAGNE'],
  35390: ['LA DOMINELAIS', 'GRAND FOUGERAY', 'STE ANNE SUR VILAINE', 'ST SULPICE DES LANDES'],
  35450: ['DOURDAIN', 'LANDAVRAN', 'LIVRE SUR CHANGEON', 'MECE', 'VAL D IZE'],
  35620: ['ERCE EN LAMEE', 'TEILLAY'],
  35300: ['FOUGERES'],
  35111: ['LA FRESNAIS', 'LILLEMER'],
  35850: ['GEVEZE', 'IRODOUER', 'LANGAN', 'PARTHENAY DE BRETAGNE', 'ROMILLE'],
  35350: ['LA GOUESNIERE', 'ST COULOMB', 'ST MELOIR DES ONDES'],
  35240: ['MARCILLE ROBERT', 'RETIERS', 'LE THEIL DE BRETAGNE'],
  35380: ['MAXENT', 'PAIMPONT', 'PLELAN LE GRAND', 'ST PERAN', 'TREFFENDEL'],
  35480: ['GUIPRY MESSAC', 'ST MALO DE PHILY'],
  35540: ['MINIAC MORVAN', 'PLERGUER', 'LE TRONCHET'],
  35870: ['LE MINIHIC SUR RANCE'],
  35760: ['MONTGERMONT', 'ST GREGOIRE'],
  35740: ['PACE'],
  35610: [
    'PLEINE FOUGERES',
    'ROZ SUR COUESNON',
    'SAINS',
    'ST GEORGES DE GREHAIGNE',
    'SOUGEAL',
    'TRANS LA FORET',
    'VIEUX VIEL',
  ],
  35720: ['PLESDER', 'PLEUGUENEUC', 'MESNIL ROC H'],
  35730: ['PLEURTUIT'],
  35000: ['RENNES'],
  35200: ['RENNES'],
  35700: ['RENNES'],
  35650: ['LE RHEU'],
  35780: ['LA RICHARDAIS'],
  35114: ['ST BENOIT DES ONDES'],
  35136: ['ST JACQUES DE LA LANDE'],
  35400: ['ST MALO'],
  35235: ['THORIGNE FOUILLARD'],
  35770: ['VERN SUR SEICHE'],
  35132: ['VEZIN LE COQUET'],
  35960: ['LE VIVIER SUR MER'],
  36140: [
    'AIGURANDE',
    'LA BUXERETTE',
    'CREVANT',
    'CROZON SUR VAUVRE',
    'LOURDOUEIX ST MICHEL',
    'MONTCHEVRIER',
  ],
  36150: [
    'AIZE',
    'BUXEUIL',
    'LA CHAPELLE ST LAURIAN',
    'FONTENAY',
    'GIROUX',
    'GUILLY',
    'LINIEZ',
    'LUCAY LE LIBRE',
    'MENETREOLS SOUS VATAN',
    'MEUNET SUR VATAN',
    'REBOURSIN',
    'ST FLORENTIN',
    'VATAN',
  ],
  36120: [
    'AMBRAULT',
    'ARDENTES',
    'BOMMIERS',
    'ETRECHET',
    'JEU LES BOIS',
    'MARON',
    'PRUNIERS',
    'ST AOUT',
    'SASSIERGES ST GERMAIN',
  ],
  36210: [
    'ANJOUIN',
    'BAGNEUX',
    'CHABRIS',
    'DUN LE POELIER',
    'MENETOU SUR NAHON',
    'ORVILLE',
    'POULAINES',
    'ST CHRISTOPHE EN BAZELLE',
    'SEMBLECAY',
    'VAL FOUZON',
  ],
  36200: [
    'ARGENTON SUR CREUSE',
    'BOUESSE',
    'CEAULMONT',
    'CELON',
    'CHAVIN',
    'LE MENOUX',
    'MOSNAY',
    'LE PECHEREAU',
    'BADECON LE PIN',
    'ST MARCEL',
    'TENDU',
  ],
  36500: [
    'ARGY',
    'BUZANCAIS',
    'LA CHAPELLE ORTHEMALE',
    'CHEZELLES',
    'MEOBECQ',
    'NEUILLAY LES BOIS',
    'PALLUAU SUR INDRE',
    'STE GEMME',
    'ST GENOU',
    'ST LACTENCIN',
    'SOUGE',
    'VENDOEUVRES',
    'VILLEGOUIN',
  ],
  36700: [
    'ARPHEUILLES',
    'CHATILLON SUR INDRE',
    'CLERE DU BOIS',
    'CLION',
    'FLERE LA RIVIERE',
    'MURS',
    'ST CYRAN DU JAMBOT',
    'ST MEDARD',
    'LE TRANGER',
  ],
  36330: ['ARTHON', 'LE POINCONNET', 'VELLES'],
  36290: [
    'AZAY LE FERRON',
    'MEZIERES EN BRENNE',
    'OBTERRE',
    'PAULNAY',
    'ST MICHEL EN BRENNE',
    'SAULNAY',
    'VILLIERS',
  ],
  36270: ['BARAIZE', 'BAZAIGES', 'EGUZON CHANTOME'],
  36110: [
    'BAUDRES',
    'BOUGES LE CHATEAU',
    'BRETAGNE',
    'BRION',
    'FRANCILLON',
    'LEVROUX',
    'MOULINS SUR CEPHONS',
    'ROUVRES LES BOIS',
    'VILLEGONGIS',
    'VINEUIL',
  ],
  36310: ['BEAULIEU', 'BONNEUIL', 'CHAILLAC', 'DUNET', 'TILLY'],
  36370: ['BELABRE', 'CHALAIS', 'LIGNAC', 'MAUVIERES', 'PRISSAC', 'ST HILAIRE SUR BENAIZE'],
  36400: [
    'LA BERTHENOUX',
    'BRIANTES',
    'CHASSIGNOLLES',
    'LA CHATRE',
    'LACS',
    'LOUROUER ST LAURENT',
    'LE MAGNY',
    'MONTGIVRAY',
    'MONTLEVICQ',
    'NERET',
    'NOHANT VIC',
    'ST CHARTIER',
    'ST CHRISTOPHE EN BOUCHERIE',
    'THEVET ST JULIEN',
    'VERNEUIL SUR IGNERAIE',
    'VICQ EXEMPLET',
  ],
  36300: [
    'LE BLANC',
    'CIRON',
    'CONCREMIERS',
    'DOUADIC',
    'INGRANDES',
    'POULIGNY ST PIERRE',
    'ROSNAY',
    'RUFFEC',
    'ST AIGNY',
  ],
  36100: [
    'LES BORDES',
    'BRIVES',
    'LA CHAMPENOISE',
    'CHOUDAY',
    'CONDE',
    'ISSOUDUN',
    'LIZERAY',
    'MEUNET PLANCHES',
    'NEUVY PAILLOUX',
    'ST AOUSTRILLE',
    'ST AUBIN',
    'STE FAUSTE',
    'ST GEORGES SUR ARNON',
    'ST VALENTIN',
    'SEGRY',
    'THIZAY',
    'VOUILLON',
  ],
  36230: [
    'BUXIERES D AILLAC',
    'FOUGEROLLES',
    'GOURNAY',
    'LYS ST GEORGES',
    'MERS SUR INDRE',
    'MONTIPOURET',
    'NEUVY ST SEPULCHRE',
    'ST DENIS DE JOUHET',
    'SARZAY',
    'TRANZAULT',
  ],
  36160: [
    'CHAMPILLET',
    'FEUSINES',
    'LIGNEROLLES',
    'LA MOTTE FEUILLY',
    'PERASSAY',
    'POULIGNY NOTRE DAME',
    'POULIGNY ST MARTIN',
    'STE SEVERE SUR INDRE',
    'SAZERAY',
    'URCIERS',
    'VIGOULANT',
    'VIJON',
  ],
  36800: [
    'CHASSENEUIL',
    'CHITRAY',
    'LUZERET',
    'MIGNE',
    'NURET LE FERRON',
    'OULCHES',
    'LE PONT CHRETIEN CHABENET',
    'RIVARENNES',
    'ST GAULTIER',
    'THENAY',
  ],
  36000: ['CHATEAUROUX'],
  36170: [
    'LA CHATRE LANGLIN',
    'CHAZELET',
    'MOUHET',
    'PARNAC',
    'ROUSSINES',
    'SACIERGES ST MARTIN',
    'ST BENOIT DU SAULT',
    'ST CIVRAN',
    'ST GILLES',
    'VIGOUX',
  ],
  36340: ['CLUIS', 'MAILLET', 'MALICORNAY', 'MOUHERS'],
  36130: ['COINGS', 'DEOLS', 'DIORS', 'MONTIERCHAUME'],
  36190: ['CUZION', 'GARGILESSE DAMPIERRE', 'ORSENNES', 'POMMIERS', 'ST PLANTAIRE'],
  36260: ['DIOU', 'MIGNY', 'PAUDY', 'REUILLY', 'STE LIZAIGNE', 'ST PIERRE DE JARDS'],
  36240: ['ECUEILLE', 'GEHEE', 'JEU MALOCHES', 'PREAUX'],
  36220: [
    'FONTGOMBAULT',
    'LINGE',
    'LURAIS',
    'LUREUIL',
    'MARTIZAY',
    'MERIGNY',
    'NEONS SUR CREUSE',
    'PREUILLY LA VILLE',
    'SAUZELLES',
    'TOURNON ST MARTIN',
  ],
  36600: [
    'FONTGUENAND',
    'LANGE',
    'LYE',
    'VALENCAY',
    'LA VERNELLE',
    'VEUIL',
    'VICQ SUR NAHON',
    'VILLENTROIS FAVEROLLES EN BERRY',
  ],
  36180: ['FREDILLE', 'HEUGNES', 'PELLEVOISIN', 'SELLES SUR NAHON'],
  36350: ['LUANT', 'LA PEROUILLE'],
  36360: ['LUCAY LE MALE', 'VILLENTROIS FAVEROLLES EN BERRY'],
  36250: ['NIHERNE', 'ST MAUR'],
  36320: ['VILLEDIEU SUR INDRE'],
  37160: [
    'ABILLY',
    'LA CELLE ST AVANT',
    'CIVRAY SUR ESVES',
    'DESCARTES',
    'MARCE SUR ESVES',
    'NEUILLY LE BRIGNON',
    'BUXEUIL',
  ],
  37340: [
    'AMBILLOU',
    'AVRILLE LES PONCEAUX',
    'CLERE LES PINS',
    'CONTINVOIR',
    'GIZEUX',
    'HOMMES',
    'RILLE',
    'SAVIGNE SUR LATHAN',
  ],
  37400: ['AMBOISE', 'LUSSAULT SUR LOIRE'],
  37500: [
    'ANCHE',
    'CANDES ST MARTIN',
    'CHINON',
    'CINAIS',
    'COUZIERS',
    'CRAVANT LES COTEAUX',
    'LERNE',
    'LIGRE',
    'MARCAY',
    'RIVIERE',
    'LA ROCHE CLERMAULT',
    'ST BENOIT LA FORET',
    'ST GERMAIN SUR VIENNE',
    'SEUILLY',
    'THIZAY',
  ],
  37800: [
    'ANTOGNY LE TILLAC',
    'DRACHE',
    'MAILLE',
    'MARCILLY SUR VIENNE',
    'NOUATRE',
    'NOYANT DE TOURAINE',
    'PORTS SUR VIENNE',
    'POUZAY',
    'PUSSIGNY',
    'STE CATHERINE DE FIERBOIS',
    'ST EPAIN',
    'STE MAURE DE TOURAINE',
    'SEPMES',
  ],
  37260: ['ARTANNES SUR INDRE', 'MONTS', 'PONT DE RUAN', 'THILOUZE', 'VILLEPERDUE'],
  37120: [
    'ASSAY',
    'BRASLOU',
    'BRAYE SOUS FAYE',
    'CHAMPIGNY SUR VEUDE',
    'CHAVEIGNES',
    'COURCOUE',
    'FAYE LA VINEUSE',
    'JAULNAY',
    'LEMERE',
    'LUZE',
    'MARIGNY MARMANDE',
    'RAZINES',
    'RICHELIEU',
    'LA TOUR ST GELIN',
    'VERNEUIL LE CHATEAU',
  ],
  37270: [
    'ATHEE SUR CHER',
    'AZAY SUR CHER',
    'LARCAY',
    'MONTLOUIS SUR LOIRE',
    'ST MARTIN LE BEAU',
    'VERETZ',
  ],
  37110: [
    'AUTRECHE',
    'AUZOUER EN TOURAINE',
    'LE BOULAY',
    'CHATEAU RENAULT',
    'DAME MARIE LES BOIS',
    'LA FERRIERE',
    'LES HERMITES',
    'MONTHODON',
    'MORAND',
    'NEUVILLE SUR BRENNE',
    'ST NICOLAS DES MOTETS',
    'SAUNAY',
    'VILLEDOMER',
  ],
  37420: ['AVOINE', 'BEAUMONT EN VERON', 'HUISMES', 'RIGNY USSE', 'SAVIGNY EN VERON'],
  37220: [
    'AVON LES ROCHES',
    'BRIZAY',
    'CHEZELLES',
    'CRISSAY SUR MANSE',
    'CROUZILLES',
    'L ILE BOUCHARD',
    'PANZOULT',
    'PARCAY SUR VIENNE',
    'RILLY SUR VIENNE',
    'SAZILLY',
    'TAVANT',
    'THENEUIL',
    'TROGUES',
  ],
  37190: [
    'AZAY LE RIDEAU',
    'CHEILLE',
    'DRUYE',
    'NEUIL',
    'RIVARENNES',
    'SACHE',
    'VALLERES',
    'VILLAINES LES ROCHERS',
  ],
  37310: [
    'AZAY SUR INDRE',
    'CHAMBOURG SUR INDRE',
    'CHEDIGNY',
    'CIGOGNE',
    'COURCAY',
    'DOLUS LE SEC',
    'REIGNAC SUR INDRE',
    'ST QUENTIN SUR INDROIS',
    'SUBLAINES',
    'TAUXIGNY ST BAULD',
  ],
  37510: ['BALLAN MIRE', 'BERTHENAY', 'ST GENOUPH', 'SAVONNIERES', 'VILLANDRY'],
  37350: [
    'BARROU',
    'LA CELLE GUENAND',
    'CHAUMUSSAY',
    'FERRIERE LARCON',
    'LE GRAND PRESSIGNY',
    'LA GUERCHE',
    'PAULMY',
    'LE PETIT PRESSIGNY',
  ],
  37600: [
    'BEAULIEU LES LOCHES',
    'BETZ LE CHATEAU',
    'BRIDORE',
    'CHANCEAUX PRES LOCHES',
    'FERRIERE SUR BEAULIEU',
    'LOCHES',
    'MOUZAY',
    'PERRUSSON',
    'ST FLOVIER',
    'ST HIPPOLYTE',
    'ST JEAN ST GERMAIN',
    'ST SENOCH',
    'SENNEVIERES',
    'VARENNES',
    'VERNEUIL SUR INDRE',
  ],
  37360: [
    'BEAUMONT LOUESTAULT',
    'NEUILLE PONT PIERRE',
    'ROUZIERS DE TOURAINE',
    'ST ANTOINE DU ROCHER',
    'SEMBLANCAY',
    'SONZAY',
  ],
  37370: [
    'BEAUMONT LOUESTAULT',
    'BUEIL EN TOURAINE',
    'CHEMILLE SUR DEME',
    'EPEIGNE SUR DEME',
    'MARRAY',
    'NEUVY LE ROI',
    'ST AUBIN LE DEPEINT',
    'ST CHRISTOPHE SUR LE NAIS',
    'ST PATERNE RACAN',
    'VILLEBOURG',
  ],
  37460: [
    'BEAUMONT VILLAGE',
    'CERE LA RONDE',
    'CHEMILLE SUR INDROIS',
    'GENILLE',
    'LE LIEGE',
    'LOCHE SUR INDROIS',
    'MONTRESOR',
    'NOUANS LES FONTAINES',
    'ORBIGNY',
    'VILLEDOMAIN',
    'VILLELOIN COULANGE',
  ],
  37140: [
    'BENAIS',
    'BOURGUEIL',
    'LA CHAPELLE SUR LOIRE',
    'CHOUZE SUR LOIRE',
    'RESTIGNE',
    'ST NICOLAS DE BOURGUEIL',
    'COTEAUX SUR LOIRE',
  ],
  37150: [
    'BLERE',
    'CHENONCEAUX',
    'CHISSEAUX',
    'CIVRAY DE TOURAINE',
    'LA CROIX EN TOURAINE',
    'DIERRE',
    'EPEIGNE LES BOIS',
    'FRANCUEIL',
    'LUZILLE',
  ],
  37290: [
    'BOSSAY SUR CLAISE',
    'BOUSSAY',
    'CHAMBON',
    'CHARNIZAY',
    'PREUILLY SUR CLAISE',
    'TOURNON ST PIERRE',
    'YZEURES SUR CREUSE',
  ],
  37240: [
    'BOSSEE',
    'BOURNAN',
    'LA CHAPELLE BLANCHE ST MARTIN',
    'CIRAN',
    'CUSSAY',
    'ESVES LE MOUTIER',
    'LIGUEIL',
    'LE LOUROUX',
    'MANTHELAN',
    'VOU',
  ],
  37330: [
    'BRAYE SUR MAULNE',
    'BRECHES',
    'CHANNAY SUR LATHAN',
    'CHATEAU LA VALLIERE',
    'COUESMES',
    'COURCELLES DE TOURAINE',
    'LUBLE',
    'MARCILLY SUR MAULNE',
    'ST LAURENT DE LIN',
    'SOUVIGNE',
    'VILLIERS AU BOUIN',
  ],
  37130: [
    'BREHEMONT',
    'LA CHAPELLE AUX NAUX',
    'CINQ MARS LA PILE',
    'LANGEAIS',
    'LIGNIERES DE TOURAINE',
    'MAZIERES DE TOURAINE',
    'COTEAUX SUR LOIRE',
  ],
  37530: [
    'CANGEY',
    'CHARGE',
    'LIMERAY',
    'MONTREUIL EN TOURAINE',
    'MOSNES',
    'NAZELLES NEGRON',
    'POCE SUR CISSE',
    'ST OUEN LES VIGNES',
    'ST REGLE',
    'SOUVIGNY DE TOURAINE',
  ],
  37390: [
    'CERELLES',
    'CHANCEAUX SUR CHOISILLE',
    'CHARENTILLY',
    'LA MEMBROLLE SUR CHOISILLE',
    'METTRAY',
    'NOTRE DAME D OE',
    'ST ROCH',
  ],
  37170: ['CHAMBRAY LES TOURS'],
  37210: ['CHANCAY', 'NOIZAY', 'PARCAY MESLAY', 'ROCHECORBON', 'VERNOU SUR BRENNE', 'VOUVRAY'],
  37320: ['CORMERY', 'ESVRES', 'LOUANS', 'ST BRANCHS', 'TRUYES'],
  37380: [
    'CROTELLES',
    'MONNAIE',
    'NEUILLE LE LIERRE',
    'NOUZILLY',
    'REUGNY',
    'ST LAURENT EN GATINES',
  ],
  37230: ['FONDETTES', 'LUYNES', 'PERNAY', 'ST ETIENNE DE CHIGNY'],
  37300: ['JOUE LES TOURS'],
  37250: ['MONTBAZON', 'SORIGNY', 'VEIGNE'],
  37520: ['LA RICHE'],
  37550: ['ST AVERTIN'],
  37540: ['ST CYR SUR LOIRE'],
  37700: ['ST PIERRE DES CORPS', 'LA VILLE AUX DAMES'],
  37000: ['TOURS'],
  37100: ['TOURS'],
  37200: ['TOURS'],
  38490: [
    'LES ABRETS EN DAUPHINE',
    'AOSTE',
    'CHARANCIEU',
    'CHIMILIN',
    'GRANIEU',
    'LE PASSAGE',
    'ST ANDRE LE GAZ',
    'ST ONDRAS',
  ],
  38190: [
    'LES ADRETS',
    'BERNIN',
    'LE CHAMP PRES FROGES',
    'LA COMBE DE LANCEY',
    'FROGES',
    'LAVAL EN BELLEDONNE',
    'STE AGNES',
    'ST MURY MONTEYMOND',
    'VILLARD BONNOT',
  ],
  38150: [
    'AGNIN',
    'ANJOU',
    'ASSIEU',
    'BOUGE CHAMBALUD',
    'CHANAS',
    'LA CHAPELLE DE SURIEU',
    'ROUSSILLON',
    'ST ROMAIN DE SURIEU',
    'SALAISE SUR SANNE',
    'SONNAY',
    'VERNIOZ',
    'VILLE SOUS ANJOU',
  ],
  38470: [
    'L ALBENC',
    'BEAULIEU',
    'CHANTESSE',
    'CHASSELAY',
    'COGNIN LES GORGES',
    'MALLEVAL EN VERCORS',
    'SERRE NERPOL',
    'NOTRE DAME DE L OSIER',
    'QUINCIEU',
    'ROVON',
    'ST GERVAIS',
    'TECHE',
    'VARACIEUX',
    'VATILIEU',
    'VINAY',
  ],
  38114: ['ALLEMOND', 'OZ', 'VAUJANY', 'VILLARD RECULAS'],
  38580: ['ALLEVARD', 'LA CHAPELLE DU BARD', 'LE HAUT BREDA', 'LE MOUTARET'],
  38970: [
    'AMBEL',
    'BEAUFIN',
    'CORPS',
    'LES COTES DE CORPS',
    'MONESTIER D AMBEL',
    'PELLAFOL',
    'QUET EN BEAUMONT',
    'STE LUCE',
    'LA SALETTE FALLAVAUX',
  ],
  38460: [
    'ANNOISIN CHATELANS',
    'CHAMAGNIEU',
    'CHOZEAU',
    'CREMIEU',
    'DIZIMIEU',
    'LEYRIEU',
    'MORAS',
    'OPTEVOZ',
    'PANOSSAS',
    'ST HILAIRE DE BRENS',
    'ST ROMAIN DE JALIONAS',
    'SICCIEU ST JULIEN ET CARISIEU',
    'SOLEYMIEU',
    'TREPT',
    'VENERIEU',
    'VERNAS',
    'VEYSSILIEU',
    'VILLEMOIRIEU',
  ],
  38280: ['ANTHON', 'JANNEYRIAS', 'VILLETTE D ANTHON'],
  38140: [
    'APPRIEU',
    'BEAUCROISSANT',
    'CHARNECLES',
    'IZEAUX',
    'LA MURETTE',
    'REAUMONT',
    'RENAGE',
    'RIVES',
    'ST BLAISE DU BUIS',
    'ST PAUL D IZEAUX',
  ],
  38440: [
    'ARTAS',
    'BEAUVOIR DE MARC',
    'CHATONNAY',
    'LIEUDIEU',
    'MEYRIEU LES ETANGS',
    'MEYSSIEZ',
    'MOIDIEU DETOURBE',
    'ROYAS',
    'STE ANNE SUR GERVONDE',
    'ST JEAN DE BOURNAY',
    'SAVAS MEPIN',
    'VILLENEUVE DE MARC',
  ],
  38680: [
    'AUBERIVES EN ROYANS',
    'CHATELUS',
    'CHORANCHE',
    'PONT EN ROYANS',
    'PRESLES',
    'RENCUREL',
    'ST ANDRE EN ROYANS',
    'ST JUST DE CLAIX',
  ],
  38550: [
    'AUBERIVES SUR VAREZE',
    'CHEYSSIEU',
    'CLONAS SUR VAREZE',
    'LE PEAGE DE ROUSSILLON',
    'SABLONS',
    'ST MAURICE L EXIL',
  ],
  38142: ['AURIS', 'BESSE', 'CLAVANS EN HAUT OISANS', 'LE FRENEY D OISANS', 'MIZOEN'],
  38630: ['LES AVENIERES VEYRINS THUELLIN', 'CORBELIN'],
  38650: [
    'AVIGNONET',
    'CHATEAU BERNARD',
    'ST MARTIN DE LA CLUZE',
    'GRESSE EN VERCORS',
    'MONESTIER DE CLERMONT',
    'ROISSARD',
    'ST ANDEOL',
    'ST GUILLAUME',
    'ST MICHEL LES PORTES',
    'ST PAUL LES MONESTIER',
    'SINARD',
    'TREFFORT',
  ],
  38390: [
    'LA BALME LES GROTTES',
    'BOUVESSE QUIRIEU',
    'CHARETTE',
    'MONTALIEU VERCIEU',
    'PARMILIEU',
    'PORCIEU AMBLAGNIEU',
    'VERTRIEU',
  ],
  38530: ['BARRAUX', 'LA BUISSIERE', 'CHAPAREILLAN', 'LA FLACHERE', 'PONTCHARRA', 'ST MAXIMIN'],
  38110: [
    'LA BATIE MONTGASCON',
    'CESSIEU',
    'LA CHAPELLE DE LA TOUR',
    'DOLOMIEU',
    'FAVERGES DE LA TOUR',
    'MONTAGNIEU',
    'ROCHETOIRIN',
    'STE BLANDINE',
    'ST CLAIR DE LA TOUR',
    'ST DIDIER DE LA TOUR',
    'ST JEAN DE SOUDAIN',
    'ST VICTOR DE CESSIEU',
    'LA TOUR DU PIN',
  ],
  38270: [
    'BEAUFORT',
    'BEAUREPAIRE',
    'BELLEGARDE POUSSIEU',
    'JARCIEU',
    'LENTIOL',
    'MARCOLLIN',
    'MOISSIEU SUR DOLON',
    'PACT',
    'PISIEU',
    'PRIMARETTE',
    'REVEL TOURDAN',
    'ST BARTHELEMY',
  ],
  38160: [
    'BEAUVOIR EN ROYANS',
    'BESSINS',
    'CHATTE',
    'CHEVRIERES',
    'IZERON',
    'MONTAGNE',
    'MURINAIS',
    'ST ANTOINE L ABBAYE',
    'ST APPOLINARD',
    'ST MARCELLIN',
    'ST PIERRE DE CHERENNES',
    'ST ROMANS',
    'ST SAUVEUR',
    'ST VERAND',
  ],
  38690: [
    'BELMONT',
    'BEVENAIS',
    'BIOL',
    'BIZONNES',
    'BURCIN',
    'CHABONS',
    'COLOMBE',
    'EYDOCHE',
    'FLACHERES',
    'LE GRAND LEMPS',
    'LONGECHENAL',
    'MONTREVEL',
    'OYEU',
    'ST DIDIER DE BIZONNES',
    'TORCHEFELON',
  ],
  38850: ['BILIEU', 'CHARAVINES', 'CHIRENS', 'VILLAGES DU LAC DE PALADRU'],
  38330: ['BIVIERS', 'MONTBONNOT ST MARTIN', 'ST ISMIER', 'ST NAZAIRE LES EYMES'],
  38730: [
    'BLANDIN',
    'CHASSIGNIEU',
    'CHELIEU',
    'DOISSIN',
    'VILLAGES DU LAC DE PALADRU',
    'VALENCOGNE',
    'VAL DE VIRIEU',
  ],
  38090: ['BONNEFAMILLE', 'ROCHE', 'VAULX MILIEU', 'VILLEFONTAINE'],
  38260: [
    'BOSSIEU',
    'CHAMPIER',
    'LA COTE ST ANDRE',
    'FARAMANS',
    'LA FRETTE',
    'GILLONNAY',
    'MARCILLOLES',
    'MOTTIER',
    'ORNACIEUX BALBINS',
    'PAJAY',
    'PENOL',
    'POMMIER DE BEAUREPAIRE',
    'ST HILAIRE DE LA COTE',
    'SARDIEU',
    'PORTE DES BONNEVAUX',
    'THODURE',
  ],
  38510: [
    'LE BOUCHAGE',
    'BRANGUES',
    'COURTENAY',
    'CREYS MEPIEU',
    'MORESTEL',
    'ARANDON PASSINS',
    'ST SORLIN DE MORESTEL',
    'ST VICTOR DE MORESTEL',
    'SERMERIEU',
    'VEZERONCE CURTIN',
  ],
  38520: [
    'LE BOURG D OISANS',
    'LA GARDE',
    'LES DEUX ALPES',
    'ORNON',
    'OULLES',
    'ST CHRISTOPHE EN OISANS',
    'VILLARD NOTRE DAME',
    'VILLARD REYMOND',
  ],
  38300: [
    'BOURGOIN JALLIEU',
    'CHATEAUVILAIN',
    'CHEZENEUVE',
    'CRACHIER',
    'CULIN',
    'DOMARIN',
    'ECLOSE BADINIERES',
    'LES EPARRES',
    'MAUBEC',
    'MEYRIE',
    'NIVOLAS VERMELLE',
    'RUY MONTCEAU',
    'ST AGNIN SUR BION',
    'ST SAVIN',
    'SEREZIN DE LA TOUR',
    'SUCCIEU',
    'TRAMOLE',
  ],
  38870: ['BRESSIEUX', 'ST PIERRE DE BRESSIEUX', 'ST SIMEON DE BRESSIEUX'],
  38320: ['BRESSON', 'BRIE ET ANGONNES', 'EYBENS', 'HERBEYS', 'POISAT'],
  38590: [
    'BREZINS',
    'BRION',
    'LA FORTERESSE',
    'PLAN',
    'ST ETIENNE DE ST GEOIRS',
    'ST GEOIRS',
    'ST MICHEL DE ST GEOIRS',
    'SILLANS',
  ],
  38500: ['LA BUISSE', 'COUBLEVIE', 'ST CASSIEN', 'ST NICOLAS DE MACHERIN', 'VOIRON'],
  38122: ['CHALON', 'COUR ET BUIS', 'MONSTEROUX MILIEU', 'MONTSEVEROUX', 'ST JULIEN DE L HERMS'],
  38800: ['CHAMPAGNIER', 'LE PONT DE CLAIX'],
  38560: ['CHAMP SUR DRAC', 'JARRIE'],
  38740: ['CHANTEPERIER', 'ENTRAIGUES', 'VALBONNAIS', 'VALJOUFFREY'],
  38790: ['CHARANTONNAY', 'DIEMOZ', 'ST GEORGES D ESPERANCHE'],
  38230: ['CHARVIEU CHAVAGNEUX', 'CHAVANOZ', 'PONT DE CHERUY', 'TIGNIEU JAMEYZIEU'],
  38670: ['CHASSE SUR RHONE'],
  38980: ['CHATENAY', 'MARNANS', 'VIRIVILLE'],
  38570: [
    'LE CHEYLAS',
    'GONCELIN',
    'HURTIERES',
    'LA PIERRE',
    'CRETS EN BELLEDONNE',
    'TENCIN',
    'THEYS',
  ],
  38930: [
    'CHICHILIANNE',
    'CLELLES',
    'LALLEY',
    'MONESTIER DU PERCY',
    'LE PERCY',
    'ST MARTIN DE CLELLES',
    'ST MAURICE EN TRIEVES',
  ],
  38220: [
    'CHOLONGE',
    'LAFFREY',
    'LIVET ET GAVET',
    'MONTCHABOUD',
    'NOTRE DAME DE MESAGE',
    'ST BARTHELEMY DE SECHILIENNE',
    'ST JEAN DE VAULX',
    'ST PIERRE DE MESAGE',
    'SECHILIENNE',
    'VIZILLE',
  ],
  38121: ['CHONAS L AMBALLAN', 'REVENTIN VAUGRIS'],
  38200: [
    'CHUZELLES',
    'JARDIN',
    'LUZINAY',
    'ST SORLIN DE VIENNE',
    'SERPAIZE',
    'SEYSSUEL',
    'VIENNE',
    'VILLETTE DE VIENNE',
  ],
  38640: ['CLAIX'],
  38350: [
    'COGNET',
    'LAVALDENS',
    'MARCIEU',
    'MAYRES SAVEL',
    'LA MORTE',
    'LA MURE',
    'NANTES EN RATIER',
    'ORIS EN RATTIER',
    'PONSONNAS',
    'PRUNIERES',
    'ST AREY',
    'ST HONORE',
    'ST LAURENT EN BEAUMONT',
    'ST MICHEL EN BEAUMONT',
    'ST PIERRE DE MEAROZ',
    'LA SALLE EN BEAUMONT',
    'SIEVOZ',
    'SOUSVILLE',
    'SUSVILLE',
    'LA VALETTE',
  ],
  38700: ['CORENC', 'LE SAPPEY EN CHARTREUSE', 'SARCENAS', 'LA TRONCHE'],
  38710: [
    'CORNILLON EN TRIEVES',
    'LAVARS',
    'MENS',
    'PREBOIS',
    'ST BAUDILLE ET PIPET',
    'ST JEAN D HERANS',
    'CHATEL EN TRIEVES',
    'TREMINIS',
  ],
  38250: ['CORRENCON EN VERCORS', 'LANS EN VERCORS', 'ST NIZIER DU MOUCHEROTTE', 'VILLARD DE LANS'],
  38138: ['LES COTES D AREY'],
  38210: [
    'CRAS',
    'MONTAUD',
    'MORETTE',
    'POLIENAS',
    'LA RIVIERE',
    'ST QUENTIN SUR ISERE',
    'TULLINS',
    'VOUREY',
  ],
  38920: ['CROLLES'],
  38420: ['DOMENE', 'MURIANETTE', 'REVEL', 'ST JEAN LE VIEUX', 'LE VERSOUD'],
  38130: ['ECHIROLLES'],
  38360: ['ENGINS', 'NOYAREY', 'SASSENAGE'],
  38380: [
    'ENTRE DEUX GUIERS',
    'MIRIBEL LES ECHELLES',
    'ST CHRISTOPHE SUR GUIERS',
    'ST LAURENT DU PONT',
    'ST PIERRE DE CHARTREUSE',
    'ST PIERRE D ENTREMONT',
  ],
  38780: ['ESTRABLIN', 'EYZIN PINET', 'OYTIER ST OBLAS', 'PONT EVEQUE', 'SEPTEME'],
  38600: ['FONTAINE'],
  38120: ['FONTANIL CORNILLON', 'MONT ST MARTIN', 'PROVEYSIEUX', 'ST EGREVE'],
  38080: ['FOUR', 'L ISLE D ABEAU', 'ST ALBAN DE ROCHE', 'ST MARCEL BEL ACCUEIL'],
  38290: ['FRONTONAS', 'SATOLAS ET BONCE', 'LA VERPILLIERE'],
  38610: ['GIERES', 'VENON'],
  38540: ['GRENAY', 'HEYRIEUX', 'ST JUST CHALEYSSIN', 'VALENCIN'],
  38000: ['GRENOBLE'],
  38100: ['GRENOBLE'],
  38450: ['LE GUA', 'MIRIBEL LANCHATRE', 'NOTRE DAME DE COMMIERS', 'ST GEORGES DE COMMIERS', 'VIF'],
  38118: ['HIERES SUR AMBY', 'ST BAUDILLE DE LA TOUR'],
  38750: ['HUEZ'],
  38660: [
    'LUMBIN',
    'PLATEAU DES PETITES ROCHES',
    'STE MARIE D ALLOIX',
    'STE MARIE DU MONT',
    'ST VINCENT DE MERCUZE',
    'LA TERRASSE',
    'LE TOUVET',
  ],
  38620: [
    'MASSIEU',
    'MERLAS',
    'MONTFERRAT',
    'ST BUEIL',
    'ST GEOIRE EN VALDAINE',
    'ST SULPICE DES RIVOIRES',
    'VELANNE',
    'VOISSANT',
  ],
  38112: ['AUTRANS MEAUDRE EN VERCORS'],
  38880: ['AUTRANS MEAUDRE EN VERCORS'],
  38240: ['MEYLAN'],
  38430: ['MOIRANS', 'ST JEAN DE MOIRANS'],
  38890: ['MONTCARRA', 'ST CHEF', 'SALAGNON', 'VASSELIN', 'VIGNIEU'],
  38860: ['LES DEUX ALPES'],
  38770: ['MONTEYNARD', 'LA MOTTE D AVEILLANS', 'LA MOTTE ST MARTIN'],
  38940: ['MONTFALCON', 'ROYBON', 'ST CLAIR SUR GALAURE'],
  38144: ['NOTRE DAME DE VAULX'],
  38119: ['PIERRE CHATEL', 'ST THEOFFREY', 'VILLARD ST CHRISTOPHE'],
  38480: [
    'LE PONT DE BEAUVOISIN',
    'PRESSINS',
    'ROMAGNIEU',
    'ST ALBIN DE VAULSERRE',
    'ST JEAN D AVELANNE',
    'ST MARTIN DE VAULSERRE',
  ],
  38950: ['QUAIX EN CHARTREUSE', 'ST MARTIN LE VINOUX'],
  38370: ['LES ROCHES DE CONDRIEU', 'ST ALBAN DU RHONE', 'ST CLAIR DU RHONE', 'ST PRIM'],
  38960: ['ST AUPRE', 'ST ETIENNE DE CROSSEY'],
  38840: ['ST BONNET DE CHAVAGNE', 'ST HILAIRE DU ROSIER', 'ST LATTIER', 'LA SONE'],
  38134: ['ST JOSEPH DE RIVIERE', 'LA SURE EN CHARTREUSE'],
  38340: ['LA SURE EN CHARTREUSE', 'VOREPPE'],
  38400: ['ST MARTIN D HERES'],
  38410: ['ST MARTIN D URIAGE', 'VAULNAVEYS LE BAS', 'VAULNAVEYS LE HAUT', 'CHAMROUSSE'],
  38760: ['ST PAUL DE VARCES', 'VARCES ALLIERES ET RISSET'],
  38830: ['CRETS EN BELLEDONNE'],
  38070: ['ST QUENTIN FALLAVIER'],
  38170: ['SEYSSINET PARISET'],
  38180: ['SEYSSINS'],
  38113: ['VEUREY VOROIZE'],
  39500: ['ABERGEMENT LA RONCE', 'CHAMPDIVERS', 'DAMPARIS', 'MOLAY', 'TAVAUX'],
  39600: [
    'ABERGEMENT LE GRAND',
    'ARBOIS',
    'LES ARSURES',
    'CHAMPAGNE SUR LOUE',
    'LA CHATELAINE',
    'CRAMANS',
    'ECLEUX',
    'LA FERTE',
    'GRANGE DE VAIVRE',
    'MATHENAY',
    'MESNAY',
    'MOLAMBOZ',
    'MONTIGNY LES ARSURES',
    'LES PLANCHES PRES ARBOIS',
    'PORT LESNEY',
    'PUPILLIN',
    'ST CYR MONTMALIN',
    'VADANS',
    'VILLENEUVE D AVAL',
    'VILLERS FARLAY',
    'VILLETTE LES ARBOIS',
  ],
  39800: [
    'ABERGEMENT LE PETIT',
    'AUMONT',
    'BARRETAINE',
    'BERSAILLIN',
    'BESAIN',
    'BIEFMORIN',
    'BONNEFONTAINE',
    'BRAINANS',
    'BUVILLY',
    'CHAMOLE',
    'CHAUSSENANS',
    'COLONNE',
    'FAY EN MONTAGNE',
    'LE FIED',
    'GROZON',
    'MIERY',
    'MOLAIN',
    'MONTHOLIER',
    'NEUVILLEY',
    'OUSSIERES',
    'PICARREAU',
    'PLASNE',
    'POLIGNY',
    'TOURMONT',
    'VAUX SUR POLIGNY',
    'VILLERSERINE',
    'VILLERS LES BOIS',
  ],
  39110: [
    'ABERGEMENT LES THESY',
    'AIGLEPIERRE',
    'ANDELOT EN MONTAGNE',
    'BRACON',
    'CERNANS',
    'LA CHAPELLE SUR FURIEUSE',
    'CHAUX CHAMPAGNY',
    'CHILLY SUR SALINS',
    'CLUCY',
    'DOURNON',
    'GERAISE',
    'IVORY',
    'IVREY',
    'LEMUY',
    'MARNOZ',
    'MONTMARLON',
    'PONT D HERY',
    'PRETIN',
    'ST THIEBAUD',
    'SAIZENAY',
    'SALINS LES BAINS',
    'THESY',
    'ARESCHES',
  ],
  39270: [
    'ALIEZE',
    'LA CHAILLEUSE',
    'AUGISEY',
    'BEFFIA',
    'CHAMBERIA',
    'CHAVERIA',
    'CRESSIA',
    'DOMPIERRE SUR MONT',
    'ECRILLE',
    'MARNEZIA',
    'MERONA',
    'MOUTONNE',
    'NANCUISE',
    'ONOZ',
    'ORGELET',
    'PIMORIN',
    'PLAISIA',
    'PRESILLY',
    'REITHOUSE',
    'ROTHONAY',
    'SARROGNA',
    'LA TOUR DU MEIX',
  ],
  39700: [
    'AMANGE',
    'AUDELANGE',
    'AUXANGE',
    'LA BARRE',
    'LA BRETENIERE',
    'CHATENOIS',
    'COURTEFONTAINE',
    'DAMPIERRE',
    'ECLANS NENON',
    'ETREPIGNEY',
    'EVANS',
    'FALLETANS',
    'FRAISANS',
    'LAVANGEOT',
    'LAVANS LES DOLE',
    'MALANGE',
    'MONTEPLAIN',
    'ORCHAMPS',
    'OUR',
    'PLUMONT',
    'RANCHOT',
    'RANS',
    'ROCHEFORT SUR NENON',
    'ROMANGE',
    'SALANS',
    'SERMANGE',
    'SERRE LES MOULIERES',
    'VRIANGE',
  ],
  39320: [
    'ANDELOT MORVAL',
    'BROISSIA',
    'VAL D EPY',
    'GIGNY',
    'GRAYE ET CHARNAY',
    'MONTLAINSIA',
    'LOISIA',
    'MONNETAY',
    'MONTFLEUR',
    'MONTREVEL',
    'VAL SURAN',
  ],
  39120: [
    'ANNOIRE',
    'ASNANS BEAUVOISIN',
    'BALAISEAUX',
    'BRETENIERES',
    'CHAINEE DES COUPIS',
    'CHAUSSIN',
    'CHEMIN',
    'CHENE BERNARD',
    'LE DESCHAUX',
    'LES ESSARDS TAIGNEVAUX',
    'GATEY',
    'LES HAYS',
    'LONGWY SUR LE DOUBS',
    'NEUBLANS ABERGEMENT',
    'PESEUX',
    'PETIT NOIR',
    'PLEURE',
    'RAHON',
    'ST BARAING',
    'ST LOUP',
    'SELIGNEY',
    'SERGENON',
    'TASSENIERES',
    'VILLERS LES BOIS',
    'VILLERS ROBERT',
  ],
  39290: [
    'ARCHELANGE',
    'BIARNE',
    'BRANS',
    'CHAMPAGNEY',
    'CHEVIGNY',
    'DAMMARTIN MARPAIN',
    'FRASNE LES MEULIERES',
    'GREDISANS',
    'MENOTEY',
    'MOISSEY',
    'MONTMIREY LA VILLE',
    'MONTMIREY LE CHATEAU',
    'MUTIGNEY',
    'OFFLANGES',
    'PEINTRE',
    'POINTRE',
    'RAINANS',
    'THERVAY',
  ],
  39300: [
    'ARDON',
    'BOURG DE SIROD',
    'CHAMPAGNOLE',
    'CHAPOIS',
    'CHATELNEUF',
    'CIZE',
    'CONTE',
    'CRANS',
    'CROTENAY',
    'EQUEVILLON',
    'LE LARDERET',
    'LE LATET',
    'LENT',
    'LOULLE',
    'MONNET LA VILLE',
    'MONTIGNY SUR L AIN',
    'MONTROND',
    'MONT SUR MONNET',
    'MOUTOUX',
    'LES NANS',
    'NEY',
    'LE PASQUIER',
    'PILLEMOINE',
    'PONT DU NAVOY',
    'ST GERMAIN EN MONTAGNE',
    'SAPOIS',
    'SIROD',
    'SUPT',
    'SYAM',
    'VALEMPOULIERES',
    'VANNOZ',
    'LE VAUDIOUX',
    'VERS EN MONTAGNE',
  ],
  39240: [
    'ARINTHOD',
    'AROMAS',
    'LA BOISSIERE',
    'CERNON',
    'CHARNOD',
    'ST HYMETIERE SUR VALOUSE',
    'CONDES',
    'CORNOD',
    'DRAMELAY',
    'GENOD',
    'VALZIN EN PETITE MONTAGNE',
    'MARIGNA SUR VALOUSE',
    'THOIRETTE COISIA',
    'VESCLES',
    'VOSBLES VALFIN',
  ],
  39140: [
    'ARLAY',
    'BLETTERANS',
    'CHAPELLE VOLAND',
    'COMMENAILLES',
    'COSGES',
    'DESNES',
    'FONTAINEBRUX',
    'LARNAUD',
    'NANCE',
    'RELANS',
    'LES REPOTS',
    'RUFFEY SUR SEILLE',
    'VILLEVIEUX',
  ],
  39210: [
    'ARLAY',
    'BAUME LES MESSIEURS',
    'BLOIS SUR SEILLE',
    'CHATEAU CHALON',
    'HAUTEROCHE',
    'DOMBLANS',
    'FRONTENAY',
    'LADOYE SUR SEILLE',
    'LAVIGNY',
    'LE LOUVEROT',
    'LA MARRE',
    'MENETRU LE VIGNOBLE',
    'MONTAIN',
    'NEVY SUR SEILLE',
    'LE PIN',
    'PLAINOISEAU',
    'PLASNE',
    'LE VERNOIS',
    'VOITEUR',
  ],
  39250: [
    'ARSURE ARSURETTE',
    'BIEF DU FOURG',
    'BILLECUL',
    'CENSEAU',
    'CERNIEBAUD',
    'CHARENCY',
    'CUVIER',
    'DOYE',
    'ESSERVAL TARTRE',
    'LA FAVIERE',
    'FRAROZ',
    'GILLOIS',
    'LA LATETTE',
    'LONGCOCHON',
    'MIEGES',
    'MIGNOVILLARD',
    'MOURNANS CHARBONNY',
    'NOZEROY',
    'ONGLIERES',
    'PLENISE',
    'PLENISETTE',
    'RIX',
  ],
  39570: [
    'LA CHAILLEUSE',
    'BAUME LES MESSIEURS',
    'BORNAY',
    'BRIOD',
    'CESANCEY',
    'CHILLE',
    'CHILLY LE VIGNOBLE',
    'CONDAMINE',
    'CONLIEGE',
    'COURBETTE',
    'COURBOUZON',
    'COURLANS',
    'COURLAOUX',
    'HAUTEROCHE',
    'L ETOILE',
    'FREBUANS',
    'GERUGE',
    'GEVINGEY',
    'MACORNAY',
    'MESSIA SUR SORNE',
    'MOIRON',
    'MONTAIGU',
    'MONTMOROT',
    'NOGNA',
    'PANNESSIERES',
    'PERRIGNY',
    'POIDS DE FIOLE',
    'PUBLY',
    'QUINTIGNY',
    'REVIGNY',
    'ST DIDIER',
    'ST MAUR',
    'TRENAL',
    'VERGES',
    'VERNANTOIS',
    'VEVY',
    'VILLENEUVE SOUS PYMONT',
  ],
  39190: [
    'AUGEA',
    'BEAUFORT ORBAGNA',
    'CHEVREAUX',
    'COUSANCE',
    'CUISIA',
    'DIGNA',
    'GIZIA',
    'MAYNAL',
    'ROSAY',
    'ROTALIER',
    'STE AGNES',
    'TRENAL',
    'VAL SONNETTE',
  ],
  39380: [
    'AUGERANS',
    'BANS',
    'BELMONT',
    'CHAMBLAY',
    'CHATELAY',
    'CHISSEY SUR LOUE',
    'GERMIGNEY',
    'LA LOYE',
    'MONTBARREY',
    'MONT SOUS VAUDREY',
    'NEVY LES DOLE',
    'OUNANS',
    'SANTANS',
    'SOUVANS',
    'VAUDREY',
    'LA VIEILLE LOYE',
  ],
  39410: ['AUMUR', 'ST AUBIN'],
  39100: [
    'AUTHUME',
    'BAVERANS',
    'BREVANS',
    'CHAMPVANS',
    'CHOISEY',
    'CRISSEY',
    'DOLE',
    'FOUCHERANS',
    'GEVRY',
    'JOUHE',
    'MONNIERES',
    'PARCEY',
    'SAMPANS',
    'VILLETTE LES DOLE',
  ],
  39200: [
    'AVIGNON LES ST CLAUDE',
    'NANCHEZ',
    'COISERETTE',
    'COYRIERE',
    'LA RIXOUSE',
    'ST CLAUDE',
    'VILLARD ST SAUVEUR',
  ],
  39160: [
    'BALANOD',
    'VAL D EPY',
    'MONTAGNA LE RECONDUIT',
    'LES TROIS CHATEAUX',
    'ST AMOUR',
    'THOISSIA',
    'VERIA',
  ],
  39130: [
    'BARESIA SUR L AIN',
    'BLYE',
    'BOISSIA',
    'BONLIEU',
    'CHARCIER',
    'CHAREZIER',
    'CHATEL DE JOUX',
    'CHATILLON',
    'CHEVROTAINE',
    'CLAIRVAUX LES LACS',
    'COGNA',
    'DENEZIERES',
    'DOUCIER',
    'ETIVAL',
    'FONTENU',
    'LA FRASNEE',
    'LE FRASNOIS',
    'HAUTECOUR',
    'LARGILLAY MARSONNAY',
    'MARIGNY',
    'MENETRUX EN JOUX',
    'MESNOIS',
    'PATORNAY',
    'PONT DE POITTE',
    'SAFFLOZ',
    'ST MAURICE CRILLAT',
    'SAUGEOT',
    'SONGESON',
    'SOUCIA',
    'THOIRIA',
    'UXELLES',
    'VERTAMBOZ',
  ],
  39310: ['BELLECOMBE', 'LAJOUX', 'LAMOURA', 'LES MOUSSIERES', 'SEPTMONCEL LES MOLUNES'],
  39400: ['BELLEFONTAINE', 'LONGCHAUMOIS', 'MORBIER', 'HAUTS DE BIENNE', 'PREMANON', 'LES ROUSSES'],
  39150: [
    'BIEF DES MAISONS',
    'LES CHALESMES',
    'LA CHAUMUSSE',
    'CHAUX DES CROTENAY',
    'NANCHEZ',
    'LA CHAUX DU DOMBIEF',
    'ENTRE DEUX MONTS',
    'FORT DU PLASNE',
    'GRANDE RIVIERE CHATEAU',
    'LAC DES ROUGES TRUITES',
    'LES PLANCHES EN MONTAGNE',
    'ST LAURENT EN GRANDVAUX',
    'ST PIERRE',
  ],
  39220: ['BOIS D AMONT', 'PREMANON', 'LES ROUSSES'],
  39230: [
    'BOIS DE GAND',
    'CHAMPROUGIER',
    'LA CHARME',
    'LA CHASSAGNE',
    'LE CHATELEY',
    'CHAUMERGY',
    'LA CHAUX EN BRESSE',
    'CHEMENOT',
    'CHENE SEC',
    'DARBONNAY',
    'LES DEUX FAYS',
    'DOMBLANS',
    'FOULENAY',
    'FRANCHEVILLE',
    'LOMBARD',
    'MANTRY',
    'MONAY',
    'PASSENANS',
    'RECANOZ',
    'RYE',
    'ST LAMAIN',
    'ST LOTHAIN',
    'SELLIERES',
    'SERGENAUX',
    'TOULOUSE LE CHATEAU',
    'VERS SOUS SELLIERES',
    'LE VILLEY',
    'VINCENT FROIDEVILLE',
  ],
  39370: ['LES BOUCHOUX', 'CHOUX', 'LA PESSE'],
  39260: [
    'CHARCHILLA',
    'COYRON',
    'CRENANS',
    'LES CROZETS',
    'LECT',
    'MAISOD',
    'MARTIGNA',
    'MEUSSIA',
    'MOIRANS EN MONTAGNE',
    'MONTCUSEL',
    'VILLARDS D HERIA',
  ],
  39350: [
    'DAMPIERRE',
    'GENDREY',
    'LOUVATANGE',
    'OUGNEY',
    'PAGNEY',
    'ROMAIN',
    'ROUFFANGE',
    'SALIGNEY',
    'TAXENNE',
    'VITREUX',
  ],
  39520: ['FONCINE LE BAS'],
  39460: ['FONCINE LE HAUT'],
  39360: [
    'JEURRE',
    'LARRIVOIRE',
    'CHASSAL MOLINGES',
    'ROGNA',
    'VAUX LES ST CLAUDE',
    'VIRY',
    'VULVOZ',
  ],
  39170: ['LAVANS LES ST CLAUDE', 'LESCHERES', 'RAVILLOLES', 'COTEAUX DU LIZON'],
  39000: ['LONS LE SAUNIER'],
  39330: ['MOUCHARD', 'PAGNOZ', 'PORT LESNEY'],
  40800: ['AIRE SUR L ADOUR', 'DUHORT BACHEN', 'LATRILLE', 'ST AGNET', 'SARRON'],
  40330: [
    'AMOU',
    'ARSAGUE',
    'BONNEGARDE',
    'BRASSEMPOUY',
    'CASTEL SARRAZIN',
    'GAUJACQ',
    'MARPAPS',
    'NASSIET',
  ],
  40990: [
    'ANGOUME',
    'GOURBERA',
    'HERM',
    'MEES',
    'ST PAUL LES DAX',
    'ST VINCENT DE PAUL',
    'TETHIEU',
  ],
  40150: ['ANGRESSE', 'SOORTS HOSSEGOR'],
  40320: [
    'ARBOUCAVE',
    'BAHUS SOUBIRAN',
    'BATS',
    'BUANES',
    'CASTELNAU TURSAN',
    'CLASSUN',
    'CLEDES',
    'EUGENIE LES BAINS',
    'GEAUNE',
    'LACAJUNTE',
    'LAURET',
    'MAURIES',
    'MIRAMONT SENSACQ',
    'PAYROS CAZAUTETS',
    'PECORADE',
    'PHILONDENX',
    'PIMBO',
    'PUYOL CAZALET',
    'ST LOUBOUER',
    'SAMADET',
    'SORBETS',
    'URGONS',
    'VIELLE TURSAN',
  ],
  40110: [
    'ARENGOSSE',
    'MORCENX LA NOUVELLE',
    'ONESSE LAHARIE',
    'OUSSE SUZAN',
    'VILLENAVE',
    'YGOS ST SATURNIN',
  ],
  40700: [
    'ARGELOS',
    'AUBAGNAN',
    'BASSERCLES',
    'BEYRIES',
    'CASTAIGNOS SOUSLENS',
    'CASTELNER',
    'CAZALIS',
    'DOAZIT',
    'HAGETMAU',
    'HORSARRIEU',
    'LABASTIDE CHALOSSE',
    'LACRABE',
    'MANT',
    'MOMUY',
    'MONGET',
    'MONSEGUR',
    'MORGANX',
    'PEYRE',
    'POUDENX',
    'STE COLOMBE',
    'ST CRICQ CHALOSSE',
    'SERRES GASTON',
    'SERRESLOUS ET ARRIBANS',
  ],
  40430: ['ARGELOUSE', 'CALLEN', 'LUXEY', 'SORE'],
  40090: [
    'ARTASSENX',
    'BASCONS',
    'BOSTENS',
    'BOUGUE',
    'CAMPAGNE',
    'CAMPET ET LAMOLERE',
    'CANENX ET REAUT',
    'CERE',
    'GAILLERES',
    'GELOUX',
    'LAGLORIEUSE',
    'LUCBARDEZ ET BARGUES',
    'MAZEROLLES',
    'ST AVIT',
    'ST MARTIN D ONEY',
    'ST PERDON',
    'UCHACQ ET PARENTIS',
  ],
  40190: [
    'ARTHEZ D ARMAGNAC',
    'BOURDALAT',
    'LE FRECHE',
    'HONTANX',
    'MONTEGUT',
    'PERQUIE',
    'PUJO LE PLAN',
    'ST CRICQ VILLENEUVE',
    'STE FOY',
    'ST GEIN',
    'VILLENEUVE DE MARSAN',
  ],
  40120: [
    'ARUE',
    'BELIS',
    'BOURRIOT BERGONCE',
    'CACHEN',
    'LACQUY',
    'LENCOUACQ',
    'RETJONS',
    'MAILLAS',
    'MAILLERES',
    'POUYDESSEAUX',
    'ROQUEFORT',
    'ST GOR',
    'SARBAZAN',
  ],
  40310: ['ARX', 'BAUDIGNAN', 'ESCALANS', 'GABARRET', 'HERRE', 'PARLEBOSCQ', 'RIMBEZ ET BAUDIETS'],
  40500: [
    'AUDIGNON',
    'AURICE',
    'BANOS',
    'BAS MAUCO',
    'CAUNA',
    'COUDURES',
    'DUMES',
    'EYRES MONCUBE',
    'FARGUES',
    'MONTAUT',
    'MONTGAILLARD',
    'MONTSOUE',
    'ST SEVER',
    'SARRAZIET',
  ],
  40400: [
    'AUDON',
    'BEGAAR',
    'CARCARES STE CROIX',
    'CARCEN PONSON',
    'GOUTS',
    'LESGOR',
    'MEILHAN',
    'ST YAGUEN',
    'TARTAS',
  ],
  40200: ['AUREILHAN', 'MIMIZAN', 'PONTENX LES FORGES', 'STE EULALIE EN BORN', 'ST PAUL EN BORN'],
  40140: ['AZUR', 'MAGESCQ', 'SOUSTONS'],
  40380: [
    'BAIGTS',
    'CASSEN',
    'GAMARDE LES BAINS',
    'GIBRET',
    'LOUER',
    'MONTFORT EN CHALOSSE',
    'NOUSSE',
    'ONARD',
    'OZOURT',
    'POYANNE',
    'POYARTIN',
    'ST GEOURS D AURIBAT',
    'ST JEAN DE LIER',
    'VICQ D AURIBAT',
  ],
  40360: ['BASTENNES', 'CASTELNAU CHALOSSE', 'DONZACQ', 'POMAREZ', 'TILH'],
  40410: ['BELHADE', 'LIPOSTHEY', 'MANO', 'MOUSTEY', 'PISSOS', 'SAUGNAC ET MURET'],
  40300: [
    'BELUS',
    'CAGNOTTE',
    'CAUNEILLE',
    'HASTINGUES',
    'LABATUT',
    'OEYREGAVE',
    'ORIST',
    'ORTHEVIELLE',
    'PEY',
    'PEYREHORADE',
    'PORT DE LANNE',
    'ST CRICQ DU GAVE',
    'ST ETIENNE D ORTHE',
    'ST LON LES MINES',
    'SORDE L ABBAYE',
  ],
  40180: [
    'BENESSE LES DAX',
    'CANDRESSE',
    'CLERMONT',
    'GARREY',
    'GOOS',
    'HEUGAS',
    'HINX',
    'NARROSSE',
    'OEYRELUY',
    'RIVIERE SAAS ET GOURBY',
    'ST PANDELON',
    'SAUBUSSE',
    'SAUGNAC ET CAMBRAN',
    'SEYRESSE',
    'SIEST',
    'SORT EN CHALOSSE',
    'TERCIS LES BAINS',
    'YZOSSE',
  ],
  40230: [
    'BENESSE MAREMNE',
    'JOSSE',
    'ORX',
    'ST GEOURS DE MAREMNE',
    'ST JEAN DE MARSACQ',
    'ST VINCENT DE TYROSSE',
    'SAUBION',
    'SAUBRIGUES',
    'TOSSE',
  ],
  40280: ['BENQUET', 'BRETAGNE DE MARSAN', 'HAUT MAUCO', 'ST PIERRE DU MONT'],
  40250: [
    'BERGOUEY',
    'CAUPENNE',
    'HAURIET',
    'LAHOSSE',
    'LAMOTHE',
    'LARBEY',
    'LAUREDE',
    'LE LEUY',
    'LOURQUEN',
    'MAYLIS',
    'MUGRON',
    'NERBIS',
    'ST AUBIN',
    'SOUPROSSE',
    'TOULOUZETTE',
  ],
  40240: [
    'BETBEZER D ARMAGNAC',
    'CREON D ARMAGNAC',
    'ESTIGARDE',
    'LABASTIDE D ARMAGNAC',
    'LAGRANGE',
    'LOSSE',
    'LUBBON',
    'MAUVEZIN D ARMAGNAC',
    'ST JULIEN D ARMAGNAC',
    'ST JUSTIN',
    'VIELLE SOUBIRAN',
  ],
  40370: ['BEYLONGUE', 'RION DES LANDES'],
  40390: [
    'BIARROTTE',
    'BIAUDOS',
    'ST ANDRE DE SEIGNANX',
    'ST BARTHELEMY',
    'ST LAURENT DE GOSSE',
    'STE MARIE DE GOSSE',
    'ST MARTIN DE HINX',
    'ST MARTIN DE SEIGNANX',
  ],
  40170: ['BIAS', 'LEVIGNACQ', 'LIT ET MIXE', 'MEZOS', 'ST JULIEN EN BORN', 'UZA'],
  40600: ['BISCARROSSE'],
  40270: [
    'BORDERES ET LAMENSANS',
    'CASTANDET',
    'CAZERES SUR L ADOUR',
    'GRENADE SUR L ADOUR',
    'LARRIVIERE ST SAVIN',
    'LUSSAGNET',
    'MAURRIN',
    'RENUNG',
    'ST MAURICE SUR ADOUR',
    'LE VIGNAU',
  ],
  40420: ['BROCAS', 'GAREIN', 'LABRIT', 'LE SEN', 'VERT'],
  40130: ['CAPBRETON'],
  40260: ['CASTETS', 'LESPERON', 'LINXE', 'TALLER'],
  40210: ['COMMENSACQ', 'ESCOURCE', 'LABOUHEYRE', 'LUE', 'SOLFERINO'],
  40100: ['DAX'],
  40290: ['ESTIBEAUX', 'HABAS', 'MISSON', 'MOUSCARDES', 'OSSAGES'],
  40350: ['GAAS', 'MIMBASTE', 'POUILLON'],
  40160: ['GASTES', 'PARENTIS EN BORN', 'YCHOUX'],
  40465: ['GOUSSE', 'LALUQUE', 'PONTONX SUR L ADOUR', 'PRECHACQ LES BAINS'],
  40530: ['LABENNE'],
  40550: ['LEON', 'ST MICHEL ESCALUS'],
  40630: ['LUGLON', 'SABRES', 'TRENSACQ'],
  40660: ['MESSANGES', 'MOLIETS ET MAA'],
  40000: ['MONT DE MARSAN'],
  40440: ['ONDRES'],
  40460: ['SANGUINET'],
  40510: ['SEIGNOSSE'],
  40220: ['TARNOS'],
  40560: ['VIELLE ST GIRONS'],
  40480: ['VIEUX BOUCAU LES BAINS'],
  41310: [
    'AMBLOY',
    'AUTHON',
    'GOMBERGEAN',
    'HUISSEAU EN BEAUCE',
    'LANCE',
    'NOURRAY',
    'PRUNAY CASSEREAU',
    'ST AMAND LONGPRE',
    'ST GOURGON',
    'SASNIERES',
    'VILLECHAUVE',
    'VILLEPORCHER',
  ],
  41400: [
    'ANGE',
    'CHISSAY EN TOURAINE',
    'LE CONTROIS EN SOLOGNE',
    'FAVEROLLES SUR CHER',
    'MONTHOU SUR CHER',
    'MONTRICHARD VAL DE CHER',
    'PONTLEVOY',
    'ST GEORGES SUR CHER',
    'ST JULIEN DE CHEDON',
    'VALLIERES LES GRANDES',
  ],
  41100: [
    'AREINES',
    'AZE',
    'COULOMMIERS LA TOUR',
    'CRUCHERAY',
    'FAYE',
    'LISLE',
    'MARCILLY EN BEAUCE',
    'MAZANGE',
    'MESLAY',
    'NAVEIL',
    'PERIGNY',
    'PEZOU',
    'RENAY',
    'ROCE',
    'STE ANNE',
    'ST FIRMIN DES PRES',
    'ST OUEN',
    'SELOMMES',
    'THORE LA ROCHETTE',
    'VENDOME',
    'VILLEMARDY',
    'VILLERABLE',
    'VILLEROMAIN',
    'VILLETRUN',
    'VILLIERSFAUX',
    'VILLIERS SUR LOIR',
  ],
  41800: [
    'ARTINS',
    'BONNEVEAU',
    'VALLEE DE RONSARD',
    'LES ESSARTS',
    'FONTAINE LES COTEAUX',
    'LES HAYES',
    'HOUSSAY',
    'LAVARDIN',
    'MONTOIRE SUR LE LOIR',
    'MONTROUVEAU',
    'LES ROCHES L EVEQUE',
    'ST ARNOULT',
    'ST JACQUES DES GUERETS',
    'ST MARTIN DES BOIS',
    'ST RIMAY',
    'SOUGE',
    'TERNAY',
    'TROO',
    'VILLAVARD',
    'VILLEDIEU LE CHATEAU',
  ],
  41240: ['AUTAINVILLE', 'BINAS', 'BEAUCE LA ROMAINE', 'ST LAURENT DES BOIS', 'VILLERMAIN'],
  41500: [
    'AVARAY',
    'LA CHAPELLE ST MARTIN EN PLAINE',
    'COURBOUZON',
    'COUR SUR LOIRE',
    'LESTIOU',
    'MAVES',
    'MENARS',
    'MER',
    'MUIDES SUR LOIRE',
    'MULSANS',
    'ST DYE SUR LOIRE',
    'SERIS',
    'SUEVRES',
    'VILLEXANTON',
  ],
  41330: [
    'AVERDON',
    'CHAMPIGNY EN BEAUCE',
    'LA CHAPELLE VENDOMOISE',
    'FOSSE',
    'MAROLLES',
    'ST BOHAIRE',
    'VILLEFRANCOEUR',
  ],
  41170: [
    'BAILLOU',
    'BEAUCHENE',
    'CHOUE',
    'CORMENON',
    'MONDOUBLEAU',
    'LE PLESSIS DORIN',
    'ST MARC DU COR',
    'SARGE SUR BRAYE',
    'COUETRON AU PERCHE',
    'LE TEMPLE',
  ],
  41250: [
    'BAUZY',
    'BRACIEUX',
    'CHAMBORD',
    'FONTAINES EN SOLOGNE',
    'MASLIVES',
    'MONT PRES CHAMBORD',
    'NEUVY',
    'TOUR EN SOLOGNE',
  ],
  41130: ['BILLY', 'CHATILLON SUR CHER', 'GIEVRES', 'MEUSNES', 'SELLES SUR CHER'],
  41000: ['BLOIS', 'ST DENIS SUR LOIRE', 'ST SULPICE DE POMMERAY', 'VILLEBAROU', 'VILLERBON'],
  41290: [
    'BOISSEAU',
    'LA CHAPELLE ENCHERIE',
    'CONAN',
    'EPIAIS',
    'OUCQUES LA NOUVELLE',
    'RHODON',
    'VIEVY LE RAYE',
    'VILLENEUVE FROUVILLE',
  ],
  41270: [
    'BOUFFRY',
    'BOURSAY',
    'LA CHAPELLE VICOMTESSE',
    'CHAUVIGNY DU PERCHE',
    'DROUE',
    'FONTAINE RAOUL',
    'LA FONTENELLE',
    'LE GAULT DU PERCHE',
    'LE POISLAY',
    'ROMILLY',
    'RUAN SUR EGVONNE',
    'VILLEBOUT',
  ],
  41160: [
    'BREVAINVILLE',
    'BUSLOUP',
    'DANZE',
    'FRETEVAL',
    'LIGNIERES',
    'MOISY',
    'MOREE',
    'OUZOUER LE DOYEN',
    'BEAUCE LA ROMAINE',
    'RAHART',
    'ST HILAIRE LA GRAVELLE',
    'ST JEAN FROIDMENTEL',
    'LA VILLE AUX CLERCS',
  ],
  41370: [
    'BRIOU',
    'CONCRIERS',
    'JOSNES',
    'LORGES',
    'LA MADELEINE VILLEFROUIN',
    'MARCHENOIR',
    'LE PLESSIS L ECHELLE',
    'ROCHES',
    'ST LEONARD EN BEAUCE',
    'TALCY',
  ],
  41120: [
    'CANDE SUR BEUVRON',
    'CELLETTES',
    'CHAILLES',
    'CHITENAY',
    'LE CONTROIS EN SOLOGNE',
    'CORMERAY',
    'MONTHOU SUR BIEVRE',
    'LES MONTILS',
    'SAMBIN',
    'SEUR',
    'VALAIRE',
  ],
  41360: ['CELLE', 'EPUISAY', 'FORTAN', 'LUNAY', 'SAVIGNY SUR BRAYE'],
  41600: [
    'CHAON',
    'CHAUMONT SUR THARONNE',
    'LAMOTTE BEUVRON',
    'NOUAN LE FUZELIER',
    'SOUVIGNY EN SOLOGNE',
    'VOUZON',
    'YVOY LE MARRON',
  ],
  41320: [
    'LA CHAPELLE MONTMARTIN',
    'CHATRES SUR CHER',
    'LANGON SUR CHER',
    'MARAY',
    'MENNETOU SUR CHER',
    'ST JULIEN SUR CHER',
    'ST LOUP',
  ],
  41110: ['CHATEAUVIEUX', 'COUFFY', 'MAREUIL SUR CHER', 'POUILLE', 'ST AIGNAN', 'SEIGY'],
  41150: [
    'CHAUMONT SUR LOIRE',
    'VALLOIRE SUR CISSE',
    'MESLAND',
    'MONTEAUX',
    'VEUZAIN SUR LOIRE',
    'RILLY SUR LOIRE',
  ],
  41260: ['LA CHAUSSEE ST VICTOR'],
  41700: [
    'CHEMERY',
    'CHEVERNY',
    'CHOUSSY',
    'LE CONTROIS EN SOLOGNE',
    'COUDDES',
    'COUR CHEVERNY',
    'FRESNES',
    'OISLY',
    'SASSAY',
  ],
  41230: [
    'COURMEMIN',
    'GY EN SOLOGNE',
    'LASSAY SUR CROISNE',
    'MUR DE SOLOGNE',
    'ROUGEOU',
    'SOINGS EN SOLOGNE',
    'VEILLEINS',
    'VERNOU EN SOLOGNE',
  ],
  41220: [
    'CROUY SUR COSSON',
    'DHUIZON',
    'LA FERTE ST CYR',
    'ST LAURENT NOUAN',
    'THOURY',
    'VILLENY',
  ],
  41210: [
    'LA FERTE BEAUHARNAIS',
    'MARCILLY EN GAULT',
    'LA MAROLLE EN SOLOGNE',
    'MONTRIEUX EN SOLOGNE',
    'NEUNG SUR BEUVRON',
    'ST VIATRE',
  ],
  41300: [
    'LA FERTE IMBAULT',
    'ORCAY',
    'PIERREFITTE SUR SAULDRE',
    'SALBRIS',
    'SELLES ST DENIS',
    'SOUESMES',
    'THEILLAY',
  ],
  41190: [
    'FRANCAY',
    'HERBAULT',
    'LANCOME',
    'LANDES LE GAULOIS',
    'VALENCISSE',
    'PRAY',
    'ST CYR DU GAULT',
    'ST ETIENNE DES GUERETS',
    'ST LUBIN EN VERGONNOIS',
    'SANTENAY',
    'TOURAILLES',
  ],
  41350: [
    'HUISSEAU SUR COSSON',
    'MONTLIVAULT',
    'ST CLAUDE DE DIRAY',
    'ST GERVAIS LA FORET',
    'VINEUIL',
  ],
  41200: [
    'LOREUX',
    'MILLANCAY',
    'PRUNIERS EN SOLOGNE',
    'ROMORANTIN LANTHENAY',
    'VILLEFRANCHE SUR CHER',
    'VILLEHERVIERS',
  ],
  41140: ['MEHERS', 'NOYERS SUR CHER', 'ST ROMAIN SUR CHER', 'THESEE'],
  42380: [
    'ABOEN',
    'LA CHAPELLE EN LAFAYE',
    'ESTIVAREILLES',
    'LURIECQ',
    'MERLE LEIGNEC',
    'MONTARCHER',
    'PERIGNEUX',
    'ROZIER COTES D AUREC',
    'ST BONNET LE CHATEAU',
    'ST HILAIRE CUSSON LA VALMITTE',
    'ST NIZIER DE FORNAS',
    'LA TOURETTE',
  ],
  42130: [
    'AILLEUX',
    'ARTHUN',
    'BOEN SUR LIGNON',
    'CEZAY',
    'DEBATS RIVIERE D ORPRA',
    'L HOPITAL SOUS ROCHEFORT',
    'LEIGNEUX',
    'MARCILLY LE CHATEL',
    'MARCOUX',
    'MONTVERDUN',
    'STE AGATHE LA BOUTERESSE',
    'ST ETIENNE LE MOLARD',
    'ST LAURENT ROCHEFORT',
    'ST SIXTE',
    'TRELINS',
  ],
  42820: ['AMBIERLE'],
  42160: ['ANDREZIEUX BOUTHEON', 'BONSON', 'ST CYPRIEN'],
  42550: ['APINAC', 'USSON EN FOREZ'],
  42460: [
    'ARCINGES',
    'BOYER',
    'LE CERGNE',
    'COUTOUVRE',
    'CUINZIER',
    'LA GRESLE',
    'JARNOSSE',
    'SEVELINGES',
    'VILLERS',
  ],
  42370: [
    'ARCON',
    'LES NOES',
    'RENAISON',
    'ST ALBAN LES EAUX',
    'ST ANDRE D APCHON',
    'ST HAON LE CHATEL',
    'ST HAON LE VIEUX',
    'ST RIRAND',
  ],
  42330: [
    'AVEIZIEUX',
    'CHAMBOEUF',
    'CUZIEU',
    'ST BONNET LES OULES',
    'ST GALMIER',
    'ST MEDARD EN FOREZ',
  ],
  42510: [
    'BALBIGNY',
    'BUSSIERES',
    'NERONDE',
    'NERVIEUX',
    'STE AGATHE EN DONZY',
    'ST GEORGES DE BAROILLE',
  ],
  42600: [
    'BARD',
    'CHALAIN D UZORE',
    'CHALAIN LE COMTAL',
    'CHAMPDIEU',
    'ECOTAY L OLME',
    'ESSERTINES EN CHATELNEUF',
    'GREZIEUX LE FROMENTAL',
    'LERIGNEUX',
    'LEZIGNEUX',
    'MAGNEUX HAUTE RIVE',
    'MONTBRISON',
    'MORNAND EN FOREZ',
    'PRALONG',
    'PRECIEUX',
    'ROCHE',
    'ST PAUL D UZORE',
    'ST THOMAS LA GARDE',
    'SAVIGNEUX',
    'VERRIERES EN FOREZ',
  ],
  42210: [
    'BELLEGARDE EN FOREZ',
    'BOISSET LES MONTROND',
    'CRAINTILLEUX',
    'L HOPITAL LE GRAND',
    'MARCLOPT',
    'MONTROND LES BAINS',
    'ST ANDRE LE PUY',
    'ST CYR LES VIGNES',
    'ST LAURENT LA CONCHE',
    'UNIAS',
  ],
  42670: ['BELLEROCHE', 'BELMONT DE LA LOIRE', 'ECOCHE', 'ST GERMAIN LA MONTAGNE'],
  42720: ['LA BENISSON DIEU', 'BRIENNON', 'NANDAX', 'POUILLY SOUS CHARLIEU', 'VOUGY'],
  42660: [
    'LE BESSAT',
    'JONZIEUX',
    'MARLHES',
    'PLANFOY',
    'ST GENEST MALIFAUX',
    'ST REGIS DU COIN',
    'ST ROMAIN LES ATHEUX',
    'TARENTAISE',
  ],
  42520: [
    'BESSEY',
    'LUPE',
    'MACLAS',
    'MALLEVAL',
    'ROISEY',
    'ST APPOLINARD',
    'ST PIERRE DE BOEUF',
    'VERANNE',
  ],
  42560: [
    'BOISSET ST PRIEST',
    'CHAZELLES SUR LAVIEU',
    'CHENEREILLES',
    'GUMIERES',
    'LAVIEU',
    'MARGERIE CHANTAGRET',
    'MAROLS',
    'ST JEAN SOLEYMIEUX',
    'SOLEYMIEUX',
  ],
  42220: [
    'BOURG ARGENTAL',
    'BURDIGNES',
    'COLOMBIER',
    'GRAIX',
    'ST JULIEN MOLIN MOLETTE',
    'ST SAUVEUR EN RUE',
    'THELIS LA COMBE',
    'LA VERSANNE',
  ],
  42260: [
    'BULLY',
    'BUSSY ALBIEUX',
    'CREMEAUX',
    'GREZOLLES',
    'LURE',
    'NOLLIEUX',
    'POMMIERS EN FOREZ',
    'ST GERMAIN LAVAL',
    'ST JULIEN D ODDES',
    'ST MARTIN LA SAUVETE',
    'VEZELIN SUR LOIRE',
    'ST POLGUES',
    'SOUTERNON',
  ],
  42240: ['CALOIRE', 'ST MAURICE EN GOURGOIS', 'ST PAUL EN CORNILLON', 'UNIEUX'],
  42320: ['CELLIEU', 'FARNAY', 'LA GRAND CROIX', 'ST CHRISTO EN JAREZ', 'VALFLEURY'],
  42440: [
    'CERVIERES',
    'LA CHAMBA',
    'LA CHAMBONIE',
    'NOIRETABLE',
    'ST JEAN LA VETRE',
    'VETRE SUR ANZON',
    'ST PRIEST LA VETRE',
    'LES SALLES',
  ],
  42800: [
    'CHAGNON',
    'CHATEAUNEUF',
    'DARGOIRE',
    'RIVE DE GIER',
    'STE CROIX EN JAREZ',
    'GENILAC',
    'ST JOSEPH',
    'ST MARTIN LA PLAINE',
    'ST ROMAIN EN JAREZ',
    'TARTARAS',
  ],
  42920: ['CHALMAZEL JEANSAGNIERE'],
  42110: [
    'CHAMBEON',
    'CIVENS',
    'CLEPPE',
    'EPERCIEUX ST PAUL',
    'FEURS',
    'JAS',
    'MIZERIEUX',
    'PONCINS',
    'POUILLY LES FEURS',
    'ST BARTHELEMY LESTRA',
    'STE FOY ST SULPICE',
    'ST MARTIN LESTRA',
    'SALT EN DONZY',
    'SALVIZINET',
    'VALEILLE',
  ],
  42170: ['CHAMBLES', 'ST JUST ST RAMBERT'],
  42500: ['LE CHAMBON FEUGEROLLES'],
  42430: [
    'CHAMPOLY',
    'CHERIER',
    'JURE',
    'ST JUST EN CHEVALET',
    'ST MARCEL D URFE',
    'ST ROMAIN D URFE',
    'CHAUSSETERRE',
  ],
  42190: [
    'CHANDON',
    'CHARLIEU',
    'ST HILAIRE SOUS CHARLIEU',
    'ST NIZIER SOUS CHARLIEU',
    'ST PIERRE LA NOAILLE',
  ],
  42310: [
    'CHANGY',
    'LE CROZET',
    'LA PACAUDIERE',
    'SAIL LES BAINS',
    'ST BONNET DES QUARTS',
    'URBISE',
    'VIVANS',
  ],
  42410: [
    'LA CHAPELLE VILLARS',
    'CHAVANAY',
    'CHUYER',
    'PAVEZIN',
    'PELUSSIN',
    'ST MICHEL SUR RHONE',
    'VERIN',
  ],
  42940: ['CHATELNEUF', 'ST BONNET LE COURREAU'],
  42140: [
    'CHATELUS',
    'CHAZELLES SUR LYON',
    'CHEVRIERES',
    'FONTANES',
    'LA GIMOND',
    'GRAMMOND',
    'MARCENOD',
    'MARINGES',
    'ST DENIS SUR COISE',
    'VIRICELLES',
    'VIRIGNEUX',
  ],
  42114: ['CHIRASSIMONT', 'MACHEZAL', 'ST CYR DE VALORGES'],
  42840: ['COMBRE', 'MONTAGNY'],
  42120: [
    'COMMELLE VERNAY',
    'LE COTEAU',
    'NOTRE DAME DE BOISSET',
    'PARIGNY',
    'PERREUX',
    'ST VINCENT DE BOISSET',
  ],
  42123: ['CORDELLE', 'ST CYR DE FAVIERES'],
  42111: [
    'LA COTE EN COUZAN',
    'ST DIDIER SUR ROCHEFORT',
    'VETRE SUR ANZON',
    'LA VALLA SUR ROCHEFORT',
  ],
  42360: ['COTTANCE', 'ESSERTINES EN DONZY', 'MONTCHAL', 'PANISSIERES'],
  42540: ['CROIZET SUR GAND', 'STE COLOMBE SUR GAND', 'ST JUST LA PENDUE'],
  42740: ['DOIZIEUX', 'ST PAUL EN JAREZ', 'LA TERRASSE SUR DORLAY'],
  42580: ['L ETRAT', 'LA TOUR EN JAREZ'],
  42700: ['FIRMINY'],
  42480: ['LA FOUILLOUSE'],
  42470: ['FOURNEAUX', 'LAY', 'NEAUX', 'ST SYMPHORIEN DE LAY'],
  42490: ['FRAISSES'],
  42152: ['L HORME'],
  42155: [
    'LENTIGNY',
    'OUCHES',
    'POUILLY LES NONAINS',
    'ST JEAN ST MAURICE SUR LOIRE',
    'ST LEGER SUR ROANNE',
    'VILLEMONTAIS',
  ],
  42420: ['LORETTE'],
  42300: ['MABLY', 'ROANNE', 'VILLEREST'],
  42750: ['MAIZILLY', 'MARS', 'ST DENIS DE CABANNE'],
  42590: ['NEULISE', 'PINAY', 'ST JODARD', 'VEZELIN SUR LOIRE', 'ST PRIEST LA ROCHE', 'VENDRANGES'],
  42640: ['NOAILLY', 'ST FORGEUX LESPINASSE', 'ST GERMAIN LESPINASSE', 'ST ROMAIN LA MOTTE'],
  42990: ['PALOGNEUX', 'ST GEORGES EN COUZAN', 'ST JUST EN BAS', 'SAUVAIN'],
  42630: ['PRADINES', 'REGNY', 'ST VICTOR SUR RHINS'],
  42150: ['LA RICAMARIE'],
  42153: ['RIORGES'],
  42340: ['RIVAS', 'VEAUCHE', 'VEAUCHETTE'],
  42230: ['ROCHE LA MOLIERE', 'ST ETIENNE'],
  42810: ['ROZIER EN DONZY'],
  42890: ['SAIL SOUS COUZAN'],
  42400: ['ST CHAMOND'],
  42000: ['ST ETIENNE'],
  42100: ['ST ETIENNE'],
  42530: ['ST GENEST LERPT'],
  42610: ['ST GEORGES HAUTE VILLE', 'ST ROMAIN LE PUY'],
  42570: ['ST HEAND'],
  42650: ['ST JEAN BONNEFONDS'],
  42122: ['ST MARCEL DE FELINES'],
  42680: ['ST MARCELLIN EN FOREZ'],
  42270: ['ST PRIEST EN JAREZ'],
  42830: ['ST PRIEST LA PRUGNE', 'LA TUILIERE'],
  42290: ['SORBIERS'],
  42450: ['SURY LE COMTAL'],
  42350: ['LA TALAUDIERE'],
  42131: ['LA VALLA EN GIER'],
  42390: ['VILLARS'],
  42780: ['VIOLAY'],
  43100: [
    'AGNAT',
    'BEAUMONT',
    'BRIOUDE',
    'CHANIAT',
    'COHADE',
    'FONTANNES',
    'JAVAUGUES',
    'LAMOTHE',
    'LAVAUDIEU',
    'LUBILHAC',
    'MERCOEUR',
    'PAULHAC',
    'ST BEAUZIRE',
    'ST JUST PRES BRIOUDE',
    'ST LAURENT CHABREUGES',
    'VIEILLE BRIOUDE',
  ],
  43000: ['AIGUILHE', 'CEYSSAC', 'ESPALY ST MARCEL', 'POLIGNAC', 'LE PUY EN VELAY'],
  43270: [
    'ALLEGRE',
    'CEAUX D ALLEGRE',
    'LA CHAPELLE BERTIN',
    'MONLET',
    'VARENNES ST HONORAT',
    'VERNASSAL',
  ],
  43150: [
    'ALLEYRAC',
    'CHADRON',
    'LES ESTABLES',
    'FREYCENET LA CUCHE',
    'FREYCENET LA TOUR',
    'GOUDET',
    'LAUSSONNE',
    'LE MONASTIER SUR GAZEILLE',
    'MOUDEYRES',
    'PRESAILLES',
    'ST MARTIN DE FUGERES',
    'SALETTES',
  ],
  43580: [
    'ALLEYRAS',
    'ESPLANTAS VAZEILLES',
    'MONISTROL D ALLIER',
    'ST PREJET D ALLIER',
    'ST PRIVAT D ALLIER',
    'ST VENERAND',
    'THORAS',
  ],
  43380: [
    'ALLY',
    'ARLET',
    'AUBAZAT',
    'BLASSAC',
    'CERZAT',
    'CHILHAC',
    'LAVOUTE CHILHAC',
    'ST AUSTREMOINE',
    'ST CIRGUES',
    'ST ILPIZE',
    'ST PRIVAT DU DRAGON',
    'VILLENEUVE D ALLIER',
  ],
  43200: [
    'ARAULES',
    'BEAUX',
    'BESSAMOREL',
    'GRAZAC',
    'LAPTE',
    'LE PERTUIS',
    'ST JEURES',
    'ST JULIEN DU PINET',
    'ST MAURICE DE LIGNON',
    'YSSINGEAUX',
  ],
  43490: ['ARLEMPDES', 'COSTAROS', 'LAFARRE', 'VIELPRAT'],
  43700: [
    'ARSAC EN VELAY',
    'BLAVOZY',
    'BRIVES CHARENSAC',
    'CHASPINHAC',
    'COUBON',
    'LE MONTEIL',
    'ST GERMAIN LAPRADE',
  ],
  43110: ['AUREC SUR LOIRE'],
  43300: [
    'VISSAC AUTEYRAC',
    'AUVERS',
    'CHANTEUGES',
    'CHARRAIX',
    'CHASTEL',
    'CHAZELLES',
    'CRONCE',
    'DESGES',
    'FERRUSSAC',
    'LANGEAC',
    'MAZEYRAT D ALLIER',
    'PEBRAC',
    'PINOLS',
    'PRADES',
    'ST ARCONS D ALLIER',
    'ST BERAIN',
    'ST JULIEN DES CHAZES',
    'SIAUGUES STE MARIE',
    'TAILHAC',
  ],
  43390: ['AUZON', 'AZERAT', 'ST HILAIRE', 'VEZEZOUX'],
  43370: [
    'BAINS',
    'LE BRIGNON',
    'CUSSAC SUR LOIRE',
    'ST CHRISTOPHE SUR DOLAISON',
    'SOLIGNAC SUR LOIRE',
  ],
  43340: ['BARGES', 'LANDOS', 'RAURET', 'ST CHRISTOPHE D ALLIER', 'ST HAON'],
  43210: ['BAS EN BASSET', 'MALVALETTE', 'VALPRIVAS'],
  43800: [
    'BEAULIEU',
    'CHAMALIERES SUR LOIRE',
    'LAVOUTE SUR LOIRE',
    'MALREVERS',
    'MEZERES',
    'ROSIERES',
    'ST VINCENT',
    'VOREY',
  ],
  43500: [
    'BEAUNE SUR ARZON',
    'BOISSET',
    'CHOMELIX',
    'CRAPONNE SUR ARZON',
    'JULLIANGES',
    'ST GEORGES LAGRICOL',
    'ST JEAN D AUBRIGOUX',
    'ST JULIEN D ANCE',
    'ST PAL DE CHALENCON',
    'ST VICTOR SUR ARLANC',
  ],
  43590: ['BEAUZAC'],
  43350: [
    'BELLEVUE LA MONTAGNE',
    'BLANZAC',
    'BORNE',
    'LISSAC',
    'ST GENEYS PRES ST PAULIEN',
    'ST PAULIEN',
  ],
  43160: [
    'BERBEZIT',
    'BONNEVAL',
    'LA CHAISE DIEU',
    'LA CHAPELLE GENESTE',
    'CISTRIERES',
    'CONNANGLES',
    'FELINES',
    'MALVIERES',
    'ST PAL DE SENOUIRE',
    'SEMBADEL',
  ],
  43170: [
    'LA BESSEYRE ST MARY',
    'CHANALEILLES',
    'CUBELLES',
    'ESPLANTAS VAZEILLES',
    'GREZES',
    'SAUGUES',
    'THORAS',
    'VENTEUGES',
  ],
  43510: ['LE BOUCHET ST NICOLAS', 'CAYRES', 'OUIDES', 'ST JEAN LACHALM', 'SENEUJOLS'],
  43360: ['BOURNONCLE ST PIERRE', 'LORLANGES', 'ST GERON', 'VERGONGHEON'],
  43770: ['CHADRAC'],
  43410: ['CHAMBEZON', 'LEMPDES SUR ALLAGNON', 'LEOTOING'],
  43400: ['LE CHAMBON SUR LIGNON'],
  43440: [
    'CHAMPAGNAC LE VIEUX',
    'CHASSIGNOLLES',
    'LAVAL SUR DOULON',
    'ST DIDIER SUR DOULON',
    'ST VERT',
  ],
  43260: [
    'CHAMPCLAUSE',
    'LANTRIAC',
    'MONTUSCLAT',
    'QUEYRIERES',
    'ST ETIENNE LARDEYROL',
    'ST HOSTIEN',
    'ST JULIEN CHAPTEUIL',
    'ST PIERRE EYNAC',
  ],
  43430: ['CHAMPCLAUSE', 'CHAUDEYROLLES', 'FAY SUR LIGNON', 'LES VASTRES'],
  43120: ['LA CHAPELLE D AUREC', 'MONISTROL SUR LOIRE'],
  43320: [
    'CHASPUZAC',
    'FIX ST GENEYS',
    'LOUDES',
    'ST JEAN DE NAY',
    'ST VIDAL',
    'SANSSAC L EGLISE',
    'VAZEILLES LIMANDRE',
    'VERGEZAC',
    'LE VERNET',
  ],
  43230: [
    'CHASSAGNES',
    'CHAVANIAC LAFAYETTE',
    'LA CHOMETTE',
    'COLLAT',
    'COUTEUGES',
    'DOMEYRAT',
    'FRUGIERES LE PIN',
    'JAX',
    'JOSAT',
    'MAZERAT AUROUZE',
    'MONTCLARD',
    'PAULHAGUET',
    'STE EUGENIE DE VILLENEUVE',
    'ST GEORGES D AURAC',
    'STE MARGUERITE',
    'ST PREJET ARMANDON',
    'SALZUIT',
    'VALS LE CHASTEL',
  ],
  43190: ['CHENEREILLES', 'LE MAS DE TENCE', 'TENCE'],
  43220: ['DUNIERES', 'RIOTORD', 'ST JULIEN MOLHESABATE'],
  43250: ['FRUGERES LES MINES', 'STE FLORINE'],
  43520: ['MAZET ST VOY'],
  43290: ['MONTFAUCON EN VELAY', 'MONTREGARD', 'RAUCOULES', 'ST BONNET LE FROID'],
  43330: ['PONT SALOMON', 'ST FERREOL D AUROURE'],
  43420: ['PRADELLES', 'ST ARCONS DE BARGES', 'ST ETIENNE DU VIGAN', 'ST PAUL DE TARTAS'],
  43130: ['RETOURNAC', 'ST ANDRE DE CHALENCON', 'SOLIGNAC SOUS ROCHE'],
  43810: ['ROCHE EN REGNIER', 'ST PIERRE DU CHAMP'],
  43140: ['ST DIDIER EN VELAY', 'ST VICTOR MALESCOURS', 'LA SEAUVE SUR SEMENE'],
  43550: ['ST FRONT'],
  43240: ['ST JUST MALMONT'],
  43620: ['ST PAL DE MONS', 'ST ROMAIN LACHALM'],
  43600: ['STE SIGOLENE', 'LES VILLETTES'],
  43530: ['TIRANGES'],
  43750: ['VALS PRES LE PUY'],
  44170: ['ABBARETZ', 'JANS', 'MARSAC SUR DON', 'NOZAY', 'TREFFIEUX', 'VAY', 'LA GRIGONNAIS'],
  44140: ['AIGREFEUILLE SUR MAINE', 'LE BIGNON', 'MONTBERT', 'LA PLANCHE', 'REMOUILLE', 'GENESTON'],
  44150: ['ANCENIS ST GEREON', 'VAIR SUR LOIRE'],
  44320: ['CHAUMES EN RETZ', 'CHAUVE', 'FROSSAY', 'ST PERE EN RETZ', 'ST VIAUD'],
  44680: ['CHAUMES EN RETZ', 'ST HILAIRE DE CHALEONS', 'ST MARS DE COUTAIS', 'STE PAZANNE'],
  44410: ['ASSERAC', 'LA CHAPELLE DES MARAIS', 'HERBIGNAC', 'ST LYPHARD'],
  44460: ['AVESSAC', 'FEGREAC', 'ST NICOLAS DE REDON'],
  44115: ['BASSE GOULAINE', 'HAUTE GOULAINE'],
  44740: ['BATZ SUR MER'],
  44760: ['LA BERNERIE EN RETZ', 'LES MOUTIERS EN RETZ'],
  44160: ['BESNE', 'CROSSAC', 'PONTCHATEAU', 'STE ANNE SUR BRIVET', 'STE REINE DE BRETAGNE'],
  44130: ['BLAIN', 'BOUVRON', 'FAY DE BRETAGNE', 'LE GAVRE', 'NOTRE DAME DES LANDES'],
  44430: ['LA BOISSIERE DU DORE', 'LE LANDREAU', 'LE LOROUX BOTTEREAU', 'LA REMAUDIERE'],
  44830: ['BOUAYE', 'BRAINS'],
  44260: ['BOUEE', 'LA CHAPELLE LAUNAY', 'LAVAU SUR LOIRE', 'MALVILLE', 'PRINQUIAU', 'SAVENAY'],
  44340: ['BOUGUENAIS'],
  44580: ['VILLENEUVE EN RETZ'],
  44190: [
    'BOUSSAY',
    'CLISSON',
    'GETIGNE',
    'GORGES',
    'ST HILAIRE DE CLISSON',
    'ST LUMINE DE CLISSON',
  ],
  44750: ['CAMPBON', 'QUILLY'],
  44470: ['CARQUEFOU', 'MAUVES SUR LOIRE', 'THOUARE SUR LOIRE'],
  44390: ['CASSON', 'NORT SUR ERDRE', 'PETIT MARS', 'PUCEUL', 'SAFFRE', 'LES TOUCHES'],
  44850: ['LE CELLIER', 'LIGNE', 'MOUZEIL', 'ST MARS DU DESERT'],
  44450: ['DIVATTE SUR LOIRE', 'ST JULIEN DE CONCELLES'],
  44670: ['LA CHAPELLE GLAIN', 'JUIGNE DES MOUTIERS', 'PETIT AUVERNE', 'ST JULIEN DE VOUVANTES'],
  44330: ['LA CHAPELLE HEULIN', 'MOUZILLON', 'LE PALLET', 'LA REGRIPPIERE', 'VALLET'],
  44240: ['LA CHAPELLE SUR ERDRE', 'SUCE SUR ERDRE'],
  44110: [
    'CHATEAUBRIANT',
    'ERBRAY',
    'LOUISFERT',
    'NOYAL SUR BRUTZ',
    'ST AUBIN DES CHATEAUX',
    'SOUDAN',
    'VILLEPOT',
  ],
  44690: [
    'CHATEAU THEBAUD',
    'LA HAIE FOUASSIERE',
    'MAISDON SUR SEVRE',
    'MONNIERES',
    'ST FIACRE SUR MAINE',
  ],
  44640: ['CHEIX EN RETZ', 'LE PELLERIN', 'ROUANS', 'ST JEAN DE BOISEAU', 'VUE'],
  44118: ['LA CHEVROLIERE'],
  44290: ['CONQUEREUIL', 'GUEMENE PENFAO', 'MASSERAC', 'PIERRIC'],
  44360: ['CORDEMAIS', 'ST ETIENNE DE MONTLUC', 'LE TEMPLE DE BRETAGNE', 'VIGNEUX DE BRETAGNE'],
  44560: ['CORSEPT', 'PAIMBOEUF'],
  44220: ['COUERON'],
  44521: ['COUFFE', 'OUDON'],
  44490: ['LE CROISIC'],
  44590: ['DERVAL', 'LUSANGER', 'MOUAIS', 'ST VINCENT DES LANDES', 'SION LES MINES'],
  44480: ['DONGES'],
  44530: ['DREFFEAC', 'GUENROUET', 'ST GILDAS DES BOIS', 'SEVERAC'],
  44500: ['LA BAULE ESCOUBLAC'],
  44660: ['FERCE', 'ROUGE', 'RUFFIGNE', 'SOULVACHE'],
  44520: ['GRAND AUVERNE', 'ISSE', 'LA MEILLERAYE DE BRETAGNE', 'MOISDON LA RIVIERE'],
  44119: ['GRANDCHAMP DES FONTAINES', 'TREILLIERES'],
  44350: ['GUERANDE', 'ST MOLF'],
  44810: ['HERIC', 'LA CHEVALLERAIS'],
  44610: ['INDRE'],
  44440: ['JOUE SUR ERDRE', 'PANNECE', 'RIAILLE', 'TEILLE', 'TRANS SUR ERDRE'],
  44650: ['LEGE', 'CORCOUE SUR LOGNE', 'TOUVOIS'],
  44310: ['LA LIMOUZINIERE', 'ST COLOMBAN', 'ST LUMINE DE COUTAIS', 'ST PHILBERT DE GRAND LIEU'],
  44270: ['MACHECOUL ST MEME', 'LA MARNE', 'PAULX', 'ST ETIENNE DE MER MORTE'],
  44522: ['MESANGER', 'POUILLE LES COTEAUX', 'LA ROCHE BLANCHE'],
  44420: ['MESQUER', 'PIRIAC SUR MER', 'LA TURBALLE'],
  44780: ['MISSILLAC'],
  44620: ['LA MONTAGNE'],
  44550: ['MONTOIR DE BRETAGNE', 'ST MALO DE GUERSAC'],
  44370: ['MONTRELAIS', 'LOIREAUXENCE'],
  44000: ['NANTES'],
  44100: ['NANTES'],
  44200: ['NANTES'],
  44300: ['NANTES'],
  44700: ['ORVAULT'],
  44540: ['LE PIN', 'VALLONS DE L ERDRE'],
  44770: ['LA PLAINE SUR MER', 'PREFAILLES'],
  44630: ['PLESSE'],
  44860: ['PONT ST MARTIN', 'ST AIGNAN GRANDLIEU'],
  44210: ['PORNIC'],
  44380: ['PORNICHET'],
  44710: ['PORT ST PERE', 'ST LEGER LES VIGNES'],
  44510: ['LE POULIGUEN'],
  44400: ['REZE'],
  44117: ['ST ANDRE DES EAUX'],
  44250: ['ST BREVIN LES PINS'],
  44800: ['ST HERBLAIN'],
  44720: ['ST JOACHIM'],
  44980: ['STE LUCE SUR LOIRE'],
  44730: ['ST MICHEL CHEF CHEF'],
  44600: ['ST NAZAIRE'],
  44230: ['ST SEBASTIEN SUR LOIRE'],
  44880: ['SAUTRON'],
  44840: ['LES SORINIERES'],
  44570: ['TRIGNAC'],
  44120: ['VERTOU'],
  44116: ['VIEILLEVIGNE'],
  45230: [
    'ADON',
    'AILLANT SUR MILLERON',
    'LA BUSSIERE',
    'LA CHAPELLE SUR AVEYRON',
    'LE CHARME',
    'CHATILLON COLIGNY',
    'DAMMARIE SUR LOING',
    'FEINS EN GATINAIS',
    'MONTBOUY',
    'STE GENEVIEVE DES BOIS',
    'ST MAURICE SUR AVEYRON',
  ],
  45200: ['AMILLY', 'MONTARGIS', 'PAUCOURT'],
  45480: [
    'ANDONVILLE',
    'AUTRUY SUR JUINE',
    'BAZOCHES LES GALLERANDES',
    'BOISSEAUX',
    'CHARMONT EN BEAUCE',
    'CHATILLON LE ROI',
    'CHAUSSY',
    'ERCEVILLE',
    'GRENEVILLE EN BEAUCE',
    'JOUY EN PITHIVERAIS',
    'LEOUVILLE',
    'OUTARVILLE',
  ],
  45160: ['ARDON', 'OLIVET', 'ST HILAIRE ST MESMIN'],
  45410: ['ARTENAY', 'BUCY LE ROI', 'LION EN BEAUCE', 'RUAN', 'SOUGY', 'TRINAY'],
  45170: [
    'ASCHERES LE MARCHE',
    'ATTRAY',
    'BOUGY LEZ NEUVILLE',
    'CHILLEURS AUX BOIS',
    'CROTTES EN PITHIVERAIS',
    'MONTIGNY',
    'NEUVILLE AUX BOIS',
    'OISON',
    'ST LYE LA FORET',
    'SANTEAU',
    'TIVERNON',
    'VILLEREAU',
  ],
  45300: [
    'ASCOUX',
    'AUDEVILLE',
    'BONDAROY',
    'BOUILLY EN GATINAIS',
    'BOUZONVILLE AUX BOIS',
    'BOYNES',
    'CESARVILLE DOSSAINVILLE',
    'COURCELLES LE ROI',
    'COURCY AUX LOGES',
    'DADONVILLE',
    'ENGENVILLE',
    'ESCRENNES',
    'ESTOUY',
    'GIVRAINES',
    'GUIGNEVILLE',
    'INTVILLE LA GUETARD',
    'LAAS',
    'LE MALESHERBOIS',
    'MAREAU AUX BOIS',
    'MARSAINVILLIERS',
    'MORVILLE EN BEAUCE',
    'PANNECIERES',
    'PITHIVIERS',
    'PITHIVIERS LE VIEIL',
    'RAMOULU',
    'ROUVRES ST JEAN',
    'SERMAISES',
    'THIGNONVILLE',
    'VRIGNY',
    'YEVRE LA VILLE',
  ],
  45330: ['AUGERVILLE LA RIVIERE', 'LE MALESHERBOIS'],
  45390: [
    'AULNAY LA RIVIERE',
    'BOESSES',
    'BRIARRES SUR ESSONNE',
    'BROMEILLES',
    'DESMONTS',
    'DIMANCHEVILLE',
    'ECHILLEUSES',
    'GRANGERMONT',
    'LA NEUVILLE SUR ESSONNE',
    'ONDREVILLE SUR ESSONNE',
    'ORVILLE',
    'PUISEAUX',
  ],
  45500: [
    'AUTRY LE CHATEL',
    'GIEN',
    'NEVOY',
    'POILLY LEZ GIEN',
    'ST BRISSON SUR LOIRE',
    'ST GONDON',
    'ST MARTIN SUR OCRE',
  ],
  45270: [
    'AUVILLIERS EN GATINAIS',
    'BEAUCHAMPS SUR HUILLARD',
    'BELLEGARDE',
    'CHAPELON',
    'FREVILLE DU GATINAIS',
    'LADON',
    'MEZIERES EN GATINAIS',
    'MOULON',
    'NESPLOY',
    'OUZOUER SOUS BELLEGARDE',
    'QUIERS SUR BEZONDE',
    'VILLEMOUTIERS',
  ],
  45340: [
    'AUXY',
    'BARVILLE EN GATINAIS',
    'BATILLY EN GATINAIS',
    'BEAUNE LA ROLANDE',
    'BOISCOMMUN',
    'BORDEAUX EN GATINAIS',
    'CHAMBON LA FORET',
    'EGRY',
    'GAUBERTIN',
    'JURANVILLE',
    'MONTBARROIS',
    'MONTLIARD',
    'NANCRAY SUR RIMARDE',
    'NIBELLE',
    'ST LOUP DES VIGNES',
    'ST MICHEL',
  ],
  45130: [
    'BACCON',
    'LE BARDON',
    'BAULE',
    'CHARSONVILLE',
    'COULMIERS',
    'EPIEDS EN BEAUCE',
    'HUISSEAU SUR MAUVES',
    'MEUNG SUR LOIRE',
    'ROZIERES EN BEAUCE',
    'ST AY',
  ],
  45420: [
    'BATILLY EN PUISAYE',
    'BONNY SUR LOIRE',
    'CHAMPOULET',
    'DAMMARIE EN PUISAYE',
    'FAVERELLES',
    'THOU',
  ],
  45210: [
    'BAZOCHES SUR LE BETZ',
    'LE BIGNON MIRABEAU',
    'LA CHAPELLE ST SEPULCRE',
    'CHEVANNES',
    'CHEVRY SOUS LE BIGNON',
    'FERRIERES EN GATINAIS',
    'FONTENAY SUR LOING',
    'GRISELLES',
    'LOUZOUER',
    'MERINVILLE',
    'NARGIS',
    'PERS EN GATINAIS',
    'ROZOY LE VIEIL',
    'LA SELLE EN HERMOY',
    'LA SELLE SUR LE BIED',
    'THORAILLES',
  ],
  45190: ['BEAUGENCY', 'CRAVANT', 'MESSAS', 'TAVERS', 'VILLORCEAU'],
  45630: ['BEAULIEU SUR LOIRE'],
  45760: ['BOIGNY SUR BIONNE', 'MARIGNY LES USAGES', 'VENNECY'],
  45290: [
    'BOISMORAND',
    'LES CHOUX',
    'LANGESSE',
    'LE MOULINET SUR SOLIN',
    'NOGENT SUR VERNISSON',
    'OUSSOY EN GATINAIS',
    'OUZOUER DES CHAMPS',
    'PRESSIGNY LES PINS',
    'VARENNES CHANGY',
  ],
  45460: ['BONNEE', 'LES BORDES', 'BOUZY LA FORET', 'BRAY ST AIGNAN'],
  45430: ['BOU', 'CHECY', 'MARDIE'],
  45140: ['BOULAY LES BARRES', 'BUCY ST LIPHARD', 'INGRE', 'ORMES', 'ST JEAN DE LA RUELLE'],
  45250: ['BRETEAU', 'BRIARE', 'ESCRIGNELLES', 'OUSSON SUR LOIRE', 'OUZOUER SUR TREZEE'],
  45310: [
    'BRICY',
    'LA CHAPELLE ONZERAIN',
    'COINCES',
    'GEMIGNY',
    'PATAY',
    'ROUVRAY STE CROIX',
    'ST PERAVY LA COLOMBE',
    'ST SIGISMOND',
    'TOURNOISIS',
    'VILLAMBLAIN',
    'VILLENEUVE SUR CONIE',
  ],
  45120: ['CEPOY', 'CHALETTE SUR LOING', 'CORQUILLEROY', 'GIROLLES'],
  45520: ['CERCOTTES', 'CHEVILLY', 'GIDY', 'HUETRE'],
  45620: ['CERDON', 'ISDES'],
  45360: ['CERNOY EN BERRY', 'CHATILLON SUR LOIRE', 'PIERREFITTE ES BOIS', 'ST FIRMIN SUR LOIRE'],
  45260: [
    'CHAILLY EN GATINAIS',
    'CHATENOY',
    'COUDROY',
    'LA COUR MARIGNY',
    'LORRIS',
    'MONTEREAU',
    'NOYERS',
    'PRESNOY',
    'THIMORY',
    'VIEILLES MAISONS SUR JOUDRY',
  ],
  45380: ['CHAINGY', 'LA CHAPELLE ST MESMIN'],
  45400: ['CHANTEAU', 'FLEURY LES AUBRAIS', 'SEMOY'],
  45320: [
    'CHANTECOQ',
    'COURTEMAUX',
    'COURTENAY',
    'ERVAUVILLE',
    'FOUCHEROLLES',
    'ST HILAIRE LES ANDRESIS',
  ],
  45110: ['CHATEAUNEUF SUR LOIRE', 'GERMIGNY DES PRES', 'ST MARTIN D ABBAT', 'SIGLOY'],
  45220: [
    'CHATEAU RENARD',
    'CHUELLES',
    'DOUCHY MONTCORBON',
    'GY LES NONAINS',
    'MELLEROY',
    'ST FIRMIN DES BOIS',
    'ST GERMAIN DES PRES',
    'TRIGUERES',
  ],
  45700: [
    'CHEVILLON SUR HUILLARD',
    'CONFLANS SUR LOING',
    'CORTRAT',
    'LOMBREUIL',
    'MONTCRESSON',
    'MORMANT SUR VERNISSON',
    'PANNES',
    'ST HILAIRE SUR PUISEAUX',
    'ST MAURICE SUR FESSARD',
    'SOLTERRE',
    'VILLEMANDEUR',
    'VILLEVOQUES',
    'VIMORY',
  ],
  45370: ['CLERY ST ANDRE', 'DRY', 'JOUY LE POTIER', 'MAREAU AUX PRES', 'MEZIERES LEZ CLERY'],
  45800: ['COMBLEUX', 'ST JEAN DE BRAYE'],
  45530: ['COMBREUX', 'SEICHEBRIERES', 'SURY AUX BOIS', 'VITRY AUX LOGES'],
  45490: [
    'CORBEILLES',
    'COURTEMPIERRE',
    'GONDREVILLE',
    'LORCY',
    'MIGNERES',
    'MIGNERETTE',
    'PREFONTAINES',
    'SCEAUX DU GATINAIS',
    'TREILLES EN GATINAIS',
  ],
  45720: ['COULLONS'],
  45570: ['DAMPIERRE EN BURLY', 'OUZOUER SUR LOIRE'],
  45150: ['DARVOY', 'FEROLLES', 'JARGEAU', 'OUVROUER LES CHAMPS'],
  45450: ['DONNERY', 'FAY AUX LOGES', 'INGRANNES', 'SULLY LA CHAPELLE'],
  45680: ['DORDIVES'],
  45240: [
    'LA FERTE ST AUBIN',
    'LIGNY LE RIBAULT',
    'MARCILLY EN VILLETTE',
    'MENESTREAU EN VILLETTE',
    'SENNELY',
  ],
  45600: [
    'GUILLY',
    'LION EN SULLIAS',
    'ST AIGNAN LE JAILLARD',
    'ST FLORENT',
    'ST PERE SUR LOIRE',
    'SULLY SUR LOIRE',
    'VIGLAIN',
    'VILLEMURLIN',
  ],
  45740: ['LAILLY EN VAL'],
  45470: ['LOURY', 'REBRECHIEN', 'TRAINOU'],
  45510: ['NEUVY EN SULLIAS', 'TIGY', 'VANNES SUR COSSON', 'VIENNE EN VAL'],
  45000: ['ORLEANS'],
  45100: ['ORLEANS'],
  45730: ['ST BENOIT SUR LOIRE'],
  45590: ['ST CYR EN VAL'],
  45550: ['ST DENIS DE L HOTEL'],
  45560: ['ST DENIS EN VAL'],
  45650: ['ST JEAN LE BLANC'],
  45750: ['ST PRYVE ST MESMIN'],
  45640: ['SANDILLON'],
  45770: ['SARAN'],
  46140: [
    'ALBAS',
    'ANGLARS JUILLAC',
    'BELAYE',
    'CAILLAC',
    'CAMBAYRAC',
    'CARNAC ROUFFIAC',
    'CASTELFRANC',
    'DOUELLE',
    'LUZECH',
    'PARNAC',
    'ST VINCENT RIVE D OLT',
    'SAUZET',
  ],
  46500: [
    'ALBIAC',
    'ALVIGNAC',
    'LE BASTIT',
    'BIO',
    'CARLUCET',
    'COUZOU',
    'GRAMAT',
    'ISSENDOLUS',
    'LAVERGNE',
    'MAYRINHAC LENTOUR',
    'MIERS',
    'PADIRAC',
    'REILHAC',
    'RIGNAC',
    'ROCAMADOUR',
    'SAIGNES',
    'THEGRA',
  ],
  46120: [
    'ANGLARS',
    'AYNAC',
    'LE BOURG',
    'LE BOUYSSOU',
    'ESPEYROUX',
    'LABATHUDE',
    'LACAPELLE MARIVAL',
    'LEYME',
    'MOLIERES',
    'RUDELLE',
    'RUEYRES',
    'ST BRESSOU',
    'STE COLOMBE',
    'ST MAURICE EN QUERCY',
    'TERROU',
    'THEMINES',
    'THEMINETTES',
  ],
  46300: [
    'ANGLARS NOZAC',
    'FAJOLES',
    'GINOUILLAC',
    'GOURDON',
    'LEOBARD',
    'MILHAC',
    'PAYRIGNAC',
    'ROUFFILHAC',
    'ST CIRQ MADELON',
    'ST CIRQ SOUILLAGUET',
    'ST CLAIR',
    'ST PROJET',
    'SOUCIRAC',
    'LE VIGAN',
  ],
  46090: [
    'ARCAMBAL',
    'AUJOLS',
    'BERGANTY',
    'ESCLAUZELS',
    'ESPERE',
    'FLAUJAC POUJOLS',
    'FRANCOULES',
    'LABASTIDE MARNHAC',
    'LAMAGDELAINE',
    'BELLEFONT LA RAUZE',
    'MAXOU',
    'MERCUES',
    'LE MONTAT',
    'PRADINES',
    'ST GERY VERS',
    'TRESPOUX RASSIELS',
    'VILLESEQUE',
    'ST PIERRE LAFEUILLE',
  ],
  46250: [
    'LES ARQUES',
    'CAZALS',
    'FRAYSSINET LE GELAT',
    'GINDOU',
    'GOUJOUNAC',
    'MARMINIAC',
    'MONTCLERA',
    'POMAREDE',
    'ST CAPRAIS',
  ],
  46320: [
    'ASSIER',
    'BRENGUES',
    'DURBANS',
    'ESPAGNAC STE EULALIE',
    'ESPEDAILLAC',
    'FLAUJAC GARE',
    'GREZES',
    'ISSEPTS',
    'LIVERNON',
    'QUISSAC EN QUERCY',
    'REYREVIGNES',
    'ST SIMON',
    'SONAC',
  ],
  46400: [
    'AUTOIRE',
    'BANNES',
    'FRAYSSINHES',
    'LADIRAT',
    'LATOUILLE LENTILLAC',
    'ST CERE',
    'ST JEAN LESPINASSE',
    'ST LAURENT LES TOURS',
    'ST MEDARD DE PRESQUE',
    'ST PAUL DE VERN',
    'ST VINCENT DU PENDIT',
    'ST JEAN LAGINESTE',
  ],
  46230: [
    'BACH',
    'BELFORT DU QUERCY',
    'BELMONT STE FOI',
    'CIEURAC',
    'CREMPS',
    'ESCAMPS',
    'FONTANES',
    'LABURGADE',
    'LALBENQUE',
    'MONTDOUMERC',
    'VAYLATS',
  ],
  46270: [
    'BAGNAC SUR CELE',
    'CUZAC',
    'FELZINS',
    'LINAC',
    'MONTREDON',
    'PRENDEIGNES',
    'ST JEAN MIRABEL',
  ],
  46600: [
    'BALADOU',
    'CRESSENSAC SARRAZAC',
    'CREYSSE',
    'CUZANCE',
    'FLOIRAC',
    'GIGNAC',
    'MARTEL',
    'MONTVALENT',
    'LE VIGNON EN QUERCY',
    'ST DENIS LES MARTEL',
  ],
  46260: [
    'BEAUREGARD',
    'CONCOTS',
    'LARAMIERE',
    'LIMOGNE EN QUERCY',
    'LUGAGNAC',
    'PROMILHANES',
    'PUYJOURDES',
    'SAILLAC',
    'ST JEAN DE LAUR',
    'VARAIRE',
    'VIDAILLAC',
  ],
  46100: [
    'BEDUER',
    'BOUSSAC',
    'CAMBES',
    'CAMBOULIT',
    'CAMBURAT',
    'CAPDENAC',
    'CARDAILLAC',
    'CORN',
    'FAYCELLES',
    'FIGEAC',
    'FONS',
    'FOURMAGNAC',
    'LENTILLAC ST BLAISE',
    'LISSAC ET MOURET',
    'LUNAN',
    'PLANIOLES',
    'ST FELIX',
    'ST PERDOUX',
    'VIAZAC',
  ],
  46130: [
    'BELMONT BRETENOUX',
    'BIARS SUR CERE',
    'BRETENOUX',
    'CAHUS',
    'CORNAC',
    'ESTAL',
    'GAGNAC SUR CERE',
    'GINTRAC',
    'GIRAC',
    'GLANES',
    'LAVAL DE CERE',
    'LOUBRESSAC',
    'PRUDHOMAT',
    'PUYBRUN',
    'ST MICHEL LOUBEJOU',
    'TAURIAC',
  ],
  46110: [
    'BETAILLE',
    'CARENNAC',
    'CAVAGNAC',
    'CONDAT',
    'LE VIGNON EN QUERCY',
    'ST MICHEL DE BANNIERES',
    'STRENQUELS',
    'VAYRAC',
  ],
  46330: [
    'BLARS',
    'BOUZIES',
    'CABRERETS',
    'CENEVIERES',
    'CREGOLS',
    'LENTILLAC DU CAUSSE',
    'ORNIAC',
    'ST CIRQ LAPOPIE',
    'ST GERY VERS',
    'ST MARTIN LABOUVAL',
    'SAULIAC SUR CELE',
    'TOUR DE FAURE',
  ],
  46150: [
    'BOISSIERES',
    'CALAMANE',
    'CATUS',
    'CRAYSSAC',
    'GIGOUZAC',
    'LES JUNIES',
    'LABASTIDE DU VERT',
    'LHERM',
    'MECHMONT',
    'MONTGESTY',
    'NUZEJOULS',
    'PONTCIRQ',
    'ST DENIS CATUS',
    'ST MEDARD',
    'THEDIRAC',
  ],
  46800: [
    'PORTE DU QUERCY',
    'MONTCUQ EN QUERCY BLANC',
    'MONTLAUZUN',
    'LENDOU EN QUERCY',
    'BARGUELONNE EN QUERCY',
  ],
  46160: [
    'CADRIEU',
    'CAJARC',
    'CALVIGNAC',
    'CARAYAC',
    'FRONTENAC',
    'GREALOU',
    'LARNAGOL',
    'LARROQUE TOIRAC',
    'MARCILHAC SUR CELE',
    'MONTBRUN',
    'ST CHELS',
    'ST PIERRE TOIRAC',
    'ST SULPICE',
  ],
  46000: ['CAHORS'],
  46350: [
    'CALES',
    'LAMOTHE FENELON',
    'LOUPIAC',
    'MASCLAT',
    'NADAILLAC DE ROUGE',
    'PAYRAC',
    'REILHAGUET',
  ],
  46240: [
    'CANIAC DU CAUSSE',
    'COEUR DE CAUSSE',
    'LAMOTHE CASSEL',
    'LUNEGARDE',
    'MONTFAUCON',
    'SENIERGUES',
    'SOULOMES',
    'USSEL',
  ],
  46700: [
    'CASSAGNES',
    'DURAVEL',
    'FLORESSAS',
    'GREZELS',
    'LACAPELLE CABANAC',
    'MAUROUX',
    'MONTCABRIER',
    'PUY L EVEQUE',
    'ST MARTIN LE REDON',
    'SERIGNAC',
    'SOTURAC',
    'TOUZAC',
    'VIRE SUR LOT',
  ],
  46170: ['CASTELNAU MONTRATIER', 'CEZAC', 'ST PAUL FLAUGNAC', 'LHOSPITALET', 'PERN'],
  46310: [
    'CONCORES',
    'FRAYSSINET',
    'MONTAMEL',
    'PEYRILLES',
    'ST CHAMARAND',
    'ST GERMAIN DU BEL AIR',
    'UZECH',
  ],
  46360: ['CRAS', 'LAUZES', 'NADILLAC', 'SABADEL LAUZES', 'LES PECHS DU VERS', 'SENAILLAC LAUZES'],
  46340: ['DEGAGNAC', 'LAVERCANTIERE', 'RAMPOUX', 'SALVIAC'],
  46210: [
    'GORSES',
    'LABASTIDE DU HAUT MONT',
    'LATRONQUIERE',
    'LAURESSES',
    'MONTET ET BOUXAL',
    'SABADEL LATRONQUIERE',
    'ST CIRGUES',
    'ST HILAIRE',
    'ST MEDARD NICOURBY',
    'SENAILLAC LATRONQUIERE',
    'BESSONIES',
  ],
  46200: [
    'LACAVE',
    'LACHAPELLE AUZAC',
    'LANZAC',
    'MEYRONNE',
    'PINSAC',
    'LE ROC',
    'ST SOZY',
    'SOUILLAC',
    'MAYRAC',
  ],
  46220: ['LAGARDELLE', 'PESCADOIRES', 'PRAYSSAC'],
  46190: ['SOUSCEYRAC EN QUERCY', 'TEYSSIEU'],
  47000: ['AGEN'],
  47350: [
    'AGME',
    'CAMBES',
    'ESCASSEFORT',
    'LABRETONIE',
    'LACHAPELLE',
    'MONTIGNAC TOUPINERIE',
    'PEYRIERE',
    'PUYMICLAN',
    'ST AVIT',
    'ST BARTHELEMY D AGENAIS',
    'SEYCHES',
  ],
  47800: [
    'AGNAC',
    'ALLEMANS DU DROPT',
    'ARMILLAC',
    'LAPERCHE',
    'LAVERGNE',
    'MIRAMONT DE GUYENNE',
    'MONTIGNAC DE LAUZUN',
    'MOUSTIER',
    'PUYSSERAMPION',
    'ROUMAGNE',
    'ST PARDOUX ISAAC',
    'LA SAUVETAT DU DROPT',
  ],
  47190: ['AIGUILLON', 'GALAPIAN', 'LAGARRIGUE', 'NICOLE'],
  47110: ['ALLEZ ET CAZENEUVE', 'DOLMAYRAC', 'STE LIVRADE SUR LOT', 'LE TEMPLE SUR LOT'],
  47420: ['ALLONS', 'BOUSSES', 'DURANCE', 'HOUEILLES', 'POMPOGNE', 'SAUMEJAN'],
  47160: [
    'AMBRUS',
    'BUZET SUR BAISE',
    'CAUBEYRES',
    'DAMAZAN',
    'MONHEURT',
    'PUCH D AGENAIS',
    'RAZIMET',
    'ST LEGER',
    'ST LEON',
    'ST PIERRE DE BUZET',
    'VILLEFRANCHE DU QUEYRAN',
  ],
  47170: [
    'ANDIRAN',
    'LANNES',
    'MEZIN',
    'POUDENAS',
    'REAUP LISSE',
    'STE MAURE DE PEYRIAC',
    'ST PE ST SIMON',
    'SOS',
  ],
  47700: [
    'ANTAGNAC',
    'ANZEX',
    'BEAUZIAC',
    'CASTELJALOUX',
    'FARGUES SUR OURBISE',
    'LEYRITZ MONCASSIN',
    'PINDERES',
    'POUSSIGNAC',
    'LA REUNION',
    'RUFFIAC',
    'ST MARTIN CURTON',
  ],
  47370: [
    'ANTHE',
    'BOURLENS',
    'CAZIDEROQUE',
    'COURBIAC',
    'MASQUIERES',
    'THEZAC',
    'TOURNON D AGENAIS',
    'ST GEORGES',
  ],
  47250: [
    'ARGENTON',
    'BOUGLON',
    'COCUMONT',
    'GREZET CAVAGNAN',
    'GUERIN',
    'LABASTIDE CASTEL AMOUROUX',
    'ROMESTAING',
    'STE GEMME MARTAILLAC',
    'SAMAZAN',
  ],
  47220: [
    'ASTAFFORT',
    'CAUDECOSTE',
    'CUQ',
    'FALS',
    'MARMONT PACHAS',
    'ST NICOLAS DE LA BALERME',
    'ST SIXTE',
    'SAUVETERRE ST DENIS',
  ],
  47310: [
    'AUBIAC',
    'BRAX',
    'ESTILLAC',
    'LAMONTJOIE',
    'LAPLUME',
    'MOIRAX',
    'MONCAUT',
    'ROQUEFORT',
    'STE COLOMBE EN BRUILHOIS',
    'ST VINCENT DE LAMONTJOIE',
    'SERIGNAC SUR GARONNE',
  ],
  47140: [
    'AURADOU',
    'DAUSSE',
    'FRESPECH',
    'MASSELS',
    'MASSOULES',
    'PENNE D AGENAIS',
    'ST SYLVESTRE SUR LOT',
    'TREMONS',
    'TRENTELS',
  ],
  47120: [
    'AURIAC SUR DROPT',
    'BALEYSSAGUES',
    'CAUBON ST SAUVEUR',
    'DURAS',
    'ESCLOTTES',
    'LEVIGNAC DE GUYENNE',
    'LOUBES BERNAC',
    'MONTETON',
    'PARDAILLAN',
    'ST ASTIER',
    'STE COLOMBE DE DURAS',
    'ST GERAUD',
    'ST JEAN DE DURAS',
    'ST PIERRE SUR DROPT',
    'ST SERNIN',
    'SAVIGNAC DE DURAS',
    'SOUMENSAC',
    'VILLENEUVE DE DURAS',
  ],
  47480: ['BAJAMONT', 'PONT DU CASSE'],
  47230: [
    'BARBASTE',
    'FEUGAROLLES',
    'LAVARDAC',
    'MONTGAILLARD EN ALBRET',
    'POMPIEY',
    'THOUARS SUR GARONNE',
    'VIANNE',
    'XAINTRAILLES',
  ],
  47130: ['BAZENS', 'BRUCH', 'CLERMONT DESSOUS', 'MONTESQUIEU', 'PORT STE MARIE', 'ST LAURENT'],
  47290: [
    'BEAUGAS',
    'BOUDY DE BEAUREGARD',
    'CANCON',
    'CASTELNAUD DE GRATECAMBE',
    'LOUGRATTE',
    'MONBAHUS',
    'MONVIEL',
    'MOULINET',
    'ST MAURICE DE LESTAPEL',
    'ST PASTOUR',
  ],
  47200: [
    'BEAUPUY',
    'BIRAC SUR TREC',
    'FOURQUES SUR GARONNE',
    'GAUJAC',
    'LONGUEVILLE',
    'MARCELLUS',
    'MARMANDE',
    'MAUVEZIN SUR GUPIE',
    'MONTPOUILLAN',
    'ST PARDOUX DU BREUIL',
    'TAILLEBOURG',
    'VIRAZEIL',
  ],
  47470: ['BEAUVILLE', 'BLAYMONT', 'CAUZAC', 'DONDAS', 'ENGAYRAC'],
  47300: ['BIAS', 'LEDAT', 'PUJOLS', 'STE COLOMBE DE VILLENEUVE', 'VILLENEUVE SUR LOT'],
  47500: [
    'BLANQUEFORT SUR BRIOLANCE',
    'CONDEZAYGUES',
    'CUZORN',
    'FUMEL',
    'MONSEMPRON LIBOS',
    'MONTAYRAL',
    'ST FRONT SUR LEMANCE',
    'ST VITE',
    'SAUVETERRE LA LEMANCE',
  ],
  47550: ['BOE'],
  47240: ['BON ENCONTRE', 'CASTELCULIER', 'LAFOX'],
  47410: ['BOURGOUGNAGUE', 'LAUZUN', 'ST COLOMB DE LAUZUN', 'SEGALAS', 'SERIGNAC PEBOUDOU'],
  47210: [
    'BOURNEL',
    'DEVILLAC',
    'DOUDRAC',
    'MAZIERES NARESSE',
    'MONTAUT',
    'PARRANQUET',
    'RAYET',
    'RIVES',
    'ST ETIENNE DE VILLEREAL',
    'ST EUTROPE DE BORN',
    'ST MARTIN DE VILLEREAL',
    'TOURLIAC',
    'VILLEREAL',
  ],
  47320: ['BOURRAN', 'CLAIRAC', 'LAFITTE SUR LOT'],
  47260: [
    'BRUGNAC',
    'CASTELMORON SUR LOT',
    'COULX',
    'FONGRAVE',
    'GRANGES SUR LOT',
    'LAPARADE',
    'VERTEUIL D AGENAIS',
  ],
  47330: [
    'CAHUZAC',
    'CASTILLONNES',
    'CAVARC',
    'DOUZAINS',
    'FERRENSAC',
    'LALANDUSSE',
    'MONTAURIOL',
    'ST QUENTIN DU DROPT',
  ],
  47600: [
    'CALIGNAC',
    'ESPIENS',
    'FIEUX',
    'FRANCESCAS',
    'FRECHOU',
    'LASSERRE',
    'MONCRABEAU',
    'MONTAGNAC SUR AUVIGNON',
    'NERAC',
    'NOMDIEU',
    'SAUMONT',
  ],
  47430: ['CALONGES', 'CAUMONT SUR GARONNE', 'LE MAS D AGENAIS', 'STE MARTHE', 'SENESTIS'],
  47440: ['CASSENEUIL', 'PAILLOLES'],
  47340: [
    'CASSIGNAS',
    'CASTELLA',
    'LA CROIX BLANCHE',
    'HAUTEFAGE LA TOUR',
    'LAROQUE TIMBAUT',
    'MONBALEN',
    'ST ANTOINE DE FICALBA',
    'ST ROBERT',
    'SAUVAGNAS',
  ],
  47180: [
    'CASTELNAU SUR GUPIE',
    'COUTHURES SUR GARONNE',
    'JUSIX',
    'LAGUPIE',
    'MEILHAN SUR GARONNE',
    'STE BAZEILLE',
    'ST MARTIN PETIT',
    'ST SAUVEUR DE MEILHAN',
  ],
  47270: [
    'CLERMONT SOUBIRAN',
    'GRAYSSAS',
    'PUYMIROL',
    'ST CAPRAIS DE LERM',
    'ST JEAN DE THURAC',
    'ST MARTIN DE BEAUVILLE',
    'ST MAURIN',
    'ST PIERRE DE CLAIRAC',
    'ST ROMAIN LE NOBLE',
    'ST URCISSE',
    'LA SAUVETAT DE SAVERES',
    'TAYRAC',
  ],
  47450: ['COLAYRAC ST CIRQ', 'ST HILAIRE DE LUSIGNAN'],
  47360: [
    'COURS',
    'FREGIMONT',
    'LACEPEDE',
    'LAUGNAC',
    'LUSIGNAN PETIT',
    'MADAILLAN',
    'MONTPEZAT',
    'PRAYSSAS',
    'ST SALVY',
    'ST SARDOS',
    'SEMBAS',
  ],
  47400: [
    'FAUGUEROLLES',
    'FAUILLET',
    'GONTAUD DE NOGARET',
    'GRATELOUP ST GAYRAND',
    'HAUTESVIGNES',
    'LAGRUERE',
    'TONNEINS',
    'VARES',
    'VILLETON',
  ],
  47510: ['FOULAYRONNES'],
  47150: [
    'GAVAUDUN',
    'LACAPELLE BIRON',
    'LACAUSSADE',
    'LAUSSOU',
    'MONFLANQUIN',
    'MONSEGUR',
    'MONTAGNAC SUR LEDE',
    'PAULHIAC',
    'ST AUBIN',
    'SALLES',
    'LA SAUVETAT SUR LEDE',
    'SAVIGNAC SUR LEYZE',
  ],
  47390: ['LAYRAC'],
  47380: [
    'MONCLAR',
    'MONTASTRUC',
    'PINEL HAUTERIVE',
    'ST ETIENNE DE FOUGERES',
    'TOMBEBOEUF',
    'TOURTRES',
    'VILLEBRAMAR',
  ],
  47520: ['LE PASSAGE'],
  48310: [
    'ALBARET LE COMTAL',
    'ARZENC D APCHER',
    'BRION',
    'CHAUCHAILLES',
    'LA FAGE MONTIVERNOUX',
    'FOURNELS',
    'NOALHAC',
    'ST JUERY',
    'ST LAURENT DE VEYRES',
    'TERMES',
  ],
  48200: [
    'ALBARET STE MARIE',
    'LES MONTS VERTS',
    'LES BESSONS',
    'BLAVIGNAC',
    'LA FAGE ST JULIEN',
    'PRUNIERES',
    'RIMEIZE',
    'ST CHELY D APCHER',
    'ST PIERRE LE VIEUX',
  ],
  48190: ['ALLENC', 'MONT LOZERE ET GOULET', 'CHADENET', 'CUBIERES', 'CUBIERETTES', 'STE HELENE'],
  48800: [
    'ALTIER',
    'PIED DE BORNE',
    'POURCHARESSES',
    'PREVENCHERES',
    'ST ANDRE CAPCEZE',
    'VILLEFORT',
  ],
  48100: [
    'ANTRENAS',
    'LE BUISSON',
    'GABRIAS',
    'GREZES',
    'PRINSUEJOLS MALBOUZON',
    'MARVEJOLS',
    'BOURGS SUR COLAGNE',
    'MONTRODAT',
    'PALHERS',
    'RECOULES DE FUMAS',
    'LACHAMP RIBENNES',
    'ST BONNET DE CHIRAC',
    'ST LAURENT DE MURET',
    'ST LEGER DE PEYRE',
    'LES SALCES',
  ],
  48170: [
    'ARZENC DE RANDON',
    'MONT LOZERE ET GOULET',
    'CHATEAUNEUF DE RANDON',
    'CHAUDEYRAC',
    'LAUBERT',
    'MONTBEL',
    'ST FREZAL D ALBUGES',
    'ST JEAN LA FOUILLOUSE',
    'ST SAUVEUR DE GINESTOUX',
  ],
  48130: ['PEYRE EN AUBRAC'],
  48600: [
    'AUROUX',
    'BEL AIR VAL D ANCE',
    'GRANDRIEU',
    'LA PANOUSE',
    'ST BONNET LAVAL',
    'ST PAUL LE FROID',
  ],
  48000: [
    'BADAROUX',
    'BALSIEGES',
    'BARJAC',
    'LE BORN',
    'BRENOUX',
    'CHASTEL NOUVEL',
    'LANUEJOLS',
    'MENDE',
    'PELOUSE',
    'MONTS DE RANDON',
    'ST BAUZILE',
    'ST ETIENNE DU VALDONNEZ',
  ],
  48500: [
    'BANASSAC CANILHAC',
    'LA CANOURGUE',
    'LAVAL DU TARN',
    'MASSEGROS CAUSSES GORGES',
    'ST SATURNIN',
    'LA TIEULE',
  ],
  48400: [
    'BARRE DES CEVENNES',
    'BASSURELS',
    'LES BONDONS',
    'CASSAGNAS',
    'BEDOUES COCURES',
    'FLORAC TROIS RIVIERES',
    'FRAISSINET DE FOURQUES',
    'ROUSSES',
    'CANS ET CEVENNES',
    'VEBRON',
  ],
  48230: ['CHANAC', 'CULTURES', 'ESCLANEDES', 'LES SALELLES'],
  48300: [
    'CHASTANIER',
    'CHEYLARD L EVEQUE',
    'LANGOGNE',
    'NAUSSAC FONTANES',
    'PIERREFICHE',
    'ROCLES',
    'ST FLOUR DE MERCOIRE',
  ],
  48140: [
    'CHAULHAC',
    'JULIANGES',
    'LE MALZIEU FORAIN',
    'LE MALZIEU VILLE',
    'PAULHAC EN MARGERIDE',
    'ST LEGER DU MALZIEU',
    'ST PRIVAT DU FAU',
  ],
  48160: [
    'LE COLLET DE DEZE',
    'VENTALON EN CEVENNES',
    'ST HILAIRE DE LAVIT',
    'ST JULIEN DES POINTS',
    'ST MARTIN DE BOUBAUX',
    'ST MICHEL DE DEZE',
  ],
  48700: [
    'FONTANS',
    'LES LAUBIES',
    'LACHAMP RIBENNES',
    'MONTS DE RANDON',
    'ST DENIS EN MARGERIDE',
    'ST GAL',
    'SERVERETTE',
  ],
  48110: [
    'GABRIAC',
    'MOISSAC VALLEE FRANCAISE',
    'MOLEZON',
    'LE POMPIDOU',
    'STE CROIX VALLEE FRANCAISE',
    'ST MARTIN DE LANSUSCLE',
  ],
  48150: ['GATUZIERES', 'HURES LA PARADE', 'MEYRUEIS', 'LE ROZIER', 'ST PIERRE DES TRIPIERS'],
  48260: ['GRANDVALS', 'MARCHASTEL', 'NASBINALS', 'RECOULES D AUBRAC'],
  48340: ['LES HERMAUX', 'ST GERMAIN DU TEIL', 'ST PIERRE DE NOGARET', 'TRELANS'],
  48320: ['ISPAGNAC', 'GORGES DU TARN CAUSSES'],
  48120: ['LAJO', 'ST ALBAN SUR LIMAGNOLE', 'STE EULALIE'],
  48270: ['PRINSUEJOLS MALBOUZON'],
  48210: ['LA MALENE', 'MASSEGROS CAUSSES GORGES', 'MAS ST CHELY', 'GORGES DU TARN CAUSSES'],
  48220: ['PONT DE MONTVERT SUD MONT LOZERE', 'VIALAS'],
  48240: ['ST ANDRE DE LANCIZE', 'VENTALON EN CEVENNES', 'ST PRIVAT DE VALLONGUE'],
  48330: ['ST ETIENNE VALLEE FRANCAISE'],
  48370: ['ST GERMAIN DE CALBERTE'],
  49650: ['ALLONNES', 'BRAIN SUR ALLONNES'],
  49700: [
    'TUFFALUN',
    'BROSSAY',
    'CIZAY LA MADELEINE',
    'DENEZE SOUS DOUE',
    'DOUE EN ANJOU',
    'LOURESSE ROCHEMENIER',
    'LES ULMES',
  ],
  49000: ['ANGERS', 'ECOUFLANT'],
  49100: ['ANGERS'],
  49440: ['ANGRIE', 'CANDE', 'CHALLAIN LA POTHERIE', 'LOIRE', 'VAL D ERDRE AUXENCE'],
  49260: [
    'ANTOIGNE',
    'ARTANNES SUR THOUET',
    'BELLEVIGNE LES CHATEAUX',
    'LE COUDRAY MACOUARD',
    'COURCHAMPS',
    'EPIEDS',
    'MONTREUIL BELLAY',
    'LE PUY NOTRE DAME',
    'ST JUST SUR DIVE',
    'ST MACAIRE DU BOIS',
    'VAUDELNAY',
  ],
  49420: ['ARMAILLE', 'CARBAY', 'OMBREE D ANJOU'],
  49540: ['AUBIGNE SUR LAYON', 'TERRANJOU', 'LYS HAUT LAYON'],
  49240: ['AVRILLE'],
  49430: ['BARACE', 'DURTAL', 'HUILLE LEZIGNE', 'MONTIGNE LES RAIRIES', 'LES RAIRIES'],
  49150: ['BAUGE EN ANJOU', 'LA LANDE CHASLES'],
  49070: ['BEAUCOUZE', 'ST LAMBERT LA POTHERIE', 'ST LEGER DE LINIERES'],
  49250: [
    'BEAUFORT EN ANJOU',
    'BRISSAC LOIRE AUBANCE',
    'LES BOIS D ANJOU',
    'LA MENITRE',
    'LOIRE AUTHION',
  ],
  49750: ['BEAULIEU SUR LAYON', 'CHEMILLE EN ANJOU', 'VAL DU LAYON', 'BELLEVIGNE EN LAYON'],
  49110: ['BEAUPREAU EN MAUGES', 'MONTREVAULT SUR EVRE', 'MAUGES SUR LOIRE'],
  49450: ['BEAUPREAU EN MAUGES', 'SEVREMOINE'],
  49510: ['BEAUPREAU EN MAUGES'],
  49600: ['BEAUPREAU EN MAUGES', 'MONTREVAULT SUR EVRE'],
  49370: ['BECON LES GRANITS', 'VAL D ERDRE AUXENCE', 'ST CLEMENT DE LA PLACE', 'ERDRE EN ANJOU'],
  49122: ['BEGROLLES EN MAUGES', 'LE MAY SUR EVRE'],
  49170: [
    'BEHUARD',
    'LA POSSONNIERE',
    'ST AUGUSTIN DES BOIS',
    'ST GEORGES SUR LOIRE',
    'ST GERMAIN DES PRES',
    'ST LEGER DE LINIERES',
    'ST MARTIN DU FOUILLOUX',
    'SAVENNIERES',
  ],
  49320: [
    'BLAISON ST SULPICE',
    'BRISSAC LOIRE AUBANCE',
    'LES GARENNES SUR LOIRE',
    'GENNES VAL DE LOIRE',
  ],
  49160: ['BLOU', 'LONGUE JUMELLES', 'GENNES VAL DE LOIRE', 'ST PHILBERT DU PEUPLE'],
  49080: ['BOUCHEMAINE'],
  49520: ['BOUILLE MENARD', 'BOURG L EVEQUE', 'OMBREE D ANJOU', 'SEGRE EN ANJOU BLEU'],
  49390: [
    'LA BREILLE LES PINS',
    'COURLEON',
    'MOULIHERNE',
    'NOYANT VILLAGES',
    'VERNANTES',
    'VERNOIL LE FOURRIER',
  ],
  49125: ['BRIOLLAY', 'CHEFFES', 'TIERCE'],
  49460: ['CANTENAY EPINARD', 'ECUILLE', 'FENEU', 'MONTREUIL JUIGNE', 'SOULAIRE ET BOURG'],
  49310: ['CERNUSSON', 'CHEMILLE EN ANJOU', 'MONTILLIERS', 'ST PAUL DU BOIS', 'LYS HAUT LAYON'],
  49360: ['LES CERQUEUX', 'MAULEVRIER', 'LA PLAINE', 'SOMLOIRE', 'TOUTLEMONDE', 'YZERNAY'],
  49400: [
    'BELLEVIGNE LES CHATEAUX',
    'DISTRE',
    'ROU MARSON',
    'SAUMUR',
    'SOUZAY CHAMPIGNY',
    'VARRAINS',
    'VERRIE',
    'VILLEBERNIER',
  ],
  49290: ['CHALONNES SUR LOIRE', 'CHAUDEFONDS SUR LAYON', 'MAUGES SUR LOIRE'],
  49220: [
    'CHAMBELLAY',
    'CHENILLE CHAMPTEUSSE',
    'GREZ NEUVILLE',
    'LA JAILLE YVON',
    'LE LION D ANGERS',
    'LONGUENEE EN ANJOU',
    'MONTREUIL SUR MAINE',
    'THORIGNE D ANJOU',
    'ERDRE EN ANJOU',
  ],
  49123: ['CHAMPTOCE SUR LOIRE', 'INGRANDES LE FRESNE SUR LOIRE'],
  49270: ['OREE D ANJOU', 'MONTREVAULT SUR EVRE'],
  49530: ['OREE D ANJOU'],
  49340: ['CHANTELOUP LES BOIS', 'NUAILLE', 'TREMENTINES', 'VEZINS'],
  49140: [
    'LA CHAPELLE ST LAUD',
    'CORNILLE LES CAVES',
    'CORZE',
    'JARZE VILLAGES',
    'MARCE',
    'MAZE MILON',
    'MONTREUIL SUR LOIR',
    'LOIRE AUTHION',
    'SEICHES SUR LE LOIR',
    'SERMAISE',
    'RIVES DU LOIR EN ANJOU',
  ],
  49330: ['LES HAUTS D ANJOU', 'ETRICHE', 'JUVARDEIL', 'MIRE', 'SCEAUX D ANJOU'],
  49380: ['TERRANJOU', 'BELLEVIGNE EN LAYON'],
  49500: ['CHAZE SUR ARGOS', 'SEGRE EN ANJOU BLEU'],
  49120: ['CHEMILLE EN ANJOU'],
  49670: ['CHEMILLE EN ANJOU'],
  49300: ['CHOLET'],
  49560: ['CLERE SUR LAYON', 'PASSAVANT SUR LAYON', 'LYS HAUT LAYON'],
  49690: ['CORON'],
  49190: ['DENEE', 'ROCHEFORT SUR LOIRE', 'VAL DU LAYON'],
  49590: ['FONTEVRAUD L ABBAYE'],
  49610: [
    'LES GARENNES SUR LOIRE',
    'MOZE SUR LOUET',
    'MURS ERIGNE',
    'ST MELAINE SUR AUBANCE',
    'SOULAINES SUR AUBANCE',
  ],
  49630: ['MAZE MILON', 'LOIRE AUTHION'],
  49280: [
    'MAZIERES EN MAUGES',
    'ST CHRISTOPHE DU BOIS',
    'ST LEGER SOUS CHOLET',
    'LA SEGUINIERE',
    'LA TESSOUALLE',
  ],
  49770: ['LONGUENEE EN ANJOU'],
  49730: ['MONTSOREAU', 'PARNAY', 'TURQUANT', 'VARENNES SUR LOIRE'],
  49640: ['MORANNES SUR SARTHE DAUMERAY'],
  49680: ['NEUILLE', 'VIVY'],
  49490: ['NOYANT VILLAGES', 'LA PELLERINE'],
  49124: ['LE PLESSIS GRAMMOIRE', 'ST BARTHELEMY D ANJOU'],
  49410: ['MAUGES SUR LOIRE'],
  49570: ['MAUGES SUR LOIRE'],
  49620: ['MAUGES SUR LOIRE'],
  49130: ['LES PONTS DE CE', 'STE GEMMES SUR LOIRE', 'ST JEAN DE LA CROIX'],
  49740: ['LA ROMAGNE'],
  49350: ['GENNES VAL DE LOIRE', 'ST CLEMENT DES LEVEES'],
  49230: ['SEVREMOINE'],
  49660: ['SEVREMOINE'],
  49710: ['SEVREMOINE'],
  49800: ['LOIRE AUTHION', 'SARRIGNE', 'TRELAZE'],
  49112: ['VERRIERES EN ANJOU'],
  49480: ['VERRIERES EN ANJOU'],
  50180: ['AGNEAUX', 'THEREVAL', 'ST GILLES'],
  50230: ['AGON COUTAINVILLE'],
  50680: [
    'AIREL',
    'CERISY LA FORET',
    'COUVAINS',
    'LA LUZERNE',
    'MOON SUR ELLE',
    'ST ANDRE DE L EPINE',
    'ST CLAIR SUR L ELLE',
    'ST GEORGES D ELLE',
    'ST JEAN DE SAVIGNY',
    'VILLIERS FOSSARD',
  ],
  50620: [
    'AMIGNY',
    'CARENTAN LES MARAIS',
    'CAVIGNY',
    'LE DEZERT',
    'GRAIGNES MESNIL ANGOT',
    'LE MESNIL VENERON',
    'PONT HEBERT',
    'REMILLY LES MARAIS',
    'ST FROMOND',
    'ST JEAN DE DAYE',
    'TRIBEHOU',
  ],
  50400: ['ANCTOVILLE SUR BOSCQ', 'GRANVILLE', 'ST PLANCHERS', 'YQUELON'],
  50760: [
    'ANNEVILLE EN SAIRE',
    'BARFLEUR',
    'GATTEVILLE LE PHARE',
    'MONTFARVILLE',
    'REVILLE',
    'STE GENEVIEVE',
    'VALCANVILLE',
    'LE VICEL',
  ],
  50500: [
    'APPEVILLE',
    'AUVERS',
    'AUXAIS',
    'BAUPTE',
    'CARENTAN LES MARAIS',
    'MEAUTIS',
    'RAIDS',
    'ST ANDRE DE BOHON',
    'TERRE ET MARAIS',
  ],
  50170: [
    'AUCEY LA PLAINE',
    'BEAUVOIR',
    'HUISNES SUR MER',
    'LE MONT ST MICHEL',
    'PONTORSON',
    'SACEY',
    'SERVON',
    'TANIS',
  ],
  50480: [
    'AUDOUVILLE LA HUBERT',
    'BLOSVILLE',
    'BOUTTEVILLE',
    'CARENTAN LES MARAIS',
    'HIESVILLE',
    'LIESVILLE SUR DOUVE',
    'NEUVILLE AU PLAIN',
    'PICAUVILLE',
    'ST GERMAIN DE VARREVILLE',
    'STE MARIE DU MONT',
    'ST MARTIN DE VARREVILLE',
    'STE MERE EGLISE',
    'SEBEVILLE',
    'TURQUEVILLE',
  ],
  50630: [
    'AUMEVILLE LESTRE',
    'CRASVILLE',
    'OCTEVILLE L AVENEL',
    'LA PERNELLE',
    'QUETTEHOU',
    'TEURTHEVILLE BOCAGE',
    'LE VAST',
    'VIDECOSVILLE',
  ],
  50300: [
    'AVRANCHES',
    'LA GODEFROY',
    'MARCEY LES GREVES',
    'PONTS',
    'ST BRICE',
    'ST JEAN DE LA HAIZE',
    'ST LOUP',
    'ST OVIN',
    'ST SENIER SOUS AVRANCHES',
    'TIREPIED SUR SEE',
    'VAINS',
    'LE VAL ST PERE',
  ],
  50310: [
    'AZEVILLE',
    'ECAUSSEVILLE',
    'EMONDEVILLE',
    'EROUDEVILLE',
    'FONTENAY SUR MER',
    'FRESVILLE',
    'LE HAM',
    'JOGANVILLE',
    'LESTRE',
    'MONTEBOURG',
    'OZEVILLE',
    'QUINEVILLE',
    'ST CYR',
    'ST FLOXEL',
    'ST MARCOUF',
    'ST MARTIN D AUDOUVILLE',
    'SORTOSVILLE',
    'VAUDREVILLE',
  ],
  50530: [
    'BACILLY',
    'CHAMPEAUX',
    'DRAGEY RONTHON',
    'GENETS',
    'LOLIF',
    'ST JEAN LE THOMAS',
    'ST PIERRE LANGERS',
    'SARTILLY BAIE BOCAGE',
  ],
  50450: [
    'LA BALEINE',
    'GAVRAY SUR SIENNE',
    'GRIMESNIL',
    'HAMBYE',
    'LENGRONNE',
    'LE MESNIL GARNIER',
    'LE MESNIL VILLEMAN',
    'MONTAIGU LES BOIS',
    'ST DENIS LE GAST',
    'VER',
  ],
  50720: ['BARENTON', 'ST CYR DU BAILLEUL', 'ST GEORGES DE ROUELLEY'],
  50270: [
    'BARNEVILLE CARTERET',
    'BAUBIGNY',
    'LA HAYE D ECTOT',
    'LES MOITIERS D ALLONNE',
    'ST GEORGES DE LA RIVIERE',
    'ST JEAN DE LA RIVIERE',
    'ST MAURICE EN COTENTIN',
    'ST PIERRE D ARTHEGLISE',
    'SENOVILLE',
    'SORTOSVILLE EN BEAUMONT',
    'SURTAINVILLE',
  ],
  50810: [
    'LA BARRE DE SEMILLY',
    'BERIGNY',
    'MONTRABOT',
    'ST GERMAIN D ELLE',
    'ST JEAN D ELLE',
    'ST PIERRE DE SEMILLY',
  ],
  50000: ['BAUDRE', 'LE MESNIL ROUXELIN', 'RAMPAN', 'ST GEORGES MONTCOCQ', 'ST LO'],
  50320: [
    'BEAUCHAMPS',
    'LE GRIPPON',
    'EQUILLY',
    'FOLLIGNY',
    'LA HAYE PESNEL',
    'HOCQUIGNY',
    'LA LUCERNE D OUTREMER',
    'LA MOUCHE',
    'ST JEAN DES CHAMPS',
    'LE TANU',
  ],
  50420: [
    'BEAUCOUDRAY',
    'BEUVRIGNY',
    'CONDE SUR VIRE',
    'DOMJEAN',
    'FOURNEAUX',
    'GOUVETS',
    'MOYON VILLAGES',
    'ST LOUET SUR VIRE',
    'ST VIGOR DES MONTS',
    'TESSY BOCAGE',
  ],
  50150: ['BEAUFICEL', 'BROUAINS', 'GATHEMO', 'PERRIERS EN BEAUFICEL', 'CHAULIEU', 'SOURDEVAL'],
  50440: ['LA HAGUE'],
  50460: ['LA HAGUE', 'CHERBOURG EN COTENTIN'],
  50690: [
    'LA HAGUE',
    'COUVILLE',
    'HARDINVAST',
    'MARTINVAST',
    'NOUAINVILLE',
    'ST MARTIN LE GREARD',
    'SIDEVILLE',
    'TEURTHEVILLE HAGUE',
    'VIRANDEVILLE',
  ],
  50210: [
    'BELVAL',
    'CAMPROND',
    'CERISY LA SALLE',
    'MONTPINCHON',
    'NOTRE DAME DE CENILLY',
    'OUVILLE',
    'QUETTREVILLE SUR SIENNE',
    'RONCEY',
    'ST DENIS LE VETU',
    'ST MARTIN DE CENILLY',
    'SAVIGNY',
  ],
  50340: [
    'BENOITVILLE',
    'BRICQUEBOSQ',
    'FLAMANVILLE',
    'GROSVILLE',
    'HEAUVILLE',
    'HELLEVILLE',
    'PIERREVILLE',
    'LES PIEUX',
    'LE ROZEL',
    'ST CHRISTOPHE DU FOC',
    'ST GERMAIN LE GAILLARD',
    'SIOUVILLE HAGUE',
    'SOTTEVILLE',
    'TREAUVILLE',
  ],
  50800: [
    'BESLON',
    'LA BLOUTIERE',
    'BOISYVON',
    'BOURGUENOLLES',
    'CHAMPREPUS',
    'LA CHAPELLE CECELIN',
    'CHERENCE LE HERON',
    'LA COLOMBE',
    'FLEURY',
    'LA LANDE D AIROU',
    'STE CECILE',
    'ST MARTIN LE BOUILLANT',
    'ST MAUR DES BOIS',
    'LA TRINITE',
    'VILLEDIEU LES POELES ROUFFIGNY',
  ],
  50390: [
    'BESNEVILLE',
    'BINIVILLE',
    'CATTEVILLE',
    'GOLLEVILLE',
    'HAUTTEVILLE BOCAGE',
    'NEHOU',
    'ORGLANDES',
    'RAUVILLE LA PLACE',
    'REIGNEVILLE BOCAGE',
    'STE COLOMBE',
    'ST JACQUES DE NEHOU',
    'ST SAUVEUR LE VICOMTE',
    'TAILLEPIED',
  ],
  50360: [
    'BEUZEVILLE LA BASTILLE',
    'LA BONNEVILLE',
    'CROSVILLE SUR DOUVE',
    'ETIENVILLE',
    'PICAUVILLE',
  ],
  50160: ['BIEVILLE', 'LAMBERVILLE', 'LE PERRON', 'ST AMAND VILLAGES', 'TORIGNY LES VILLES'],
  50560: ['BLAINVILLE SUR MER', 'GEFFOSSES', 'GOUVILLE SUR MER'],
  50610: ['JULLOUVILLE'],
  50200: [
    'BRAINVILLE',
    'BRICQUEVILLE LA BLOUETTE',
    'CAMBERNON',
    'COURCY',
    'COUTANCES',
    'GOUVILLE SUR MER',
    'GRATOT',
    'HEUGUEVILLE SUR SIENNE',
    'MONTHUCHON',
    'NICORPS',
    'ST MALO DE LA LANDE',
    'ST PIERRE DE COUTANCES',
    'ST SAUVEUR VILLAGES',
    'SAUSSEY',
    'TOURVILLE SUR SIENNE',
    'LA VENDELEE',
  ],
  50370: [
    'BRECEY',
    'LA CHAISE BAUDOUIN',
    'LA CHAPELLE UREE',
    'LES CRESNAYS',
    'LE GRAND CELLAND',
    'LES LOGES SUR BRECEY',
    'NOTRE DAME DE LIVOYE',
    'LE PETIT CELLAND',
    'ST GEORGES DE LIVOYE',
    'ST JEAN DU CORAIL DES BOIS',
    'ST NICOLAS DES BOIS',
    'VERNIX',
  ],
  50290: [
    'BREHAL',
    'BREVILLE SUR MER',
    'BRICQUEVILLE SUR MER',
    'COUDEVILLE SUR MER',
    'LONGUEVILLE',
    'MUNEVILLE SUR MER',
  ],
  50110: ['BRETTEVILLE', 'CHERBOURG EN COTENTIN', 'DIGOSVILLE', 'LE MESNIL AU VAL'],
  50430: ['BRETTEVILLE SUR AY', 'LAULNE', 'LESSAY', 'ST GERMAIN SUR AY', 'VESLY'],
  50260: [
    'BREUVILLE',
    'BRICQUEBEC EN COTENTIN',
    'L ETANG BERTRAND',
    'MAGNEVILLE',
    'NEGREVILLE',
    'RAUVILLE LA BIGOT',
    'ROCHEVILLE',
    'SOTTEVAST',
  ],
  50330: [
    'BRILLEVAST',
    'CANTELOUP',
    'CARNEVILLE',
    'CLITOURPS',
    'VICQ SUR MER',
    'GONNEVILLE LE THEIL',
    'MAUPERTUS SUR MER',
    'ST PIERRE EGLISE',
    'THEVILLE',
    'TOCQUEVILLE',
    'VAROUVILLE',
  ],
  50700: [
    'BRIX',
    'COLOMBY',
    'FLOTTEMANVILLE',
    'HEMEVEZ',
    'HUBERVILLE',
    'LIEUSAINT',
    'MONTAIGU LA BRISETTE',
    'MORVILLE',
    'ST GERMAIN DE TOURNEBUT',
    'ST JOSEPH',
    'SAUSSEMESNIL',
    'TAMERVILLE',
    'URVILLE',
    'VALOGNES',
    'YVETOT BOCAGE',
  ],
  50640: ['BUAIS LES MONTS', 'SAVIGNY LE VIEUX', 'LE TEILLEUL'],
  50570: [
    'CAMETOURS',
    'CARANTILLY',
    'HAUTEVILLE LA GUICHARD',
    'THEREVAL',
    'LE LOREY',
    'MARIGNY LE LOZON',
    'LE MESNIL AMEY',
    'LE MESNIL EURY',
    'MONTREUIL SUR LOZON',
    'REMILLY LES MARAIS',
  ],
  50750: [
    'CANISY',
    'DANGY',
    'QUIBOU',
    'ST MARTIN DE BONFOSSE',
    'BOURGVALLEES',
    'STE SUZANNE SUR VIRE',
  ],
  50580: ['CANVILLE LA ROCQUE', 'FIERVILLE LES MINES', 'LA HAYE', 'LE MESNIL', 'PORT BAIL SUR MER'],
  50740: ['CAROLLES'],
  50220: [
    'CEAUX',
    'COURTILS',
    'CROLLON',
    'DUCEY LES CHERIS',
    'JUILLEY',
    'MARCILLY',
    'LE MESNIL OZENNE',
    'POILLEY',
    'PONTAUBAULT',
    'PRECEY',
    'ST QUENTIN SUR LE HOMME',
  ],
  50510: [
    'CERENCES',
    'CHANTELOUP',
    'HUDIMESNIL',
    'LE LOREUR',
    'LE MESNIL AUBERT',
    'LA MEURDRAQUIERE',
    'ST SAUVEUR LA POMMERAYE',
  ],
  50870: ['CHAVOY', 'LE LUOT', 'LE PARC', 'SUBLIGNY', 'TIREPIED SUR SEE'],
  50100: ['CHERBOURG EN COTENTIN'],
  50120: ['CHERBOURG EN COTENTIN'],
  50130: ['CHERBOURG EN COTENTIN'],
  50470: ['CHERBOURG EN COTENTIN', 'TOLLEVAST'],
  50890: ['CONDE SUR VIRE'],
  50670: [
    'COULOUVRAY BOISBENATRE',
    'CUVES',
    'LINGEARD',
    'LE MESNIL GILBERT',
    'ST LAURENT DE CUVES',
    'ST MICHEL DE MONTJOIE',
    'ST POIS',
  ],
  50710: ['CREANCES'],
  50350: ['DONVILLE LES BAINS'],
  50250: [
    'DOVILLE',
    'LA HAYE',
    'MONTSENELLE',
    'NEUFMESNIL',
    'NEUVILLE EN BEAUMONT',
    'PICAUVILLE',
    'LE PLESSIS LASTELLE',
    'ST NICOLAS DE PIERREPONT',
    'ST SAUVEUR DE PIERREPONT',
    'VARENGUEBEC',
  ],
  50840: ['FERMANVILLE'],
  50190: [
    'FEUGERES',
    'LA FEUILLIE',
    'GONFREVILLE',
    'GORGES',
    'MARCHESIEUX',
    'MILLIERES',
    'NAY',
    'PERIERS',
    'ST GERMAIN SUR SEVES',
    'ST MARTIN D AUBIGNY',
    'ST PATRICE DE CLAIDS',
    'ST SEBASTIEN DE RAIDS',
  ],
  50850: ['LE FRESNE PORET', 'GER'],
  50410: [
    'LE GUISLAIN',
    'LA HAYE BELLEFOND',
    'MARGUERAY',
    'MAUPERTUIS',
    'MONTABOT',
    'MONTBRAY',
    'MORIGNY',
    'PERCY EN NORMANDIE',
    'VILLEBAUDON',
  ],
  50730: ['HAMELIN', 'ST BRICE DE LANDELLES', 'ST HILAIRE DU HARCOUET'],
  50590: ['HAUTEVILLE SUR MER', 'MONTMARTIN SUR MER', 'REGNEVILLE SUR MER'],
  50540: ['ISIGNY LE BUAT'],
  50520: ['JUVIGNY LES VALLEES', 'LE MESNIL ADELEE', 'REFFUVEILLE'],
  50600: [
    'LAPENTY',
    'LES LOGES MARCHIS',
    'LE MESNILLARD',
    'MOULINES',
    'GRANDPARIGNY',
    'ST HILAIRE DU HARCOUET',
  ],
  50660: ['TOURNEVILLE SUR MER', 'ORVAL SUR SIENNE', 'QUETTREVILLE SUR SIENNE'],
  50880: ['LA MEAUFFE', 'PONT HEBERT'],
  50490: ['MONTCUIT', 'MUNEVILLE LE BINGARD', 'ST SAUVEUR VILLAGES'],
  50240: [
    'MONTJOIE ST MARTIN',
    'ST AUBIN DE TERREGATTE',
    'ST JAMES',
    'ST LAURENT DE TERREGATTE',
    'ST SENIER DE BEUVRON',
  ],
  50140: [
    'MORTAIN BOCAGE',
    'LE NEUFBOURG',
    'ROMAGNY FONTENAY',
    'ST BARTHELEMY',
    'ST CLEMENT RANCOUDRAY',
  ],
  50860: ['MOYON VILLAGES'],
  50770: ['PIROU'],
  50380: ['ST AUBIN DES PREAUX', 'ST PAIR SUR MER'],
  50550: ['ST VAAST LA HOUGUE'],
  51240: [
    'ABLANCOURT',
    'AULNAY L AITRE',
    'BREUVERY SUR COOLE',
    'CERNON',
    'LA CHAUSSEE SUR MARNE',
    'CHEPPES LA PRAIRIE',
    'CHEPY',
    'COUPETZ',
    'COUPEVILLE',
    'DAMPIERRE SUR MOIVRE',
    'ECURY SUR COOLE',
    'FRANCHEVILLE',
    'LE FRESNE',
    'MAIRY SUR MARNE',
    'MARSON',
    'MOIVRE',
    'NUISEMENT SUR COOLE',
    'OMEY',
    'POGNY',
    'ST GERMAIN LA VILLE',
    'ST JEAN SUR MOIVRE',
    'ST MARTIN AUX CHAMPS',
    'ST QUENTIN SUR COOLE',
    'SONGY',
    'TOGNY AUX BOEUFS',
    'VESIGNEUL SUR MARNE',
    'VITRY LA VILLE',
  ],
  51530: [
    'ST MARTIN D ABLOIS',
    'BRUGNY VAUDANCOURT',
    'CHAVOT COURCOURT',
    'CHOUILLY',
    'CRAMANT',
    'CUIS',
    'DIZY',
    'MANCY',
    'MARDEUIL',
    'MONTHELON',
    'MORANGIS',
    'MOSLINS',
    'MOUSSY',
    'OIRY',
    'PIERRY',
    'VINAY',
    'MAGENTA',
  ],
  51150: [
    'AIGNY',
    'AMBONNAY',
    'ATHIS',
    'AULNAY SUR MARNE',
    'AY CHAMPAGNE',
    'BOUZY',
    'CHAMPIGNEUL CHAMPAGNE',
    'CHERVILLE',
    'CONDE SUR MARNE',
    'ISSE',
    'JALONS',
    'JUVIGNY',
    'PLIVOT',
    'VAL DE LIVRE',
    'TOURS SUR MARNE',
    'VRAUX',
  ],
  51260: [
    'ALLEMANCHE LAUNAY ET SOYER',
    'ANGLURE',
    'BAGNEUX',
    'BAUDEMENT',
    'BETHON',
    'LA CELLE SOUS CHANTEMERLE',
    'CHANTEMERLE',
    'LA CHAPELLE LASSON',
    'CLESLES',
    'CONFLANS SUR SEINE',
    'COURCEMAIN',
    'ESCLAVOLLES LUREY',
    'GRANGES SUR AUBE',
    'MARCILLY SUR SEINE',
    'MARSANGIS',
    'MONTGENOST',
    'POTANGIS',
    'ST JUST SAUVAGE',
    'ST SATURNIN',
    'SARON SUR AUBE',
    'VILLIERS AUX CORNEILLES',
    'VOUARCES',
  ],
  51120: [
    'ALLEMANT',
    'BARBONNE FAYEL',
    'BROYES',
    'CHARLEVILLE',
    'CHICHEY',
    'LES ESSARTS LES SEZANNE',
    'FONTAINE DENIS NUISY',
    'LA FORESTIERE',
    'GAYE',
    'LACHY',
    'LE MEIX ST EPOING',
    'MOEURS VERDEY',
    'MONDEMENT MONTGIVROUX',
    'NESLE LA REPOSTE',
    'OYES',
    'PEAS',
    'QUEUDES',
    'REUVES',
    'ST LOUP',
    'ST QUENTIN LE VERGER',
    'ST REMY SOUS BROYES',
    'SAUDOY',
    'SEZANNE',
    'SOIZY AUX BOIS',
    'LA VILLENEUVE LES CHARLEVILLE',
    'VILLENEUVE ST VISTRE ET VILLEVOTTE',
    'VINDEY',
  ],
  51250: ['ALLIANCELLES', 'CHEMINON', 'SERMAIZE LES BAINS', 'VILLERS LE SEC'],
  51290: [
    'AMBRIERES',
    'ARRIGNY',
    'ARZILLIERES NEUVILLE',
    'BRANDONVILLERS',
    'CHAPELAINE',
    'CHATILLON SUR BROUE',
    'DROSNAY',
    'ECOLLEMONT',
    'GIFFAUMONT CHAMPAUBERT',
    'GIGNY BUSSY',
    'STE MARIE DU LAC NUISEMENT',
    'HAUTEVILLE',
    'ISLE SUR MARNE',
    'LANDRICOURT',
    'LARZICOURT',
    'LIGNON',
    'MARGERIE HANCOURT',
    'MONCETZ L ABBAYE',
    'OUTINES',
    'ST CHERON',
    'ST REMY EN BOUZEMONT ST GENEST ISSON',
    'ST UTIN',
    'SOMSOIS',
  ],
  51230: [
    'ANGLUZELLES ET COURCELLES',
    'BANNES',
    'BROUSSY LE GRAND',
    'BROUSSY LE PETIT',
    'CONNANTRAY VAUREFROY',
    'CONNANTRE',
    'CORROY',
    'ECURY LE REPOS',
    'EUVY',
    'FAUX FRESNAY',
    'FERE CHAMPENOISE',
    'GOURGANCON',
    'LENHARREE',
    'LINTHELLES',
    'LINTHES',
    'MARIGNY',
    'OGNES',
    'PLEURS',
    'THAAS',
  ],
  51700: [
    'ANTHENAY',
    'BASLIEUX SOUS CHATILLON',
    'CHAMPVOISY',
    'CHATILLON SUR MARNE',
    'COURTHIEZY',
    'CUISLES',
    'DORMANS',
    'FESTIGNY',
    'IGNY COMBLIZY',
    'JONQUERY',
    'LEUVRIGNY',
    'MAREUIL LE PORT',
    'NESLE LE REPONS',
    'OLIZY',
    'PASSY GRIGNY',
    'COEUR DE LA VALLEE',
    'STE GEMME',
    'TROISSY',
    'VANDIERES',
    'VERNEUIL',
    'VINCELLES',
  ],
  51170: [
    'AOUGNY',
    'ARCIS LE PONSART',
    'AUBILLY',
    'BASLIEUX LES FISMES',
    'BLIGNY',
    'BOULEUSE',
    'BROUILLET',
    'CHAMBRECY',
    'CHAUMUZY',
    'COURLANDON',
    'COURVILLE',
    'CRUGNY',
    'FAVEROLLES ET COEMY',
    'FISMES',
    'LAGERY',
    'LHERY',
    'MAGNEUX',
    'MARFAUX',
    'MONT SUR COURVILLE',
    'POILLY',
    'ROMIGNY',
    'ST GILLES',
    'SARCY',
    'SAVIGNY SUR ARDRES',
    'SERZY ET PRIN',
    'TRAMERY',
    'UNCHAIR',
    'VILLE EN TARDENOIS',
  ],
  51800: [
    'ARGERS',
    'AUVE',
    'BERZIEUX',
    'BINARVILLE',
    'BRAUX STE COHIERE',
    'BRAUX ST REMY',
    'CERNAY EN DORMOIS',
    'LA CHAPELLE FELCOURT',
    'CHATRICES',
    'CHAUDEFONTAINE',
    'LE CHEMIN',
    'COURTEMONT',
    'DOMMARTIN DAMPIERRE',
    'DOMMARTIN SOUS HANS',
    'ECLAIRES',
    'ELISE DAUCOURT',
    'FLORENT EN ARGONNE',
    'FONTAINE EN DORMOIS',
    'GIZAUCOURT',
    'GRATREUIL',
    'HANS',
    'MAFFRECOURT',
    'MALMY',
    'MASSIGES',
    'MINAUCOURT LE MESNIL LES HURLUS',
    'MOIREMONT',
    'LA NEUVILLE AU PONT',
    'PASSAVANT EN ARGONNE',
    'ROUVROY RIPONT',
    'ST MARD SUR AUVE',
    'STE MENEHOULD',
    'ST THOMAS EN ARGONNE',
    'SERVON MELZICOURT',
    'SIVRY ANTE',
    'SOMME BIONNE',
    'VALMY',
    'VERRIERES',
    'VIENNE LA VILLE',
    'VIENNE LE CHATEAU',
    'VILLERS EN ARGONNE',
    'VILLE SUR TOURBE',
    'VIRGINY',
    'VOILEMONT',
    'WARGEMOULIN HURLUS',
  ],
  51600: [
    'AUBERIVE',
    'BUSSY LE CHATEAU',
    'LA CHEPPE',
    'LA CROIX EN CHAMPAGNE',
    'JONCHERY SUR SUIPPE',
    'LAVAL SUR TOURBE',
    'ST HILAIRE LE GRAND',
    'ST JEAN SUR TOURBE',
    'STE MARIE A PY',
    'ST REMY SUR BUSSY',
    'ST SOUPLET SUR PY',
    'SOMMEPY TAHURE',
    'SOMME SUIPPE',
    'SOMME TOURBE',
    'SOUAIN PERTHES LES HURLUS',
    'SUIPPES',
    'VAUDESINCOURT',
  ],
  51110: [
    'AUMENANCOURT',
    'BAZANCOURT',
    'BOULT SUR SUIPPE',
    'BOURGOGNE FRESNE',
    'CAUREL',
    'HEUTREGIVILLE',
    'ISLES SUR SUIPPE',
    'LAVANNES',
    'POMACLE',
    'ST ETIENNE SUR SUIPPE',
    'WARMERIVILLE',
  ],
  51160: [
    'AVENAY VAL D OR',
    'AY CHAMPAGNE',
    'CHAMPILLON',
    'FONTAINE SUR AY',
    'GERMAINE',
    'HAUTVILLERS',
    'MUTIGNY',
    'ST IMOGES',
  ],
  51190: [
    'AVIZE',
    'FLAVIGNY',
    'GRAUVES',
    'LES ISTRES ET BURY',
    'LE MESNIL SUR OGER',
    'BLANCS COTEAUX',
  ],
  51400: [
    'BACONNES',
    'BILLY LE GRAND',
    'BOUY',
    'CUPERLY',
    'DAMPIERRE AU TEMPLE',
    'LES GRANDES LOGES',
    'LIVRY LOUVERCY',
    'MOURMELON LE GRAND',
    'MOURMELON LE PETIT',
    'LES PETITES LOGES',
    'PROSNES',
    'ST HILAIRE AU TEMPLE',
    'SEPT SAULX',
    'VADENAY',
  ],
  51270: [
    'LE BAIZIL',
    'BANNAY',
    'BAYE',
    'BEAUNAY',
    'LA CAURE',
    'CHAMPAUBERT',
    'LA CHAPELLE SOUS ORBAIS',
    'COIZARD JOCHES',
    'CONGY',
    'CORRIBERT',
    'COURJEONNET',
    'ETOGES',
    'FEREBRIANGES',
    'MAREUIL EN BRIE',
    'MONTMORT LUCY',
    'ORBAIS L ABBAYE',
    'SUIZY LE FRANC',
    'TALUS ST PRIX',
    'LA VILLE SOUS ORBAIS',
    'VILLEVENARD',
  ],
  51300: [
    'BASSU',
    'BASSUET',
    'BIGNICOURT SUR MARNE',
    'BLACY',
    'BLAISE SOUS ARZILLIERES',
    'BRUSSON',
    'LE BUISSON',
    'CHANGY',
    'CHATELRAOULD ST LOUVENT',
    'CLOYES SUR MARNE',
    'COURDEMANGES',
    'COUVROT',
    'DOMPREMY',
    'DROUILLY',
    'ECRIENNES',
    'FAVRESSE',
    'FRIGNICOURT',
    'GLANNES',
    'HAUSSIGNEMONT',
    'HEILTZ LE HUTIER',
    'HUIRON',
    'LISSE EN CHAMPAGNE',
    'LOISY SUR MARNE',
    'LUXEMONT ET VILLOTTE',
    'MAISONS EN CHAMPAGNE',
    'MAROLLES',
    'MATIGNICOURT GONCOURT',
    'MERLAUT',
    'NORROIS',
    'ORCONTE',
    'OUTREPONT',
    'PLICHANCOURT',
    'PONTHION',
    'PRINGY',
    'REIMS LA BRULEE',
    'LES RIVIERES HENRUEL',
    'ST AMAND SUR FION',
    'ST LUMIER EN CHAMPAGNE',
    'ST QUENTIN LES MARAIS',
    'SOULANGES',
    'THIEBLEMONT FAREMONT',
    'VAUCLERC',
    'VAVRAY LE GRAND',
    'VAVRAY LE PETIT',
    'VITRY EN PERTHOIS',
    'VITRY LE FRANCOIS',
  ],
  51360: ['BEAUMONT SUR VESLE', 'PRUNAY', 'VAL DE VESLE', 'VERZENAY'],
  51490: [
    'BEINE NAUROY',
    'BETHENIVILLE',
    'DONTRIEN',
    'EPOYE',
    'PONTFAVERGER MORONVILLIERS',
    'ST HILAIRE LE PETIT',
    'ST MARTIN L HEUREUX',
    'ST MASMES',
    'SELLES',
  ],
  51330: [
    'BELVAL EN ARGONNE',
    'BETTANCOURT LA LONGUE',
    'BUSSY LE REPOS',
    'CHARMONT',
    'LES CHARMONTOIS',
    'LE CHATELIER',
    'CONTAULT',
    'DAMPIERRE LE CHATEAU',
    'DOMMARTIN VARIMONT',
    'EPENSE',
    'GIVRY EN ARGONNE',
    'LA NEUVILLE AUX BOIS',
    'NOIRLIEU',
    'POSSESSE',
    'RAPSECOURT',
    'REMICOURT',
    'ST JEAN DEVANT POSSESSE',
    'ST MARD SUR LE MONT',
    'SOMME YEVRE',
    'VANAULT LE CHATEL',
    'VERNANCOURT',
    'LE VIEIL DAMPIERRE',
    'VROIL',
  ],
  51480: [
    'BELVAL SOUS CHATILLON',
    'BOURSAULT',
    'CHAMPLAT ET BOUJACOURT',
    'CORMOYEUX',
    'COURTAGNON',
    'CUCHERY',
    'CUMIERES',
    'DAMERY',
    'FLEURY LA RIVIERE',
    'NANTEUIL LA FORET',
    'LA NEUVILLE AUX LARRIS',
    'OEUILLY',
    'POURCY',
    'COEUR DE LA VALLEE',
    'ROMERY',
    'VAUCIENNES',
    'VENTEUIL',
  ],
  51130: [
    'BERGERES LES VERTUS',
    'CHAINTRIX BIERGES',
    'CHALTRAIT',
    'CLAMANGES',
    'VAL DES MARAIS',
    'ETRECHY',
    'GERMINON',
    'GIVRY LES LOISY',
    'LOISY EN BRIE',
    'PIERRE MORAINS',
    'POCANCY',
    'ROUFFY',
    'ST MARD LES ROUFFY',
    'SOULIERES',
    'TRECON',
    'VELYE',
    'VERT TOULON',
    'BLANCS COTEAUX',
    'VILLENEUVE RENNEVILLE CHEVIGNY',
    'VILLERS AUX BOIS',
    'VILLESENEUX',
    'VOUZY',
  ],
  51210: [
    'BERGERES SOUS MONTMIRAIL',
    'BOISSY LE REPOS',
    'LE BREUIL',
    'CORFELIX',
    'CORROBERT',
    'FROMENTIERES',
    'LE GAULT SOIGNY',
    'JANVILLIERS',
    'MARGNY',
    'MECRINGES',
    'MONTMIRAIL',
    'MORSAINS',
    'RIEUX',
    'LE THOULT TROSNAY',
    'TREFOLS',
    'VAUCHAMPS',
    'VERDON',
    'LE VEZIER',
  ],
  51220: [
    'BERMERICOURT',
    'BRIMONT',
    'CAUROY LES HERMONVILLE',
    'CORMICY',
    'COURCY',
    'HERMONVILLE',
    'LOIVRE',
    'MERFY',
    'POUILLON',
    'ST THIERRY',
    'THIL',
    'VILLERS FRANQUEUX',
  ],
  51420: ['BERRU', 'CERNAY LES REIMS', 'NOGENT L ABBESSE', 'WITRY LES REIMS'],
  51450: ['BETHENY'],
  51430: ['BEZANNES', 'TINQUEUX'],
  51340: [
    'BIGNICOURT SUR SAULX',
    'BLESME',
    'VAL DE VIERE',
    'ETREPY',
    'HEILTZ LE MAURUPT',
    'HEILTZ L EVEQUE',
    'JUSSECOURT MINECOURT',
    'MAURUPT LE MONTOIS',
    'PARGNY SUR SAULX',
    'ST LUMIER LA POPULEUSE',
    'ST VRAIN',
    'SCRUPT',
    'SOGNY EN L ANGLE',
    'TROIS FONTAINES L ABBAYE',
    'VANAULT LES DAMES',
    'VOUILLERS',
  ],
  51310: [
    'BOUCHY ST GENEST',
    'CHAMPGUYON',
    'CHATILLON SUR MORIN',
    'COURGIVAUX',
    'ESCARDES',
    'LES ESSARTS LE VICOMTE',
    'ESTERNAY',
    'JOISELLE',
    'NEUVY',
    'LA NOUE',
    'REVEILLON',
    'ST BON',
    'VILLENEUVE LA LIONNE',
  ],
  51390: [
    'BOUILLY',
    'COULOMMES LA MONTAGNE',
    'COURMAS',
    'GERMIGNY',
    'GUEUX',
    'JANVRY',
    'JOUY LES REIMS',
    'MERY PREMECY',
    'PARGNY LES REIMS',
    'ROSNAY',
    'ST EUPHRAISE ET CLAIRIZET',
    'VILLE DOMMANGE',
    'VRIGNY',
  ],
  51140: [
    'BOUVANCOURT',
    'BRANSCOURT',
    'BREUIL SUR VESLE',
    'CHALONS SUR VESLE',
    'CHENAY',
    'COURCELLES SAPICOURT',
    'HOURGES',
    'JONCHERY SUR VESLE',
    'MONTIGNY SUR VESLE',
    'MUIZON',
    'PEVY',
    'PROUILLY',
    'ROMAIN',
    'TRESLON',
    'TRIGNY',
    'VANDEUIL',
    'VENTELAY',
  ],
  51320: [
    'BREBAN',
    'BUSSY LETTREE',
    'COOLE',
    'CORBEIL',
    'DOMMARTIN LETTREE',
    'FAUX VESIGNEUL',
    'HAUSSIMONT',
    'HUMBAUVILLE',
    'LE MEIX TIERCELIN',
    'MONTEPREUX',
    'ST OUEN DOMPROT',
    'SOMMESOUS',
    'SOMPUIS',
    'SOUDE',
    'SOUDRON',
    'VASSIMONT ET CHAPELAINE',
    'VATRY',
  ],
  51000: ['CHALONS EN CHAMPAGNE'],
  51500: [
    'CHAMERY',
    'CHAMPFLEURY',
    'CHIGNY LES ROSES',
    'ECUEIL',
    'LUDES',
    'MAILLY CHAMPAGNE',
    'MONTBRE',
    'PUISIEULX',
    'RILLY LA MONTAGNE',
    'SACY',
    'ST LEONARD',
    'SERMIERS',
    'SILLERY',
    'TAISSY',
    'TROIS PUITS',
    'VILLE EN SELVE',
    'VILLERS ALLERAND',
    'VILLERS AUX NOEUDS',
  ],
  51370: ['CHAMPIGNY', 'LES MESNEUX', 'ORMES', 'ST BRICE COURCELLES', 'THILLOIS'],
  51510: [
    'CHENIERS',
    'COMPERTRIX',
    'COOLUS',
    'FAGNIERES',
    'MATOUGUES',
    'ST GIBRIEN',
    'ST PIERRE',
    'THIBIE',
    'VILLERS LE CHATEAU',
  ],
  51350: ['CORMONTREUIL'],
  51460: [
    'COURTISOLS',
    'L EPINE',
    'HERPONT',
    'POIX',
    'ST ETIENNE AU TEMPLE',
    'SOMME VESLE',
    'TILLOY ET BELLAY',
  ],
  51200: ['EPERNAY'],
  51470: ['MONCETZ LONGEVAS', 'ST MEMMIE'],
  51520: ['RECY', 'ST MARTIN SUR LE PRE', 'SARRY', 'SOGNY AUX MOULINS', 'LA VEUVE'],
  51100: ['REIMS'],
  52100: [
    'ST EULIEN',
    'SAPIGNICOURT',
    'BETTANCOURT LA FERREE',
    'CHANCENAY',
    'HALLIGNICOURT',
    'LANEUVILLE AU PONT',
    'MOESLAINS',
    'PERTHES',
    'ST DIZIER',
    'VALCOURT',
    'VILLIERS EN LIEU',
  ],
  51380: ['TREPAIL', 'VAUDEMANGE', 'VERZY', 'VILLERS MARMERY'],
  52340: ['AGEVILLE', 'BIESLES', 'ESNOUVEAUX'],
  52400: [
    'AIGREMONT',
    'BOURBONNE LES BAINS',
    'CHAMPIGNY SOUS VARENNES',
    'CHEZEAUX',
    'COIFFY LE BAS',
    'COIFFY LE HAUT',
    'DAMREMONT',
    'ENFONVELLE',
    'FRESNES SUR APANCE',
    'GUYONVELLE',
    'LANEUVELLE',
    'LARIVIERE ARNONCOURT',
    'MELAY',
    'MONTCHARVOT',
    'NEUVELLE LES VOISEY',
    'PARNOY EN BASSIGNY',
    'LE CHATELET SUR MEUSE',
    'SERQUEUX',
    'SOYERS',
    'VARENNES SUR AMANCE',
    'VICQ',
    'VOISEY',
  ],
  52700: [
    'AILLIANVILLE',
    'ANDELOT BLANCHEVILLE',
    'BOURDONS SUR ROGNON',
    'BRIAUCOURT',
    'BUSSON',
    'CHALVRAINES',
    'CHAMBRONCOURT',
    'CHANTRAINES',
    'CIREY LES MAREILLES',
    'CLINCHAMP',
    'CONSIGNY',
    'DARMANNES',
    'ECOT LA COMBE',
    'FORCEY',
    'HUMBERVILLE',
    'LAFAUCHE',
    'LEURVILLE',
    'LIFFOL LE PETIT',
    'MANOIS',
    'MAREILLES',
    'MONTOT SUR ROGNON',
    'MORIONVILLIERS',
    'ORQUEVAUX',
    'OZIERES',
    'PREZ SOUS LAFAUCHE',
    'REYNEL',
    'RIMAUCOURT',
    'ROCHEFORT SUR LA COTE',
    'ST BLIN',
    'SEMILLY',
    'SIGNEVILLE',
    'VESAIGNES SOUS LAFAUCHE',
    'VIGNES LA COTE',
  ],
  52230: [
    'AINGOULAINCOURT',
    'ANNONVILLE',
    'CIRFONTAINES EN ORNOIS',
    'ECHENAY',
    'EPIZON',
    'GERMAY',
    'GERMISAY',
    'GILLAUME',
    'LEZEVILLE',
    'MONTREUIL SUR THONNANCE',
    'NONCOURT SUR LE RONGEANT',
    'PANSEY',
    'POISSONS',
    'SAILLY',
    'SAUDRON',
    'THONNANCE LES MOULINS',
  ],
  52120: [
    'AIZANVILLE',
    'AUTREVILLE SUR LA RENNE',
    'BLESSONVILLE',
    'BRAUX LE CHATEL',
    'BRICON',
    'CHATEAUVILLAIN',
    'DINTEVILLE',
    'LAFERTE SUR AUBE',
    'LANTY SUR AUBE',
    'LATRECEY ORMOY SUR AUBE',
    'ORGES',
    'PONT LA VILLE',
    'RICHEBOURG',
    'SILVAROUVRES',
    'VILLARS EN AZOIS',
  ],
  52130: [
    'ALLICHAMPS',
    'ATTANCOURT',
    'BAILLY AUX FORGES',
    'BROUSSEVAL',
    'DOMBLAIN',
    'DOULEVANT LE PETIT',
    'FAYS',
    'LOUVEMONT',
    'MAGNEUX',
    'MONTREUIL SUR BLAISE',
    'RACHECOURT SUZEMONT',
    'SOMMANCOURT',
    'TROISFONTAINES LA VILLE',
    'VALLERET',
    'VAUX SUR BLAISE',
    'VILLE EN BLAISOIS',
    'VOILLECOMTE',
    'WASSY',
  ],
  52110: [
    'AMBONVILLE',
    'ARNANCOURT',
    'BAUDRECOURT',
    'BEURVILLE',
    'BLUMERAY',
    'BOUZANCOURT',
    'BRACHAY',
    'CHARMES EN L ANGLE',
    'CHARMES LA GRANDE',
    'CIREY SUR BLAISE',
    'COURCELLES SUR BLAISE',
    'DAILLANCOURT',
    'DOMMARTIN LE FRANC',
    'DOMMARTIN LE ST PERE',
    'DOULEVANT LE CHATEAU',
    'FLAMMERECOURT',
    'LESCHERES SUR LE BLAISERON',
    'MERTRUD',
    'MORANCOURT',
    'NULLY',
    'TREMILLY',
  ],
  52360: [
    'ANDILLY EN BASSIGNY',
    'BANNES',
    'BONNECOURT',
    'CELLES EN BASSIGNY',
    'CHANGEY',
    'CHARMES',
    'CHATENAY VAUDIN',
    'DAMPIERRE',
    'FRECOURT',
    'LECEY',
    'MARCILLY EN BASSIGNY',
    'NEUILLY L EVEQUE',
    'ORBIGNY AU MONT',
    'ORBIGNY AU VAL',
    'PLESNOY',
    'POISEUL',
  ],
  52310: [
    'ANNEVILLE LA PRAIRIE',
    'BOLOGNE',
    'LAMANCINE',
    'MEURES',
    'ORMOY LES SEXFONTAINES',
    'OUDINCOURT',
    'VIEVILLE',
    'VRAINCOURT',
  ],
  52500: [
    'ANROSEY',
    'ARBIGNY SOUS VARENNES',
    'BELMONT',
    'BIZE',
    'CHAMPSEVRAINE',
    'COUBLANC',
    'FARINCOURT',
    'FAYL BILLOT',
    'GENEVRIERES',
    'GILLEY',
    'GRENANT',
    'LAFERTE SUR AMANCE',
    'LES LOGES',
    'MAATZ',
    'MAIZIERES SUR AMANCE',
    'PIERREMONT SUR AMANCE',
    'PISSELOUP',
    'POINSON LES FAYL',
    'PRESSIGNY',
    'ROUGEUX',
    'SAULLES',
    'SAVIGNY',
    'TORNAY',
    'VALLEROY',
    'VELLES',
    'VONCOURT',
  ],
  52250: [
    'APREY',
    'BAISSEY',
    'FLAGEY',
    'LONGEAU PERCEY',
    'ORCEVAUX',
    'VERSEILLES LE BAS',
    'VERSEILLES LE HAUT',
  ],
  52160: [
    'ARBOT',
    'AUBERIVE',
    'AULNOY SUR AUBE',
    'BAY SUR AUBE',
    'CHALANCEY',
    'VALS DES TILLES',
    'COLMIER LE BAS',
    'COLMIER LE HAUT',
    'GERMAINES',
    'MOUILLERON',
    'PERROGNEY LES FONTAINES',
    'POINSENOT',
    'POINSON LES GRANCEY',
    'PRASLAY',
    'ROUELLES',
    'ROUVRES SUR AUBE',
    'VAILLANT',
    'VILLARS SANTENOGE',
    'VITRY EN MONTAGNE',
    'VIVEY',
  ],
  52210: [
    'ARC EN BARROIS',
    'AUBEPIERRE SUR AUBE',
    'BUGNIERES',
    'COUPRAY',
    'COUR L EVEQUE',
    'DANCEVOIR',
    'GIEY SUR AUJON',
    'LEFFONDS',
    'ROCHETAILLEE',
    'ST LOUP SUR AUJON',
    'TERNAT',
    'VILLIERS SUR SUIZE',
  ],
  52240: [
    'AUDELONCOURT',
    'BASSONCOURT',
    'BREUVANNES EN BASSIGNY',
    'BUXIERES LES CLEFMONT',
    'CHOISEUL',
    'CLEFMONT',
    'CUVES',
    'DAILLECOURT',
    'LONGCHAMP',
    'MAISONCELLES',
    'MENNOUVEAUX',
    'MERREY',
    'MILLIERES',
    'VAL DE MEUSE',
    'NOYERS',
    'PERRUSSE',
    'THOL LES MILLIERES',
    'VRONCOURT LA COTE',
  ],
  52190: [
    'AUJEURRES',
    'CHASSIGNY',
    'CHOILLEY DARDENAY',
    'CUSEY',
    'DOMMARIEN',
    'LE VAL D ESNOMS',
    'ISOMES',
    'LEUCHEY',
    'OCCEY',
    'LE MONTSAUGEONNAIS',
    'RIVIERE LES FOSSES',
    'ST BROINGT LE BOIS',
    'ST BROINGT LES FOSSES',
    'VESVRES SOUS CHALANCEY',
    'VILLEGUSIEN LE LAC',
    'VILLIERS LES APREY',
  ],
  52300: [
    'AUTIGNY LE GRAND',
    'AUTIGNY LE PETIT',
    'BLECOURT',
    'CHATONRUPT SOMMERMONT',
    'CUREL',
    'DONJEUX',
    'EFFINCOURT',
    'FERRIERE ET LAFOLIE',
    'FRONVILLE',
    'GUINDRECOURT AUX ORMES',
    'JOINVILLE',
    'MAIZIERES',
    'MATHONS',
    'MUSSEY SUR MARNE',
    'NOMECOURT',
    'OSNE LE VAL',
    'PAROY SUR SAULX',
    'ROUVROY SUR MARNE',
    'RUPT',
    'ST URBAIN MACONCOURT',
    'SUZANNECOURT',
    'THONNANCE LES JOINVILLE',
    'VAUX SUR ST URBAIN',
    'VECQUEVILLE',
  ],
  52330: [
    'AUTREVILLE SUR LA RENNE',
    'BLAISY',
    'COLOMBEY LES DEUX EGLISES',
    'CURMONT',
    'GILLANCOURT',
    'GUINDRECOURT SUR BLAISE',
    'JUZENNECOURT',
    'LACHAPELLE EN BLAISY',
    'LAVILLENEUVE AU ROI',
    'MONTHERIES',
    'RIZAUCOURT BUCHEY',
    'SEXFONTAINES',
    'VAUDREMONT',
  ],
  52140: [
    'AVRECOURT',
    'CHAUFFOURT',
    'DAMMARTIN SUR MEUSE',
    'IS EN BASSIGNY',
    'LAVERNOY',
    'LAVILLENEUVE',
    'VAL DE MEUSE',
    'RANCONNIERES',
    'RANGECOURT',
    'SARREY',
    'SAULXURES',
  ],
  52260: ['BEAUCHEMIN', 'CHANOY', 'FAVEROLLES', 'MARAC', 'ROLAMPONT'],
  52270: ['ROCHES BETTAINCOURT', 'DOMREMY LANDEVILLE', 'DOULAINCOURT SAUCOURT', 'EPIZON'],
  52200: [
    'BOURG',
    'BRENNES',
    'CHAMPIGNY LES LANGRES',
    'CHATENAY MACHERON',
    'COURCELLES EN MONTAGNE',
    'HUMES JORQUENAY',
    'LANGRES',
    'MARDOR',
    'NOIDANT LE ROCHEUX',
    'ORMANCEY',
    'PEIGNEY',
    'PERRANCEY LES VIEUX MOULINS',
    'ST CIERGUES',
    'SAINTS GEOSMES',
    'ST MARTIN LES LANGRES',
    'ST MAURICE',
    'ST VALLIER SUR MARNE',
    'VAUXBONS',
    'VOISINES',
  ],
  52150: [
    'BOURG STE MARIE',
    'BOURMONT ENTRE MEUSE ET MOUZON',
    'BRAINVILLE SUR MEUSE',
    'CHAMPIGNEULLES EN BASSIGNY',
    'CHAUMONT LA VILLE',
    'DONCOURT SUR MEUSE',
    'GERMAINVILLIERS',
    'GRAFFIGNY CHEMIN',
    'HACOURT',
    'HARREVILLE LES CHANTEURS',
    'HUILLIECOURT',
    'ILLOUD',
    'LEVECOURT',
    'MALAINCOURT SUR MEUSE',
    'OUTREMECOURT',
    'ROMAIN SUR MEUSE',
    'ST THIEBAULT',
    'SOMMERECOURT',
    'SOULAUCOURT SUR MOUZON',
    'VAUDRECOURT',
  ],
  52000: [
    'BRETHENAY',
    'BUXIERES LES VILLIERS',
    'CHAUMONT',
    'CHAMARANDES CHOIGNES',
    'CONDES',
    'EUFFIGNEIX',
    'FOULAIN',
    'JONCHERY',
    'LAVILLE AUX BOIS',
    'LUZY SUR MARNE',
    'NEUILLY SUR SUIZE',
    'RIAUCOURT',
    'SEMOUTIERS MONTSAON',
    'TREIX',
    'VERBIESLES',
    'VILLIERS LE SEC',
  ],
  52220: [
    'CEFFONDS',
    'FRAMPAS',
    'LANEUVILLE A REMY',
    'LA PORTE DU DER',
    'PLANRUPT',
    'RIVES DERVOISES',
    'SOMMEVOIRE',
    'THILLEUX',
  ],
  52600: [
    'CELSOY',
    'CHALINDREY',
    'CHAUDENAY',
    'COHONS',
    'CULMONT',
    'GRANDCHAMP',
    'HEUILLEY LE GRAND',
    'HAUTE AMANCE',
    'NOIDANT CHATENOY',
    'LE PAILLY',
    'PALAISEUL',
    'RIVIERES LE BOIS',
    'TORCENAY',
    'VILLEGUSIEN LE LAC',
    'VIOLOT',
  ],
  52320: [
    'CERISIERES',
    'FRONCLES',
    'LA GENEVROYE',
    'GUDMONT VILLIERS',
    'MARBEVILLE',
    'MIRBEL',
    'ROUECOURT',
    'SONCOURT SUR MARNE',
    'VIGNORY',
    'VOUECOURT',
  ],
  52410: ['CHAMOUILLEY', 'EURVILLE BIENVILLE', 'ROCHES SUR MARNE'],
  52170: ['CHEVILLON', 'FONTAINES SUR MARNE', 'BAYARD SUR MARNE', 'NARCY', 'RACHECOURT SUR MARNE'],
  52370: ['CIRFONTAINES EN AZOIS', 'MARANVILLE', 'RENNEPONT'],
  52290: ['ECLARON BRAUCOURT STE LIVIERE', 'HUMBECOURT'],
  52800: [
    'FOULAIN',
    'LANQUES SUR ROGNON',
    'LOUVIERES',
    'MANDRES LA COTE',
    'MARNAY SUR MARNE',
    'NINVILLE',
    'NOGENT',
    'POINSON LES NOGENT',
    'POULANGY',
    'SARCEY',
    'THIVET',
    'VESAIGNES SUR MARNE',
    'VITRY LES NOGENT',
  ],
  53940: ['AHUILLE', 'LE GENEST ST ISLE', 'ST BERTHEVIN'],
  53240: [
    'ALEXAIN',
    'ANDOUILLE',
    'LA BACONNIERE',
    'LA BIGOTTIERE',
    'MONTFLOURS',
    'PLACE',
    'ST GERMAIN D ANXURE',
    'ST GERMAIN LE FOUILLOUX',
    'ST GERMAIN LE GUILLAUME',
    'ST JEAN SUR MAYENNE',
  ],
  53300: [
    'AMBRIERES LES VALLEES',
    'CHANTRIGNE',
    'COUESMES VAUCE',
    'LA HAIE TRAVERSAINE',
    'OISSEAU',
    'LE PAS',
    'ST FRAIMBAULT DE PRIERES',
    'ST LOUP DU GAST',
    'ST MARS SUR COLMONT',
    'SOUCE',
  ],
  53210: ['ARGENTRE', 'LOUVIGNE', 'SOULGE SUR OUETTE'],
  53440: [
    'ARON',
    'LA BAZOGE MONTPINCON',
    'BELGEARD',
    'LA CHAPELLE AU RIBOUL',
    'GRAZAY',
    'MARCILLE LA VILLE',
  ],
  53170: [
    'ARQUENAY',
    'LA BAZOUGE DE CHEMERE',
    'BAZOUGERS',
    'LE BIGNON DU MAINE',
    'LE BURET',
    'LA CROPTE',
    'MAISONCELLES DU MAINE',
    'MESLAY DU MAINE',
    'RUILLE FROID FONDS',
    'ST CHARLES LA FORET',
    'ST DENIS DU MAINE',
    'VILLIERS CHARLEMAGNE',
  ],
  53600: [
    'ASSE LE BERENGER',
    'EVRON',
    'MEZANGERS',
    'STE GEMMES LE ROBERT',
    'ST GEORGES SUR ERVE',
    'VOUTRE',
  ],
  53230: [
    'ASTILLE',
    'LA CHAPELLE CRAONNAISE',
    'COSMES',
    'COSSE LE VIVIEN',
    'COURBEVEILLE',
    'MERAL',
  ],
  53400: [
    'ATHEE',
    'CHERANCE',
    'CRAON',
    'DENAZE',
    'LIVRE LA TOUCHE',
    'MEE',
    'NIAFLES',
    'POMMERIEUX',
    'ST QUENTIN LES ANGES',
  ],
  53700: [
    'AVERTON',
    'COURCITE',
    'CRENNES SUR FRAUBEE',
    'LOUPFOUGERES',
    'ST AUBIN DU DESERT',
    'ST GERMAIN DE COULAMER',
    'ST MARS DU DESERT',
    'VILLAINES LA JUHEL',
  ],
  53160: [
    'BAIS',
    'CHAMPGENETEUX',
    'HAMBERS',
    'IZE',
    'JUBLAINS',
    'VIMARTIN SUR ORTHE',
    'ST THOMAS DE COURCERIERS',
    'TRANS',
  ],
  53340: ['VAL DU MAINE', 'BANNES', 'CHEMERE LE ROI', 'COSSE EN CHAMPAGNE', 'PREAUX', 'SAULGES'],
  53350: [
    'BALLOTS',
    'BRAINS SUR LES MARCHES',
    'FONTAINE COUVERTE',
    'LA ROE',
    'ST MICHEL DE LA ROE',
  ],
  53470: ['LA BAZOUGE DES ALLEUX', 'CHALONS DU MAINE', 'COMMER', 'MARTIGNE SUR MAYENNE', 'SACE'],
  53320: ['BEAULIEU SUR OUDON', 'LOIRON RUILLE', 'MONTJEAN', 'ST CYR LE GRAVELAIS'],
  53290: [
    'BEAUMONT PIED DE BOEUF',
    'BIERNE LES VILLAGES',
    'BOUERE',
    'BOUESSAY',
    'GREZ EN BOUERE',
    'ST BRICE',
    'ST DENIS D ANJOU',
    'ST LOUP DU DORAT',
  ],
  53800: [
    'LA BOISSIERE',
    'BOUCHAMPS LES CRAON',
    'CONGRIER',
    'RENAZE',
    'ST MARTIN DU LIMET',
    'ST SATURNIN DU LIMET',
    'LA SELLE CRAONNAISE',
  ],
  53960: ['BONCHAMP LES LAVAL'],
  53370: ['BOULAY LES IFS', 'CHAMPFREMONT', 'GESVRES', 'RAVIGNY', 'ST PIERRE DES NIDS'],
  53410: [
    'LE BOURGNEUF LA FORET',
    'BOURGON',
    'LA BRULATTE',
    'LA GRAVELLE',
    'LAUNAY VILLIERS',
    'OLIVET',
    'PORT BRILLET',
    'ST OUEN DES TOITS',
    'ST PIERRE LA COUR',
  ],
  53120: [
    'BRECE',
    'CARELLES',
    'COLOMBIERS DU PLESSIS',
    'GORRON',
    'HERCE',
    'LESBOIS',
    'LEVARE',
    'ST AUBIN FOSSE LOUVAIN',
    'VIEUVY',
  ],
  53150: ['BREE', 'LA CHAPELLE RAINSOUIN', 'EVRON', 'GESNES', 'LIVET', 'MONTSURS', 'NEAU'],
  53420: ['CHAILLAND'],
  53640: ['CHAMPEON', 'HARDANGES', 'LE HORPS', 'MONTREUIL POULAY', 'LE RIBAY'],
  53810: ['CHANGE'],
  53950: ['LA CHAPELLE ANTHENAISE', 'LOUVERNE'],
  53250: [
    'CHARCHIGNE',
    'CHEVAIGNE DU MAINE',
    'COUPTRAIN',
    'LE HAM',
    'JAVRON LES CHAPELLES',
    'MADRE',
    'NEUILLY LE VENDIN',
    'ST AIGNAN DE COUPTRAIN',
    'VILLEPAIL',
  ],
  53200: [
    'CHATEAU GONTIER SUR MAYENNE',
    'CHATELAIN',
    'CHEMAZE',
    'COUDRAY',
    'DAON',
    'FROMENTIERES',
    'GENNES LONGUEFUYE',
    'PREE D ANJOU',
    'LA ROCHE NEUVILLE',
    'MARIGNE PEUTON',
    'MENIL',
  ],
  53100: [
    'CHATILLON SUR COLMONT',
    'CONTEST',
    'MAYENNE',
    'MOULAY',
    'PARIGNE SUR BRAYE',
    'ST BAUDELLE',
    'ST GEORGES BUTTAVENT',
  ],
  53380: ['LA CROIXILLE', 'JUVIGNE', 'ST HILAIRE DU MAINE'],
  53540: ['CUILLE', 'GASTINES', 'LAUBRIERES', 'ST POIX'],
  53190: ['DESERTINES', 'LA DOREE', 'FOUGEROLLES DU PLESSIS', 'LANDIVY'],
  53260: ['ENTRAMMES', 'FORCE', 'PARNE SUR ROC'],
  53500: ['ERNEE', 'MONTENAY', 'ST DENIS DE GASTINES', 'ST PIERRE DES LANDES', 'VAUTORTE'],
  53360: ['HOUSSAY', 'LA ROCHE NEUVILLE', 'ORIGNE', 'PEUTON', 'QUELAINES ST GAULT', 'SIMPLE'],
  53110: [
    'LE HOUSSEAU BRETIGNOLLES',
    'LASSAY LES CHATEAUX',
    'RENNES EN GRENOUILLES',
    'ST JULIEN DU TERROUX',
    'STE MARIE DU BOIS',
    'THUBOEUF',
  ],
  53970: ['L HUISSERIE', 'MONTIGNE LE BRILLANT', 'NUILLE SUR VICOIN'],
  53220: [
    'LARCHAMP',
    'MONTAUDIN',
    'LA PELLERINE',
    'PONTMAIN',
    'ST BERTHEVIN LA TANNIERE',
    'ST ELLIER DU MAINE',
    'ST MARS SUR LA FUTAIE',
  ],
  53000: ['LAVAL'],
  53140: [
    'LIGNIERES ORGERES',
    'LA PALLU',
    'PRE EN PAIL ST SAMSON',
    'ST CALAIS DU DESERT',
    'ST CYR EN PAIL',
  ],
  53390: ['LA ROUAUDIERE', 'ST AIGNAN SUR ROE', 'ST ERBLON', 'SENONNES'],
  53480: ['ST GEORGES LE FLECHARD', 'ST LEGER', 'VAIGES'],
  53270: [
    'BLANDOUET ST JEAN',
    'ST PIERRE SUR ERVE',
    'STE SUZANNE ET CHAMMES',
    'THORIGNE EN CHARNIE',
    'TORCE VIVIERS EN CHARNIE',
  ],
  54610: [
    'ABAUCOURT',
    'BELLEAU',
    'BRATTE',
    'CHENICOURT',
    'CLEMERY',
    'EPLY',
    'LETRICOURT',
    'MAILLY SUR SEILLE',
    'NOMENY',
    'PHLIN',
    'RAUCOURT',
    'ROUVES',
    'SIVRY',
    'THEZEY ST MARTIN',
  ],
  54800: [
    'ABBEVILLE LES CONFLANS',
    'AFFLEVILLE',
    'ALLAMONT',
    'BECHAMPS',
    'BONCOURT',
    'BRAINVILLE',
    'BRUVILLE',
    'CONFLANS EN JARNISY',
    'DONCOURT LES CONFLANS',
    'FRIAUVILLE',
    'GONDRECOURT AIX',
    'HANNONVILLE SUZEMONT',
    'HATRIZE',
    'JARNY',
    'JEANDELIZE',
    'JOUAVILLE',
    'LABRY',
    'MARS LA TOUR',
    'MOUAVILLE',
    'OLLEY',
    'PUXE',
    'PUXIEUX',
    'ST MARCEL',
    'SPONVILLE',
    'THUMEREVILLE',
    'TRONVILLE',
    'VILLE SUR YRON',
    'XONVILLE',
  ],
  54115: [
    'ABONCOURT',
    'BATTIGNY',
    'BEUVEZIN',
    'DOMMARIE EULMONT',
    'FAVIERES',
    'FECOCOURT',
    'GELAUCOURT',
    'GEMONVILLE',
    'GRIMONVILLER',
    'LALOEUF',
    'PULNEY',
    'SAULXEROTTE',
    'THOREY LYAUTEY',
    'TRAMONT EMY',
    'TRAMONT LASSUS',
    'TRAMONT ST ANDRE',
    'VANDELEVILLE',
  ],
  54740: [
    'AFFRACOURT',
    'BENNEY',
    'BRALLEVILLE',
    'CRANTENOY',
    'GERBECOURT ET HAPLEMONT',
    'GERMONVILLE',
    'HAROUE',
    'JEVONCOURT',
    'LANEUVEVILLE DEVANT BAYON',
    'LEBEUVILLE',
    'LEMAINVILLE',
    'LEMENIL MITRY',
    'ORMES ET VILLE',
    'ST REMIMONT',
    'VAUDEVILLE',
    'VAUDIGNY',
    'XIROCOURT',
  ],
  54770: [
    'AGINCOURT',
    'AMANCE',
    'BOUXIERES AUX CHENES',
    'DOMMARTIN SOUS AMANCE',
    'LAITRE SOUS AMANCE',
  ],
  54460: ['AINGERAY', 'LIVERDUN'],
  54170: [
    'ALLAIN',
    'BAGNEUX',
    'BARISEY AU PLAIN',
    'BARISEY LA COTE',
    'COLOMBEY LES BELLES',
    'CREPEY',
    'DOLCOURT',
    'GERMINY',
    'MONT L ETROIT',
    'OCHEY',
    'SAULXURES LES VANNES',
    'SELAINCOURT',
    'THUILLEY AUX GROSEILLES',
  ],
  54112: ['ALLAMPS', 'GIBEAUMEIX', 'URUFFE', 'VANNES LE CHATEL'],
  54260: [
    'ALLONDRELLE LA MALMAISON',
    'CHARENCY VEZIN',
    'COLMEY',
    'EPIEZ SUR CHIERS',
    'FRESNOIS LA MONTAGNE',
    'GRAND FAILLY',
    'LONGUYON',
    'OTHE',
    'PETIT FAILLY',
    'ST JEAN LES LONGUYON',
    'TELLANCOURT',
    'VILLERS LE ROND',
    'VILLETTE',
    'VIVIERS SUR CHIERS',
  ],
  54450: [
    'AMENONCOURT',
    'ANCERVILLER',
    'AUTREPIERRE',
    'AVRICOURT',
    'BARBAS',
    'BENAMENIL',
    'BLAMONT',
    'BLEMEREY',
    'BURIVILLE',
    'CHAZELLES SUR ALBE',
    'DOMEVRE SUR VEZOUZE',
    'DOMJEVIN',
    'FREMENIL',
    'FREMONVILLE',
    'GOGNEY',
    'GONDREXON',
    'HALLOVILLE',
    'HARBOUEY',
    'HERBEVILLER',
    'IGNEY',
    'LEINTREY',
    'MONTREUX',
    'NONHIGNY',
    'OGEVILLER',
    'RECLONVILLE',
    'REILLON',
    'REPAIX',
    'ST MARTIN',
    'VEHO',
    'VERDENAL',
  ],
  54560: [
    'ANDERNY',
    'AUDUN LE ROMAN',
    'BEUVILLERS',
    'FILLIERES',
    'MALAVILLERS',
    'MERCY LE HAUT',
    'SANCY',
    'SERROUVILLE',
  ],
  54200: [
    'ANDILLY',
    'BICQUELEY',
    'BOUCQ',
    'BOUVRON',
    'BRULEY',
    'CHAUDENEY SUR MOSELLE',
    'CHOLOY MENILLOT',
    'DOMMARTIN LES TOUL',
    'ECROUVES',
    'FRANCHEVILLE',
    'JAILLON',
    'LAGNEY',
    'LUCEY',
    'MENIL LA TOUR',
    'PAGNEY DERRIERE BARINE',
    'PIERRE LA TREICHE',
    'ROYAUMEIX',
    'SANZEY',
    'TOUL',
    'VILLEY ST ETIENNE',
  ],
  54540: [
    'ANGOMONT',
    'BADONVILLER',
    'BIONVILLE',
    'BREMENIL',
    'FENNEVILLER',
    'MIGNEVILLE',
    'MONTIGNY',
    'NEUFMAISONS',
    'NEUVILLER LES BADONVILLER',
    'PEXONNE',
    'PIERRE PERCEE',
    'RAON LES LEAU',
    'ST MAURICE AUX FORGES',
    'STE POLE',
    'VACQUEVILLE',
    'VENEY',
  ],
  54150: [
    'ANOUX',
    'AVRIL',
    'LES BAROCHES',
    'VAL DE BRIEY',
    'FLEVILLE LIXIERES',
    'LANTEFONTAINE',
    'LUBEY',
    'MAIRY MAINVILLE',
    'NORROY LE SEC',
    'OZERAILLES',
  ],
  54470: [
    'ANSAUVILLE',
    'BEAUMONT',
    'BERNECOURT',
    'BOUILLONVILLE',
    'CHAREY',
    'DAMPVITOUX',
    'DOMMARTIN LA CHAUSSEE',
    'ESSEY ET MAIZERAIS',
    'EUVEZIN',
    'FEY EN HAYE',
    'FLIREY',
    'GROSROUVRES',
    'HAGEVILLE',
    'HAMONVILLE',
    'JAULNY',
    'LIMEY REMENAUVILLE',
    'LIRONVILLE',
    'MAMEY',
    'MANDRES AUX QUATRE TOURS',
    'PANNES',
    'REMBERCOURT SUR MAD',
    'ST BAUSSANT',
    'ST JULIEN LES GORZE',
    'SEICHEPREY',
    'THIAUCOURT REGNIEVILLE',
    'VIEVILLE EN HAYE',
    'XAMMES',
  ],
  54110: [
    'ANTHELUPT',
    'BUISSONCOURT',
    'COURBESSEAUX',
    'CREVIC',
    'DOMBASLE SUR MEURTHE',
    'FLAINVAL',
    'GELLENONCOURT',
    'HARAUCOURT',
    'HUDIVILLER',
    'LENONCOURT',
    'REMEREVILLE',
    'ROSIERES AUX SALINES',
    'SOMMERVILLER',
    'VARANGEVILLE',
  ],
  54760: [
    'ARMAUCOURT',
    'ARRAYE ET HAN',
    'BEY SUR SEILLE',
    'FAULX',
    'LANFROICOURT',
    'LEYR',
    'MOIVRONS',
    'MONTENOY',
    'VILLERS LES MOIVRONS',
  ],
  54530: ['ARNAVILLE', 'PAGNY SUR MOSELLE', 'PRENY'],
  54370: [
    'ARRACOURT',
    'ATHIENVILLE',
    'BATHELEMONT',
    'BAUZEMONT',
    'BEZANGE LA GRANDE',
    'BURES',
    'COINCOURT',
    'DEUXVILLE',
    'DROUVILLE',
    'EINVILLE AU JARD',
    'EMBERMENIL',
    'HENAMENIL',
    'HOEVILLE',
    'JUVRECOURT',
    'LANEUVEVILLE AUX BOIS',
    'MAIXE',
    'MOUACOURT',
    'PARROY',
    'RAVILLE SUR SANON',
    'RECHICOURT LA PETITE',
    'REMONCOURT',
    'SERRES',
    'VALHEY',
    'VAUCOURT',
    'XOUSSE',
    'XURES',
  ],
  54510: ['ART SUR MEURTHE', 'TOMBLAINE'],
  54700: [
    'ATTON',
    'BLENOD LES PONT A MOUSSON',
    'BOUXIERES SOUS FROIDMONT',
    'CHAMPEY SUR MOSELLE',
    'JEZAINVILLE',
    'LESMENILS',
    'LOISY',
    'MAIDIERES',
    'MONTAUVILLE',
    'MORVILLE SUR SEILLE',
    'MOUSSON',
    'NORROY LES PONT A MOUSSON',
    'PONT A MOUSSON',
    'PORT SUR SEILLE',
    'STE GENEVIEVE',
    'VILCEY SUR TREY',
    'VILLERS SOUS PRENY',
    'VITTONVILLE',
  ],
  54580: ['AUBOUE', 'MOINEVILLE', 'ST AIL'],
  54380: [
    'AUTREVILLE SUR MOSELLE',
    'BEZAUMONT',
    'DIEULOUARD',
    'GEZONCOURT',
    'GRISCOURT',
    'LANDREMONT',
    'MARTINCOURT',
    'ROGEVILLE',
    'SAIZERAIS',
    'VILLE AU VAL',
    'VILLERS EN HAYE',
  ],
  54160: ['AUTREY', 'FROLOIS', 'PIERREVILLE', 'PULLIGNY'],
  54490: [
    'AVILLERS',
    'DOMPRIX',
    'JOUDREVILLE',
    'MURVILLE',
    'PIENNES',
    'PREUTIN HIGNY',
    'XIVRY CIRCOURT',
  ],
  54385: [
    'AVRAINVILLE',
    'DOMEVRE EN HAYE',
    'MANONCOURT EN WOEVRE',
    'MANONVILLE',
    'MINORVILLE',
    'NOVIANT AUX PRES',
    'ROSIERES EN HAYE',
    'TREMBLECOURT',
  ],
  54210: [
    'AZELOT',
    'BURTHECOURT AUX CHENES',
    'COYVILLER',
    'FERRIERES',
    'LUPCOURT',
    'MANONCOURT EN VERMOIS',
    'SAFFAIS',
    'ST NICOLAS DE PORT',
    'TONNOY',
    'VILLE EN VERMOIS',
  ],
  54122: ['AZERAILLES', 'CHENEVIERES', 'FLIN', 'FONTENOY LA JOUTE', 'GLONVILLE', 'VATHIMENIL'],
  54120: [
    'BACCARAT',
    'BERTRICHAMPS',
    'BROUVILLE',
    'DENEUVRE',
    'GELACOURT',
    'HABLAINVILLE',
    'LACHAPELLE',
    'MERVILLER',
    'PETTONVILLE',
    'REHERREY',
    'THIAVILLE SUR MEURTHE',
    'VAXAINVILLE',
  ],
  54290: [
    'BAINVILLE AUX MIROIRS',
    'BAYON',
    'BORVILLE',
    'BREMONCOURT',
    'CLAYEURES',
    'CREVECHAMPS',
    'DOMPTAIL EN L AIR',
    'FROVILLE',
    'GRIPPORT',
    'HAIGNEVILLE',
    'HAUSSONVILLE',
    'LOREY',
    'LOROMONTZEY',
    'MANGONVILLE',
    'NEUVILLER SUR MOSELLE',
    'ROVILLE DEVANT BAYON',
    'ROZELIEURES',
    'ST BOINGT',
    'ST GERMAIN',
    'ST MARD',
    'ST REMY AUX BOIS',
    'VELLE SUR MOSELLE',
    'VILLACOURT',
    'VIRECOURT',
  ],
  54550: ['BAINVILLE SUR MADON', 'MAIZIERES', 'PONT ST VINCENT', 'SEXEY AUX FORGES'],
  54360: [
    'BARBONVILLE',
    'BLAINVILLE SUR L EAU',
    'CHARMOIS',
    'DAMELEVIERES',
    'EINVAUX',
    'LANDECOURT',
    'MEHONCOURT',
    'MONT SUR MEURTHE',
    'ROMAIN',
    'VIGNEULLES',
  ],
  54620: [
    'BASLIEUX',
    'BAZAILLES',
    'BEUVEILLE',
    'BOISMONT',
    'DONCOURT LES LONGUYON',
    'JOPPECOURT',
    'PIERREPONT',
    'ST SUPPLET',
    'VILLE AU MONTOIS',
    'HAN DEVANT PIERREPONT',
  ],
  54980: ['BATILLY'],
  54890: [
    'BAYONVILLE SUR MAD',
    'CHAMBLEY BUSSIERES',
    'ONVILLE',
    'VANDELAINVILLE',
    'VILLECEY SUR MAD',
    'WAVILLE',
  ],
  54940: ['BELLEVILLE'],
  54480: [
    'BERTRAMBOIS',
    'CIREY SUR VEZOUZE',
    'PARUX',
    'PETITMONT',
    'ST SAUVEUR',
    'TANCONVILLE',
    'VAL ET CHATILLON',
  ],
  54640: ['BETTAINVILLERS', 'TUCQUEGNIEUX'],
  54300: [
    'BIENVILLE LA PETITE',
    'BONVILLER',
    'CHANTEHEUX',
    'CRION',
    'CROISMARE',
    'FRAIMBOIS',
    'HERIMENIL',
    'JOLIVET',
    'LAMATH',
    'LUNEVILLE',
    'MANONVILLER',
    'MARAINVILLER',
    'MONCEL LES LUNEVILLE',
    'REHAINVILLER',
    'SIONVILLER',
    'THIEBAUMENIL',
    'VITRIMONT',
    'XERMAMENIL',
  ],
  54113: [
    'BLENOD LES TOUL',
    'BULLIGNY',
    'CHARMES LA COTE',
    'CREZILLES',
    'GYE',
    'MONT LE VIGNOBLE',
    'MOUTROT',
  ],
  54111: ['MONT BONVILLERS'],
  54136: ['BOUXIERES AUX DAMES'],
  54930: [
    'BOUZANVILLE',
    'COURCELLES',
    'DIARVILLE',
    'FORCELLES SOUS GUGNEY',
    'FRAISNES EN SAINTOIS',
    'GUGNEY',
    'HOUSSEVILLE',
    'ST FIRMIN',
    'THEY SOUS VAUDEMONT',
  ],
  54190: ['BREHAIN LA VILLE', 'TIERCELET', 'VILLERUPT'],
  54790: ['VAL DE BRIEY'],
  54280: [
    'BRIN SUR SEILLE',
    'CHAMPENOUX',
    'ERBEVILLER SUR AMEZULE',
    'LANEUVELOTTE',
    'MAZERULLES',
    'MONCEL SUR SEILLE',
    'SEICHAMPS',
    'SORNEVILLE',
    'VELAINE SOUS AMANCE',
  ],
  54134: ['CEINTREY', 'VOINEMONT'],
  54420: ['CERVILLE', 'SAULXURES LES NANCY'],
  54230: ['CHALIGNY', 'CHAVIGNY', 'MARON', 'NEUVES MAISONS'],
  54250: ['CHAMPIGNEULLES'],
  54330: [
    'CHAOUILLEY',
    'CLEREY SUR BRENON',
    'ETREVAL',
    'FORCELLES ST GORGON',
    'GOVILLER',
    'HAMMEVILLE',
    'HOUDELMONT',
    'HOUDREVILLE',
    'MARTHEMONT',
    'OGNEVILLE',
    'OMELMONT',
    'PAREY ST CESAIRE',
    'QUEVILLONCOURT',
    'SAXON SION',
    'THELOD',
    'VAUDEMONT',
    'VEZELISE',
    'VITREY',
    'VRONCOURT',
  ],
  54720: ['CHENIERES', 'CUTRY', 'LAIX', 'LEXY'],
  54870: ['CONS LA GRANDVILLE', 'MONTIGNY SUR CHIERS', 'UGNY', 'VILLERS LA CHEVRE'],
  54400: ['COSNES ET ROMAIN', 'LONGWY'],
  54680: ['CRUSNES', 'ERROUVILLE'],
  54670: ['CUSTINES', 'MALLELOY', 'MILLERY'],
  54119: ['DOMGERMAIN'],
  54130: ['DOMMARTEMONT', 'ST MAX'],
  54830: [
    'ESSEY LA COTE',
    'FRANCONVILLE',
    'GERBEVILLER',
    'GIRIVILLER',
    'HAUDONVILLE',
    'MATTEXEY',
    'MORIVILLER',
    'REMENOVILLE',
    'SERANVILLE',
    'VALLOIS',
    'VENNEZEY',
  ],
  54270: ['ESSEY LES NANCY'],
  54690: ['EULMONT', 'LAY ST CHRISTOPHE'],
  54630: ['FLAVIGNY SUR MOSELLE', 'RICHARDMENIL'],
  54710: ['FLEVILLE DEVANT NANCY', 'LUDRES'],
  54840: ['FONTENOY SUR MOSELLE', 'GONDREVILLE', 'BOIS DE HAYE', 'VILLEY LE SEC'],
  54570: ['FOUG', 'LANEUVEVILLE DERRIERE FOUG', 'LAY ST REMY', 'TRONDES'],
  54390: ['FROUARD'],
  54780: ['GIRAUMONT'],
  54730: ['GORCY', 'ST PANCRE', 'VILLE HOUDLEMONT'],
  54860: ['HAUCOURT MOULAINE'],
  54180: ['HEILLECOURT', 'HOUDEMONT'],
  54440: ['HERSERANGE'],
  54310: ['HOMECOURT'],
  54590: ['HUSSIGNY GODBRANGE'],
  54140: ['JARVILLE LA MALGRANGE'],
  54114: ['JEANDELAINCOURT'],
  54240: ['JOEUF'],
  54970: ['LANDRES'],
  54410: ['LANEUVEVILLE DEVANT NANCY'],
  54950: ['LARONXE', 'ST CLEMENT'],
  54520: ['LAXOU'],
  54810: ['LONGLAVILLE'],
  54129: ['MAGNIERES'],
  54220: ['MALZEVILLE'],
  54820: ['MARBACHE'],
  54320: ['MAXEVILLE'],
  54960: ['MERCY LE BAS'],
  54850: ['MEREVILLE', 'MESSEIN'],
  54135: ['MEXY'],
  54350: ['MONT ST MARTIN'],
  54920: ['MORFONTAINE', 'VILLERS LA MONTAGNE'],
  54660: ['MOUTIERS'],
  54118: ['MOYEN'],
  54000: ['NANCY'],
  54100: ['NANCY'],
  54340: ['POMPEY'],
  54116: ['PRAYE', 'TANTONVILLE'],
  54425: ['PULNOY'],
  54430: ['REHON'],
  54650: ['SAULNES'],
  54880: ['THIL'],
  54750: ['TRIEUX'],
  54910: ['VALLEROY'],
  54121: ['VANDIERES'],
  54500: ['VANDOEUVRE LES NANCY'],
  54600: ['VILLERS LES NANCY'],
  54123: ['VITERNE'],
  54990: ['XEUILLEY'],
  55130: [
    'ABAINVILLE',
    'AMANTY',
    'BADONVILLIERS GERAUVILLIERS',
    'BONNET',
    'CHASSEY BEAUPRE',
    'DAINVILLE BERTHELEVILLE',
    'DELOUZE ROSIERES',
    'DEMANGE BAUDIGNECOURT',
    'GONDRECOURT LE CHATEAU',
    'HORVILLE EN ORNOIS',
    'HOUDELAINCOURT',
    'LES ROISES',
    'ST JOIRE',
    'TREVERAY',
    'VAUDEVILLE LE HAUT',
    'VOUTHON BAS',
    'VOUTHON HAUT',
  ],
  55400: [
    'ABAUCOURT HAUTECOURT',
    'BLANZEE',
    'BOINVILLE EN WOEVRE',
    'BRAQUIS',
    'BUZY DARMONT',
    'CHATILLON SOUS LES COTES',
    'DAMLOUP',
    'DIEPPE SOUS DOUAUMONT',
    'EIX',
    'ETAIN',
    'FOAMEIX ORNEL',
    'FROMEZEY',
    'GINCREY',
    'GRIMAUCOURT EN WOEVRE',
    'GUSSAINVILLE',
    'HERMEVILLE EN WOEVRE',
    'LANHERES',
    'MAUCOURT SUR ORNE',
    'MOGEVILLE',
    'MORANVILLE',
    'MORGEMOULIN',
    'MOULAINVILLE',
    'PARFONDRUPT',
    'ROUVRES EN WOEVRE',
    'ST JEAN LES BUZY',
    'DOUAUMONT VAUX',
    'WARCQ',
  ],
  55110: [
    'AINCREVILLE',
    'BANTHEVILLE',
    'BRIEULLES SUR MEUSE',
    'CLERY LE GRAND',
    'CLERY LE PETIT',
    'CONSENVOYE',
    'CUNEL',
    'DANNEVOUX',
    'DOULCON',
    'DUN SUR MEUSE',
    'FONTAINES ST CLAIR',
    'FORGES SUR MEUSE',
    'GERCOURT ET DRILLANCOURT',
    'GESNES EN ARGONNE',
    'LINY DEVANT DUN',
    'LION DEVANT DUN',
    'MILLY SUR BRADON',
    'MONT DEVANT SASSEY',
    'MONTIGNY DEVANT SASSEY',
    'MURVAUX',
    'REGNEVILLE SUR MEUSE',
    'ROMAGNE SOUS MONTFAUCON',
    'SASSEY SUR MEUSE',
    'SAULMORY VILLEFRANCHE',
    'SIVRY SUR MEUSE',
    'VILLERS DEVANT DUN',
    'VILOSNES HARAUMONT',
  ],
  55300: [
    'AMBLY SUR MEUSE',
    'APREMONT LA FORET',
    'BANNONCOURT',
    'BISLEE',
    'BOUCONVILLE SUR MADT',
    'BOUQUEMONT',
    'BUXIERES SOUS LES COTES',
    'CHAUVONCOURT',
    'DOMPCEVRIN',
    'DOMPIERRE AUX BOIS',
    'HAN SUR MEUSE',
    'KOEUR LA GRANDE',
    'KOEUR LA PETITE',
    'LACROIX SUR MEUSE',
    'LAHAYVILLE',
    'LAMORVILLE',
    'LOUPMONT',
    'MAIZEY',
    'MECRIN',
    'MONTSEC',
    'LES PAROCHES',
    'RAMBUCOURT',
    'RANZIERES',
    'RICHECOURT',
    'ROUVROIS SUR MEUSE',
    'ST MIHIEL',
    'SAMPIGNY',
    'SEUZEY',
    'TROYON',
    'VARNEVILLE',
    'VALBOIS',
    'VAUX LES PALAMEIX',
    'WOIMBEY',
    'XIVRAY ET MARVOISIN',
  ],
  55230: [
    'AMEL SUR L ETANG',
    'ARRANCY SUR CRUSNES',
    'BILLY SOUS MANGIENNES',
    'DUZEY',
    'GOURAINCOURT',
    'LOISON',
    'MUZERAY',
    'NOUILLONPONT',
    'PILLON',
    'ROUVROIS SUR OTHAIN',
    'ST PIERREVILLERS',
    'SENON',
    'SORBEY',
    'SPINCOURT',
    'VAUDONCOURT',
  ],
  55320: [
    'ANCEMONT',
    'DIEUE SUR MEUSE',
    'GENICOURT SUR MEUSE',
    'LES MONTHAIRONS',
    'MOUILLY',
    'RUPT EN WOEVRE',
    'SOMMEDIEUE',
  ],
  55170: [
    'ANCERVILLE',
    'AULNOIS EN PERTHOIS',
    'BAUDONVILLIERS',
    'BAZINCOURT SUR SAULX',
    'BRAUVILLIERS',
    'COUSANCES LES FORGES',
    'JUVIGNY EN PERTHOIS',
    'LAVINCOURT',
    'RUPT AUX NONAINS',
    'SAVONNIERES EN PERTHOIS',
    'SOMMELONNE',
  ],
  55800: [
    'ANDERNAY',
    'BRABANT LE ROI',
    'CONTRISSON',
    'COUVONGES',
    'LAHEYCOURT',
    'LAIMONT',
    'LOUPPY LE CHATEAU',
    'MOGNEVILLE',
    'NETTANCOURT',
    'NEUVILLE SUR ORNAIN',
    'NOYERS AUZECOURT',
    'RANCOURT SUR ORNAIN',
    'REMENNECOURT',
    'REVIGNY SUR ORNAIN',
    'SOMMEILLES',
    'VASSINCOURT',
    'VILLERS AUX VENTS',
  ],
  55120: [
    'AUBREVILLE',
    'AUTRECOURT SUR AIRE',
    'BRABANT EN ARGONNE',
    'BROCOURT EN ARGONNE',
    'LE CLAON',
    'CLERMONT EN ARGONNE',
    'DOMBASLE EN ARGONNE',
    'FROIDOS',
    'FUTEAU',
    'LES ISLETTES',
    'JOUY EN ARGONNE',
    'JULVECOURT',
    'LACHALADE',
    'LAVOYE',
    'LE NEUFOUR',
    'NEUVILLY EN ARGONNE',
    'NIXEVILLE BLERCOURT',
    'RARECOURT',
    'RECICOURT',
    'VILLE SUR COUSANCES',
  ],
  55700: [
    'AUTREVILLE ST LAMBERT',
    'BAALON',
    'BEAUCLAIR',
    'BEAUFORT EN ARGONNE',
    'BROUENNES',
    'CESSE',
    'HALLES SOUS LES COTES',
    'INOR',
    'LAMOUILLY',
    'LANEUVILLE SUR MEUSE',
    'LUZY ST MARTIN',
    'MARTINCOURT SUR MEUSE',
    'MOULINS ST HUBERT',
    'MOUZAY',
    'NEPVANT',
    'OLIZY SUR CHIERS',
    'POUILLY SUR MEUSE',
    'STENAY',
    'WISEPPE',
  ],
  55210: [
    'AVILLERS STE CROIX',
    'BENEY EN WOEVRE',
    'CHAILLON',
    'HANNONVILLE SOUS LES COTES',
    'HERBEUVILLE',
    'HEUDICOURT SOUS LES COTES',
    'LACHAUSSEE',
    'NONSARD LAMARCHE',
    'ST MAURICE SOUS LES COTES',
    'THILLOT',
    'VIGNEULLES LES HATTONCHATEL',
    'WOEL',
  ],
  55600: [
    'AVIOTH',
    'BAZEILLES SUR OTHAIN',
    'BREUX',
    'CHAUVENCY LE CHATEAU',
    'CHAUVENCY ST HUBERT',
    'ECOUVIEZ',
    'FLASSIGNY',
    'HAN LES JUVIGNY',
    'IRE LE SEC',
    'JAMETZ',
    'JUVIGNY SUR LOISON',
    'LOUPPY SUR LOISON',
    'MARVILLE',
    'MONTMEDY',
    'QUINCY LANDZECOURT',
    'REMOIVILLE',
    'THONNE LA LONG',
    'THONNE LE THIL',
    'THONNE LES PRES',
    'THONNELLE',
    'VELOSNES',
    'VERNEUIL GRAND',
    'VERNEUIL PETIT',
    'VIGNEUL SOUS MONTMEDY',
    'VILLECLOYE',
  ],
  55270: [
    'AVOCOURT',
    'BAULNY',
    'BETHINCOURT',
    'BOUREUILLES',
    'CHARPENTRY',
    'CHEPPY',
    'CIERGES SOUS MONTFAUCON',
    'CUISY',
    'EPINONVILLE',
    'MALANCOURT',
    'MONTBLAINVILLE',
    'MONTFAUCON D ARGONNE',
    'NANTILLOIS',
    'SEPTSARGES',
    'VARENNES EN ARGONNE',
    'VAUQUOIS',
    'VERY',
  ],
  55150: [
    'AZANNES ET SOUMAZANNES',
    'BRANDEVILLE',
    'BREHEVILLE',
    'CHAUMONT DEVANT DAMVILLERS',
    'DAMVILLERS',
    'DELUT',
    'DOMBRAS',
    'ECUREY EN VERDUNOIS',
    'ETRAYE',
    'GREMILLY',
    'LISSEY',
    'MANGIENNES',
    'MERLES SUR LOISON',
    'MOIREY FLABAS CREPION',
    'ORNES',
    'PEUVILLERS',
    'REVILLE AUX BOIS',
    'ROMAGNE SOUS LES COTES',
    'RUPT SUR OTHAIN',
    'ST LAURENT SUR OTHAIN',
    'VILLE DEVANT CHAUMONT',
    'VILLERS LES MANGIENNES',
    'VITTARVILLE',
    'WAVRILLE',
  ],
  55000: [
    'BAR LE DUC',
    'BEHONNE',
    'BEUREY SUR SAULX',
    'BRILLON EN BARROIS',
    'CHARDOGNE',
    'COMBLES EN BARROIS',
    'LES HAUTS DE CHEE',
    'CULEY',
    'ERIZE ST DIZIER',
    'FAINS VEEL',
    'GERY',
    'GUERPONT',
    'HAIRONVILLE',
    'L ISLE EN RIGAULT',
    'LOISEY',
    'LONGEVILLE EN BARROIS',
    'MONTPLONNE',
    'VAL D ORNAIN',
    'NAIVES ROSIERES',
    'RESSON',
    'ROBERT ESPAGNE',
    'RUMONT',
    'SALMAGNE',
    'SAUDRUPT',
    'SAVONNIERES DEVANT BAR',
    'SEIGNEULLES',
    'SILMONT',
    'TANNOIS',
    'TREMONT SUR SAULX',
    'VAVINCOURT',
    'VILLE SUR SAULX',
  ],
  55260: [
    'BAUDREMONT',
    'BELRAIN',
    'CHAUMONT SUR AIRE',
    'COURCELLES EN BARROIS',
    'COURCELLES SUR AIRE',
    'COUROUVRE',
    'ERIZE LA BRULEE',
    'ERIZE LA PETITE',
    'FRESNES AU MONT',
    'GIMECOURT',
    'LAHAYMEIX',
    'LAVALLEE',
    'LEVONCOURT',
    'LIGNIERES SUR AIRE',
    'LONGCHAMPS SUR AIRE',
    'MENIL AUX BOIS',
    'NEUVILLE EN VERDUNOIS',
    'NICEY SUR AIRE',
    'PIERREFITTE SUR AIRE',
    'RAIVAL',
    'RUPT DEVANT ST MIHIEL',
    'THILLOMBOIS',
    'VILLE DEVANT BELRAIN',
    'VILLOTTE SUR AIRE',
  ],
  55250: [
    'BEAULIEU EN ARGONNE',
    'BEAUSITE',
    'BRIZEAUX',
    'EVRES',
    'FOUCAUCOURT SUR THABAS',
    'LISLE EN BARROIS',
    'NUBECOURT',
    'PRETZ EN ARGONNE',
    'REMBERCOURT SOMMAISNE',
    'SEUIL D ARGONNE',
    'VAUBECOURT',
    'VILLOTTE DEVANT LOUPPY',
    'WALY',
  ],
  55100: [
    'BEAUMONT EN VERDUNOIS',
    'BELLERAY',
    'BELRUPT EN VERDUNOIS',
    'BETHELAINVILLE',
    'BEZONVAUX',
    'BRABANT SUR MEUSE',
    'BRAS SUR MEUSE',
    'CHAMPNEUVILLE',
    'CHARNY SUR MEUSE',
    'CHATTANCOURT',
    'CUMIERES LE MORT HOMME',
    'DUGNY SUR MEUSE',
    'ESNES EN ARGONNE',
    'FLEURY DEVANT DOUAUMONT',
    'FROMEREVILLE LES VALLONS',
    'HAUDAINVILLE',
    'HAUMONT PRES SAMOGNEUX',
    'LANDRECOURT LEMPIRE',
    'LOUVEMONT COTE DU POIVRE',
    'MARRE',
    'MONTZEVILLE',
    'SAMOGNEUX',
    'SIVRY LA PERCHE',
    'VACHERAUVILLE',
    'DOUAUMONT VAUX',
    'VERDUN',
  ],
  55430: ['BELLEVILLE SUR MEUSE'],
  55290: [
    'BIENCOURT SUR ORGE',
    'BURE',
    'COUVERTPUIS',
    'HEVILLIERS',
    'MANDRES EN BARROIS',
    'MONTIERS SUR SAULX',
    'MORLEY',
    'RIBEAUCOURT',
  ],
  55200: [
    'BONCOURT SUR MEUSE',
    'BROUSSEY RAULECOURT',
    'CHONVILLE MALAUMONT',
    'COMMERCY',
    'EUVILLE',
    'FREMEREVILLE SOUS LES COTES',
    'GIRAUVOISIN',
    'GEVILLE',
    'LEROUVILLE',
    'PONT SUR MEUSE',
    'ST JULIEN SOUS LES COTES',
    'VADONVILLE',
    'VIGNOT',
  ],
  55160: [
    'BONZEE',
    'COMBRES SOUS LES COTES',
    'DOMMARTIN LA MONTAGNE',
    'DONCOURT AUX TEMPLIERS',
    'LES EPARGES',
    'FRESNES EN WOEVRE',
    'HARVILLE',
    'HAUDIOMONT',
    'HENNEMONT',
    'JONVILLE EN WOEVRE',
    'LABEUVILLE',
    'LATOUR EN WOEVRE',
    'MAIZERAY',
    'MANHEULLES',
    'MARCHEVILLE EN WOEVRE',
    'MOULOTTE',
    'PAREID',
    'PINTHEVILLE',
    'RIAVILLE',
    'RONVAUX',
    'ST HILAIRE EN WOEVRE',
    'ST REMY LA CALONNE',
    'SAULX LES CHAMPLON',
    'TRESAUVAUX',
    'VILLE EN WOEVRE',
    'VILLERS SOUS PAREID',
    'WATRONVILLE',
  ],
  55500: [
    'LE BOUCHON SUR SAULX',
    'BOVIOLLES',
    'DAGONVILLE',
    'DAMMARIE SUR SAULX',
    'ERNEVILLE AUX BOIS',
    'FOUCHERES AUX BOIS',
    'GIVRAUVAL',
    'GRIMAUCOURT PRES SAMPIGNY',
    'LIGNY EN BARROIS',
    'LONGEAUX',
    'MAULAN',
    'MENAUCOURT',
    'MENIL SUR SAULX',
    'CHANTERAINE',
    'NAIX AUX FORGES',
    'NANCOIS LE GRAND',
    'NANCOIS SUR ORNAIN',
    'NANT LE GRAND',
    'NANT LE PETIT',
    'NANTOIS',
    'ST AMAND SUR ORNAIN',
    'ST AUBIN SUR AIRE',
    'SAULVAUX',
    'STAINVILLE',
    'COUSANCES LES TRICONVILLE',
    'VELAINES',
    'VILLERS LE SEC',
    'WILLERONCOURT',
  ],
  55240: ['BOULIGNY', 'DOMMARY BARONCOURT', 'DOMREMY LA CANNE', 'ETON'],
  55190: [
    'BOVEE SUR BARBOURE',
    'BROUSSEY EN BLOIS',
    'LANEUVILLE AU RUPT',
    'MARSON SUR BARBOURE',
    'MAUVAGES',
    'MELIGNY LE GRAND',
    'MELIGNY LE PETIT',
    'MENIL LA HORGNE',
    'NAIVES EN BLOIS',
    'OURCHES SUR MEUSE',
    'PAGNY SUR MEUSE',
    'REFFROY',
    'SAUVOY',
    'SORCY ST MARTIN',
    'TROUSSEY',
    'VILLEROY SUR MEHOLLE',
    'VOID VACON',
  ],
  55140: [
    'BRIXEY AUX CHANOINES',
    'BUREY EN VAUX',
    'BUREY LA COTE',
    'CHALAINES',
    'CHAMPOUGNY',
    'EPIEZ SUR MEUSE',
    'GOUSSAINCOURT',
    'MAXEY SUR VAISE',
    'MONTBRAS',
    'MONTIGNY LES VAUCOULEURS',
    'NEUVILLE LES VAUCOULEURS',
    'PAGNY LA BLANCHE COTE',
    'RIGNY LA SALLE',
    'RIGNY ST MARTIN',
    'ST GERMAIN SUR MEUSE',
    'SAUVIGNY',
    'SEPVIGNY',
    'TAILLANCOURT',
    'UGNY SUR MEUSE',
    'VAUCOULEURS',
  ],
  55220: [
    'HEIPPES',
    'IPPECOURT',
    'LES TROIS DOMAINES',
    'LEMMES',
    'OSCHES',
    'RAMBLUZIN ET BENOITE VAUX',
    'RECOURT LE CREUX',
    'ST ANDRE EN BARROIS',
    'SENONCOURT LES MAUJOUY',
    'LES SOUHESMES RAMPONT',
    'SOUILLY',
    'TILLY SUR MEUSE',
    'VADELAINCOURT',
    'VILLERS SUR MEUSE',
  ],
  55840: ['THIERVILLE SUR MEUSE'],
  55310: ['TRONVILLE EN BARROIS'],
  56350: [
    'ALLAIRE',
    'BEGANNE',
    'RIEUX',
    'ST GORGON',
    'ST JEAN LA POTERIE',
    'ST PERREUX',
    'ST VINCENT SUR OUST',
  ],
  56190: [
    'AMBON',
    'ARZAL',
    'BILLIERS',
    'LE GUERNO',
    'LAUZACH',
    'MUZILLAC',
    'NOYAL MUZILLAC',
    'LA TRINITE SURZUR',
  ],
  56610: ['ARRADON'],
  56640: ['ARZON'],
  56800: [
    'AUGAN',
    'CAMPENEAC',
    'GOURHEL',
    'GUILLAC',
    'LOYAT',
    'MONTERTELOT',
    'PLOERMEL',
    'VAL D OUST',
    'TAUPONT',
  ],
  56400: [
    'AURAY',
    'BRECH',
    'PLOEMEL',
    'PLOUGOUMELEN',
    'PLUMERGAT',
    'PLUNERET',
    'LE BONO',
    'STE ANNE D AURAY',
  ],
  56870: ['BADEN', 'LARMOR BADEN'],
  56360: ['BANGOR', 'LOCMARIA', 'LE PALAIS', 'SAUZON'],
  56150: ['BAUD', 'GUENIN', 'ST BARTHELEMY'],
  56380: ['BEIGNON', 'GUER', 'MONTENEUF', 'PORCARO', 'ST MALO DE BEIGNON'],
  56550: ['BELZ', 'LOCOAL MENDON'],
  56240: ['BERNE', 'CALAN', 'INGUINIEL', 'LANVAUDAN', 'PLOUAY'],
  56230: ['BERRIC', 'LE COURS', 'LARRE', 'MOLAC', 'QUESTEMBERT'],
  56500: [
    'BIGNAN',
    'LA CHAPELLE NEUVE',
    'LOCMINE',
    'MOREAC',
    'MOUSTOIR AC',
    'EVELLYS',
    'PLUMELIN',
    'RADENAC',
    'REGUINY',
    'ST ALLOUESTRE',
  ],
  56420: ['BILLIO', 'BULEON', 'CRUGUEL', 'GUEHENNO', 'PLAUDREN', 'PLUMELEC'],
  56140: [
    'BOHAL',
    'CARO',
    'MALESTROIT',
    'MISSIRIAC',
    'PLEUCADEUC',
    'REMINIAC',
    'RUFFIAC',
    'ST ABRAHAM',
    'ST CONGARD',
    'ST LAURENT SUR OUST',
    'ST MARCEL',
    'TREAL',
  ],
  56700: ['BRANDERION', 'HENNEBONT', 'KERVIGNAC', 'MERLEVENEZ', 'STE HELENE'],
  56390: ['BRANDIVY', 'COLPO', 'GRAND CHAMP', 'LOCMARIA GRAND CHAMP', 'LOCQUELTAS'],
  56580: ['BREHAN', 'CREDIN', 'ROHAN'],
  56430: [
    'BRIGNAC',
    'CONCORET',
    'MAURON',
    'NEANT SUR YVEL',
    'ST BRIEUC DE MAURON',
    'ST LERY',
    'TREHORENTEUC',
  ],
  56310: ['BUBRY', 'GUERN', 'MELRAND', 'PLUMELIAU BIEUZY', 'QUISTINIC'],
  56220: [
    'CADEN',
    'LIMERZEL',
    'MALANSAC',
    'PEILLAC',
    'PLUHERLIN',
    'ROCHEFORT EN TERRE',
    'ST GRAVE',
    'ST JACUT LES PINS',
  ],
  56130: [
    'CAMOEL',
    'FEREL',
    'MARZAN',
    'NIVILLAC',
    'PEAULE',
    'LA ROCHE BERNARD',
    'ST DOLAY',
    'THEHILLAC',
  ],
  56330: ['CAMORS', 'PLUVIGNER'],
  56910: ['CARENTOIR', 'ST NICOLAS DU TERTRE'],
  56340: ['CARNAC', 'PLOUHARNEL'],
  56850: ['CAUDAN'],
  56620: ['CLEGUER', 'PONT SCORFF'],
  56480: ['CLEGUEREC', 'ST AIGNAN', 'STE BRIGITTE', 'SILFIAC'],
  56200: ['COURNON', 'LES FOUGERETS', 'LA GACILLY', 'ST MARTIN SUR OUST'],
  56950: ['CRACH'],
  56540: ['LE CROISTY', 'ST CARADEC TREGOMEL', 'ST TUGDUAL', 'KERNASCLEDEN'],
  56120: [
    'LA CROIX HELLEAN',
    'LA GREE ST LAURENT',
    'GUEGON',
    'HELLEAN',
    'JOSSELIN',
    'FORGES DE LANOUEE',
    'LANTILLAC',
    'PLEUGRIFFET',
    'ST SERVANT',
  ],
  56750: ['DAMGAN'],
  56250: ['ELVEN', 'MONTERBLANC', 'ST NOLFF', 'SULNIAC', 'TREDION', 'TREFFLEAN', 'LA VRAIE CROIX'],
  56410: ['ERDEVEN', 'ETEL'],
  56490: [
    'EVRIGUET',
    'GUILLIERS',
    'MENEAC',
    'MOHON',
    'ST MALO DES TROIS FONTAINES',
    'LA TRINITE PORHOET',
  ],
  56320: ['LE FAOUET', 'LANVENEGEN', 'MESLAN', 'PRIZIAC'],
  56680: ['GAVRES', 'PLOUHINEC'],
  56530: ['GESTEL', 'QUEVEN'],
  56110: ['GOURIN', 'ROUDOUALLEC', 'LE SAINT'],
  56590: ['GROIX'],
  56920: ['GUELTAS', 'KERFOURN', 'NOYAL PONTIVY', 'ST GERAND CROIXANVEC', 'ST GONNERY'],
  56160: [
    'GUEMENE SUR SCORFF',
    'LANGOELAN',
    'LIGNOL',
    'LOCMALO',
    'PERSQUEN',
    'PLOERDUT',
    'SEGLIEN',
  ],
  56520: ['GUIDEL'],
  56560: ['GUISCRIFF'],
  56450: ['LE HEZO', 'ST ARMEL', 'SURZUR', 'THEIX NOYALO'],
  56170: ['HOEDIC', 'ILE D HOUAT', 'QUIBERON'],
  56780: ['ILE AUX MOINES'],
  56840: ['ILE D ARZ'],
  56650: ['INZINZAC LOCHRIST'],
  56300: ['KERGRIST', 'MALGUENAC', 'NEULLIAC', 'PONTIVY', 'ST THURIAU', 'LE SOURN'],
  56690: ['LANDAUL', 'LANDEVANT', 'NOSTANG'],
  56600: ['LANESTER'],
  56630: ['LANGONNET'],
  56440: ['LANGUIDIC'],
  56260: ['LARMOR PLAGE'],
  56460: ['LIZIO', 'VAL D OUST', 'ST GUYOMARD', 'SERENT'],
  56740: ['LOCMARIAQUER'],
  56570: ['LOCMIQUELIC'],
  56100: ['LORIENT'],
  56890: ['MEUCON', 'PLESCOP', 'ST AVE'],
  56760: ['PENESTIN'],
  56270: ['PLOEMEUR'],
  56880: ['PLOEREN'],
  56770: ['PLOURAY'],
  56930: ['PLUMELIAU BIEUZY'],
  56290: ['PORT LOUIS'],
  56670: ['RIANTEC'],
  56730: ['ST GILDAS DE RHUYS'],
  56660: ['ST JEAN BREVELAY'],
  56470: ['ST PHILIBERT', 'LA TRINITE SUR MER'],
  56510: ['ST PIERRE QUIBERON'],
  56370: ['SARZEAU', 'LE TOUR DU PARC'],
  56860: ['SENE'],
  56000: ['VANNES'],
  57920: [
    'ABONCOURT',
    'BUDING',
    'HOMBOURG BUDANGE',
    'KEDANGE SUR CANNER',
    'KEMPLICH',
    'KLANG',
    'METZERESCHE',
    'MONNEREN',
    'VECKRING',
  ],
  57590: [
    'ABONCOURT SUR SEILLE',
    'AJONCOURT',
    'ALAINCOURT LA COTE',
    'AULNOIS SUR SEILLE',
    'BACOURT',
    'CHICOURT',
    'CRAINCOURT',
    'DELME',
    'DONJEUX',
    'FONTENY',
    'FOSSIEUX',
    'FREMERY',
    'HANNOCOURT',
    'JALLAUCOURT',
    'JUVILLE',
    'LANEUVEVILLE EN SAULNOIS',
    'LEMONCOURT',
    'LIOCOURT',
    'LUCY',
    'MALAUCOURT SUR SEILLE',
    'MANHOUE',
    'MORVILLE SUR NIED',
    'ORIOCOURT',
    'ORON',
    'PREVOCOURT',
    'PUZIEUX',
    'TINCRY',
    'VIVIERS',
    'XOCOURT',
  ],
  57560: [
    'ABRESCHVILLER',
    'LAFRIMBOLLE',
    'METAIRIES ST QUIRIN',
    'NIDERHOFF',
    'ST QUIRIN',
    'TURQUESTEIN BLANCRUPT',
    'VASPERVILLER',
    'VOYER',
  ],
  57340: [
    'ACHAIN',
    'BARONVILLE',
    'BELLANGE',
    'BERMERING',
    'BREHAIN',
    'BRULANGE',
    'CHATEAU BREHAIN',
    'CONTHIL',
    'DALHAIN',
    'DESTRY',
    'EINCHEVILLE',
    'HABOUDANGE',
    'HARPRICH',
    'LANDROFF',
    'LIDREZING',
    'MARTHILLE',
    'MORHANGE',
    'PEVANGE',
    'RACRANGE',
    'RICHE',
    'RODALBE',
    'SUISSE',
    'VALLERANGE',
    'VANNECOURT',
    'VILLER',
    'VILLERS SUR NIED',
    'VIRMING',
    'ZARBELING',
  ],
  57412: ['ACHEN', 'ETTING', 'KALHAUSEN', 'SCHMITTVILLER'],
  57580: [
    'ADAINCOURT',
    'ANCERVILLE',
    'ARRIANCE',
    'AUBE',
    'BAUDRECOURT',
    'BECHY',
    'BEUX',
    'CHANVILLE',
    'CHENOIS',
    'FLOCOURT',
    'HAN SUR NIED',
    'HERNY',
    'LEMUD',
    'LESSE',
    'LUPPY',
    'REMILLY',
    'ST EPVRE',
    'SORBEY',
    'THIMONVILLE',
    'TRAGNY',
    'VATIMONT',
    'VITTONCOURT',
    'VOIMHAUT',
  ],
  57380: [
    'ADELANGE',
    'ARRAINCOURT',
    'BOUSTROFF',
    'FAULQUEMONT',
    'GUESSLING HEMERING',
    'HOLACOURT',
    'MAINVILLERS',
    'MANY',
    'PONTPIERRE',
    'THICOURT',
    'THONVILLE',
    'VAHL LES FAULQUEMONT',
  ],
  57670: [
    'ALBESTROFF',
    'BENESTROFF',
    'FRANCALTROFF',
    'GIVRYCOURT',
    'GUINZELING',
    'HONSKIRCH',
    'INSMING',
    'INSVILLER',
    'LENING',
    'LHOR',
    'LOSTROFF',
    'LOUDREFING',
    'MARIMONT LES BENESTROFF',
    'MOLRING',
    'MONTDIDIER',
    'MUNSTER',
    'NEBING',
    'NELLING',
    'NEUFVILLAGE',
    'RENING',
    'TORCHEVILLE',
    'VAHL LES BENESTROFF',
    'VIBERSVILLER',
    'VITTERSBOURG',
  ],
  57440: ['ALGRANGE', 'ANGEVILLERS'],
  57515: ['ALSTING'],
  57660: [
    'ALTRIPPE',
    'BERIG VINTRANGE',
    'BIDING',
    'BISTROFF',
    'DIFFEMBACH LES HELLIMER',
    'ERSTROFF',
    'FREMESTROFF',
    'FREYBOUSE',
    'GRENING',
    'GROSTENQUIN',
    'HELLIMER',
    'LANING',
    'LELLING',
    'LEYVILLER',
    'LIXING LES ST AVOLD',
    'MAXSTADT',
    'PETIT TENQUIN',
    'VAHL EBERSING',
  ],
  57730: ['ALTVILLER', 'FOLSCHVILLER', 'LACHAMBRE', 'MACHEREN', 'VALMONT'],
  57320: [
    'ALZING',
    'ANZELING',
    'BIBICHE',
    'BOUZONVILLE',
    'BRETTNACH',
    'CHATEAU ROUGE',
    'CHEMERY LES DEUX',
    'COLMEN',
    'DALSTEIN',
    'EBERSVILLER',
    'FILSTROFF',
    'FLASTROFF',
    'FREISTROFF',
    'GUERSTLING',
    'HEINING LES BOUZONVILLE',
    'HESTROFF',
    'MENSKIRCH',
    'NEUNKIRCHEN LES BOUZONVILLE',
    'OBERDORFF',
    'REMELFANG',
    'ST FRANCOIS LACROIX',
    'SCHWERDORFF',
    'TROMBORN',
    'VAUDRECHING',
    'WALDWEISTROFF',
    'VOELFLING LES BOUZONVILLE',
  ],
  57865: ['AMANVILLERS'],
  57170: [
    'AMELECOURT',
    'ATTILLONCOURT',
    'BIONCOURT',
    'BURLIONCOURT',
    'CHAMBREY',
    'CHATEAU SALINS',
    'CHATEAU VOUE',
    'FRESNES EN SAULNOIS',
    'GERBECOURT',
    'GREMECEY',
    'HAMPONT',
    'LUBECOURT',
    'MORVILLE LES VIC',
    'OBRECK',
    'PETTONCOURT',
    'PUTTIGNY',
    'SALONNES',
    'SOTZELING',
    'VAXY',
    'WUISSE',
  ],
  57360: ['AMNEVILLE'],
  57130: [
    'ANCY DORNOT',
    'ARS SUR MOSELLE',
    'GRAVELOTTE',
    'JOUY AUX ARCHES',
    'JUSSY',
    'REZONVILLE VIONVILLE',
    'STE RUFFINE',
    'VAUX',
    'VERNEVILLE',
  ],
  57640: [
    'ANTILLY',
    'ARGANCY',
    'BETTELAINVILLE',
    'CHARLY ORADOUR',
    'FAILLY',
    'MALROY',
    'STE BARBE',
    'ST HUBERT',
    'SANRY LES VIGY',
    'SERVIGNY LES STE BARBE',
    'VIGY',
    'VRY',
  ],
  57480: [
    'APACH',
    'CONTZ LES BAINS',
    'GRINDORFF BIZING',
    'HALSTROFF',
    'HUNTING',
    'KERLING LES SIERCK',
    'KIRSCH LES SIERCK',
    'KIRSCHNAUMEN',
    'HAUTE KONTZ',
    'LAUMESFELD',
    'LAUNSTROFF',
    'MALLING',
    'MANDEREN RITZING',
    'MERSCHWEILLER',
    'MONTENACH',
    'REMELING',
    'RETTEL',
    'RUSTROFF',
    'SIERCK LES BAINS',
    'WALDWISSE',
  ],
  57680: ['ARRY', 'CORNY SUR MOSELLE', 'GORZE', 'NOVEANT SUR MOSELLE'],
  57530: [
    'ARS LAQUENEXY',
    'BAZONCOURT',
    'COINCY',
    'COLLIGNY MAIZERY',
    'COURCELLES CHAUSSY',
    'COURCELLES SUR NIED',
    'LES ETANGS',
    'GLATIGNY',
    'HAYES',
    'LAQUENEXY',
    'MAIZEROY',
    'MARSILLY',
    'OGY MONTOY FLANVILLE',
    'PANGE',
    'RAVILLE',
    'SANRY SUR NIED',
    'SERVIGNY LES RAVILLE',
    'SILLY SUR NIED',
    'VILLERS STONCOURT',
  ],
  57405: ['ARZVILLER', 'GUNTZVILLER', 'HOMMARTING'],
  57790: [
    'ASPACH',
    'FRAQUELFING',
    'HATTIGNY',
    'HERMELANGE',
    'LANEUVEVILLE LES LORQUIN',
    'LORQUIN',
    'NITTING',
  ],
  57260: [
    'ASSENONCOURT',
    'BASSING',
    'BIDESTROFF',
    'BLANCHE EGLISE',
    'BOURGALTROFF',
    'CUTTING',
    'DESSELING',
    'DIEUZE',
    'DOMNOM LES DIEUZE',
    'GELUCOURT',
    'GUEBESTROFF',
    'GUEBLANGE LES DIEUZE',
    'GUEBLING',
    'VAL DE BRIDE',
    'GUERMANGE',
    'LINDRE BASSE',
    'LINDRE HAUTE',
    'MULCEY',
    'RORBACH LES DIEUZE',
    'ST MEDARD',
    'TARQUIMPOL',
    'VERGAVILLE',
    'ZOMMANGE',
  ],
  57390: ['AUDUN LE TICHE', 'REDANGE', 'RUSSANGE'],
  57685: ['AUGNY'],
  57710: ['AUMETZ', 'TRESSANGE'],
  57810: [
    'AVRICOURT',
    'AZOUDANGE',
    'BOURDONNAY',
    'DONNELAY',
    'FRIBOURG',
    'LAGARDE',
    'LANGUIMBERG',
    'LEY',
    'MAIZIERES LES VIC',
    'MONCOURT',
    'OMMERAY',
    'RECHICOURT LE CHATEAU',
    'RHODES',
  ],
  57300: ['AY SUR MOSELLE', 'HAGONDANGE', 'MONDELANGE', 'TREMERY'],
  57230: [
    'BAERENTHAL',
    'BITCHE',
    'BOUSSEVILLER',
    'EGUELSHARDT',
    'HANVILLER',
    'HASPELSCHIEDT',
    'LIEDERSCHIEDT',
    'PHILIPPSBOURG',
    'REYERSVILLER',
    'ROPPEVILLER',
    'SCHORBACH',
    'STURZELBRONN',
  ],
  57690: [
    'BAMBIDERSTROFF',
    'CREHANGE',
    'ELVANGE',
    'FLETRANGE',
    'GUINGLANGE',
    'HALLERING',
    'HEMILLY',
    'MARANGE ZONDRANGE',
    'HAUTE VIGNEULLES',
    'ZIMMING',
  ],
  57220: [
    'BANNAY',
    'BETTANGE',
    'BIONVILLE SUR NIED',
    'BISTEN EN LORRAINE',
    'BOUCHEPORN',
    'BOULAY MOSELLE',
    'BROUCK',
    'BURTONCOURT',
    'CHARLEVILLE SOUS BOIS',
    'CONDE NORTHEN',
    'COUME',
    'DENTING',
    'EBLANGE',
    'FOULIGNY',
    'GOMELANGE',
    'GUINKIRCHEN',
    'HELSTROFF',
    'HINCKANGE',
    'HOLLING',
    'MEGANGE',
    'MOMERSTROFF',
    'NARBEFONTAINE',
    'NIEDERVISSE',
    'OBERVISSE',
    'OTTONVILLE',
    'PIBLANGE',
    'ROUPELDANGE',
    'TETERCHEN',
    'VALMUNSTER',
    'VARIZE VAUDONCOURT',
    'VELVING',
    'VOLMERANGE LES BOULAY',
  ],
  57050: ['LE BAN ST MARTIN', 'LONGEVILLE LES METZ', 'LORRY LES METZ', 'METZ', 'PLAPPEVILLE'],
  57830: [
    'BARCHAIN',
    'BEBING',
    'DIANE CAPELLE',
    'FOULCREY',
    'HEMING',
    'HERTZING',
    'IBIGNY',
    'KERPRICH AUX BOIS',
    'LANDANGE',
    'NEUFMOULINS',
    'RICHEVAL',
    'ST GEORGES',
    'XOUAXANGE',
  ],
  57450: ['BARST', 'CAPPEL', 'FAREBERSVILLER', 'FARSCHVILLER', 'HENRIVILLE', 'THEDING'],
  57460: ['BEHREN LES FORBACH', 'BOUSBACH', 'ETZLING', 'KERBACH'],
  57800: ['BENING LES ST AVOLD', 'BETTING', 'COCHEREN', 'FREYMING MERLEBACH', 'ROSBRUCK'],
  57570: [
    'BERG SUR MOSELLE',
    'BEYREN LES SIERCK',
    'BOUST',
    'BREISTROFF LA GRANDE',
    'CATTENOM',
    'EVRANGE',
    'FIXEM',
    'GAVISSE',
    'HAGEN',
    'MONDORFF',
    'PUTTELANGE LES THIONVILLE',
    'BASSE RENTGEN',
    'RODEMACK',
  ],
  57370: [
    'BERLING',
    'BOURSCHEID',
    'DANNE ET QUATRE VENTS',
    'HANGVILLER',
    'METTING',
    'MITTELBRONN',
    'PHALSBOURG',
    'ST JEAN KOURTZERODE',
    'SCHALBACH',
    'VECKERSVILLER',
    'VESCHEIM',
    'VILSBERG',
    'WALTEMBOURG',
    'ZILLING',
  ],
  57930: [
    'BERTHELMING',
    'BETTBORN',
    'BELLES FORETS',
    'FENETRANGE',
    'GOSSELMING',
    'HELLERING LES FENETRANGE',
    'MITTERSHEIM',
    'NIEDERSTINZEL',
    'OBERSTINZEL',
    'POSTROFF',
    'ROMELFING',
    'ST JEAN DE BASSEL',
  ],
  57310: ['BERTRANGE', 'BOUSSE', 'GUENANGE', 'RURANGE LES THIONVILLE'],
  57550: [
    'BERVILLER EN MOSELLE',
    'DALEM',
    'FALCK',
    'HARGARTEN AUX MINES',
    'MERTEN',
    'REMERING',
    'VILLING',
  ],
  57410: [
    'BETTVILLER',
    'BINING',
    'GROS REDERCHING',
    'LAMBACH',
    'PETIT REDERCHING',
    'RAHLING',
    'ROHRBACH LES BITCHE',
    'SIERSTHAL',
  ],
  57630: [
    'BEZANGE LA PETITE',
    'HARAUCOURT SUR SEILLE',
    'JUVELIZE',
    'LEZEY',
    'MARSAL',
    'MOYENVIC',
    'VIC SUR SEILLE',
    'XANREY',
  ],
  57635: [
    'BICKENHOLTZ',
    'BROUVILLER',
    'FLEISHEIM',
    'HERANGE',
    'LIXHEIM',
    'VIEUX LIXHEIM',
    'WINTERSBOURG',
  ],
  57200: [
    'BLIESBRUCK',
    'BLIES EBERSING',
    'BLIES GUERSVILLER',
    'FRAUENBERG',
    'REMELFING',
    'SARREGUEMINES',
    'WIESVILLER',
    'WOELFLING LES SARREGUEMINES',
  ],
  57655: ['BOULANGE'],
  57720: [
    'BREIDENBACH',
    'EPPING',
    'ERCHING',
    'HOTTVILLER',
    'LENGELSHEIM',
    'LOUTZVILLER',
    'NOUSSEVILLER LES BITCHE',
    'OBERGAILBACH',
    'ORMERSVILLER',
    'RIMLING',
    'ROLBING',
    'SCHWEYEN',
    'VOLMUNSTER',
    'WALDHOUSE',
    'WALSCHBRONN',
  ],
  57535: ['BRONVAUX', 'MARANGE SILVANGE'],
  57565: ['BROUDERDORFF', 'NIDERVILLER'],
  57420: [
    'BUCHY',
    'CHEMINOT',
    'CHERISEY',
    'COIN LES CUVRY',
    'COIN SUR SEILLE',
    'CUVRY',
    'FEY',
    'FLEURY',
    'FOVILLE',
    'GOIN',
    'LIEHON',
    'LORRY MARDIGNY',
    'LOUVIGNY',
    'MARIEULLES',
    'MONCHEUX',
    'ORNY',
    'PAGNY LES GOIN',
    'POMMERIEUX',
    'PONTOY',
    'POUILLY',
    'POURNOY LA CHETIVE',
    'POURNOY LA GRASSE',
    'SAILLY ACHATEL',
    'ST JURE',
    'SECOURT',
    'SILLEGNY',
    'SILLY EN SAULNOIS',
    'SOLGNE',
    'VERNY',
    'VIGNY',
    'VULMONT',
  ],
  57970: [
    'BUDLING',
    'ELZANGE',
    'BASSE HAM',
    'ILLANGE',
    'INGLANGE',
    'KOENIGSMACKER',
    'KUNTZIG',
    'OUDRENNE',
    'VALMESTROFF',
    'YUTZ',
    'STUCKANGE',
  ],
  57400: [
    'BUHL LORRAINE',
    'DOLVING',
    'HAUT CLOCHER',
    'HESSE',
    'HILBESHEIM',
    'IMLING',
    'LANGATTE',
    'SARRALTROFF',
    'SARREBOURG',
    'SCHNECKENBUSCH',
  ],
  57490: ['CARLING', 'L HOPITAL'],
  57365: ['CHAILLY LES ENNERY', 'ENNERY', 'FLEVY'],
  57160: ['CHATEL ST GERMAIN', 'LESSY', 'MOULINS LES METZ', 'ROZERIEULLES', 'SCY CHAZELLES'],
  57245: ['CHESNY', 'JURY', 'MECLEUVES', 'PELTRE'],
  57070: ['CHIEULLES', 'METZ', 'MEY', 'ST JULIEN LES METZ', 'VANTOUX', 'VANY'],
  57185: ['CLOUANGE', 'VITRY SUR ORNE'],
  57150: ['CREUTZWALD'],
  57850: ['DABO', 'HASELBOURG'],
  57820: ['DANNELBOURG', 'GARREBOURG', 'HENRIDORFF', 'HULTEHOUSE', 'LUTZELBOURG', 'ST LOUIS'],
  57980: ['DIEBLING', 'METZING', 'TENTELING'],
  57925: ['DISTROFF'],
  57415: ['ENCHENBERG', 'MONTBRONN'],
  57330: [
    'ENTRANGE',
    'ESCHERANGE',
    'HETTANGE GRANDE',
    'KANFEN',
    'ROUSSY LE VILLAGE',
    'VOLMERANGE LES MINES',
    'ZOUFFTGEN',
  ],
  57510: [
    'ERNESTVILLER',
    'GRUNDVILLER',
    'GUEBENHOUSE',
    'HILSPRICH',
    'HOLVING',
    'HOSTE',
    'LOUPERSHOUSE',
    'PUTTELANGE AUX LACS',
    'REMERING LES PUTTELANGE',
    'RICHELING',
    'ST JEAN ROHRBACH',
  ],
  57290: ['FAMECK', 'SEREMANGE ERZANGE'],
  57280: ['FEVES', 'HAUCONCOURT', 'MAIZIERES LES METZ', 'SEMECOURT'],
  57190: ['FLORANGE'],
  57600: ['FOLKLING', 'FORBACH', 'MORSBACH', 'OETING'],
  57650: ['FONTOY', 'HAVANGE', 'LOMMERANGE'],
  57175: ['GANDRANGE'],
  57620: ['GOETZENBRUCK', 'LEMBERG', 'MOUTERHOUSE', 'ST LOUIS LES BITCHE'],
  57815: ['GONDREXANGE'],
  57520: ['GROSBLIEDERSTROFF', 'LIXING LES ROUHLING', 'ROUHLING'],
  57430: [
    'LE VAL DE GUEBLANGE',
    'HAZEMBOURG',
    'KAPPELKINGER',
    'KIRVILLER',
    'SARRALBE',
    'WILLERWALD',
  ],
  57470: ['GUENVILLER', 'HOMBOURG HAUT'],
  57880: ['GUERTING', 'HAM SOUS VARSBERG', 'VARSBERG'],
  57910: ['HAMBACH', 'NEUFGRANGE'],
  57870: ['HARREBERG', 'HARTZVILLER', 'HOMMERT', 'PLAINE DE WALSCH', 'TROISFONTAINES', 'WALSCHEID'],
  57700: ['HAYANGE', 'NEUFCHEF', 'RANGUEVAUX'],
  57990: ['HUNDLING', 'IPPLING', 'NOUSSEVILLER ST NABOR'],
  57240: ['KNUTANGE', 'NILVANGE'],
  57385: ['LAUDREFANG', 'TETING SUR NIED', 'TRITTELING REDLACH'],
  57740: ['LONGEVILLE LES ST AVOLD'],
  57935: ['LUTTANGE'],
  57100: ['MANOM', 'THIONVILLE'],
  57155: ['MARLY'],
  57140: ['LA MAXE', 'NORROY LE VENEUR', 'PLESNOIS', 'SAULNY', 'WOIPPY'],
  57960: ['MEISENTHAL', 'SOUCHT'],
  57000: ['METZ'],
  57940: ['METZERVISSE', 'VOLSTROFF'],
  57950: ['MONTIGNY LES METZ'],
  57860: ['MONTOIS LA MONTAGNE', 'RONCOURT'],
  57645: ['OGY MONTOY FLANVILLE', 'NOISSEVILLE', 'NOUILLY', 'RETONFEY'],
  57770: ['MOUSSEY'],
  57250: ['MOYEUVRE GRANDE', 'MOYEUVRE PETITE'],
  57840: ['OTTANGE', 'ROCHONVILLERS'],
  57540: ['PETITE ROSSELLE'],
  57120: ['PIERREVILLERS', 'ROMBAS'],
  57890: ['PORCELETTE', 'DIESEN'],
  57445: ['REDING'],
  57270: ['RICHEMONT', 'UCKANGE'],
  57780: ['ROSSELANGE'],
  57500: ['ST AVOLD'],
  57255: ['STE MARIE AUX CHENES'],
  57855: ['ST PRIVAT LA MONTAGNE'],
  57905: ['SARREINSMING', 'WITTRING', 'ZETTING'],
  57350: ['SCHOENECK', 'SPICHEREN', 'STIRING WENDEL'],
  57455: ['SEINGBOUSE'],
  57525: ['TALANGE'],
  57180: ['TERVILLE'],
  57915: ['WOUSTVILLER'],
  58110: [
    'ACHUN',
    'ALLUY',
    'AUNAY EN BAZOIS',
    'BAZOLLES',
    'BICHES',
    'BRINAY',
    'CHATILLON EN BAZOIS',
    'CHOUGNY',
    'DUN SUR GRANDRY',
    'MONTAPAS',
    'MONT ET MARRE',
    'OUGNY',
    'ROUY',
    'ST PEREUSE',
    'TAMNAY EN BAZOIS',
    'TINTURY',
  ],
  58200: ['ALLIGNY COSNE', 'COSNE COURS SUR LOIRE', 'POUGNY', 'ST LOUP DES BOIS', 'ST PERE'],
  58230: [
    'ALLIGNY EN MORVAN',
    'DUN LES PLACES',
    'GIEN SUR CURE',
    'GOULOUX',
    'LAVAULT DE FRETOY',
    'MONTSAUCHE LES SETTONS',
    'MOUX EN MORVAN',
    'OUROUX EN MORVAN',
    'PLANCHEZ',
    'ST AGNAN',
    'ST BRISSON',
  ],
  58190: [
    'AMAZY',
    'ASNOIS',
    'BAZOCHES',
    'DIROL',
    'FLEZ CUZY',
    'LYS',
    'LA MAISON DIEU',
    'METZ LE COMTE',
    'MOISSY MOULINOT',
    'MONCEAUX LE COMTE',
    'NEUFFONTAINES',
    'NUARS',
    'RUAGES',
    'ST AUBIN DES CHAUMES',
    'ST DIDIER',
    'SAIZY',
    'TALON',
    'TANNAY',
    'TEIGNY',
    'VIGNOL',
  ],
  58270: [
    'ANLEZY',
    'BEAUMONT SARDOLLES',
    'BILLY CHEVANNES',
    'CIZELY',
    'FERTREVE',
    'FRASNAY REUGNY',
    'LIMON',
    'ST BENIN D AZY',
    'ST FIRMIN',
    'ST JEAN AUX AMOGNES',
    'ST SULPICE',
    'VILLE LANGY',
  ],
  58450: ['ANNAY', 'NEUVY SUR LOIRE'],
  58800: [
    'ANTHIEN',
    'CERVON',
    'CHAUMOT',
    'CHITRY LES MINES',
    'LA COLLANCELLE',
    'CORBIGNY',
    'EPIRY',
    'GERMENAY',
    'HERY',
    'MAGNY LORMES',
    'MARIGNY SUR YONNE',
    'MONTREUILLON',
    'MOURON SUR YONNE',
    'PAZY',
    'SARDY LES EPIRY',
  ],
  58350: [
    'ARBOURSE',
    'CHASNAY',
    'CHATEAUNEUF VAL DE BARGIS',
    'COLMERY',
    'DOMPIERRE SUR NIEVRE',
    'NANNAY',
    'ST MALO EN DONZIOIS',
  ],
  58430: ['ARLEUF', 'FACHIN'],
  58500: [
    'ARMES',
    'BILLY SUR OISY',
    'CHEVROCHES',
    'CLAMECY',
    'OISY',
    'OUAGNE',
    'POUSSEAUX',
    'RIX',
    'SURGY',
    'VILLIERS SUR YONNE',
  ],
  58310: ['ARQUIAN', 'BITRY', 'BOUHY', 'DAMPIERRE SOUS BOUHY', 'ST AMAND EN PUISAYE', 'ST VERAIN'],
  58700: [
    'ARTHEL',
    'ARZEMBOUY',
    'AUTHIOU',
    'BEAUMONT LA FERRIERE',
    'LA CELLE SUR NIEVRE',
    'CHAMPLIN',
    'CHAZEUIL',
    'GIRY',
    'LURCY LE BOURG',
    'MONTENOISON',
    'MOUSSY',
    'MURLIN',
    'NOLAY',
    'OULON',
    'PREMERY',
    'ST BONNOT',
    'SICHAMPS',
  ],
  58420: [
    'ASNAN',
    'BEAULIEU',
    'BRINON SUR BEUVRON',
    'BUSSY LA PESLE',
    'CHALLEMENT',
    'CHAMPALLEMENT',
    'CHEVANNES CHANGY',
    'GRENOIS',
    'GUIPY',
    'MORACHES',
    'NEUILLY',
    'ST REVERIEN',
    'TACONNAY',
    'VITRY LACHE',
  ],
  58170: ['AVREE', 'CHIDDES', 'FLETY', 'LUZY', 'MILLAY', 'POIL', 'SAVIGNY POIL FOL', 'TAZILLY'],
  58300: [
    'AVRIL SUR LOIRE',
    'CHAMPVERT',
    'CHARRIN',
    'COSSAYE',
    'DECIZE',
    'DEVAY',
    'LAMENAY SUR LOIRE',
    'NEUVILLE LES DECIZE',
    'ST GERMAIN CHASSENAY',
    'ST HILAIRE FONTAINE',
    'ST LEGER DES VIGNES',
    'ST PARIZE EN VIRY',
    'SOUGY SUR LOIRE',
    'TOURY LURCY',
    'VERNEUIL',
  ],
  58240: [
    'AZY LE VIF',
    'CHANTENAY ST IMBERT',
    'FLEURY SUR LOIRE',
    'LANGERON',
    'LIVRY',
    'LUTHENAY UXELOUP',
    'MARS SUR ALLIER',
    'ST PIERRE LE MOUTIER',
    'TOURY SUR JOUR',
    'TRESNAY',
  ],
  58160: [
    'BEARD',
    'CHEVENON',
    'DRUY PARIGNY',
    'LA FERMETE',
    'IMPHY',
    'ST OUEN SUR LOIRE',
    'SAUVIGNY LES BOIS',
  ],
  58210: [
    'BEUVRON',
    'CHAMPLEMY',
    'LA CHAPELLE ST ANDRE',
    'CORVOL D EMBERNARD',
    'COURCELLES',
    'CUNCY LES VARZY',
    'MARCY',
    'MENOU',
    'OUDAN',
    'PARIGNY LA ROSE',
    'ST GERMAIN DES BOIS',
    'ST PIERRE DU MONT',
    'VARZY',
    'VILLIERS LE SEC',
  ],
  58120: [
    'BLISMES',
    'CHATEAU CHINON VILLE',
    'CHATEAU CHINON CAMPAGNE',
    'CHATIN',
    'CHAUMARD',
    'CORANCY',
    'DOMMARTIN',
    'MONTIGNY EN MORVAN',
    'ST HILAIRE EN MORVAN',
    'ST LEGER DE FOUGERET',
  ],
  58330: [
    'BONA',
    'CRUX LA VILLE',
    'JAILLY',
    'ST BENIN DES BOIS',
    'ST FRANCHY',
    'STE MARIE',
    'ST MAURICE',
    'ST SAULGE',
    'SAXI BOURDON',
  ],
  58140: [
    'BRASSY',
    'CHALAUX',
    'EMPURY',
    'GACOGNE',
    'LORMES',
    'MARIGNY L EGLISE',
    'MHERE',
    'POUQUES LORMES',
    'ST ANDRE EN MORVAN',
    'ST MARTIN DU PUY',
    'VAUCLAIX',
  ],
  58460: ['BREUGNON', 'CORVOL L ORGUEILLEUX', 'TRUCY L ORGUEILLEUX'],
  58530: ['BREVES', 'DORNECY'],
  58400: [
    'BULCY',
    'CHAMPVOUX',
    'LA CHARITE SUR LOIRE',
    'CHAULGNES',
    'LA MARCHE',
    'MESVES SUR LOIRE',
    'NARCY',
    'RAVEAU',
    'TRONSANGES',
    'VARENNES LES NARCY',
  ],
  58440: ['LA CELLE SUR LOIRE', 'MYENNES'],
  58340: ['CERCY LA TOUR', 'DIENNES AUBIGNY', 'MONTIGNY SUR CANNE', 'ST GRATIEN SAVIGNY'],
  58220: ['CESSY LES BOIS', 'CIEZ', 'COULOUTRE', 'DONZY', 'PERROY', 'STE COLOMBE DES BOIS'],
  58000: ['CHALLUY', 'NEVERS', 'ST ELOI', 'SERMOISE SUR LOIRE'],
  58660: ['COULANGES LES NEVERS'],
  58390: ['DORNES'],
  58410: ['ENTRAINS SUR NOHAIN', 'MENESTREAU'],
  58600: ['FOURCHAMBAULT', 'GARCHIZY'],
  58250: [
    'FOURS',
    'LANTY',
    'MONTAMBERT',
    'MONTARON',
    'LA NOCLE MAULAIX',
    'REMILLY',
    'ST SEINE',
    'TERNANT',
    'THAIX',
  ],
  58150: [
    'GARCHY',
    'POUILLY SUR LOIRE',
    'ST ANDELAIN',
    'ST LAURENT L ABBAYE',
    'ST MARTIN SUR NOHAIN',
    'ST QUENTIN SUR NOHAIN',
    'SUILLY LA TOUR',
    'TRACY SUR LOIRE',
    'VIELMANAY',
  ],
  58320: ['GERMIGNY SUR LOIRE', 'PARIGNY LES VAUX', 'POUGUES LES EAUX'],
  58470: ['GIMOUILLE', 'MAGNY COURS', 'SAINCAIZE MEAUCE'],
  58370: ['GLUX EN GLENNE', 'LAROCHEMILLAY', 'ONLAY', 'VILLAPOURCON'],
  58130: [
    'GUERIGNY',
    'MONTIGNY AUX AMOGNES',
    'VAUX D AMOGNES',
    'POISEUX',
    'ST AUBIN LES FORGES',
    'ST MARTIN D HEUILLE',
    'URZY',
  ],
  58290: ['ISENAY', 'LIMANTON', 'MAUX', 'MOULINS ENGILBERT', 'SERMAGES', 'VANDENESSE'],
  58380: ['LUCENAY LES AIX'],
  58260: ['LA MACHINE', 'THIANGES', 'TROIS VEVRES'],
  58180: ['MARZY'],
  58360: ['PREPORCHE', 'ST HONORE LES BAINS', 'SEMELAY'],
  58490: ['ST PARIZE LE CHATEL'],
  58640: ['VARENNES VAUZELLES'],
  59268: ['ABANCOURT', 'BLECOURT', 'CUVILLERS', 'FRESSIES', 'HAYNECOURT', 'SANCOURT'],
  59215: ['ABSCON'],
  59149: ['AIBES', 'BOUSIGNIES SUR ROC', 'COUSOLRE'],
  59310: [
    'AIX EN PEVELE',
    'AUCHY LEZ ORCHIES',
    'BEUVRY LA FORET',
    'COUTICHES',
    'FAUMONT',
    'LANDAS',
    'MOUCHIN',
    'NOMAIN',
    'ORCHIES',
    'SAMEON',
  ],
  59251: ['ALLENNES LES MARAIS'],
  59144: [
    'AMFROIPRET',
    'BRY',
    'ETH',
    'GOMMEGNIES',
    'JENLAIN',
    'PREUX AU SART',
    'WARGNIES LE GRAND',
    'WARGNIES LE PETIT',
  ],
  59194: ['ANHIERS', 'RACHES'],
  59580: ['ANICHE', 'EMERCHICOURT'],
  59491: ['VILLENEUVE D ASCQ'],
  59493: ['VILLENEUVE D ASCQ'],
  59650: ['VILLENEUVE D ASCQ'],
  59400: [
    'ANNEUX',
    'AWOINGT',
    'BOURSIES',
    'CAMBRAI',
    'CAUROIR',
    'DOIGNIES',
    'ESTOURMEL',
    'FONTAINE NOTRE DAME',
    'MOEUVRES',
    'NIERGNIES',
    'SERANVILLERS FORENVILLE',
    'WAMBAIX',
  ],
  59112: ['ANNOEULLIN', 'CARNIN'],
  59186: ['ANOR'],
  59152: ['ANSTAING', 'CHERENG', 'GRUSON', 'TRESSIN'],
  59410: ['ANZIN'],
  59151: ['ARLEUX', 'BRUNEMONT', 'BUGNICOURT', 'ESTREES', 'HAMEL'],
  59380: [
    'ARMBOUTS CAPPEL',
    'BERGUES',
    'BIERNE',
    'BISSEZEELE',
    'CROCHTE',
    'QUAEDYPRE',
    'SOCX',
    'SPYCKER',
    'STEENE',
    'TETEGHEM COUDEKERQUE VILLAGE',
    'WARHEM',
    'WEST CAPPEL',
    'WYLDER',
  ],
  59280: ['ARMENTIERES', 'BOIS GRENIER'],
  59285: ['ARNEKE', 'BUYSSCHEURE', 'RUBROUCK'],
  59269: ['ARTRES', 'QUERENAING', 'SEPMERIES'],
  59600: [
    'ASSEVENT',
    'BERSILLIES',
    'BETTIGNIES',
    'ELESMES',
    'GOGNIES CHAUSSEE',
    'MAIRIEUX',
    'MAUBEUGE',
    'VIEUX RENG',
    'VILLERS SIRE NICOLE',
  ],
  59551: ['ATTICHES', 'TOURMIGNIES'],
  59265: ['AUBENCHEUL AU BAC', 'AUBIGNY AU BAC'],
  59165: ['AUBERCHICOURT'],
  59249: ['AUBERS', 'FROMELLES'],
  59494: ['AUBRY DU HAINAUT', 'PETITE FORET'],
  59950: ['AUBY'],
  59570: [
    'AUDIGNIES',
    'BAVAY',
    'BELLIGNIES',
    'BERMERIES',
    'BETTRECHIES',
    'LA FLAMENGRIE',
    'GUSSIGNIES',
    'HON HERGIES',
    'HOUDAIN LEZ BAVAY',
    'LA LONGUEVILLE',
    'MECQUIGNIES',
    'OBIES',
    'ST WAAST',
    'TAISNIERES SUR HON',
  ],
  59300: ['AULNOY LEZ VALENCIENNES', 'FAMARS', 'VALENCIENNES'],
  59620: ['AULNOYE AYMERIES', 'ECUELIN', 'LEVAL', 'MONCEAU ST WAAST', 'ST REMY CHAUSSEE'],
  59710: ['AVELIN', 'ENNEVELIN', 'MERIGNIES', 'PONT A MARCQ'],
  59440: [
    'AVESNELLES',
    'AVESNES SUR HELPE',
    'BAS LIEU',
    'BOULOGNE SUR HELPE',
    'DOMPIERRE SUR HELPE',
    'DOURLERS',
    'FLAUMONT WAUDRECHIES',
    'FLOURSIES',
    'HAUT LIEU',
    'MARBAIX',
    'ST AUBIN',
    'ST HILAIRE SUR HELPE',
    'SEMERIES',
    'SEMOUSIES',
  ],
  59129: ['AVESNES LES AUBERT'],
  59296: ['AVESNES LE SEC'],
  59138: ['BACHANT', 'HARGNIES', 'PONT SUR SAMBRE', 'VIEUX MESNIL'],
  59830: ['BACHY', 'BOURGHELLES', 'BOUVINES', 'COBRIEUX', 'CYSOING', 'LOUVIL', 'WANNEHAIN'],
  59270: [
    'BAILLEUL',
    'BERTHEN',
    'FLETRE',
    'GODEWAERSVELDE',
    'MERRIS',
    'METEREN',
    'ST JANS CAPPEL',
    'STRAZEELE',
  ],
  59780: ['BAISIEUX', 'CAMPHIN EN PEVELE', 'WILLEMS'],
  59132: [
    'BAIVES',
    'EPPE SAUVAGE',
    'GLAGEON',
    'MOUSTIER EN FAGNE',
    'OHAIN',
    'TRELON',
    'WALLERS EN FAGNE',
  ],
  59470: [
    'BAMBECQUE',
    'BOLLEZEELE',
    'BROXEELE',
    'ERINGHEM',
    'ESQUELBECQ',
    'HERZEELE',
    'HOUTKERQUE',
    'LEDRINGHEM',
    'MERCKEGHEM',
    'VOLCKERINCKHOVE',
    'WORMHOUT',
    'ZEGERSCAPPEL',
  ],
  59266: ['BANTEUX', 'BANTOUZELLE', 'HONNECOURT SUR ESCAUT'],
  59554: [
    'BANTIGNY',
    'NEUVILLE ST REMY',
    'RAILLENCOURT STE OLLE',
    'SAILLY LEZ CAMBRAI',
    'TILLOY LEZ CAMBRAI',
  ],
  59480: ['LA BASSEE', 'ILLIES'],
  59221: ['BAUVIN'],
  59670: [
    'BAVINCHOVE',
    'CASSEL',
    'HARDIFORT',
    'NOORDPEENE',
    'OCHTEZEELE',
    'OUDEZEELE',
    'OXELAERE',
    'STE MARIE CAPPEL',
    'WEMAERS CAPPEL',
    'WINNEZEELE',
    'ZERMEZEELE',
    'ZUYTPEENE',
  ],
  59360: [
    'BAZUEL',
    'LE CATEAU CAMBRESIS',
    'CATILLON SUR SAMBRE',
    'LA GROISE',
    'MAZINGHIEN',
    'MONTAY',
    'NEUVILLY',
    'ORS',
    'POMMEREUIL',
    'REJET DE BEAULIEU',
    'ST BENIN',
    'ST SOUPLET',
  ],
  59134: ['BEAUCAMPS LIGNY', 'FOURNES EN WEPPES', 'HERLIES', 'LE MAISNIL', 'WICRES'],
  59530: [
    'BEAUDIGNIES',
    'ENGLEFONTAINE',
    'FRASNOY',
    'GHISSIGNIES',
    'HECQ',
    'JOLIMETZ',
    'LOCQUIGNOL',
    'LOUVIGNIES QUESNOY',
    'ORSINVAL',
    'POTELLE',
    'LE QUESNOY',
    'RAUCOURT AU BOIS',
    'RUESNES',
    'VILLEREAU',
    'VILLERS POL',
  ],
  59330: [
    'BEAUFORT',
    'BOUSSIERES SUR SAMBRE',
    'ECLAIBES',
    'HAUTMONT',
    'LIMONT FONTAINE',
    'NEUF MESNIL',
    'ST REMY DU NORD',
  ],
  59540: ['BEAUMONT EN CAMBRESIS', 'BETHENCOURT', 'CAUDRY', 'INCHY'],
  59730: ['BEAURAIN', 'BRIASTRE', 'ROMERIES', 'ST PYTHON', 'SOLESMES', 'VERTAIN'],
  59550: [
    'BEAUREPAIRE SUR SAMBRE',
    'LE FAVRIL',
    'FONTAINE AU BOIS',
    'LANDRECIES',
    'MAROILLES',
    'NOYELLES SUR SAMBRE',
    'PRISCHES',
    'ROBERSART',
    'TAISNIERES EN THIERACHE',
  ],
  59740: [
    'BEAURIEUX',
    'BERELLES',
    'CHOISIES',
    'CLAIRFAYTS',
    'DIMECHAUX',
    'ECCLES',
    'FELLERIES',
    'HESTRUD',
    'LEZ FONTAINE',
    'LIESSIES',
    'SOLRE LE CHATEAU',
    'SOLRINNES',
    'WILLIES',
  ],
  59157: ['BEAUVOIS EN CAMBRESIS', 'FONTAINE AU PIRE'],
  59135: ['BELLAING', 'WALLERS'],
  59145: ['BERLAIMONT', 'SASSEGNIES'],
  59213: [
    'BERMERAIN',
    'CAPELLE',
    'ESCARMAIN',
    'ST MARTIN SUR ECAILLON',
    'SOMMAING',
    'VENDEGIES SUR ECAILLON',
  ],
  59235: ['BERSEE'],
  59980: ['BERTRY', 'HONNECHY', 'MAUROIS', 'REUMONT', 'TROISVILLES'],
  59216: ['BEUGNIES', 'DIMONT', 'SARS POTERIES'],
  59192: ['BEUVRAGES'],
  59217: ['BEVILLERS', 'BOUSSIERES EN CAMBRESIS', 'CARNIERES', 'CATTENIERES'],
  59173: ['BLARINGHEM', 'EBBLINGHEM', 'LYNDE', 'RENESCURE', 'SERCUS'],
  59299: ['BOESCHEPE'],
  59189: ['BOESEGHEM', 'STEENBECQUE', 'THIENNES'],
  59910: ['BONDUES'],
  59190: [
    'BORRE',
    'CAESTRE',
    'HAZEBROUCK',
    'HONDEGHEM',
    'MORBECQUE',
    'PRADELLES',
    'STAPLE',
    'WALLON CAPPEL',
  ],
  59111: ['BOUCHAIN', 'HORDAIN', 'LIEU ST AMAND', 'WAVRECHAIN SOUS FAULX'],
  59630: [
    'BOURBOURG',
    'BROUCKERQUE',
    'CAPPELLE BROUCK',
    'DRINCHAM',
    'LOOBERGHE',
    'ST PIERRE BROUCK',
  ],
  59166: ['BOUSBECQUE'],
  59222: ['BOUSIES', 'CROIX CALUYAU', 'FOREST EN CAMBRESIS'],
  59178: ['BOUSIGNIES', 'BRILLON', 'HASNON', 'MILLONFOSSE'],
  59168: ['BOUSSOIS'],
  59870: [
    'BOUVIGNIES',
    'MARCHIENNES',
    'RIEULAY',
    'TILLOY LEZ MARCHIENNES',
    'VRED',
    'WANDIGNIES HAMAGE',
    'WARLAING',
  ],
  59123: ['BRAY DUNES', 'ZUYDCOOTE'],
  59860: ['BRUAY SUR L ESCAUT'],
  59490: ['BRUILLE LEZ MARCHIENNES', 'SOMAIN'],
  59199: ['BRUILLE ST AMAND', 'HERGNIES'],
  59137: ['BUSIGNY'],
  59161: ['CAGNONCLES', 'ESCAUDOEUVRES', 'ESWARS', 'NAVES', 'RAMILLIES'],
  59133: ['CAMPHIN EN CAREMBAULT', 'PHALEMPIN'],
  59267: ['CANTAING SUR ESCAUT', 'FLESQUIERES', 'PROVILLE'],
  59169: ['CANTIN', 'ERCHIN', 'FERIN', 'GOEULZIN', 'ROUCOURT'],
  59160: ['CAPINGHEM', 'LILLE'],
  59242: ['CAPPELLE EN PEVELE', 'GENECH', 'TEMPLEUVE EN PEVELE'],
  59180: ['CAPPELLE LA GRANDE'],
  59244: ['CARTIGNIES', 'GRAND FAYT', 'PETIT FAYT'],
  59191: ['CAULLERY', 'HAUCOURT EN CAMBRESIS', 'LIGNY EN CAMBRESIS'],
  59680: [
    'CERFONTAINE',
    'COLLERET',
    'DAMOUSIES',
    'FERRIERE LA GRANDE',
    'FERRIERE LA PETITE',
    'OBRECHIES',
    'QUIEVELON',
    'WATTIGNIES LA VICTOIRE',
  ],
  59930: ['LA CHAPELLE D ARMENTIERES'],
  59230: ['CHATEAU L ABBAYE', 'NIVELLE', 'ROSULT', 'ST AMAND LES EAUX', 'SARS ET ROSIERES'],
  59147: ['CHEMY', 'GONDECOURT', 'HERRIN'],
  59225: ['CLARY', 'MONTIGNY EN CAMBRESIS'],
  59560: ['COMINES', 'WARNETON'],
  59163: ['CONDE SUR L ESCAUT', 'ST AYBERT', 'THIVENCELLE'],
  59210: ['COUDEKERQUE BRANCHE'],
  59552: ['COURCHELETTES', 'LAMBRES LEZ DOUAI'],
  59279: ['CRAYWICK', 'DUNKERQUE', 'LOON PLAGE'],
  59154: ['CRESPIN'],
  59258: ['CREVECOEUR SUR L ESCAUT', 'LESDAIN', 'LES RUES DES VIGNES'],
  59170: ['CROIX'],
  59553: ['CUINCY', 'ESQUERCHIN', 'LAUWIN PLANQUE'],
  59990: [
    'CURGIES',
    'ESTREUX',
    'MARESCHES',
    'PRESEAU',
    'ROMBIES ET MARCHIPONT',
    'SAULTAIN',
    'SEBOURG',
  ],
  59187: ['DECHY'],
  59127: ['DEHERIES', 'ELINCOURT', 'ESNES', 'MALINCOURT', 'WALINCOURT SELVIGNY'],
  59220: ['DENAIN', 'ROUVIGNIES', 'WAVRECHAIN SOUS DENAIN'],
  59890: ['DEULEMONT', 'QUESNOY SUR DEULE'],
  59500: ['DOUAI'],
  59282: ['DOUCHY LES MINES', 'NOYELLES SUR SELLE'],
  59940: ['LE DOULIEU', 'ESTAIRES', 'NEUF BERQUIN'],
  59140: ['DUNKERQUE'],
  59240: ['DUNKERQUE'],
  59430: ['DUNKERQUE'],
  59640: ['DUNKERQUE'],
  59176: ['ECAILLON', 'MASNY'],
  59114: ['EECKE', 'ST SYLVESTRE CAPPEL', 'STEENVOORDE', 'TERDEGHEM'],
  59320: [
    'EMMERIN',
    'ENGLOS',
    'ENNETIERES EN WEPPES',
    'ERQUINGHEM LE SEC',
    'ESCOBECQUES',
    'HALLENNES LEZ HAUBOURDIN',
    'HAUBOURDIN',
    'RADINGHEM EN WEPPES',
    'SEQUEDIN',
  ],
  59193: ['ERQUINGHEM LYS'],
  59171: ['ERRE', 'HELESMES', 'HORNAING'],
  59124: ['ESCAUDAIN'],
  59278: ['ESCAUTPONT'],
  59219: ['ETROEUNGT', 'FLOYON', 'LAROUILLIES'],
  59295: ['ESTRUN', 'PAILLENCOURT'],
  59155: ['FACHES THUMESNIL'],
  59247: ['FECHAIN', 'HEM LENGLET'],
  59750: ['FEIGNIES'],
  59179: ['FENAIN'],
  59610: ['FERON', 'FOURMIES'],
  59128: ['FLERS EN ESCREBIEUX'],
  59158: ['FLINES LES MORTAGNE', 'MAULDE', 'MORTAGNE DU NORD', 'THUN ST AMAND'],
  59148: ['FLINES LEZ RACHES'],
  59510: ['FOREST SUR MARQUE', 'HEM'],
  59236: ['FRELINGHIEN'],
  59970: ['FRESNES SUR ESCAUT', 'ODOMEZ', 'VICQ'],
  59234: ['FRESSAIN', 'MONCHECOURT', 'VILLERS AU TERTRE'],
  59273: ['FRETIN', 'PERONNE EN MELANTOIS'],
  59122: ['GHYVELDE', 'HONDSCHOOTE', 'KILLEM', 'OOST CAPPEL', 'REXPOEDE'],
  59254: ['GHYVELDE'],
  59231: ['GONNELIEU', 'GOUZEAUCOURT', 'VILLERS PLOUICH'],
  59253: ['LA GORGUE'],
  59760: ['GRANDE SYNTHE'],
  59153: ['GRAND FORT PHILIPPE'],
  59820: ['GRAVELINES', 'ST GEORGES SUR L AA'],
  59287: ['GUESNAIN', 'LEWARDE'],
  59250: ['HALLUIN'],
  59496: ['HANTAY', 'SALOME'],
  59198: ['HASPRES'],
  59121: ['HAULCHIN', 'PROUVY'],
  59294: ['HAUSSY'],
  59255: ['HAVELUY'],
  59660: ['HAVERSKERQUE', 'MERVILLE'],
  59195: ['HERIN', 'OISY'],
  59143: ['HOLQUE', 'LEDERZEELE', 'MILLAM', 'NIEURLET', 'ST MOMELIN', 'WATTEN', 'WULVERDINGHE'],
  59263: ['HOUPLIN ANCOISNE'],
  59116: ['HOUPLINES'],
  59492: ['HOYMILLE'],
  59141: ['IWUY', 'THUN L EVEQUE', 'THUN ST MARTIN'],
  59460: ['JEUMONT'],
  59167: ['LALLAING'],
  59130: ['LAMBERSART'],
  59390: ['LANNOY', 'LYS LEZ LANNOY', 'SAILLY LEZ LANNOY', 'TOUFFLERS'],
  59226: ['LECELLES', 'RUMEGIES'],
  59259: ['LECLUSE'],
  59115: ['LEERS'],
  59495: ['LEFFRINCKOUCKE'],
  59810: ['LESQUIN'],
  59260: ['LEZENNES', 'LILLE'],
  59000: ['LILLE'],
  59777: ['LILLE'],
  59800: ['LILLE'],
  59126: ['LINSELLES'],
  59182: ['LOFFRE', 'MONTIGNY EN OSTREVENT'],
  59840: ['LOMPRET', 'PERENCHIES', 'PREMESQUES'],
  59120: ['LOOS'],
  59156: ['LOURCHES'],
  59720: ['LOUVROIL'],
  59110: ['LA MADELEINE'],
  59233: ['MAING'],
  59159: ['MARCOING', 'NOYELLES SUR ESCAUT', 'RIBECOURT LA TOUR'],
  59700: ['MARCQ EN BAROEUL'],
  59252: ['MARCQ EN OSTREVENT', 'MARQUETTE EN OSTREVANT', 'WASNES AU BAC'],
  59238: ['MARETZ'],
  59770: ['MARLY'],
  59164: ['MARPENT'],
  59520: ['MARQUETTE LEZ LILLE'],
  59274: ['MARQUILLIES'],
  59241: ['MASNIERES'],
  59172: ['MASTAING', 'ROEULX'],
  59224: ['MONCHAUX SUR ECAILLON', 'THIANT'],
  59283: ['MONCHEAUX', 'RAIMBEAUCOURT'],
  59370: ['MONS EN BAROEUL'],
  59246: ['MONS EN PEVELE'],
  59227: ['MONTRECOURT', 'SAULZOIR', 'VERCHAIN MAUGRE'],
  59420: ['MOUVAUX'],
  59218: ['NEUVILLE EN AVESNOIS', 'POIX DU NORD', 'SALESCHES', 'VENDEGIES AU BOIS'],
  59960: ['NEUVILLE EN FERRAIN'],
  59239: ['LA NEUVILLE', 'THUMERIES'],
  59293: ['NEUVILLE SUR ESCAUT'],
  59850: ['NIEPPE'],
  59139: ['NOYELLES LES SECLIN', 'WATTIGNIES'],
  59264: ['ONNAING'],
  59162: ['OSTRICOURT'],
  59146: ['PECQUENCOURT'],
  59284: ['PITGAM'],
  59288: ['PREUX AU BOIS'],
  59185: ['PROVIN'],
  59243: ['QUAROUBLE'],
  59920: ['QUIEVRECHAIN'],
  59214: ['QUIEVY'],
  59177: ['RAINSARS', 'RAMOUSIES', 'SAINS DU NORD'],
  59590: ['RAISMES'],
  59245: ['RECQUIGNIES'],
  59277: ['RIEUX EN CAMBRESIS'],
  59790: ['RONCHIN'],
  59223: ['RONCQ'],
  59286: ['ROOST WARENDIN'],
  59100: ['ROUBAIX'],
  59131: ['ROUSIES'],
  59281: ['RUMILLY EN CAMBRESIS'],
  59262: ['SAINGHIN EN MELANTOIS'],
  59184: ['SAINGHIN EN WEPPES'],
  59350: ['ST ANDRE LEZ LILLE'],
  59188: ['ST AUBERT', 'ST VAAST EN CAMBRESIS', 'VILLERS EN CAUCHIES'],
  59292: ['ST HILAIRE LEZ CAMBRAI'],
  59880: ['ST SAULVE'],
  59211: ['SANTES'],
  59113: ['SECLIN'],
  59174: ['LA SENTINELLE'],
  59450: ['SIN LE NOBLE'],
  59181: ['STEENWERCK'],
  59175: ['TEMPLEMARS', 'VENDEVILLE'],
  59229: ['TETEGHEM COUDEKERQUE VILLAGE', 'UXEM'],
  59200: ['TOURCOING'],
  59125: ['TRITH ST LEGER'],
  59237: ['VERLINGHEM'],
  59271: ['VIESLY'],
  59232: ['VIEUX BERQUIN'],
  59690: ['VIEUX CONDE'],
  59297: ['VILLERS GUISLAIN'],
  59142: ['VILLERS OUTREAUX'],
  59261: ['WAHAGNIES'],
  59118: ['WAMBRECHIES'],
  59290: ['WASQUEHAL'],
  59150: ['WATTRELOS'],
  59136: ['WAVRIN'],
  59119: ['WAZIERS'],
  59117: ['WERVICQ SUD'],
  59212: ['WIGNEHIES'],
  59272: ['DON'],
  60220: [
    'ABANCOURT',
    'BLARGIES',
    'BOUVRESSE',
    'BROQUIERS',
    'CAMPEAUX',
    'CANNY SUR THERAIN',
    'ESCLES ST PIERRE',
    'FORMERIE',
    'FOUILLOY',
    'GOURCHELLES',
    'LANNOY CUILLERE',
    'MOLIENS',
    'MONCEAUX L ABBAYE',
    'MUREAUMONT',
    'OMECOURT',
    'QUINCAMPOIX FLEUZY',
    'ROMESCAMPS',
    'ST ARNOULT',
    'ST SAMSON LA POTERIE',
    'ST VALERY',
  ],
  60430: [
    'ABBECOURT',
    'LE COUDRAY SUR THELLE',
    'HODENC L EVEQUE',
    'NOAILLES',
    'PONCHON',
    'ST SULPICE',
    'SILLY TILLARD',
    'WARLUIS',
  ],
  60480: [
    'ABBEVILLE ST LUCIEN',
    'BUCAMPS',
    'CAMPREMY',
    'FONTAINE ST LUCIEN',
    'FRANCASTEL',
    'FROISSY',
    'GUIGNECOURT',
    'LACHAUSSEE DU BOIS D ECU',
    'MAISONCELLE TUILERIE',
    'MAULERS',
    'MONTREUIL SUR BRECHE',
    'MUIDORGE',
    'LA NEUVILLE ST PIERRE',
    'NOIREMONT',
    'NOYERS ST MARTIN',
    'OURSEL MAISON',
    'PUITS LA VALLEE',
    'LE QUESNEL AUBRY',
    'REUIL SUR BRECHE',
    'ST ANDRE FARIVILLERS',
    'STE EUSOYE',
    'THIEUX',
  ],
  60690: [
    'ACHY',
    'FONTAINE LAVAGANNE',
    'HAUTE EPINE',
    'MARSEILLE EN BEAUVAISIS',
    'LA NEUVILLE SUR OUDEUIL',
    'ROTHOIS',
    'ROY BOISSY',
  ],
  60620: [
    'ACY EN MULTIEN',
    'ANTILLY',
    'BARGNY',
    'BETZ',
    'BOUILLANCY',
    'BOULLARRE',
    'CUVERGNON',
    'ETAVIGNY',
    'ORMOY LE DAVIEN',
    'REEZ FOSSE MARTIN',
    'ROSOY EN MULTIEN',
    'ROUVRES EN MULTIEN',
    'VILLERS ST GENEST',
  ],
  60700: [
    'LES AGEUX',
    'BAZICOURT',
    'BEAUREPAIRE',
    'FLEURINES',
    'PONTPOINT',
    'PONT STE MAXENCE',
    'SACY LE GRAND',
    'ST MARTIN LONGUEAU',
  ],
  60600: [
    'AGNETZ',
    'AIRION',
    'BREUIL LE VERT',
    'CLERMONT',
    'ERQUERY',
    'ETOUY',
    'FITZ JAMES',
    'LAMECOURT',
    'MAIMBEVILLE',
    'REMECOURT',
    'ST AUBIN SOUS ERQUERY',
  ],
  60000: [
    'ALLONNE',
    'BEAUVAIS',
    'FOUQUENIES',
    'FROCOURT',
    'GOINCOURT',
    'ST MARTIN LE NOEUD',
    'TILLE',
    'AUX MARAIS',
  ],
  60110: ['AMBLAINVILLE', 'CORBEIL CERF', 'ESCHES', 'LORMAISON', 'MERU'],
  60310: [
    'AMY',
    'AVRICOURT',
    'BEAULIEU LES FONTAINES',
    'CANDOR',
    'CANNECTANCOURT',
    'CANNY SUR MATZ',
    'CRAPEAUMESNIL',
    'CUY',
    'DIVES',
    'ECUVILLY',
    'EVRICOURT',
    'FRESNIERES',
    'GURY',
    'LABERLIERE',
    'LAGNY',
    'LASSIGNY',
    'MARGNY AUX CERISES',
    'OGNOLLES',
    'PLESSIS DE ROYE',
    'ROYE SUR MATZ',
    'SOLENTE',
    'THIESCOURT',
  ],
  60570: ['ANDEVILLE', 'LABOISSIERE EN THELLE', 'MORTEFONTAINE EN THELLE'],
  60940: ['ANGICOURT', 'CINQUEUX', 'MONCEAUX'],
  60130: [
    'ANGIVILLERS',
    'AVRECHY',
    'BRUNVILLERS LA MOTTE',
    'BULLES',
    'CATILLON FUMECHON',
    'CUIGNIERES',
    'ERQUINVILLERS',
    'FOURNIVAL',
    'LIEUVILLERS',
    'LE MESNIL SUR BULLES',
    'NOROY',
    'NOURARD LE FRANC',
    'PLAINVAL',
    'LE PLESSIER SUR BULLES',
    'LE PLESSIER SUR ST JUST',
    'QUINQUEMPOIX',
    'RAVENEL',
    'ST JUST EN CHAUSSEE',
    'ST REMY EN L EAU',
    'VALESCOURT',
    'WAVIGNIES',
  ],
  60250: [
    'ANGY',
    'ANSACQ',
    'BALAGNY SUR THERAIN',
    'BURY',
    'FOULANGUES',
    'HEILLES',
    'HONDAINVILLE',
    'MOUCHY LE CHATEL',
    'MOUY',
    'THURY SOUS CLERMONT',
  ],
  60120: [
    'ANSAUVILLERS',
    'BACOUEL',
    'BEAUVOIR',
    'BLANCFOSSE',
    'BONNEUIL LES EAUX',
    'BONVILLERS',
    'BRETEUIL',
    'BROYES',
    'CHEPOIX',
    'CORMEILLES',
    'LE CROCQ',
    'CROISSY SUR CELLE',
    'ESQUENNOY',
    'FLECHY',
    'GANNES',
    'GOUY LES GROSEILLERS',
    'HARDIVILLERS',
    'LA HERELLE',
    'LAVACQUERIE',
    'LE MESNIL ST FIRMIN',
    'MORY MONTCRUX',
    'PAILLART',
    'PLAINVILLE',
    'ROCQUENCOURT',
    'ROUVROY LES MERLES',
    'SEREVILLERS',
    'TARTIGNY',
    'TROUSSENCOURT',
    'VENDEUIL CAPLY',
    'VILLERS VICOMTE',
  ],
  60162: ['ANTHEUIL PORTES', 'VIGNEMONT'],
  60400: [
    'APPILLY',
    'BABOEUF',
    'BEAURAINS LES NOYON',
    'BEHERICOURT',
    'BRETIGNY',
    'BUSSY',
    'CAISNES',
    'CRISOLLES',
    'CUTS',
    'GENVRY',
    'GRANDRU',
    'LARBROYE',
    'MONDESCOURT',
    'MORLINCOURT',
    'NAMPCEL',
    'NOYON',
    'PASSEL',
    'PONT L EVEQUE',
    'PONTOISE LES NOYON',
    'PORQUERICOURT',
    'SALENCY',
    'SEMPIGNY',
    'SERMAIZE',
    'SUZOY',
    'VARESNES',
    'VAUCHELLES',
    'VILLE',
  ],
  60300: [
    'APREMONT',
    'AUMONT EN HALATTE',
    'AVILLY ST LEONARD',
    'BARON',
    'BOREST',
    'CHAMANT',
    'COURTEUIL',
    'FONTAINE CHAALIS',
    'MONT L EVEQUE',
    'MONTLOGNON',
    'SENLIS',
  ],
  60880: ['ARMANCOURT', 'JAUX', 'LE MEUX'],
  60190: [
    'ARSY',
    'AVRIGNY',
    'BAILLEUL LE SOC',
    'BAUGY',
    'BLINCOURT',
    'CERNOY',
    'CHOISY LA VICTOIRE',
    'CRESSONSACQ',
    'EPINEUSE',
    'ESTREES ST DENIS',
    'FOUILLEUSE',
    'FRANCIERES',
    'GOURNAY SUR ARONDE',
    'GRANDVILLERS AUX BOIS',
    'HEMEVILLERS',
    'LACHELLE',
    'MONTIERS',
    'MONTMARTIN',
    'MOYENNEVILLE',
    'MOYVILLERS',
    'NEUFVY SUR ARONDE',
    'LA NEUVILLE ROY',
    'PRONLEROY',
    'REMY',
    'ROUVILLERS',
    'SACY LE PETIT',
  ],
  60350: [
    'ATTICHY',
    'AUTRECHES',
    'BERNEUIL SUR AISNE',
    'BITRY',
    'CHELLES',
    'COULOISY',
    'COURTIEUX',
    'CROUTOY',
    'CUISE LA MOTTE',
    'HAUTEFONTAINE',
    'JAULZY',
    'MOULIN SOUS TOUVENT',
    'PIERREFONDS',
    'ST ETIENNE ROILAYE',
    'ST JEAN AUX BOIS',
    'ST PIERRE LES BITRY',
    'TROSLY BREUIL',
    'VIEUX MOULIN',
  ],
  60360: [
    'AUCHY LA MONTAGNE',
    'CATHEUX',
    'CHOQUEUSE LES BENARDS',
    'CONTEVILLE',
    'CREVECOEUR LE GRAND',
    'DOMELIERS',
    'FONTAINE BONNELEAU',
    'LE GALLET',
    'HETOMESNIL',
    'LIHUS',
    'LUCHY',
    'PREVILLERS',
    'ROTANGY',
    'LE SAULCHOY',
    'VIEFVILLERS',
  ],
  60800: [
    'AUGER ST VINCENT',
    'CREPY EN VALOIS',
    'DUVY',
    'FEIGNEUX',
    'FRESNOY LE LUAT',
    'LEVIGNEN',
    'ORMOY VILLERS',
    'ROCQUEMONT',
    'ROUVILLE',
    'SERY MAGNEVAL',
    'TRUMILLY',
  ],
  60390: [
    'AUNEUIL',
    'AUTEUIL',
    'BEAUMONT LES NONAINS',
    'BERNEUIL EN BRAY',
    'LA HOUSSOYE',
    'PORCHEUX',
    'LE VAUROUX',
    'LES HAUTS TALICAN',
  ],
  60890: [
    'AUTHEUIL EN VALOIS',
    'MAREUIL SUR OURCQ',
    'MAROLLES',
    'NEUFCHELLES',
    'THURY EN VALOIS',
    'VARINFROY',
    'LA VILLENEUVE SOUS THURY',
  ],
  60930: ['BAILLEUL SUR THERAIN'],
  60140: ['BAILLEVAL', 'LABRUYERE', 'LIANCOURT', 'MOGNEVILLE', 'ROSOY', 'VERDERONNE'],
  60170: [
    'BAILLY',
    'CAMBRONNE LES RIBECOURT',
    'CARLEPONT',
    'PIMPREZ',
    'RIBECOURT DRESLINCOURT',
    'ST CREPIN AUX BOIS',
    'ST LEGER AUX BOIS',
    'TRACY LE MONT',
    'TRACY LE VAL',
  ],
  60810: ['BARBERY', 'BRASSEUSE', 'MONTEPILLOY', 'RARAY', 'RULLY', 'VILLERS ST FRAMBOURG OGNON'],
  60113: ['BAUGY', 'BRAISNES SUR ARONDE', 'MONCHY HUMIERES'],
  60380: [
    'BAZANCOURT',
    'BUICOURT',
    'ERNEMONT BOUTAVENT',
    'ESCAMES',
    'FONTENAY TORCY',
    'GERBEROY',
    'GREMEVILLERS',
    'HECOURT',
    'HERICOURT SUR THERAIN',
    'LACHAPELLE SOUS GERBEROY',
    'LOUEUSE',
    'MORVILLERS',
    'ST DENISCOURT',
    'ST QUENTIN DES PRES',
    'SONGEONS',
    'SULLY',
    'THERINES',
    'VILLERS VERMONT',
    'WAMBEZ',
  ],
  60210: [
    'BEAUDEDUIT',
    'BRIOT',
    'BROMBOS',
    'CEMPUIS',
    'DAMERAUCOURT',
    'DARGIES',
    'ELENCOURT',
    'GAUDECHART',
    'GRANDVILLIERS',
    'GREZ',
    'HALLOY',
    'LE HAMEL',
    'HAUTBOS',
    'LAVERRIERE',
    'LE MESNIL CONTEVILLE',
    'OFFOY',
    'ST MAUR',
    'ST THIBAULT',
    'SARCUS',
    'SARNOIS',
    'SOMMEREUX',
    'THIEULOY ST ANTOINE',
  ],
  60640: [
    'BEAUGIES SOUS BOIS',
    'BERLANCOURT',
    'CAMPAGNE',
    'CATIGNY',
    'FLAVY LE MELDEUX',
    'FRENICHES',
    'FRETOY LE CHATEAU',
    'GOLANCOURT',
    'GUISCARD',
    'LIBERMONT',
    'MAUCOURT',
    'MUIRANCOURT',
    'LE PLESSIS PATTE D OIE',
    'QUESMY',
    'VILLESELVE',
  ],
  60540: ['BELLE EGLISE', 'BORNEL', 'PUISEUX LE HAUBERGER'],
  60490: [
    'BELLOY',
    'BIERMONT',
    'BOULOGNE LA GRASSE',
    'CONCHY LES POTS',
    'CUVILLY',
    'HAINVILLERS',
    'LATAULE',
    'MAREST SUR MATZ',
    'MAREUIL LA MOTTE',
    'MARGNY SUR MATZ',
    'MARQUEGLISE',
    'MORTEMER',
    'LA NEUVILLE SUR RESSONS',
    'ORVILLERS SOREL',
    'RESSONS SUR MATZ',
    'RICQUEBOURG',
    'VANDELICOURT',
  ],
  60370: ['BERTHECOURT', 'HERMES', 'ST FELIX'],
  60129: ['BETHANCOURT EN VALOIS', 'GILOCOURT', 'GLAIGNES', 'ORROUY'],
  60320: ['BETHISY ST MARTIN', 'BETHISY ST PIERRE', 'NERY', 'ST SAUVEUR'],
  60280: ['BIENVILLE', 'CLAIROIX', 'MARGNY LES COMPIEGNE', 'VENETTE'],
  60650: [
    'BLACOURT',
    'ESPAUBOURG',
    'GLATIGNY',
    'HANNACHES',
    'HANVOILE',
    'HODENC EN BRAY',
    'LACHAPELLE AUX POTS',
    'LHERAULE',
    'LE MONT ST ADRIEN',
    'ONS EN BRAY',
    'ST AUBIN EN BRAY',
    'ST GERMAIN LA POTERIE',
    'ST PAUL',
    'SAVIGNIES',
    'SENANTES',
    'VILLEMBRAY',
    'VILLERS ST BARTHELEMY',
    'VILLERS SUR AUCHY',
  ],
  60460: ['BLAINCOURT LES PRECY', 'PRECY SUR OISE'],
  60860: ['BLICOURT', 'OUDEUIL', 'PISSELEU', 'ST OMER EN CHAUSSEE', 'VILLERS SUR BONNIERES'],
  60440: [
    'BOISSY FRESNOY',
    'BREGY',
    'CHEVREVILLE',
    'NANTEUIL LE HAUDOUIN',
    'OGNES',
    'PEROY LES GOMBRIES',
    'ROSIERES',
    'VERSIGNY',
  ],
  60510: [
    'BONLIER',
    'BRESLES',
    'ESSUILES',
    'LE FAY ST QUENTIN',
    'FOUQUEROLLES',
    'HAUDIVILLERS',
    'LAFRAYE',
    'LAVERSINES',
    'LITZ',
    'LA NEUVILLE EN HEZ',
    'NIVILLERS',
    'OROER',
    'REMERANGLES',
    'ROCHY CONDE',
    'LA RUE ST PIERRE',
    'THERDONNE',
    'VELENNES',
  ],
  60123: ['BONNEUIL EN VALOIS', 'EMEVILLE'],
  60112: [
    'BONNIERES',
    'CRILLON',
    'HAUCOURT',
    'HERCHIES',
    'JUVIGNIES',
    'MAISONCELLE ST PIERRE',
    'MARTINCOURT',
    'MILLY SUR THERAIN',
    'LA NEUVILLE VAULT',
    'PIERREFITTE EN BEAUVAISIS',
    'TROISSEREUX',
    'VERDEREL LES SAUQUEUSE',
    'VROCOURT',
  ],
  60820: ['BORAN SUR OISE'],
  60240: [
    'BOUBIERS',
    'BOUCONVILLERS',
    'BOURY EN VEXIN',
    'CHAMBORS',
    'CHAUMONT EN VEXIN',
    'CHAVENCON',
    'COURCELLES LES GISORS',
    'DELINCOURT',
    'LA CORNE EN VEXIN',
    'FAY LES ETANGS',
    'FLEURY',
    'MONTCHEVREUIL',
    'FRESNE LEGUILLON',
    'HADANCOURT LE HAUT CLOCHER',
    'JAMERICOURT',
    'JOUY SOUS THELLE',
    'LATTAINVILLE',
    'LAVILLETERTRE',
    'LIANCOURT ST PIERRE',
    'LIERVILLE',
    'LOCONVILLE',
    'LE MESNIL THERIBUS',
    'MONNEVILLE',
    'MONTAGNY EN VEXIN',
    'MONTJAVOULT',
    'PARNES',
    'REILLY',
    'SENOTS',
    'SERANS',
    'THIBIVILLERS',
    'TOURLY',
    'VAUDANCOURT',
  ],
  60141: ['BOURSONNE', 'IVORS'],
  60590: [
    'BOUTENCOURT',
    'ENENCOURT LEAGE',
    'ERAGNY SUR EPTE',
    'FLAVACOURT',
    'LABOSSE',
    'LALANDE EN SON',
    'SERIFONTAINE',
    'TALMONTIERS',
    'TRIE CHATEAU',
    'TRIE LA VILLE',
    'LE VAUMAIN',
  ],
  60870: ['BRENOUILLE', 'RIEUX', 'VILLERS ST PAUL'],
  60840: ['BREUIL LE SEC', 'CATENOY', 'NOINTEL'],
  60290: [
    'CAMBRONNE LES CLERMONT',
    'CAUFFRY',
    'LAIGNEVILLE',
    'MONCHY ST ELOI',
    'NEUILLY SOUS CLERMONT',
    'RANTIGNY',
  ],
  60680: ['CANLY', 'LE FAYEL', 'GRANDFRESNOY', 'JONQUIERES'],
  60730: ['CAUVIGNY', 'LACHAPELLE ST PIERRE', 'NOVILLERS', 'STE GENEVIEVE', 'ULLY ST GEORGES'],
  60230: ['CHAMBLY'],
  60500: ['CHANTILLY', 'VINEUIL ST FIRMIN'],
  60520: ['LA CHAPELLE EN SERVAL', 'PONTARME', 'THIERS SUR THEVE'],
  60150: [
    'CHEVINCOURT',
    'COUDUN',
    'GIRAUMONT',
    'JANVILLE',
    'LONGUEIL ANNEL',
    'MACHEMONT',
    'MELICOCQ',
    'MONTMACQ',
    'LE PLESSIS BRION',
    'THOUROTTE',
    'VILLERS SUR COUDUN',
  ],
  60710: ['CHEVRIERES', 'HOUDANCOURT'],
  60138: ['CHIRY OURSCAMP'],
  60750: ['CHOISY AU BAC'],
  60660: ['CIRES LES MELLO', 'CRAMOISY', 'MAYSEL', 'MELLO', 'ROUSSELOY', 'ST VAAST LES MELLO'],
  60420: [
    'COIVREL',
    'COURCELLES EPAYELLES',
    'CREVECOEUR LE PETIT',
    'DOMFRONT',
    'DOMPIERRE',
    'FERRIERES',
    'LE FRESTOY VAUX',
    'GODENVILLERS',
    'LEGLANTIERS',
    'MAIGNELAY MONTIGNY',
    'MENEVILLERS',
    'MERY LA BATAILLE',
    'MONTGERAIN',
    'LE PLOYRON',
    'ROYAUCOURT',
    'SAINS MORAINVILLERS',
    'ST MARTIN AUX BOIS',
    'TRICOT',
    'WACQUEMOULIN',
    'WELLES PERENNES',
  ],
  60200: ['COMPIEGNE'],
  60850: [
    'LE COUDRAY ST GERMER',
    'CUIGY EN BRAY',
    'LALANDELLE',
    'PUISEUX EN BRAY',
    'ST GERMER DE FLY',
    'ST PIERRE ES CHAMPS',
  ],
  60580: ['COYE LA FORET'],
  60100: ['CREIL'],
  60530: [
    'CROUY EN THELLE',
    'DIEUDONNE',
    'ERCUIS',
    'FRESNOY EN THELLE',
    'LE MESNIL EN THELLE',
    'MORANGLES',
    'NEUILLY EN THELLE',
  ],
  60790: ['LA DRENNE', 'POUILLY', 'ST CREPIN IBOUVILLERS', 'VALDAMPIERRE'],
  60157: ['ELINCOURT STE MARGUERITE'],
  60950: ['ERMENONVILLE', 'MONTAGNY STE FELICITE', 'VER SUR LAUNETTE'],
  60330: ['EVE', 'LAGNY LE SEC', 'LE PLESSIS BELLEVILLE', 'SILLY LE LONG'],
  60960: ['FEUQUIERES'],
  60127: ['FRESNOY LA RIVIERE', 'MORIENVAL'],
  60117: ['GONDREVILLE', 'RUSSY BEMONT', 'VAUCIENNES', 'VAUMOISE', 'VEZ'],
  60270: ['GOUVIEUX'],
  60119: ['HENONVILLE', 'MONTS', 'NEUVILLE BOSC'],
  60173: ['IVRY LE TEMPLE'],
  60610: ['LACROIX ST OUEN'],
  60260: ['LAMORLAYE'],
  60126: ['LONGUEIL STE MARIE', 'RIVECOURT'],
  60160: ['MONTATAIRE', 'THIVERNY'],
  60134: ['MONTREUIL SUR THERAIN', 'VILLERS ST SEPULCRE'],
  60128: ['MORTEFONTAINE', 'PLAILLY'],
  60180: ['NOGENT SUR OISE'],
  60560: ['ORRY LA VILLE'],
  60155: ['RAINVILLERS', 'ST LEGER EN BRAY'],
  60153: ['RETHONDES'],
  60410: [
    'RHUIS',
    'ROBERVAL',
    'SAINTINES',
    'ST VAAST DE LONGMONT',
    'VERBERIE',
    'VILLENEUVE SUR VERBERIE',
  ],
  60149: ['ST CREPIN IBOUVILLERS'],
  60340: ['ST LEU D ESSERENT', 'VILLERS SOUS ST LEU'],
  60740: ['ST MAXIMIN'],
  60550: ['VERNEUIL EN HALATTE'],
  60175: ['VILLENEUVE LES SABLONS'],
  61000: ['ALENCON', 'CERISE', 'ST GERMAIN DU CORBEIS'],
  61570: [
    'ALMENECHES',
    'LA BELLIERE',
    'BOISSEI LA LANDE',
    'BOUCE',
    'LE CHATEAU D ALMENECHES',
    'FRANCHEVILLE',
    'MEDAVY',
    'MONTMERREI',
    'MORTREE',
    'BOISCHAMPRE',
  ],
  61130: [
    'APPENAI SOUS BELLEME',
    'BELLEME',
    'BELLOU LE TRICHARD',
    'LA CHAPELLE SOUEF',
    'DAME MARIE',
    'BELFORET EN PERCHE',
    'IGE',
    'ORIGNY LE ROUX',
    'POUVRAI',
    'ST CYR LA ROSIERE',
    'ST FULGENT DES ORMES',
    'ST GERMAIN DE LA COUDRE',
    'ST MARTIN DU VIEUX BELLEME',
    'VAL AU PERCHE',
    'VAUNOISE',
  ],
  61200: [
    'ARGENTAN',
    'AUNOU LE FAUCON',
    'COMMEAUX',
    'ECOUCHE LES VALLEES',
    'FLEURE',
    'JUVIGNY SUR ORNE',
    'MOULINS SUR ORNE',
    'OCCAGNES',
    'SAI',
    'SARCEAUX',
    'SEVIGNY',
    'GOUFFERN EN AUGE',
  ],
  61100: [
    'ATHIS VAL DE ROUVRE',
    'AUBUSSON',
    'LA BAZOQUE',
    'CALIGNY',
    'CERISY BELLE ETOILE',
    'LA CHAPELLE AU MOINE',
    'LA CHAPELLE BICHE',
    'DURCET',
    'FLERS',
    'LA LANDE PATRY',
    'LA LANDE ST SIMEON',
    'LANDIGOU',
    'LANDISACQ',
    'MONTILLY SUR NOIREAU',
    'ST GEORGES DES GROSEILLERS',
    'STE OPPORTUNE',
    'ST PAUL',
    'LA SELLE LA FORGE',
  ],
  61430: [
    'ATHIS VAL DE ROUVRE',
    'BERJOU',
    'CAHAN',
    'MENIL HUBERT SUR ORNE',
    'STE HONORINE LA CHARDONNE',
    'ST PHILBERT SUR ORNE',
  ],
  61270: [
    'AUBE',
    'AUGUAISE',
    'BEAUFAI',
    'BONNEFOI',
    'BRETHEL',
    'LA CHAPELLE VIEL',
    'ECORCEI',
    'LES GENETTES',
    'LE MENIL BERARD',
    'RAI',
    'ST HILAIRE SUR RISLE',
    'LES ASPRES',
  ],
  61120: [
    'AUBRY LE PANTHOU',
    'CAMEMBERT',
    'CANAPVILLE',
    'LES CHAMPEAUX',
    'CHAMPOSOULT',
    'CROUTTES',
    'FRESNAY LE SAMSON',
    'GUERQUESALLES',
    'NEUVILLE SUR TOUQUES',
    'PONTCHARDON',
    'LE RENOUARD',
    'ROIVILLE',
    'SAP EN AUGE',
    'TICHEVILLE',
    'VIMOUTIERS',
  ],
  61500: [
    'AUNAY LES BOIS',
    'AUNOU SUR ORNE',
    'BELFONDS',
    'BOITRON',
    'LE BOUILLON',
    'BURSARD',
    'LE CERCUEIL',
    'CHAILLOUE',
    'LA CHAPELLE PRES SEES',
    'ESSAY',
    'LA FERRIERE BECHET',
    'MACE',
    'MORTREE',
    'NEAUPHE SOUS ESSAI',
    'ST GERVAIS DU PERRON',
    'SEES',
    'TANVILLE',
  ],
  61240: [
    'LES AUTHIEUX DU PUITS',
    'CHAILLOUE',
    'CHAMP HAUT',
    'LA GENEVRAIE',
    'GODISSON',
    'LIGNERES',
    'MENIL FROGER',
    'LE MENIL VICOMTE',
    'LE MERLERAULT',
    'NONANT LE PIN',
    'ST GERMAIN DE CLAIREFEUILLE',
  ],
  61470: [
    'AVERNES ST GOURGON',
    'LE BOSC RENOULT',
    'LA FERTE EN OUCHE',
    'ST AUBIN DE BONNEVAL',
    'ST GERMAIN D AUNAY',
    'SAP EN AUGE',
  ],
  61150: [
    'AVOINE',
    'ECOUCHE LES VALLEES',
    'MONTS SUR ORNE',
    'JOUE DU PLAIN',
    'LOUGE SUR MAIRE',
    'RANES',
    'ST BRICE SOUS RANES',
    'SEVRAI',
    'TANQUES',
    'VIEUX PONT',
  ],
  61700: [
    'AVRILLY',
    'CHAMPSECRET',
    'DOMFRONT EN POIRAIE',
    'DOMPIERRE',
    'LONLAY L ABBAYE',
    'PERROU',
    'ST BOMER LES FORGES',
    'ST BRICE',
    'ST GILLES DES MARAIS',
  ],
  61160: [
    'BAILLEUL',
    'BRIEUX',
    'COUDEHARD',
    'COULONCES',
    'ECORCHES',
    'FONTAINE LES BASSETS',
    'GUEPREI',
    'LOUVIERES EN AUGE',
    'MERRI',
    'MONTABARD',
    'MONT ORMEL',
    'MONTREUIL LA CAMBE',
    'NEAUPHE SUR DIVE',
    'NECY',
    'OMMOY',
    'RONAI',
    'ST GERVAIS DES SABLONS',
    'ST LAMBERT SUR DIVE',
    'GOUFFERN EN AUGE',
    'TOURNAI SUR DIVE',
    'TRUN',
    'VILLEDIEU LES BAILLEUL',
  ],
  61450: ['BANVOU', 'LE CHATELLIER', 'LA FERRIERE AUX ETANGS'],
  61170: [
    'BARVILLE',
    'BURE',
    'BURES',
    'COULONGES SUR SARTHE',
    'LALEU',
    'MARCHEMAISONS',
    'LE MELE SUR SARTHE',
    'LE MENIL GUYON',
    'MONTCHEVREL',
    'LE PLANTIS',
    'ST AGNAN SUR SARTHE',
    'ST AUBIN D APPENAI',
    'ST JULIEN SUR SARTHE',
    'ST LEGER SUR SARTHE',
    'STE SCOLASSE SUR SARTHE',
    'LES VENTES DE BOURSE',
  ],
  61210: [
    'BAZOCHES AU HOULME',
    'CHAMPCERIE',
    'GIEL COURTEILLES',
    'HABLOVILLE',
    'LA LANDE DE LOUGE',
    'MENIL GONDOUIN',
    'MENIL HERMEI',
    'MENIL VIN',
    'MONTREUIL AU HOULME',
    'NEUVY AU HOULME',
    'PUTANGES LE LAC',
    'RI',
    'STE HONORINE LA GUILLAUME',
    'LES YVETEAUX',
  ],
  61560: [
    'BAZOCHES SUR HOENE',
    'BOECE',
    'CHAMPEAUX SUR SARTHE',
    'COURGEOUT',
    'LA MESNIERE',
    'ST AUBIN DE COURTERAIE',
    'ST GERMAIN DE MARTIGNY',
    'ST OUEN DE SECHEROUVRE',
  ],
  61190: ['BEAULIEU', 'IRAI', 'CHARENCEY', 'TOUROUVRE AU PERCHE', 'LA VENTROUZE'],
  61600: [
    'BEAUVAIN',
    'LA CHAUX',
    'FAVEROLLES',
    'LA FERTE MACE',
    'LE GRAIS',
    'LONLAY LE TESSON',
    'MAGNY LE DESERT',
    'LA MOTTE FOUQUET',
    'ST GEORGES D ANNEBECQ',
    'ST PATRICE DU DESERT',
    'LES MONTS D ANDAINE',
    'BAGNOLES DE L ORNE NORMANDIE',
  ],
  61360: [
    'BELLAVILLIERS',
    'CHEMILLI',
    'COULIMER',
    'BELFORET EN PERCHE',
    'MONTGAUDRY',
    'PERVENCHERES',
    'ST JOUIN DE BLAVOU',
    'ST QUENTIN DE BLAVOU',
    'SURE',
    'VIDAI',
  ],
  61220: [
    'BELLOU EN HOULME',
    'BRIOUZE',
    'LA COULONCHE',
    'CRAMENIL',
    'LIGNOU',
    'LE MENIL DE BRIOUZE',
    'POINTEL',
    'ST ANDRE DE BRIOUZE',
    'ST HILAIRE DE BRIOUZE',
    'SAIRES LA VERRERIE',
  ],
  61340: [
    'BERD HUIS',
    'COUR MAUGIS SUR HUISNE',
    'PERCHE EN NOCE',
    'ST HILAIRE SUR ERRE',
    'ST PIERRE LA BRUYERE',
    'VAL AU PERCHE',
  ],
  61290: [
    'BIZOU',
    'L HOME CHAMONDOT',
    'LONGNY LES VILLAGES',
    'LE MAGE',
    'LES MENUS',
    'LE PAS ST L HOMER',
  ],
  61110: [
    'COUR MAUGIS SUR HUISNE',
    'BRETONCELLES',
    'SABLONS SUR HUISNE',
    'LA MADELEINE BOUVET',
    'MOUTIERS AU PERCHE',
    'REMALARD EN PERCHE',
    'ST GERMAIN DES GROIS',
    'VERRIERES',
  ],
  61380: [
    'BONSMOULINS',
    'LA FERRIERE AU DOYEN',
    'MAHERU',
    'MOULINS LA MARCHE',
    'ST AQUILIN DE CORBION',
    'STE CERONNE LES MORTAGNE',
    'ST MARTIN DES PEZERITS',
    'SOLIGNY LA TRAPPE',
  ],
  61390: [
    'BRULLEMAIL',
    'LE CHALANGE',
    'COURTOMER',
    'FAY',
    'FERRIERES LA VERRERIE',
    'GAPREE',
    'ST GERMAIN LE VIEUX',
    'ST LEONARD DES PARCS',
    'TELLIERES LE PLESSIS',
    'TREMONT',
  ],
  61320: [
    'CARROUGES',
    'CHAHAINS',
    'LE CHAMP DE LA PIERRE',
    'CIRAL',
    'JOUE DU BOIS',
    'LALACELLE',
    'LA LANDE DE GOULT',
    'L OREE D ECOUVES',
    'LE MENIL SCELLEUR',
    'ROUPERROUX',
    'ST ELLIER LES BOIS',
    'STE MARGUERITE DE CARROUGES',
    'STE MARIE LA ROBERT',
    'ST MARTIN DES LANDES',
    'ST MARTIN L AIGUILLON',
    'ST SAUVEUR DE CARROUGES',
  ],
  61330: ['CEAUCE', 'JUVIGNY VAL D ANDAINE', 'TORCHAMP'],
  61260: ['CETON', 'VAL AU PERCHE'],
  61300: [
    'CHANDAI',
    'CRULAI',
    'L AIGLE',
    'ST MARTIN D ECUBLEI',
    'ST MICHEL TUBOEUF',
    'ST OUEN SUR ITON',
    'ST SULPICE SUR RISLE',
    'ST SYMPHORIEN DES BRUYERES',
    'VITRAI SOUS LAIGLE',
  ],
  61800: [
    'CHANU',
    'LE MENIL CIBOULT',
    'MONCY',
    'MONTSECRET CLAIREFOUGERE',
    'ST CHRISTOPHE DE CHAULIEU',
    'ST PIERRE D ENTREMONT',
    'ST QUENTIN LES CHARDONNETS',
    'TINCHEBRAY BOCAGE',
  ],
  61140: ['RIVES D ANDAINE', 'JUVIGNY VAL D ANDAINE', 'BAGNOLES DE L ORNE NORMANDIE'],
  61410: ['RIVES D ANDAINE', 'LA FERTE MACE', 'MEHOUDIN', 'ST OUEN LE BRISOULT', 'TESSE FROULAY'],
  61400: [
    'LA CHAPELLE MONTLIGEON',
    'COMBLOT',
    'CORBON',
    'COURGEON',
    'FEINGS',
    'BELFORET EN PERCHE',
    'LOISAIL',
    'MAUVES SUR HUISNE',
    'MORTAGNE AU PERCHE',
    'PARFONDEVAL',
    'LE PIN LA GARENNE',
    'REVEILLON',
    'ST DENIS SUR HUISNE',
    'ST HILAIRE LE CHATEL',
    'ST LANGIS LES MORTAGNE',
    'ST MARD DE RENO',
    'VILLIERS SOUS MORTAGNE',
  ],
  61230: [
    'CHAUMONT',
    'CISAI ST AUBIN',
    'COULMER',
    'CROISILLES',
    'LA FRESNAIE FAYEL',
    'GACE',
    'MARDILLY',
    'MENIL HUBERT EN EXMES',
    'ORGERES',
    'RESENLIEU',
    'ST EVROULT DE MONTFORT',
    'LE SAP ANDRE',
    'LA TRINITE DES LAITIERS',
  ],
  61250: [
    'COLOMBIERS',
    'CONDE SUR SARTHE',
    'CUISSAI',
    'DAMIGNY',
    'HAUTERIVE',
    'HELOUP',
    'LARRE',
    'LONRAI',
    'LE MENIL BROUT',
    'MENIL ERREUX',
    'MIEUXCE',
    'NEUILLY LE BISSON',
    'PACE',
    'ECOUVES',
    'ST CENERI LE GEREI',
    'ST NICOLAS DES BOIS',
    'SEMALLE',
    'VALFRAMBERT',
  ],
  61440: ['ECHALOU', 'MESSEI', 'ST ANDRE DE MESSEI'],
  61370: ['ECHAUFFOUR', 'PLANCHES', 'STE GAUBURGE STE COLOMBE', 'ST PIERRE DES LOGES'],
  61420: [
    'LA FERRIERE BOCHARD',
    'GANDELAIN',
    'L OREE D ECOUVES',
    'LA ROCHE MABILE',
    'ST DENIS SUR SARTHON',
  ],
  61550: [
    'LA FERTE EN OUCHE',
    'LA GONFRIERE',
    'ST EVROULT NOTRE DAME DU BOIS',
    'ST NICOLAS DE SOMMAIRE',
    'TOUQUETTES',
  ],
  61310: ['GINAI', 'LE PIN AU HARAS', 'GOUFFERN EN AUGE'],
  61350: [
    'MANTILLY',
    'PASSAIS VILLAGES',
    'ST FRAIMBAULT',
    'ST MARS D EGRENNE',
    'ST ROCH SUR EGRENNE',
  ],
  61490: ['ST CLAIR DE HALOUZE'],
  61790: ['ST PIERRE DU REGARD'],
  62153: ['ABLAIN ST NAZAIRE', 'SOUCHEZ'],
  62116: ['ABLAINZEVELLE', 'ADINFER', 'AYETTE', 'BUCQUOY', 'DOUCHY LES AYETTE', 'PUISIEUX'],
  62320: ['ACHEVILLE', 'BOIS BERNARD', 'DROCOURT', 'ROUVROY'],
  62217: [
    'ACHICOURT',
    'AGNY',
    'BEAURAINS',
    'MERCATEL',
    'NEUVILLE VITASSE',
    'TILLOY LES MOFFLAINES',
    'WAILLY',
  ],
  62121: [
    'ACHIET LE GRAND',
    'ACHIET LE PETIT',
    'BEHAGNIES',
    'BIHUCOURT',
    'COURCELLES LE COMTE',
    'ERVILLERS',
    'GOMIECOURT',
    'HAMELINCOURT',
    'MOYENNEVILLE',
    'SAPIGNIES',
  ],
  62144: ['ACQ', 'CARENCY', 'HAUTE AVESNES', 'MONT ST ELOI', 'VILLERS AU BOIS'],
  62380: [
    'ACQUIN WESTBECOURT',
    'AFFRINGUES',
    'BAYENGHEM LES SENINGHEM',
    'BLEQUIN',
    'BOUVELINGHEM',
    'CLETY',
    'COULOMBY',
    'DOHEM',
    'ELNES',
    'ESQUERDES',
    'LEDINGHEM',
    'LUMBRES',
    'NIELLES LES BLEQUIN',
    'OUVE WIRQUIN',
    'QUERCAMPS',
    'REMILLY WIRQUIN',
    'SENINGHEM',
    'SETQUES',
    'VAUDRINGHEM',
    'WAVRANS SUR L AA',
    'WISMES',
  ],
  62161: ['AGNEZ LES DUISANS', 'DUISANS', 'ETRUN', 'MAROEUIL'],
  62690: [
    'AGNIERES',
    'AUBIGNY EN ARTOIS',
    'BERLES MONCHEL',
    'BETHONSART',
    'CAMBLIGNEUL',
    'CAMBLAIN L ABBE',
    'CAPELLE FERMONT',
    'ESTREE CAUCHY',
    'FREVIN CAPELLE',
    'HERMAVILLE',
    'IZEL LES HAMEAU',
    'MINGOVAL',
    'SAVY BERLETTE',
    'TILLOY LES HERMAVILLE',
    'VILLERS BRULIN',
    'VILLERS CHATEL',
  ],
  62120: [
    'AIRE SUR LA LYS',
    'BLESSY',
    'CAMPAGNE LES WARDRECQUES',
    'LAMBRES',
    'LINGHEM',
    'MAMETZ',
    'MAZINGHEM',
    'NORRENT FONTES',
    'QUERNES',
    'QUIESTEDE',
    'RACQUINGHEM',
    'ST AUGUSTIN',
    'RELY',
    'ROMBLY',
    'ROQUETOIRE',
    'ST HILAIRE COTTES',
    'WARDRECQUES',
    'WITTERNESSE',
    'WITTES',
  ],
  62180: [
    'AIRON NOTRE DAME',
    'AIRON ST VAAST',
    'COLLINE BEAUMONT',
    'CONCHIL LE TEMPLE',
    'NEMPONT ST FIRMIN',
    'RANG DU FLIERS',
    'TIGNY NOYELLE',
    'VERTON',
    'WABEN',
  ],
  62650: [
    'AIX EN ERGNY',
    'ALETTE',
    'AVESNES',
    'BEZINGHEM',
    'BIMONT',
    'BOURTHES',
    'CAMPAGNE LES BOULONNAIS',
    'CLENLEU',
    'ENQUIN SUR BAILLONS',
    'ERGNY',
    'HERLY',
    'HUCQUELIERS',
    'HUMBERT',
    'MANINGHEM',
    'PARENTY',
    'PREURES',
    'QUILEN',
    'RUMILLY',
    'ST MICHEL SOUS BOIS',
    'WICQUINGHEM',
    'ZOTEUX',
  ],
  62170: [
    'AIX EN ISSART',
    'ATTIN',
    'BEAUMERIE ST MARTIN',
    'BERNIEULLES',
    'BEUSSENT',
    'BEUTIN',
    'BOISJEAN',
    'BREXENT ENOCQ',
    'BRIMEUX',
    'LA CALOTTERIE',
    'CAMPIGNEULLES LES GRANDES',
    'CAMPIGNEULLES LES PETITES',
    'ECUIRES',
    'ESTREE',
    'ESTREELLES',
    'INXENT',
    'LEPINE',
    'LA MADELAINE SOUS MONTREUIL',
    'MARANT',
    'MARLES SUR CANCHE',
    'MONTCAVREL',
    'MONTREUIL SUR MER',
    'NEUVILLE SOUS MONTREUIL',
    'RECQUES SUR COURSE',
    'ST AUBIN',
    'ST JOSSE',
    'SEMPY',
    'SORRUS',
    'WAILLY BEAUCAMP',
  ],
  62160: ['AIX NOULETTE', 'BULLY LES MINES', 'GRENAY'],
  62850: [
    'ALEMBON',
    'ALQUINES',
    'BAINGHEN',
    'ESCOEUILLES',
    'HAUT LOQUIN',
    'HERBINGHEN',
    'HOCQUINGHEN',
    'JOURNY',
    'LICQUES',
    'REBERGUES',
    'SANGHEN',
    'SURQUES',
  ],
  62142: [
    'ALINCTHUN',
    'BELLEBRUNE',
    'BELLE ET HOULLEFORT',
    'COLEMBERT',
    'HENNEVEUX',
    'LONGUEVILLE',
    'NABRINGHEN',
    'LE WAST',
  ],
  62157: ['ALLOUAGNE'],
  62164: ['AMBLETEUSE', 'AUDRESSELLES'],
  62310: [
    'AMBRICOURT',
    'AVONDANCE',
    'AZINCOURT',
    'CANLERS',
    'COUPELLE NEUVE',
    'COUPELLE VIEILLE',
    'CREPY',
    'CREQUY',
    'FRUGES',
    'HEZECQUES',
    'LUGY',
    'MAISONCELLE',
    'MATRINGHEM',
    'MENCAS',
    'PLANQUES',
    'RADINGHEM',
    'RUISSEAUVILLE',
    'SAINS LES FRESSIN',
    'SENLIS',
    'TORCY',
    'TRAMECOURT',
    'VERCHIN',
    'VINCLY',
  ],
  62127: [
    'AMBRINES',
    'AVERDOINGT',
    'BAILLEUL AUX CORNAILLES',
    'CHELERS',
    'FREVILLERS',
    'GOUY EN TERNOIS',
    'LIGNY ST FLOCHEL',
    'MAGNICOURT EN COMTE',
    'MAIZIERES',
    'MARQUAY',
    'MONCHY BRETON',
    'PENIN',
    'TERNAS',
    'TINCQUES',
    'VILLERS SIR SIMON',
  ],
  62190: [
    'AMES',
    'AUCHY AU BOIS',
    'BOURECQ',
    'ECQUEDECQUES',
    'HAM EN ARTOIS',
    'LESPESSES',
    'LIERES',
    'LILLERS',
  ],
  62260: ['AMETTES', 'AUCHEL', 'CAUCHY A LA TOUR', 'FERFAY'],
  62760: [
    'AMPLIER',
    'COUIN',
    'FAMECHON',
    'GAUDIEMPRE',
    'GRINCOURT LES PAS',
    'HALLOY',
    'HENU',
    'MONDICOURT',
    'ORVILLE',
    'PAS EN ARTOIS',
    'POMMERA',
    'ST AMAND',
    'SARTON',
    'THIEVRES',
    'WARLINCOURT LES PAS',
  ],
  62340: [
    'ANDRES',
    'BONNINGUES LES CALAIS',
    'BOUQUEHAULT',
    'CAMPAGNE LES GUINES',
    'GUINES',
    'HAMES BOUCRES',
    'PIHEN LES GUINES',
  ],
  62143: ['ANGRES'],
  62880: ['ANNAY', 'ESTEVELLES', 'PONT A VENDIN', 'VENDIN LE VIEIL'],
  62149: ['ANNEQUIN', 'CAMBRIN', 'CUINCHY', 'FESTUBERT', 'GIVENCHY LES LA BASSEE'],
  62232: ['ANNEZIN', 'FOUQUEREUIL', 'FOUQUIERES LES BETHUNE', 'HINGES', 'VENDIN LES BETHUNE'],
  62134: [
    'ANVIN',
    'BERGUENEUSE',
    'BOYAVAL',
    'EPS',
    'EQUIRRE',
    'ERIN',
    'FIEFS',
    'FLEURY',
    'FONTAINE LES BOULANS',
    'HEUCHIN',
    'LISBOURG',
    'MONCHY CAYEUX',
    'PREDEFIN',
    'TENEUR',
    'TILLY CAPELLE',
  ],
  62223: [
    'ANZIN ST AUBIN',
    'ATHIES',
    'ECURIE',
    'FEUCHY',
    'ROCLINCOURT',
    'STE CATHERINE',
    'ST LAURENT BLANGY',
    'ST NICOLAS',
  ],
  62610: [
    'ARDRES',
    'AUTINGUES',
    'BALINGHEM',
    'BREMES',
    'LANDRETHUN LES ARDRES',
    'LOUCHES',
    'NIELLES LES ARDRES',
    'RODELINGHEM',
  ],
  62580: [
    'ARLEUX EN GOHELLE',
    'BAILLEUL SIR BERTHOULT',
    'FARBUS',
    'FRESNOY EN GOHELLE',
    'GAVRELLE',
    'GIVENCHY EN GOHELLE',
    'NEUVILLE ST VAAST',
    'NEUVIREUIL',
    'OPPY',
    'THELUS',
    'VIMY',
    'WILLERVAL',
  ],
  62510: ['ARQUES'],
  62000: ['ARRAS', 'DAINVILLE'],
  62730: ['LES ATTAQUES', 'MARCK'],
  62140: [
    'AUBIN ST VAAST',
    'BREVILLERS',
    'CAPELLE LES HESDIN',
    'CAUMONT',
    'CAVRON ST MARTIN',
    'CHERIENNES',
    'FRESSIN',
    'GRIGNY',
    'GUIGNY',
    'GUISY',
    'HESDIN',
    'HUBY ST LEU',
    'LABROYE',
    'LA LOGE',
    'MARCONNE',
    'MARCONNELLE',
    'MOURIEZ',
    'BOUIN PLUMOISON',
    'LE QUESNOY EN ARTOIS',
    'RAYE SUR AUTHIE',
    'REGNAUVILLE',
    'STE AUSTREBERTHE',
    'TORTEFONTAINE',
    'VACQUERIETTE ERQUIERES',
    'WAMBERCOURT',
  ],
  62390: [
    'AUBROMETZ',
    'AUXI LE CHATEAU',
    'BOFFLES',
    'BUIRE AU BOIS',
    'FONTAINE L ETALON',
    'GENNES IVERGNY',
    'HARAVESNES',
    'NOEUX LES AUXI',
    'LE PONCHEL',
    'QUOEUX HAUT MAINIL',
    'ROUGEFAY',
    'TOLLENT',
    'VAULX',
    'VILLERS L HOPITAL',
    'BEAUVOIR WAVANS',
    'WILLENCOURT',
  ],
  62770: [
    'AUCHY LES HESDIN',
    'BEALENCOURT',
    'BLANGY SUR TERNOISE',
    'BLINGEL',
    'ECLIMEUX',
    'FILLIEVRES',
    'FRESNOY',
    'GALAMETZ',
    'INCOURT',
    'NEULETTE',
    'NOYELLES LES HUMIERES',
    'LE PARCQ',
    'ROLLANCOURT',
    'ST GEORGES',
    'VIEIL HESDIN',
    'WAIL',
    'WAMIN',
    'WILLEMAN',
  ],
  62138: ['AUCHY LES MINES', 'BILLY BERCLAU', 'DOUVRIN', 'HAISNES', 'VIOLAINES'],
  62250: [
    'AUDEMBERT',
    'BAZINGHEN',
    'BEUVREQUEN',
    'FERQUES',
    'LANDRETHUN LE NORD',
    'LEUBRINGHEN',
    'LEULINGHEN BERNES',
    'MANINGHEN HENNE',
    'MARQUISE',
    'OFFRETHUN',
    'ST INGLEVERT',
    'WACQUINGHEN',
  ],
  62560: [
    'AUDINCTHUN',
    'AVROULT',
    'COYECQUES',
    'DENNEBROEUCQ',
    'FAUQUEMBERGUES',
    'MERCK ST LIEVIN',
    'RECLINGHEM',
    'RENTY',
    'ST MARTIN D HARDINGHEM',
    'THIEMBRONNE',
    'VERCHOCQ',
  ],
  62179: ['AUDINGHEN', 'ESCALLES', 'HERVELINGHEN', 'TARDINGHEN', 'WISSANT'],
  62890: [
    'AUDREHEM',
    'BONNINGUES LES ARDRES',
    'CLERQUES',
    'MENTQUE NORTBECOURT',
    'MUNCQ NIEURLET',
    'NORDAUSQUES',
    'NORT LEULINGHEM',
    'RECQUES SUR HEM',
    'TOURNEHEM SUR LA HEM',
    'ZOUAFQUES',
  ],
  62370: [
    'AUDRUICQ',
    'GUEMPS',
    'NORTKERQUE',
    'NOUVELLE EGLISE',
    'OFFEKERQUE',
    'POLINCOVE',
    'RUMINGHEM',
    'ST FOLQUIN',
    'STE MARIE KERQUE',
    'ZUTKERQUE',
  ],
  62550: [
    'AUMERVAL',
    'BAILLEUL LES PERNES',
    'BOURS',
    'FLORINGHEM',
    'FONTAINE LES HERMANS',
    'HESTRUS',
    'MAREST',
    'NEDON',
    'NEDONCHEL',
    'PERNES',
    'PRESSY',
    'SACHIN',
    'SAINS LES PERNES',
    'TANGRY',
    'VALHUON',
  ],
  62810: [
    'AVESNES LE COMTE',
    'BARLY',
    'BEAUDRICOURT',
    'BEAUFORT BLAVINCOURT',
    'BERLENCOURT LE CAUROY',
    'DENIER',
    'ESTREE WAMIN',
    'FOSSEUX',
    'GIVENCHY LE NOBLE',
    'GRAND RULLECOURT',
    'HAUTEVILLE',
    'IVERGNY',
    'LATTRE ST QUENTIN',
    'LIENCOURT',
    'LIGNEREUIL',
    'MANIN',
    'NOYELLE VION',
    'SARS LE BOIS',
    'SOMBRIN',
    'LE SOUICH',
    'SUS ST LEGER',
    'WARLUZEL',
  ],
  62450: [
    'AVESNES LES BAPAUME',
    'BANCOURT',
    'BAPAUME',
    'BEAULENCOURT',
    'BEUGNATRE',
    'BIEFVILLERS LES BAPAUME',
    'FAVREUIL',
    'FREMICOURT',
    'GREVILLERS',
    'LIGNY THILLOY',
    'MARTINPUICH',
    'MORVAL',
    'RIENCOURT LES BAPAUME',
    'ROCQUIGNY',
    'LE SARS',
    'LE TRANSLOY',
    'VILLERS AU FLOS',
    'WARLENCOURT EAUCOURT',
  ],
  62210: ['AVION'],
  62123: [
    'BAILLEULMONT',
    'BAILLEULVAL',
    'BASSEUX',
    'BEAUMETZ LES LOGES',
    'BERLES AU BOIS',
    'BERNEVILLE',
    'GOUVES',
    'GOUY EN ARTOIS',
    'HABARCQ',
    'MONCHIET',
    'MONTENESCOURT',
    'NOYELLETTE',
    'SIMENCOURT',
    'WANQUETIN',
    'WARLUS',
  ],
  62360: [
    'BAINCTHUN',
    'CONDETTE',
    'ECHINGHEN',
    'HESDIGNEUL LES BOULOGNE',
    'HESDIN L ABBE',
    'ISQUES',
    'ST ETIENNE AU MONT',
    'ST LEONARD',
    'LA CAPELLE LES BOULOGNE',
  ],
  62150: [
    'BAJUS',
    'BEUGIN',
    'CAUCOURT',
    'LA COMTE',
    'FRESNICOURT LE DOLMEN',
    'GAUCHIN LEGAL',
    'HERMIN',
    'HOUDAIN',
    'REBREUVE RANCHICOURT',
  ],
  62860: [
    'BARALLE',
    'BOURLON',
    'BUISSY',
    'ECOURT ST QUENTIN',
    'EPINOY',
    'INCHY EN ARTOIS',
    'MARQUION',
    'OISY LE VERGER',
    'PALLUEL',
    'PRONVILLE EN ARTOIS',
    'QUEANT',
    'RECOURT',
    'RUMAUCOURT',
    'SAINS LES MARQUION',
    'SAUCHY CAUCHY',
    'SAUCHY LESTREE',
    'SAUDEMONT',
  ],
  62124: [
    'BARASTRE',
    'BEAUMETZ LES CAMBRAI',
    'BERTINCOURT',
    'BEUGNY',
    'BUS',
    'HAPLINCOURT',
    'LEBUCQUIERE',
    'LECHELLE',
    'METZ EN COUTURE',
    'MORCHIES',
    'NEUVILLE BOURJONVAL',
    'RUYAULCOURT',
    'VELU',
    'YTRES',
  ],
  62620: ['BARLIN', 'HOUCHIN', 'MAISNIL LES RUITZ', 'RUITZ'],
  62158: [
    'BAVINCOURT',
    'LA CAUCHIE',
    'COULLEMONT',
    'COUTURELLE',
    'LA HERLIERE',
    'HUMBERCAMPS',
    'SAULTY',
  ],
  62910: ['BAYENGHEM LES EPERLECQUES', 'EPERLECQUES', 'HOULLE', 'MORINGHEM', 'MOULLE', 'SERQUES'],
  62960: [
    'BEAUMETZ LES AIRE',
    'BOMY',
    'ERNY ST JULIEN',
    'FEBVIN PALFART',
    'FLECHIN',
    'LAIRES',
    'LIGNY LES AIRE',
    'WESTREHEM',
  ],
  62990: [
    'BEAURAINVILLE',
    'BOUBERS LES HESMOND',
    'CONTES',
    'EMBRY',
    'HESMOND',
    'LEBIEZ',
    'LESPINOY',
    'LOISON SUR CREQUOISE',
    'MARENLA',
    'MARESQUEL ECQUEMICOURT',
    'OFFIN',
    'RIMBOVAL',
    'ROYON',
    'ST DENOEUX',
  ],
  62130: [
    'BEAUVOIS',
    'BERMICOURT',
    'BRIAS',
    'BUNEVILLE',
    'CONTEVILLE EN TERNOIS',
    'CROISETTE',
    'CROIX EN TERNOIS',
    'FOUFFLIN RICAMETZ',
    'FRAMECOURT',
    'GAUCHIN VERLOINGT',
    'GUINECOURT',
    'HAUTECLOQUE',
    'HERICOURT',
    'HERLINCOURT',
    'HERLIN LE SEC',
    'HERNICOURT',
    'HUCLIER',
    'HUMEROEUILLE',
    'HUMIERES',
    'MAISNIL',
    'MONTS EN TERNOIS',
    'NEUVILLE AU CORNET',
    'OEUF EN TERNOIS',
    'OSTREVILLE',
    'PIERREMONT',
    'RAMECOURT',
    'ROELLECOURT',
    'ST MICHEL SUR TERNOISE',
    'ST POL SUR TERNOISE',
    'SIRACOURT',
    'LA THIEULOYE',
    'TROISVAUX',
    'WAVRANS SUR TERNOISE',
  ],
  62240: [
    'BECOURT',
    'BOURNONVILLE',
    'BRUNEMBERT',
    'COURSET',
    'CREMAREST',
    'DESVRES',
    'LONGFOSSE',
    'LOTTINGHEN',
    'MENNEVILLE',
    'QUESQUES',
    'ST MARTIN CHOQUEL',
    'SELLES',
    'SENLECQUES',
    'VIEIL MOUTIER',
    'WIRWIGNES',
  ],
  62490: [
    'BELLONNE',
    'FRESNES LES MONTAUBAN',
    'IZEL LES EQUERCHIN',
    'NOYELLES SOUS BELLONNE',
    'QUIERY LA MOTTE',
    'SAILLY EN OSTREVENT',
    'TORTEQUESNE',
    'VITRY EN ARTOIS',
  ],
  62410: ['BENIFONTAINE', 'HULLUCH', 'MEURCHIN', 'WINGLES'],
  62600: ['BERCK', 'GROFFLIERS'],
  62400: ['BETHUNE', 'ESSARS', 'LOCON'],
  62660: ['BEUVRY'],
  62118: [
    'BIACHE ST VAAST',
    'FAMPOUX',
    'HAMBLAIN LES PRES',
    'MONCHY LE PREUX',
    'PELVES',
    'PLOUVAIN',
    'ROEUX',
  ],
  62111: [
    'BIENVILLERS AU BOIS',
    'FONCQUEVILLERS',
    'GOMMECOURT',
    'HANNESCAMPS',
    'HEBUTERNE',
    'MONCHY AU BOIS',
    'POMMIER',
    'SAILLY AU BOIS',
    'SOUASTRE',
  ],
  62420: ['BILLY MONTIGNY'],
  62173: ['BLAIRVILLE', 'FICHEUX', 'RANSART', 'RIVIERE'],
  62270: [
    'BLANGERVAL BLANGERMONT',
    'BONNIERES',
    'BOUBERS SUR CANCHE',
    'BOURET SUR CANCHE',
    'CANETTEMONT',
    'CONCHY SUR CANCHE',
    'ECOIVRES',
    'FLERS',
    'FORTEL EN ARTOIS',
    'FREVENT',
    'HOUVIN HOUVIGNEUL',
    'LIGNY SUR CANCHE',
    'LINZEUX',
    'MAGNICOURT SUR CANCHE',
    'MONCHEAUX LES FREVENT',
    'MONCHEL SUR CANCHE',
    'NUNCQ HAUTECOTE',
    'REBREUVE SUR CANCHE',
    'REBREUVIETTE',
    'SERICOURT',
    'SIBIVILLE',
    'VACQUERIE LE BOUCQ',
  ],
  62575: ['BLENDECQUES', 'HEURINGHEM'],
  62128: [
    'BOIRY BECQUERELLE',
    'BOYELLES',
    'BULLECOURT',
    'CHERISY',
    'CROISILLES',
    'ECOUST ST MEIN',
    'FONTAINE LES CROISILLES',
    'GUEMAPPE',
    'HENINEL',
    'HENIN SUR COJEUL',
    'NOREUIL',
    'ST LEGER',
    'ST MARTIN SUR COJEUL',
    'WANCOURT',
  ],
  62156: ['BOIRY NOTRE DAME', 'DURY', 'ETAING', 'ETERPIGNY', 'HAUCOURT', 'REMY', 'VIS EN ARTOIS'],
  62175: [
    'BOIRY ST MARTIN',
    'BOIRY STE RICTRUDE',
    'BOISLEUX AU MONT',
    'BOISLEUX ST MARC',
    'HENDECOURT LES RANSART',
  ],
  62500: [
    'BOISDINGHEM',
    'CLAIRMARAIS',
    'LEULINGHEM',
    'QUELMES',
    'ST MARTIN LEZ TATINGHEM',
    'ST OMER',
    'SALPERWICK',
    'TILQUES',
    'ZUDAUSQUES',
  ],
  62200: ['BOULOGNE SUR MER'],
  62132: ['BOURSIN', 'CAFFIERS', 'FIENNES', 'HARDINGHEN', 'HERMELINGHEN'],
  62172: ['BOUVIGNY BOYEFFLES'],
  62117: ['BREBIERES'],
  62700: ['BRUAY LA BUISSIERE'],
  62870: [
    'BUIRE LE SEC',
    'CAMPAGNE LES HESDIN',
    'DOURIEZ',
    'GOUY ST ANDRE',
    'MAINTENAY',
    'ROUSSENT',
    'ST REMY AU BOIS',
    'SAULCHOY',
  ],
  62151: ['BURBURE'],
  62350: ['BUSNES', 'CALONNE SUR LA LYS', 'MONT BERNANCHON', 'ROBECQ', 'ST FLORIS', 'ST VENANT'],
  62182: [
    'CAGNICOURT',
    'HENDECOURT LES CAGNICOURT',
    'RIENCOURT LES CAGNICOURT',
    'VILLERS LES CAGNICOURT',
  ],
  62100: ['CALAIS'],
  62470: ['CALONNE RICOUART', 'CAMBLAIN CHATELAIN'],
  62176: ['CAMIERS'],
  62830: [
    'CARLY',
    'DOUDEAUVILLE',
    'HALINGHEN',
    'LACRES',
    'QUESTRECQUES',
    'SAMER',
    'TINGRY',
    'VERLINCTHUN',
    'WIERRE AU BOIS',
  ],
  62220: ['CARVIN'],
  62920: ['CHOCQUES', 'GONNEHEM', 'OBLINGHEM'],
  62126: ['CONTEVILLE LES BOULOGNE', 'PERNES LES BOULOGNE', 'PITTEFAUX', 'WIMILLE'],
  62231: ['COQUELLES', 'PEUPLINGUES', 'SANGATTE'],
  62112: ['CORBEHEM', 'GOUY SOUS BELLONNE'],
  62630: [
    'CORMONT',
    'ETAPLES',
    'FRENCQ',
    'HUBERSENT',
    'LEFAUX',
    'LONGVILLIERS',
    'MARESVILLE',
    'TUBERSENT',
    'WIDEHEM',
  ],
  62137: ['COULOGNE'],
  62970: ['COURCELLES LES LENS'],
  62710: ['COURRIERES'],
  62136: ['LA COUTURE', 'LESTREM', 'RICHEBOURG', 'VIEILLE CHAPELLE'],
  62780: ['CUCQ'],
  62187: ['DANNES'],
  62129: ['DELETTES', 'ECQUES', 'BELLINGHEM', 'ST AUGUSTIN', 'THEROUANNE'],
  62460: ['DIEVAL', 'DIVION', 'OURTON'],
  62119: ['DOURGES'],
  62131: ['DROUVIN LE MARAIS', 'VAUDRICOURT', 'VERQUIN'],
  62300: ['ELEU DIT LEAUWETTE', 'LENS'],
  62145: ['ENQUIN LEZ GUINEGATTE', 'ESTREE BLANCHE', 'LIETTRES'],
  62224: ['EQUIHEN PLAGE'],
  62141: ['EVIN MALMAISON'],
  62840: ['FLEURBAIX', 'LAVENTIE', 'LORGIES', 'NEUVE CHAPELLE', 'SAILLY SUR LA LYS'],
  62740: ['FOUQUIERES LES LENS'],
  62185: ['FRETHUN', 'NIELLES LES CALAIS', 'ST TRICAT'],
  62199: ['GOSNAY'],
  62530: ['GOUY SERVINS', 'HERSIN COUPIGNY', 'SERVINS'],
  62147: ['GRAINCOURT LES HAVRINCOURT', 'HAVRINCOURT', 'HERMIES', 'TRESCAULT'],
  62330: ['GUARBECQUE', 'ISBERGUES'],
  62940: ['HAILLICOURT'],
  62570: ['HALLINES', 'HELFAUT', 'PIHEM', 'WIZERNES'],
  62440: ['HARNES'],
  62110: ['HENIN BEAUMONT'],
  62196: ['HESDIGNEUL LES BETHUNE'],
  62122: ['LABEUVRIERE', 'LAPUGNOY'],
  62113: ['LABOURSE', 'SAILLY LABOURSE', 'VERQUIGNEUL'],
  62159: ['LAGNICOURT MARCEL', 'MORY', 'VAULX VRAUCOURT'],
  62790: ['LEFOREST'],
  62800: ['LIEVIN'],
  62218: ['LOISON SOUS LENS'],
  62219: ['LONGUENESSE', 'WISQUES'],
  62750: ['LOOS EN GOHELLE'],
  62540: ['LOZINGHEM', 'MARLES LES MINES'],
  62670: ['MAZINGARBE'],
  62680: ['MERICOURT'],
  62155: ['MERLIMONT'],
  62640: ['MONTIGNY EN GOHELLE'],
  62152: ['NESLES', 'NEUFCHATEL HARDELOT'],
  62290: ['NOEUX LES MINES'],
  62950: ['NOYELLES GODAULT'],
  62980: ['NOYELLES LES VERMELLES', 'VERMELLES'],
  62221: ['NOYELLES SOUS LENS'],
  62590: ['OIGNIES'],
  62230: ['OUTREAU'],
  62215: ['OYE PLAGE'],
  62480: ['LE PORTEL'],
  62720: ['RETY', 'RINXENT', 'WIERRE EFFROY'],
  62114: ['SAINS EN GOHELLE'],
  62280: ['ST MARTIN BOULOGNE'],
  62162: ['ST OMER CAPELLE', 'VIEILLE EGLISE'],
  62430: ['SALLAUMINES'],
  62520: ['LE TOUQUET PARIS PLAGE'],
  62930: ['WIMEREUX'],
  62820: ['LIBERCOURT'],
  63260: [
    'AIGUEPERSE',
    'AUBIAT',
    'BUSSIERES ET PRUNS',
    'CHAPTUZAT',
    'EFFIAT',
    'MONTPENSIER',
    'ST AGOULIN',
    'ST GENES DU RETZ',
    'SARDON',
    'THURET',
    'VENSAT',
  ],
  63980: ['AIX LA FAYETTE', 'CHAMBON SUR DOLORE', 'ECHANDELYS', 'FOURNOLS'],
  63600: [
    'AMBERT',
    'BAFFIE',
    'CHAMPETIERES',
    'LA FORIE',
    'GRANDRIF',
    'ST FERREOL DES COTES',
    'ST JUST',
    'ST MARTIN DES OLMES',
    'THIOLIERES',
    'VALCIVIERES',
  ],
  63770: ['LES ANCIZES COMPS'],
  63340: [
    'ANTOINGT',
    'AUGNAT',
    'BOUDES',
    'LE BREUIL SUR COUZE',
    'CHALUS',
    'CHARBONNIER LES MINES',
    'COLLANGES',
    'DAUZAT SUR VODABLE',
    'GIGNAT',
    'MADRIAT',
    'MAREUGHEOL',
    'MORIAT',
    'NONETTE ORSONNETTE',
    'ST GERMAIN LEMBRON',
    'ST GERVAZY',
    'ST HERENT',
    'TERNANT LES EAUX',
    'VICHEL',
    'VILLENEUVE',
  ],
  63420: [
    'ANZAT LE LUGUET',
    'APCHAT',
    'ARDES',
    'LA CHAPELLE MARCOUSSE',
    'MAZOIRES',
    'RENTIERES',
    'ROCHE CHARLES LA MAYRAND',
    'ST ALYRE ES MONTAGNE',
  ],
  63250: ['ARCONSAT', 'CELLES SUR DUROLLE', 'CHABRELOCHE', 'VISCOMTAT'],
  63220: [
    'ARLANC',
    'BEURIERES',
    'CHAUMONT LE BOURG',
    'DORANGES',
    'DORE L EGLISE',
    'MAYRES',
    'MEDEYROLLES',
    'NOVACELLES',
    'ST ALYRE D ARLANC',
    'ST SAUVEUR LA SAGNE',
  ],
  63700: [
    'ARS LES FAVETS',
    'BUXIERES SOUS MONTAIGUT',
    'LA CROUZILLE',
    'DURMIGNAT',
    'LAPEYROUSE',
    'MONTAIGUT EN COMBRAILLE',
    'MOUREUILLE',
    'ST ELOY LES MINES',
    'YOUX',
  ],
  63460: [
    'ARTONNE',
    'BEAUREGARD VENDON',
    'COMBRONDE',
    'JOZERAND',
    'MONTCEL',
    'ST MYON',
    'TEILHEDE',
  ],
  63170: ['AUBIERE', 'PERIGNAT LES SARLIEVE'],
  63120: [
    'AUBUSSON D AUVERGNE',
    'COURPIERE',
    'NERONDE SUR DORE',
    'STE AGATHE',
    'SAUVIAT',
    'SERMENTIZON',
    'VOLLORE MONTAGNE',
    'VOLLORE VILLE',
  ],
  63930: ['AUGEROLLES', 'LA RENAUDIE'],
  63510: ['AULNAT', 'MALINTRAT'],
  63210: [
    'AURIERES',
    'CEYSSAT',
    'HEUME L EGLISE',
    'NEBOUZAT',
    'OLBY',
    'ORCIVAL',
    'PERPEZAT',
    'ROCHEFORT MONTAGNE',
    'ST BONNET PRES ORCIVAL',
    'ST PIERRE ROCHE',
    'VERNINES',
  ],
  63114: ['AUTHEZAT', 'COUDES', 'MONTPEYROUX'],
  63570: [
    'AUZAT LA COMBELLE',
    'BANSAT',
    'BEAULIEU',
    'BRASSAC LES MINES',
    'ESTEIL',
    'JUMEAUX',
    'LAMONTGIE',
    'ST JEAN ST GERVAIS',
    'ST MARTIN DES PLAINS',
  ],
  63590: ['AUZELLES', 'LA CHAPELLE AGNON', 'CUNLHAT', 'TOURS SUR MEYMONT'],
  63690: ['AVEZE', 'LABESSETTE', 'LARODDE', 'SINGLES', 'TAUVES'],
  63390: [
    'AYAT SUR SIOULE',
    'CHATEAUNEUF LES BAINS',
    'ESPINASSE',
    'GOUTTIERES',
    'STE CHRISTINE',
    'ST GERVAIS D AUVERGNE',
    'ST JULIEN LA GENESTE',
    'SAURET BESSERVE',
  ],
  63970: ['AYDAT', 'SAULZET LE FROID'],
  63810: ['BAGNOLS', 'CROS', 'TREMOUILLE ST LOUP'],
  63310: [
    'BAS ET LEZAT',
    'BEAUMONT LES RANDAN',
    'MONS',
    'RANDAN',
    'ST ANDRE LE COQ',
    'ST CLEMENT DE REGNAT',
    'ST DENIS COMBARNAZAT',
    'ST PRIEST BRAMEFANT',
    'ST SYLVESTRE PRAGOULIN',
    'VILLENEUVE LES CERFS',
  ],
  63110: ['BEAUMONT'],
  63116: ['BEAUREGARD L EVEQUE'],
  63500: [
    'BERGONNE',
    'BRENAT',
    'LE BROC',
    'AULHAT FLAT',
    'ISSOIRE',
    'ORBEIL',
    'PARDINES',
    'PARENTIGNAT',
    'PERRIER',
    'LES PRADEAUX',
    'ST BABEL',
    'ST REMY DE CHARGNAT',
    'ST YVOINE',
    'SAUVAGNAT STE MARTHE',
    'SOLIGNAT',
    'VARENNES SUR USSON',
    'VODABLE',
  ],
  63480: ['BERTIGNAT', 'MARAT', 'ST PIERRE LA BOURLHONNE', 'VERTOLAYE'],
  63610: ['BESSE ET ST ANASTAISE', 'COMPAINS', 'ST PIERRE COLAMINE', 'VALBELEIX'],
  63160: [
    'BILLOM',
    'BONGHEAT',
    'CHAS',
    'EGLISENEUVE PRES BILLOM',
    'ESPIRAT',
    'FAYET LE CHATEAU',
    'GLAINE MONTAIGUT',
    'MAUZUN',
    'MONTMORIN',
    'NEUVILLE',
    'REIGNAT',
    'ST JULIEN DE COPPEL',
  ],
  63640: ['BIOLLET', 'CHARENSAT', 'ST PRIEST DES CHAMPS'],
  63112: ['BLANZAT'],
  63440: [
    'BLOT L EGLISE',
    'CHAMPS',
    'LISSEUIL',
    'MARCILLAT',
    'POUZOL',
    'ST GAL SUR SIOULE',
    'ST HILAIRE LA CROIX',
    'ST PARDOUX',
    'ST QUINTIN SUR SIOULE',
    'ST REMY DE BLOT',
  ],
  63190: [
    'BORT L ETANG',
    'LEMPTY',
    'LEZOUX',
    'MOISSAT',
    'ORLEAT',
    'RAVEL',
    'ST JEAN D HEURS',
    'SEYCHALLES',
  ],
  63150: ['LA BOURBOULE', 'MURAT LE QUAIRE'],
  63760: ['BOURG LASTIC', 'LASTIC', 'ST SULPICE'],
  63910: ['BOUZEL', 'VASSEL', 'VERTAIZON'],
  63820: ['BRIFFONS', 'LAQUEUILLE', 'ST JULIEN PUY LAVEZE'],
  63230: [
    'BROMONT LAMOTHE',
    'CHAPDES BEAUFORT',
    'LA GOUTELLE',
    'MAZAYE',
    'MONTFERMY',
    'PONTGIBAUD',
    'PULVERIERES',
    'ST JACQUES D AMBUR',
    'ST OURS',
    'ST PIERRE LE CHASTEL',
  ],
  63490: [
    'BROUSSE',
    'CONDAT LES MONTBOISSIER',
    'EGLISENEUVE DES LIARDS',
    'ST JEAN EN VAL',
    'ST QUENTIN SUR SAUXILLANGES',
    'SAUXILLANGES',
    'SUGERES',
    'USSON',
  ],
  63880: ['LE BRUGERON', 'OLLIERGUES', 'OLMET', 'ST GERVAIS SOUS MEYMONT'],
  63350: [
    'BULHON',
    'CREVANT LAVEINE',
    'CULHAT',
    'JOZE',
    'LUZILLAT',
    'MARINGUES',
    'ST LAURE',
    'VINZELLES',
  ],
  63270: [
    'BUSSEOL',
    'ISSERTEAUX',
    'LAPS',
    'MANGLIEU',
    'PARENT',
    'PIGNOLS',
    'ST MAURICE',
    'SALLEDES',
    'VIC LE COMTE',
    'YRONDE ET BURON',
  ],
  63330: [
    'BUSSIERES',
    'LA CELLETTE',
    'CHATEAU SUR CHER',
    'PIONSAT',
    'LE QUARTIER',
    'ROCHE D AGOUX',
    'ST HILAIRE',
    'ST MAIGNER',
    'ST MAURICE PRES PIONSAT',
    'VERGHEAS',
    'VIRLET',
  ],
  63118: ['CEBAZAT'],
  63620: ['LA CELLE', 'FERNOEL', 'GIAT', 'VOINGT'],
  63520: [
    'CEILLOUX',
    'DOMAIZE',
    'ESTANDEUIL',
    'ST DIER D AUVERGNE',
    'ST FLOUR L ETANG',
    'ST JEAN DES OLLIERES',
    'TREZIOUX',
  ],
  63670: ['LE CENDRE', 'ORCET', 'LA ROCHE BLANCHE'],
  63122: ['CEYRAT', 'ST GENES CHAMPANELLE'],
  63320: [
    'CHADELEUF',
    'CHAMPEIX',
    'CHASSAGNE',
    'CHIDRAC',
    'CLEMENSAT',
    'COURGOUL',
    'GRANDEYROLLES',
    'LUDESSE',
    'MEILHAUD',
    'MONTAIGUT LE BLANC',
    'NESCHERS',
    'ST CIRGUES SUR COUZE',
    'ST DIERY',
    'ST FLORET',
    'ST VINCENT',
    'SAURIER',
    'TOURZEL RONZIERES',
    'VERRIERES',
  ],
  63400: ['CHAMALIERES'],
  63790: ['CHAMBON SUR LAC', 'MUROL', 'ST VICTOR LA RIVIERE'],
  63580: [
    'CHAMPAGNAT LE JEUNE',
    'LA CHAPELLE SUR USSON',
    'PESLIERES',
    'STE CATHERINE',
    'ST ETIENNE SUR USSON',
    'ST GENES LA TOURETTE',
    'ST MARTIN D OLLIERES',
    'VALZ SOUS CHATEAUNEUF',
    'LE VERNET CHAMEANE',
  ],
  63530: ['CHANAT LA MOUTEYRE', 'ENVAL', 'SAYAT', 'VOLVIC'],
  63450: [
    'CHANONAT',
    'COURNOLS',
    'LE CREST',
    'OLLOIX',
    'ST AMANT TALLENDE',
    'ST SANDOUX',
    'ST SATURNIN',
    'TALLENDE',
  ],
  63720: [
    'CHAPPES',
    'CHAVAROUX',
    'CLERLANDE',
    'ENNEZAT',
    'ENTRAIGUES',
    'MARTRES SUR MORGE',
    'ST IGNAT',
    'SURAT',
    'VARENNES SUR MORGE',
  ],
  63410: [
    'CHARBONNIERES LES VARENNES',
    'CHARBONNIERES LES VIEILLES',
    'LOUBEYRAT',
    'MANZAT',
    'ST ANGEL',
    'VITRAC',
  ],
  63290: [
    'CHARNAT',
    'CHATELDON',
    'LACHAUX',
    'LIMONS',
    'NOALHAT',
    'PASLIERES',
    'PUY GUILLAUME',
    'RIS',
  ],
  63680: ['CHASTREIX', 'LA TOUR D AUVERGNE', 'ST DONAT'],
  63119: ['CHATEAUGAY'],
  63140: ['CHATEL GUYON'],
  63660: ['LA CHAULME', 'ST ANTHEME', 'ST CLEMENT DE VALORGUE', 'ST ROMAIN'],
  63117: ['CHAURIAT'],
  63200: [
    'LE CHEIX',
    'DAVAYAT',
    'GIMEAUX',
    'MALAUZAT',
    'MARSAT',
    'MENETROL',
    'CHAMBARON SUR MORGE',
    'MOZAC',
    'PESSAT VILLENEUVE',
    'PROMPSAT',
    'RIOM',
    'ST BONNET PRES RIOM',
    'YSSAC LA TOURETTE',
  ],
  63740: ['CISTERNES LA FORET', 'GELLES'],
  63000: ['CLERMONT FERRAND'],
  63100: ['CLERMONT FERRAND'],
  63380: [
    'COMBRAILLES',
    'CONDAT EN COMBRAILLE',
    'LANDOGNE',
    'MIREMONT',
    'MONTEL DE GELAT',
    'PONTAUMUR',
    'ST AVIT',
    'ST ETIENNE DES CHAMPS',
    'ST HILAIRE LES MONGES',
    'TRALAIGUES',
    'VILLOSSANGES',
  ],
  63730: ['CORENT', 'LES MARTRES DE VEYRE', 'MIREFLEURS', 'PLAUZAT', 'LA SAUVETAT'],
  63800: [
    'COURNON D AUVERGNE',
    'PERIGNAT SUR ALLIER',
    'LA ROCHE NOIRE',
    'ST BONNET LES ALLIER',
    'ST GEORGES SUR ALLIER',
  ],
  63300: ['DORAT', 'ESCOUTOUX', 'THIERS'],
  63830: ['DURTOL', 'NOHANENT'],
  63850: ['EGLISENEUVE D ENTRAIGUES', 'ESPINCHAL', 'LA GODIVELLE', 'ST GENES CHAMPESPE'],
  63840: ['EGLISOLLES', 'SAILLANT', 'SAUVESSANGES', 'VIVEROLS'],
  63630: ['FAYET RONAYE', 'ST BONNET LE BOURG', 'ST BONNET LE CHASTEL', 'ST GERMAIN L HERM'],
  63360: ['GERZAT', 'LUSSAT', 'ST BEAUZIRE'],
  63890: ['GRANDVAL', 'LE MONESTIER', 'ST AMANT ROCHE SAVINE', 'ST ELOY LA GLACIERE'],
  63470: [
    'HERMENT',
    'PRONDINES',
    'PUY ST GULMIER',
    'ST GERMAIN PRES HERMENT',
    'SAUVAGNAT',
    'TORTEBESSE',
    'VERNEUGHEOL',
  ],
  63990: ['JOB'],
  63370: ['LEMPDES'],
  63940: ['MARSAC EN LIVRADOIS'],
  63430: ['LES MARTRES D ARTIERE', 'PONT DU CHATEAU'],
  63560: ['MENAT', 'NEUF EGLISE', 'SERVANT', 'TEILHET'],
  63750: ['MESSEIX', 'SAVENNES'],
  63111: ['MUR SUR ALLIER'],
  63115: ['MUR SUR ALLIER'],
  63650: ['LA MONNERIE LE MONTEL'],
  63240: ['MONT DORE'],
  63870: ['ORCINES'],
  63550: ['PALLADUC', 'ST REMY SUR DUROLLE', 'ST VICTOR MONTVIANEIX'],
  63920: ['PESCHADOIRES'],
  63113: ['PICHERANDE'],
  63780: ['QUEUILLE', 'ST GEORGES DE MONS'],
  63540: ['ROMAGNAT'],
  63130: ['ROYAT'],
  63710: ['ST NECTAIRE', 'LE VERNET STE MARGUERITE'],
  63950: ['ST SAUVES D AUVERGNE'],
  63960: ['VEYRE MONTON'],
  64460: [
    'AAST',
    'BALEIX',
    'BEDEILLE',
    'BENTAYOU SEREE',
    'CASTEIDE DOAT',
    'CASTERA LOUBIX',
    'LABATUT FIGUIERES',
    'LAMAYOU',
    'MAURE',
    'MONSEGUR',
    'MONTANER',
    'PONSON DEBAT POUTS',
    'PONSON DESSUS',
    'PONTIACQ VIELLEPINTE',
  ],
  64160: [
    'ABERE',
    'ANOS',
    'BARINQUE',
    'BERNADETS',
    'BUROS',
    'CARRERE',
    'COSLEDAA LUBE BOAST',
    'ESCOUBES',
    'ESPECHEDE',
    'GABASTON',
    'GERDEREST',
    'HIGUERES SOUYE',
    'LESPOURCY',
    'LOMBIA',
    'LUSSAGNET LUSSON',
    'MAUCOR',
    'MONASSUT AUDIRACQ',
    'MORLAAS',
    'OUILLON',
    'RIUPEYROUS',
    'ST ARMOU',
    'ST CASTIN',
    'ST JAMMES',
    'ST LAURENT BRETAGNE',
    'SEDZE MAUBECQ',
    'SEDZERE',
    'SERRES MORLAAS',
    'SEVIGNACQ',
    'UROST',
  ],
  64150: [
    'ABIDOS',
    'BESINGRAND',
    'LAGOR',
    'LAHOURCADE',
    'MOURENX',
    'NOGUERES',
    'OS MARSILLON',
    'PARDIES',
    'SAUVELADE',
    'VIELLESEGURE',
  ],
  64390: [
    'ABITAIN',
    'ANDREIN',
    'ATHOS ASPIS',
    'AUTEVIELLE ST MARTIN BIDEREN',
    'BARRAUTE CAMU',
    'BURGARONNE',
    'ESPIUTE',
    'GUINARTHE PARENTIES',
    'LAAS',
    'ORAAS',
    'ORION',
    'ORRIULE',
    'OSSERAIN RIVAREYTE',
    'ST GLADIE ARRIVE MUNEIN',
    'SAUVETERRE DE BEARN',
  ],
  64360: [
    'ABOS',
    'CARDESSE',
    'CUQUERON',
    'LACOMMANDE',
    'LUCQ DE BEARN',
    'MONEIN',
    'PARBAYSE',
    'TARSACQ',
  ],
  64490: [
    'ACCOUS',
    'AYDIUS',
    'BEDOUS',
    'BORCE',
    'CETTE EYGUN',
    'ESCOT',
    'ETSAUT',
    'LEES ATHAS',
    'LESCUN',
    'OSSE EN ASPE',
    'SARRANCE',
    'URDOS',
  ],
  64400: [
    'AGNOS',
    'AREN',
    'BIDOS',
    'ESQUIULE',
    'ESTOS',
    'EYSUS',
    'GERONCE',
    'GEUS D OLORON',
    'GOES',
    'GURMENCON',
    'LEDEUIX',
    'MOUMOUR',
    'OLORON STE MARIE',
    'ORIN',
    'POEY D OLORON',
    'PRECILHON',
    'ST GOIN',
    'SAUCEDE',
    'VERDETS',
  ],
  64220: [
    'AHAXE ALCIETTE BASCASSAN',
    'AINCILLE',
    'AINHICE MONGELOS',
    'ANHAUX',
    'ARNEGUY',
    'ASCARAT',
    'BEHORLEGUY',
    'BUSSUNARITS SARRASQUETTE',
    'BUSTINCE IRIBERRY',
    'CARO',
    'ESTERENCUBY',
    'GAMARTHE',
    'IROULEGUY',
    'ISPOURE',
    'JAXU',
    'LACARRE',
    'LASSE',
    'LECUMBERRY',
    'MENDIVE',
    'ST JEAN LE VIEUX',
    'ST JEAN PIED DE PORT',
    'ST MICHEL',
    'UHART CIZE',
  ],
  64210: ['AHETZE', 'ARBONNE', 'BIDART', 'GUETHARY'],
  64120: [
    'AICIRITS CAMOU SUHAST',
    'AMENDEUIX ONEIX',
    'AMOROTS SUCCOS',
    'ARBERATS SILLEGUE',
    'ARBOUET SUSSAUTE',
    'ARHANSUS',
    'AROUE ITHOROTS OLHAIBY',
    'ARRAUTE CHARRITTE',
    'BEGUIOS',
    'BEHASQUE LAPISTE',
    'BEYRIE SUR JOYEUSE',
    'BUNUS',
    'DOMEZAIN BERRAUTE',
    'ETCHARRY',
    'GABAT',
    'GARRIS',
    'HOSTA',
    'IBARROLLE',
    'ILHARRE',
    'JUXUE',
    'LABETS BISCAY',
    'LARCEVEAU ARROS CIBITS',
    'LARRIBAR SORHAPURU',
    'LOHITZUN OYHERCQ',
    'LUXE SUMBERRAUTE',
    'MASPARRAUTE',
    'MEHARIN',
    'OREGUE',
    'ORSANCO',
    'OSTABAT ASME',
    'PAGOLLE',
    'ST JUST IBARRE',
    'ST PALAIS',
    'UHART MIXE',
  ],
  64130: [
    'AINHARP',
    'ARRAST LARREBIEU',
    'AUSSURUCQ',
    'BARCUS',
    'BERROGAIN LARUNS',
    'CHARRITTE DE BAS',
    'CHERAUTE',
    'ESPES UNDUREIN',
    'GARINDEIN',
    'GOTEIN LIBARRENX',
    'L HOPITAL ST BLAISE',
    'IDAUX MENDY',
    'LICHOS',
    'MAULEON LICHARRE',
    'MENDITTE',
    'MONCAYOLLE LARRORY MENDIBIEU',
    'MUSCULDY',
    'ORDIARP',
    'ROQUIAGUE',
    'VIODOS ABENSE DE BAS',
  ],
  64250: ['AINHOA', 'CAMBO LES BAINS', 'ESPELETTE', 'ITXASSOU', 'LOUHOSSOA', 'SOURAIDE'],
  64470: [
    'ALCAY ALCABEHETY SUNHARETTE',
    'ALOS SIBAS ABENSE',
    'CAMOU CIHIGUE',
    'ETCHEBAR',
    'HAUX',
    'LACARRY ARHAN CHARRITTE DE HAUT',
    'LAGUINGE RESTOUE',
    'LICHANS SUNHAR',
    'MONTORY',
    'OSSAS SUHARE',
    'SAUGUIS ST ETIENNE',
    'TARDETS SORHOLUS',
    'TROIS VILLES',
  ],
  64430: ['ALDUDES', 'BANCA', 'ST ETIENNE DE BAIGORRY', 'UREPEL'],
  64420: [
    'ANDOINS',
    'ARRIEN',
    'ARTIGUELOUTAN',
    'ESLOURENTIES DABAN',
    'ESPOEY',
    'GOMER',
    'HOURS',
    'LIMENDOUS',
    'LOURENTIES',
    'LUCGARIER',
    'NOUSTY',
    'SAUBOLE',
    'SOUMOULOU',
  ],
  64510: ['ANGAIS', 'ASSAT', 'BALIROS', 'BOEIL BEZING', 'BORDES', 'MEILLON', 'NARCASTET'],
  64600: ['ANGLET'],
  64190: [
    'ANGOUS',
    'ARAUJUZON',
    'ARAUX',
    'AUDAUX',
    'BASTANES',
    'BUGNEIN',
    'CASTETBON',
    'CASTETNAU CAMBLONG',
    'CHARRE',
    'DOGNEN',
    'GESTAS',
    'GURS',
    'JASSES',
    'LAY LAMIDOU',
    'MERITEIN',
    'MONTFORT',
    'NABAS',
    'NARP',
    'NAVARRENX',
    'OGENNE CAMPTORT',
    'OSSENX',
    'PRECHACQ JOSBAIG',
    'PRECHACQ NAVARRENX',
    'RIVEHAUTE',
    'SUS',
    'SUSMIOU',
    'TABAILLE USQUAIN',
    'VIELLENAVE DE NAVARRENX',
  ],
  64350: [
    'ANOYE',
    'ARRICAU BORDES',
    'ARROSES',
    'AURIONS IDERNES',
    'BASSILLON VAUZE',
    'BETRACQ',
    'CASTILLON DE LEMBEYE',
    'CORBERE ABERES',
    'CROUSEILLES',
    'ESCURES',
    'GAYON',
    'LALONGUE',
    'LANNECAUBE',
    'LASSERRE',
    'LEMBEYE',
    'LESPIELLE',
    'LUC ARMAU',
    'LUCARRE',
    'MASPIE LALONQUERE JUILLACQ',
    'MOMY',
    'MONCAUP',
    'MONPEZAT',
    'PEYRELONGUE ABOS',
    'SAMSONS LION',
    'SEMEACQ BLACHON',
    'SIMACOURBE',
  ],
  64570: ['ARAMITS', 'ARETTE', 'ANCE FEAS', 'ISSOR', 'LANNE EN BARETOUS', 'LOURDIOS ICHERE'],
  64270: [
    'ARANCOU',
    'AUTERRIVE',
    'BELLOCQ',
    'BERGOUEY VIELLENAVE',
    'CARRESSE CASSABER',
    'CASTAGNEDE',
    'ESCOS',
    'L HOPITAL D ORION',
    'LABASTIDE VILLEFRANCHE',
    'LAHONTAN',
    'LEREN',
    'PUYOO',
    'RAMOUS',
    'ST DOS',
    'ST PE DE LEREN',
    'SALIES DE BEARN',
  ],
  64230: [
    'ARBUS',
    'ARTIGUELOUVE',
    'AUBIN',
    'AUSSEVIELLE',
    'BEYRIE EN BEARN',
    'BOUGARBER',
    'CAUBIOS LOOS',
    'DENGUIN',
    'LESCAR',
    'MAZEROLLES',
    'MOMAS',
    'POEY DE LESCAR',
    'SAUVAGNON',
    'SIROS',
    'UZEIN',
  ],
  64200: ['ARCANGUES', 'BASSUSSARRY', 'BIARRITZ'],
  64320: ['ARESSY', 'BIZANOS', 'IDRON', 'LEE', 'OUSSE', 'SENDETS'],
  64300: [
    'ARGAGNON',
    'BAIGTS DE BEARN',
    'BALANSUN',
    'BERENX',
    'BIRON',
    'BONNUT',
    'CASTETIS',
    'CASTETNER',
    'LAA MONDRANS',
    'LABEYRIE',
    'LACADEE',
    'LANNEPLAA',
    'LOUBIENG',
    'MASLACQ',
    'MONT',
    'ORTHEZ',
    'OZENX MONTESTRUCQ',
    'ST BOES',
    'ST GIRONS EN BEARN',
    'SALLES MONGISCARD',
    'SALLESPISSE',
    'SARPOURENX',
    'SAULT DE NAVAILLES',
  ],
  64450: [
    'ARGELOS',
    'ASTIS',
    'AUGA',
    'AURIAC',
    'BOURNOS',
    'DOUMY',
    'GARLEDE MONDEBAT',
    'LALONQUETTE',
    'LASCLAVERIES',
    'LEME',
    'MIOSSENS LANUSSE',
    'NAVAILLES ANGOS',
    'THEZE',
    'VIVEN',
  ],
  64410: [
    'ARGET',
    'ARZACQ ARRAZIGUET',
    'BOUILLON',
    'CABIDOS',
    'COUBLUCQ',
    'FICHOUS RIUMAYOU',
    'GAROS',
    'LARREULE',
    'LONCON',
    'LOUVIGNY',
    'MALAUSSANNE',
    'MERACQ',
    'MIALOS',
    'MONTAGUT',
    'PIETS PLASENCE MOUSTROU',
    'POULIACQ',
    'POURSIUGUES BOUCOUE',
    'SEBY',
    'VIGNES',
  ],
  64640: ['ARMENDARITS', 'HELETTE', 'IHOLDY', 'LANTABAT', 'ST ESTEBEN', 'ST MARTIN D ARBEROUE'],
  64370: [
    'ARNOS',
    'ARTHEZ DE BEARN',
    'BOUMOURT',
    'CASTEIDE CANDAU',
    'CASTILLON D ARTHEZ',
    'DOAZON',
    'GEUS D ARZACQ',
    'HAGETAUBIN',
    'MESPLEDE',
    'MORLANNE',
    'POMPS',
    'ST MEDARD',
    'UZAN',
  ],
  64800: [
    'ARROS DE NAY',
    'ARTHEZ D ASSON',
    'ASSON',
    'BAUDREIX',
    'BENEJACQ',
    'BEUSTE',
    'BORDERES',
    'BOURDETTES',
    'BRUGES CAPBIS MIFAGET',
    'COARRAZE',
    'HAUT DE BOSDARROS',
    'IGON',
    'LAGOS',
    'LESTELLE BETHARRAM',
    'MIREPEIX',
    'MONTAUT',
    'NAY',
    'PARDIES PIETAT',
    'ST ABIT',
    'ST VINCENT',
  ],
  64170: [
    'ARTIX',
    'CASTEIDE CAMI',
    'CESCAU',
    'LABASTIDE CEZERACQ',
    'LABASTIDE MONREJEAU',
    'LACQ',
    'SERRES STE MARIE',
    'VIELLENAVE D ARTHEZ',
  ],
  64260: [
    'ARUDY',
    'ASTE BEON',
    'BESCAT',
    'BIELLE',
    'BILHERES',
    'BUZY',
    'CASTET',
    'GERE BELESTEN',
    'IZESTE',
    'LOUVIE JUZON',
    'LYS',
    'REBENACQ',
    'STE COLOME',
    'SEVIGNACQ MEYRACQ',
  ],
  64660: ['ASASP ARROS', 'LURBE ST CHRISTAU'],
  64310: ['ASCAIN', 'ST PEE SUR NIVELLE', 'SARE'],
  64290: ['AUBERTIN', 'BOSDARROS', 'ESTIALESCQ', 'GAN', 'LASSEUBE', 'LASSEUBETAT'],
  64330: [
    'AUBOUS',
    'AYDIE',
    'BALIRACQ MAUMUSSON',
    'BOUEILH BOUEILHO LASQUE',
    'BUROSSE MENDOUSSE',
    'CADILLON',
    'CASTETPUGON',
    'CLARACQ',
    'CONCHEZ DE BEARN',
    'DIUSSE',
    'GARLIN',
    'MASCARAAS HARON',
    'MONCLA',
    'MONT DISSE',
    'MOUHOUS',
    'PORTET',
    'RIBARROUY',
    'ST JEAN POUDGE',
    'TADOUSSE USSAU',
    'TARON SADIRAC VIELLENAVE',
    'VIALER',
  ],
  64240: [
    'AYHERRE',
    'BONLOC',
    'BRISCOUS',
    'HASPARREN',
    'ISTURITS',
    'LA BASTIDE CLAIRENCE',
    'MACAYE',
    'MENDIONDE',
    'URT',
  ],
  64520: ['BARDOS', 'BIDACHE', 'CAME', 'GUICHE', 'SAMES'],
  64530: ['BARZUN', 'GER', 'LABATMALE', 'LIVRON', 'PONTACQ'],
  64100: ['BAYONNE'],
  64440: ['BEOST', 'EAUX BONNES', 'LARUNS', 'LOUVIE SOUBIRON'],
  64780: ['BIDARRAY', 'IRISSARRY', 'OSSES', 'ST MARTIN D ARROSSA', 'SUHESCUN'],
  64140: ['BILLERE', 'LONS'],
  64700: ['BIRIATOU', 'HENDAYE', 'URRUGNE'],
  64340: ['BOUCAU'],
  64680: ['BUZIET', 'HERRERE', 'OGEU LES BAINS'],
  64500: ['CIBOURE', 'ST JEAN DE LUZ'],
  64870: ['ESCOU', 'ESCOUT'],
  64110: ['GELOS', 'JURANCON', 'LAROIN', 'MAZERES LEZONS', 'RONTIGNON', 'ST FAUST', 'UZOS'],
  64480: ['HALSOU', 'JATXOU', 'LARRESSORE', 'USTARITZ'],
  64990: ['LAHONCE', 'MOUGUERRE', 'ST PIERRE D IRUBE', 'URCUIT', 'VILLEFRANQUE'],
  64560: ['LARRAU', 'LICQ ATHEREY', 'STE ENGRACE'],
  64121: ['MONTARDON', 'SERRES CASTET'],
  64000: ['PAU'],
  64122: ['URRUGNE'],
  65260: ['ADAST', 'PIERREFITTE NESTALAS', 'SOULOM', 'VILLELONGUE'],
  65100: [
    'ADE',
    'LES ANGLES',
    'ARCIZAC EZ ANGLES',
    'ARRODETS EZ ANGLES',
    'ARTIGUES',
    'ASPIN EN LAVEDAN',
    'BARLEST',
    'BARTRES',
    'BERBERUST LIAS',
    'BOURREAC',
    'CHEUST',
    'ESCOUBES POUTS',
    'GAZOST',
    'GER',
    'GEU',
    'GEZ EZ ANGLES',
    'JARRET',
    'JULOS',
    'JUNCALAS',
    'ARRAYOU LAHITTE',
    'LEZIGNAN',
    'LOUBAJAC',
    'LOURDES',
    'LUGAGNAN',
    'OMEX',
    'OSSEN',
    'OSSUN EZ ANGLES',
    'OURDIS COTDOUSSAN',
    'OURDON',
    'OUSTE',
    'PAREAC',
    'POUEYFERRE',
    'ST CREAC',
    'SEGUS',
    'SERE LANSO',
    'VIGER',
  ],
  65240: [
    'ADERVIELLE POUCHERGUES',
    'ARDENGOST',
    'ARREAU',
    'ASPIN AURE',
    'AULON',
    'AVAJAN',
    'BAREILLES',
    'BARRANCOUEU',
    'CADEAC',
    'CAZAUX FRECHET ANERAN CAMORS',
    'ESTARVIELLE',
    'FRECHET AURE',
    'GENOS',
    'GERM',
    'GOUAUX',
    'GREZIAN',
    'GUCHEN',
    'JEZEAU',
    'LANCON',
    'LOUDENVIELLE',
    'LOUDERVIELLE',
    'MONT',
    'PAILHAC',
    'VIELLE LOURON',
  ],
  65400: [
    'AGOS VIDALOS',
    'ARCIZANS AVANT',
    'ARCIZANS DESSUS',
    'ARGELES GAZOST',
    'ARRAS EN LAVEDAN',
    'ARRENS MARSOUS',
    'ARTALENS SOUIN',
    'AUCUN',
    'AYROS ARBOUIX',
    'AYZAC OST',
    'BEAUCENS',
    'BOO SILHEN',
    'BUN',
    'ESTAING',
    'GAILLAGOS',
    'GEZ',
    'LAU BALAGNAS',
    'OUZOUS',
    'PRECHAC',
    'ST PASTOUS',
    'ST SAVIN',
    'SALLES',
    'SERE EN LAVEDAN',
    'SIREIX',
    'UZ',
    'VIER BORDES',
  ],
  65360: [
    'ALLIER',
    'ARCIZAC ADOUR',
    'BARBAZAN DESSUS',
    'BERNAC DEBAT',
    'BERNAC DESSUS',
    'MOMERES',
    'ST MARTIN',
    'SALLES ADOUR',
    'VIELLE ADOUR',
  ],
  65440: ['ANCIZAN'],
  65390: ['ANDREST', 'AURENSAN', 'SARNIGUET'],
  65150: [
    'ANERES',
    'BIZE',
    'BIZOUS',
    'GENEREST',
    'HAUTAGET',
    'LOMBRES',
    'MAZERES DE NESTE',
    'MONTEGUT',
    'MONTSERIE',
    'NESTIER',
    'NISTOS',
    'ST LAURENT DE NESTE',
    'ST PAUL',
    'SEICH',
    'TIBIRAN JAUNAC',
    'TUZAGUET',
    'CANTAOUS',
  ],
  65690: ['ANGOS', 'BARBAZAN DEBAT', 'MONTIGNAC'],
  65370: [
    'ANLA',
    'ANTICHAN',
    'AVEUX',
    'BERTREN',
    'BRAMEVAQUE',
    'CAZARILH',
    'CRECHETS',
    'ESBAREICH',
    'FERRERE',
    'GAUDENT',
    'GEMBRIE',
    'ILHEU',
    'IZAOURT',
    'LOURES BAROUSSE',
    'MAULEON BAROUSSE',
    'OURDE',
    'SACOUE',
    'STE MARIE',
    'SALECHAN',
    'SAMURAN',
    'SARP',
    'SIRADAN',
    'SOST',
    'THEBE',
    'TROUBAT',
  ],
  65140: [
    'ANSOST',
    'BARBACHEN',
    'BAZILLAC',
    'BOUILH DEVANT',
    'BUZON',
    'ESCONDEAUX',
    'GENSAC',
    'LACASSAGNE',
    'LAMEAC',
    'LESCURRY',
    'LIAC',
    'MANSAN',
    'MINGOT',
    'MONFAUCON',
    'MOUMOULOUS',
    'PEYRUN',
    'RABASTENS DE BIGORRE',
    'ST SEVER DE RUSTAN',
    'SARRIAC BIGORRE',
    'SEGALAS',
    'SENAC',
    'TOSTAT',
    'TROULEY LABARTHE',
    'UGNOUAS',
  ],
  65220: [
    'ANTIN',
    'BERNADETS DEBAT',
    'BONNEFONT',
    'BUGARD',
    'ESTAMPURES',
    'FONTRAILLES',
    'FRECHEDE',
    'LALANNE TRIE',
    'LAMARQUE RUSTAING',
    'LAPEYRE',
    'LUBRET ST LUC',
    'LUBY BETMONT',
    'LUSTAR',
    'MAZEROLLES',
    'PUYDARRIEUX',
    'SADOURNIN',
    'SERE RUSTAING',
    'TOURNOUS DARRE',
    'TRIE SUR BAISE',
    'VIDOU',
    'VILLEMBITS',
  ],
  65200: [
    'ANTIST',
    'ARGELES BAGNERES',
    'ASTE',
    'ASTUGUE',
    'BAGNERES DE BIGORRE',
    'BANIOS',
    'CIEUTAT',
    'GERDE',
    'GERMS SUR L OUSSOUET',
    'HAUBAN',
    'HIIS',
    'LABASSERE',
    'LIES',
    'LOUCRUP',
    'MARSAS',
    'MERILHEU',
    'MONTGAILLARD',
    'NEUILH',
    'ORDIZAN',
    'ORIGNAC',
    'POUZAC',
    'TREBONS',
    'UZER',
    'VISKER',
  ],
  65170: [
    'ARAGNOUET',
    'AZET',
    'BAZUS AURE',
    'BOURISP',
    'CADEILHAN TRACHERE',
    'CAMPARAN',
    'ENS',
    'ESTENSAN',
    'GRAILHEN',
    'GUCHAN',
    'SAILHAN',
    'ST LARY SOULAN',
    'TRAMEZAIGUES',
    'VIELLE AURE',
    'VIGNEC',
  ],
  65560: ['ARBEOST', 'FERRIERES'],
  65230: [
    'ARIES ESPENAN',
    'BARTHE',
    'BETBEZE',
    'BETPOUY',
    'CAMPUZAN',
    'CASTELNAU MAGNOAC',
    'CASTERETS',
    'CAUBOUS',
    'CIZOS',
    'DEVEZE',
    'GUIZERIX',
    'HACHAN',
    'LALANNE',
    'LARROQUE',
    'ORGAN',
    'PEYRET ST ANDRE',
    'POUY',
    'PUNTOUS',
    'SARIAC MAGNOAC',
    'THERMES MAGNOAC',
    'VIEUZOS',
    'VILLEMUR',
  ],
  65670: ['ARNE', 'BAZORDAN', 'GAUSSAN', 'LARAN', 'LASSALES', 'MONLEON MAGNOAC', 'MONLONG'],
  65130: [
    'ARRODETS',
    'ARTIGUEMY',
    'ASQUE',
    'AVEZAC PRAT LAHITTE',
    'BATSERE',
    'BENQUE MOLERE',
    'BETTES',
    'BONNEMAZON',
    'BOURG DE BIGORRE',
    'BULAN',
    'CAPVERN',
    'CASTILLON',
    'CHELLE SPOU',
    'ESCONNETS',
    'ESCOTS',
    'ESPARROS',
    'ESPECHE',
    'ESPIEILH',
    'FRECHENDETS',
    'GOURGUE',
    'LABASTIDE',
    'LABORDE',
    'LOMNE',
    'MAUVEZIN',
    'PERE',
    'SARLABOUS',
    'TILHOUSE',
  ],
  65500: [
    'ARTAGNAN',
    'CAIXON',
    'CAMALES',
    'ESCAUNETS',
    'MARSAC',
    'NOUILHAN',
    'PUJO',
    'ST LEZER',
    'SANOUS',
    'SIARROUY',
    'TALAZAC',
    'VIC EN BIGORRE',
    'VILLENAVE PRES BEARN',
    'VILLENAVE PRES MARSAC',
  ],
  65350: [
    'AUBAREDE',
    'BOUILH PEREUILH',
    'BOULIN',
    'CABANAC',
    'CASTELVIEILH',
    'CASTERA LOU',
    'CHELLE DEBAT',
    'COLLONGUES',
    'COUSSAN',
    'DOURS',
    'GONEZ',
    'HOURC',
    'JACQUE',
    'LANSAC',
    'LASLADES',
    'LIZOS',
    'LOUIT',
    'MARQUERIE',
    'MARSEILLAN',
    'MUN',
    'OLEAC DEBAT',
    'OSMETS',
    'PEYRIGUERE',
    'POUYASTRUC',
    'SABALOS',
    'SOREAC',
    'SOUYEAUX',
    'THUY',
  ],
  65800: ['AUREILHAN', 'CHIS', 'ORLEIX'],
  65700: [
    'AURIEBAT',
    'CASTELNAU RIVIERE BASSE',
    'CAUSSADE RIVIERE',
    'ESTIRAC',
    'HAGEDET',
    'HERES',
    'LABATUT RIVIERE',
    'LAFITOLE',
    'LAHITTE TOUPIERE',
    'LARREULE',
    'LASCAZERES',
    'MADIRAN',
    'MAUBOURGUET',
    'ST LANNE',
    'SAUVETERRE',
    'SOMBRUN',
    'SOUBLECAUSE',
    'VIDOUZE',
    'VILLEFRANQUE',
  ],
  65660: ['AVENTIGNAN'],
  65380: [
    'AVERAN',
    'AZEREIX',
    'BARRY',
    'BENAC',
    'HIBARETTE',
    'LAMARQUE PONTACQ',
    'LANNE',
    'LAYRISSE',
    'ORINCLES',
    'OSSUN',
  ],
  65710: ['BAGNERES DE BIGORRE', 'BEAUDEAN', 'CAMPAN'],
  65250: [
    'LA BARTHE DE NESTE',
    'BAZUS NESTE',
    'ESCALA',
    'GAZAVE',
    'HECHES',
    'IZAUX',
    'LORTET',
    'MAZOUAU',
    'MONTOUSSE',
    'ST ARROMAN',
  ],
  65460: ['BAZET', 'BOURS'],
  65190: [
    'BEGOLE',
    'BERNADETS DESSUS',
    'BORDES',
    'BURG',
    'CAHARET',
    'CALAVANTE',
    'CASTERA LANUSSE',
    'CLARAC',
    'FRECHOU FRECHET',
    'GOUDON',
    'HITTE',
    'LANESPEDE',
    'LESPOUEY',
    'LHEZ',
    'LUC',
    'MASCARAS',
    'MOULEDOUS',
    'OLEAC DESSUS',
    'ORIEUX',
    'OUEILLOUX',
    'OZON',
    'PEYRAUBE',
    'POUMAROUS',
    'RICAUD',
    'SINZOS',
    'TOURNAY',
  ],
  65120: [
    'BETPOUEY',
    'CHEZE',
    'ESQUIEZE SERE',
    'ESTERRE',
    'GAVARNIE GEDRE',
    'GRUST',
    'LUZ ST SAUVEUR',
    'SALIGOS',
    'SASSIS',
    'SAZOS',
    'SERS',
    'VIELLA',
    'VIEY',
    'VISCOS',
    'BAREGES',
  ],
  65410: ['BEYREDE JUMET CAMOUS', 'ILHET', 'SARRANCOLIN'],
  65330: [
    'BONREPOS',
    'CASTELBAJAC',
    'GALAN',
    'GALEZ',
    'HOUEYDETS',
    'LIBAROS',
    'MONTASTRUC',
    'RECURT',
    'SABARROS',
    'SENTOUS',
    'TOURNOUS DEVANT',
  ],
  65590: ['BORDERES LOURON', 'CAZAUX DEBAT', 'RIS'],
  65320: [
    'BORDERES SUR L ECHEZ',
    'GARDERES',
    'GAYAN',
    'LAGARDE',
    'LUQUET',
    'OROIX',
    'PINTAC',
    'SERON',
    'TARASTEIX',
  ],
  65300: [
    'CAMPISTROUS',
    'CLARENS',
    'LAGRANGE',
    'LANNEMEZAN',
    'LUTILHOUS',
    'PINAS',
    'REJAUMONT',
    'TAJAN',
    'UGLAS',
  ],
  65110: ['CAUTERETS'],
  65310: ['HORGUES', 'LALOUBERE', 'ODOS'],
  65420: ['IBOS'],
  65290: ['JUILLAN', 'LOUEY'],
  65510: ['LOUDENVIELLE'],
  65490: ['OURSBELILLE'],
  65270: ['PEYROUSE', 'ST PE DE BIGORRE'],
  65600: ['SARROUILLES', 'SEMEAC'],
  65430: ['SOUES'],
  65000: ['TARBES'],
  66480: ['L ALBERE', 'LES CLUSES', 'MAUREILLAS LAS ILLAS', 'LE PERTHUS'],
  66200: ['ALENYA', 'CORNEILLA DEL VERCOL', 'ELNE', 'LATOUR BAS ELNE', 'MONTESCOT', 'THEZA'],
  66110: ['AMELIE LES BAINS PALALDA', 'LA BASTIDE', 'MONTBOLO', 'ST MARSAL', 'TAULIS'],
  66210: [
    'LES ANGLES',
    'BOLQUERE',
    'LA CABANASSE',
    'FONTRABIOUSE',
    'FORMIGUERES',
    'LA LLAGONNE',
    'MATEMALE',
    'MONT LOUIS',
    'PLANES',
    'PUYVALADOR',
    'REAL',
    'ST PIERRE DELS FORCATS',
    'SAUTO',
  ],
  66760: [
    'ANGOUSTRINE VILLENEUVE DES ESCALDES',
    'BOURG MADAME',
    'DORRES',
    'ENVEITG',
    'LATOUR DE CAROL',
    'PORTA',
    'PORTE PUYMORENS',
    'UR',
  ],
  66220: [
    'ANSIGNAN',
    'CAUDIES DE FENOUILLEDES',
    'FENOUILLET',
    'FOSSE',
    'LESQUERDE',
    'PRUGNANES',
    'ST ARNAC',
    'ST MARTIN DE FENOUILLET',
    'ST PAUL DE FENOUILLET',
    'TRILLA',
    'VIRA',
  ],
  66320: [
    'ARBOUSSOLS',
    'BAILLESTAVY',
    'ESPIRA DE CONFLENT',
    'ESTOHER',
    'FINESTRET',
    'GLORIANES',
    'JOCH',
    'MARQUIXANES',
    'RIGARDA',
    'RODES',
    'TARERACH',
    'VALMANYA',
    'VINCA',
  ],
  66700: ['ARGELES SUR MER'],
  66150: ['ARLES SUR TECH', 'CORSAVY', 'MONTFERRER'],
  66360: [
    'AYGUATEBIA TALAU',
    'CANAVEILLES',
    'CAUDIES DE CONFLENT',
    'ESCARO',
    'FONTPEDROUSE',
    'JUJOLS',
    'MANTET',
    'NYER',
    'OLETTE',
    'OREILLA',
    'PY',
    'RAILLEU',
    'SAHORRE',
    'SANSA',
    'SERDINYA',
    'SOUANYAS',
    'THUES ENTRE VALLS',
  ],
  66670: ['BAGES'],
  66540: ['BAHO'],
  66390: ['BAIXAS'],
  66300: [
    'BANYULS DELS ASPRES',
    'CAIXAS',
    'CAMELAS',
    'CASTELNOU',
    'FOURQUES',
    'LLAURO',
    'LLUPIA',
    'MONTAURIOL',
    'PASSA',
    'PONTEILLA',
    'STE COLOMBE DE LA COMMANDERIE',
    'ST JEAN LASSEILLE',
    'TERRATS',
    'THUIR',
    'TORDERES',
    'TRESSERRE',
    'TROUILLAS',
    'VILLEMOLAQUE',
  ],
  66650: ['BANYULS SUR MER'],
  66420: ['LE BARCARES'],
  66720: [
    'BELESTA',
    'CARAMANY',
    'CASSAGNES',
    'LANSAC',
    'LATOUR DE FRANCE',
    'MONTNER',
    'PLANEZES',
    'RASIGUERES',
    'TAUTAVEL',
  ],
  66430: ['BOMPAS'],
  66130: [
    'BOULE D AMONT',
    'BOULETERNERE',
    'CASEFABRE',
    'CORBERE',
    'CORBERE LES CABANES',
    'ILLE SUR TET',
    'MONTALBA LE CHATEAU',
    'PRUNET ET BELPUIG',
    'ST MICHEL DE LLOTES',
    'TREVILLACH',
  ],
  66160: ['LE BOULOU'],
  66620: ['BROUILLA'],
  66330: ['CABESTANY'],
  66600: [
    'CALCE',
    'CASES DE PENE',
    'ESPIRA DE L AGLY',
    'OPOUL PERILLOS',
    'PEYRESTORTES',
    'RIVESALTES',
    'SALSES LE CHATEAU',
    'VINGRAU',
  ],
  66400: ['CALMEILLES', 'CERET', 'OMS', 'REYNES', 'TAILLET'],
  66500: [
    'CAMPOME',
    'CATLLAR',
    'CLARA VILLERACH',
    'CODALET',
    'CONAT',
    'EUS',
    'LOS MASOS',
    'MOLITG LES BAINS',
    'MOSSET',
    'NOHEDES',
    'PRADES',
    'RIA SIRACH',
    'TAURINYA',
    'URBANYA',
    'VILLEFRANCHE DE CONFLENT',
  ],
  66730: [
    'CAMPOUSSY',
    'FEILLUNS',
    'PEZILLA DE CONFLENT',
    'PRATS DE SOURNIA',
    'RABOUILLET',
    'SOURNIA',
    'LE VIVIER',
  ],
  66140: ['CANET EN ROUSSILLON'],
  66680: ['CANOHES'],
  66820: ['CASTEIL', 'CORNEILLA DE CONFLENT', 'FILLOLS', 'FUILLA', 'VERNET LES BAINS'],
  66290: ['CERBERE'],
  66530: ['CLAIRA'],
  66190: ['COLLIOURE'],
  66550: ['CORNEILLA LA RIVIERE'],
  66260: ['COUSTOUGES', 'ST LAURENT DE CERDANS'],
  66120: ['EGAT', 'FONT ROMEU ODEILLO VIA', 'TARGASONNE'],
  66800: ['ERR', 'ESTAVAR', 'EYNE', 'LLO', 'SAILLAGOUSE', 'STE LEOCADIE'],
  66310: ['ESTAGEL'],
  66230: ['LAMANERE', 'PRATS DE MOLLO LA PRESTE', 'SERRALONGUE', 'LE TECH'],
  66740: [
    'LAROQUE DES ALBERES',
    'MONTESQUIEU DES ALBERES',
    'ST GENIS DES FONTAINES',
    'VILLELONGUE DELS MONTS',
  ],
  66460: ['MAURY'],
  66170: ['MILLAS', 'NEFIACH', 'ST FELIU D AMONT', 'ST FELIU D AVALL'],
  66340: ['NAHUJA', 'OSSEJA', 'PALAU DE CERDAGNE', 'VALCEBOLLERE'],
  66560: ['ORTAFFA'],
  66690: ['PALAU DEL VIDRE', 'ST ANDRE', 'SOREDE'],
  66000: ['PERPIGNAN'],
  66100: ['PERPIGNAN'],
  66370: ['PEZILLA LA RIVIERE'],
  66380: ['PIA'],
  66450: ['POLLESTRES'],
  66660: ['PORT VENDRES'],
  66750: ['ST CYPRIEN'],
  66240: ['ST ESTEVE'],
  66510: ['ST HIPPOLYTE'],
  66490: ['ST JEAN PLA DE CORTS', 'VIVES'],
  66250: ['ST LAURENT DE LA SALANQUE'],
  66470: ['STE MARIE LA MER'],
  66570: ['ST NAZAIRE'],
  66280: ['SALEILLES'],
  66270: ['LE SOLER'],
  66440: ['TORREILLES'],
  66350: ['TOULOUGES'],
  66410: ['VILLELONGUE DE LA SALANQUE'],
  66180: ['VILLENEUVE DE LA RAHO'],
  66610: ['VILLENEUVE LA RIVIERE'],
  67204: ['ACHENHEIM'],
  67320: [
    'ADAMSWILLER',
    'ASSWILLER',
    'BAERENDORF',
    'BERG',
    'BETTWILLER',
    'BUST',
    'DRULINGEN',
    'DURSTEL',
    'ESCHBOURG',
    'ESCHWILLER',
    'EYWILLER',
    'GOERLINGEN',
    'GUNGWILLER',
    'HIRSCHLAND',
    'KIRRBERG',
    'OTTWILLER',
    'PFALZWEYER',
    'RAUWILLER',
    'REXINGEN',
    'SCHOENBOURG',
    'SIEWILLER',
    'THAL DRULINGEN',
    'WEYER',
  ],
  67220: [
    'ALBE',
    'BASSEMBERG',
    'BREITENAU',
    'BREITENBACH',
    'DIEFFENBACH AU VAL',
    'FOUCHY',
    'LALAYE',
    'MAISONSGOUTTE',
    'NEUBOIS',
    'NEUVE EGLISE',
    'ST MARTIN',
    'ST MAURICE',
    'ST PIERRE BOIS',
    'STEIGE',
    'THANVILLE',
    'TRIEMBACH AU VAL',
    'URBEIS',
    'VILLE',
  ],
  67310: [
    'SOMMERAU',
    'BALBRONN',
    'BERGBIETEN',
    'COSSWILLER',
    'CRASTATT',
    'DAHLENHEIM',
    'DANGOLSHEIM',
    'FLEXBOURG',
    'HOHENGOEFT',
    'KNOERSHEIM',
    'RANGEN',
    'ROMANSWILLER',
    'SCHARRACHBERGHEIM IRMSTETT',
    'TRAENHEIM',
    'WASSELONNE',
    'WESTHOFFEN',
    'ZEHNACKER',
    'ZEINHEIM',
  ],
  67440: [
    'SOMMERAU',
    'DIMBSTHAL',
    'HENGWILLER',
    'JETTERSWILLER',
    'KLEINGOEFT',
    'LOCHWILLER',
    'MARMOUTIER',
    'REINHARDSMUNSTER',
    'REUTENBOURG',
    'SCHWENHEIM',
    'THAL MARMOUTIER',
    'WESTHOUSE MARMOUTIER',
  ],
  67270: [
    'ALTECKENDORF',
    'BOSSENDORF',
    'DUNTZENHEIM',
    'DURNINGEN',
    'GEISWILLER ZOEBERSDORF',
    'GOUGENHEIM',
    'HOCHFELDEN',
    'HOHFRANKENHEIM',
    'HUTTENDORF',
    'INGENHEIM',
    'KIENHEIM',
    'LIXHAUSEN',
    'MELSHEIM',
    'MINVERSHEIM',
    'MUTZENHOUSE',
    'ROHR',
    'SAESSOLSHEIM',
    'SCHERLENHEIM',
    'SCHWINDRATZHEIM',
    'WICKERSHEIM WILSHAUSEN',
    'WILWISHEIM',
    'WINGERSHEIM LES QUATRE BANS',
  ],
  67490: [
    'ALTENHEIM',
    'DETTWILLER',
    'FRIEDOLSHEIM',
    'GOTTESHEIM',
    'LITTENHEIM',
    'LUPSTEIN',
    'PRINTZHEIM',
  ],
  67120: [
    'ALTORF',
    'AVOLSHEIM',
    'DACHSTEIN',
    'DORLISHEIM',
    'DUPPIGHEIM',
    'DUTTLENHEIM',
    'ERGERSHEIM',
    'ERNOLSHEIM BRUCHE',
    'KOLBSHEIM',
    'MOLSHEIM',
    'SOULTZ LES BAINS',
    'WOLXHEIM',
  ],
  67260: [
    'ALTWILLER',
    'BISSERT',
    'BURBACH',
    'DIEDENDORF',
    'HARSKIRCHEN',
    'HERBITZHEIM',
    'HINSINGEN',
    'KESKASTEL',
    'RIMSDORF',
    'SARRE UNION',
    'SARREWERDEN',
    'SCHOPPERTEN',
    'SILTZHEIM',
    'WOLFSKIRCHEN',
  ],
  67140: [
    'ANDLAU',
    'BARR',
    'BERNARDVILLE',
    'BOURGHEIM',
    'EICHHOFFEN',
    'GERTWILLER',
    'HEILIGENSTEIN',
    'LE HOHWALD',
    'ITTERSWILLER',
    'MITTELBERGHEIM',
    'REICHSFELD',
    'ST PIERRE',
    'STOTZHEIM',
    'ZELLWILLER',
  ],
  67390: [
    'ARTOLSHEIM',
    'BOESENBIESEN',
    'BOOTZHEIM',
    'ELSENHEIM',
    'HEIDOLSHEIM',
    'HESSENHEIM',
    'MACKENHEIM',
    'MARCKOLSHEIM',
    'OHNENHEIM',
    'RICHTOLSHEIM',
    'SAASENHEIM',
    'SCHOENAU',
    'SCHWOBSHEIM',
  ],
  67250: [
    'ASCHBACH',
    'HOFFEN',
    'HUNSPACH',
    'INGOLSHEIM',
    'KEFFENACH',
    'KUTZENHAUSEN',
    'LAMPERTSLOCH',
    'LOBSANN',
    'MEMMELSHOFFEN',
    'MERKWILLER PECHELBRONN',
    'OBERROEDERN',
    'PREUSCHDORF',
    'RETSCHWILLER',
    'SCHOENENBOURG',
    'SOULTZ SOUS FORETS',
    'STUNDWILLER',
    'SURBOURG',
  ],
  67600: [
    'BALDENHEIM',
    'BINDERNHEIM',
    'EBERSHEIM',
    'EBERSMUNSTER',
    'HILSENHEIM',
    'KINTZHEIM',
    'MUSSIG',
    'MUTTERSHOLTZ',
    'ORSCHWILLER',
    'SELESTAT',
  ],
  67130: [
    'BAREMBACH',
    'BELLEFOSSE',
    'BELMONT',
    'BLANCHERUPT',
    'LA BROQUE',
    'FOUDAY',
    'GRANDFONTAINE',
    'LUTZELHOUSE',
    'MUHLBACH SUR BRUCHE',
    'NATZWILLER',
    'NEUVILLER LA ROCHE',
    'RUSS',
    'SCHIRMECK',
    'SOLBACH',
    'WALDERSBACH',
    'WILDERSBACH',
    'WISCHES',
  ],
  67500: ['BATZENDORF', 'HAGUENAU', 'NIEDERSCHAEFFOLSHEIM', 'WEITBRUCH'],
  67930: ['BEINHEIM', 'KESSELDORF'],
  67230: [
    'BENFELD',
    'DIEBOLSHEIM',
    'HERBSHEIM',
    'HUTTENHEIM',
    'KERTZFELD',
    'KOGENHEIM',
    'OBENHEIM',
    'ROSSFELD',
    'SAND',
    'SERMERSHEIM',
    'WESTHOUSE',
    'WITTERNHEIM',
  ],
  67210: ['BERNARDSWILLER', 'GOXWILLER', 'MEISTRATZHEIM', 'NIEDERNAI', 'OBERNAI', 'VALFF'],
  67170: [
    'BERNOLSHEIM',
    'BERSTHEIM',
    'BILWISHEIM',
    'BRUMATH',
    'DONNENHEIM',
    'GEUDERTHEIM',
    'HOCHSTETT',
    'KRAUTWILLER',
    'KRIEGSHEIM',
    'MITTELSCHAEFFOLSHEIM',
    'OHLUNGEN',
    'OLWISHEIM',
    'ROTTELSHEIM',
    'WAHLENHEIM',
    'WINGERSHEIM LES QUATRE BANS',
  ],
  67370: [
    'BERSTETT',
    'DINGSHEIM',
    'GRIESHEIM SUR SOUFFEL',
    'NEUGARTHEIM ITTLENHEIM',
    'PFULGRIESHEIM',
    'SCHNERSHEIM',
    'STUTZHEIM OFFENHEIM',
    'TRUCHTERSHEIM',
    'WILLGOTTHEIM',
    'WINTZENHEIM KOCHERSBERG',
    'WIWERSHEIM',
  ],
  67360: [
    'BIBLISHEIM',
    'DIEFFENBACH LES WOERTH',
    'DURRENBACH',
    'ESCHBACH',
    'FROESCHWILLER',
    'GOERSDORF',
    'GUNSTETT',
    'HEGENEY',
    'LANGENSOULTZBACH',
    'MORSBRONN LES BAINS',
    'OBERDORF SPACHBACH',
    'WALBOURG',
    'WOERTH',
  ],
  67720: ['BIETLENHEIM', 'HOERDT', 'WEYERSHEIM'],
  67800: ['BISCHHEIM', 'HOENHEIM'],
  67340: [
    'BISCHHOLTZ',
    'INGWILLER',
    'LICHTENBERG',
    'MENCHHOFFEN',
    'OFFWILLER',
    'REIPERTSWILLER',
    'ROTHBACH',
    'SCHILLERSDORF',
    'SPARSBACH',
    'WEINBOURG',
    'WEITERSWILLER',
  ],
  67870: ['BISCHOFFSHEIM', 'GRIESHEIM PRES MOLSHEIM'],
  67240: [
    'BISCHWILLER',
    'GRIES',
    'KALTENHOUSE',
    'KURTZENHOUSE',
    'OBERHOFFEN SUR MODER',
    'SCHIRRHEIN',
    'SCHIRRHOFFEN',
  ],
  67350: [
    'BITSCHHOFFEN',
    'BUSWILLER',
    'DAUENDORF',
    'ENGWILLER',
    'ETTENDORF',
    'GRASSENDORF',
    'KINDWILLER',
    'MORSCHWILLER',
    'MULHAUSEN',
    'NIEDERMODERN',
    'VAL DE MODER',
    'RINGENDORF',
    'SCHALKENDORF',
    'UHLWILLER',
    'UHRWILLER',
  ],
  67113: ['BLAESHEIM'],
  67650: ['BLIENSCHWILLER', 'DAMBACH LA VILLE', 'DIEFFENTHAL'],
  67530: ['BOERSCH', 'OTTROTT', 'ST NABOR'],
  67150: [
    'BOLSENHEIM',
    'DAUBENSAND',
    'ERSTEIN',
    'GERSTHEIM',
    'HINDISHEIM',
    'HIPSHEIM',
    'LIMERSHEIM',
    'MATZENHEIM',
    'NORDHOUSE',
    'OSTHOUSE',
    'SCHAEFFERSHEIM',
    'UTTENHEIM',
  ],
  67860: ['BOOFZHEIM', 'FRIESENHEIM', 'RHINAU'],
  67330: [
    'BOSSELSHAUSEN',
    'BOUXWILLER',
    'DOSSENHEIM SUR ZINSEL',
    'ERNOLSHEIM LES SAVERNE',
    'HATTMATT',
    'ISSENHAUSEN',
    'KIRRWILLER',
    'NEUWILLER LES SAVERNE',
    'NIEDERSOULTZBACH',
    'OBERMODERN ZUTZENDORF',
    'OBERSOULTZBACH',
    'UTTWILLER',
  ],
  67420: [
    'BOURG BRUCHE',
    'COLROY LA ROCHE',
    'PLAINE',
    'RANRUPT',
    'SAALES',
    'ST BLAISE LA ROCHE',
    'SAULXURES',
  ],
  67112: ['BREUSCHWICKERSHEIM'],
  67570: ['LA BROQUE', 'ROTHAU'],
  67470: [
    'BUHL',
    'CROETTWILLER',
    'EBERBACH SELTZ',
    'MOTHERN',
    'MUNCHHAUSEN',
    'NIEDERROEDERN',
    'SCHAFFHOUSE PRES SELTZ',
    'SELTZ',
    'TRIMBACH',
    'WINTZENBACH',
  ],
  67430: [
    'BUTTEN',
    'DEHLINGEN',
    'DIEMERINGEN',
    'DOMFESSEL',
    'LORENTZEN',
    'MACKWILLER',
    'RATZWILLER',
    'VOELLERDINGEN',
    'WALDHAMBACH',
  ],
  67730: ['CHATENOIS', 'LA VANCELLE'],
  67160: [
    'CLEEBOURG',
    'DRACHENBRONN BIRLENBACH',
    'OBERHOFFEN LES WISSEMBOURG',
    'OBERLAUTERBACH',
    'SEEBACH',
    'RIEDSELTZ',
    'ROTT',
    'SALMBACH',
    'SCHLEITHAL',
    'SIEGEN',
    'STEINSELTZ',
    'WISSEMBOURG',
  ],
  67510: ['CLIMBACH', 'LEMBACH', 'NIEDERSTEINBACH', 'OBERSTEINBACH', 'WINGEN'],
  67770: ['DALHUNDEN', 'SESSENHEIM', 'STATTMATTEN'],
  67110: [
    'DAMBACH',
    'GUMBRECHTSHOFFEN',
    'GUNDERSHOFFEN',
    'NIEDERBRONN LES BAINS',
    'OBERBRONN',
    'REICHSHOFFEN',
    'UTTENHOFFEN',
    'WINDSTEIN',
    'ZINSWILLER',
  ],
  67190: [
    'DINSHEIM SUR BRUCHE',
    'GRENDELBRUCH',
    'GRESSWILLER',
    'HEILIGENBERG',
    'MOLLKIRCH',
    'MUTZIG',
    'STILL',
  ],
  67117: [
    'DOSSENHEIM KOCHERSBERG',
    'FESSENHEIM LE BAS',
    'FURDENHEIM',
    'HANDSCHUHEIM',
    'HURTIGHEIM',
    'ITTENHEIM',
    'QUATZENHEIM',
  ],
  67410: ['DRUSENHEIM', 'ROHRWILLER'],
  67700: [
    'ECKARTSWILLER',
    'FURCHHAUSEN',
    'GOTTENHOUSE',
    'HAEGEN',
    'LANDERSHEIM',
    'MAENNOLSHEIM',
    'MONSWILLER',
    'OTTERSTHAL',
    'OTTERSWILLER',
    'ST JEAN SAVERNE',
    'SAVERNE',
    'WALDOLWISHEIM',
    'WOLSCHHEIM',
  ],
  67201: ['ECKBOLSHEIM'],
  67550: ['ECKWERSHEIM', 'VENDENHEIM'],
  67710: ['WANGENBOURG ENGENTHAL'],
  67960: ['ENTZHEIM'],
  67680: ['EPFIG', 'NOTHALTEN'],
  67290: [
    'ERCKARTSWILLER',
    'FROHMUHL',
    'HINSBOURG',
    'LOHR',
    'PETERSBACH',
    'LA PETITE PIERRE',
    'PUBERG',
    'ROSTEIG',
    'STRUTH',
    'TIEFFENBACH',
    'VOLKSBERG',
    'WEISLINGEN',
    'WIMMENAU',
    'WINGEN SUR MODER',
    'ZITTERSHEIM',
  ],
  67114: ['ESCHAU'],
  67640: ['FEGERSHEIM', 'ICHTRATZHEIM', 'LIPSHEIM'],
  67480: [
    'FORSTFELD',
    'FORT LOUIS',
    'KAUFFENHEIM',
    'LEUTENHEIM',
    'NEUHAEUSEL',
    'ROESCHWOOG',
    'ROPPENHEIM',
    'ROUNTZENHEIM AUENHEIM',
  ],
  67580: ['FORSTHEIM', 'LAUBACH', 'MERTZWILLER', 'MIETESHEIM'],
  67760: ['GAMBSHEIM'],
  67118: ['GEISPOLSHEIM'],
  67980: ['HANGENBIETEN'],
  67690: ['HATTEN', 'RITTERSHOFFEN'],
  67850: ['HERRLISHEIM', 'OFFENDORF'],
  67810: ['HOLTZHEIM'],
  67400: ['ILLKIRCH GRAFFENSTADEN'],
  67880: ['INNENHEIM', 'KRAUTERGERSHEIM'],
  67840: ['KILSTETT'],
  67520: ['KIRCHHEIM', 'KUTTOLSHEIM', 'MARLENHEIM', 'NORDHEIM', 'ODRATZHEIM', 'WANGEN'],
  67450: ['LAMPERTHEIM', 'MUNDOLSHEIM'],
  67630: ['LAUTERBOURG', 'NEEWILLER PRES LAUTERBOURG', 'NIEDERLAUTERBACH', 'SCHEIBENHARD'],
  67380: ['LINGOLSHEIM'],
  67206: ['MITTELHAUSBERGEN'],
  67670: ['MOMMENHEIM', 'WALTENHEIM SUR ZORN', 'WITTERSHEIM'],
  67280: ['NIEDERHASLACH', 'OBERHASLACH', 'URMATT'],
  67207: ['NIEDERHAUSBERGEN'],
  67660: ['BETSCHDORF'],
  67205: ['OBERHAUSBERGEN'],
  67203: ['OBERSCHAEFFOLSHEIM'],
  67970: ['OERMINGEN'],
  67590: ['OHLUNGEN', 'SCHWEIGHOUSE SUR MODER', 'WINTERSHOUSE'],
  67990: ['OSTHOFFEN'],
  67540: ['OSTWALD'],
  67115: ['PLOBSHEIM'],
  67116: ['REICHSTETT'],
  67560: ['ROSENWILLER', 'ROSHEIM'],
  67750: ['SCHERWILLER'],
  67300: ['SCHILTIGHEIM'],
  67460: ['SOUFFELWEYERSHEIM'],
  67620: ['SOUFFLENHEIM'],
  67790: ['STEINBOURG'],
  67000: ['STRASBOURG'],
  67100: ['STRASBOURG'],
  67200: ['STRASBOURG'],
  67920: ['SUNDHOUSE'],
  67610: ['LA WANTZENAU'],
  67820: ['WITTISHEIM'],
  67202: ['WOLFISHEIM'],
  68600: [
    'ALGOLSHEIM',
    'BIESHEIM',
    'DESSENHEIM',
    'GEISWASSER',
    'HEITEREN',
    'HETTENSCHLAG',
    'NEUF BRISACH',
    'OBERSAASHEIM',
    'VOGELGRUN',
    'VOLGELSHEIM',
    'WECKOLSHEIM',
    'WOLFGANTZEN',
  ],
  68210: [
    'ALTENACH',
    'BERNWILLER',
    'BALLERSDORF',
    'BALSCHWILLER',
    'BELLEMAGNY',
    'BRECHAUMONT',
    'BUETHWILLER',
    'CHAVANNES SUR L ETANG',
    'DANNEMARIE',
    'ELBACH',
    'ETEIMBES',
    'FALKWILLER',
    'FULLEREN',
    'GILDWILLER',
    'GOMMERSDORF',
    'GUEVENATTEN',
    'HAGENBACH',
    'HECKEN',
    'VALDIEU LUTRAN',
    'MAGNY',
    'MANSPACH',
    'MERTZEN',
    'MONTREUX JEUNE',
    'MONTREUX VIEUX',
    'RETZWILLER',
    'ROMAGNY',
    'ST COSME',
    'ST ULRICH',
    'TRAUBACH LE BAS',
    'TRAUBACH LE HAUT',
    'WOLFERSDORF',
  ],
  68130: [
    'ALTKIRCH',
    'ASPACH',
    'BERENTZWILLER',
    'CARSPACH',
    'EMLINGEN',
    'FRANKEN',
    'HAUSGAUEN',
    'HEIWILLER',
    'HUNDSBACH',
    'JETTINGEN',
    'OBERMORSCHWILLER',
    'SCHWOBEN',
    'TAGSDORF',
    'WAHLBACH',
    'WALHEIM',
    'WITTERSDORF',
    'ZAESSINGUE',
  ],
  68410: ['AMMERSCHWIHR'],
  68770: ['AMMERSCHWIHR'],
  68280: ['ANDOLSHEIM', 'APPENWIHR', 'LOGELHEIM', 'SUNDHOFFEN'],
  68320: [
    'ARTZENHEIM',
    'BALTZENHEIM',
    'BISCHWIHR',
    'DURRENENTZEN',
    'FORTSCHWIHR',
    'GRUSSENHEIM',
    'PORTE DU RIED',
    'JEBSHEIM',
    'KUNHEIM',
    'MUNTZENHEIM',
    'URSCHENHEIM',
    'WICKERSCHWIHR',
    'WIDENSOLEN',
  ],
  68700: ['ASPACH LE BAS', 'ASPACH MICHELBACH', 'CERNAY', 'STEINBACH', 'UFFHOLTZ', 'WATTWILLER'],
  68220: [
    'ATTENSCHWILLER',
    'BUSCHWILLER',
    'FOLGENSBOURG',
    'HAGENTHAL LE BAS',
    'HAGENTHAL LE HAUT',
    'HEGENHEIM',
    'HESINGUE',
    'KNOERINGUE',
    'LEYMEN',
    'LIEBENSWILLER',
    'MICHELBACH LE HAUT',
    'NEUWILLER',
    'RANSPACH LE HAUT',
    'WENTZWILLER',
  ],
  68150: ['AUBURE', 'HUNAWIHR', 'OSTHEIM', 'RIBEAUVILLE'],
  68390: ['BALDERSHEIM', 'BATTENHEIM', 'SAUSHEIM'],
  68740: [
    'BALGAU',
    'BLODELSHEIM',
    'FESSENHEIM',
    'HIRTZFELDEN',
    'MUNCHHOUSE',
    'NAMBSHEIM',
    'ROGGENHOUSE',
    'RUSTENHART',
    'RUMERSHEIM LE HAUT',
  ],
  68490: ['BANTZENHEIM', 'CHALAMPE', 'HOMBOURG', 'OTTMARSHEIM', 'PETIT LANDAU'],
  68870: ['BARTENHEIM', 'BRINCKHEIM'],
  68980: ['BEBLENHEIM'],
  68480: [
    'BENDORF',
    'BETTLACH',
    'BIEDERTHAL',
    'BOUXWILLER',
    'COURTAVON',
    'DURLINSDORF',
    'DURMENACH',
    'FERRETTE',
    'FISLIS',
    'KIFFIS',
    'KOESTLACH',
    'LEVONCOURT',
    'LIEBSDORF',
    'LIGSDORF',
    'LINSDORF',
    'LUCELLE',
    'LUTTER',
    'MOERNACH',
    'OBERLARG',
    'OLTINGUE',
    'PFETTERHOUSE',
    'RAEDERSDORF',
    'ROPPENTZWILLER',
    'SONDERSDORF',
    'VIEUX FERRETTE',
    'WERENTZHOUSE',
    'WINKEL',
    'WOLSCHWILLER',
  ],
  68126: ['BENNWIHR'],
  68630: ['BENNWIHR', 'MITTELWIHR'],
  68750: ['BERGHEIM'],
  68500: [
    'BERGHOLTZ',
    'BERGHOLTZZELL',
    'BERRWILLER',
    'GUEBWILLER',
    'HARTMANNSWILLER',
    'ISSENHEIM',
    'JUNGHOLTZ',
    'MERXHEIM',
    'ORSCHWIHR',
    'RIMBACH PRES GUEBWILLER',
    'RIMBACHZELL',
    'WUENHEIM',
  ],
  68560: ['BETTENDORF', 'HEIMERSDORF', 'HIRSINGUE', 'RUEDERBACH'],
  68127: [
    'BILTZHEIM',
    'NIEDERENTZEN',
    'NIEDERHERGHEIM',
    'OBERENTZEN',
    'OBERHERGHEIM',
    'STE CROIX EN PLAINE',
  ],
  68580: [
    'BISEL',
    'FRIESEN',
    'HINDLINGEN',
    'LARGITZEN',
    'MOOSLARGUE',
    'SEPPOIS LE BAS',
    'SEPPOIS LE HAUT',
    'STRUETH',
    'UEBERSTRASS',
  ],
  68620: ['BITSCHWILLER LES THANN'],
  68730: ['BLOTZHEIM', 'MICHELBACH LE BAS', 'RANSPACH LE BAS'],
  68540: ['BOLLWILLER', 'FELDKIRCH'],
  68650: ['LE BONHOMME', 'LAPOUTROIE'],
  68290: [
    'BOURBACH LE BAS',
    'BOURBACH LE HAUT',
    'DOLLEREN',
    'KIRCHBERG',
    'LAUW',
    'MASEVAUX NIEDERBRUCK',
    'OBERBRUCK',
    'RIMBACH PRES MASEVAUX',
    'SEWEN',
    'SICKERT',
    'WEGSCHEID',
  ],
  68380: ['BREITENBACH HAUT RHIN', 'METZERAL', 'MITTLACH', 'MUHLBACH SUR MUNSTER', 'SONDERNACH'],
  68780: ['BRETTEN', 'DIEFMATTEN', 'LE HAUT SOULTZBACH', 'SENTHEIM', 'SOPPE LE BAS', 'STERNENBERG'],
  68440: [
    'BRUEBACH',
    'DIETWILLER',
    'ESCHENTZWILLER',
    'HABSHEIM',
    'LANDSER',
    'SCHLIERBACH',
    'STEINBRUNN LE BAS',
    'STEINBRUNN LE HAUT',
    'ZIMMERSHEIM',
  ],
  68350: ['BRUNSTATT DIDENHEIM'],
  68530: ['BUHL', 'MURBACH'],
  68520: ['BURNHAUPT LE BAS', 'BURNHAUPT LE HAUT', 'SCHWEIGHOUSE THANN'],
  68000: ['COLMAR'],
  68720: [
    'EGLINGEN',
    'ST BERNARD',
    'FLAXLANDEN',
    'FROENINGEN',
    'HEIDWILLER',
    'HOCHSTATT',
    'ILLFURTH',
    'LUEMSCHWILLER',
    'SPECHBACH',
    'TAGOLSHEIM',
    'ZILLISHEIM',
  ],
  68420: [
    'EGUISHEIM',
    'GUEBERSCHWIHR',
    'HATTSTATT',
    'HERRLISHEIM PRES COLMAR',
    'HUSSEREN LES CHATEAUX',
    'OBERMORSCHWIHR',
    'VOEGTLINSHOFFEN',
  ],
  68190: ['ENSISHEIM', 'RAEDERSHEIM', 'UNGERSHEIM'],
  68140: [
    'ESCHBACH AU VAL',
    'GRIESBACH AU VAL',
    'GUNSBACH',
    'HOHROD',
    'LUTTENBACH PRES MUNSTER',
    'MUNSTER',
    'SOULTZEREN',
    'STOSSWIHR',
  ],
  68640: ['FELDBACH', 'MUESPACH', 'MUESPACH LE HAUT', 'RIESPACH', 'STEINSOULTZ', 'WALDIGHOFEN'],
  68470: ['FELLERING', 'HUSSEREN WESSERLING', 'MITZACH', 'MOLLAU', 'RANSPACH', 'STORCKENSOHN'],
  68240: ['FRELAND', 'KAYSERSBERG VIGNOBLE'],
  68990: ['GALFINGUE', 'HEIMSBRUNN'],
  68690: ['GEISHOUSE', 'MOOSCH'],
  68510: [
    'GEISPITZEN',
    'HELFRANTZKIRCH',
    'KAPPELEN',
    'KOETZINGUE',
    'MAGSTATT LE BAS',
    'MAGSTATT LE HAUT',
    'RANTZWILLER',
    'SIERENTZ',
    'STETTEN',
    'UFFHEIM',
    'WALTENHEIM',
  ],
  68760: ['GOLDBACH ALTENBACH', 'WILLER SUR THUR'],
  68970: ['GUEMAR', 'ILLHAEUSERN'],
  68116: ['GUEWENHEIM'],
  68250: ['GUNDOLSHEIM', 'MUNWILLER', 'PFAFFENHEIM', 'ROUFFACH', 'WESTHALTEN'],
  68118: ['HIRTZBACH'],
  68180: ['HORBOURG WIHR'],
  68125: ['HOUSSEN'],
  68330: ['HUNINGUE'],
  68110: ['ILLZACH'],
  68040: ['INGERSHEIM'],
  68230: [
    'KATZENTHAL',
    'NIEDERMORSCHWIHR',
    'SOULTZBACH LES BAINS',
    'TURCKHEIM',
    'WALBACH',
    'WASSERBOURG',
    'WIHR AU VAL',
    'ZIMMERBACH',
  ],
  68680: ['KEMBS', 'NIFFER'],
  68260: ['KINGERSHEIM'],
  68820: ['KRUTH', 'WILDENSTEIN'],
  68910: ['LABAROCHE'],
  68610: ['LAUTENBACH', 'LAUTENBACHZELL', 'LINTHAL'],
  68800: ['LEIMBACH', 'RAMMERSMATT', 'RODEREN', 'THANN', 'VIEUX THANN'],
  68660: ['LIEPVRE', 'ROMBACH LE FRANC'],
  68460: ['LUTTERBACH'],
  68550: ['MALMERSPACH', 'ST AMARIN'],
  68890: ['MEYENHEIM', 'REGUISHEIM'],
  68790: ['MORSCHWILLER LE BAS'],
  68100: ['MULHOUSE'],
  68200: ['MULHOUSE'],
  68960: ['ILLTAL', 'WILLER'],
  68830: ['ODEREN'],
  68370: ['ORBEY'],
  68570: ['OSENBACH', 'SOULTZMATT'],
  68120: ['PFASTATT', 'RICHWILLER'],
  68840: ['PULVERSHEIM'],
  68950: ['REININGUE'],
  68400: ['RIEDISHEIM'],
  68340: ['RIQUEWIHR', 'ZELLENBERG'],
  68170: ['RIXHEIM'],
  68590: ['RODERN', 'RORSCHWIHR', 'ST HIPPOLYTE', 'THANNENKIRCH'],
  68128: ['ROSENAU', 'VILLAGE NEUF'],
  68270: ['RUELISHEIM', 'WITTENHEIM'],
  68160: ['STE CROIX AUX MINES', 'STE MARIE AUX MINES'],
  68300: ['ST LOUIS'],
  68360: ['SOULTZ HAUT RHIN'],
  68850: ['STAFFELFELDEN'],
  68121: ['URBES'],
  68920: ['WETTOLSHEIM', 'WINTZENHEIM'],
  68124: ['WINTZENHEIM'],
  68310: ['WITTELSHEIM'],
  69170: [
    'AFFOUX',
    'DIEME',
    'JOUX',
    'LES SAUVAGES',
    'ST APPOLINAIRE',
    'ST CLEMENT SUR VALSONNE',
    'ST MARCEL L ECLAIRE',
    'TARARE',
    'VALSONNE',
  ],
  69790: [
    'AIGUEPERSE',
    'AZOLETTE',
    'PROPIERES',
    'ST BONNET DES BRUYERES',
    'ST CLEMENT DE VERS',
    'ST IGNY DE VERS',
  ],
  69250: [
    'ALBIGNY SUR SAONE',
    'CURIS AU MONT D OR',
    'FLEURIEU SUR SAONE',
    'NEUVILLE SUR SAONE',
    'POLEYMIEUX AU MONT D OR',
    'MONTANAY',
  ],
  69380: [
    'ALIX',
    'BELMONT D AZERGUES',
    'CHARNAY',
    'CHASSELAY',
    'CHATILLON',
    'CHAZAY D AZERGUES',
    'LES CHERES',
    'CHESSY',
    'CIVRIEUX D AZERGUES',
    'DOMMARTIN',
    'LISSIEU',
    'LOZANNE',
    'MARCILLY D AZERGUES',
    'ST JEAN DES VIGNES',
  ],
  69480: ['AMBERIEUX', 'ANSE', 'LACHASSAGNE', 'LUCENAY', 'MARCY', 'MORANCE', 'POMMIERS'],
  69550: ['AMPLEPUIS', 'CUBLIZE', 'MEAUX LA MONTAGNE', 'RONNO', 'ST JEAN LA BUSSIERE'],
  69420: ['AMPUIS', 'CONDRIEU', 'LES HAIES', 'LONGES', 'TREVES', 'TUPIN ET SEMONS'],
  69490: ['ANCY', 'VINDRY SUR TURDINE', 'SARCEY', 'ST FORGEUX', 'ST ROMAIN DE POPEY'],
  69210: [
    'L ARBRESLE',
    'BULLY',
    'CHEVINAY',
    'EVEUX',
    'FLEURIEUX SUR L ARBRESLE',
    'LENTILLY',
    'SAIN BEL',
    'SAVIGNY',
    'SOURCIEUX LES MINES',
    'ST GERMAIN NUELLES',
    'ST PIERRE LA PALUD',
  ],
  69430: [
    'LES ARDILLATS',
    'BEAUJEU',
    'CHENELETTE',
    'LANTIGNIE',
    'MARCHAMPT',
    'DEUX GROSNES',
    'QUINCIE EN BEAUJOLAIS',
    'REGNIE DURETTE',
    'ST DIDIER SUR BEAUJEU',
    'VERNAY',
  ],
  69400: ['ARNAS', 'GLEIZE', 'LIMAS', 'PORTE DES PIERRES DOREES', 'VILLEFRANCHE SUR SAONE'],
  69610: [
    'AVEIZE',
    'GREZIEU LE MARCHE',
    'LES HALLES',
    'HAUTE RIVOIRE',
    'MEYS',
    'MONTROMANT',
    'SOUZY',
    'STE FOY L ARGENTIERE',
    'ST GENIS L ARGENTIERE',
  ],
  69620: [
    'BAGNOLS',
    'VAL D OINGT',
    'LE BREUIL',
    'CHAMELET',
    'FRONTENAS',
    'LEGNY',
    'LETRA',
    'MOIRE',
    'STE PAULE',
    'ST VERAND',
    'TERNAND',
    'THEIZE',
  ],
  69220: [
    'BELLEVILLE EN BEAUJOLAIS',
    'CERCIE',
    'CHARENTAY',
    'CORCELLES EN BEAUJOLAIS',
    'DRACE',
    'LANCIE',
    'ST LAGER',
    'TAPONAS',
  ],
  69690: ['BESSENAY', 'BIBOST', 'BRULLIOLES', 'BRUSSIEU', 'COURZIEU', 'ST JULIEN SUR BIBOST'],
  69460: [
    'BLACE',
    'ODENAS',
    'LE PERREON',
    'SALLES ARBUISSONNAS EN BEAUJOLAIS',
    'ST ETIENNE DES OULLIERES',
    'ST ETIENNE LA VARENNE',
    'VAUX EN BEAUJOLAIS',
  ],
  69530: ['BRIGNAIS', 'ORLIENAS'],
  69126: ['BRINDAS'],
  69500: ['BRON'],
  69270: [
    'CAILLOUX SUR FONTAINES',
    'COUZON AU MONT D OR',
    'FONTAINES ST MARTIN',
    'FONTAINES SUR SAONE',
    'ROCHETAILLEE SUR SAONE',
    'ST ROMAIN AU MONT D OR',
  ],
  69300: ['CALUIRE ET CUIRE'],
  69840: ['CENVES', 'CHENAS', 'EMERINGES', 'JULIENAS', 'JULLIE'],
  69870: [
    'CHAMBOST ALLIERES',
    'CLAVEISOLLES',
    'GRANDRIS',
    'LAMURE SUR AZERGUES',
    'POULE LES ECHARMEAUX',
    'ST BONNET LE TRONCY',
    'ST CYR LE CHATOUX',
    'ST JUST D AVRAY',
    'ST NIZIER D AZERGUES',
  ],
  69770: ['CHAMBOST LONGESSAIGNE', 'LONGESSAIGNE', 'MONTROTTIER', 'VILLECHENEVE'],
  69410: ['CHAMPAGNE AU MONT D OR'],
  69590: ['LA CHAPELLE SUR COISE', 'COISE', 'LARAJASSE', 'POMEYS', 'ST SYMPHORIEN SUR COISE'],
  69630: ['CHAPONOST'],
  69260: ['CHARBONNIERES LES BAINS'],
  69390: ['CHARLY', 'MILLERY', 'VERNAISON', 'VOURLES'],
  69440: [
    'CHAUSSAN',
    'MORNANT',
    'RIVERIE',
    'ST ANDRE LA COTE',
    'STE CATHERINE',
    'ST LAURENT D AGNY',
    'CHABANIERE',
    'TALUYERS',
  ],
  69115: ['CHIROUBLES'],
  69640: [
    'COGNY',
    'DENICE',
    'LACENAS',
    'MONTMELAS ST SORLIN',
    'PORTE DES PIERRES DOREES',
    'RIVOLET',
    'ST JULIEN',
    'VILLE SUR JARNIOUX',
  ],
  69660: ['COLLONGES AU MONT D OR'],
  69470: ['COURS', 'RANCHAL'],
  69290: ['CRAPONNE', 'GREZIEU LA VARENNE', 'POLLIONNAY', 'ST GENIS LES OLLIERES'],
  69570: ['DARDILLY'],
  69850: ['DUERNE', 'ST MARTIN EN HAUT'],
  69700: ['ECHALAS', 'GIVORS', 'LOIRE SUR RHONE', 'MONTAGNY', 'BEAUVALLON', 'ST ROMAIN EN GIER'],
  69130: ['ECULLY'],
  69820: ['FLEURIE', 'VAUXRENARD'],
  69340: ['FRANCHEVILLE'],
  69520: ['GRIGNY'],
  69540: ['IRIGNY'],
  69760: ['LIMONEST'],
  69280: ['MARCY L ETOILE', 'STE CONSORCE'],
  69510: ['MESSIMY', 'RONTALON', 'SOUCIEU EN JARREST', 'THURINS', 'YZERON'],
  69860: ['DEUX GROSNES'],
  69350: ['LA MULATIERE'],
  69310: ['OULLINS PIERRE BENITE'],
  69600: ['OULLINS PIERRE BENITE'],
  69650: ['QUINCIEUX', 'ST GERMAIN AU MONT D OR'],
  69930: ['ST CLEMENT LES PLACES', 'ST LAURENT DE CHAMOUSSET'],
  69560: ['STE COLOMBE', 'ST CYR SUR LE RHONE', 'ST ROMAIN EN GAL'],
  69450: ['ST CYR AU MONT D OR'],
  69370: ['ST DIDIER AU MONT D OR'],
  69190: ['ST FONS'],
  69110: ['STE FOY LES LYON'],
  69230: ['ST GENIS LAVAL'],
  69830: ['ST GEORGES DE RENEINS'],
  69240: ['ST VINCENT DE REINS', 'THIZY LES BOURGS'],
  69160: ['TASSIN LA DEMI LUNE'],
  69890: ['LA TOUR DE SALVAGNY'],
  69670: ['VAUGNERAY'],
  69120: ['VAULX EN VELIN'],
  69200: ['VENISSIEUX'],
  69100: ['VILLEURBANNE'],
  69910: ['VILLIE MORGON'],
  69970: ['CHAPONNAY', 'MARENNES'],
  69680: ['CHASSIEU'],
  69360: ['COMMUNAY', 'ST SYMPHORIEN D OZON', 'SEREZIN DU RHONE', 'SIMANDRES', 'SOLAIZE', 'TERNAY'],
  69960: ['CORBAS'],
  69150: ['DECINES CHARPIEU'],
  69320: ['FEYZIN'],
  69740: ['GENAS'],
  69730: ['GENAY'],
  69330: ['JONAGE', 'JONS', 'MEYZIEU', 'PUSIGNAN'],
  69780: ['MIONS', 'ST PIERRE DE CHANDIEU', 'TOUSSIEU'],
  69140: ['RILLIEUX LA PAPE'],
  69720: ['ST BONNET DE MURE', 'ST LAURENT DE MURE'],
  69800: ['ST PRIEST'],
  69580: ['SATHONAY CAMP', 'SATHONAY VILLAGE'],
  69124: ['COLOMBIER SAUGNIEU'],
  69125: ['COLOMBIER SAUGNIEU'],
  69001: ['LYON 01'],
  69002: ['LYON 02'],
  69003: ['LYON 03'],
  69004: ['LYON 04'],
  69005: ['LYON 05'],
  69006: ['LYON 06'],
  69007: ['LYON 07'],
  69008: ['LYON 08'],
  69009: ['LYON 09'],
  70300: [
    'ABELCOURT',
    'AILLONCOURT',
    'BAUDONCOURT',
    'BETONCOURT LES BROTTE',
    'BREUCHES',
    'BROTTE LES LUXEUIL',
    'LA CHAPELLE LES LUXEUIL',
    'CITERS',
    'LA CORBIERE',
    'EHUNS',
    'ESBOZ BREST',
    'FOUGEROLLES ST VALBERT',
    'FROIDECONCHE',
    'LUXEUIL LES BAINS',
    'MAGNIVRAY',
    'MEURCOURT',
    'ORMOICHE',
    'STE MARIE EN CHAUX',
    'ST SAUVEUR',
    'VELORCEY',
    'VILLERS LES LUXEUIL',
    'VISONCOURT',
  ],
  70500: [
    'ABONCOURT GESINCOURT',
    'AISEY ET RICHECOURT',
    'AUGICOURT',
    'BARGES',
    'BETAUCOURT',
    'BETONCOURT SUR MANCE',
    'BLONDEFONTAINE',
    'BOUGEY',
    'BOURBEVELLE',
    'BOUSSERAUCOURT',
    'BUFFIGNECOURT',
    'CEMBOING',
    'CENDRECOURT',
    'CHAUVIREY LE CHATEL',
    'CHAUVIREY LE VIEIL',
    'CORRE',
    'GEVIGNEY ET MERCEY',
    'JONVELLE',
    'JUSSEY',
    'LAMBREY',
    'MAGNY LES JUSSEY',
    'MONTCOURT',
    'MONTIGNY LES CHERLIEU',
    'MONTUREUX LES BAULAY',
    'ORMOY',
    'OUGE',
    'RAINCOURT',
    'RANZEVELLE',
    'ROSIERES SUR MANCE',
    'ST MARCEL',
    'TARTECOURT',
    'VENISEY',
    'VERNOIS SUR MANCE',
    'VILLARS LE PAUTEL',
    'VITREY SUR MANCE',
    'VOUGECOURT',
  ],
  70180: [
    'ACHEY',
    'AUTET',
    'BROTTE LES RAY',
    'DAMPIERRE SUR SALON',
    'DELAIN',
    'DENEVRE',
    'FRANCOURT',
    'MEMBREY',
    'MONTOT',
    'ROCHE ET RAUCOURT',
    'VAITE',
    'VEREUX',
    'VOLON',
  ],
  70200: [
    'ADELANS ET LE VAL DE BITHAINE',
    'AMBLANS ET VELOTTE',
    'ANDORNAY',
    'ARPENANS',
    'LES AYNANS',
    'BOUHANS LES LURE',
    'CLAIREGOUTTE',
    'LA COTE',
    'DAMBENOIT LES COLOMBE',
    'FAYMONT',
    'FRANCHEVELLE',
    'FREDERIC FONTAINE',
    'FROIDETERRE',
    'FROTEY LES LURE',
    'LANTENOT',
    'LINEXERT',
    'LOMONT',
    'LURE',
    'LYOFFANS',
    'MAGNY DANIGON',
    'MAGNY JOBERT',
    'MAGNY VERNOIS',
    'MALBOUHANS',
    'MOFFANS ET VACHERESSE',
    'LA NEUVELLE LES LURE',
    'PALANTE',
    'QUERS',
    'RIGNOVELLE',
    'ROYE',
    'ST GERMAIN',
    'LE VAL DE GOUHENANS',
    'LA VERGENNE',
    'VOUHENANS',
    'VY LES LURE',
  ],
  70110: [
    'AILLEVANS',
    'ATHESANS ETROITEFONTAINE',
    'AUTREY LES CERRE',
    'AUTREY LE VAY',
    'BEVEUGE',
    'BOREY',
    'COURCHATON',
    'ESPRELS',
    'FALLON',
    'GEORFANS',
    'GOUHENANS',
    'GRAMMONT',
    'LONGEVELLE',
    'LES MAGNY',
    'MARAST',
    'MELECEY',
    'MOIMAY',
    'MONTJUSTIN ET VELOTTE',
    'OPPENANS',
    'ORICOURT',
    'PONT SUR L OGNON',
    'ST FERJEUX',
    'ST SULPICE',
    'SENARGENT MIGNAFANS',
    'VELLECHEVREUX ET COURBENANS',
    'VILLAFANS',
    'VILLARGENT',
    'VILLERSEXEL',
    'VILLERS LA VILLE',
  ],
  70320: ['AILLEVILLERS ET LYAUMONT', 'CORBENAY', 'LA VAIVRE'],
  70800: [
    'AINVELLE',
    'ANJEUX',
    'BASSIGNEY',
    'BOULIGNEY',
    'BOURGUIGNON LES CONFLANS',
    'BRIAUCOURT',
    'CONFLANS SUR LANTERNE',
    'CUVE',
    'DAMPIERRE LES CONFLANS',
    'FLEUREY LES ST LOUP',
    'FONTAINE LES LUXEUIL',
    'FRANCALMONT',
    'HAUTEVELLE',
    'JASNEY',
    'MAGNONCOURT',
    'LA PISSEURE',
    'PLAINEMONT',
    'ST LOUP SUR SEMOUSE',
  ],
  70210: [
    'ALAINCOURT',
    'AMBIEVILLERS',
    'ANCHENONCOURT ET CHAZEL',
    'LA BASSE VAIVRE',
    'BETONCOURT ST PANCRAS',
    'DAMPVALLEY ST PANCRAS',
    'DEMANGEVELLE',
    'FONTENOIS LA VILLE',
    'GIREFONTAINE',
    'HURECOURT',
    'MAILLERONCOURT ST PANCRAS',
    'MELINCOURT',
    'MONTDORE',
    'PASSAVANT LA ROCHERE',
    'POLAINCOURT ET CLAIREFONTAINE',
    'PONT DU BOIS',
    'SAPONCOURT',
    'SELLES',
    'VAUVILLERS',
  ],
  70280: ['AMAGE', 'BREUCHOTTE', 'LA BRUYERE', 'RADDON ET CHAPENDU', 'ST BRESSON'],
  70160: [
    'AMANCE',
    'BAULAY',
    'BREUREY LES FAVERNEY',
    'CONTREGLISE',
    'CUBRY LES FAVERNEY',
    'EQUEVILLEY',
    'FAVERNEY',
    'FLEUREY LES FAVERNEY',
    'FOUCHECOURT',
    'MENOUX',
    'MERSUAY',
    'NEUREY EN VAUX',
    'PURGEROT',
    'ST REMY EN COMTE',
    'SENONCOURT',
    'LE VAL ST ELOI',
    'LA VILLEDIEU EN FONTENETTE',
  ],
  70170: [
    'AMONCOURT',
    'BOUGNON',
    'CHARGEY LES PORT',
    'CHAUX LES PORT',
    'CONFLANDEY',
    'GRATTERY',
    'PORT SUR SAONE',
    'PROVENCHERE',
    'SCYE',
    'VAUCHOUX',
    'VILLERS SUR PORT',
  ],
  70310: [
    'AMONT ET EFFRENEY',
    'BEULOTTE ST LAURENT',
    'CORRAVILLERS',
    'ESMOULIERES',
    'FAUCOGNEY ET LA MER',
    'LES FESSEY',
    'LA LONGINE',
    'LA MONTAGNE',
    'LA PROISELIERE ET LANGLE',
    'LA ROSIERE',
    'STE MARIE EN CHANOIS',
    'LA VOIVRE',
  ],
  70100: [
    'ANCIER',
    'APREMONT',
    'ARC LES GRAY',
    'ARSANS',
    'ATTRICOURT',
    'AUTREY LES GRAY',
    'AUVET ET LA CHAPELOTTE',
    'BATTRANS',
    'BEAUJEU ST VALLIER PIERREJUX QUITTEUR',
    'BOUHANS ET FEURG',
    'BROYE LES LOUPS ET VERFONTAINE',
    'CHAMPTONNAY',
    'CHAMPVANS',
    'CHARGEY LES GRAY',
    'CRESANCEY',
    'ESMOULINS',
    'ESSERTENNE ET CECEY',
    'FAHY LES AUTREY',
    'GERMIGNEY',
    'GRAY',
    'GRAY LA VILLE',
    'LOEUILLEY',
    'MANTOCHE',
    'MONTUREUX ET PRANTIGNY',
    'NANTILLY',
    'NOIRON',
    'ONAY',
    'POYANS',
    'RIGNY',
    'ST BROING',
    'ST LOUP NANTOUARD',
    'SAUVIGNEY LES GRAY',
    'LE TREMBLOIS',
    'VELESMES ECHEVANNE',
    'VELET',
    'VENERE',
  ],
  70000: [
    'ANDELARRE',
    'ANDELARROT',
    'AUXON',
    'BAIGNES',
    'BOURSIERES',
    'CERRE LES NOROY',
    'CHARIEZ',
    'CHARMOILLE',
    'CLANS',
    'COLOMBE LES VESOUL',
    'COLOMBIER',
    'COMBERJON',
    'COULEVON',
    'DAMPVALLEY LES COLOMBE',
    'LA DEMIE',
    'ECHENOZ LA MELINE',
    'ECHENOZ LE SEC',
    'FLAGY',
    'FROTEY LES VESOUL',
    'LE MAGNORAY',
    'MAILLEY ET CHAZELOT',
    'MONTCEY',
    'MONTIGNY LES VESOUL',
    'MONT LE VERNOIS',
    'NAVENNE',
    'NEUREY LES LA DEMIE',
    'NOIDANS LES VESOUL',
    'NOROY LE BOURG',
    'PUSEY',
    'PUSY ET EPENOUX',
    'QUINCEY',
    'RAZE',
    'ROSEY',
    'VAIVRE ET MONTOILLE',
    'VALLEROIS LE BOIS',
    'VALLEROIS LORIOZ',
    'VELLEFAUX',
    'VELLEGUINDRY ET LEVRECEY',
    'VELLE LE CHATEL',
    'VESOUL',
    'VILLEPAROIS',
    'VILLERS LE SEC',
  ],
  70700: [
    'ANGIREY',
    'AUTOREILLE',
    'BONNEVENT VELLOREILLE',
    'BUCEY LES GY',
    'LA CHAPELLE ST QUILLAIN',
    'CHARCENNE',
    'CHOYE',
    'CITEY',
    'CUGNEY',
    'ETRELLES ET LA MONTBLEUSE',
    'FRASNE LE CHATEAU',
    'GEZIER ET FONTENELAY',
    'GY',
    'IGNY',
    'MONTBOILLON',
    'VILLERS CHEMIN ET MONT LES ETRELLES',
    'OISELAY ET GRACHAUX',
    'STE REINE',
    'VANTOUX ET LONGEVELLE',
    'VAUX LE MONCELOT',
    'VELLECLAIRE',
    'VELLEFREY ET VELLEFRANGE',
    'VELLEMOZ',
    'VELLOREILLE LES CHOYE',
    'VILLEFRANCON',
  ],
  70120: [
    'ARBECEY',
    'BOURGUIGNON LES MOREY',
    'CHARMES ST VALBERT',
    'CINTREY',
    'COMBEAUFONTAINE',
    'CONFRACOURT',
    'CORNOT',
    'FEDRY',
    'FLEUREY LES LAVONCOURT',
    'GOURGEON',
    'GRANDECOURT',
    'LAVIGNEY',
    'LAVONCOURT',
    'MALVILLERS',
    'MELIN',
    'MOLAY',
    'MONT ST LEGER',
    'LA ROCHE MOREY',
    'OIGNEY',
    'PREIGNEY',
    'LA QUARTE',
    'RENAUCOURT',
    'LA ROCHELLE',
    'SEMMADON',
    'THEULEY',
    'TINCEY ET PONTREBEAU',
    'VAUCONCOURT NERVEZAIN',
    'VILLERS VAUDEY',
    'VY LES RUPT',
  ],
  70600: [
    'ARGILLIERES',
    'CHAMPLITTE',
    'COURTESOULT ET GATEY',
    'ECUELLE',
    'FOUVENT ST ANDOCHE',
    'FRAMONT',
    'LARRET',
    'OYRIERES',
    'PERCEY LE GRAND',
    'PIERRECOURT',
    'VARS',
  ],
  70360: [
    'AROZ',
    'BUCEY LES TRAVES',
    'CHANTES',
    'CHASSEY LES SCEY',
    'CHEMILLY',
    'FERRIERES LES SCEY',
    'LA NEUVELLE LES SCEY',
    'OVANCHES',
    'PONTCEY',
    'RUPT SUR SAONE',
    'SCEY SUR SAONE ET ST ALBIN',
    'TRAVES',
  ],
  70190: [
    'AULX LES CROMARY',
    'AUTHOISON',
    'LA BARRE',
    'BEAUMOTTE AUBERTANS',
    'BOULOT',
    'BOULT',
    'BOURGUIGNON LES LA CHARITE',
    'BUSSIERES',
    'BUTHIERS',
    'CHAMBORNAY LES BELLEVAUX',
    'CHAUX LA LOTIERE',
    'CIREY',
    'CORDONNET',
    'CROMARY',
    'FONDREMAND',
    'GRANDVELLE ET LE PERRENOT',
    'HYET',
    'LIEFFRANS',
    'MAIZIERES',
    'LA MALACHERE',
    'MONTARLOT LES RIOZ',
    'NEUVELLE LES CROMARY',
    'PENNESIERES',
    'PERROUSE',
    'QUENOCHE',
    'RECOLOGNE LES RIOZ',
    'RIOZ',
    'RUHANS',
    'SORANS LES BREUREY',
    'TRAITIEFONTAINE',
    'TRESILLEY',
    'VANDELANS',
    'VILLERS BOUTON',
    'VILLERS PATER',
    'VORAY SUR L OGNON',
  ],
  70150: [
    'AVRIGNEY VIREY',
    'BAY',
    'BEAUMOTTE LES PIN',
    'BONBOILLON',
    'BRUSSEY',
    'CHAMBORNAY LES PIN',
    'CHENEVREY ET MOROGNE',
    'COURCUIRE',
    'CULT',
    'ETUZ',
    'HUGIER',
    'MARNAY',
    'PIN',
    'SORNAY',
    'TROMAREY',
    'VREGILLE',
  ],
  70140: [
    'BARD LES PESMES',
    'BRESILLEY',
    'BROYE AUBIGNEY MONTSEUGNY',
    'CHANCEY',
    'CHAUMERCENNE',
    'CHEVIGNEY',
    'LIEUCOURT',
    'MALANS',
    'MONTAGNEY',
    'MOTEY BESUCHE',
    'PESMES',
    'LA GRANDE RESIE',
    'LA RESIE ST MARTIN',
    'SAUVIGNEY LES PESMES',
    'VADANS',
    'VALAY',
  ],
  70130: [
    'LES BATIES',
    'FERRIERES LES RAY',
    'FRESNE ST MAMES',
    'FRETIGNEY ET VELLOREILLE',
    'MERCEY SUR SAONE',
    'NEUVELLE LES LA CHARITE',
    'NOIDANS LE FERROUX',
    'LA ROMAINE',
    'RAY SUR SAONE',
    'RECOLOGNE',
    'ST GAND',
    'SAVOYEUX',
    'SEVEUX MOTEY',
    'SOING CUBRY CHARENTENAY',
    'VANNE',
    'VELLEXON QUEUTREY ET VAUDEY',
    'LA VERNOTTE',
    'VY LE FERROUX',
  ],
  70290: ['BELFAHY', 'CHAMPAGNEY', 'PLANCHER BAS', 'PLANCHER LES MINES'],
  70270: [
    'BELMONT',
    'BELONCHAMP',
    'ECROMAGNY',
    'FRESSE',
    'LA LANTERNE ET LES ARMONTS',
    'MELISEY',
    'MONTESSAUX',
    'ST BARTHELEMY',
    'TERNUAY MELAY ET ST HILAIRE',
  ],
  70400: [
    'BELVERNE',
    'BREVILLIERS',
    'CHAGEY',
    'CHALONVILLARS',
    'CHAMPEY',
    'CHAVANNE',
    'CHENEBIER',
    'COISEVAUX',
    'COURMONT',
    'COUTHENANS',
    'CREVANS ET LA CHAPELLE LES GRANGES',
    'ECHAVANNE',
    'ECHENANS SOUS MONT VAUDOIS',
    'ERREVET',
    'ETOBON',
    'FRAHIER ET CHATEBIER',
    'GRANGES LA VILLE',
    'GRANGES LE BOURG',
    'HERICOURT',
    'LUZE',
    'MANDREVILLARS',
    'MIGNAVILLERS',
    'SAULNOT',
    'SECENANS',
    'TREMOINS',
    'VERLANS',
    'VILLERS SUR SAULNOT',
    'VYANS LE VAL',
  ],
  70230: [
    'BESNANS',
    'BOUHANS LES MONTBOZON',
    'CENANS',
    'CHASSEY LES MONTBOZON',
    'COGNIERES',
    'DAMPIERRE SUR LINOTTE',
    'FILAIN',
    'FONTENOIS LES MONTBOZON',
    'LARIANS ET MUNANS',
    'LOULANS VERCHAMP',
    'MAUSSANS',
    'MONTBOZON',
    'ORMENANS',
    'ROCHE LINOTTE ET SORANS CORDIERS',
    'THIEFFRANS',
    'THIENANS',
    'VY LES FILAIN',
  ],
  70240: [
    'CALMOUTIER',
    'CHATENEY',
    'CHATENOIS',
    'COLOMBOTTE',
    'LA CREUSE',
    'CREVENEY',
    'GENEVREUILLE',
    'GENEVREY',
    'LIEVANS',
    'MAILLERONCOURT CHARETTE',
    'MOLLANS',
    'POMOY',
    'SAULX',
    'SERVIGNEY',
    'VAROGNE',
    'VELLEFRIE',
    'VELLEMINFROY',
    'LA VILLENEUVE BELLENOYE LA MAIZE',
    'VILORY',
  ],
  70220: ['FOUGEROLLES ST VALBERT'],
  70440: ['HAUT DU THEM CHATEAU LAMBERT', 'SERVANCE MIELLIN'],
  70250: ['RONCHAMP'],
  71290: [
    'L ABERGEMENT DE CUISERY',
    'BRIENNE',
    'CUISERY',
    'LA GENETE',
    'HUILLY SUR SEILLE',
    'JOUVENCON',
    'LOISY',
    'ORMES',
    'PRETY',
    'RANCY',
    'RATENELLE',
    'SIMANDRE',
    'LA TRUCHERE',
  ],
  71370: [
    'L ABERGEMENT STE COLOMBE',
    'BAUDRIERES',
    'OUROUX SUR SAONE',
    'ST CHRISTOPHE EN BRESSE',
    'ST ETIENNE EN BRESSE',
    'ST GERMAIN DU PLAIN',
  ],
  71350: [
    'ALLEREY SUR SAONE',
    'LES BORDES',
    'BRAGNY SUR SAONE',
    'CHARNAY LES CHALON',
    'CIEL',
    'ECUELLES',
    'PALLEAU',
    'ST GERVAIS EN VALLIERE',
    'ST LOUP GEANGES',
    'ST MARTIN EN GATINOIS',
    'SAUNIERES',
    'SERMESSE',
    'TOUTENANT',
    'VERDUN SUR LE DOUBS',
  ],
  71380: ['ALLERIOT', 'CHATENOY EN BRESSE', 'EPERVANS', 'LANS', 'OSLON', 'ST MARCEL'],
  71510: [
    'ALUZE',
    'CHAMILLY',
    'CHARRECEY',
    'CHATEL MORON',
    'DENNEVY',
    'ESSERTENNE',
    'MOREY',
    'PERREUIL',
    'ST BERAIN SUR DHEUNE',
    'ST GILLES',
    'ST LEGER SUR DHEUNE',
    'ST SERNIN DU PLAIN',
  ],
  71800: [
    'AMANZE',
    'BAUDEMONT',
    'BOIS STE MARIE',
    'LA CHAPELLE SOUS DUN',
    'CHATENAY',
    'LA CLAYETTE',
    'COLOMBIER EN BRIONNAIS',
    'CURBIGNY',
    'DYO',
    'GIBLES',
    'OUROUX SOUS LE BOIS STE MARIE',
    'OYE',
    'PRIZY',
    'ST CHRISTOPHE EN BRIONNAIS',
    'ST GERMAIN EN BRIONNAIS',
    'ST JULIEN DE CIVRY',
    'ST LAURENT EN BRIONNAIS',
    'ST RACHO',
    'ST SYMPHORIEN DES BOIS',
    'VAREILLES',
    'VARENNES SOUS DUN',
    'VAUBAN',
  ],
  71460: [
    'AMEUGNY',
    'BISSY SOUS UXELLES',
    'BISSY SUR FLEY',
    'BONNAY ST YTHAIRE',
    'BRESSE SUR GROSNE',
    'BURNAND',
    'BURZY',
    'CHAMPAGNY SOUS UXELLES',
    'CHAPAIZE',
    'CHISSEY LES MACON',
    'COLLONGE EN CHAROLLAIS',
    'CORMATIN',
    'CORTEVAIX',
    'CULLES LES ROCHES',
    'CURTIL SOUS BURNAND',
    'GENOUILLY',
    'GERMAGNY',
    'JONCY',
    'MALAY',
    'LE PULEY',
    'ST CLEMENT SUR GUYE',
    'ST GENGOUX LE NATIONAL',
    'ST HURUGE',
    'ST MARCELIN DE CRAY',
    'ST MARTIN DU TARTRE',
    'ST MARTIN LA PATROUILLE',
    'ST MAURICE DES CHAMPS',
    'ST MICAUD',
    'SANTILLY',
    'SAVIANGES',
    'SAVIGNY SUR GROSNE',
    'SERCY',
    'VAUX EN PRE',
  ],
  71170: [
    'ANGLURE SOUS DUN',
    'CHASSIGNY SOUS DUN',
    'CHAUFFAILLES',
    'COUBLANC',
    'MUSSY SOUS DUN',
    'ST IGNY DE ROCHE',
  ],
  71550: ['ANOST', 'CUSSY EN MORVAN', 'ROUSSILLON EN MORVAN'],
  71400: [
    'ANTULLY',
    'AUTUN',
    'AUXY',
    'CURGY',
    'DRACY ST LOUP',
    'MONTHELON',
    'LA PETITE VERRIERE',
    'ST FORGEOT',
    'LA CELLE EN MORVAN',
    'TAVERNAY',
  ],
  71110: [
    'ANZY LE DUC',
    'ARTAIX',
    'BAUGY',
    'BOURG LE COMTE',
    'BRIANT',
    'CERON',
    'CHAMBILLY',
    'LIGNY EN BRIONNAIS',
    'MARCIGNY',
    'MONTCEAUX L ETOILE',
    'ST DIDIER EN BRIONNAIS',
    'STE FOY',
    'ST JULIEN DE JONZY',
    'ST MARTIN DU LAC',
    'SARRY',
    'SEMUR EN BRIONNAIS',
    'VARENNE L ARCONCE',
    'VERSAUGUES',
    'VINDECY',
  ],
  71270: [
    'AUTHUMES',
    'BEAUVERNOIS',
    'BELLEVESVRE',
    'CHARETTE VARENNES',
    'FRETTERANS',
    'FRONTENARD',
    'LAYS SUR LE DOUBS',
    'LONGEPIERRE',
    'MONT LES SEURRE',
    'MOUTHIER EN BRESSE',
    'NAVILLY',
    'PIERRE DE BRESSE',
    'PONTOUX',
    'POURLANS',
    'TORPES',
    'CLUX VILLENEUVE',
  ],
  71260: [
    'AZE',
    'BISSY LA MACONNAISE',
    'BURGY',
    'CHARBONNIERES',
    'CLESSE',
    'CRUZILLE',
    'LUGNY',
    'MONTBELLET',
    'PERONNE',
    'ST ALBAIN',
    'ST GENGOUX DE SCISSE',
    'ST MAURICE DE SATONNAY',
    'LA SALLE',
    'SENOZAN',
    'VIRE',
    'FLEURVILLE',
  ],
  71220: [
    'BALLORE',
    'BEAUBERY',
    'CHEVAGNY SUR GUYE',
    'CHIDDES',
    'LA GUICHE',
    'LE ROUSSET MARIZY',
    'MARTIGNY LE COMTE',
    'MORNAY',
    'PASSY',
    'PRESSY SOUS DONDIN',
    'ST ANDRE LE DESERT',
    'ST BONNET DE JOUX',
    'ST MARTIN DE SALENCEY',
    'SIVIGNON',
    'SUIN',
    'VEROSVRES',
  ],
  71500: [
    'BANTANGES',
    'BRANGES',
    'BRUAILLES',
    'LA CHAPELLE NAUDE',
    'LOUHANS',
    'MONTAGNY PRES LOUHANS',
    'MONTCONY',
    'RATTE',
    'ST USUGE',
    'SORNAY',
    'VINCELLES',
  ],
  71640: [
    'BARIZEY',
    'DRACY LE FORT',
    'GIVRY',
    'JAMBLES',
    'MELLECEY',
    'MERCUREY',
    'ST DENIS DE VAUX',
    'ST JEAN DE VAUX',
    'ST MARD DE VAUX',
    'ST MARTIN SOUS MONTAIGU',
  ],
  71540: [
    'BARNAY',
    'CHISSEY EN MORVAN',
    'CORDESSE',
    'IGORNAY',
    'LUCENAY L EVEQUE',
    'RECLESNE',
    'SOMMANT',
  ],
  71120: [
    'BARON',
    'CHAMPLECY',
    'CHANGY',
    'CHAROLLES',
    'FONTENAY',
    'LUGNY LES CHAROLLES',
    'MARCILLY LA GUEURCE',
    'OZOLLES',
    'VAUDEBARRIER',
    'VENDENESSE LES CHAROLLES',
    'VIRY',
  ],
  71240: [
    'BEAUMONT SUR GROSNE',
    'LA CHAPELLE DE BRAGNY',
    'ETRIGNY',
    'GIGNY SUR SAONE',
    'JUGY',
    'LAIVES',
    'LALHEUE',
    'MANCEY',
    'MARNAY',
    'MONTCEAUX RAGNY',
    'NANTON',
    'ST AMBREUIL',
    'ST CYR',
    'ST LOUP DE VARENNES',
    'SENNECEY LE GRAND',
    'VARENNES LE GRAND',
    'VERS',
  ],
  71580: [
    'BEAUREPAIRE EN BRESSE',
    'LE FAY',
    'FLACEY EN BRESSE',
    'FRONTENAUD',
    'SAGY',
    'SAILLENARD',
    'ST MARTIN DU MONT',
    'SAVIGNY EN REVERMONT',
  ],
  71250: [
    'BERGESSERIN',
    'BLANOT',
    'BRAY',
    'BUFFIERES',
    'CHATEAU',
    'CHERIZET',
    'CLUNY',
    'CORTAMBERT',
    'DONZY LE PERTUIS',
    'FLAGY',
    'JALOGNY',
    'LOURNAND',
    'MASSILLY',
    'MAZILLE',
    'SAILLY',
    'STE CECILE',
    'ST VINCENT DES PRES',
    'SALORNAY SUR GUYE',
    'SIGY LE CHATEL',
    'TAIZE',
    'LA VINEUSE SUR FREGANDE',
  ],
  71960: [
    'BERZE LE CHATEL',
    'BERZE LA VILLE',
    'BUSSIERES',
    'CHEVAGNY LES CHEVRIERES',
    'DAVAYE',
    'FUISSE',
    'IGE',
    'MILLY LAMARTINE',
    'PIERRECLOS',
    'PRISSE',
    'LA ROCHE VINEUSE',
    'SERRIERES',
    'SOLOGNY',
    'SOLUTRE POUILLY',
    'VERGISSON',
    'VERZE',
  ],
  71620: [
    'BEY',
    'DAMEREY',
    'GUERFAND',
    'MONTCOY',
    'ST DIDIER EN BRESSE',
    'ST MARTIN EN BRESSE',
    'ST MAURICE EN RIVIERE',
    'VILLEGAUDIN',
  ],
  71390: [
    'BISSEY SOUS CRUCHAUD',
    'BUXY',
    'CERSOT',
    'CHENOVES',
    'FLEY',
    'GRANGES',
    'JULLY LES BUXY',
    'MARCILLY LES BUXY',
    'MESSEY SUR GROSNE',
    'MONTAGNY LES BUXY',
    'MOROGES',
    'ROSEY',
    'ST BOIL',
    'ST DESERT',
    'ST GERMAIN LES BUXY',
    'STE HELENE',
    'ST MARTIN D AUXY',
    'ST PRIVE',
    'ST VALLERIN',
    'SASSANGY',
    'SAULES',
    'VILLENEUVE EN MONTAGNE',
  ],
  71710: ['LES BIZOTS', 'CHARMOY', 'MARMAGNE', 'MONTCENIS', 'ST SYMPHORIEN DE MARMAGNE'],
  71450: ['BLANZY'],
  71330: [
    'BOSJEAN',
    'BOUHANS',
    'DEVROUZE',
    'DICONNE',
    'FRANGY EN BRESSE',
    'LE PLANOIS',
    'ST GERMAIN DU BOIS',
    'SENS SUR SEILLE',
    'SIMARD',
    'LE TARTRE',
  ],
  71320: [
    'LA BOULAYE',
    'CHARBONNAT',
    'CUZY',
    'MONTMORT',
    'ST EUGENE',
    'STE RADEGONDE',
    'TOULON SUR ARROUX',
  ],
  71140: [
    'BOURBON LANCY',
    'CHALMOUX',
    'CRONAT',
    'LESME',
    'MALTAT',
    'MONT',
    'ST AUBIN SUR LOIRE',
    'VITRY SUR LOIRE',
  ],
  71520: [
    'BOURGVILAIN',
    'LA CHAPELLE DU MONT DE FRANCE',
    'NAVOUR SUR GROSNE',
    'CURTIL SOUS BUFFIERES',
    'DOMPIERRE LES ORMES',
    'GERMOLLES SUR GROSNE',
    'MATOUR',
    'MONTMELARD',
    'ST LEGER SOUS LA BUSSIERE',
    'ST PIERRE LE VIEUX',
    'ST POINT',
    'TRAMAYES',
    'TRAMBLY',
    'TRIVY',
  ],
  71150: [
    'BOUZERON',
    'CHAGNY',
    'CHASSEY LE CAMP',
    'CHAUDENAY',
    'CHEILLY LES MARANGES',
    'DEMIGNY',
    'DEZIZE LES MARANGES',
    'FARGES LES CHALON',
    'FONTAINES',
    'PARIS L HOPITAL',
    'REMIGNY',
    'RULLY',
    'SAMPIGNY LES MARANGES',
  ],
  71700: [
    'BOYER',
    'LA CHAPELLE SOUS BRANCION',
    'CHARDONNAY',
    'FARGES LES MACON',
    'GREVILLY',
    'LACROST',
    'MARTAILLY LES BRANCION',
    'OZENAY',
    'PLOTTES',
    'ROYER',
    'TOURNUS',
    'UCHIZY',
    'LE VILLARS',
  ],
  71670: ['LE BREUIL', 'ST FIRMIN', 'ST PIERRE DE VARENNES'],
  71190: [
    'BRION',
    'BROYE',
    'LA CHAPELLE SOUS UCHON',
    'DETTEY',
    'ETANG SUR ARROUX',
    'LAIZY',
    'MESVRES',
    'ST DIDIER SUR ARROUX',
    'ST NIZIER SUR ARROUX',
    'LA TAGNIERE',
    'THIL SUR ARROUX',
    'UCHON',
  ],
  71570: [
    'CHAINTRE',
    'CHANES',
    'LA CHAPELLE DE GUINCHAY',
    'CHASSELAS',
    'LEYNES',
    'PRUZILLY',
    'ROMANECHE THORINS',
    'ST AMOUR BELLEVUE',
    'ST SYMPHORIEN D ANCELLES',
    'ST VERAND',
  ],
  71100: ['CHALON SUR SAONE', 'LA CHARMEE', 'LUX', 'ST REMY', 'SEVREY'],
  71480: [
    'CHAMPAGNAT',
    'CONDAL',
    'CUISEAUX',
    'DOMMARTIN LES CUISEAUX',
    'JOUDES',
    'LE MIROIR',
    'VARENNES ST SAUVEUR',
  ],
  71530: [
    'CHAMPFORGEUIL',
    'CRISSEY',
    'FRAGNES LA LOYERE',
    'LESSARD LE NATIONAL',
    'SASSENAY',
    'VIREY LE GRAND',
  ],
  71130: [
    'LA CHAPELLE AU MANS',
    'CHASSY',
    'CLESSY',
    'CURDIN',
    'GUEUGNON',
    'NEUVY GRANDCHAMP',
    'UXEAU',
    'VENDENESSE SUR ARROUX',
  ],
  71310: [
    'LA CHAPELLE ST SAUVEUR',
    'LA CHAUX',
    'DAMPIERRE EN BRESSE',
    'MERVANS',
    'MONTJAY',
    'LA RACINEUSE',
    'ST BONNET EN BRESSE',
    'SERLEY',
    'SERRIGNY EN BRESSE',
  ],
  71470: [
    'LA CHAPELLE THECLE',
    'MENETREUIL',
    'MONTPONT EN BRESSE',
    'ROMENAY',
    'STE CROIX EN BRESSE',
  ],
  71850: ['CHARNAY LES MACON'],
  71740: ['CHATEAUNEUF', 'ST EDMOND', 'ST MARTIN DE LIXY', 'ST MAURICE LES CHATEAUNEUF', 'TANCON'],
  71880: ['CHATENOY LE ROYAL'],
  71340: [
    'CHENAY LE CHATEL',
    'FLEURY LA MONTAGNE',
    'IGUERANDE',
    'MAILLY',
    'MELAY',
    'ST BONNET DE CRAY',
  ],
  71420: [
    'CIRY LE NOBLE',
    'DOMPIERRE SOUS SANVIGNES',
    'GENELARD',
    'MARLY SUR ARROUX',
    'OUDRY',
    'PERRECY LES FORGES',
    'ST ROMAIN SOUS VERSIGNY',
  ],
  71360: [
    'COLLONGE LA MADELEINE',
    'EPERTULLY',
    'EPINAC',
    'MORLET',
    'ST LEGER DU BOIS',
    'SAISY',
    'SULLY',
  ],
  71990: ['LA COMELLE', 'LA GRANDE VERRIERE', 'ST LEGER SOUS BEUVRAY', 'ST PRIX'],
  71490: [
    'COUCHES',
    'CREOT',
    'DRACY LES COUCHES',
    'ST EMILAND',
    'ST GERVAIS SUR COUCHES',
    'ST JEAN DE TREZY',
    'ST MARTIN DE COMMUNE',
    'ST MAURICE LES COUCHES',
    'TINTRY',
  ],
  71680: ['CRECHES SUR SAONE', 'VINZELLES'],
  71760: ['CRESSY SUR SOMME', 'GRURY', 'ISSY L EVEQUE', 'MARLY SOUS ISSY'],
  71200: ['LE CREUSOT', 'ST SERNIN DU BOIS'],
  71160: [
    'DIGOIN',
    'GILLY SUR LOIRE',
    'LES GUERREAUX',
    'LA MOTTE ST JEAN',
    'PERRIGNY SUR LOIRE',
    'RIGNY SUR ARROUX',
    'ST AGNAN',
  ],
  71210: [
    'ECUISSES',
    'MONTCHANIN',
    'ST EUSEBE',
    'ST JULIEN SUR DHEUNE',
    'ST LAURENT D ANDENAY',
    'TORCY',
  ],
  71440: [
    'LA FRETTE',
    'JUIF',
    'LESSARD EN BRESSE',
    'MONTRET',
    'ST ANDRE EN BRESSE',
    'ST VINCENT EN BRESSE',
    'SAVIGNY SUR SEILLE',
    'THUREY',
    'TRONCHY',
    'VERISSEY',
  ],
  71590: ['GERGY', 'VERJUX'],
  71300: [
    'GOURDON',
    'MARIGNY',
    'MARY',
    'MONTCEAU LES MINES',
    'MONT ST VINCENT',
    'ST BERAIN SOUS SANVIGNES',
  ],
  71430: [
    'GRANDVAUX',
    'PALINGES',
    'ST AUBIN EN CHAROLLAIS',
    'ST BONNET DE VIEILLE VIGNE',
    'ST VINCENT BRAGNY',
  ],
  71600: [
    'HAUTEFOND',
    'L HOPITAL LE MERCIER',
    'NOCHIZE',
    'PARAY LE MONIAL',
    'POISSON',
    'ST LEGER LES PARAY',
    'ST YAN',
    'VARENNE ST GERMAIN',
    'VITRY EN CHAROLLAIS',
    'VOLESVRES',
  ],
  71870: ['HURIGNY', 'LAIZE'],
  71000: ['MACON', 'SANCE', 'VARENNES LES MACON'],
  71230: ['POUILLOUX', 'ST ROMAIN SOUS GOURDON', 'ST VALLIER'],
  71118: ['ST MARTIN BELLE ROCHE'],
  71410: ['SANVIGNES LES MINES'],
  72650: ['AIGNE', 'LA BAZOGE', 'LA CHAPELLE ST AUBIN', 'LA MILESSE', 'ST SATURNIN', 'TRANGE'],
  72600: [
    'AILLIERES BEAUVOIR',
    'LES AULNEAUX',
    'BLEVES',
    'COMMERVEIL',
    'CONTILLY',
    'VILLENEUVE EN PERSEIGNE',
    'LOUVIGNY',
    'LOUZES',
    'MAMERS',
    'MAROLLETTE',
    'NEUFCHATEL EN SAOSNOIS',
    'PANON',
    'PIZIEUX',
    'ST CALEZ EN SAOSNOIS',
    'ST LONGIS',
    'ST PIERRE DES ORMES',
    'ST REMY DES MONTS',
    'ST REMY DU VAL',
    'ST VINCENT DES PRES',
    'SAOSNES',
    'VEZOT',
    'VILLAINES LA CARELLE',
  ],
  72700: [
    'ALLONNES',
    'ETIVAL LES LE MANS',
    'PRUILLE LE CHETIF',
    'ROUILLON',
    'ST GEORGES DU BOIS',
    'SPAY',
  ],
  72540: [
    'AMNE',
    'AUVERS SOUS MONTFAUCON',
    'CHASSILLE',
    'CHEMIRE EN CHARNIE',
    'CRANNES EN CHAMPAGNE',
    'EPINEU LE CHEVREUIL',
    'JOUE EN CHARNIE',
    'LONGNES',
    'LOUE',
    'MAREIL EN CHAMPAGNE',
    'ST CHRISTOPHE EN CHAMPAGNE',
    'TASSILLE',
    'VALLON SUR GEE',
  ],
  72610: [
    'ANCINNES',
    'ARCONNAY',
    'BERUS',
    'BETHON',
    'BOURG LE ROI',
    'CHAMPFLEUR',
    'CHENAY',
    'CHERISAY',
    'VILLENEUVE EN PERSEIGNE',
    'FYE',
    'GRANDCHAMP',
    'LIVET EN SAOSNOIS',
    'OISSEAU LE PETIT',
    'ROUESSE FONTAINE',
    'ST PATERNE LE CHEVAIN',
    'THOIRE SOUS CONTENSOR',
  ],
  72370: ['ARDENAY SUR MERIZE', 'LE BREIL SUR MERIZE', 'NUILLE LE JALAIS', 'SOULITRE', 'SURFONDS'],
  72230: ['ARNAGE', 'GUECELARD', 'MONCE EN BELIN', 'MULSANNE', 'RUAUDIN'],
  72270: [
    'ARTHEZE',
    'BOUSSE',
    'COURCELLES LA FORET',
    'DUREIL',
    'LIGRON',
    'MALICORNE SUR SARTHE',
    'MEZERAY',
    'VILLAINES SOUS MALICORNE',
  ],
  72430: [
    'ASNIERES SUR VEGRE',
    'AVOISE',
    'CHANTENAY VILLEDIEU',
    'FERCE SUR SARTHE',
    'NOYEN SUR SARTHE',
    'PIRMIL',
    'ST JEAN DU BOIS',
    'ST PIERRE DES BOIS',
    'TASSE',
  ],
  72130: [
    'ASSE LE BOISNE',
    'DOUILLET',
    'FRESNAY SUR SARTHE',
    'GESNES LE GANDELIN',
    'MONTREUIL LE CHETIF',
    'MOULINS LE CARBONNEL',
    'ST AUBIN DE LOCQUENAY',
    'ST GEORGES LE GAULTIER',
    'ST LEONARD DES BOIS',
    'ST OUEN DE MIMBRE',
    'ST PAUL LE GAULTIER',
    'ST VICTEUR',
    'SOUGE LE GANELON',
  ],
  72170: [
    'ASSE LE RIBOUL',
    'BEAUMONT SUR SARTHE',
    'CHERANCE',
    'DOUCELLES',
    'JUILLE',
    'MARESCHE',
    'MEURCE',
    'MOITRON SUR SARTHE',
    'PIACE',
    'ST CHRISTOPHE DU JAMBET',
    'ST MARCEAU',
    'SEGRIE',
    'LE TRONCHET',
    'VERNIE',
    'VIVOIN',
  ],
  72800: [
    'AUBIGNE RACAN',
    'LA CHAPELLE AUX CHOUX',
    'COULONGE',
    'LUCHE PRINGE',
    'LE LUDE',
    'ST GERMAIN D ARCE',
    'SAVIGNE SOUS LE LUDE',
    'THOREE LES PINS',
  ],
  72300: [
    'AUVERS LE HAMON',
    'LA CHAPELLE D ALIGNE',
    'COURTILLERS',
    'JUIGNE SUR SARTHE',
    'LOUAILLES',
    'PARCE SUR SARTHE',
    'NOTRE DAME DU PE',
    'PINCE',
    'PRECIGNE',
    'SABLE SUR SARTHE',
    'SOLESMES',
    'SOUVIGNE SUR SARTHE',
    'VION',
  ],
  72260: [
    'AVESNES EN SAOSNOIS',
    'COURGAINS',
    'DANGEUL',
    'MAROLLES LES BRAULTS',
    'LES MEES',
    'MONCE EN SAOSNOIS',
    'MONHOUDOU',
    'NAUVAY',
    'NOUANS',
    'PERAY',
    'RENE',
    'THOIGNE',
  ],
  72350: [
    'AVESSE',
    'BRULON',
    'CHEVILLE',
    'FONTENAY SUR VEGRE',
    'POILLE SUR VEGRE',
    'ST DENIS D ORQUES',
    'ST OUEN EN CHAMPAGNE',
    'VIRE EN CHAMPAGNE',
  ],
  72400: [
    'AVEZE',
    'BOESSE LE SEC',
    'LA BOSSE',
    'LA CHAPELLE DU BOIS',
    'CHERRE AU',
    'CORMES',
    'DEHAULT',
    'LA FERTE BERNARD',
    'PREVAL',
    'ST AUBIN DES COUDRAIS',
    'ST MARTIN DES MONTS',
    'SOUVIGNE SUR MEME',
    'VILLAINES LA GONAIS',
  ],
  72200: [
    'LE BAILLEUL',
    'BAZOUGES CRE SUR LOIR',
    'CLERMONT CREANS',
    'CROSMIERES',
    'LA FLECHE',
    'MAREIL SUR LOIR',
  ],
  72290: [
    'BALLON ST MARS',
    'CONGE SUR ORNE',
    'COURCEBOEUFS',
    'LUCE SOUS BALLON',
    'MEZIERES SUR PONTHOUIN',
    'SOULIGNE SOUS BALLON',
    'TEILLE',
  ],
  72110: [
    'BEAUFAY',
    'BONNETABLE',
    'BRIOSNE LES SABLES',
    'COURCEMONT',
    'COURCIVAL',
    'JAUZE',
    'NOGENT LE BERNARD',
    'PREVELLES',
    'ROUPERROUX LE COQUET',
    'ST AIGNAN',
    'ST CELERIN',
    'ST COSME EN VAIRAIS',
    'ST DENIS DES COUDRAIS',
    'ST GEORGES DU ROSAY',
    'TERREHAULT',
    'TORCE EN VALLEE',
  ],
  72340: [
    'BEAUMONT SUR DEME',
    'CHAHAIGNES',
    'LA CHARTRE SUR LE LOIR',
    'LHOMME',
    'MARCON',
    'LOIR EN VALLEE',
  ],
  72500: [
    'BEAUMONT PIED DE BOEUF',
    'LA BRUERE SUR LOIR',
    'MONTVAL SUR LOIR',
    'CHENU',
    'DISSAY SOUS COURCILLON',
    'FLEE',
    'JUPILLES',
    'LAVERNAT',
    'LUCEAU',
    'NOGENT SUR LOIR',
    'ST PIERRE DE CHEVILLE',
    'THOIRE SUR DINAN',
    'VAAS',
  ],
  72160: [
    'BEILLE',
    'LA CHAPELLE ST REMY',
    'CONNERRE',
    'DUNEAU',
    'SCEAUX SUR HUISNE',
    'THORIGNE SUR DUE',
    'TUFFE VAL DE LA CHERONNE',
    'VOUVRAY SUR HUISNE',
  ],
  72320: [
    'BERFAY',
    'CHAMPROND',
    'COURGENARD',
    'GREEZ SUR ROC',
    'LAMNAY',
    'MELLERAY',
    'MONTMIRAIL',
    'ST JEAN DES ECHELLES',
    'ST MAIXENT',
    'ST ULPHACE',
    'THELIGNY',
    'VALENNES',
    'VIBRAYE',
  ],
  72310: ['BESSE SUR BRAYE', 'LA CHAPELLE HUON', 'COGNERS', 'LOIR EN VALLEE', 'VANCE'],
  72390: ['BOUER', 'DOLLON', 'LAVARE', 'LE LUART', 'SEMUR EN VALLON'],
  72440: [
    'BOULOIRE',
    'COUDRECIEUX',
    'MAISONCELLES',
    'ST MARS DE LOCQUENAY',
    'ST MICHEL DE CHAVAIGNES',
    'TRESSON',
    'VOLNAY',
  ],
  72550: ['BRAINS SUR GEE', 'CHAUFOUR NOTRE DAME', 'COULANS SUR GEE', 'DEGRE', 'FAY', 'LA QUINTE'],
  72250: ['BRETTE LES PINS', 'CHALLES', 'PARIGNE L EVEQUE'],
  72330: [
    'CERANS FOULLETOURTE',
    'LA FONTAINE ST MARTIN',
    'OIZE',
    'PARIGNE LE POLIN',
    'YVRE LE POLIN',
  ],
  72470: ['CHAMPAGNE', 'FATINES', 'ST MARS LA BRIERE'],
  72560: ['CHANGE'],
  72240: [
    'LA CHAPELLE ST FRAY',
    'CONLIE',
    'CURES',
    'DOMFRONT EN CHAMPAGNE',
    'LAVARDIN',
    'MEZIERES SOUS LAVARDIN',
    'NEUVILLALAIS',
    'BERNAY NEUVY EN CHAMPAGNE',
    'RUILLE EN CHAMPAGNE',
    'ST SYMPHORIEN',
    'TENNIE',
  ],
  72510: ['CHATEAU L HERMITAGE', 'MANSIGNE', 'PONTVALLAIN', 'REQUEIL', 'ST JEAN DE LA MOTTE'],
  72210: [
    'CHEMIRE LE GAUDIN',
    'FILLE',
    'LOUPLANDE',
    'MAIGNE',
    'ROEZE SUR SARTHE',
    'SOULIGNE FLACE',
    'LA SUZE SUR SARTHE',
    'VOIVRES LES LE MANS',
  ],
  72120: [
    'CONFLANS SUR ANILLE',
    'ECORPAIN',
    'VAL D ETANGSON',
    'MAROLLES LES ST CALAIS',
    'MONTAILLE',
    'RAHAY',
    'ST CALAIS',
    'STE CEROTTE',
    'ST GERVAIS DE VIC',
  ],
  72190: ['COULAINES', 'NEUVILLE SUR SARTHE', 'ST PAVACE', 'SARGE LES LE MANS'],
  72150: [
    'COURDEMANCHE',
    'LE GRAND LUCE',
    'MONTREUIL LE HENRI',
    'PRUILLE L EGUILLE',
    'ST GEORGES DE LA COUEE',
    'ST PIERRE DU LOROUER',
    'ST VINCENT DU LOROUER',
    'VILLAINES SOUS LUCE',
  ],
  72140: [
    'CRISSE',
    'LE GREZ',
    'MONT ST JEAN',
    'NEUVILLETTE EN CHARNIE',
    'PARENNES',
    'PEZE LE ROBERT',
    'ROUESSE VASSE',
    'ROUEZ',
    'ST REMY DE SILLE',
    'SILLE LE GUILLAUME',
  ],
  72220: [
    'ECOMMOY',
    'LAIGNE EN BELIN',
    'MARIGNE LAILLE',
    'ST BIEZ EN BELIN',
    'ST GERVAIS EN BELIN',
    'ST MARS D OUTILLE',
    'ST OUEN EN BELIN',
    'TELOCHE',
  ],
  72380: [
    'LA GUIERCHE',
    'JOUE L ABBE',
    'MONTBIZOT',
    'STE JAMME SUR SARTHE',
    'ST JEAN D ASSE',
    'STE SABINE SUR LONGEVE',
    'SOUILLE',
  ],
  72450: ['LOMBRON', 'MONTFORT LE GESNOIS'],
  72000: ['LE MANS'],
  72100: ['LE MANS'],
  72360: ['MAYET', 'SARCE', 'VERNEIL LE CHETIF'],
  72460: ['ST CORNEILLE', 'SAVIGNE L EVEQUE', 'SILLE LE PHILIPPE'],
  72530: ['YVRE L EVEQUE'],
  73610: ['AIGUEBELETTE LE LAC', 'ATTIGNAT ONCIN', 'DULLIN', 'LEPIN LE LAC', 'ST ALBAN DE MONTBEL'],
  73260: ['GRAND AIGUEBLANCHE', 'LES AVANCHERS VALMOREL', 'LA LECHERE'],
  73340: [
    'AILLON LE JEUNE',
    'AILLON LE VIEUX',
    'ARITH',
    'BELLECOMBE EN BAUGES',
    'LESCHERAINES',
    'LA MOTTE EN BAUGES',
    'LE NOYER',
    'ST FRANCOIS DE SALES',
  ],
  73210: ['AIME LA PLAGNE', 'LANDRY', 'LA PLAGNE TARENTAISE', 'PEISEY NANCROIX'],
  73220: [
    'AITON',
    'ARGENTINE',
    'BONVILLARET',
    'EPIERRE',
    'MONTGILBERT',
    'MONTSAPEY',
    'VAL D ARC',
    'ST ALBAN D HURTIERES',
    'ST GEORGES D HURTIERES',
    'ST LEGER',
    'ST PIERRE DE BELLEVILLE',
  ],
  73100: [
    'AIX LES BAINS',
    'BRISON ST INNOCENT',
    'GRESY SUR AIX',
    'MONTCEL',
    'MOUXY',
    'PUGNY CHATENOD',
    'ST OFFENGE',
    'TRESSERVE',
    'TREVIGNIN',
  ],
  73410: ['ENTRELACS', 'LA BIOLLE', 'ST OURS'],
  73200: [
    'ALBERTVILLE',
    'ALLONDAZ',
    'CESARCHES',
    'GILLY SUR ISERE',
    'GRIGNON',
    'MERCURY',
    'MONTHION',
    'PALLUD',
    'PLANCHERINE',
    'THENESOL',
    'VENTHON',
  ],
  73300: [
    'ALBIEZ LE JEUNE',
    'ALBIEZ MONTROND',
    'FONTCOUVERTE LA TOUSSUIRE',
    'LA TOUR EN MAURIENNE',
    'JARRIER',
    'MONTVERNIER',
    'ST JEAN DE MAURIENNE',
    'ST PANCRACE',
    'VILLAREMBERT',
    'VILLARGONDRAN',
  ],
  73550: ['LES ALLUES'],
  73190: [
    'APREMONT',
    'CHALLES LES EAUX',
    'CURIENNE',
    'PUYGROS',
    'ST BALDOPH',
    'ST JEOIRE PRIEURE',
    'LA THUILE',
  ],
  73800: [
    'ARBIN',
    'LA CHAVANNE',
    'CHIGNIN',
    'COISE ST JEAN PIED GAUTHIER',
    'CRUET',
    'LAISSAUD',
    'PORTE DE SAVOIE',
    'LES MOLLETTES',
    'MONTMELIAN',
    'MYANS',
    'PLANAISE',
    'STE HELENE DU LAC',
    'ST PIERRE DE SOUCY',
    'VILLARD D HERY',
  ],
  73110: [
    'ARVILLARD',
    'BOURGET EN HUILE',
    'LA CHAPELLE BLANCHE',
    'LA CROIX DE LA ROCHETTE',
    'DETRIER',
    'LE PONTET',
    'PRESLE',
    'VALGELON LA ROCHETTE',
    'ROTHERENS',
    'LA TABLE',
    'LA TRINITE',
    'LE VERNEIL',
    'VILLARD SALLET',
    'VILLAROUX',
  ],
  73500: [
    'AUSSOIS',
    'AVRIEUX',
    'FOURNEAUX',
    'FRENEY',
    'MODANE',
    'ST ANDRE',
    'VAL CENIS',
    'VILLARODIN BOURGET',
  ],
  73240: ['AVRESSIEUX', 'CHAMPAGNEUX', 'ROCHEFORT', 'ST GENIX LES VILLAGES', 'STE MARIE D ALVEY'],
  73470: ['AYN', 'GERBAIX', 'MARCIEUX', 'NANCES', 'NOVALAISE'],
  73170: [
    'LA BALME',
    'BILLIEME',
    'LA CHAPELLE ST MARTIN',
    'JONGIEUX',
    'LOISIEUX',
    'LUCEY',
    'MEYRIEUX TROUET',
    'ST JEAN DE CHEVELU',
    'ST PAUL SUR YENNE',
    'ST PIERRE D ALVEY',
    'TRAIZE',
    'VERTHEMEX',
    'YENNE',
  ],
  73000: ['BARBERAZ', 'BASSENS', 'CHAMBERY', 'JACOB BELLECOMBETTE', 'MONTAGNOLE', 'SONNAZ'],
  73230: [
    'BARBY',
    'LES DESERTS',
    'ST ALBAN LEYSSE',
    'ST JEAN D ARVEY',
    'THOIRY',
    'VEREL PRAGONDRAN',
  ],
  73540: ['LA BATHIE', 'ESSERTS BLAY'],
  73360: ['LA BAUCHE', 'LES ECHELLES', 'ST CHRISTOPHE', 'ST FRANC', 'ST PIERRE DE GENEBROZ'],
  73270: ['BEAUFORT', 'VILLARD SUR DORON'],
  73330: ['BELMONT TRAMONET', 'DOMESSIN', 'LE PONT DE BEAUVOISIN', 'VEREL DE MONTBEL'],
  73480: ['BESSANS', 'BONNEVAL SUR ARC', 'VAL CENIS'],
  73390: [
    'BETTON BETTONET',
    'BOURGNEUF',
    'CHAMOUSSET',
    'CHAMOUX SUR GELON',
    'CHAMP LAURENT',
    'CHATEAUNEUF',
    'HAUTEVILLE',
    'MONTENDRY',
    'VILLARD LEGER',
  ],
  73460: [
    'BONVILLARD',
    'CLERY',
    'FRONTENEX',
    'GRESY SUR ISERE',
    'MONTAILLEUR',
    'NOTRE DAME DES MILLIERES',
    'STE HELENE SUR ISERE',
    'ST VITAL',
    'TOURNON',
    'VERRENS ARVEY',
  ],
  73370: ['BOURDEAU', 'LE BOURGET DU LAC', 'LA CHAPELLE DU MONT DU CHAT'],
  73700: ['BOURG ST MAURICE', 'LES CHAPELLES', 'MONTVALEZAN', 'SEEZ'],
  73350: ['BOZEL', 'CHAMPAGNY EN VANOISE', 'FEISSONS SUR SALINS', 'MONTAGNY', 'PLANAY'],
  73570: ['BRIDES LES BAINS'],
  73520: ['LA BRIDOIRE', 'ST BERON'],
  73730: ['CEVINS', 'ROGNAIX', 'ST PAUL SUR ISERE'],
  73130: [
    'LA CHAMBRE',
    'NOTRE DAME DU CRUET',
    'ST ALBAN DES VILLARDS',
    'ST AVRE',
    'ST COLOMBAN DES VILLARDS',
    'ST ETIENNE DE CUINES',
    'ST FRANCOIS LONGCHAMP',
    'STE MARIE DE CUINES',
    'ST MARTIN SUR LA CHAMBRE',
  ],
  73310: [
    'CHANAZ',
    'CHINDRIEUX',
    'CONJUX',
    'MOTZ',
    'ONTEX',
    'RUFFIEUX',
    'ST PIERRE DE CURTILLE',
    'SERRIERES EN CHAUTAGNE',
    'VIONS',
  ],
  73660: ['LA CHAPELLE', 'LES CHAVANNES EN MAURIENNE', 'ST REMY DE MAURIENNE'],
  73630: ['LE CHATELARD', 'LA COMPOTE', 'DOUCY EN BAUGES', 'ECOLE', 'JARSY', 'STE REINE'],
  73160: [
    'COGNIN',
    'CORBEL',
    'ST CASSIN',
    'ST JEAN DE COUZ',
    'ST SULPICE',
    'ST THIBAUD DE COUZ',
    'VIMINES',
  ],
  73400: ['COHENNOZ', 'MARTHOD', 'UGINE'],
  73590: [
    'COHENNOZ',
    'CREST VOLAND',
    'FLUMET',
    'LA GIETTAZ',
    'NOTRE DAME DE BELLECOMBE',
    'ST NICOLAS LA CHAPELLE',
  ],
  73420: ['DRUMETTAZ CLARAFOND', 'MERY', 'VIVIERS DU LAC', 'VOGLANS'],
  73670: ['ENTREMONT LE VIEUX', 'ST PIERRE D ENTREMONT'],
  73250: ['FRETERIVE', 'ST JEAN DE LA PORTE', 'ST PIERRE D ALBIGNY'],
  73600: [
    'HAUTECOUR',
    'MOUTIERS',
    'NOTRE DAME DU PRE',
    'ST MARCEL',
    'LES BELLEVILLE',
    'SALINS FONTAINE',
  ],
  73620: ['HAUTELUCE'],
  73870: ['MONTRICHER ALBANNE', 'ST JULIEN MONT DENIS'],
  73290: ['LA MOTTE SERVOLEX'],
  73140: ['ORELLE', 'ST MARTIN D ARC', 'ST MARTIN DE LA PORTE', 'ST MICHEL DE MAURIENNE'],
  73710: ['PRALOGNAN LA VANOISE'],
  73720: ['QUEIGE'],
  73490: ['LA RAVOIRE'],
  73120: ['COURCHEVEL'],
  73640: ['STE FOY TARENTAISE', 'VILLAROGER'],
  73530: ['ST JEAN D ARVES', 'ST SORLIN D ARVES'],
  73440: ['LES BELLEVILLE'],
  73320: ['TIGNES'],
  73790: ['TOURS EN SAVOIE'],
  73150: ['VAL D ISERE'],
  73450: ['VALLOIRE', 'VALMEINIER'],
  74360: ['ABONDANCE', 'BONNEVAUX', 'LA CHAPELLE D ABONDANCE', 'VACHERESSE'],
  74540: [
    'ALBY SUR CHERAN',
    'ALLEVES',
    'CHAINAZ LES FRASSES',
    'CHAPEIRY',
    'CUSY',
    'GRUFFY',
    'HERY SUR ALBY',
    'MURES',
    'ST FELIX',
    'ST SYLVESTRE',
    'VIUZ LA CHIESAZ',
  ],
  74290: ['ALEX', 'BLUFFY', 'MENTHON ST BERNARD', 'TALLOIRES MONTMIN', 'VEYRIER DU LAC'],
  74200: [
    'ALLINGES',
    'ANTHY SUR LEMAN',
    'ARMOY',
    'LA FORCLAZ',
    'LYAUD',
    'MARGENCEL',
    'MARIN',
    'REYVROZ',
    'THONON LES BAINS',
    'LA VERNAZ',
  ],
  74350: [
    'ALLONZIER LA CAILLE',
    'ANDILLY',
    'CERCIER',
    'CERNEX',
    'COPPONEX',
    'CRUSEILLES',
    'CUVAT',
    'MENTHONNEX EN BORNES',
    'ST BLAISE',
    'LE SAPPEY',
    'VILLY LE BOUVERET',
    'VILLY LE PELLOUX',
    'VOVRAY EN BORNES',
  ],
  74800: [
    'AMANCY',
    'ARENTHON',
    'LA CHAPELLE RAMBAUD',
    'CORNIER',
    'ETAUX',
    'LA ROCHE SUR FORON',
    'ST LAURENT',
    'ST PIERRE EN FAUCIGNY',
    'ST SIXT',
  ],
  74100: ['AMBILLY', 'ANNEMASSE', 'ETREMBIERES', 'JUVIGNY', 'VETRAZ MONTHOUX', 'VILLE LA GRAND'],
  74000: ['ANNECY'],
  74370: [
    'ANNECY',
    'ARGONAY',
    'CHARVONNEX',
    'EPAGNY METZ TESSY',
    'NAVES PARMELAN',
    'FILLIERE',
    'VILLAZ',
  ],
  74600: ['ANNECY', 'MONTAGNY LES LANCHES', 'QUINTAL'],
  74940: ['ANNECY'],
  74960: ['ANNECY'],
  74300: [
    'ARACHES LA FRASSE',
    'CHATILLON SUR CLUSES',
    'CLUSES',
    'MAGLAND',
    'NANCY SUR CLUSES',
    'ST SIGISMOND',
    'THYEZ',
  ],
  74930: ['ARBUSIGNY', 'PERS JUSSY', 'REIGNIER ESERY', 'SCIENTRIER'],
  74160: [
    'ARCHAMPS',
    'BEAUMONT',
    'BOSSEY',
    'COLLONGES SOUS SALEVE',
    'FEIGERES',
    'NEYDENS',
    'PRESILLY',
    'ST JULIEN EN GENEVOIS',
    'VERS',
  ],
  74380: ['ARTHAZ PONT NOTRE DAME', 'BONNE', 'CRANVES SALES', 'LUCINGES', 'NANGY'],
  74130: [
    'AYSE',
    'BONNEVILLE',
    'BRIZON',
    'CONTAMINE SUR ARVE',
    'FAUCIGNY',
    'MONT SAXONNEX',
    'GLIERES VAL DE BORNE',
    'VOUGY',
  ],
  74140: [
    'BALLAISON',
    'CHENS SUR LEMAN',
    'DOUVAINE',
    'EXCENEVEX',
    'LOISIN',
    'MACHILLY',
    'MASSONGY',
    'MESSERY',
    'NERNIER',
    'ST CERGUES',
    'SCIEZ',
    'VEIGY FONCENEX',
    'YVOIRE',
  ],
  74330: [
    'LA BALME DE SILLINGY',
    'CHOISY',
    'EPAGNY METZ TESSY',
    'LOVAGNY',
    'MESIGNY',
    'NONGLARD',
    'POISY',
    'SILLINGY',
  ],
  74230: [
    'LA BALME DE THUY',
    'LE BOUCHET',
    'LES CLEFS',
    'DINGY ST CLAIR',
    'MANIGOD',
    'SERRAVAL',
    'THONES',
    'LES VILLARDS SUR THONES',
  ],
  74910: ['BASSY', 'CHALLONGES', 'FRANCLENS', 'ST GERMAIN SUR RHONE', 'SEYSSEL', 'USINENS'],
  74430: ['LA BAUME', 'LE BIOT', 'ST JEAN D AULPS', 'SEYTROUX'],
  74470: ['BELLEVAUX', 'LULLIN', 'VAILLY'],
  74500: [
    'BERNEX',
    'CHAMPANGES',
    'CHEVENOZ',
    'EVIAN LES BAINS',
    'FETERNES',
    'LARRINGES',
    'LUGRIN',
    'MAXILLY SUR LEMAN',
    'MEILLERIE',
    'NEUVECELLE',
    'NOVEL',
    'PUBLIER',
    'ST GINGOLPH',
    'ST PAUL EN CHABLAIS',
    'THOLLON LES MEMISES',
    'VINZIER',
  ],
  74150: [
    'BLOYE',
    'BOUSSY',
    'CREMPIGNY BONNEGUETE',
    'ETERCY',
    'HAUTEVILLE SUR FIER',
    'LORNAY',
    'MARCELLAZ ALBANAIS',
    'MARIGNY ST MARCEL',
    'MASSINGY',
    'MOYE',
    'RUMILLY',
    'ST EUSEBE',
    'SALES',
    'THUSY',
    'VALLIERES SUR FIER',
    'VAULX',
    'VERSONNEX',
  ],
  74420: [
    'BOEGE',
    'BURDIGNIN',
    'HABERE LULLIN',
    'HABERE POCHE',
    'ST ANDRE DE BOEGE',
    'SAXEL',
    'VILLARD',
  ],
  74250: [
    'BOGEVE',
    'FILLINGES',
    'MARCELLAZ',
    'PEILLONNEX',
    'ST JEAN DE THOLOME',
    'LA TOUR',
    'VILLE EN SALLAZ',
    'VIUZ EN SALLAZ',
  ],
  74890: ['BONS EN CHABLAIS', 'BRENTHONNE', 'FESSY', 'LULLY'],
  74550: ['CERVENS', 'DRAILLANT', 'ORCIER', 'PERRIGNIER'],
  74400: ['CHAMONIX MONT BLANC'],
  74410: ['LA CHAPELLE ST MAURICE', 'DUINGT', 'ENTREVERNES', 'ST EUSTACHE', 'ST JORIOZ'],
  74390: ['CHATEL'],
  74270: [
    'CHAUMONT',
    'CHAVANNAZ',
    'CHENE EN SEMINE',
    'CHESSENAZ',
    'CHILLY',
    'CLARAFOND ARCINE',
    'CLERMONT',
    'CONTAMINE SARZIN',
    'DESINGY',
    'DROISY',
    'FRANGY',
    'MARLIOZ',
    'MENTHONNEX SOUS CLERMONT',
    'MINZIER',
    'MUSIEGES',
    'SALLENOVES',
    'VANZY',
  ],
  74650: ['CHAVANOD'],
  74520: [
    'CHENEX',
    'CHEVRIER',
    'DINGY EN VUACHE',
    'JONZIER EPAGNY',
    'SAVIGNY',
    'VALLEIRY',
    'VULBENS',
  ],
  74210: [
    'CHEVALINE',
    'DOUSSARD',
    'FAVERGES SEYTHENEX',
    'GIEZ',
    'LATHUILE',
    'VAL DE CHAISE',
    'ST FERREOL',
    'TALLOIRES MONTMIN',
  ],
  74220: ['LA CLUSAZ'],
  74920: ['COMBLOUX'],
  74170: ['LES CONTAMINES MONTJOIE', 'ST GERVAIS LES BAINS'],
  74700: ['CORDON', 'DOMANCY', 'SALLANCHES'],
  74110: ['LA COTE D ARBROZ', 'ESSERT ROMAND', 'MONTRIOND', 'MORZINE'],
  74120: ['DEMI QUARTIER', 'MEGEVE', 'PRAZ SUR ARLY'],
  74240: ['GAILLARD'],
  74260: ['LES GETS'],
  74450: ['LE GRAND BORNAND', 'ST JEAN DE SIXT'],
  74570: ['GROISY', 'FILLIERE'],
  74310: ['LES HOUCHES', 'SERVOZ'],
  74320: ['LESCHAUX', 'SEVRIER'],
  74970: ['MARIGNIER'],
  74460: ['MARNAZ'],
  74490: ['MEGEVETTE', 'ONNION', 'ST JEOIRE'],
  74440: ['MIEUSSY', 'MORILLON', 'LA RIVIERE ENVERSE', 'TANINGES', 'VERCHAIX'],
  74560: ['MONNETIER MORNEX', 'LA MURAZ'],
  74190: ['PASSY'],
  74950: ['LE REPOSOIR', 'SCIONZIER'],
  74340: ['SAMOENS'],
  74740: ['SIXT FER A CHEVAL'],
  74660: ['VALLORCINE'],
  74580: ['VIRY'],
  75001: ['PARIS 01'],
  75002: ['PARIS 02'],
  75003: ['PARIS 03'],
  75004: ['PARIS 04'],
  75005: ['PARIS 05'],
  75006: ['PARIS 06'],
  75007: ['PARIS 07'],
  75008: ['PARIS 08'],
  75009: ['PARIS 09'],
  75010: ['PARIS 10'],
  75011: ['PARIS 11'],
  75012: ['PARIS 12'],
  75013: ['PARIS 13'],
  75014: ['PARIS 14'],
  75015: ['PARIS 15'],
  75016: ['PARIS 16'],
  75116: ['PARIS 16'],
  75017: ['PARIS 17'],
  75018: ['PARIS 18'],
  75019: ['PARIS 19'],
  75020: ['PARIS 20'],
  76190: [
    'ALLOUVILLE BELLEFOSSE',
    'LES HAUTS DE CAUX',
    'AUZEBOSC',
    'BAONS LE COMTE',
    'BLACQUEVILLE',
    'BOIS HIMONT',
    'CARVILLE LA FOLLETIERE',
    'CROIX MARE',
    'ECALLES ALIX',
    'ECRETTEVILLE LES BAONS',
    'ETOUTTEVILLE',
    'ST MARTIN DE L IF',
    'HAUTOT LE VATOIS',
    'HAUTOT ST SULPICE',
    'ST AUBIN DE CRETOT',
    'ST CLAIR SUR LES MONTS',
    'STE MARIE DES CHAMPS',
    'TOUFFREVILLE LA CORBELINE',
    'VALLIQUERVILLE',
    'YVETOT',
  ],
  76640: [
    'ALVIMARE',
    'CLEVILLE',
    'CLIPONVILLE',
    'ENVRONVILLE',
    'TERRES DE CAUX',
    'FOUCART',
    'HATTENVILLE',
    'NORMANVILLE',
    'ROCQUEFORT',
    'TREMAUVILLE',
    'YEBLERON',
  ],
  76550: [
    'AMBRUMESNIL',
    'AUBERMESNIL BEAUMAIS',
    'COLMESNIL MANNEVILLE',
    'HAUTOT SUR MER',
    'OFFRANVILLE',
    'ST AUBIN SUR SCIE',
    'SAUQUEVILLE',
    'TOURVILLE SUR ARQUES',
  ],
  76920: ['AMFREVILLE LA MI VOIE'],
  76560: [
    'AMFREVILLE LES CHAMPS',
    'ANCOURTEVILLE SUR HERICOURT',
    'ANVEVILLE',
    'BENESVILLE',
    'BERVILLE EN CAUX',
    'BOUDEVILLE',
    'BRETTEVILLE ST LAURENT',
    'CANVILLE LES DEUX EGLISES',
    'CARVILLE POT DE FER',
    'DOUDEVILLE',
    'ETALLEVILLE',
    'FULTOT',
    'GONZEVILLE',
    'HARCANVILLE',
    'HERICOURT EN CAUX',
    'OHERVILLE',
    'PRETOT VICQUEMARE',
    'REUVILLE',
    'ROBERTOT',
    'ROUTES',
    'ST LAURENT EN CAUX',
    'SOMMESNIL',
    'LE TORP MESNIL',
    'VEAUVILLE LES QUELLES',
    'YVECRIQUE',
  ],
  76710: ['ANCEAUMEVILLE', 'BOSC GUERARD ST ADRIEN', 'ESLETTES', 'MONTVILLE'],
  76370: ['ANCOURT', 'DIEPPE', 'GREGES', 'MARTIN EGLISE', 'ROUXMESNIL BOUTEILLES', 'PETIT CAUX'],
  76760: [
    'ANCRETIEVILLE ST VICTOR',
    'AUZOUVILLE L ESNEVAL',
    'BOURDAINVILLE',
    'CRIQUETOT SUR OUVILLE',
    'ECTOT L AUBER',
    'LINDEBEUF',
    'OUVILLE L ABBAYE',
    'ST MARTIN AUX ARBRES',
    'SAUSSAY',
    'VIBEUF',
    'YERVILLE',
  ],
  76540: [
    'ANCRETTEVILLE SUR MER',
    'ANGERVILLE LA MARTEL',
    'CRIQUETOT LE MAUCONDUIT',
    'ECRETTEVILLE SUR MER',
    'ELETOT',
    'GERPONVILLE',
    'LIMPIVILLE',
    'RIVILLE',
    'ST MARTIN AUX BUNEAUX',
    'ST PIERRE EN PORT',
    'SASSETOT LE MAUCONDUIT',
    'SORQUAINVILLE',
    'THEROULDEVILLE',
    'THEUVILLE AUX MAILLOTS',
    'THIERGEVILLE',
    'THIETREVILLE',
    'VALMONT',
    'VINNEMERVILLE',
    'YPREVILLE BIVILLE',
  ],
  76110: [
    'ANGERVILLE BAILLEUL',
    'ANNOUVILLE VILMESNIL',
    'AUBERVILLE LA RENAULT',
    'BEC DE MORTAGNE',
    'BENARVILLE',
    'BORNAMBUSC',
    'BREAUTE',
    'BRETTEVILLE DU GRAND CAUX',
    'DAUBEUF SERVILLE',
    'ECRAINVILLE',
    'GODERVILLE',
    'GONFREVILLE CAILLOT',
    'GRAINVILLE YMAUVILLE',
    'HOUQUETOT',
    'MANNEVILLE LA GOUPIL',
    'MENTHEVILLE',
    'ST MACLOU LA BRIERE',
    'ST SAUVEUR D EMALLEVILLE',
    'SAUSSEUZEMARE EN CAUX',
    'TOCQUEVILLE LES MURS',
    'VATTETOT SOUS BEAUMONT',
    'VIRVILLE',
  ],
  76280: [
    'ANGERVILLE L ORCHER',
    'ANGLESQUEVILLE L ESNEVAL',
    'BEAUREPAIRE',
    'CRIQUETOT L ESNEVAL',
    'CUVERVILLE',
    'FONGUEUSEMARE',
    'GONNEVILLE LA MALLET',
    'HERMEVILLE',
    'HEUQUEVILLE',
    'PIERREFIQUES',
    'LA POTERIE CAP D ANTIFER',
    'ST JOUIN BRUNEVAL',
    'STE MARIE AU BOSC',
    'TURRETOT',
    'VERGETOT',
    'VILLAINVILLE',
  ],
  76740: [
    'ANGIENS',
    'ANGLESQUEVILLE LA BRAS LONG',
    'AUTIGNY',
    'LE BOURG DUN',
    'BOURVILLE',
    'BRAMETOT',
    'LA CHAPELLE SUR DUN',
    'CRASVILLE LA ROCQUEFORT',
    'ERMENOUVILLE',
    'FONTAINE LE DUN',
    'LA GAILLARDE',
    'HEBERVILLE',
    'HOUDETOT',
    'ST AUBIN SUR MER',
    'ST PIERRE LE VIEUX',
    'ST PIERRE LE VIGER',
    'SOTTEVILLE SUR MER',
  ],
  76890: [
    'VAL DE SAANE',
    'BEAUVAL EN CAUX',
    'BEAUTOT',
    'BELLEVILLE EN CAUX',
    'BERTRIMONT',
    'BIVILLE LA BAIGNARDE',
    'BUTOT',
    'CALLEVILLE LES DEUX EGLISES',
    'LA FONTELAYE',
    'GUEUTTEVILLE',
    'IMBLEVILLE',
    'ST DENIS SUR SCIE',
    'ST MACLOU DE FOLLEVILLE',
    'ST OUEN DU BREUIL',
    'ST PIERRE BENOUVILLE',
    'ST VAAST DU VAL',
    'ST VICTOR L ABBAYE',
    'TOTES',
    'VARNEVILLE BRETTEVILLE',
    'VASSONVILLE',
  ],
  76590: [
    'ANNEVILLE SUR SCIE',
    'BELMESNIL',
    'BERTREVILLE ST OUEN',
    'LE BOIS ROBERT',
    'LE CATELIER',
    'LES CENT ACRES',
    'LA CHAPELLE DU BOURGAY',
    'LA CHAUSSEE',
    'CRIQUETOT SUR LONGUEVILLE',
    'CROSVILLE SUR SCIE',
    'DENESTANVILLE',
    'GONNEVILLE SUR SCIE',
    'LINTOT LES BOIS',
    'LONGUEVILLE SUR SCIE',
    'MANEHOUVILLE',
    'MUCHEDENT',
    'NOTRE DAME DU PARC',
    'ST CRESPIN',
    'STE FOY',
    'ST GERMAIN D ETABLES',
    'ST HONORE',
    'TORCY LE GRAND',
    'TORCY LE PETIT',
  ],
  76480: [
    'ANNEVILLE AMBOURVILLE',
    'BARDOUVILLE',
    'BERVILLE SUR SEINE',
    'DUCLAIR',
    'EPINAY SUR DUCLAIR',
    'JUMIEGES',
    'LE MESNIL SOUS JUMIEGES',
    'ROUMARE',
    'STE MARGUERITE SUR DUCLAIR',
    'ST PAER',
    'ST PIERRE DE VARENGEVILLE',
    'YAINVILLE',
  ],
  76490: [
    'ANQUETIERVILLE',
    'RIVES EN SEINE',
    'LOUVETOT',
    'MAULEVRIER STE GERTRUDE',
    'ST ARNOULT',
    'ST GILLES DE CRETOT',
    'ST NICOLAS DE LA HAIE',
  ],
  76680: [
    'ARDOUVAL',
    'BELLENCOMBRE',
    'BOSC BERENGER',
    'BOSC MESNIL',
    'BRADIANCOURT',
    'CRITOT',
    'MATHONVILLE',
    'MAUCOMBLE',
    'MONTEROLIER',
    'NEUFBOSC',
    'POMMEREVAL',
    'ROCQUEMONT',
    'ROSAY',
    'ST HELLIER',
    'ST MARTIN OSMONVILLE',
    'ST SAENS',
    'VENTES ST REMY',
  ],
  76780: [
    'ARGUEIL',
    'LA CHAPELLE ST OUEN',
    'CROISY SUR ANDELLE',
    'ELBEUF SUR ANDELLE',
    'FRY',
    'LA HALLOTIERE',
    'LA HAYE',
    'LE HERON',
    'HODENG HODENGER',
    'MESANGUEVILLE',
    'LE MESNIL LIEUBRAY',
    'MORVILLE SUR ANDELLE',
    'NOLLEVAL',
    'ST LUCIEN',
    'SIGY EN BRAY',
  ],
  76880: ['ARQUES LA BATAILLE', 'MARTIGNY'],
  76390: [
    'AUBEGUIMONT',
    'AUMALE',
    'LE CAULE STE BEUVE',
    'CONTEVILLE',
    'CRIQUIERS',
    'ELLECOURT',
    'HAUDRICOURT',
    'ILLOIS',
    'LANDES VIEILLES ET NEUVES',
    'MARQUES',
    'NULLEMONT',
    'RICHEMONT',
    'RONCHOIS',
    'MORIENNE',
    'VIEUX ROUEN SUR BRESLE',
  ],
  76340: [
    'AUBERMESNIL AUX ERABLES',
    'BAZINVAL',
    'BLANGY SUR BRESLE',
    'CAMPNEUSEVILLE',
    'DANCOURT',
    'FALLENCOURT',
    'FOUCARMONT',
    'GUERVILLE',
    'HODENG AU BOSC',
    'MONCHAUX SORENG',
    'NESLE NORMANDEUSE',
    'PIERRECOURT',
    'REALCAMP',
    'RETONVAL',
    'RIEUX',
    'ST LEGER AUX BOIS',
    'ST MARTIN AU BOSC',
    'ST RIQUIER EN RIVIERE',
    'VILLERS SOUS FOUCARMONT',
  ],
  76450: [
    'AUBERVILLE LA MANUEL',
    'BERTHEAUVILLE',
    'BERTREVILLE',
    'BEUZEVILLE LA GUERARD',
    'BOSVILLE',
    'CANOUVILLE',
    'CANY BARVILLE',
    'CLASVILLE',
    'CLEUVILLE',
    'CRASVILLE LA MALLET',
    'GRAINVILLE LA TEINTURIERE',
    'LE HANOUARD',
    'HAUTOT L AUVRAY',
    'MALLEVILLE LES GRES',
    'OCQUEVILLE',
    'OUAINVILLE',
    'OURVILLE EN CAUX',
    'PALUEL',
    'ST MARTIN AUX BUNEAUX',
    'ST VAAST DIEPPEDALLE',
    'SASSEVILLE',
    'THIOUVILLE',
    'BUTOT VENESVILLE',
    'VEULETTES SUR MER',
    'VITTEFLEUR',
  ],
  76720: ['VAL DE SCIE', 'CROPUS', 'HEUGLEVILLE SUR SCIE'],
  76850: [
    'VAL DE SCIE',
    'BEAUMONT LE HARENG',
    'BOSC LE HARD',
    'BRACQUETUIT',
    'COTTEVRARD',
    'LA CRIQUE',
    'ETAIMPUIS',
    'FRESNAY LE LONG',
    'GRIGNEUSEVILLE',
    'MONTREUIL EN CAUX',
  ],
  76730: [
    'AUPPEGARD',
    'AUZOUVILLE SUR SAANE',
    'AVREMESNIL',
    'BACQUEVILLE EN CAUX',
    'BIVILLE LA RIVIERE',
    'BRACHY',
    'GONNETOT',
    'GUEURES',
    'HERMANVILLE',
    'LAMBERVILLE',
    'LAMMERVILLE',
    'LESTANVILLE',
    'OMONVILLE',
    'RAINFREVILLE',
    'ROYVILLE',
    'SAANE ST JUST',
    'ST MARDS',
    'ST OUEN LE MAUGER',
    'SASSETOT LE MALGARDE',
    'THIL MANNEVILLE',
    'TOCQUEVILLE EN CAUX',
    'VENESTANVILLE',
  ],
  76690: [
    'AUTHIEUX RATIEVILLE',
    'LE BOCASSE',
    'CAILLY',
    'CLAVILLE MOTTEVILLE',
    'CLERES',
    'ESTEVILLE',
    'FONTAINE LE BOURG',
    'FRICHEMESNIL',
    'GRUGNY',
    'LA HOUSSAYE BERANGER',
    'MONT CAUVAIRE',
    'LA RUE ST PIERRE',
    'ST ANDRE SUR CAILLY',
    'ST GEORGES SUR FONTAINE',
    'ST GERMAIN SOUS CAILLY',
    'SIERVILLE',
    'YQUEBEUF',
  ],
  76520: [
    'LES AUTHIEUX SUR LE PORT ST OUEN',
    'BOOS',
    'FRESNE LE PLAN',
    'GOUY',
    'MESNIL RAOUL',
    'MONTMAIN',
    'LA NEUVILLE CHANT D OISEL',
    'FRANQUEVILLE ST PIERRE',
    'QUEVREVILLE LA POTERIE',
    'ST AUBIN CELLOVILLE',
    'YMARE',
  ],
  76270: [
    'AUVILLIERS',
    'CALLENGEVILLE',
    'BOUELLES',
    'BULLY',
    'ESCLAVELLES',
    'FESQUES',
    'FLAMETS FRETILS',
    'FRESLES',
    'GRAVAL',
    'LUCY',
    'MASSY',
    'MENONVAL',
    'MESNIERES EN BRAY',
    'MORTEMER',
    'NESLE HODENG',
    'NEUFCHATEL EN BRAY',
    'NEUVILLE FERRIERES',
    'QUIEVRECOURT',
    'STE BEUVE EN RIVIERE',
    'ST GERMAIN SUR EAULNE',
    'ST MARTIN L HORTIER',
    'ST SAIRE',
    'VATIERVILLE',
  ],
  76116: [
    'AUZOUVILLE SUR RY',
    'BLAINVILLE CREVON',
    'CATENAY',
    'GRAINVILLE SUR RY',
    'MARTAINVILLE EPREVILLE',
    'RY',
    'ST AIGNAN SUR RY',
    'ST DENIS LE THIBOULT',
    'SERVAVILLE SALMONVILLE',
  ],
  76220: [
    'AVESNES EN BRAY',
    'BEAUVOIR EN LYONS',
    'BEZANCOURT',
    'BOSC HYONS',
    'BREMONTIER MERVAL',
    'CUY ST FIACRE',
    'DAMPIERRE EN BRAY',
    'DOUDEAUVILLE',
    'ELBEUF EN BRAY',
    'ERNEMONT LA VILLETTE',
    'FERRIERES EN BRAY',
    'LA FEUILLIE',
    'GANCOURT ST ETIENNE',
    'GOURNAY EN BRAY',
    'MENERVAL',
    'MOLAGNIES',
    'MONTROTY',
    'NEUF MARCHE',
  ],
  76630: [
    'AVESNES EN VAL',
    'BAILLY EN RIVIERE',
    'BELLENGREVILLE',
    'DOUVREND',
    'ENVERMEU',
    'LES IFS',
    'PETIT CAUX',
    'ST OUEN SOUS BAILLY',
    'SAUCHAY',
  ],
  76660: [
    'BAILLEUL NEUVILLE',
    'BAILLOLET',
    'BURES EN BRAY',
    'CLAIS',
    'CROIXDALLE',
    'FREAUVILLE',
    'FRESNOY FOLNY',
    'GRANDCOURT',
    'LONDINIERES',
    'MESNIL FOLLEMPRISE',
    'OSMOY ST VALERY',
    'PREUSEVILLE',
    'PUISENVAL',
    'STE AGATHE D ALIERMONT',
    'ST PIERRE DES JONQUIERES',
    'SMERMESNIL',
    'WANCHY CAPVAL',
  ],
  76360: ['BARENTIN', 'BOUVILLE', 'PISSY POVILLE', 'VILLERS ECALLES'],
  76260: [
    'BAROMESNIL',
    'CANEHAN',
    'CUVERVILLE SUR YERES',
    'ETALONDES',
    'EU',
    'FLOCQUES',
    'LONGROY',
    'MELLEVILLE',
    'LE MESNIL REAUME',
    'MILLEBOSC',
    'MONCHY SUR EU',
    'PONTS ET MARAIS',
    'ST MARTIN LE GAILLARD',
    'ST PIERRE EN VAL',
    'ST REMY BOSCROCOURT',
    'SEPT MEULES',
    'VILLY SUR YERES',
  ],
  76440: [
    'BEAUBEC LA ROSIERE',
    'LA BELLIERE',
    'COMPAINVILLE',
    'LA FERTE ST SAMSON',
    'FONTAINE EN BRAY',
    'FORGES LES EAUX',
    'GRUMESNIL',
    'HAUCOURT',
    'HAUSSEZ',
    'LONGMESNIL',
    'MAUQUENCHY',
    'MESNIL MAUGER',
    'POMMEREUX',
    'RONCHEROLLES EN BRAY',
    'ROUVRAY CATILLON',
    'STE GENEVIEVE',
    'ST MICHEL D HALESCOURT',
    'SAUMONT LA POTERIE',
    'SERQUEUX',
    'SOMMERY',
    'LE THIL RIBERPRE',
  ],
  76870: ['BEAUSSAULT', 'GAILLEFONTAINE'],
  76240: ['BELBEUF', 'BONSECOURS', 'LE MESNIL ESNARD'],
  76790: ['BENOUVILLE', 'BORDEAUX ST CLAIR', 'ETRETAT', 'GERVILLE', 'LES LOGES', 'LE TILLEUL'],
  76210: [
    'BERNIERES',
    'BEUZEVILLE LA GRENIER',
    'BEUZEVILLETTE',
    'BOLBEC',
    'BOLLEVILLE',
    'GRUCHET LE VALASSE',
    'LANQUETOT',
    'LINTOT',
    'MIRVILLE',
    'NOINTOT',
    'PARC D ANXTOT',
    'RAFFETOT',
    'ROUVILLE',
    'ST EUSTACHE LA FORET',
    'ST JEAN DE LA NEUVILLE',
    'TROUVILLE',
  ],
  76750: [
    'BIERVILLE',
    'BOIS GUILBERT',
    'BOIS HEROULT',
    'BOISSAY',
    'BOSC BORDEL',
    'BOSC EDELINE',
    'BUCHY',
    'ERNEMONT SUR BUCHY',
    'HERONCHELLES',
    'LONGUERUE',
    'MORGNY LA POMMERAYE',
    'PIERREVAL',
    'REBETS',
    'STE CROIX SUR BUCHY',
    'ST GERMAIN DES ESSOURTS',
    'VIEUX MANOIR',
  ],
  76420: ['BIHOREL'],
  76460: [
    'BLOSSEVILLE',
    'CAILLEVILLE',
    'DROSAY',
    'GUEUTTEVILLE LES GRES',
    'INGOUVILLE',
    'MANNEVILLE ES PLAINS',
    'LE MESNIL DURDENT',
    'NEVILLE',
    'PLEINE SEVE',
    'STE COLOMBE',
    'ST RIQUIER ES PLAINS',
    'ST SYLVAIN',
    'ST VALERY EN CAUX',
  ],
  76160: [
    'BOIS D ENNEBOURG',
    'BOIS L EVEQUE',
    'DARNETAL',
    'FONTAINE SOUS PREAUX',
    'PREAUX',
    'RONCHEROLLES SUR LE VIVIER',
    'ST AUBIN EPINAY',
    'ST JACQUES SUR DARNETAL',
    'ST LEGER DU BOURG DENIS',
    'ST MARTIN DU VIVIER',
    'LA VIEUX RUE',
  ],
  76230: ['BOIS GUILLAUME', 'ISNEAUVILLE', 'QUINCAMPOIX'],
  76530: ['LA BOUILLE', 'GRAND COURONNE', 'MAUNY', 'MOULINEAUX', 'YVILLE SUR SEINE'],
  76380: ['CANTELEU', 'MONTIGNY', 'VAL DE LA HAYE'],
  76320: ['CAUDEBEC LES ELBEUF', 'ST PIERRE LES ELBEUF'],
  76930: ['CAUVILLE SUR MER', 'OCTEVILLE SUR MER'],
  76430: [
    'LA CERLANGUE',
    'EPRETOT',
    'ETAINHUS',
    'GOMMERVILLE',
    'GRAIMBOUVILLE',
    'OUDALLE',
    'LA REMUEE',
    'SAINNEVILLE',
    'ST AUBIN ROUTOT',
    'ST GILLES DE LA NEUVILLE',
    'ST ROMAIN DE COLBOSC',
    'ST VIGOR D YMONVILLE',
    'ST VINCENT CRAMESNIL',
    'SANDOUVILLE',
    'TANCARVILLE',
    'LES TROIS PIERRES',
  ],
  76570: [
    'CIDEVILLE',
    'EMANVILLE',
    'FRESQUIENNES',
    'GOUPILLIERES',
    'HUGLEVILLE EN CAUX',
    'LIMESY',
    'MESNIL PANNEVILLE',
    'PAVILLY',
    'STE AUSTREBERTHE',
  ],
  76410: [
    'CLEON',
    'FRENEUSE',
    'ST AUBIN LES ELBEUF',
    'SOTTEVILLE SOUS LE VAL',
    'TOURVILLE LA RIVIERE',
  ],
  76400: [
    'COLLEVILLE',
    'CONTREMOULINS',
    'EPREVILLE',
    'FECAMP',
    'FROBERVILLE',
    'GANZEVILLE',
    'MANIQUERVILLE',
    'STE HELENE BONDEVILLE',
    'ST LEONARD',
    'SENNEVILLE SUR FECAMP',
    'TOURVILLE LES IFS',
    'TOUSSAINT',
  ],
  76910: ['CRIEL SUR MER', 'PETIT CAUX', 'TOUFFREVILLE SUR EU'],
  76111: ['CRIQUEBEUF EN CAUX', 'VATTETOT SUR MER', 'YPORT'],
  76510: [
    'DAMPIERRE ST NICOLAS',
    'FREULLEVILLE',
    'MEULERS',
    'NOTRE DAME D ALIERMONT',
    'RICARVILLE DU VAL',
    'ST AUBIN LE CAUF',
    'ST JACQUES D ALIERMONT',
    'ST NICOLAS D ALIERMONT',
    'ST VAAST D EQUIQUEVILLE',
  ],
  76250: ['DEVILLE LES ROUEN'],
  76200: ['DIEPPE'],
  76970: ['ECTOT LES BAONS', 'FLAMANVILLE', 'GREMONVILLE', 'MOTTEVILLE'],
  76500: ['ELBEUF', 'LA LONDE', 'ORIVAL'],
  76133: ['EPOUVILLE', 'MANEGLISE', 'NOTRE DAME DU BEC', 'ROLLEVILLE', 'ST MARTIN DU BEC'],
  76290: [
    'FONTAINE LA MALLET',
    'FONTENAY',
    'MANNEVILLETTE',
    'MONTIVILLIERS',
    'ST MARTIN DU MANOIR',
  ],
  76170: [
    'LA FRENAYE',
    'GRAND CAMP',
    'LILLEBONNE',
    'MELAMARE',
    'PORT JEROME SUR SEINE',
    'ST ANTOINE LA FORET',
    'ST JEAN DE FOLLEVILLE',
    'ST NICOLAS DE LA TAILLE',
    'LA TRINITE DU MONT',
  ],
  76700: [
    'GAINNEVILLE',
    'GONFREVILLE L ORCHER',
    'HARFLEUR',
    'ROGERVILLE',
    'ST LAURENT DE BREVEDENT',
  ],
  76950: ['LES GRANDES VENTES'],
  76120: ['LE GRAND QUEVILLY'],
  76810: ['GREUVILLE', 'GRUCHET ST SIMEON', 'LUNERAY'],
  76113: ['HAUTOT SUR SEINE', 'SAHURS', 'ST PIERRE DE MANNEVILLE'],
  76600: ['LE HAVRE'],
  76610: ['LE HAVRE'],
  76620: ['LE HAVRE'],
  76840: ['HENOUVILLE', 'QUEVILLON', 'ST MARTIN DE BOSCHERVILLE'],
  76940: ['HEURTEAUVILLE', 'ARELAUNE EN SEINE', 'NOTRE DAME DE BLIQUETUIT', 'VATTEVILLE LA RUE'],
  76770: ['LE HOULME', 'HOUPPEVILLE', 'MALAUNAY'],
  76117: ['INCHEVILLE'],
  76860: ['LONGUEIL', 'OUVILLE LA RIVIERE', 'QUIBERVILLE SUR MER', 'ST DENIS D ACLON'],
  76150: ['MAROMME', 'ST JEAN DU CARDONNAY', 'LA VAUPALIERE'],
  76130: ['MONT ST AIGNAN'],
  76330: ['NORVILLE', 'PORT JEROME SUR SEINE', 'PETIVILLE', 'ST MAURICE D ETELAN'],
  76960: ['NOTRE DAME DE BONDEVILLE'],
  76350: ['OISSEL'],
  76650: ['PETIT COURONNE'],
  76140: ['LE PETIT QUEVILLY'],
  76000: ['ROUEN'],
  76100: ['ROUEN'],
  76310: ['STE ADRESSE'],
  76800: ['ST ETIENNE DU ROUVRAY'],
  76119: ['STE MARGUERITE SUR MER', 'VARENGEVILLE SUR MER'],
  76300: ['SOTTEVILLE LES ROUEN'],
  76580: ['LE TRAIT'],
  76470: ['LE TREPORT'],
  76980: ['VEULES LES ROSES'],
  77760: [
    'ACHERES LA FORET',
    'AMPONVILLE',
    'BOISSY AUX CAILLES',
    'BOULANCOURT',
    'BURCY',
    'BUTHIERS',
    'LA CHAPELLE LA REINE',
    'CHEVRAINVILLIERS',
    'FROMONT',
    'GUERCHEVILLE',
    'LARCHANT',
    'NANTEAU SUR ESSONNE',
    'RECLOSES',
    'RUMONT',
    'URY',
    'VILLIERS SOUS GREZ',
  ],
  77120: [
    'AMILLIS',
    'AULNOY',
    'CHAILLY EN BRIE',
    'COULOMMIERS',
    'GIREMOUTIERS',
    'MAROLLES EN BRIE',
    'MAUPERTHUIS',
    'MOUROUX',
    'BEAUTHEIL SAINTS',
  ],
  77390: [
    'ANDREZEL',
    'ARGENTIERES',
    'BEAUVOIR',
    'CHAMPDEUIL',
    'CHAUMES EN BRIE',
    'COURQUETAINE',
    'COURTOMER',
    'CRISENOY',
    'FOUJU',
    'GUIGNES',
    'OZOUER LE VOULGIS',
    'VERNEUIL L ETANG',
    'YEBLES',
  ],
  77410: [
    'ANNET SUR MARNE',
    'CHARMENTRAY',
    'CHARNY',
    'CLAYE SOUILLY',
    'FRESNES SUR MARNE',
    'GRESSY',
    'MESSY',
    'PRECY SUR MARNE',
    'ST MESMES',
    'VILLEROY',
    'VILLEVAUDE',
  ],
  77630: ['ARBONNE LA FORET', 'BARBIZON', 'ST MARTIN EN BIERE'],
  77440: [
    'ARMENTIERES EN BRIE',
    'COCHEREL',
    'CONGIS SUR THEROUANNE',
    'DHUISY',
    'ISLES LES MELDEUSES',
    'JAIGNES',
    'LIZY SUR OURCQ',
    'MARY SUR MARNE',
    'OCQUERRE',
    'LE PLESSIS PLACY',
    'TANCROU',
    'TROCY EN MULTIEN',
    'VENDREST',
  ],
  77890: ['ARVILLE', 'BEAUMONT DU GATINAIS', 'GARENTREVILLE', 'GIRONVILLE', 'ICHY', 'OBSONVILLE'],
  77720: [
    'AUBEPIERRE OZOUER LE REPOS',
    'BOMBON',
    'BREAU',
    'CHAMPEAUX',
    'LA CHAPELLE GAUTHIER',
    'GRANDPUITS BAILLY CARROIS',
    'MORMANT',
    'QUIERS',
    'ST MERY',
    'ST OUEN EN BRIE',
  ],
  77570: [
    'AUFFERVILLE',
    'BOUGLIGNY',
    'CHATEAU LANDON',
    'CHENOU',
    'LA MADELEINE SUR LOING',
    'MAISONCELLES EN GATINAIS',
    'MONDREVILLE',
  ],
  77560: [
    'AUGERS EN BRIE',
    'BEAUCHERY ST MARTIN',
    'CHAMPCENEST',
    'COURCHAMP',
    'COURTACON',
    'LOUAN VILLEGRUIS FONTAINE',
    'LES MARETS',
    'RUPEREUX',
    'VILLIERS ST GEORGES',
    'VOULTON',
  ],
  77210: ['AVON', 'SAMOREAU'],
  77480: [
    'BABY',
    'BRAY SUR SEINE',
    'FONTAINE FOURCHES',
    'GRISY SUR SEINE',
    'JAULNES',
    'MONTIGNY LE GUESDIER',
    'MOUSSEAUX LES BRAY',
    'MOUY SUR SEINE',
    'PASSY SUR SEINE',
    'ST SAUVEUR LES BRAY',
    'VILLENAUXE LA PETITE',
    'VILLUIS',
  ],
  77167: ['BAGNEAUX SUR LOING', 'CHATENOY', 'FAY LES NEMOURS', 'ORMESSON', 'POLIGNY'],
  77700: ['BAILLY ROMAINVILLIERS', 'CHESSY', 'COUPVRAY', 'MAGNY LE HONGRE', 'SERRIS'],
  77118: ['BALLOY', 'BAZOCHES LES BRAY', 'GRAVON'],
  77970: ['BANNOST VILLEGAGNON', 'BEZALLES', 'BOISDON', 'JOUY LE CHATEL', 'PECY'],
  77130: [
    'BARBEY',
    'CANNES ECLUSE',
    'DORMELLES',
    'FORGES',
    'LA GRANDE PAROISSE',
    'MAROLLES SUR SEINE',
    'MISY SUR YONNE',
    'MONTEREAU FAULT YONNE',
    'ST GERMAIN LAVAL',
    'LA TOMBE',
    'VARENNES SUR SEINE',
    'VILLE ST JACQUES',
  ],
  77910: ['BARCY', 'CHAMBRY', 'GERMIGNY L EVEQUE', 'VARREDDES'],
  77750: [
    'BASSEVELLE',
    'BOITRON',
    'BUSSIERES',
    'ORLY SUR MORIN',
    'ST CYR SUR MORIN',
    'ST OUEN SUR MORIN',
  ],
  77510: [
    'BELLOT',
    'DOUE',
    'HONDEVILLIERS',
    'REBAIS',
    'SABLONNIERES',
    'ST DENIS LES REBAIS',
    'ST LEGER',
    'LA TRETOIRE',
    'VERDELOT',
    'VILLENEUVE SUR BELLOT',
  ],
  77540: [
    'BERNAY VILBERT',
    'LA CHAPELLE IGER',
    'COURPALAY',
    'LUMIGNY NESLES ORMEAUX',
    'LE PLESSIS FEU AUSSOUX',
    'ROZAY EN BRIE',
    'VOINSLES',
  ],
  77320: [
    'BETON BAZOCHES',
    'CERNEUX',
    'LA CHAPELLE MOUTILS',
    'CHARTRONGES',
    'CHEVRU',
    'CHOISY EN BRIE',
    'DAGNY',
    'LA FERTE GAUCHER',
    'FRETOY',
    'JOUY SUR MORIN',
    'LESCHEROLLES',
    'LEUDON EN BRIE',
    'MEILLERAY',
    'MONTDAUPHIN',
    'MONTENILS',
    'MONTOLIVET',
    'ST BARTHELEMY',
    'ST MARS VIEUX MAISONS',
    'ST MARTIN DES CHAMPS',
    'ST MARTIN DU BOSCHET',
    'ST REMY DE LA VANNE',
    'SANCY LES PROVINS',
  ],
  77115: ['BLANDY', 'SIVRY COURTRY'],
  77940: [
    'BLENNES',
    'LA BROSSE MONTCEAUX',
    'DIANT',
    'ESMANS',
    'FLAGY',
    'MONTMACHOUX',
    'NOISY RUDIGNON',
    'THOURY FEROTTES',
    'VOULX',
  ],
  77590: ['BOIS LE ROI', 'CHARTRETTES', 'FONTAINE LE PORT'],
  77350: ['BOISSETTES', 'BOISSISE LA BERTRAND', 'LE MEE SUR SEINE'],
  77310: ['BOISSISE LE ROI', 'PRINGY', 'ST FARGEAU PONTHIERRY'],
  77169: ['BOISSY LE CHATEL', 'CHAUFFRY', 'ST GERMAIN SOUS DOUE', 'ST SIMEON'],
  77580: [
    'BOULEURS',
    'COULOMMES',
    'COUTEVROULT',
    'CRECY LA CHAPELLE',
    'GUERARD',
    'LA HAUTE MAISON',
    'MAISONCELLES EN BRIE',
    'PIERRE LEVEE',
    'SANCY',
    'VAUCOURTOIS',
    'VILLIERS SUR MORIN',
    'VOULANGIS',
  ],
  77780: ['BOURRON MARLOTTE'],
  77470: [
    'BOUTIGNY',
    'FUBLAINES',
    'MONTCEAUX LES MEAUX',
    'POINCY',
    'ST FIACRE',
    'TRILPORT',
    'VILLEMAREUIL',
  ],
  77620: ['BRANSLES', 'EGREVILLE'],
  77170: ['BRIE COMTE ROBERT', 'COUBERT', 'SERVON'],
  77177: ['BROU SUR CHANTEREINE'],
  77600: [
    'BUSSY ST GEORGES',
    'BUSSY ST MARTIN',
    'CHANTELOUP EN BRIE',
    'CONCHES SUR GONDOIRE',
    'GUERMANTES',
    'JOSSIGNY',
  ],
  77400: [
    'CARNETIN',
    'DAMPMART',
    'GOUVERNES',
    'LAGNY SUR MARNE',
    'POMPONNE',
    'ST THIBAULT DES VIGNES',
    'THORIGNY SUR MARNE',
  ],
  77515: ['LA CELLE SUR MORIN', 'FAREMOUTIERS', 'HAUTEFEUILLE', 'POMMEUSE', 'ST AUGUSTIN'],
  77930: [
    'CELY',
    'CHAILLY EN BIERE',
    'FLEURY EN BIERE',
    'PERTHES',
    'ST GERMAIN SUR ECOLE',
    'ST SAUVEUR SUR ECOLE',
  ],
  77240: ['CESSON', 'SEINE PORT', 'VERT ST DENIS'],
  77520: [
    'CESSOY EN MONTOIS',
    'DONNEMARIE DONTILLY',
    'GURCY LE CHATEL',
    'LUISETAINES',
    'MEIGNEUX',
    'MONS EN MONTOIS',
    'MONTIGNY LENCOUP',
    'PAROY',
    'SIGY',
    'SOGNOLLES EN MONTOIS',
    'THENISY',
    'VIMPELLES',
  ],
  77460: ['CHAINTREAUX', 'SOUPPES SUR LOING'],
  77171: ['CHALAUTRE LA GRANDE', 'LECHELLE', 'MELZ SUR SEINE', 'SOURDUN'],
  77160: [
    'CHALAUTRE LA PETITE',
    'LA CHAPELLE ST SULPICE',
    'CHENOISE CUCHARMOY',
    'MORTERY',
    'POIGNY',
    'PROVINS',
    'ROUILLY',
    'ST BRICE',
    'ST HILLIERS',
    'VULAINES LES PROVINS',
  ],
  77144: ['CHALIFERT', 'MONTEVRAIN'],
  77650: [
    'CHALMAISON',
    'JUTIGNY',
    'LIZINES',
    'LONGUEVILLE',
    'STE COLOMBE',
    'ST LOUP DE NAUD',
    'SAVINS',
    'SOISY BOUY',
  ],
  77260: [
    'CHAMIGNY',
    'LA FERTE SOUS JOUARRE',
    'REUIL EN BRIE',
    'STE AULDE',
    'SAMMERON',
    'SEPT SORTS',
    'USSY SUR MARNE',
  ],
  77430: ['CHAMPAGNE SUR SEINE'],
  77420: ['CHAMPS SUR MARNE'],
  77660: ['CHANGIS SUR MARNE', 'ST JEAN LES DEUX JUMEAUX'],
  77370: [
    'LA CHAPELLE RABLAIS',
    'CHATEAUBLEAU',
    'CLOS FONTAINE',
    'LA CROIX EN BRIE',
    'FONTAINS',
    'FONTENAILLES',
    'GASTINS',
    'MAISON ROUGE',
    'NANGIS',
    'RAMPILLON',
    'ST JUST EN BRIE',
    'VANVILLE',
    'VIEUX CHAMPAGNE',
  ],
  77610: [
    'LES CHAPELLES BOURBON',
    'CHATRES',
    'CREVECOEUR EN BRIE',
    'FONTENAY TRESIGNY',
    'LA HOUSSAYE EN BRIE',
    'MARLES EN BRIE',
    'NEUFMOUTIERS EN BRIE',
  ],
  77820: ['LE CHATELET EN BRIE', 'CHATILLON LA BORDE', 'LES ECRENNES'],
  77126: ['CHATENAY SUR SEINE', 'COURCELLES EN BASSEE', 'EGLIGNY'],
  77500: ['CHELLES'],
  77173: ['CHEVRY COSSIGNY'],
  77710: [
    'CHEVRY EN SEREINE',
    'LORREZ LE BOCAGE PREAUX',
    'NANTEAU SUR LUNAIN',
    'PALEY',
    'REMAUVILLE',
    'TREUZY LEVELAY',
    'VAUX SUR LUNAIN',
    'VILLEBEON',
    'VILLEMARECHAL',
  ],
  77730: ['CITRY', 'MERY SUR MARNE', 'NANTEUIL SUR MARNE', 'SAACY SUR MARNE'],
  77090: ['COLLEGIEN'],
  77380: ['COMBS LA VILLE'],
  77290: ['COMPANS', 'MITRY MORY'],
  77450: [
    'CONDE STE LIBIAIRE',
    'ESBLY',
    'ISLES LES VILLENOY',
    'JABLINES',
    'LESCHES',
    'MONTRY',
    'TRILBARDOU',
    'VIGNELY',
  ],
  77860: ['COUILLY PONT AUX DAMES', 'QUINCY VOISINS', 'ST GERMAIN SUR MORIN'],
  77840: ['COULOMBS EN VALOIS', 'CROUY SUR OURCQ', 'GERMIGNY SOUS COULOMBS'],
  77181: ['COURTRY', 'LE PIN'],
  77154: ['COUTENCON', 'VILLENEUVE LES BORDES'],
  77124: ['CREGY LES MEAUX', 'CHAUCONIN NEUFMONTIERS', 'PENCHARD', 'VILLENOY'],
  77183: ['CROISSY BEAUBOURG'],
  77165: [
    'CUISY',
    'FORFRY',
    'GESVRES LE CHAPITRE',
    'IVERNY',
    'LE PLESSIS AUX BOIS',
    'LE PLESSIS L EVEQUE',
    'ST SOUPPLETS',
  ],
  77190: ['DAMMARIE LES LYS', 'VILLIERS EN BIERE'],
  77230: [
    'DAMMARTIN EN GOELE',
    'JUILLY',
    'LONGPERRIER',
    'MARCHEMORET',
    'MONTGE EN GOELE',
    'MOUSSY LE NEUF',
    'MOUSSY LE VIEUX',
    'NANTOUILLET',
    'ROUVRES',
    'ST MARD',
    'THIEUX',
    'VILLENEUVE SOUS DAMMARTIN',
    'VINANTES',
  ],
  77163: ['DAMMARTIN SUR TIGEAUX', 'MORTCERF', 'TIGEAUX'],
  77140: ['DARVAULT', 'MONTCOURT FROMONVILLE', 'NEMOURS', 'NONVILLE', 'ST PIERRE LES NEMOURS'],
  77139: ['DOUY LA RAMEE', 'ETREPILLY', 'MARCILLY', 'PUISIEUX', 'VINCY MANOEUVRE'],
  77830: ['ECHOUBOULAINS', 'PAMFOU', 'VALENCE EN BRIE'],
  77184: ['EMERAINVILLE'],
  77157: ['EVERLY'],
  77166: ['EVRY GREGY SUR YERRE', 'GRISY SUISNES'],
  77220: [
    'FAVIERES',
    'GRETZ ARMAINVILLIERS',
    'LIVERDY EN BRIE',
    'PRESLES EN BRIE',
    'TOURNAN EN BRIE',
  ],
  77133: ['FERICY', 'MACHAULT'],
  77150: ['FEROLLES ATTILLY', 'LESIGNY'],
  77164: ['FERRIERES EN BRIE'],
  77300: ['FONTAINEBLEAU'],
  77690: ['LA GENEVRAYE', 'MONTIGNY SUR LOING'],
  77114: ['GOUAIX', 'HERME', 'NOYEN SUR SEINE', 'VILLIERS SUR SEINE'],
  77880: ['GREZ SUR LOING'],
  77850: ['HERICY'],
  77640: ['JOUARRE', 'SIGNY SIGNETS'],
  77148: ['LAVAL EN BRIE', 'SALINS'],
  77127: ['LIEUSAINT'],
  77550: ['LIMOGES FOURCHES', 'LISSY', 'MOISSY CRAMAYEL', 'REAU'],
  77000: ['LIVRY SUR SEINE', 'MELUN', 'LA ROCHETTE', 'VAUX LE PENIL'],
  77185: ['LOGNES'],
  77138: ['LUZANCY'],
  77950: [
    'MAINCY',
    'MOISENAY',
    'MONTEREAU SUR LE JARD',
    'RUBELLES',
    'ST GERMAIN LAXIS',
    'VOISENON',
  ],
  77100: ['MAREUIL LES MEAUX', 'MEAUX', 'NANTEUIL LES MEAUX'],
  77990: ['MAUREGARD', 'LE MESNIL AMELOT'],
  77145: ['MAY EN MULTIEN'],
  77151: ['MONTCEAUX LES PROVINS'],
  77122: ['MONTHYON'],
  77250: ['MORET LOING ET ORVANNE', 'VILLECERF', 'VILLEMER'],
  77176: ['NANDY', 'SAVIGNY LE TEMPLE'],
  77186: ['NOISIEL'],
  77123: ['NOISY SUR ECOLE', 'TOUSSON', 'LE VAUDOUE'],
  77178: ['OISSERY', 'ST PATHUS'],
  77134: ['LES ORMES SUR VOULZIE'],
  77280: ['OTHIS'],
  77330: ['OZOIR LA FERRIERE'],
  77131: ['PEZARCHES', 'TOUQUIN'],
  77340: ['PONTAULT COMBAULT'],
  77135: ['PONTCARRE'],
  77680: ['ROISSY EN BRIE'],
  77670: ['ST MAMMES', 'VERNOU LA CELLE SUR SEINE'],
  77920: ['SAMOIS SUR SEINE'],
  77111: ['SOIGNOLLES EN BRIE', 'SOLERS'],
  77810: ['THOMERY'],
  77200: ['TORCY'],
  77360: ['VAIRES SUR MARNE'],
  77141: ['VAUDOY EN BRIE'],
  77174: ['VILLENEUVE LE COMTE', 'VILLENEUVE ST DENIS'],
  77270: ['VILLEPARISIS'],
  77870: ['VULAINES SUR SEINE'],
  78660: [
    'ABLIS',
    'ALLAINVILLE',
    'BOINVILLE LE GAILLARD',
    'ORSONVILLE',
    'PARAY DOUAVILLE',
    'PRUNAY EN YVELINES',
    'ST MARTIN DE BRETHENCOURT',
  ],
  78260: ['ACHERES'],
  78113: [
    'ADAINVILLE',
    'BOURDONNE',
    'CONDE SUR VESGRE',
    'GRANDCHAMP',
    'LA HAUTEVILLE',
    'LE TARTRE GAUDRAN',
  ],
  78240: ['AIGREMONT', 'CHAMBOURCY'],
  78580: ['LES ALLUETS LE ROI', 'BAZEMONT', 'HERBEVILLE', 'JUMEAUVILLE', 'MAULE'],
  78770: [
    'ANDELU',
    'AUTEUIL',
    'AUTOUILLET',
    'GOUPILLIERES',
    'MARCQ',
    'THOIRY',
    'VILLIERS LE MAHIEU',
  ],
  78570: ['ANDRESY', 'CHANTELOUP LES VIGNES'],
  78790: [
    'ARNOUVILLE LES MANTES',
    'COURGENT',
    'FLINS NEUVE EGLISE',
    'HARGEVILLE',
    'MONTCHAUVET',
    'MULCENT',
    'ROSAY',
    'ST MARTIN DES CHAMPS',
    'SEPTEUIL',
    'TILLY',
  ],
  78410: ['AUBERGENVILLE', 'BOUAFLE', 'LA FALAISE', 'FLINS SUR SEINE', 'NEZEL'],
  78610: ['AUFFARGIS', 'LES BREVIAIRES', 'LE PERRAY EN YVELINES', 'ST LEGER EN YVELINES'],
  78930: [
    'AUFFREVILLE BRASSEUIL',
    'BOINVILLE EN MANTOIS',
    'BREUIL BOIS ROBERT',
    'GOUSSONVILLE',
    'GUERVILLE',
    'VERT',
    'VILLETTE',
  ],
  78126: ['AULNAY SUR MAULDRE'],
  78870: ['BAILLY'],
  78550: ['BAZAINVILLE', 'DANNEMARIE', 'GRESSEY', 'HOUDAN', 'MAULETTE', 'RICHEBOURG'],
  78490: [
    'BAZOCHES SUR GUYONNE',
    'BOISSY SANS AVOIR',
    'GALLUIS',
    'GAMBAISEUIL',
    'GROSROUVRE',
    'MAREIL LE GUYON',
    'MERE',
    'LES MESNULS',
    'MONTFORT L AMAURY',
    'LE TREMBLAY SUR MAULDRE',
    'VICQ',
  ],
  78910: [
    'BEHOUST',
    'BOISSETS',
    'CIVRY LA FORET',
    'FLEXANVILLE',
    'ORGERUS',
    'ORVILLIERS',
    'OSMOY',
    'PRUNAY LE TEMPLE',
    'TACOIGNIERES',
  ],
  78270: [
    'BENNECOURT',
    'BLARU',
    'BONNIERES SUR SEINE',
    'CHAUFOUR LES BONNIERES',
    'CRAVENT',
    'GOMMECOURT',
    'NOTRE DAME DE LA MER',
    'LIMETZ VILLEZ',
    'LOMMOYE',
    'MERICOURT',
    'MOUSSEAUX SUR SEINE',
    'ROLLEBOISE',
    'LA VILLENEUVE EN CHEVRIE',
  ],
  78650: ['BEYNES', 'SAULX MARCHAIS'],
  78200: [
    'BOINVILLIERS',
    'BOISSY MAUVOISIN',
    'BUCHELAY',
    'FAVRIEUX',
    'FLACOURT',
    'FONTENAY MAUVOISIN',
    'JOUY MAUVOISIN',
    'MAGNANVILLE',
    'MANTES LA JOLIE',
    'MENERVILLE',
    'PERDREAUVILLE',
    'SOINDRES',
  ],
  78390: ['BOIS D ARCY'],
  78125: [
    'LA BOISSIERE ECOLE',
    'EMANCE',
    'GAZERAN',
    'HERMERAY',
    'MITTAINVILLE',
    'ORCEMONT',
    'ORPHIN',
    'POIGNY LA FORET',
    'RAIZEUX',
    'ST HILARION',
    'VIEILLE EGLISE EN YVELINES',
  ],
  78830: ['BONNELLES', 'BULLION'],
  78380: ['BOUGIVAL'],
  78980: [
    'BREVAL',
    'LONGNES',
    'MONDREVILLE',
    'NEAUPHLETTE',
    'ST ILLIERS LA VILLE',
    'ST ILLIERS LE BOIS',
    'LE TERTRE ST DENIS',
  ],
  78440: [
    'BRUEIL EN VEXIN',
    'DROCOURT',
    'FONTENAY ST PERE',
    'GARGENVILLE',
    'GUITRANCOURT',
    'ISSOU',
    'JAMBVILLE',
    'LAINVILLE EN VEXIN',
    'MONTALET LE BOIS',
    'PORCHEVILLE',
    'SAILLY',
  ],
  78530: ['BUC'],
  78955: ['CARRIERES SOUS POISSY'],
  78420: ['CARRIERES SUR SEINE'],
  78720: [
    'LA CELLE LES BORDES',
    'CERNAY LA VILLE',
    'DAMPIERRE EN YVELINES',
    'ST FORGET',
    'SENLISSE',
  ],
  78170: ['LA CELLE ST CLOUD'],
  78130: ['CHAPET', 'LES MUREAUX'],
  78117: ['CHATEAUFORT', 'TOUSSUS LE NOBLE'],
  78400: ['CHATOU'],
  78450: ['CHAVENAY', 'VILLEPREUX'],
  78150: ['LE CHESNAY ROCQUENCOURT'],
  78460: ['CHEVREUSE', 'CHOISEL'],
  78120: ['CLAIREFONTAINE EN YVELINES', 'RAMBOUILLET', 'SONCHAMP'],
  78340: ['LES CLAYES SOUS BOIS'],
  78310: ['COIGNIERES', 'MAUREPAS'],
  78700: ['CONFLANS STE HONORINE'],
  78121: ['CRESPIERES'],
  78290: ['CROISSY SUR SEINE'],
  78111: ['DAMMARTIN EN SERVE'],
  78810: ['DAVRON', 'FEUCHEROLLES'],
  78920: ['ECQUEVILLY'],
  78990: ['ELANCOURT'],
  78680: ['EPONE'],
  78690: ['LES ESSARTS LE ROI', 'ST REMY L HONORE'],
  78620: ['L ETANG LA VILLE'],
  78740: ['EVECQUEMONT', 'VAUX SUR SEINE'],
  78520: ['FOLLAINVILLE DENNEMONT', 'GUERNES', 'LIMAY', 'ST MARTIN LA GARENNE'],
  78330: ['FONTENAY LE FLEURY'],
  78840: ['FRENEUSE', 'MOISSON'],
  78250: [
    'GAILLON SUR MONTCIENT',
    'HARDRICOURT',
    'MEULAN EN YVELINES',
    'MEZY SUR SEINE',
    'OINVILLE SUR MONTCIENT',
    'TESSANCOURT SUR AUBETTE',
  ],
  78950: ['GAMBAIS'],
  78890: ['GARANCIERES'],
  78280: ['GUYANCOURT'],
  78800: ['HOUILLES'],
  78760: ['JOUARS PONTCHARTRAIN'],
  78350: ['JOUY EN JOSAS', 'LES LOGES EN JOSAS'],
  78820: ['JUZIERS'],
  78320: ['LEVIS ST NOM', 'LE MESNIL ST DENIS', 'LA VERRIERE'],
  78730: [
    'LONGVILLIERS',
    'PONTHEVRARD',
    'ROCHEFORT EN YVELINES',
    'ST ARNOULT EN YVELINES',
    'STE MESME',
  ],
  78430: ['LOUVECIENNES'],
  78114: ['MAGNY LES HAMEAUX'],
  78600: ['MAISONS LAFFITTE', 'LE MESNIL LE ROI'],
  78711: ['MANTES LA VILLE'],
  78750: ['MAREIL MARLY'],
  78124: ['MAREIL SUR MAULDRE', 'MONTAINVILLE'],
  78160: ['MARLY LE ROI'],
  78780: ['MAURECOURT'],
  78670: ['MEDAN', 'VILLENNES SUR SEINE'],
  78970: ['MEZIERES SUR SEINE'],
  78940: ['MILLEMONT', 'LA QUEUE LES YVELINES'],
  78470: ['MILON LA CHAPELLE', 'ST LAMBERT', 'ST REMY LES CHEVREUSE'],
  78360: ['MONTESSON'],
  78180: ['MONTIGNY LE BRETONNEUX'],
  78630: ['MORAINVILLIERS', 'ORGEVAL'],
  78640: [
    'NEAUPHLE LE CHATEAU',
    'NEAUPHLE LE VIEUX',
    'ST GERMAIN DE LA GRANGE',
    'VILLIERS ST FREDERIC',
  ],
  78590: ['NOISY LE ROI', 'RENNEMOULIN'],
  78230: ['LE PECQ'],
  78370: ['PLAISIR'],
  78300: ['POISSY'],
  78560: ['LE PORT MARLY'],
  78710: ['ROSNY SUR SEINE'],
  78210: ['ST CYR L ECOLE'],
  78100: ['ST GERMAIN EN LAYE'],
  78112: ['ST GERMAIN EN LAYE'],
  78860: ['ST NOM LA BRETECHE'],
  78500: ['SARTROUVILLE'],
  78850: ['THIVERVAL GRIGNON'],
  78190: ['TRAPPES'],
  78510: ['TRIEL SUR SEINE'],
  78140: ['VELIZY VILLACOUBLAY'],
  78480: ['VERNEUIL SUR SEINE'],
  78540: ['VERNOUILLET'],
  78000: ['VERSAILLES'],
  78110: ['LE VESINET'],
  78220: ['VIROFLAY'],
  78960: ['VOISINS LE BRETONNEUX'],
  79240: [
    'L ABSIE',
    'LE BUSSEAU',
    'LARGEASSE',
    'MONCOUTANT SUR SEVRE',
    'ST PAUL EN GATINE',
    'SCILLE',
    'TRAYES',
    'VERNOUX EN GATINE',
  ],
  79200: [
    'ADILLY',
    'LA CHAPELLE BERTRAND',
    'CHATILLON SUR THOUET',
    'GOURGE',
    'LAGEON',
    'PARTHENAY',
    'LA PEYRATTE',
    'POMPAIRE',
    'ST GERMAIN DE LONGUE CHAUME',
    'SAURAIS',
    'LE TALLUD',
    'VIENNAY',
  ],
  79230: [
    'AIFFRES',
    'BRULAIN',
    'FORS',
    'JUSCORPS',
    'PRAHECQ',
    'ST MARTIN DE BERNEGOUE',
    'ST ROMANS DES CHAMPS',
    'VOUILLE',
  ],
  79600: [
    'AIRVAULT',
    'ASSAIS LES JUMEAUX',
    'AVAILLES THOUARSAIS',
    'BOUSSAIS',
    'LE CHILLOU',
    'IRAIS',
    'LOUIN',
    'MAISONTIERS',
    'MARNES',
    'PLAINE ET VALLEES',
    'ST GENEROUX',
    'ST LOUP LAMAIRE',
  ],
  79130: [
    'ALLONNE',
    'AZAY SUR THOUET',
    'BEUGNON THIREUIL',
    'NEUVY BOUIN',
    'POUGNE HERISSON',
    'LE RETAIL',
    'SECONDIGNY',
  ],
  79350: ['AMAILLOUX', 'CHICHE', 'CLESSE', 'FAYE L ABBESSE'],
  79210: [
    'AMURE',
    'ARCAIS',
    'LE BOURDET',
    'MAUZE SUR LE MIGNON',
    'PRIN DEYRANCON',
    'ST GEORGES DE REX',
    'ST HILAIRE LA PALUD',
    'VAL DU MIGNON',
  ],
  79160: [
    'ARDIN',
    'BECELEUF',
    'BEUGNON THIREUIL',
    'COULONGES SUR L AUTIZE',
    'FAYE SUR ARDIN',
    'FENIOUX',
    'PUIHARDY',
    'ST LAURS',
    'ST MAIXENT DE BEUGNE',
    'ST POMPAIN',
    'VILLIERS EN PLAINE',
  ],
  79150: ['ARGENTONNAY', 'VAL EN VIGNES', 'GENNETON', 'VOULMENTIN', 'ST MAURICE ETUSSON'],
  79300: ['ARGENTONNAY', 'BOISME', 'BRESSUIRE', 'ST AUBIN DU PLAIN'],
  79290: ['LORETZ D ARGENTON', 'BRION PRES THOUET', 'VAL EN VIGNES', 'ST MARTIN DE SANZAY'],
  79170: [
    'ASNIERES EN POITOU',
    'BRIEUIL SUR CHIZE',
    'BRIOUX SUR BOUTONNE',
    'CHERIGNE',
    'CHIZE',
    'ENSIGNE',
    'JUILLE',
    'LUCHE SUR BRIOUX',
    'LUSSERAY',
    'PAIZAY LE CHAPT',
    'PERIGNE',
    'SECONDIGNE SUR BELLE',
    'SELIGNE',
    'VERNOUX SUR BOUTONNE',
    'LE VERT',
    'VILLEFOLLET',
    'VILLIERS SUR CHIZE',
  ],
  79110: [
    'AUBIGNE',
    'FONTIVILLIE',
    'CHEF BOUTONNE',
    'COUTURE D ARGENSON',
    'FONTENILLE ST MARTIN D ENTRAIGUES',
    'ALLOINAY',
    'VALDELAUME',
    'LOUBIGNE',
    'LOUBILLE',
    'VILLEMAIN',
  ],
  79390: [
    'AUBIGNY',
    'DOUX',
    'LA FERRIERE EN PARTHENAY',
    'LHOUMOIS',
    'OROUX',
    'PRESSIGNY',
    'THENEZAY',
  ],
  79400: [
    'AUGE',
    'AZAY LE BRULE',
    'EXIREUIL',
    'NANTEUIL',
    'ST GEORGES DE NOISNE',
    'ST MAIXENT L ECOLE',
    'ST MARTIN DE ST MAIXENT',
    'SAIVRES',
  ],
  79800: [
    'AVON',
    'BOUGON',
    'EXOUDUN',
    'LA MOTHE ST HERAY',
    'PAMPROUX',
    'PRAILLES LA COUARDE',
    'STE EANNE',
    'SALLES',
    'SOUDAN',
    'SOUVIGNE',
  ],
  79420: [
    'BEAULIEU SOUS PARTHENAY',
    'CLAVE',
    'REFFANNES',
    'ST LIN',
    'ST MARTIN DU FOUILLOUX',
    'VAUSSEROUX',
    'VAUTEBIS',
  ],
  79370: ['BEAUSSAIS VITRE', 'CELLES SUR BELLE', 'FRESSINES', 'AIGONDIGNE', 'PRAILLES LA COUARDE'],
  79360: [
    'BEAUVOIR SUR NIORT',
    'PLAINE D ARGENSON',
    'LES FOSSES',
    'LA FOYE MONJAULT',
    'GRANZAY GRIPT',
    'MARIGNY',
    'VAL DU MIGNON',
    'VILLIERS EN BOIS',
  ],
  79000: ['BESSINES', 'NIORT', 'SCIECQ'],
  79310: [
    'LA BOISSIERE EN GATINE',
    'MAZIERES EN GATINE',
    'ST MARC LA LANDE',
    'ST PARDOUX SOUTIERS',
    'VERRUYES',
    'VOUHE',
  ],
  79260: ['LA CRECHE', 'FRANCOIS', 'ROMANS', 'STE NEOMAYE'],
  79140: ['BRETIGNOLLES', 'CERIZAY', 'CIRIERES', 'COMBRAND', 'MONTRAVERS', 'LE PIN'],
  79190: [
    'CAUNAY',
    'LA CHAPELLE POUILLOUX',
    'CLUSSAIS LA POMMERAIE',
    'ALLOINAY',
    'LIMALONGES',
    'LORIGNE',
    'MAIRE LEVESCAULT',
    'MELLERAN',
    'MONTALEMBERT',
    'PERS',
    'PLIBOUX',
    'SAUZE VAUSSAIS',
  ],
  79500: [
    'FONTIVILLIE',
    'MAISONNAY',
    'MELLE',
    'MARCILLE',
    'ST ROMANS LES MELLE',
    'ST VINCENT LA CHATRE',
  ],
  79220: [
    'CHAMPDENIERS',
    'LA CHAPELLE BATON',
    'COURS',
    'GERMOND ROUVRE',
    'LES GROSEILLERS',
    'PAMPLIE',
    'ST CHRISTOPHE SUR ROC',
    'STE OUENNE',
    'SURIN',
    'XAINTRAY',
  ],
  79320: ['CHANTELOUP', 'MONCOUTANT SUR SEVRE'],
  79430: ['LA CHAPELLE ST LAURENT'],
  79700: ['MAULEON', 'LA PETITE BOISSIERE', 'ST AMAND SUR SEVRE', 'ST PIERRE DES ECHAUBROGNES'],
  79180: ['CHAURAY'],
  79120: [
    'CHENAY',
    'CHEY',
    'LEZAY',
    'MESSE',
    'ROM',
    'ST COUTANT',
    'STE SOLINE',
    'SEPVRET',
    'VANCAIS',
    'VANZAY',
  ],
  79410: ['CHERVEUX', 'ECHIRE', 'ST GELAIS', 'ST MAXIRE', 'ST REMY'],
  79510: ['COULON'],
  79330: [
    'COULONGES THOUARSAIS',
    'GEAY',
    'GLENAY',
    'LUCHE THOUARSAIS',
    'PIERREFITTE',
    'STE GEMME',
    'ST VARENT',
  ],
  79440: ['COURLAY'],
  79340: ['LES CHATELIERS', 'FOMPERRON', 'LES FORGES', 'MENIGOUTE', 'ST GERMIER', 'VASLES'],
  79270: [
    'EPANNES',
    'FRONTENAY ROHAN ROHAN',
    'LA ROCHENARD',
    'ST SYMPHORIEN',
    'SANSAIS',
    'VALLANS',
    'LE VANNEAU IRLEAU',
  ],
  79450: ['FENERY', 'ST AUBIN LE CLOUD'],
  79380: ['LA FORET SUR SEVRE', 'MONCOUTANT SUR SEVRE', 'ST ANDRE SUR SEVRE'],
  79100: [
    'LOUZY',
    'LUZAY',
    'PLAINE ET VALLEES',
    'PAS DE JEU',
    'ST CYR LA LANDE',
    'ST JACQUES DE THOUARS',
    'ST JEAN DE THOUARS',
    'ST LEGER DE MONTBRUN',
    'ST MARTIN DE MACON',
    'STE VERGE',
    'THOUARS',
    'TOURTENAY',
  ],
  79460: ['MAGNE'],
  79250: ['NUEIL LES AUBIERS'],
  80100: ['ABBEVILLE'],
  80320: [
    'ABLAINCOURT PRESSOIR',
    'CHAULNES',
    'FRESNES MAZANCOURT',
    'HALLU',
    'LICOURT',
    'LIHONS',
    'HYPERCOURT',
    'PUNCHY',
    'PUZEAUX',
    'VERMANDOVILLERS',
  ],
  80560: [
    'ACHEUX EN AMIENOIS',
    'ARQUEVES',
    'AUCHONVILLERS',
    'AUTHIE',
    'BAYENCOURT',
    'BERTRANCOURT',
    'BUS LES ARTOIS',
    'COIGNEUX',
    'COLINCAMPS',
    'CONTAY',
    'COURCELLES AU BOIS',
    'FORCEVILLE',
    'HARPONVILLE',
    'HEDAUVILLE',
    'LEALVILLERS',
    'LOUVENCOURT',
    'MAILLY MAILLET',
    'MARIEUX',
    'PUCHEVILLERS',
    'ST LEGER LES AUTHIE',
    'THIEVRES',
    'TOUTENCOURT',
    'VADENCOURT',
    'VARENNES',
    'VAUCHELLES LES AUTHIE',
  ],
  80210: [
    'ACHEUX EN VIMEU',
    'AIGNEVILLE',
    'CHEPY',
    'ERCOURT',
    'FEUQUIERES EN VIMEU',
    'FRANLEU',
    'MONS BOUBERT',
    'OCHANCOURT',
    'TOURS EN VIMEU',
    'VALINES',
  ],
  80370: [
    'AGENVILLE',
    'BEALCOURT',
    'BEAUMETZ',
    'BERNATRE',
    'BERNAVILLE',
    'CONTEVILLE',
    'CRAMONT',
    'DOMESMONT',
    'DOMLEGER LONGVILLERS',
    'EPECAMPS',
    'FROHEN SUR AUTHIE',
    'GORGES',
    'HEUZECOURT',
    'HIERMONT',
    'MAIZICOURT',
    'LE MEILLARD',
    'MONTIGNY LES JONGLEURS',
    'PROUVILLE',
    'ST ACHEUL',
  ],
  80150: [
    'AGENVILLERS',
    'LE BOISLE',
    'BOUFFLERS',
    'BRAILLY CORNEHOTTE',
    'CANCHY',
    'CRECY EN PONTHIEU',
    'DOMPIERRE SUR AUTHIE',
    'DOMVAST',
    'ESTREES LES CRECY',
    'FONTAINE SUR MAYE',
    'FOREST L ABBAYE',
    'FROYELLES',
    'GAPENNES',
    'GUESCHART',
    'LAMOTTE BULEUX',
    'LIGESCOURT',
    'MACHIEL',
    'MACHY',
    'MAISON PONTHIEU',
    'NEUILLY LE DIEN',
    'NOYELLES EN CHAUSSEE',
    'PONCHES ESTRUVAL',
    'VIRONCHAUX',
    'VITZ SUR AUTHIE',
    'YVRENCH',
    'YVRENCHEUX',
  ],
  80690: [
    'AILLY LE HAUT CLOCHER',
    'BRUCAMPS',
    'ERGNIES',
    'FRANCIERES',
    'GORENFLOS',
    'MOUFLERS',
    'VILLERS SOUS AILLY',
  ],
  80250: [
    'AILLY SUR NOYE',
    'CHAUSSOY EPAGNY',
    'CHIRMONT',
    'COULLEMELLE',
    'ESCLAINVILLERS',
    'ESTREES SUR NOYE',
    'LA FALOISE',
    'FOLLEVILLE',
    'GRIVESNES',
    'GUYENCOURT SUR NOYE',
    'HALLIVILLERS',
    'JUMEL',
    'LAWARDE MAUGER L HORTOY',
    'LOUVRECHY',
    'MALPART',
    'QUIRY LE SEC',
    'REMIENCOURT',
    'ROUVREL',
    'SOURDON',
    'THORY',
  ],
  80470: [
    'AILLY SUR SOMME',
    'ARGOEUVES',
    'BREILLY',
    'DREUIL LES AMIENS',
    'FERRIERES',
    'ST SAUVEUR',
    'SAVEUSE',
  ],
  80270: [
    'AIRAINES',
    'ALLERY',
    'AVELESGES',
    'BELLOY ST LEONARD',
    'BETTENCOURT RIVIERE',
    'HEUCOURT CROQUOISON',
    'LALEU',
    'METIGNY',
    'QUESNOY SUR AIRAINES',
    'TAILLY',
    'VERGIES',
    'WARLUS',
    'WIRY AU MONT',
  ],
  80240: [
    'AIZECOURT LE BAS',
    'BERNES',
    'DRIENCOURT',
    'GUYENCOURT SAULCOURT',
    'HANCOURT',
    'HERVILLY',
    'HESBECOURT',
    'LIERAMONT',
    'LONGAVESNES',
    'MARQUAIX',
    'NURLU',
    'POEUILLY',
    'ROISEL',
    'SOREL',
    'TEMPLEUX LA FOSSE',
    'TEMPLEUX LE GUERARD',
    'TINCOURT BOUCLY',
    'VILLERS FAUCON',
    'VRAIGNES EN VERMANDOIS',
  ],
  80200: [
    'AIZECOURT LE HAUT',
    'ALLAINES',
    'ASSEVILLERS',
    'ATHIES',
    'BARLEUX',
    'BELLOY EN SANTERRE',
    'BERNY EN SANTERRE',
    'BIACHES',
    'BOUCHAVESNES BERGEN',
    'BOUVINCOURT EN VERMANDOIS',
    'BRIE',
    'BUIRE COURCELLES',
    'BUSSU',
    'CARTIGNY',
    'CIZANCOURT',
    'CLERY SUR SOMME',
    'DEVISE',
    'DOINGT',
    'ENNEMAIN',
    'ESTREES DENIECOURT',
    'ETERPIGNY',
    'FAY',
    'FEUILLERES',
    'FLAUCOURT',
    'HERBECOURT',
    'MARCHELEPOT MISERY',
    'MESNIL BRUNTEL',
    'MOISLAINS',
    'MONCHY LAGACHE',
    'ESTREES MONS',
    'PERONNE',
    'ST CHRIST BRIOST',
    'SOYECOURT',
    'TERTRY',
    'VILLERS CARBONNEL',
  ],
  80300: [
    'ALBERT',
    'AUTHUILLE',
    'AVELUY',
    'BAIZIEUX',
    'BAZENTIN',
    'BEAUCOURT SUR L ANCRE',
    'BEAUMONT HAMEL',
    'BECORDEL BECOURT',
    'BOUZINCOURT',
    'BRESLE',
    'BUIRE SUR L ANCRE',
    'CONTALMAISON',
    'COURCELETTE',
    'DERNANCOURT',
    'ENGLEBELMER',
    'FRICOURT',
    'GRANDCOURT',
    'HENENCOURT',
    'IRLES',
    'LAVIEVILLE',
    'CARNOY MAMETZ',
    'MEAULTE',
    'MESNIL MARTINSART',
    'MILLENCOURT',
    'MIRAUMONT',
    'MONTAUBAN DE PICARDIE',
    'MORLANCOURT',
    'OVILLERS LA BOISSELLE',
    'POZIERES',
    'PYS',
    'SENLIS LE SEC',
    'THIEPVAL',
    'TREUX',
    'VILLE SUR ANCRE',
    'WARLOY BAILLON',
  ],
  80130: ['ALLENAY', 'BETHENCOURT SUR MER', 'BOURSEVILLE', 'FRIVILLE ESCARBOTIN', 'TULLY'],
  80260: [
    'ALLONVILLE',
    'BAVELINCOURT',
    'BEAUCOURT SUR L HALLUE',
    'BEHENCOURT',
    'BERTANGLES',
    'CARDONNETTE',
    'COISY',
    'FLESSELLES',
    'FRECHENCOURT',
    'HERISSART',
    'MIRVAUX',
    'MOLLIENS AU BOIS',
    'MONTIGNY SUR L HALLUE',
    'MONTONVILLERS',
    'NAOURS',
    'PIERREGOT',
    'POULAINVILLE',
    'RAINNEVILLE',
    'RUBEMPRE',
    'ST GRATIEN',
    'TALMAS',
    'VAUX EN AMIENOIS',
    'LA VICOGNE',
    'VILLERS BOCAGE',
  ],
  80000: ['AMIENS'],
  80080: ['AMIENS'],
  80090: ['AMIENS'],
  80140: [
    'ANDAINVILLE',
    'ARGUEL',
    'AUMATRE',
    'AVESNES CHAUSSOY',
    'BERMESNIL',
    'BIENCOURT',
    'CANNESSIERES',
    'CERISY BULEUX',
    'DOUDELAINVILLE',
    'EPAUMESNIL',
    'ETREJUST',
    'FONTAINE LE SEC',
    'FORCEVILLE EN VIMEU',
    'FOUCAUCOURT HORS NESLE',
    'FRAMICOURT',
    'FRESNES TILLOLOY',
    'FRESNEVILLE',
    'FRESNOY ANDAINVILLE',
    'FRETTECUISSE',
    'GREBAULT MESNIL',
    'HUPPY',
    'LIGNIERES EN VIMEU',
    'MARTAINNEVILLE',
    'MOUFLIERES',
    'NESLE L HOPITAL',
    'NESLETTE',
    'NEUVILLE AU BOIS',
    'OISEMONT',
    'RAMBURELLES',
    'RAMBURES',
    'ST LEGER SUR BRESLE',
    'ST MAULVIS',
    'ST MAXENT',
    'SENARPONT',
    'LE TRANSLAY',
    'VAUX MARQUENNEVILLE',
    'VILLEROY',
    'VILLERS CAMPSART',
    'VISMES',
    'WOIREL',
  ],
  80700: [
    'ANDECHY',
    'ARMANCOURT',
    'BALATRE',
    'BEUVRAIGNES',
    'BUS LA MESIERE',
    'CARREPUIS',
    'CHAMPIEN',
    'LA CHAVATTE',
    'CREMERY',
    'DAMERY',
    'DANCOURT POPINCOURT',
    'L ECHELLE ST AURIN',
    'FONCHES FONCHETTE',
    'FRANSART',
    'FRESNOY LES ROYE',
    'GOYENCOURT',
    'GRIVILLERS',
    'GRUNY',
    'HATTENCOURT',
    'LAUCOURT',
    'LIANCOURT FOSSE',
    'MARCHE ALLOUARDE',
    'MARQUIVILLERS',
    'PARVILLERS LE QUESNOY',
    'RETHONVILLERS',
    'ROIGLISE',
    'ROYE',
    'ST MARD',
    'TILLOLOY',
    'VERPILLIERES',
    'VILLERS LES ROYE',
  ],
  80120: [
    'ARGOULES',
    'ARRY',
    'BERNAY EN PONTHIEU',
    'DOMINOIS',
    'FAVIERES',
    'FOREST MONTIERS',
    'FORT MAHON PLAGE',
    'NAMPONT',
    'QUEND',
    'REGNIERE ECLUSE',
    'RUE',
    'ST QUENTIN EN TOURMONT',
    'VERCOURT',
    'VILLERS SUR AUTHIE',
    'VRON',
  ],
  80820: ['ARREST'],
  80910: ['ARVILLERS', 'BOUCHOIR'],
  80500: [
    'ASSAINVILLERS',
    'AYENCOURT',
    'BECQUIGNY',
    'BOUILLANCOURT LA BATAILLE',
    'BOUSSICOURT',
    'CANTIGNY',
    'LE CARDONNOIS',
    'COURTEMANCHE',
    'DAVENESCOURT',
    'ERCHES',
    'ETELFAY',
    'FAVEROLLES',
    'FESCAMPS',
    'FIGNIERES',
    'FONTAINE SOUS MONTDIDIER',
    'GRATIBUS',
    'GUERBIGNY',
    'LABOISSIERE EN SANTERRE',
    'LIGNIERES',
    'MARESTMONTIERS',
    'MESNIL ST GEORGES',
    'MONTDIDIER',
    'PIENNES ONVILLERS',
    'TROIS RIVIERES',
    'REMAUGIES',
    'ROLLOT',
    'RUBESCOURT',
    'VILLERS TOURNELLE',
    'WARSY',
  ],
  80110: [
    'AUBERCOURT',
    'AUBVILLERS',
    'BEAUCOURT EN SANTERRE',
    'BERTEAUCOURT LES THENNES',
    'BRACHES',
    'DEMUIN',
    'DOMART SUR LA LUCE',
    'FRESNOY EN CHAUSSEE',
    'HANGARD',
    'MAILLY RAINEVAL',
    'MEZIERES EN SANTERRE',
    'MOREUIL',
    'MORISEL',
    'LA NEUVILLE SIRE BERNARD',
    'LE PLESSIER ROZAINVILLERS',
    'SAUVILLERS MONGIVAL',
    'THENNES',
    'VILLERS AUX ERABLES',
  ],
  80800: [
    'AUBIGNY',
    'BONNAY',
    'BUSSY LES DAOURS',
    'CACHY',
    'CAYEUX EN SANTERRE',
    'CERISY',
    'CHIPILLY',
    'CORBIE',
    'DAOURS',
    'FOUILLOY',
    'FRANVILLERS',
    'GENTELLES',
    'LE HAMEL',
    'HAMELET',
    'HEILLY',
    'IGNAUCOURT',
    'LAHOUSSOYE',
    'LAMOTTE WARFUSEE',
    'MARCELCAVE',
    'MERICOURT L ABBE',
    'RIBEMONT SUR ANCRE',
    'SAILLY LAURETTE',
    'SAILLY LE SEC',
    'VAIRE SOUS CORBIE',
    'VAUX SUR SOMME',
    'VECQUEMONT',
    'VILLERS BRETONNEUX',
  ],
  80460: ['AULT', 'FRIAUCOURT', 'OUST MAREST', 'WOIGNARUE'],
  80640: [
    'AUMONT',
    'DROMESNIL',
    'HORNOY LE BOURG',
    'MERICOURT EN VIMEU',
    'THIEULLOY L ABBAYE',
    'VRAIGNES LES HORNOY',
  ],
  80600: [
    'AUTHEUX',
    'AUTHIEULE',
    'BARLY',
    'BEAUQUESNE',
    'BOISBERGUES',
    'BOUQUEMAISON',
    'BREVILLERS',
    'DOULLENS',
    'GEZAINCOURT',
    'GROUCHES LUCHUEL',
    'HEM HARDINVAL',
    'HUMBERCOURT',
    'LONGUEVILLETTE',
    'LUCHEUX',
    'MEZEROLLES',
    'NEUVILLETTE',
    'OCCOCHES',
    'OUTREBOIS',
    'RAINCHEVAL',
    'REMAISNIL',
    'TERRAMESNIL',
  ],
  80480: [
    'BACOUEL SUR SELLE',
    'CREUSE',
    'DURY',
    'PONT DE METZ',
    'SALEUX',
    'SALOUEL',
    'VERS SUR SELLE',
  ],
  80490: [
    'BAILLEUL',
    'CITERNE',
    'FRUCOURT',
    'HALLENCOURT',
    'LIMEUX',
    'MERELESSART',
    'SOREL EN VIMEU',
  ],
  80170: [
    'BAYONVILLERS',
    'BEAUFORT EN SANTERRE',
    'CAIX',
    'CHILLY',
    'FOLIES',
    'FOUQUESCOURT',
    'GUILLAUCOURT',
    'MAUCOURT',
    'MEHARICOURT',
    'ROSIERES EN SANTERRE',
    'ROUVROY EN SANTERRE',
    'VRELY',
    'WARVILLERS',
    'WIENCOURT L EQUIPEE',
  ],
  80430: [
    'BEAUCAMPS LE JEUNE',
    'BEAUCAMPS LE VIEUX',
    'BROCOURT',
    'INVAL BOIRON',
    'LAFRESGUIMONT ST MARTIN',
    'LIOMER',
    'LE MAZIS',
    'NEUVILLE COPPEGUEULE',
    'LE QUESNE',
    'ST AUBIN RIVIERE',
    'ST GERMAIN SUR BRESLE',
  ],
  80770: ['BEAUCHAMPS'],
  80630: ['BEAUVAL'],
  80870: ['BEHEN', 'MOYENNEVILLE', 'TOEUFLES'],
  80132: [
    'BELLANCOURT',
    'BUIGNY L ABBE',
    'BUIGNY ST MACLOU',
    'CAHON',
    'CAMBRON',
    'CAOURS',
    'DRUCAT',
    'GRAND LAVIERS',
    'HAUTVILLERS OUVILLE',
    'HUCHENNEVILLE',
    'MAREUIL CAUBERT',
    'MIANNAY',
    'NEUFMOULIN',
    'NEUILLY L HOPITAL',
    'PORT LE GRAND',
    'QUESNOY LE MONTANT',
    'LE TITRE',
    'VAUCHELLES LES QUESNOY',
    'YONVAL',
  ],
  80160: [
    'BELLEUSE',
    'BOSQUEL',
    'BRASSY',
    'CONTRE',
    'CONTY',
    'COURCELLES SOUS THOIX',
    'ESSERTAUX',
    'FLERS SUR NOYE',
    'FLEURY',
    'FOSSEMANANT',
    'FRANSURES',
    'FREMONTIERS',
    'O DE SELLE',
    'MONSURES',
    'NAMPTY',
    'ORESMAUX',
    'PLACHY BUYON',
    'PROUZEL',
    'ROGY',
    'ST SAUFLIEU',
    'SENTELIE',
    'THOIX',
    'VELENNES',
  ],
  80310: [
    'BELLOY SUR SOMME',
    'BOURDON',
    'CAVILLON',
    'LA CHAUSSEE TIRANCOURT',
    'CROUY ST PIERRE',
    'FOURDRINOY',
    'HANGEST SUR SOMME',
    'LE MESGE',
    'PICQUIGNY',
    'RIENCOURT',
    'ST VAAST EN CHAUSSEE',
    'SOUES',
    'YZEUX',
  ],
  80290: [
    'BERGICOURT',
    'BETTEMBOS',
    'BLANGY SOUS POIX',
    'BUSSY LES POIX',
    'CAULIERES',
    'COURCELLES SOUS MOYENCOURT',
    'CROIXRAULT',
    'EPLESSIER',
    'EQUENNES ERAMECOURT',
    'FAMECHON',
    'FOURCIGNY',
    'FRESNOY AU VAL',
    'FRICAMPS',
    'GAUVILLE',
    'GUIZANCOURT',
    'HESCAMPS',
    'LACHAPELLE',
    'LAMARONDE',
    'LIGNIERES CHATELAIN',
    'MARLERS',
    'MEIGNEUX',
    'MEREAUCOURT',
    'MORVILLERS ST SATURNIN',
    'MOYENCOURT LES POIX',
    'NAMPS MAISNIL',
    'OFFIGNIES',
    'POIX DE PICARDIE',
    'STE SEGREE',
    'SAULCHOY SOUS POIX',
    'THIEULLOY LA VILLE',
  ],
  80620: [
    'BERNEUIL',
    'DOMART EN PONTHIEU',
    'DOMQUEUR',
    'FRANQUEVILLE',
    'FRANSU',
    'LANCHES ST HILAIRE',
    'MESNIL DOMQUEUR',
    'RIBEAUCOURT',
    'SURCAMPS',
    'VAUCHELLES LES DOMART',
  ],
  80850: ['BERTEAUCOURT LES DAMES'],
  80190: [
    'BETHENCOURT SUR SOMME',
    'BIARRE',
    'BILLANCOURT',
    'CRESSY OMENCOURT',
    'CURCHY',
    'EPENANCOURT',
    'ETALON',
    'FALVY',
    'HERLY',
    'LANGUEVOISIN QUIQUERY',
    'MESNIL ST NICAISE',
    'MORCHAIN',
    'NESLE',
    'PARGNY',
    'POTTE',
    'ROUY LE GRAND',
    'ROUY LE PETIT',
    'VILLECOURT',
    'Y',
  ],
  80610: ['BETTENCOURT ST OUEN', 'ST OUEN'],
  80440: [
    'BLANGY TRONVILLE',
    'BOVES',
    'COTTENCHY',
    'DOMMARTIN',
    'FOUENCAMPS',
    'GLISY',
    'HAILLES',
    'THEZY GLIMONT',
  ],
  80230: [
    'BOISMONT',
    'BRUTELLES',
    'ESTREBOEUF',
    'LANCHERES',
    'PENDE',
    'SAIGNEVILLE',
    'ST VALERY SUR SOMME',
    'VAUDRICOURT',
  ],
  80670: [
    'BONNEVILLE',
    'CANAPLES',
    'HALLOY LES PERNOIS',
    'HAVERNAS',
    'FIEFFES MONTRELET',
    'PERNOIS',
    'WARGNIES',
  ],
  80830: ['BOUCHON', 'L ETOILE'],
  80540: [
    'BOUGAINVILLE',
    'BOVELLES',
    'BRIQUEMESNIL FLOXICOURT',
    'CAMPS EN AMIENOIS',
    'CLAIRY SAULCHOIX',
    'FLUY',
    'GUIGNEMICOURT',
    'MOLLIENS DREUIL',
    'MONTAGNE FAYEL',
    'OISSY',
    'PISSY',
    'REVELLES',
    'ST AUBIN MONTENOY',
    'SAISSEVAL',
    'SEUX',
  ],
  80220: [
    'BOUILLANCOURT EN SERY',
    'BOUTTENCOURT',
    'BOUVAINCOURT SUR BRESLE',
    'BUIGNY LES GAMACHES',
    'FRETTEMEULE',
    'GAMACHES',
    'MAISNIERES',
    'TILLOY FLORIVILLE',
  ],
  80580: [
    'BRAY LES MAREUIL',
    'EAUCOURT SUR SOMME',
    'EPAGNE EPAGNETTE',
    'ERONDELLE',
    'LIERCOURT',
    'PONT REMY',
  ],
  80340: [
    'BRAY SUR SOMME',
    'CAPPY',
    'CHUIGNES',
    'CHUIGNOLLES',
    'ECLUSIER VAUX',
    'ETINEHEM MERICOURT',
    'FONTAINE LES CAPPY',
    'FOUCAUCOURT EN SANTERRE',
    'FRISE',
    'HERLEVILLE',
    'MORCOURT',
    'LA NEUVILLE LES BRAY',
    'PROYART',
    'SUZANNE',
  ],
  80400: [
    'BREUIL',
    'BROUCHY',
    'BUVERCHY',
    'CROIX MOLIGNEAUX',
    'DOUILLY',
    'EPPEVILLE',
    'ERCHEU',
    'ESMERY HALLON',
    'HAM',
    'HOMBLEUX',
    'MATIGNY',
    'MOYENCOURT',
    'MUILLE VILLETTE',
    'OFFOY',
    'QUIVIERES',
    'SANCOURT',
    'UGNY L EQUIPEE',
    'VOYENNES',
  ],
  80135: [
    'BUSSUS BUSSUEL',
    'COULONVILLERS',
    'MAISON ROLAND',
    'MILLENCOURT EN PONTHIEU',
    'ONEUX',
    'ST RIQUIER',
    'YAUCOURT BUSSUS',
  ],
  80330: ['CAGNY', 'LONGUEAU'],
  80450: ['CAMON', 'LAMOTTE BREBIERE'],
  80750: ['CANDAS', 'FIENVILLERS'],
  80410: ['CAYEUX SUR MER'],
  80510: ['COCQUEREL', 'FONTAINE SUR SOMME', 'LONG', 'LONGPRE LES CORPS SAINTS'],
  80360: [
    'COMBLES',
    'CURLU',
    'EQUANCOURT',
    'ETRICOURT MANANCOURT',
    'FINS',
    'FLERS',
    'GINCHY',
    'GUEUDECOURT',
    'GUILLEMONT',
    'HARDECOURT AUX BOIS',
    'HEM MONACU',
    'LESBOEUFS',
    'LONGUEVAL',
    'MARICOURT',
    'MAUREPAS',
    'MESNIL EN ARROUAISE',
    'RANCOURT',
    'SAILLY SAILLISEL',
  ],
  80890: ['CONDE FOLIE'],
  80550: ['LE CROTOY'],
  80570: ['DARGNIES', 'EMBREVILLE'],
  80980: ['DOMPIERRE BECQUINCOURT'],
  80740: ['EPEHY', 'RONSSOY'],
  80420: ['FLIXECOURT', 'VILLE LE MARCLET'],
  80131: ['FRAMERVILLE RAINECOURT', 'HARBONNIERES', 'VAUVILLERS'],
  80390: ['FRESSENNEVILLE', 'NIBAS'],
  80680: ['GRATTEPANCHE', 'HEBECOURT', 'RUMIGNY', 'SAINS EN AMIENOIS', 'ST FUSCIEN'],
  80134: ['HANGEST EN SANTERRE'],
  80122: ['HEUDICOURT'],
  80520: ['MENESLIES', 'WOINCOURT', 'YZENGREMER'],
  80350: ['MERS LES BAINS'],
  80860: ['NOUVION', 'NOYELLES SUR MER', 'PONTHOILE'],
  80115: ['PONT NOYELLES', 'QUERRIEU'],
  80118: ['LE QUESNEL'],
  80710: ['QUEVAUVILLERS'],
  80136: ['RIVERY'],
  80970: ['SAILLY FLIBEAUCOURT'],
  80960: ['ST BLIMONT'],
  80780: ['ST LEGER LES DOMART'],
  80880: ['ST QUENTIN LA MOTTE CROIX AU BAILLY'],
  80650: ['VIGNACOURT'],
  81470: [
    'AGUTS',
    'ALGANS',
    'CAMBON LES LAVAUR',
    'CUQ TOULZA',
    'LACROISILLE',
    'MAURENS SCOPONT',
    'MONTGEY',
    'MOUZENS',
    'PECHAUDIER',
    'PUECHOURSI',
    'ROQUEVIDAL',
  ],
  81200: ['AIGUEFONDE', 'AUSSILLON', 'CAUCALIERES', 'MAZAMET'],
  81250: ['ALBAN', 'CURVALLE', 'MASSALS', 'MIOLLES', 'PAULINET', 'ST ANDRE'],
  81000: ['ALBI'],
  81240: [
    'ALBINE',
    'LACABAREDE',
    'LE RIALET',
    'ROUAIROUX',
    'ST AMANS SOULT',
    'ST AMANS VALTORET',
    'SAUVETERRE',
    'LE VINTROU',
  ],
  81140: [
    'ALOS',
    'ANDILLAC',
    'CAHUZAC SUR VERE',
    'CAMPAGNAC',
    'CASTELNAU DE MONTMIRAL',
    'LARROQUE',
    'MONTELS',
    'PENNE',
    'PUYCELSI',
    'ROUSSAYROLLES',
    'ST BEAUZILE',
    'STE CECILE DU CAYROU',
    'ST MICHEL DE VAX',
    'VAOUR',
    'LE VERDIER',
    'VIEUX',
  ],
  81190: [
    'ALMAYRAC',
    'JOUQUEVIEL',
    'MIRANDOL BOURGNOUNAC',
    'MONTAURIOL',
    'MONTIRAT',
    'MOULARES',
    'PAMPELONNE',
    'ST CHRISTOPHE',
    'STE GEMME',
    'TANUS',
    'TREBAN',
    'TREVIEN',
  ],
  81170: [
    'AMARENS',
    'BOURNAZEL',
    'LES CABANNES',
    'CORDES SUR CIEL',
    'DONNAZAC',
    'FRAUSSEILLES',
    'ITZAC',
    'LABARTHE BLEYS',
    'LACAPELLE SEGALAR',
    'LIVERS CAZELLES',
    'LOUBERS',
    'MARNAVES',
    'MILHARS',
    'MONTROSIER',
    'MOUZIEYS PANENS',
    'NOAILLES',
    'LE RIOLS',
    'ST MARCEL CAMPES',
    'ST MARTIN LAGUEPIE',
    'SOUEL',
    'TONNAC',
    'VINDRAC ALAYRAC',
  ],
  81430: [
    'AMBIALET',
    'BELLEGARDE MARSAL',
    'LE FRAYSSE',
    'MOUZIEYS TEULET',
    'VILLEFRANCHE D ALBIGEOIS',
  ],
  81500: [
    'AMBRES',
    'BANNIERES',
    'BELCASTEL',
    'CABANES',
    'FIAC',
    'GARRIGUES',
    'GIROUSSENS',
    'LABASTIDE ST GEORGES',
    'LACOUGOTTE CADOUL',
    'LAVAUR',
    'LUGAN',
    'MARZENS',
    'MASSAC SERAN',
    'MONTCABRIER',
    'PRATVIEL',
    'ST AGNAN',
    'ST JEAN DE RIVES',
    'ST LIEUX LES LAVAUR',
    'TEULAT',
    'VEILHES',
    'VILLENEUVE LES LAVAUR',
    'VIVIERS LES LAVAUR',
  ],
  81350: [
    'ANDOUQUE',
    'CRESPIN',
    'CRESPINET',
    'ST GREGOIRE',
    'ST JEAN DE MARCEL',
    'SAUSSENAC',
    'SERENAC',
    'VALDERIES',
  ],
  81260: [
    'ANGLES',
    'BERLATS',
    'LE BEZ',
    'BRASSAC',
    'CAMBOUNES',
    'FONTRIEU',
    'ESPERAUSSES',
    'LAMONTELARIE',
    'LASFAILLADES',
  ],
  81700: [
    'APPELLE',
    'BERTRE',
    'BLAN',
    'GARREVAQUES',
    'LEMPAUT',
    'PALLEVILLE',
    'POUDIS',
    'PUYLAURENS',
    'ST GERMAIN DES PRES',
    'ST SERNIN LES LAVAUR',
  ],
  81110: [
    'ARFONS',
    'DOURGNE',
    'LAGARDIOLLE',
    'LESCOUT',
    'MASSAGUEL',
    'ST AMANCET',
    'ST AVIT',
    'VERDALLE',
  ],
  81360: ['ARIFAT', 'MONTREDON LABESSONNIE'],
  81160: ['ARTHES', 'ST JUERY'],
  81340: [
    'ASSAC',
    'CADIX',
    'COURRIS',
    'LE DOURN',
    'FAUSSERGUES',
    'FRAISSINES',
    'LACAPELLE PINET',
    'LEDAS ET PENTHIES',
    'PADIES',
    'ST CIRGUE',
    'ST JULIEN GAULENE',
    'ST MICHEL LABADIE',
    'TREBAS',
    'VALENCE D ALBIGEOIS',
  ],
  81600: [
    'AUSSAC',
    'BRENS',
    'BROZE',
    'CADALEN',
    'FENOLS',
    'GAILLAC',
    'MONTANS',
    'RIVIERES',
    'SENOUILLAC',
    'TECOU',
  ],
  81320: ['BARRE', 'MOULIN MAGE', 'MURAT SUR VEBRE', 'NAGES'],
  81630: [
    'BEAUVAIS SUR TESCOU',
    'MONTDURAUSSE',
    'MONTGAILLARD',
    'MONTVALEN',
    'ST URCISSE',
    'SALVAGNAC',
    'LA SAUZIERE ST JEAN',
    'TAURIAC',
  ],
  81540: ['BELLESERRE', 'CAHUZAC', 'LES CAMMAZES', 'DURFORT', 'SOREZE'],
  81150: [
    'BERNAC',
    'CASTANET',
    'CASTELNAU DE LEVIS',
    'CESTAYROLS',
    'FAYSSAC',
    'FLORENTIN',
    'LABASTIDE DE LEVIS',
    'LAGRAVE',
    'MARSSAC SUR TARN',
    'ROUFFIAC',
    'TERSSAC',
    'STE CROIX',
  ],
  81400: ['BLAYE LES MINES', 'CARMAUX', 'LABASTIDE GABAUSSE', 'ROSIERES', 'ST BENOIT DE CARMAUX'],
  81490: ['BOISSEZON', 'NOAILHAC', 'ST SALVY DE LA BALME'],
  81660: ['BOUT DU PONT DE LARN', 'PAYRIN AUGMONTEL', 'PONT DE LARN'],
  81390: ['BRIATEXTE', 'PUYBEGON', 'ST GAUZENS'],
  81440: [
    'BROUSSE',
    'JONQUIERES',
    'LAUTREC',
    'MONTDRAGON',
    'MONTPINIER',
    'PEYREGOUX',
    'PUYCALVEL',
    'ST GENEST DE CONTEST',
    'ST JULIEN DU PUY',
    'VENES',
  ],
  81100: ['BURLATS', 'CASTRES', 'LABOULBENE'],
  81300: ['BUSQUE', 'GRAULHET', 'LABESSIERE CANDEIL', 'LASGRAISSES', 'MISSECLE', 'MOULAYRES'],
  81130: ['CAGNAC LES MINES', 'MAILHOC', 'MILHAVET', 'TAIX', 'VILLENEUVE SUR VERE'],
  81990: ['CAMBON', 'CARLUS', 'CUNAC', 'FREJAIROLLES', 'PUYGOUZON', 'SALIES', 'LE SEQUESTRE'],
  81580: ['CAMBOUNET SUR LE SOR', 'SOUAL'],
  81570: ['CARBES', 'CUQ', 'FREJEVILLE', 'SEMALENS', 'VIELMUR SUR AGOUT'],
  81640: ['COMBEFA', 'LAPARROUQUIAL', 'MONESTIES', 'SALLES', 'LE SEGUR', 'VIRAC'],
  81800: ['COUFOULEUX', 'GRAZAC', 'LOUPIAC', 'MEZENS', 'RABASTENS', 'ROQUEMAURE'],
  81220: [
    'DAMIATTE',
    'GUITALENS L ALBAREDE',
    'MAGRIN',
    'PRADES',
    'ST PAUL CAP DE JOUX',
    'SERVIES',
    'TEYSSODE',
    'VITERBE',
  ],
  81120: [
    'DENAT',
    'FAUCH',
    'LABOUTARIE',
    'LAMILLARIE',
    'LOMBERS',
    'MONT ROC',
    'ORBAN',
    'POULAN POUZOLS',
    'PUYGOUZON',
    'REALMONT',
    'TERRE DE BANCALIE',
    'SIEURAC',
    'TEILLET',
  ],
  81290: ['ESCOUSSENS', 'LABRUGUIERE', 'ST AFFRIQUE LES MONTAGNES', 'VIVIERS LES MONTAGNES'],
  81530: [
    'LACAPELLE ESCROUX',
    'GIJOUNET',
    'LE MASNAU MASSUGUIES',
    'ST SALVI DE CARCAVES',
    'SENAUX',
    'VIANE',
  ],
  81450: ['LE GARRIC'],
  81270: ['LABASTIDE ROUAIROUX'],
  81230: ['LACAUNE'],
  81330: ['LACAZE', 'RAYSSAC', 'ST PIERRE DE TRIVISY', 'VABRE'],
  81210: ['LACROUZETTE', 'MONTFA', 'ROQUECOURBE', 'ST GERMIER', 'ST JEAN DE VALS'],
  81090: ['LAGARRIGUE', 'VALDURENQUE'],
  81380: ['LESCURE D ALBIGEOIS'],
  81310: ['LISLE SUR TARN', 'PARISOT', 'PEYROLE'],
  81710: ['NAVES', 'SAIX'],
  81370: ['ST SULPICE LA POINTE'],
  82290: [
    'ALBEFEUILLE LAGARDE',
    'BARRY D ISLEMADE',
    'LACOURT ST PIERRE',
    'LA VILLE DIEU DU TEMPLE',
    'MEAUZAC',
    'MONTBETON',
  ],
  82350: ['ALBIAS'],
  82210: [
    'ANGEVILLE',
    'CASTELMAYRAN',
    'CAUMONT',
    'COUTURES',
    'FAJOLLES',
    'MERLES',
    'ST ARROUMEX',
    'ST NICOLAS DE LA GRAVE',
  ],
  82120: [
    'ASQUES',
    'BALIGNAC',
    'CASTERA BOUZET',
    'GENSAC',
    'GRAMONT',
    'LACHAPELLE',
    'LAVIT',
    'MANSONVILLE',
    'MARSAC',
    'MAUMUSSON',
    'MONTGAILLARD',
    'POUPAS',
    'PUYGAILLARD DE LOMAGNE',
    'ST JEAN DU BOUZET',
  ],
  82600: [
    'AUCAMVILLE',
    'BEAUPUY',
    'BOUILLAC',
    'COMBEROUGER',
    'MAS GRENIER',
    'ST SARDOS',
    'SAVENES',
    'VERDUN SUR GARONNE',
  ],
  82500: [
    'AUTERIVE',
    'BEAUMONT DE LOMAGNE',
    'BELBEZE EN LOMAGNE',
    'LE CAUSE',
    'CUMONT',
    'ESCAZEAUX',
    'ESPARSAC',
    'FAUDOAS',
    'GARIES',
    'GIMAT',
    'GLATENS',
    'GOAS',
    'LAMOTHE CUMONT',
    'LARRAZET',
    'MARIGNAC',
    'MAUBEC',
    'SERIGNAC',
    'VIGUERON',
  ],
  82220: ['AUTY', 'LABARTHE', 'MOLIERES', 'PUYCORNET', 'VAZERAC'],
  82340: [
    'AUVILLAR',
    'BARDIGUES',
    'DONZAC',
    'DUNES',
    'LE PIN',
    'ST CIRICE',
    'ST LOUP',
    'ST MICHEL',
    'SISTELS',
  ],
  82100: [
    'LES BARTHES',
    'CASTELFERRUS',
    'CASTELSARRASIN',
    'GARGANVILLAR',
    'LABASTIDE DU TEMPLE',
    'LABOURGADE',
    'LAFITTE',
    'MONTAIN',
    'ST AIGNAN',
  ],
  82150: [
    'BELVEZE',
    'MONTAIGU DE QUERCY',
    'ROQUECOR',
    'ST AMANS DU PECH',
    'ST BEAUZEIL',
    'VALEILLES',
  ],
  82170: ['BESSENS', 'CANALS', 'DIEUPENTALE', 'FABAS', 'GRISOLLES', 'MONBEQUI', 'POMPIGNAN'],
  82800: ['BIOULE', 'BRUNIQUEL', 'MONTRICOUX', 'NEGREPELISSE', 'PUYGAILLARD DE QUERCY', 'VAISSAC'],
  82200: ['BOUDOU', 'LIZAC', 'MALAUSE', 'MOISSAC', 'MONTESQUIEU'],
  82110: [
    'BOULOC EN QUERCY',
    'CAZES MONDENARD',
    'LAUZERTE',
    'MONTAGUDET',
    'MONTBARLA',
    'ST AMANS DE PELLAGAL',
    'STE JULIETTE',
    'SAUVETERRE',
    'TREJOULS',
  ],
  82190: [
    'BOURG DE VISA',
    'BRASSAC',
    'FAUROUX',
    'LACOUR',
    'MIRAMONT DE QUERCY',
    'ST NAZAIRE DE VALENTANE',
    'TOUFFAILLES',
  ],
  82700: [
    'BOURRET',
    'CORDES TOLOSANNES',
    'ESCATALENS',
    'FINHAN',
    'MONTBARTIER',
    'MONTECH',
    'ST PORQUIER',
  ],
  82710: ['BRESSOLS'],
  82370: [
    'CAMPSAS',
    'CORBARIEU',
    'LABASTIDE ST PIERRE',
    'NOHIC',
    'ORGUEIL',
    'REYNIES',
    'ST NAUPHARY',
    'VARENNES',
    'VILLEBRUMIER',
  ],
  82160: [
    'CASTANET',
    'CAYLUS',
    'ESPINAS',
    'LACAPELLE LIVRON',
    'LOZE',
    'MOUILLAC',
    'PARISOT',
    'PUYLAGARDE',
    'ST PROJET',
  ],
  82400: [
    'CASTELSAGRAT',
    'ESPALAIS',
    'GASQUES',
    'GOLFECH',
    'GOUDOURVILLE',
    'MONTJOI',
    'PERVILLE',
    'POMMEVIC',
    'ST CLAIR',
    'ST PAUL D ESPIS',
    'ST VINCENT LESPINASSE',
    'VALENCE',
  ],
  82300: ['CAUSSADE', 'MONTEILS', 'ST CIRQ', 'ST VINCENT D AUTEJAC'],
  82440: ['CAYRAC', 'MIRABEL', 'REALVILLE'],
  82240: [
    'CAYRIECH',
    'LABASTIDE DE PENNE',
    'LAPENCHE',
    'LAVAURETTE',
    'PUYLAROQUE',
    'ST GEORGES',
    'SEPTFONDS',
  ],
  82140: ['CAZALS', 'FENEYROLS', 'ST ANTONIN NOBLE VAL'],
  82390: ['DURFORT LACAPELETTE'],
  82230: ['GENEBRIERES', 'LEOJAC', 'MONCLAR DE QUERCY', 'LA SALVETAT BELMONTET', 'VERLHAC TESCOU'],
  82330: ['GINALS', 'VAREN', 'VERFEIL'],
  82130: [
    'L HONOR DE COS',
    'LAFRANCAISE',
    'LAMOTHE CAPDEVILLE',
    'MONTASTRUC',
    'PIQUECOS',
    'VILLEMADE',
  ],
  82250: ['LAGUEPIE'],
  82360: ['LAMAGISTERE'],
  82270: ['MONTALZAT', 'MONTFERMIER', 'MONTPEZAT DE QUERCY'],
  82000: ['MONTAUBAN'],
  82410: ['ST ETIENNE DE TULMONT'],
  83600: ['LES ADRETS DE L ESTEREL', 'BAGNOLS EN FORET', 'FREJUS'],
  83630: [
    'AIGUINES',
    'ARTIGNOSC SUR VERDON',
    'AUPS',
    'BAUDINARD SUR VERDON',
    'BAUDUEN',
    'MOISSAC BELLEVUE',
    'REGUSSE',
    'LES SALLES SUR VERDON',
    'VERIGNON',
  ],
  83111: ['AMPUS'],
  83460: ['LES ARCS', 'TARADEAU'],
  83560: [
    'ARTIGUES',
    'ESPARRON',
    'GINASSERVIS',
    'RIANS',
    'ST JULIEN',
    'ST MARTIN DE PALLIERES',
    'LA VERDIERE',
    'VINON SUR VERDON',
  ],
  83150: ['BANDOL'],
  83840: [
    'BARGEME',
    'LA BASTIDE',
    'LE BOURGUET',
    'BRENON',
    'CHATEAUVIEUX',
    'COMPS SUR ARTUBY',
    'LA MARTRE',
    'LA ROQUE ESCLAPON',
    'TRIGANCE',
  ],
  83830: ['BARGEMON', 'CALLAS', 'CLAVIERS', 'FIGANIERES'],
  83670: ['BARJOLS', 'CHATEAUVERT', 'FOX AMPHOUX', 'MONTMEYAN', 'PONTEVES', 'TAVERNES', 'VARAGES'],
  83330: ['LE BEAUSSET', 'LE CASTELLET', 'EVENOS'],
  83210: ['BELGENTIER', 'LA FARLEDE', 'SOLLIES PONT', 'SOLLIES TOUCAS', 'SOLLIES VILLE'],
  83890: ['BESSE SUR ISSOLE'],
  83230: ['BORMES LES MIMOSAS'],
  83149: ['BRAS'],
  83170: ['BRIGNOLES', 'CAMPS LA SOURCE', 'LA CELLE', 'ROUGIERS', 'TOURVES', 'VINS SUR CARAMY'],
  83119: ['BRUE AURIAC'],
  83340: [
    'CABASSE',
    'LE CANNET DES MAURES',
    'FLASSANS SUR ISSOLE',
    'LE LUC',
    'LES MAYONS',
    'LE THORONET',
  ],
  83740: ['LA CADIERE D AZUR'],
  83440: [
    'CALLIAN',
    'FAYENCE',
    'MONS',
    'MONTAUROUX',
    'ST PAUL EN FORET',
    'SEILLANS',
    'TANNERON',
    'TOURRETTES',
  ],
  83570: ['CARCES', 'CORRENS', 'COTIGNAC', 'ENTRECASTEAUX', 'MONTFORT SUR ARGENS'],
  83660: ['CARNOULES'],
  83320: ['CARQUEIRANNE'],
  83240: ['CAVALAIRE SUR MER'],
  83300: ['CHATEAUDOUBLE', 'DRAGUIGNAN'],
  83310: ['COGOLIN', 'GRIMAUD', 'LA MOLE'],
  83610: ['COLLOBRIERES'],
  83260: ['LA CRAU'],
  83420: ['LA CROIX VALMER'],
  83390: ['CUERS', 'PIERREFEU DU VAR', 'PUGET VILLE'],
  83780: ['FLAYOSC'],
  83136: [
    'FORCALQUEIRET',
    'GAREOULT',
    'MAZAUGUES',
    'MEOUNES LES MONTRIEUX',
    'NEOULES',
    'ROCBARON',
    'LA ROQUEBRUSSANNE',
    'STE ANASTASIE SUR ISSOLE',
  ],
  83370: ['FREJUS'],
  83130: ['LA GARDE'],
  83680: ['LA GARDE FREINET'],
  83580: ['GASSIN'],
  83590: ['GONFARON'],
  83400: ['HYERES'],
  83980: ['LE LAVANDOU'],
  83250: ['LA LONDE LES MAURES'],
  83510: ['LORGUES', 'ST ANTONIN DU VAR'],
  83131: ['MONTFERRAT'],
  83920: ['LA MOTTE'],
  83490: ['LE MUY'],
  83860: ['NANS LES PINS'],
  83470: ['OLLIERES', 'POURCIEUX', 'ST MAXIMIN LA STE BAUME', 'SEILLONS SOURCE D ARGENS'],
  83190: ['OLLIOULES'],
  83790: ['PIGNANS'],
  83640: ['PLAN D AUPS STE BAUME', 'ST ZACHARIE'],
  83120: ['LE PLAN DE LA TOUR', 'STE MAXIME'],
  83910: ['POURRIERES'],
  83220: ['LE PRADET'],
  83480: ['PUGET SUR ARGENS'],
  83350: ['RAMATUELLE'],
  83200: ['LE REVEST LES EAUX', 'TOULON'],
  83380: ['ROQUEBRUNE SUR ARGENS'],
  83520: ['ROQUEBRUNE SUR ARGENS'],
  83270: ['ST CYR SUR MER'],
  83530: ['ST RAPHAEL'],
  83700: ['ST RAPHAEL'],
  83990: ['ST TROPEZ'],
  83690: ['SALERNES', 'SILLANS LA CASCADE', 'TOURTOUR', 'VILLECROZE'],
  83110: ['SANARY SUR MER'],
  83500: ['LA SEYNE SUR MER'],
  83870: ['SIGNES'],
  83140: ['SIX FOURS LES PLAGES'],
  83000: ['TOULON'],
  83100: ['TOULON'],
  83720: ['TRANS EN PROVENCE'],
  83143: ['LE VAL'],
  83160: ['LA VALETTE DU VAR'],
  83550: ['VIDAUBAN'],
  83820: ['RAYOL CANADEL SUR MER'],
  83430: ['ST MANDRIER SUR MER'],
  84210: [
    'ALTHEN DES PALUDS',
    'LE BEAUCET',
    'PERNES LES FONTAINES',
    'LA ROQUE SUR PERNES',
    'ST DIDIER',
    'VENASQUE',
  ],
  84240: [
    'ANSOUIS',
    'LA BASTIDE DES JOURDANS',
    'CABRIERES D AIGUES',
    'GRAMBOIS',
    'LA MOTTE D AIGUES',
    'PEYPIN D AIGUES',
    'SANNES',
    'LA TOUR D AIGUES',
    'VITROLLES EN LUBERON',
  ],
  84400: [
    'APT',
    'AURIBEAU',
    'CASTELLET EN LUBERON',
    'GARGAS',
    'GIGNAC',
    'LAGARDE D APT',
    'RUSTREL',
    'SAIGNON',
    'SIVERGUES',
    'VILLARS',
  ],
  84810: ['AUBIGNAN'],
  84390: [
    'AUREL',
    'BRANTES',
    'MONIEUX',
    'ST CHRISTOL',
    'ST LEGER DU VENTOUX',
    'ST TRINIT',
    'SAULT',
    'SAVOILLAN',
  ],
  84000: ['AVIGNON'],
  84140: ['AVIGNON'],
  84330: ['LE BARROUX', 'CAROMB', 'MODENE', 'ST HIPPOLYTE LE GRAVEYRON', 'ST PIERRE DE VASSOLS'],
  84120: ['LA BASTIDONNE', 'BEAUMONT DE PERTUIS', 'MIRABEAU', 'PERTUIS'],
  84190: ['BEAUMES DE VENISE', 'GIGONDAS', 'LAFARE', 'LA ROQUE ALRIC', 'SUZETTE', 'VACQUEYRAS'],
  84220: [
    'BEAUMETTES',
    'CABRIERES D AVIGNON',
    'GORDES',
    'GOULT',
    'JOUCAS',
    'LIOUX',
    'MURS',
    'ROUSSILLON',
    'ST PANTALEON',
  ],
  84340: ['BEAUMONT DU VENTOUX', 'ENTRECHAUX', 'MALAUCENE'],
  84370: ['BEDARRIDES'],
  84410: ['BEDOIN', 'CRILLON LE BRAVE', 'FLASSAN'],
  84570: ['BLAUVAC', 'MALEMORT DU COMTAT', 'METHAMIS', 'MORMOIRON', 'VILLES SUR AUZON'],
  84500: ['BOLLENE'],
  84480: ['BONNIEUX', 'BUOUX', 'LACOSTE'],
  84110: [
    'BUISSON',
    'CRESTET',
    'FAUCON',
    'PUYMERAS',
    'RASTEAU',
    'ROAIX',
    'SABLET',
    'ST MARCELLIN LES VAISON',
    'ST ROMAIN EN VIENNOIS',
    'SEGURET',
    'VAISON LA ROMAINE',
    'VILLEDIEU',
  ],
  84160: ['CADENET', 'CUCURON', 'LOURMARIN', 'PUYVERT', 'VAUGINES'],
  84860: ['CADEROUSSE'],
  84290: ['CAIRANNE', 'LAGARDE PAREOL', 'STE CECILE LES VIGNES', 'ST ROMAN DE MALEGARDE'],
  84850: ['CAMARET SUR AIGUES', 'TRAVAILLAN'],
  84200: ['CARPENTRAS'],
  84750: ['CASENEUVE', 'ST MARTIN DE CASTILLON', 'VIENS'],
  84510: ['CAUMONT SUR DURANCE'],
  84300: ['CAVAILLON', 'TAILLADES'],
  84470: ['CHATEAUNEUF DE GADAGNE'],
  84230: ['CHATEAUNEUF DU PAPE'],
  84460: ['CHEVAL BLANC'],
  84350: ['COURTHEZON'],
  84320: ['ENTRAIGUES SUR LA SORGUE'],
  84600: ['GRILLON', 'RICHERENCHES', 'VALREAS'],
  84800: ['L ISLE SUR LA SORGUE', 'LAGNES', 'SAUMANE DE VAUCLUSE', 'FONTAINE DE VAUCLUSE'],
  84450: ['JONQUERETTES', 'ST SATURNIN LES AVIGNON'],
  84150: ['JONQUIERES', 'VIOLES'],
  84840: ['LAMOTTE DU RHONE', 'LAPALUD'],
  84360: ['LAURIS', 'MERINDOL', 'PUGET'],
  84870: ['LORIOL DU COMTAT'],
  84660: ['MAUBEC'],
  84380: ['MAZAN'],
  84560: ['MENERBES'],
  84430: ['MONDRAGON'],
  84170: ['MONTEUX'],
  84310: ['MORIERES LES AVIGNON'],
  84550: ['MORNAS'],
  84580: ['OPPEDE'],
  84100: ['ORANGE', 'UCHAUX'],
  84420: ['PIOLENC'],
  84130: ['LE PONTET'],
  84440: ['ROBION'],
  84760: ['ST MARTIN DE LA BRASQUE'],
  84490: ['ST SATURNIN LES APT'],
  84260: ['SARRIANS'],
  84830: ['SERIGNAN DU COMTAT'],
  84700: ['SORGUES'],
  84250: ['LE THOR'],
  84270: ['VEDENE'],
  84740: ['VELLERON'],
  84530: ['VILLELAURE'],
  84820: ['VISAN'],
  85460: ['L AIGUILLON LA PRESQU ILE'],
  85220: [
    'L AIGUILLON SUR VIE',
    'APREMONT',
    'LA CHAIZE GIRAUD',
    'LA CHAPELLE HERMIER',
    'COEX',
    'COMMEQUIERS',
    'LANDEVIEILLE',
    'ST MAIXENT SUR VIE',
    'ST REVEREND',
  ],
  85190: ['AIZENAY', 'BEAULIEU SOUS LA ROCHE', 'LA GENETOUZE', 'MACHE', 'VENANSAULT'],
  85750: ['ANGLES'],
  85120: [
    'ANTIGNY',
    'LA CHATAIGNERAIE',
    'LOGE FOUGEREUSE',
    'ST HILAIRE DE VOUST',
    'ST MAURICE DES NOUES',
    'ST PIERRE DU CHEMIN',
    'TERVAL',
    'VOUVANT',
  ],
  85430: ['AUBIGNY LES CLOUZEAUX', 'LA BOISSIERE DES LANDES', 'NIEUL LE DOLENT'],
  85200: [
    'AUCHAY SUR VENDEE',
    'BOURNEAU',
    'DOIX LES FONTAINES',
    'FONTENAY LE COMTE',
    'LONGEVES',
    'MERVENT',
    'MONTREUIL',
    'L ORBRIE',
    'PISSOTTE',
    'ST MARTIN DE FRAIGNEAU',
    'ST MICHEL LE CLOUCQ',
    'SERIGNE',
  ],
  85440: ['AVRILLE', 'GROSBREUIL', 'POIROUX', 'ST HILAIRE LA FORET', 'TALMONT ST HILAIRE'],
  85630: ['BARBATRE'],
  85550: ['LA BARRE DE MONTS'],
  85130: [
    'BAZOGES EN PAILLERS',
    'LA GAUBRETIERE',
    'LES LANDES GENUSSON',
    'ST AUBIN DES ORMEAUX',
    'ST MARTIN DES TILLEULS',
    'TIFFAUGES',
    'CHANVERRIE',
  ],
  85390: [
    'BAZOGES EN PAREDS',
    'CHAVAGNES LES REDOUX',
    'CHEFFOIS',
    'MOUILLERON ST GERMAIN',
    'ST MAURICE LE GIRARD',
    'TALLUD STE GEMME',
  ],
  85170: [
    'BEAUFOU',
    'BELLEVIGNY',
    'DOMPIERRE SUR YON',
    'LES LUCS SUR BOULOGNE',
    'LE POIRE SUR VIE',
    'ST DENIS LA CHEVASSE',
  ],
  85500: ['BEAUREPAIRE', 'LES HERBIERS', 'MESNARD LA BAROTIERE', 'ST PAUL EN PAREDS', 'CHANVERRIE'],
  85230: ['BEAUVOIR SUR MER', 'BOUIN', 'ST GERVAIS', 'ST URBAIN'],
  85490: ['BENET'],
  85610: ['LA BERNARDIERE', 'CUGAND'],
  85560: ['LE BERNARD', 'LONGEVILLE SUR MER'],
  85320: [
    'BESSAY',
    'LA BRETONNIERE LA CLAYE',
    'CHATEAU GUIBERT',
    'CORPE',
    'LA COUTURE',
    'MAREUIL SUR LAY DISSAIS',
    'MOUTIERS SUR LE LAY',
    'PEAULT',
    'LES PINEAUX',
    'ROSNAY',
    'STE PEXINE',
  ],
  85710: ['BOIS DE CENE', 'CHATEAUNEUF', 'LA GARNACHE'],
  85600: ['LA BOISSIERE DE MONTAIGU', 'MONTAIGU VENDEE', 'TREIZE SEPTIERS'],
  85420: [
    'BOUILLE COURDAULT',
    'DAMVIX',
    'LIEZ',
    'MAILLE',
    'MAILLEZAIS',
    'LE MAZEAU',
    'RIVES D AUTISE',
    'ST PIERRE LE VIEUX',
    'ST SIGISMOND',
  ],
  85510: ['LE BOUPERE', 'ROCHETREJOUX'],
  85480: ['BOURNEZEAU', 'FOUGERE', 'ST HILAIRE LE VOUHIS', 'THORIGNY'],
  85470: ['BRETIGNOLLES SUR MER', 'BREM SUR MER'],
  85260: ['LES BROUZILS', 'LA COPECHAGNIERE', 'L HERBERGEMENT', 'MONTREVERD'],
  85530: ['LA BRUFFIERE'],
  85410: [
    'LA CAILLERE ST HILAIRE',
    'ST CYR DES GATS',
    'ST LAURENT DE LA SALLE',
    'RIVES DU FOUGERAIS',
  ],
  85450: [
    'CHAILLE LES MARAIS',
    'CHAMPAGNE LES MARAIS',
    'MOREILLES',
    'PUYRAVAULT',
    'STE RADEGONDE DES NOYERS',
    'LA TAILLEE',
    'VOUILLE LES MARAIS',
  ],
  85310: ['LA CHAIZE LE VICOMTE', 'NESMY', 'RIVES DE L YON', 'LE TABLIER'],
  85300: ['CHALLANS', 'FROIDFOND', 'LE PERRIER', 'SALLERTAINE', 'SOULLANS'],
  85540: [
    'LE CHAMP ST PERE',
    'CURZON',
    'LE GIVRE',
    'LA JONCHERE',
    'MOUTIERS LES MAUXFAITS',
    'ST AVAUGOURD DES LANDES',
    'ST BENOIST SUR MER',
    'ST CYR EN TALMONDAIS',
    'ST VINCENT SUR GRAON',
  ],
  85110: [
    'CHANTONNAY',
    'LA JAUDONNIERE',
    'MONSIREIGNE',
    'STE CECILE',
    'ST GERMAIN DE PRINCAY',
    'ST PROUANT',
    'ST VINCENT STERLANGES',
    'SIGOURNAIS',
  ],
  85670: [
    'LA CHAPELLE PALLUAU',
    'FALLERON',
    'GRAND LANDES',
    'PALLUAU',
    'ST CHRISTOPHE DU LIGNERON',
    'ST ETIENNE DU BOIS',
    'ST PAUL MONT PENIT',
  ],
  85210: [
    'LA CHAPELLE THEMER',
    'LA REORTHE',
    'ST AUBIN LA PLAINE',
    'ST ETIENNE DE BRILLOUET',
    'STE HERMINE',
    'ST JEAN DE BEUGNE',
    'ST JUIRE CHAMPGILLON',
    'ST MARTIN LARS EN STE HERMINE',
    'THIRE',
  ],
  85400: ['CHASNAIS', 'LAIROUX', 'LUCON', 'LES MAGNILS REIGNIERS', 'STE GEMME LA PLAINE'],
  85140: [
    'CHAUCHE',
    'ESSARTS EN BOCAGE',
    'LA MERLATIERE',
    'L OIE',
    'STE FLORENCE',
    'ST MARTIN DES NOYERS',
  ],
  85250: [
    'CHAVAGNES EN PAILLERS',
    'LA RABATELIERE',
    'ST ANDRE GOULE D OIE',
    'ST FULGENT',
    'VENDRENNES',
  ],
  85590: ['LES EPESSES', 'MALLIEVRE', 'ST MALO DU BOIS', 'ST MARS LA REORTHE', 'TREIZE VENTS'],
  85740: ['L EPINE'],
  85240: [
    'FAYMOREAU',
    'FOUSSAIS PAYRE',
    'MARILLET',
    'RIVES D AUTISE',
    'PUY DE SERRE',
    'ST HILAIRE DES LOGES',
    'XANTON CHASSENON',
  ],
  85800: ['LE FENOUILLER', 'GIVRAND', 'ST GILLES CROIX DE VIE'],
  85280: ['LA FERRIERE'],
  85700: [
    'SEVREMONT',
    'LA MEILLERAIE TILLAY',
    'MENOMBLET',
    'MONTOURNAIS',
    'POUZAUGES',
    'REAUMUR',
    'ST MESMIN',
  ],
  85150: [
    'LE GIROUARD',
    'LANDERONDE',
    'MARTINET',
    'LES ACHARDS',
    'STE FLAIVE DES LOUPS',
    'STE FOY',
    'ST GEORGES DE POINTINDOUX',
    'ST JULIEN DES LANDES',
    'ST MATHURIN',
    'VAIRE',
  ],
  85580: ['GRUES', 'ST DENIS DU PAYRE', 'ST MICHEL EN L HERM', 'TRIAIZE'],
  85770: ['LE GUE DE VELLUIRE', 'L ILE D ELLE', 'LES VELLUIRE SUR VENDEE', 'VIX'],
  85680: ['LA GUERINIERE'],
  85570: [
    'L HERMENAULT',
    'MARSAIS STE RADEGONDE',
    'PETOSSE',
    'POUILLE',
    'ST MARTIN DES FONTAINES',
    'ST VALERIEN',
  ],
  85340: ['L ILE D OLONNE', 'LES SABLES D OLONNE'],
  85350: ['L ILE D YEU'],
  85520: ['JARD SUR MER', 'ST VINCENT SUR JARD'],
  85370: ['LE LANGON', 'MOUZEUIL ST MARTIN', 'NALLIERS'],
  85290: ['MORTAGNE SUR SEVRE', 'ST LAURENT SUR SEVRE'],
  85640: ['MOUCHAMPS'],
  85000: ['MOUILLERON LE CAPTIF', 'LA ROCHE SUR YON'],
  85330: ['NOIRMOUTIER EN L ILE'],
  85690: ['NOTRE DAME DE MONTS'],
  85270: ['NOTRE DAME DE RIEZ', 'ST HILAIRE DE RIEZ'],
  85620: ['ROCHESERVIERE'],
  85100: ['LES SABLES D OLONNE'],
  85180: ['LES SABLES D OLONNE'],
  85160: ['ST JEAN DE MONTS'],
  85660: ['ST PHILBERT DE BOUAINE'],
  85360: ['LA TRANCHE SUR MER'],
  86430: ['ADRIERS', 'ASNIERES SUR BLOUR', 'LUCHAPT', 'MOUTERRE SUR BLOURDE'],
  86110: [
    'AMBERRE',
    'CHOUPPES',
    'COUSSAY',
    'CRAON',
    'CUHON',
    'LA GRIMAUDIERE',
    'MAZEUIL',
    'MIREBEAU',
    'THURAGEAU',
    'ST MARTIN LA PALLU',
  ],
  86700: ['ANCHE', 'VALENCE EN POITOU', 'ROMAGNE', 'VOULON'],
  86260: ['ANGLES SUR L ANGLIN', 'LA PUYE', 'ST PIERRE DE MAILLE', 'VICQ SUR GARTEMPE'],
  86330: [
    'ANGLIERS',
    'AULNAY',
    'LA CHAUSSEE',
    'LA GRIMAUDIERE',
    'MARTAIZE',
    'MONCONTOUR',
    'ST CLAIR',
    'ST JEAN DE SAUVES',
  ],
  86310: [
    'ANTIGNY',
    'BETHINES',
    'LA BUSSIERE',
    'HAIMS',
    'NALLIERS',
    'ST GERMAIN',
    'ST SAVIN',
    'VILLEMORT',
  ],
  86100: ['ANTRAN', 'CHATELLERAULT', 'SENILLE ST SAUVEUR'],
  86200: [
    'ARCAY',
    'BASSES',
    'CEAUX EN LOUDUN',
    'CHALAIS',
    'LA ROCHE RIGAULT',
    'GLENOUZE',
    'LOUDUN',
    'MAULAY',
    'MESSEME',
    'MOUTERRE SILLY',
    'NUEIL SOUS FAYE',
    'POUANT',
    'RANTON',
    'ST LAON',
    'SAMMARCOLLES',
  ],
  86210: [
    'ARCHIGNY',
    'BELLEFONDS',
    'BONNEUIL MATOURS',
    'LA CHAPELLE MOULIERE',
    'MONTHOIRON',
    'VOUNEUIL SUR VIENNE',
  ],
  86340: [
    'ASLONNES',
    'FLEURE',
    'GIZAY',
    'NIEUIL L ESPOIR',
    'NOUAILLE MAUPERTUIS',
    'ROCHES PREMARIE ANDILLE',
    'VERNON',
    'LA VILLEDIEU DU CLAIN',
  ],
  86250: ['ASNOIS', 'LA CHAPELLE BATON', 'CHARROUX', 'CHATAIN', 'GENOUILLE', 'ST ROMAIN', 'SURIN'],
  86530: ['AVAILLES EN CHATELLERAULT', 'CENON SUR VIENNE', 'NAINTRE'],
  86460: ['AVAILLES LIMOUZINE', 'MAUPREVOIR', 'PRESSAC'],
  86170: [
    'AVANTON',
    'CHAMPIGNY EN ROCHEREAU',
    'CHERVES',
    'CISSE',
    'MAISONNEUVE',
    'MASSOGNES',
    'NEUVILLE DE POITOU',
    'ST MARTIN LA PALLU',
    'VOUZAILLES',
    'YVERSAY',
  ],
  86190: [
    'AYRON',
    'BERUGES',
    'CHALANDRAY',
    'CHIRE EN MONTREUIL',
    'FROZES',
    'LATILLE',
    'MAILLE',
    'QUINCAY',
    'VILLIERS',
    'VOUILLE',
  ],
  86130: ['BEAUMONT ST CYR', 'DISSAY', 'JAUNAY MARIGNY', 'ST GEORGES LES BAILLARGEAUX'],
  86490: ['BEAUMONT ST CYR', 'COLOMBIERS'],
  86120: [
    'BERRIE',
    'BEUXES',
    'BOURNAND',
    'CURCAY SUR DIVE',
    'MORTON',
    'POUANCAY',
    'RASLAY',
    'ROIFFE',
    'ST LEGER DE MONTBRILLAIS',
    'SAIX',
    'TERNAY',
    'LES TROIS MOUTIERS',
    'VEZIERES',
  ],
  86420: ['BERTHEGON', 'DERCE', 'GUESNES', 'MONTS SUR GUESNES', 'PRINCAY', 'SAIRES', 'VERRUE'],
  86580: ['BIARD', 'VOUNEUIL SOUS BIARD'],
  86800: [
    'BIGNOUX',
    'JARDRES',
    'LAVOUX',
    'LINIERS',
    'POUILLE',
    'ST JULIEN L ARS',
    'SAVIGNY LEVESCAULT',
    'SEVRES ANXAUMONT',
    'TERCE',
  ],
  86400: [
    'BLANZAY',
    'CHAMPNIERS',
    'CIVRAY',
    'LINAZAY',
    'LIZANT',
    'ST GAUDENT',
    'ST PIERRE D EXIDEUIL',
    'VAL DE COMPORTE',
    'SAVIGNE',
    'VOULEME',
  ],
  86300: [
    'BONNES',
    'CHAPELLE VIVIERS',
    'CHAUVIGNY',
    'FLEIX',
    'LAUTHIERS',
    'LEIGNES SUR FONTAINE',
    'PAIZAY LE SEC',
    'VALDIVIENNE',
    'STE RADEGONDE',
  ],
  86410: ['BOURESSE', 'DIENNE', 'LHOMMAIZE', 'ST LAURENT DE JOURDES', 'VERRIERES'],
  86390: ['BOURG ARCHAMBAULT', 'LATHUS ST REMY'],
  86290: [
    'BRIGUEIL LE CHANTRE',
    'COULONGES LES HEROLLES',
    'JOURNET',
    'LIGLET',
    'ST LEOMER',
    'THOLLET',
    'LA TRIMOUILLE',
  ],
  86160: [
    'BRION',
    'CHAMPAGNE ST HILAIRE',
    'LA FERRIERE AIROUX',
    'GENCAY',
    'MAGNE',
    'MARNAY',
    'ST MAURICE LA CLOUERE',
    'SOMMIERES DU CLAIN',
  ],
  86510: ['BRUX', 'CHAMPAGNE LE SEC', 'CHAUNAY'],
  86180: ['BUXEROLLES'],
  86600: [
    'CELLE LEVESCAULT',
    'CLOUE',
    'COULOMBIERS',
    'CURZAY SUR VONNE',
    'JAZENEUIL',
    'LUSIGNAN',
    'ST SAUVANT',
    'SANXAY',
  ],
  86140: [
    'CERNAY',
    'DOUSSAY',
    'LENCLOITRE',
    'ST GENEST D AMBIERE',
    'SAVIGNY SOUS FAYE',
    'SCORBE CLAIRVAUX',
  ],
  86380: ['CHABOURNAY', 'JAUNAY MARIGNY', 'OUZILLY', 'ST MARTIN LA PALLU'],
  86360: ['CHASSENEUIL DU POITOU', 'MONTAMISE'],
  86350: [
    'CHATEAU GARNIER',
    'JOUSSE',
    'PAYROUX',
    'ST MARTIN L ARS',
    'ST SECONDIN',
    'USSON DU POITOU',
  ],
  86370: ['CHATEAU LARCHER', 'MARCAY', 'MARIGNY CHEMEREAU', 'VIVONNE'],
  86450: ['CHENEVELLES', 'LEIGNE LES BOIS', 'PLEUMARTIN'],
  86320: ['CIVAUX', 'GOUEX', 'LUSSAC LES CHATEAUX', 'MAZEROLLES', 'PERSAC', 'SILLARS'],
  86270: ['COUSSAY LES BOIS', 'LESIGNY', 'MAIRE', 'LA ROCHE POSAY'],
  86240: ['CROUTELLE', 'FONTAINE LE COMTE', 'ITEUIL', 'LIGUGE', 'SMARVES'],
  86220: [
    'DANGE ST ROMAIN',
    'INGRANDES',
    'LEUGNY',
    'LES ORMES',
    'OYRE',
    'PORT DE PILES',
    'ST REMY SUR CREUSE',
    'VAUX SUR VIENNE',
  ],
  86150: ['L ISLE JOURDAIN', 'MILLAC', 'MOUSSAC', 'NERIGNAC', 'QUEAUX', 'LE VIGEANT'],
  86500: ['JOUHET', 'MONTMORILLON', 'MOULISMES', 'PINDRAY', 'PLAISANCE', 'SAULGE'],
  86470: ['BOIVRE LA VALLEE'],
  86230: [
    'LEIGNE SUR USSEAU',
    'MONDION',
    'ORCHES',
    'ST CHRISTOPHE',
    'ST GERVAIS LES TROIS CLOCHERS',
    'SERIGNY',
    'SOSSAIS',
    'USSEAU',
    'VELLECHES',
  ],
  86550: ['MIGNALOUX BEAUVOIR'],
  86440: ['MIGNE AUXANCES'],
  86000: ['POITIERS'],
  86480: ['ROUILLE'],
  86280: ['ST BENOIT'],
  86540: ['THURE'],
  87700: [
    'AIXE SUR VIENNE',
    'BEYNAC',
    'ST MARTIN LE VIEUX',
    'ST PRIEST SOUS AIXE',
    'ST YRIEIX SOUS AIXE',
  ],
  87240: ['AMBAZAC', 'ST LAURENT LES EGLISES', 'ST SYLVESTRE'],
  87160: [
    'ARNAC LA POSTE',
    'CROMAC',
    'LES GRANDS CHEZEAUX',
    'MAILHAC SUR BENAIZE',
    'ST GEORGES LES LANDES',
    'ST SULPICE LES FEUILLES',
  ],
  87120: [
    'AUGNE',
    'BEAUMONT DU LAC',
    'DOMPS',
    'EYMOUTIERS',
    'NEDDE',
    'REMPNAT',
    'ST AMAND LE PETIT',
    'STE ANNE ST PRIEST',
  ],
  87220: ['AUREIL', 'BOISSEUIL', 'EYJEAUX', 'FEYTIAT'],
  87360: [
    'AZAT LE RIS',
    'LUSSAC LES EGLISES',
    'ST MARTIN LE MAULT',
    'TERSANNES',
    'VERNEUIL MOUSTIERS',
  ],
  87290: ['BALLEDENT', 'CHATEAUPONSAC', 'RANCON', 'ST AMAND MAGNAZEIX', 'ST SORNIN LEULAC'],
  87210: [
    'LA BAZEUGE',
    'LA CROIX SUR GARTEMPE',
    'DINSAC',
    'LE DORAT',
    'ORADOUR ST GENEST',
    'ST SORNIN LA MARCHE',
  ],
  87300: [
    'BELLAC',
    'BERNEUIL',
    'BLANZAC',
    'BLOND',
    'BREUILAUFA',
    'PEYRAT DE BELLAC',
    'ST BONNET DE BELLAC',
    'ST JUNIEN LES COMBES',
    'ST OUEN SUR GARTEMPE',
  ],
  87370: ['BERSAC SUR RIVALIER', 'JABREILLES LES BORDES', 'LAURIERE', 'ST SULPICE LAURIERE'],
  87250: ['BESSINES SUR GARTEMPE', 'FOLLES', 'FROMENTAL', 'ST PARDOUX LE LAC'],
  87340: ['LES BILLANGES', 'LA JONCHERE ST MAURICE', 'ST LEGER LA MONTAGNE'],
  87270: ['BONNAC LA COTE', 'CHAPTELAT', 'COUZEIX'],
  87110: ['BOSMIE L AIGUILLE', 'SOLIGNAC', 'LE VIGEN'],
  87140: [
    'LE BUIS',
    'CHAMBORET',
    'COMPREIGNAC',
    'NANTIAT',
    'ST PARDOUX LE LAC',
    'THOURON',
    'VAULRY',
  ],
  87460: ['BUJALEUF', 'CHEISSOUX', 'ST JULIEN LE PETIT'],
  87800: [
    'BURGNAC',
    'JANAILHAC',
    'JOURGNAC',
    'MEILHAC',
    'LA MEYZE',
    'NEXON',
    'RILHAC LASTOURS',
    'LA ROCHE L ABEILLE',
    'ST HILAIRE LES PLACES',
    'ST MAURICE LES BROUSSES',
    'ST PRIEST LIGOURE',
  ],
  87230: [
    'BUSSIERE GALANT',
    'LES CARS',
    'CHALUS',
    'CHAMPSAC',
    'DOURNAZAC',
    'FLAVIGNAC',
    'LAVIGNAC',
    'PAGEAS',
  ],
  87320: ['VAL D OIRE ET GARTEMPE'],
  87330: [
    'VAL D OIRE ET GARTEMPE',
    'GAJOUBERT',
    'VAL D ISSOIRE',
    'MONTROL SENARD',
    'MORTEMART',
    'NOUIC',
    'ST MARTIAL SUR ISOP',
  ],
  87200: ['CHAILLAC SUR VIENNE', 'ST BRICE SUR VIENNE', 'ST JUNIEN', 'ST MARTIN DE JUSSAC'],
  87500: ['LE CHALARD', 'COUSSAC BONNEVAL', 'GLANDON', 'LADIGNAC LE LONG', 'ST YRIEIX LA PERCHE'],
  87150: ['CHAMPAGNAC LA RIVIERE', 'CUSSAC', 'ORADOUR SUR VAYRES', 'ST BAZILE'],
  87400: [
    'CHAMPNETERY',
    'LE CHATENET EN DOGNON',
    'EYBOULEUF',
    'LA GENEYTOUSE',
    'MOISSANNES',
    'ROYERES',
    'ST DENIS DES MURS',
    'ST LEONARD DE NOBLAT',
    'ST MARTIN TERRESSUS',
    'SAUVIAT SUR VIGE',
  ],
  87440: [
    'LA CHAPELLE MONTBRANDEIX',
    'MAISONNAIS SUR TARDOIRE',
    'MARVAL',
    'PENSOL',
    'ST MATHIEU',
    'LES SALLES LAVAUGUYON',
  ],
  87380: [
    'CHATEAU CHERVIX',
    'GLANGES',
    'MAGNAC BOURG',
    'MEUZAC',
    'LA PORCHERIE',
    'ST GERMAIN LES BELLES',
    'ST VITTE SUR BRIANCE',
  ],
  87130: [
    'CHATEAUNEUF LA FORET',
    'LA CROISILLE SUR BRIANCE',
    'LINARDS',
    'MASLEON',
    'NEUVIC ENTIER',
    'ROZIERS ST GEORGES',
    'ST GILLES LES FORETS',
    'ST MEARD',
    'SURDOUX',
    'SUSSAC',
  ],
  87600: ['CHERONNAC', 'ROCHECHOUART', 'VAYRES', 'VIDEIX'],
  87520: ['CIEUX', 'JAVERDAT', 'ORADOUR SUR GLANE', 'VEYRAC'],
  87310: ['COGNAC LA FORET', 'GORRE', 'ST AUVENT', 'ST CYR', 'ST LAURENT SUR GORRE'],
  87920: ['CONDAT SUR VIENNE'],
  87190: [
    'DOMPIERRE LES EGLISES',
    'DROUX',
    'MAGNAC LAVAL',
    'ST HILAIRE LA TREILLE',
    'ST LEGER MAGNAZEIX',
    'VILLEFAVARD',
  ],
  87170: ['ISLE'],
  87890: ['JOUAC'],
  87000: ['LIMOGES'],
  87100: ['LIMOGES'],
  87280: ['LIMOGES'],
  87510: ['NIEUL', 'PEYRILHAC', 'ST GENCE', 'ST JOUVENT'],
  87410: ['LE PALAIS SUR VIENNE'],
  87350: ['PANAZOL'],
  87470: ['PEYRAT LE CHATEAU'],
  87260: [
    'PIERRE BUFFIERE',
    'ST BONNET BRIANCE',
    'ST GENEST SUR ROSELLE',
    'ST HILAIRE BONNEVAL',
    'ST JEAN LIGOURE',
    'ST PAUL',
    'VICQ SUR BREUILH',
  ],
  87640: ['RAZES'],
  87570: ['RILHAC RANCON'],
  87720: ['SAILLAT SUR VIENNE'],
  87590: ['ST JUST LE MARTEL'],
  87420: ['STE MARIE DE VAUX', 'ST VICTURNIEN'],
  87480: ['ST PRIEST TAURION'],
  87620: ['SEREILHAC'],
  87430: ['VERNEUIL SUR VIENNE'],
  88270: [
    'LES ABLEUVENETTES',
    'BAINVILLE AUX SAULES',
    'BAZEGNEY',
    'BEGNECOURT',
    'BOCQUEGNEY',
    'BOUXIERES AUX BOIS',
    'BOUZEMONT',
    'CHARMOIS L ORGUEILLEUX',
    'CIRCOURT',
    'DAMAS ET BETTEGNEY',
    'DERBAMONT',
    'DOMPAIRE',
    'FRENOIS',
    'GELVECOURT ET ADOMPT',
    'GORHEY',
    'HAGECOURT',
    'HAROL',
    'HENNECOURT',
    'LEGEVILLE ET BONFAYS',
    'MADECOURT',
    'MADONNE ET LAMEREY',
    'MARONCOURT',
    'PIERREFITTE',
    'RACECOURT',
    'RANCOURT',
    'ST VALLIER',
    'VALFROICOURT',
    'VALLEROY AUX SAULES',
    'VELOTTE ET TATIGNECOURT',
    'VILLE SUR ILLON',
  ],
  88500: [
    'AHEVILLE',
    'AMBACOURT',
    'AVILLERS',
    'BAUDRICOURT',
    'BAZOILLES ET MENIL',
    'BETTONCOURT',
    'BLEMEREY',
    'BOULAINCOURT',
    'CHAUFFECOURT',
    'CHEF HAUT',
    'DOMBASLE EN XAINTOIS',
    'DOMEVRE SOUS MONTFORT',
    'DOMVALLIER',
    'ESTRENNES',
    'FRENELLE LA GRANDE',
    'FRENELLE LA PETITE',
    'GIRCOURT LES VIEVILLE',
    'HYMONT',
    'JORXEY',
    'JUVAINCOURT',
    'MATTAINCOURT',
    'MAZIROT',
    'MENIL EN XAINTOIS',
    'MIRECOURT',
    'OELLEVILLE',
    'OFFROICOURT',
    'PONT SUR MADON',
    'POUSSAY',
    'PUZIEUX',
    'RAMECOURT',
    'REMICOURT',
    'REPEL',
    'ROUVRES EN XAINTOIS',
    'ROZEROTTE',
    'ST PRANCHER',
    'THIRAUCOURT',
    'TOTAINVILLE',
    'VAUBEXY',
    'VILLERS',
    'VIVIERS LES OFFROICOURT',
    'VOMECOURT SUR MADON',
    'VROVILLE',
  ],
  88140: [
    'AINGEVILLE',
    'AUZAINVILLIERS',
    'BULGNEVILLE',
    'CONTREXEVILLE',
    'CRAINVILLIERS',
    'DOMBROT LE SEC',
    'GENDREVILLE',
    'MALAINCOURT',
    'MEDONVILLE',
    'MORVILLE',
    'ST OUEN LES PAREY',
    'SAULXURES LES BULGNEVILLE',
    'SAUVILLE',
    'SURIAUVILLE',
    'URVILLE',
    'LA VACHERESSE ET LA ROUILLIE',
    'VAUDONCOURT',
    'VRECOURT',
  ],
  88320: [
    'AINVELLE',
    'BLEVAINCOURT',
    'DAMBLAIN',
    'FOUCHECOURT',
    'FRAIN',
    'GIGNEVILLE',
    'ISCHES',
    'LAMARCHE',
    'MAREY',
    'MARTIGNY LES BAINS',
    'MONT LES LAMARCHE',
    'MORIZECOURT',
    'ROBECOURT',
    'ROMAIN AUX BOIS',
    'ROZIERES SUR MOUZON',
    'SENAIDE',
    'SERECOURT',
    'SEROCOURT',
    'TIGNECOURT',
    'TOLLAINCOURT',
    'VILLOTTE',
  ],
  88110: [
    'ALLARMONT',
    'CELLES SUR PLAINE',
    'LUVIGNY',
    'RAON L ETAPE',
    'RAON SUR PLAINE',
    'VEXAINCOURT',
  ],
  88410: [
    'AMEUVELLE',
    'BLEURVILLE',
    'CHATILLON SUR SAONE',
    'CLAUDON',
    'FIGNEVELLE',
    'GODONCOURT',
    'GRIGNONCOURT',
    'LIRONCOURT',
    'MARTINVELLE',
    'MONTHUREUX SUR SAONE',
    'REGNEVELLE',
    'ST JULIEN',
    'LES THONS',
  ],
  88700: [
    'ANGLEMONT',
    'AUTREY',
    'BAZIEN',
    'BRU',
    'BULT',
    'CLEZENTAINE',
    'DEINVILLERS',
    'DOMPTAIL',
    'DONCIERES',
    'FAUCONCOURT',
    'HARDANCOURT',
    'HOUSSERAS',
    'JEANMENIL',
    'MENARMONT',
    'MENIL SUR BELVITTE',
    'MOYEMONT',
    'NOSSONCOURT',
    'ORTONCOURT',
    'PADOUX',
    'RAMBERVILLERS',
    'ROMONT',
    'ROVILLE AUX CHENES',
    'STE BARBE',
    'ST BENOIT LA CHIPOTTE',
    'ST GENEST',
    'ST GORGON',
    'STE HELENE',
    'ST MAURICE SUR MORTAGNE',
    'ST PIERREMONT',
    'VOMECOURT',
    'XAFFEVILLERS',
  ],
  88650: ['ANOULD', 'ENTRE DEUX EAUX', 'MANDRAY', 'ST LEONARD'],
  88170: [
    'AOUZE',
    'AROFFE',
    'BALLEVILLE',
    'BIECOURT',
    'CHATENOIS',
    'COURCELLES SOUS CHATENOIS',
    'DARNEY AUX CHENES',
    'DOLAINCOURT',
    'DOMBROT SUR VAIR',
    'DOMMARTIN SUR VRAINE',
    'GEMMELAINCOURT',
    'GIRONCOURT SUR VRAINE',
    'HOUECOURT',
    'LONGCHAMP SOUS CHATENOIS',
    'MACONCOURT',
    'MORELMAISON',
    'LA NEUVEVILLE SOUS CHATENOIS',
    'OLLAINVILLE',
    'PLEUVEZAIN',
    'RAINVILLE',
    'REMOVILLE',
    'ROUVRES LA CHETIVE',
    'ST MENGE',
    'ST PAUL',
    'SANDAUCOURT',
    'SONCOURT',
    'VICHEREY',
    'VIOCOURT',
    'VOUXEY',
  ],
  88380: ['ARCHES', 'ARCHETTES'],
  88430: [
    'ARRENTES DE CORCIEUX',
    'BIFFONTAINE',
    'CORCIEUX',
    'GERBEPAL',
    'LA HOUSSIERE',
    'VIENVILLE',
  ],
  88300: [
    'ATTIGNEVILLE',
    'AULNOIS',
    'AUTIGNY LA TOUR',
    'AUTREVILLE',
    'BARVILLE',
    'BAZOILLES SUR MEUSE',
    'BEAUFREMONT',
    'CERTILLEUX',
    'CIRCOURT SUR MOUZON',
    'HAGNEVILLE ET RONCOURT',
    'HARCHECHAMP',
    'HARMONVILLE',
    'HOUEVILLE',
    'JAINVILLOTTE',
    'LANDAVILLE',
    'LEMMECOURT',
    'MARTIGNY LES GERBONVAUX',
    'MONT LES NEUFCHATEAU',
    'NEUFCHATEAU',
    'POMPIERRE',
    'REBEUVILLE',
    'ROLLAINVILLE',
    'SARTES',
    'TILLEUX',
    'TRANQUEVILLE GRAUX',
  ],
  88260: [
    'ATTIGNY',
    'BELMONT LES DARNEY',
    'BELRUPT',
    'BONVILLET',
    'DARNEY',
    'DOMBASLE DEVANT DARNEY',
    'DOMMARTIN LES VALLOIS',
    'ESCLES',
    'ESLEY',
    'HENNEZEL',
    'JESONVILLE',
    'LERRAIN',
    'NONVILLE',
    'PONT LES BONFAYS',
    'PROVENCHERES LES DARNEY',
    'RELANGES',
    'ST BASLEMONT',
    'SANS VALLOIS',
    'SENONGES',
    'THUILLIERES',
    'LES VALLOIS',
    'VIOMENIL',
    'VIVIERS LE GRAS',
  ],
  88130: [
    'AVRAINVILLE',
    'BATTEXEY',
    'BOUXURULLES',
    'BRANTIGNY',
    'CHAMAGNE',
    'CHARMES',
    'ESSEGNEY',
    'FLOREMONT',
    'HERGUGNEY',
    'LANGLEY',
    'MARAINVILLE SUR MADON',
    'RAPEY',
    'RUGNEY',
    'SAVIGNY',
    'SOCOURT',
    'UBEXY',
    'XARONVAL',
  ],
  88630: [
    'AVRANVILLE',
    'CHERMISEY',
    'CLEREY LA COTE',
    'COUSSEY',
    'DOMREMY LA PUCELLE',
    'FREBECOURT',
    'GREUX',
    'JUBAINVILLE',
    'MAXEY SUR MEUSE',
    'MIDREVAUX',
    'MONCEL SUR VAIR',
    'PUNEROT',
    'RUPPES',
    'SERAUMONT',
    'SIONNE',
    'SOULOSSE SOUS ST ELOPHE',
  ],
  88600: [
    'AYDOILLES',
    'BEAUMENIL',
    'BELMONT SUR BUTTANT',
    'BOIS DE CHAMP',
    'BROUVELIEURES',
    'BRUYERES',
    'CHAMP LE DUC',
    'LA CHAPELLE DEVANT BRUYERES',
    'DESTORD',
    'DEYCIMONT',
    'DOMFAING',
    'DOMPIERRE',
    'FAYS',
    'FIMENIL',
    'FONTENAY',
    'FREMIFONTAINE',
    'GIRECOURT SUR DURBION',
    'GRANDVILLERS',
    'GUGNECOURT',
    'HERPELMONT',
    'LAVAL SUR VOLOGNE',
    'LAVELINE DEVANT BRUYERES',
    'LEPANGES SUR VOLOGNE',
    'MEMENIL',
    'MORTAGNE',
    'LA NEUVEVILLE DEVANT LEPANGES',
    'NONZEVILLE',
    'PIERREPONT SUR L ARENTELE',
    'LES POULIERES',
    'PREY',
    'LES ROUGES EAUX',
    'SERCOEUR',
    'VERVEZELLE',
    'VIMENIL',
  ],
  88330: [
    'BADMENIL AUX BOIS',
    'CHATEL SUR MOSELLE',
    'DAMAS AUX BOIS',
    'DOMEVRE SUR DURBION',
    'HADIGNY LES VERRIERES',
    'HAILLAINVILLE',
    'MORIVILLE',
    'PALLEGNEY',
    'PORTIEUX',
    'REHAINCOURT',
    'VAXONCOURT',
    'ZINCOURT',
  ],
  88460: [
    'LA BAFFE',
    'CHARMOIS DEVANT BRUYERES',
    'CHENIMENIL',
    'DOCELLES',
    'FAUCOMPIERRE',
    'LE ROULIER',
    'TENDON',
    'XAMONTARUPT',
  ],
  88240: [
    'LA VOGE LES BAINS',
    'LA CHAPELLE AUX BOIS',
    'LE CLERJUS',
    'FONTENOY LE CHATEAU',
    'GRANDRUPT DE BAINS',
    'GRUEY LES SURANCE',
    'LA HAYE',
    'MONTMOTIER',
    'TREMONZEY',
    'LES VOIVRES',
  ],
  88520: [
    'BAN DE LAVELINE',
    'BERTRIMOUTIER',
    'LA CROIX AUX MINES',
    'GEMAINGOUTTE',
    'RAVES',
    'WISEMBACH',
  ],
  88210: [
    'BAN DE SAPT',
    'BELVAL',
    'CHATAS',
    'DENIPAIRE',
    'GRANDRUPT',
    'HURBACHE',
    'MENIL DE SENONES',
    'LE MONT',
    'MOUSSEY',
    'LA PETITE RAON',
    'LE PUID',
    'ST JEAN D ORMONT',
    'ST STAIL',
    'LE SAULCY',
    'SENONES',
    'LE VERMONT',
    'VIEUX MOULIN',
  ],
  88640: [
    'BARBEY SEROUX',
    'CHAMPDRAY',
    'GRANGES AUMONTZEY',
    'JUSSARUPT',
    'LAVELINE DU HOUX',
    'REHAUPAL',
  ],
  88120: [
    'BASSE SUR LE RUPT',
    'CLEURIE',
    'GERBAMONT',
    'ROCHESSON',
    'ST AME',
    'SAPOIS',
    'LE SYNDICAT',
    'VAGNEY',
  ],
  88150: ['BAYECOURT', 'CHAVELOT', 'IGNEY', 'MAZELEY', 'THAON LES VOSGES', 'VILLONCOURT'],
  88370: ['BELLEFONTAINE', 'PLOMBIERES LES BAINS'],
  88800: [
    'BELMONT SUR VAIR',
    'DOMJULIEN',
    'HAREVILLE',
    'LIGNEVILLE',
    'MANDRES SUR VAIR',
    'MONTHUREUX LE SEC',
    'LA NEUVEVILLE SOUS MONTFORT',
    'NORROY',
    'PAREY SOUS MONTFORT',
    'REMONCOURT',
    'ST REMIMONT',
    'THEY SOUS MONTFORT',
    'VALLEROY LE SEC',
    'VITTEL',
  ],
  88450: [
    'BETTEGNEY ST BRICE',
    'EVAUX ET MENIL',
    'GUGNEY AUX AULX',
    'MADEGNEY',
    'REGNEY',
    'VARMONZEY',
    'VINCEY',
  ],
  88490: [
    'LE BEULAY',
    'COMBRIMONT',
    'FRAPELLE',
    'LA GRANDE FOSSE',
    'LESSEUX',
    'LUBINE',
    'LUSSE',
    'LA PETITE FOSSE',
    'PROVENCHERES ET COLROY',
  ],
  88470: ['LA BOURGONCE', 'NOMPATELIZE', 'ST MICHEL SUR MEURTHE', 'LA SALLE', 'LA VOIVRE'],
  88350: [
    'BRECHAINVILLE',
    'FREVILLE',
    'GRAND',
    'LIFFOL LE GRAND',
    'PARGNY SOUS MUREAU',
    'TRAMPOT',
    'VILLOUXEL',
  ],
  88250: ['LA BRESSE'],
  88540: ['BUSSANG'],
  88000: [
    'CHANTRAINE',
    'DEYVILLERS',
    'DIGNONVILLE',
    'DINOZE',
    'DOGNEVILLE',
    'EPINAL',
    'JEUXEY',
    'LONGCHAMP',
    'VAUDEVILLE',
  ],
  88390: [
    'CHAUMOUSEY',
    'DARNIEULLES',
    'DOMEVRE SUR AVIERE',
    'DOMMARTIN AUX BOIS',
    'FOMEREY',
    'LES FORGES',
    'GIGNEY',
    'GIRANCOURT',
    'RENAUVOID',
    'SANCHEY',
    'UXEGNEY',
  ],
  88230: ['BAN SUR MEURTHE CLEFCY', 'FRAIZE', 'PLAINFAING', 'LE VALTIN'],
  88100: [
    'COINCHES',
    'NAYEMONT LES FOSSES',
    'NEUVILLERS SUR FAVE',
    'PAIR ET GRANDRUPT',
    'REMOMEIX',
    'ST DIE DES VOSGES',
    'STE MARGUERITE',
    'TAINTRUX',
  ],
  88310: ['CORNIMONT', 'VENTRON'],
  88200: [
    'DOMMARTIN LES REMIREMONT',
    'REMIREMONT',
    'ST ETIENNE LES REMIREMONT',
    'ST NABORD',
    'VECOUX',
  ],
  88220: ['DOUNOUX', 'HADOL', 'RAON AUX BOIS', 'URIMENIL', 'UZEMAIN', 'XERTIGNY'],
  88510: ['ELOYES'],
  88480: ['ETIVAL CLAIREFONTAINE', 'ST REMY'],
  88360: ['FERDRUPT', 'RUPT SUR MOSELLE'],
  88530: ['LA FORGE', 'LE THOLY'],
  88160: ['FRESSE SUR MOSELLE', 'LE MENIL', 'RAMONCHAMP', 'LE THILLOT'],
  88440: ['FRIZON', 'NOMEXY'],
  88400: ['GERARDMER', 'LIEZEY', 'XONRUPT LONGEMER'],
  88340: ['GIRMONT VAL D AJOL', 'LE VAL D AJOL'],
  88190: ['GOLBEY'],
  88550: ['JARMENIL', 'POUXEUX'],
  88420: ['MOYENMOUTIER'],
  88560: ['ST MAURICE SUR MOSELLE'],
  88580: ['SAULCY SUR MEURTHE'],
  88290: ['SAULXURES SUR MOSELOTTE', 'THIEFOSSE'],
  89800: [
    'AIGREMONT',
    'BEINE',
    'CHABLIS',
    'LA CHAPELLE VAUPELTEIGNE',
    'CHEMILLY SUR SEREIN',
    'CHICHEE',
    'COURGIS',
    'FLEYS',
    'FONTENAY PRES CHABLIS',
    'LICHERES PRES AIGREMONT',
    'LIGNORELLES',
    'MALIGNY',
    'PREHY',
    'ST CYR LES COLONS',
    'VILLY',
  ],
  89110: [
    'MONTHOLON',
    'CHASSY',
    'LA FERTE LOUPIERE',
    'VALRAVILLON',
    'MERRY LA VALLEE',
    'LES ORMES',
    'POILLY SUR THOLON',
    'LE VAL D OCRE',
    'ST MAURICE LE VIEIL',
    'ST MAURICE THIZOUAILLE',
    'SOMMECAISE',
  ],
  89710: ['MONTHOLON', 'SENAN'],
  89390: ['AISY SUR ARMANCON', 'CRY', 'NUITS', 'PERRIGNY SUR ARMANCON', 'RAVIERES'],
  89160: [
    'ANCY LE FRANC',
    'ANCY LE LIBRE',
    'ARGENTENAY',
    'ARGENTEUIL SUR ARMANCON',
    'CHASSIGNELLES',
    'FULVY',
    'GIGNY',
    'JULLY',
    'LEZINNES',
    'PACY SUR ARMANCON',
    'SAMBOURG',
    'SENNEVOY LE BAS',
    'SENNEVOY LE HAUT',
    'STIGNY',
    'VILLIERS LES HAUTS',
    'VIREAUX',
  ],
  89480: [
    'ANDRYES',
    'COULANGES SUR YONNE',
    'CRAIN',
    'ETAIS LA SAUVIN',
    'FESTIGNY',
    'LUCY SUR YONNE',
  ],
  89440: [
    'ANGELY',
    'ANNOUX',
    'ATHIE',
    'BLACY',
    'COUTARNOUX',
    'DISSANGIS',
    'L ISLE SUR SEREIN',
    'JOUX LA VILLE',
    'MASSANGIS',
    'PRECY LE SEC',
    'STE COLOMBE',
  ],
  89200: [
    'ANNAY LA COTE',
    'ANNEOT',
    'AVALLON',
    'BLANNAY',
    'DOMECY SUR LE VAULT',
    'ETAULE',
    'GIROLLES',
    'GIVRY',
    'ISLAND',
    'LUCY LE BOIS',
    'MAGNY',
    'PONTAUBERT',
    'PROVENCY',
    'SAUVIGNY LE BOIS',
    'SERMIZELLES',
    'THAROT',
    'THORY',
    'VAULT DE LUGNY',
  ],
  89310: [
    'ANNAY SUR SEREIN',
    'CENSY',
    'CHATEL GERARD',
    'ETIVEY',
    'FRESNES',
    'GRIMAULT',
    'JOUANCY',
    'MOLAY',
    'MOULINS EN TONNERROIS',
    'NITRY',
    'NOYERS',
    'PASILLY',
    'POILLY SUR SEREIN',
    'STE VERTU',
    'SARRY',
  ],
  89380: ['APPOIGNY'],
  89320: [
    'ARCES DILO',
    'CERILLY',
    'CERISIERS',
    'COULOURS',
    'FOURNAUDIN',
    'NOE',
    'LES VALLEES DE LA VANNE',
    'VAUDEURS',
    'VAUMORT',
    'VILLECHETIVE',
    'VILLIERS LOUIS',
  ],
  89270: [
    'ARCY SUR CURE',
    'BESSY SUR CURE',
    'LUCY SUR CURE',
    'MAILLY LA VILLE',
    'ST MORE',
    'SERY',
    'VERMENTON',
    'VOUTENAY SUR CURE',
  ],
  89500: [
    'ARMEAU',
    'LES BORDES',
    'BUSSY LE REPOS',
    'CHAUMOT',
    'CORNANT',
    'DIXMONT',
    'EGRISELLES LE BOCAGE',
    'MARSANGY',
    'ROUSSON',
    'VILLENEUVE SUR YONNE',
  ],
  89740: ['ARTHONNAY', 'CRUZY LE CHATEL', 'GLAND', 'PIMELLES', 'QUINCEROT', 'VILLON'],
  89660: [
    'ASNIERES SOUS BOIS',
    'BOIS D ARCY',
    'BROSSES',
    'CHAMOUX',
    'CHATEL CENSOIR',
    'FONTENAY SOUS FOURONNES',
    'LICHERES SUR YONNE',
    'MAILLY LE CHATEAU',
    'MERRY SUR YONNE',
    'MONTILLOT',
  ],
  89450: [
    'ASQUINS',
    'DOMECY SUR CURE',
    'FOISSY LES VEZELAY',
    'FONTENAY PRES VEZELAY',
    'MENADES',
    'PIERRE PERTHUIS',
    'ST PERE',
    'THAROISEAU',
    'VEZELAY',
  ],
  89290: [
    'AUGY',
    'AUXERRE',
    'CHAMPS SUR YONNE',
    'ESCOLIVES STE CAMILLE',
    'IRANCY',
    'JUSSY',
    'QUENNE',
    'VENOY',
    'VINCELLES',
    'VINCELOTTES',
  ],
  89000: ['AUXERRE', 'PERRIGNY', 'ST GEORGES SUR BAULCHE'],
  89190: [
    'BAGNEAUX',
    'LES CLERIMOIS',
    'COURGENAY',
    'FLACY',
    'FOISSY SUR VANNE',
    'LAILLY',
    'MOLINONS',
    'PONT SUR VANNE',
    'ST MAURICE AUX RICHES HOMMES',
    'LES SIEGES',
    'LES VALLEES DE LA VANNE',
    'VILLENEUVE L ARCHEVEQUE',
  ],
  89430: ['BAON', 'MELISEY', 'RUGNY', 'TANLAY', 'THOREY', 'TRICHEY'],
  89400: [
    'BASSOU',
    'BONNARD',
    'BRION',
    'BUSSY EN OTHE',
    'CHARMOY',
    'CHENY',
    'CHICHERY',
    'EPINEAU LES VOVES',
    'LAROCHE ST CYDROINE',
    'MIGENNES',
    'ORMOY',
  ],
  89460: ['BAZARNES', 'DEUX RIVIERES', 'PREGILBERT', 'STE PALLAYE', 'TRUCY SUR YONNE'],
  89250: ['BEAUMONT', 'CHEMILLY SUR YONNE', 'GURGY', 'HAUTERIVE', 'MONT ST SULPICE', 'SEIGNELAY'],
  89630: [
    'BEAUVILLIERS',
    'BUSSIERES',
    'CHASTELLUX SUR CURE',
    'QUARRE LES TOMBES',
    'ST BRANCHER',
    'ST GERMAIN DES CHAMPS',
    'ST LEGER VAUBAN',
  ],
  89240: [
    'BEAUVOIR',
    'CHEVANNES',
    'DIGES',
    'EGLENY',
    'ESCAMPS',
    'LINDRY',
    'PARLY',
    'POURRAIN',
    'VILLEFARGEAU',
  ],
  89210: [
    'BELLECHAUME',
    'BRIENON SUR ARMANCON',
    'CHAMPLOST',
    'ESNON',
    'MERCY',
    'PAROY EN OTHE',
    'VENIZY',
  ],
  89150: [
    'LA BELLIOLE',
    'BRANNAY',
    'COURTOIN',
    'DOLLOT',
    'DOMATS',
    'FOUCHERES',
    'JOUY',
    'MONTACHER VILLEGARDIN',
    'ST VALERIEN',
    'SAVIGNY SUR CLAIRIS',
    'VALLERY',
    'VERNOY',
    'VILLEBOUGIS',
    'VILLENEUVE LA DONDAGRE',
  ],
  89410: ['BEON', 'CEZY'],
  89360: [
    'BERNOUIL',
    'BUTTEAUX',
    'CARISEY',
    'DYE',
    'FLOGNY LA CHAPELLE',
    'JAULGES',
    'PERCEY',
    'VILLIERS VINEUX',
  ],
  89700: [
    'BERU',
    'CHENEY',
    'COLLAN',
    'DANNEMOINE',
    'EPINEUIL',
    'JUNAY',
    'MOLOSMES',
    'ROFFEY',
    'ST MARTIN SUR ARMANCON',
    'SERRIGNY',
    'TISSEY',
    'TONNERRE',
    'TRONCHOY',
    'VEZANNES',
    'VEZINNES',
    'VIVIERS',
    'YROUERRE',
  ],
  89570: ['BEUGNON', 'LASSON', 'NEUVY SAUTOUR', 'SORMERY', 'SOUMAINTRAIN', 'TURNY'],
  89420: [
    'BIERRY LES BELLES FONTAINES',
    'CUSSY LES FORGES',
    'GUILLON TERRE PLAINE',
    'MARMEAUX',
    'MONTREAL',
    'PISY',
    'ST ANDRE EN TERRE PLAINE',
    'STE MAGNANCE',
    'SANTIGNY',
    'SAUVIGNY LE BEUREAL',
    'SAVIGNY EN TERRE PLAINE',
    'TALCY',
    'THIZY',
    'VASSY SOUS PISY',
  ],
  89230: [
    'BLEIGNY LE CARREAU',
    'MONTIGNY LA RESLE',
    'PONTIGNY',
    'ROUVRAY',
    'VENOUSE',
    'VILLENEUVE ST SALVES',
  ],
  89220: ['BLENEAU', 'CHAMPCEVRAIS', 'ROGNY LES SEPT ECLUSES', 'ST PRIVE'],
  89770: ['BOEURS EN OTHE', 'CHAILLEY'],
  89113: ['BRANCHES', 'CHARBUY', 'FLEURY LA VALLEE', 'VALRAVILLON'],
  89116: ['LA CELLE ST CYR', 'CUDOT', 'PRECY SUR VRIN', 'SEPEAUX ST ROMAIN'],
  89350: ['CHAMPIGNELLES', 'TANNERRE EN PUISAYE', 'VILLENEUVE LES GENETS'],
  89340: ['CHAMPIGNY', 'CHAUMONT', 'ST AGNAN', 'VILLEBLEVIN', 'VILLENEUVE LA GUYARD'],
  89300: [
    'CHAMPLAY',
    'CHAMVRES',
    'JOIGNY',
    'LOOZE',
    'PAROY SUR THOLON',
    'ST AUBIN SUR YONNE',
    'VILLECIEN',
  ],
  89260: ['LA CHAPELLE SUR OREUSE', 'LA POSTOLLE', 'THORIGNY SUR OREUSE', 'PERCENEIGE', 'VOISINES'],
  89580: [
    'CHARENTENAY',
    'COULANGERON',
    'COULANGES LA VINEUSE',
    'GY L EVEQUE',
    'MIGE',
    'VAL DE MERCY',
    'VALLAN',
  ],
  89120: ['CHARNY OREE DE PUISAYE'],
  89690: ['CHEROY'],
  89600: ['CHEU', 'GERMIGNY', 'ST FLORENTIN', 'VERGIGNY'],
  89530: ['CHITRY', 'ST BRIS LE VINEUX'],
  89100: [
    'COLLEMIERS',
    'COURTOIS SUR YONNE',
    'FONTAINE LA GAILLARDE',
    'GRON',
    'MAILLOT',
    'MALAY LE GRAND',
    'MALAY LE PETIT',
    'NAILLY',
    'PARON',
    'ROSOY',
    'ST CLEMENT',
    'ST DENIS LES SENS',
    'ST MARTIN DU TERTRE',
    'SALIGNY',
    'SENS',
    'SOUCY',
    'SUBLIGNY',
    'VILLEROY',
  ],
  89140: [
    'COMPIGNY',
    'COURLON SUR YONNE',
    'CUY',
    'EVRY',
    'GISY LES NOBLES',
    'LIXY',
    'MICHERY',
    'PAILLY',
    'PLESSIS ST JEAN',
    'PONT SUR YONNE',
    'ST SEROTIN',
    'SERBONNES',
    'SERGINES',
    'VILLEMANOCHE',
    'VILLENAVOTTE',
    'VILLEPERROT',
    'VILLETHIERRY',
    'VINNEUF',
  ],
  89560: [
    'COURSON LES CARRIERES',
    'DRUYES LES BELLES FONTAINES',
    'FOURONNES',
    'LAIN',
    'MERRY SEC',
    'MOUFFY',
    'OUANNE',
    'SEMENTRON',
    'LES HAUTS DE FORTERRE',
  ],
  89130: [
    'DRACY',
    'FONTAINES',
    'LALANDE',
    'LEUGNY',
    'MEZILLES',
    'MOULINS SUR OUANNE',
    'TOUCY',
    'VILLIERS ST BENOIT',
  ],
  89510: ['ETIGNY', 'PASSY', 'VERON'],
  89520: [
    'FONTENOY',
    'LAINSECQ',
    'LEVIS',
    'MOUTIERS EN PUISAYE',
    'SAINPUITS',
    'SAINTS EN PUISAYE',
    'ST SAUVEUR EN PUISAYE',
    'SOUGERES EN PUISAYE',
    'THURY',
    'TREIGNY PERREUSE STE COLOMBE',
  ],
  89550: ['HERY'],
  89170: ['LAVAU', 'RONCHERES', 'ST FARGEAU', 'ST MARTIN DES CHAMPS'],
  89144: ['LIGNY LE CHATEL', 'MERE', 'VARENNES'],
  89470: ['MONETEAU'],
  89330: [
    'PIFFONDS',
    'ST JULIEN DU SAULT',
    'ST LOUP D ORDON',
    'ST MARTIN D ORDON',
    'VERLIN',
    'VILLEVALLIER',
  ],
  90400: [
    'ANDELNANS',
    'BERMONT',
    'BOTANS',
    'DANJOUTIN',
    'DORANS',
    'MEROUX MOVAL',
    'SEVENANS',
    'TREVENANS',
    'VEZELOIS',
  ],
  90150: [
    'ANGEOT',
    'BETHONVILLIERS',
    'CUNELIERES',
    'EGUENIGUE',
    'FONTAINE',
    'FOUSSEMAGNE',
    'FRAIS',
    'LACOLLONGE',
    'LAGRANGE',
    'LARIVIERE',
    'MENONCOURT',
    'PHAFFANS',
    'REPPE',
    'VAUTHIERMONT',
  ],
  90170: ['ANJOUTEY', 'ETUEFFONT', 'LAMADELEINE VAL DES ANGES', 'PETITMAGNY'],
  90800: ['ARGIESANS', 'BANVILLARS', 'BAVILLIERS', 'BUC', 'URCEREY'],
  90200: [
    'AUXELLES BAS',
    'AUXELLES HAUT',
    'GIROMAGNY',
    'GROSMAGNY',
    'LEPUIX',
    'RIERVESCEMONT',
    'ROUGEGOUTTE',
    'VESCEMONT',
  ],
  90500: ['BEAUCOURT', 'MONTBOUTON'],
  90000: ['BELFORT'],
  90160: ['BESSONCOURT', 'DENNEY', 'PEROUSE'],
  90100: [
    'BORON',
    'CHAVANATTE',
    'CHAVANNES LES GRANDS',
    'COURCELLES',
    'COURTELEVANT',
    'CROIX',
    'DELLE',
    'FAVEROIS',
    'FECHE L EGLISE',
    'FLORIMONT',
    'GROSNE',
    'JONCHEREY',
    'LEBETAIN',
    'LEPUIX NEUF',
    'ST DIZIER L EVEQUE',
    'SUARCE',
    'THIANCOURT',
    'VELLESCOT',
    'VILLARS LE SEC',
  ],
  90110: [
    'BOURG SOUS CHATELET',
    'FELON',
    'LEVAL',
    'ROMAGNY SOUS ROUGEMONT',
    'ROUGEMONT LE CHATEAU',
    'ST GERMAIN LE CHATELET',
  ],
  90140: ['BOUROGNE', 'BREBOTTE', 'CHARMOIS', 'FROIDEFONTAINE', 'AUTRECHENE', 'RECOUVRANCE'],
  90130: ['BRETAGNE', 'MONTREUX CHATEAU', 'PETIT CROIX'],
  90700: ['CHATENOIS LES FORGES'],
  90330: ['CHAUX'],
  90340: ['CHEVREMONT', 'FONTENELLE', 'NOVILLARD'],
  90300: [
    'CRAVANCHE',
    'ELOIE',
    'LACHAPELLE SOUS CHAUX',
    'OFFEMONT',
    'SERMAMAGNY',
    'VALDOIE',
    'VETRIGNE',
  ],
  90850: ['ESSERT'],
  90350: ['EVETTE SALBERT'],
  90600: ['GRANDVILLARS'],
  90360: ['LACHAPELLE SOUS ROUGEMONT', 'PETITEFONTAINE'],
  90120: ['MEZIRE', 'MORVILLARS'],
  90370: ['RECHESY'],
  90380: ['ROPPE'],
  91150: [
    'ABBEVILLE LA RIVIERE',
    'BLANDY',
    'BOIS HERPIN',
    'BOUTERVILLIERS',
    'BRIERES LES SCELLES',
    'BROUY',
    'CHAMPMOTTEUX',
    'ETAMPES',
    'LA FORET STE CROIX',
    'MAROLLES EN BEAUCE',
    'MESPUITS',
    'MORIGNY CHAMPIGNY',
    'ORMOY LA RIVIERE',
    'PUISELET LE MARAIS',
    'ROINVILLIERS',
  ],
  91670: ['ANGERVILLE'],
  91470: [
    'ANGERVILLIERS',
    'BOULLAY LES TROUX',
    'FORGES LES BAINS',
    'LIMOURS',
    'LES MOLIERES',
    'PECQUEUSE',
  ],
  91290: ['ARPAJON', 'LA NORVILLE'],
  91690: [
    'ARRANCOURT',
    'BOISSY LA RIVIERE',
    'FONTAINE LA RIVIERE',
    'GUILLERVAL',
    'SACLAS',
    'ST CYR LA RIVIERE',
  ],
  91200: ['ATHIS MONS'],
  91410: [
    'AUTHON LA PLAINE',
    'CHATIGNONVILLE',
    'CORBREUSE',
    'DOURDAN',
    'LA FORET LE ROI',
    'LES GRANGES LE ROI',
    'PLESSIS ST BENOIST',
    'RICHARVILLE',
    'ROINVILLE',
    'ST CYR SOUS DOURDAN',
    'ST ESCOBILLE',
  ],
  91830: ['AUVERNAUX', 'LE COUDRAY MONTCEAUX'],
  91580: [
    'AUVERS ST GEORGES',
    'CHAUFFOUR LES ETRECHY',
    'ETRECHY',
    'SOUZY LA BRICHE',
    'VILLECONIN',
    'VILLENEUVE SUR AUVERS',
  ],
  91630: ['AVRAINVILLE', 'CHEPTAINVILLE', 'GUIBEVILLE', 'LEUDEVILLE', 'MAROLLES EN HUREPOIX'],
  91160: ['BALLAINVILLIERS', 'CHAMPLAN', 'LONGJUMEAU', 'SAULX LES CHARTREUX'],
  91610: ['BALLANCOURT SUR ESSONNE'],
  91590: [
    'BAULNE',
    'BOISSY LE CUTTE',
    'CERNY',
    'D HUISON LONGUEVILLE',
    'LA FERTE ALAIS',
    'GUIGNEVILLE SUR ESSONNE',
    'MONDEVILLE',
    'ORVEAU',
  ],
  91570: ['BIEVRES'],
  91720: [
    'BOIGNEVILLE',
    'BUNO BONNEVAUX',
    'COURDIMANCHE SUR ESSONNE',
    'GIRONVILLE SUR ESSONNE',
    'MAISSE',
    'PRUNAY SUR ESSONNE',
    'VALPUISEAUX',
  ],
  91870: ['BOISSY LE SEC'],
  91790: ['BOISSY SOUS ST YON'],
  91070: ['BONDOUFLE'],
  91850: ['BOURAY SUR JUINE'],
  91800: ['BOUSSY ST ANTOINE', 'BRUNOY'],
  91820: ['BOUTIGNY SUR ESSONNE', 'VAYRES SUR ESSONNE'],
  91880: ['BOUVILLE'],
  91220: ['BRETIGNY SUR ORGE', 'LE PLESSIS PATE'],
  91650: ['BREUILLET', 'BREUX JOUY', 'ST YON'],
  91640: ['BRIIS SOUS FORGES', 'FONTENAY LES BRIIS', 'JANVRY', 'VAUGRIGNEUSE'],
  91680: ['BRUYERES LE CHATEL', 'COURSON MONTELOUP'],
  91440: ['BURES SUR YVETTE'],
  91780: ['CHALO ST MARS', 'MEROBERT', 'ST HILAIRE'],
  91740: ['CHALOU MOULINEUX', 'PUSSAY', 'CONGERVILLE THIONVILLE'],
  91730: ['CHAMARANDE', 'MAUCHAMPS', 'TORFOU'],
  91750: ['CHAMPCUEIL', 'CHEVANNES', 'NAINVILLE LES ROCHES'],
  91380: ['CHILLY MAZARIN'],
  91100: ['CORBEIL ESSONNES', 'VILLABE'],
  91490: ['COURANCES', 'DANNEMOIS', 'MILLY LA FORET', 'MOIGNY SUR ECOLE', 'ONCY SUR ECOLE'],
  91560: ['CROSNE'],
  91210: ['DRAVEIL'],
  91540: ['ECHARCON', 'FONTENAY LE VICOMTE', 'MENNECY', 'ORMOY'],
  91520: ['EGLY'],
  91860: ['EPINAY SOUS SENART'],
  91360: ['EPINAY SUR ORGE', 'VILLEMOISSON SUR ORGE'],
  91450: ['ETIOLLES', 'SOISY SUR SEINE'],
  91000: ['EVRY COURCOURONNES'],
  91080: ['EVRY COURCOURONNES'],
  91700: ['FLEURY MEROGIS', 'STE GENEVIEVE DES BOIS', 'VILLIERS SUR ORGE'],
  91190: ['GIF SUR YVETTE', 'ST AUBIN', 'VILLIERS LE BACLE'],
  91400: ['GOMETZ LA VILLE', 'ORSAY', 'SACLAY'],
  91940: ['GOMETZ LE CHATEL', 'ST JEAN DE BEAUREGARD', 'LES ULIS'],
  91350: ['GRIGNY'],
  91430: ['IGNY', 'VAUHALLAN'],
  91760: ['ITTEVILLE'],
  91510: ['JANVILLE SUR JUINE', 'LARDY'],
  91260: ['JUVISY SUR ORGE'],
  91310: ['LEUVILLE SUR ORGE', 'LINAS', 'LONGPONT SUR ORGE', 'MONTLHERY'],
  91090: ['LISSES'],
  91460: ['MARCOUSSIS'],
  91300: ['MASSY'],
  91660: ['LE MEREVILLOIS'],
  91930: ['MONNERVILLE'],
  91230: ['MONTGERON'],
  91420: ['MORANGIS'],
  91390: ['MORSANG SUR ORGE'],
  91250: ['MORSANG SUR SEINE', 'ST GERMAIN LES CORBEIL', 'SAINTRY SUR SEINE', 'TIGERY'],
  91620: ['NOZAY', 'LA VILLE DU BOIS'],
  91340: ['OLLAINVILLE'],
  91120: ['PALAISEAU'],
  91550: ['PARAY VIEILLE POSTE'],
  94390: ['PARAY VIEILLE POSTE'],
  91480: ['QUINCY SOUS SENART', 'VARENNES JARCY'],
  91130: ['RIS ORANGIS'],
  91530: ['ST CHERON', 'ST MAURICE MONTCOURONNE', 'SERMAISE', 'LE VAL ST GERMAIN'],
  91180: ['ST GERMAIN LES ARPAJON'],
  91240: ['ST MICHEL SUR ORGE'],
  91280: ['ST PIERRE DU PERRAY'],
  91910: ['ST SULPICE DE FAVIERES'],
  91770: ['ST VRAIN'],
  91600: ['SAVIGNY SUR ORGE'],
  91840: ['SOISY SUR ECOLE'],
  91370: ['VERRIERES LE BUISSON'],
  91810: ['VERT LE GRAND'],
  91710: ['VERT LE PETIT'],
  91890: ['VIDELLES'],
  91270: ['VIGNEUX SUR SEINE'],
  91140: ['VILLEBON SUR YVETTE', 'VILLEJUST'],
  91170: ['VIRY CHATILLON'],
  91320: ['WISSOUS'],
  91330: ['YERRES'],
  92160: ['ANTONY'],
  92600: ['ASNIERES SUR SEINE'],
  92220: ['BAGNEUX'],
  92270: ['BOIS COLOMBES'],
  92100: ['BOULOGNE BILLANCOURT'],
  92340: ['BOURG LA REINE'],
  92290: ['CHATENAY MALABRY'],
  92320: ['CHATILLON'],
  92370: ['CHAVILLE'],
  92140: ['CLAMART'],
  92110: ['CLICHY'],
  92700: ['COLOMBES'],
  92400: ['COURBEVOIE'],
  92260: ['FONTENAY AUX ROSES'],
  92380: ['GARCHES'],
  92250: ['LA GARENNE COLOMBES'],
  92230: ['GENNEVILLIERS'],
  92130: ['ISSY LES MOULINEAUX'],
  92300: ['LEVALLOIS PERRET'],
  92240: ['MALAKOFF'],
  92430: ['MARNES LA COQUETTE'],
  92190: ['MEUDON'],
  92360: ['MEUDON'],
  92120: ['MONTROUGE'],
  92000: ['NANTERRE'],
  92200: ['NEUILLY SUR SEINE'],
  92350: ['LE PLESSIS ROBINSON'],
  92800: ['PUTEAUX'],
  92500: ['RUEIL MALMAISON'],
  92210: ['ST CLOUD'],
  92330: ['SCEAUX'],
  92310: ['SEVRES'],
  92150: ['SURESNES'],
  92170: ['VANVES'],
  92420: ['VAUCRESSON'],
  92410: ['VILLE D AVRAY'],
  92390: ['VILLENEUVE LA GARENNE'],
  93300: ['AUBERVILLIERS'],
  93600: ['AULNAY SOUS BOIS'],
  93170: ['BAGNOLET'],
  93150: ['LE BLANC MESNIL'],
  93000: ['BOBIGNY'],
  93140: ['BONDY'],
  93350: ['LE BOURGET'],
  93390: ['CLICHY SOUS BOIS'],
  93470: ['COUBRON'],
  93120: ['LA COURNEUVE'],
  93700: ['DRANCY'],
  93440: ['DUGNY'],
  93800: ['EPINAY SUR SEINE'],
  93220: ['GAGNY'],
  93460: ['GOURNAY SUR MARNE'],
  93450: ['L ILE ST DENIS'],
  93260: ['LES LILAS'],
  93190: ['LIVRY GARGAN'],
  93370: ['MONTFERMEIL'],
  93100: ['MONTREUIL'],
  93360: ['NEUILLY PLAISANCE'],
  93330: ['NEUILLY SUR MARNE'],
  93160: ['NOISY LE GRAND'],
  93130: ['NOISY LE SEC'],
  93500: ['PANTIN'],
  93320: ['LES PAVILLONS SOUS BOIS'],
  93380: ['PIERREFITTE SUR SEINE'],
  93310: ['LE PRE ST GERVAIS'],
  93340: ['LE RAINCY'],
  93230: ['ROMAINVILLE'],
  93110: ['ROSNY SOUS BOIS'],
  93200: ['ST DENIS'],
  93210: ['ST DENIS'],
  93400: ['ST OUEN SUR SEINE'],
  93270: ['SEVRAN'],
  93240: ['STAINS'],
  93290: ['TREMBLAY EN FRANCE'],
  93410: ['VAUJOURS'],
  93250: ['VILLEMOMBLE'],
  93420: ['VILLEPINTE'],
  93430: ['VILLETANEUSE'],
  94480: ['ABLON SUR SEINE'],
  94140: ['ALFORTVILLE'],
  94110: ['ARCUEIL'],
  94470: ['BOISSY ST LEGER'],
  94380: ['BONNEUIL SUR MARNE'],
  94360: ['BRY SUR MARNE'],
  94230: ['CACHAN'],
  94500: ['CHAMPIGNY SUR MARNE'],
  94220: ['CHARENTON LE PONT'],
  94430: ['CHENNEVIERES SUR MARNE'],
  94550: ['CHEVILLY LARUE'],
  94600: ['CHOISY LE ROI'],
  94000: ['CRETEIL'],
  94120: ['FONTENAY SOUS BOIS'],
  94260: ['FRESNES'],
  94250: ['GENTILLY'],
  94240: ['L HAY LES ROSES'],
  94200: ['IVRY SUR SEINE'],
  94340: ['JOINVILLE LE PONT'],
  94270: ['LE KREMLIN BICETRE'],
  94450: ['LIMEIL BREVANNES'],
  94700: ['MAISONS ALFORT'],
  94520: ['MANDRES LES ROSES', 'PERIGNY'],
  94440: ['MAROLLES EN BRIE', 'SANTENY', 'VILLECRESNES'],
  94130: ['NOGENT SUR MARNE'],
  94880: ['NOISEAU'],
  94310: ['ORLY'],
  94490: ['ORMESSON SUR MARNE'],
  94170: ['LE PERREUX SUR MARNE'],
  94420: ['LE PLESSIS TREVISE'],
  94510: ['LA QUEUE EN BRIE'],
  94150: ['RUNGIS'],
  94160: ['ST MANDE'],
  94100: ['ST MAUR DES FOSSES'],
  94210: ['ST MAUR DES FOSSES'],
  94410: ['ST MAURICE'],
  94370: ['SUCY EN BRIE'],
  94320: ['THIAIS'],
  94460: ['VALENTON'],
  94800: ['VILLEJUIF'],
  94290: ['VILLENEUVE LE ROI'],
  94190: ['VILLENEUVE ST GEORGES'],
  94350: ['VILLIERS SUR MARNE'],
  94300: ['VINCENNES'],
  94400: ['VITRY SUR SEINE'],
  95450: [
    'ABLEIGES',
    'AVERNES',
    'COMMENY',
    'CONDECOURT',
    'FREMAINVILLE',
    'GUIRY EN VEXIN',
    'LONGUESSE',
    'LE PERCHAY',
    'SAGY',
    'SERAINCOURT',
    'THEMERICOURT',
    'US',
    'VIGNY',
  ],
  95510: [
    'AINCOURT',
    'AMENUCOURT',
    'CHERENCE',
    'ST CYR EN ARTHIES',
    'VETHEUIL',
    'VIENNE EN ARTHIES',
    'VILLERS EN ARTHIES',
  ],
  95420: [
    'AMBLEVILLE',
    'ARTHIES',
    'BANTHELU',
    'LA CHAPELLE EN VEXIN',
    'CHARMONT',
    'CLERY EN VEXIN',
    'GENAINVILLE',
    'HODENT',
    'MAGNY EN VEXIN',
    'MAUDETOUR EN VEXIN',
    'NUCOURT',
    'OMERVILLE',
    'ST GERVAIS',
    'WY DIT JOLI VILLAGE',
  ],
  95710: ['AMBLEVILLE', 'BRAY ET LU', 'CHAUSSY'],
  95580: ['ANDILLY', 'MARGENCY'],
  95100: ['ARGENTEUIL'],
  95400: ['ARNOUVILLE', 'VILLIERS LE BEL'],
  95810: [
    'ARRONVILLE',
    'BERVILLE',
    'EPIAIS RHUS',
    'GRISY LES PLATRES',
    'MENOUVILLE',
    'THEUVILLE',
    'VALLANGOUJARD',
  ],
  95270: [
    'ASNIERES SUR OISE',
    'BELLEFONTAINE',
    'BELLOY EN FRANCE',
    'CHAUMONTEL',
    'EPINAY CHAMPLATREUX',
    'LASSY',
    'LUZARCHES',
    'NOISY SUR OISE',
    'LE PLESSIS LUZARCHES',
    'ST MARTIN DU TERTRE',
    'SEUGY',
    'VIARMES',
  ],
  95570: ['ATTAINVILLE', 'BOUFFEMONT', 'MOISSELLES', 'VILLAINES SOUS BOIS'],
  95430: ['AUVERS SUR OISE', 'BUTRY SUR OISE'],
  95560: ['BAILLET EN FRANCE', 'CHAUVRY', 'MAFFLIERS', 'MONTSOULT'],
  95250: ['BEAUCHAMP'],
  95260: ['BEAUMONT SUR OISE', 'MOURS'],
  95750: ['LE BELLAY EN VEXIN', 'CHARS'],
  95340: ['BERNES SUR OISE', 'PERSAN', 'RONQUEROLLES'],
  95550: ['BESSANCOURT'],
  95840: ['BETHEMONT LA FORET', 'VILLIERS ADAM'],
  95870: ['BEZONS'],
  95000: ['BOISEMONT', 'CERGY', 'NEUVILLE SUR OISE', 'PONTOISE'],
  95650: [
    'BOISSY L AILLERIE',
    'COURCELLES SUR VIOSNE',
    'GENICOURT',
    'MONTGEROULT',
    'PUISEUX PONTOISE',
  ],
  95500: ['BONNEUIL EN FRANCE', 'GONESSE', 'LE THILLAY', 'VAUDHERLAND'],
  95720: ['BOUQUEVAL', 'LE MESNIL AUBRY', 'LE PLESSIS GASSOT', 'VILLIERS LE SEC'],
  95640: [
    'BREANCON',
    'BRIGNANCOURT',
    'HARAVILLIERS',
    'LE HEAULME',
    'MARINES',
    'MOUSSY',
    'NEUILLY EN VEXIN',
    'SANTEUIL',
  ],
  95820: ['BRUYERES SUR OISE'],
  95770: ['BUHY', 'MONTREUIL SUR EPTE', 'ST CLAIR SUR EPTE'],
  95800: ['CERGY', 'COURDIMANCHE'],
  95660: ['CHAMPAGNE SUR OISE'],
  95190: ['CHATENAY EN FRANCE', 'FONTENAY EN PARISIS', 'GOUSSAINVILLE'],
  95380: [
    'CHENNEVIERES LES LOUVRES',
    'EPIAIS LES LOUVRES',
    'LOUVRES',
    'PUISEUX EN FRANCE',
    'VILLERON',
  ],
  95240: ['CORMEILLES EN PARISIS'],
  95830: ['CORMEILLES EN VEXIN', 'FREMECOURT'],
  95170: ['DEUIL LA BARRE'],
  95330: ['DOMONT'],
  95600: ['EAUBONNE'],
  95440: ['ECOUEN'],
  95880: ['ENGHIEN LES BAINS'],
  95300: ['ENNERY', 'HEROUVILLE EN VEXIN', 'LIVILLIERS', 'PONTOISE'],
  95610: ['ERAGNY'],
  95120: ['ERMONT'],
  95460: ['EZANVILLE'],
  95470: ['FOSSES', 'ST WITZ', 'SURVILLIERS', 'VEMARS'],
  95130: ['FRANCONVILLE', 'LE PLESSIS BOUCHARD'],
  95740: ['FREPILLON'],
  95530: ['LA FRETTE SUR SEINE'],
  95690: ['FROUVILLE', 'HEDOUVILLE', 'LABBEVILLE', 'NESLES LA VALLEE'],
  95140: ['GARGES LES GONESSE'],
  95410: ['GROSLAY'],
  95780: ['HAUTE ISLE', 'LA ROCHE GUYON'],
  95220: ['HERBLAY SUR SEINE', 'PIERRELAYE'],
  95290: ['L ISLE ADAM'],
  95850: ['JAGNY SOUS BOIS', 'MAREIL EN FRANCE'],
  95280: ['JOUY LE MOUTIER'],
  95670: ['MARLY LA VILLE'],
  95180: ['MENUCOURT'],
  95630: ['MERIEL'],
  95540: ['MERY SUR OISE'],
  95370: ['MONTIGNY LES CORMEILLES'],
  95680: ['MONTLIGNON'],
  95360: ['MONTMAGNY'],
  95160: ['MONTMORENCY'],
  95590: ['NERVILLE LA FORET', 'NOINTEL', 'PRESLES'],
  95520: ['OSNY'],
  95620: ['PARMAIN'],
  95480: ['PIERRELAYE'],
  95350: ['PISCOP', 'ST BRICE SOUS FORET'],
  95700: ['ROISSY EN FRANCE'],
  95210: ['ST GRATIEN'],
  95320: ['ST LEU LA FORET'],
  95310: ['ST OUEN L AUMONE'],
  95390: ['ST PRIX'],
  95110: ['SANNOIS'],
  95200: ['SARCELLES'],
  95230: ['SOISY SOUS MONTMORENCY'],
  95150: ['TAVERNY'],
  95760: ['VALMONDOIS'],
  95490: ['VAUREAL'],
  97139: ['LES ABYMES'],
  97142: ['LES ABYMES'],
  97121: ['ANSE BERTRAND'],
  97122: ['BAIE MAHAULT'],
  97123: ['BAILLIF'],
  97100: ['BASSE TERRE'],
  97125: ['BOUILLANTE'],
  97130: ['CAPESTERRE BELLE EAU'],
  97140: ['CAPESTERRE DE MARIE GALANTE'],
  97113: ['GOURBEYRE'],
  97127: ['LA DESIRADE'],
  97126: ['DESHAIES'],
  97112: ['GRAND BOURG'],
  97190: ['LE GOSIER'],
  97128: ['GOYAVE'],
  97129: ['LAMENTIN'],
  97111: ['MORNE A L EAU'],
  97160: ['LE MOULE'],
  97170: ['PETIT BOURG'],
  97131: ['PETIT CANAL'],
  97110: ['POINTE A PITRE'],
  97116: ['POINTE NOIRE'],
  97117: ['PORT LOUIS'],
  97120: ['ST CLAUDE'],
  97118: ['ST FRANCOIS'],
  97134: ['ST LOUIS'],
  97180: ['STE ANNE'],
  97115: ['STE ROSE'],
  97136: ['TERRE DE BAS'],
  97137: ['TERRE DE HAUT'],
  97114: ['TROIS RIVIERES'],
  97141: ['VIEUX FORT'],
  97119: ['VIEUX HABITANTS'],
  97216: ['L AJOUPA BOUILLON'],
  97217: ['LES ANSES D ARLET'],
  97218: ['BASSE POINTE', 'GRAND RIVIERE', 'MACOUBA'],
  97221: ['LE CARBET'],
  97222: ['CASE PILOTE', 'BELLEFONTAINE'],
  97223: ['LE DIAMANT'],
  97224: ['DUCOS'],
  97250: ['FONDS ST DENIS', 'LE PRECHEUR', 'ST PIERRE'],
  97200: ['FORT DE FRANCE'],
  97234: ['FORT DE FRANCE'],
  97240: ['LE FRANCOIS'],
  97213: ['GROS MORNE'],
  97232: ['LE LAMENTIN'],
  97214: ['LE LORRAIN'],
  97225: ['LE MARIGOT'],
  97290: ['LE MARIN'],
  97260: ['LE MORNE ROUGE'],
  97211: ['RIVIERE PILOTE'],
  97215: ['RIVIERE SALEE'],
  97231: ['LE ROBERT'],
  97270: ['ST ESPRIT'],
  97212: ['ST JOSEPH'],
  97227: ['STE ANNE'],
  97228: ['STE LUCE'],
  97230: ['STE MARIE'],
  97233: ['SCHOELCHER'],
  97220: ['LA TRINITE'],
  97229: ['LES TROIS ILETS'],
  97280: ['LE VAUCLIN'],
  97226: ['LE MORNE VERT'],
  97353: ['REGINA'],
  97390: ['REGINA'],
  97300: ['CAYENNE'],
  97350: ['IRACOUBO'],
  97310: ['KOUROU'],
  97355: ['MACOURIA'],
  97318: ['MANA'],
  97360: ['MANA'],
  97351: ['MATOURY'],
  97313: ['ST GEORGES'],
  97354: ['REMIRE MONTJOLY'],
  97311: ['ROURA'],
  97352: ['ROURA'],
  97320: ['ST LAURENT DU MARONI'],
  97315: ['SINNAMARY'],
  97356: ['MONTSINERY TONNEGRANDE'],
  97380: ['OUANARY'],
  97314: ['SAUL'],
  97370: ['MARIPASOULA'],
  97330: ['CAMOPI'],
  97340: ['GRAND SANTI'],
  97312: ['ST ELIE'],
  97317: ['APATOU'],
  97319: ['AWALA YALIMAPO'],
  97316: ['PAPAICHTON'],
  97425: ['LES AVIRONS'],
  97412: ['BRAS PANON'],
  97414: ['ENTRE DEUX'],
  97427: ['L ETANG SALE'],
  97429: ['PETITE ILE'],
  97431: ['LA PLAINE DES PALMISTES'],
  97420: ['LE PORT'],
  97419: ['LA POSSESSION'],
  97440: ['ST ANDRE'],
  97437: ['ST BENOIT'],
  97470: ['ST BENOIT'],
  97400: ['ST DENIS'],
  97417: ['ST DENIS'],
  97490: ['ST DENIS'],
  97480: ['ST JOSEPH'],
  97416: ['ST LEU'],
  97424: ['ST LEU'],
  97436: ['ST LEU'],
  97421: ['ST LOUIS'],
  97450: ['ST LOUIS'],
  97411: ['ST PAUL'],
  97422: ['ST PAUL'],
  97423: ['ST PAUL'],
  97434: ['ST PAUL'],
  97435: ['ST PAUL'],
  97460: ['ST PAUL'],
  97410: ['ST PIERRE'],
  97432: ['ST PIERRE'],
  97442: ['ST PHILIPPE'],
  97438: ['STE MARIE'],
  97439: ['STE ROSE'],
  97441: ['STE SUZANNE'],
  97433: ['SALAZIE'],
  97418: ['LE TAMPON'],
  97430: ['LE TAMPON'],
  97426: ['LES TROIS BASSINS'],
  97413: ['CILAOS'],
  97500: ['MIQUELON LANGLADE', 'ST PIERRE'],
  97630: ['ACOUA', 'MTSAMBORO'],
  97650: ['BANDRABOUA', 'M TSANGAMOUJI'],
  97660: ['BANDRELE', 'DEMBENI'],
  97620: ['BOUENI', 'CHIRONGUI'],
  97670: ['CHICONI', 'OUANGANI'],
  97615: ['DZAOUDZI', 'PAMANDZI'],
  97625: ['KANI KELI'],
  97600: ['KOUNGOU', 'MAMOUDZOU'],
  97605: ['MAMOUDZOU'],
  97640: ['SADA'],
  97680: ['TSINGONI'],
  97133: ['ST BARTHELEMY'],
  97150: ['ST MARTIN'],
  98610: ['ALO'],
  98620: ['SIGAVE'],
  98600: ['UVEA'],
  98760: ['ANAA'],
  98786: ['ANAA'],
  98790: ['ANAA', 'FAKARAVA', 'HAO', 'HIKUERU', 'MAKEMO', 'RANGIROA', 'TAKAROA'],
  98701: ['ARUE'],
  98761: ['ARUTUA'],
  98762: ['ARUTUA'],
  98785: ['ARUTUA'],
  98730: ['BORA BORA'],
  98704: ['FAAA'],
  98763: ['FAKARAVA'],
  98764: ['FAKARAVA'],
  98787: ['FAKARAVA'],
  98765: ['FANGATAU'],
  98766: ['FANGATAU'],
  98740: ['FATU HIVA'],
  98755: ['GAMBIER'],
  98792: ['GAMBIER'],
  98793: ['GAMBIER'],
  98767: ['HAO'],
  98768: ['HIKUERU'],
  98705: ['HITIAA O TE RA'],
  98706: ['HITIAA O TE RA'],
  98707: ['HITIAA O TE RA'],
  98708: ['HITIAA O TE RA'],
  98741: ['HIVA OA'],
  98749: ['HIVA OA'],
  98796: ['HIVA OA', 'NUKU HIVA'],
  98731: ['HUAHINE'],
  98732: ['HUAHINE', 'MAUPITI'],
  98709: ['MAHINA'],
  98710: ['MAHINA'],
  98769: ['MAKEMO'],
  98789: ['MAKEMO'],
  98770: ['MANIHI'],
  98771: ['MANIHI'],
  98728: ['MOOREA MAIAO'],
  98729: ['MOOREA MAIAO'],
  98772: ['NAPUKA'],
  98742: ['NUKU HIVA'],
  98748: ['NUKU HIVA'],
  98773: ['NUKUTAVAKE'],
  98788: ['NUKUTAVAKE'],
  98711: ['PAEA'],
  98712: ['PAPARA'],
  98714: ['PAPEETE'],
  98716: ['PIRAE'],
  98774: ['PUKAPUKA'],
  98703: ['PUNAAUIA'],
  98718: ['PUNAAUIA'],
  98750: ['RAIVAVAE'],
  98775: ['RANGIROA'],
  98776: ['RANGIROA'],
  98777: ['RANGIROA'],
  98778: ['RANGIROA'],
  98751: ['RAPA'],
  98794: ['RAPA'],
  98779: ['REAO'],
  98780: ['REAO'],
  98752: ['RIMATARA'],
  98795: ['RIMATARA'],
  98753: ['RURUTU'],
  98733: ['TAHAA'],
  98734: ['TAHAA'],
  98743: ['TAHUATA'],
  98719: ['TAIARAPU EST'],
  98720: ['TAIARAPU EST'],
  98721: ['TAIARAPU EST'],
  98722: ['TAIARAPU EST'],
  98723: ['TAIARAPU OUEST'],
  98724: ['TAIARAPU OUEST'],
  98725: ['TAIARAPU OUEST'],
  98781: ['TAKAROA'],
  98782: ['TAKAROA'],
  98735: ['TAPUTAPUATEA', 'TUMARAA', 'UTUROA'],
  98783: ['TATAKOTO'],
  98726: ['TEVA I UTA'],
  98727: ['TEVA I UTA'],
  98754: ['TUBUAI'],
  98784: ['TUREIA'],
  98744: ['UA HUKA'],
  98747: ['UA HUKA'],
  98745: ['UA POU'],
  98746: ['UA POU'],
  98811: ['BELEP'],
  98812: ['BOULOUPARI'],
  98870: ['BOURAIL'],
  98813: ['CANALA'],
  98830: ['DUMBEA'],
  98835: ['DUMBEA'],
  98836: ['DUMBEA'],
  98837: ['DUMBEA'],
  98839: ['DUMBEA'],
  98881: ['FARINO'],
  98815: ['HIENGHENE'],
  98816: ['HOUAILOU'],
  98838: ['HOUAILOU'],
  98832: ['L ILE DES PINS'],
  98817: ['KAALA GOMEN'],
  98859: ['KONE'],
  98860: ['KONE'],
  98850: ['KOUMAC'],
  98880: ['LA FOA'],
  98820: ['LIFOU'],
  98884: ['LIFOU'],
  98885: ['LIFOU'],
  98828: ['MARE'],
  98878: ['MARE'],
  98819: ['MOINDOU'],
  98809: ['LE MONT DORE'],
  98810: ['LE MONT DORE'],
  98874: ['LE MONT DORE'],
  98875: ['LE MONT DORE'],
  98876: ['LE MONT DORE'],
  98800: ['NOUMEA'],
  98821: ['OUEGOA'],
  98814: ['OUVEA'],
  98840: ['PAITA'],
  98889: ['PAITA'],
  98890: ['PAITA'],
  98822: ['POINDIMIE'],
  98823: ['PONERIHOUEN'],
  98824: ['POUEBO'],
  98825: ['POUEMBOUT'],
  98826: ['POUM'],
  98827: ['POYA'],
  98877: ['POYA'],
  98882: ['SARRAMEA'],
  98829: ['THIO'],
  98831: ['TOUHO'],
  98833: ['VOH'],
  98883: ['VOH'],
  98834: ['YATE'],
  98818: ['KOUAOUA'],
  98799: ['ILE DE CLIPPERTON'],
  98000: ['MONACO'],
};

export default postcodes;
